// PresupuestoDetalle Page - Redesigned layout
import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { personalPorRatio } from '../utils/personalRatio';
import { numeroEs } from '../utils/logistica2';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { presupuestosAPI, clientesAPI, menusAPI, platosAPI, alergenosAPI, personasContactoAPI, materialesAPI, plantillasMenajeAPI, ingredientesAPI, api, emailsAPI, placesAPI, vinculoIaAPI, ordenCocinaV2API, getAuthToken } from '../api/api';
import { getCached } from '../api/catalogCache';
import { 
  Save, FileText, Receipt, Package, Menu as MenuIcon, 
  Plus, Trash2, ChevronDown, ChevronRight, ChevronUp, X, MapPin, 
  Calendar, Clock, Users, Mail, Phone, Building2, DollarSign, TrendingUp, AlertCircle, Send, ChefHat, CheckCircle, ArrowUp, ArrowDown, Search,
  Layers, ExternalLink, RefreshCw, Truck, Sparkles, Pencil, ArrowLeft, MoreHorizontal, Undo2, Check, Info, Copy, GripVertical,
  FolderOpen
} from 'lucide-react';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator
} from '../components/ui/dropdown-menu';
import JornadasManager from '../components/JornadasManager';
import PersonalAsignado from '../components/PersonalAsignado';
import OrdenPersonalExtra, { calcularCosteOrdenPersonal, ordenDeJornada } from '../components/OrdenPersonalExtra';
import VehiculosAsignados from '../components/VehiculosAsignados';
import BebidasAsignadas from '../components/BebidasAsignadas';
import AlergenoIcon from '../components/AlergenoIcon';

// Función para normalizar texto (quitar acentos) para búsquedas
const normalizeText = (text) => {
  if (!text) return '';
  return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
import LoadingOverlay from '../components/LoadingOverlay';
import DireccionAutocomplete from '../components/DireccionAutocomplete';
import useFormatoNuevo from '../hooks/useFormatoNuevo';
import useAutoguardado from '../hooks/useAutoguardado';
import usePuedeEditarHorarios from '../hooks/usePuedeEditarHorarios';
import useAvisoHorarios from '../components/presupuesto/AvisoHorarios';
import { toast } from '../hooks/use-toast';
import { registrarAccion } from '../utils/usoErp';
import { Toaster } from '../components/ui/toaster';
import PestanaAlergenos from '../components/presupuesto/PestanaAlergenos';
import PestanaMaterial from '../components/presupuesto/PestanaMaterial';
import PestanaListaCompra from '../components/presupuesto/PestanaListaCompra';
import AlquilerEvento from '../components/presupuesto/AlquilerEvento';
import SelectorJornadas from '../components/presupuesto/SelectorJornadas';
import ResumenAlquiler from '../components/presupuesto/ResumenAlquiler';
import BebidasModo from '../components/presupuesto/BebidasModo';
import SugerenciasCorreosIA from '../components/presupuesto/SugerenciasCorreosIA';
import VerEnCalendario from '../components/presupuesto/VerEnCalendario';
import SelectorBuzones, { EtiquetaBuzones } from '../components/emails/SelectorBuzones';
import ResumenCostes from '../components/presupuesto/ResumenCostes';
import Logistica2 from '../components/presupuesto/logistica2/Logistica2';
import DetalleCombustible from '../components/presupuesto/DetalleCombustible';
import LineasPorJornada from '../components/presupuesto/LineasPorJornada';
import HorarioServicioMultievento, { guardarHorarioServicio } from '../components/presupuesto/HorarioServicioMultievento';
import { HorarioServicioUnDia, textoAcompana } from '../components/presupuesto/HorasServicios';
import useEsMovil from '../hooks/useEsMovil';
import HojaMovil from '../components/movil/HojaMovil';
import FilaHojaMovil, { SeparadorHojaMovil } from '../components/movil/FilaHojaMovil';
import BarraInferiorMovil from '../components/movil/BarraInferiorMovil';
import HojaEditarLineaMovil from '../components/movil/HojaEditarLineaMovil';
import EnviarFacturaCliente from '../components/presupuesto/EnviarFacturaCliente';
import DuplicarPresupuesto from '../components/presupuesto/DuplicarPresupuesto';
import SuplementoMinimoAviso from '../components/presupuesto/SuplementoMinimoAviso';
import HoraExtraLunchAviso from '../components/presupuesto/HoraExtraLunchAviso';
import OrdenCocinaDescargaModal from '../components/OrdenCocinaDescargaModal';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../components/ui/dialog';
import { personasFila, sugerenciaOrdenExtra, tarifaTransportePersonal } from '../utils/quienVaEvento';
import { ALERGENOS_OFICIALES, DIETAS, TEXTO_ESTADO_LISTA } from '../utils/alergenosPresupuesto';
import { hoyMadrid, textoConfirmacionAvisos, textoDetalleApi } from '../utils/fechas';
import { textoHorasServicio } from '../utils/horasServicio';
import FacturaRepartida from '../components/FacturaRepartida';
import AvisoAdministracionFactura from '../components/presupuesto/AvisoAdministracionFactura';
import { revisarNovedades } from '../components/guia/novedades';
import {
  TEXTO_FECHA_EN_JORNADAS, esLineaBebida, esMultievento, eventoPasado,
  lineasJornadaConPlatos, opcionesAlquilerJornadas, personasPorDefectoLinea,
  primeraJornada, rangoFechasMultievento, resumenAlquilerJornadas, textoFechasEvento, textoUnidadesJornadas,
  unidadesMultievento,
  lineaCabecera,
} from '../utils/multieventoCabecera';
import {
  lineasCostesMultievento, lineasJornadaDeCabecera, lineasSoloJornadas, numAdaptacionesLinea,
  personasLineaCabecera, resumenAdaptaciones, sumarDesglosesCoste,
} from '../utils/multieventoPantallas';
import {
  calcularTareasPorHacer, obtenerFechasEvento, calcularFechaLimiteCambios, formatoDiaMes, formatoDiaMesCorto,
  diasEntre, inicioDelDia, sumarDias, DIAS_LIMITE_CAMBIOS, formatoEur, parsearFechaDia,
  textoDetalleImporteCobroPrevio, textoObservacionesPresupuesto, jornadasParaTareas,
  TEXTO_ORDEN_NUEVA_PRUEBAS, avisoRutaPresupuesto, avisoFinSinDefinir, finSinDefinir
} from '../utils/tareasPresupuesto';
import { avisosRespuestaGuardado, camposCosteDeRespuesta, documentoTrasGuardado, parsearFechaServidor } from '../utils/pantallasUnDia';
import {
  CAMPOS_IVA_SUPLEMENTO, lineaDesdeMenu, lineasAfectadasPorPersonas, precioMenuCatalogo, redondear2,
  textoLineasAutomaticasCongeladas, tieneLineasAutomaticas, tipoIvaDe, totalesDesdeItems,
} from '../utils/lineasVenta';

// Formato nuevo, pestaña Líneas y menús: el gestor de jornadas heredado
// (JornadasManager, el recuadro "Multi-Evento" del formato anterior) queda
// OCULTO, no borrado: sus funciones están en LineasPorJornada. Para volver a
// enseñarlo encima de las líneas por jornada, poner true. El formato anterior
// lo sigue enseñando siempre.
const MOSTRAR_GESTOR_HEREDADO = false;

// Descarga el blob como PDF o, si el backend devolvió HTML (fallback local sin
// WeasyPrint), lo abre en una pestaña para poder visualizarlo. En producción
// WeasyPrint siempre genera PDF, así que este camino solo se da en desarrollo.
const descargarOAbrirDocumento = (result, filenamePdf) => {
  const esHtml = (result.contentType || '').includes('text/html');
  if (esHtml) {
    const htmlBlob = result.blob.type ? result.blob : new Blob([result.blob], { type: 'text/html' });
    const url = window.URL.createObjectURL(htmlBlob);
    window.open(url, '_blank');
    // Revocar tras un margen para que la pestaña cargue el contenido
    setTimeout(() => window.URL.revokeObjectURL(url), 30000);
    return;
  }
  const url = window.URL.createObjectURL(result.blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filenamePdf;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

// SafeFetch para blobs - evita conflictos con rrweb-recorder usando XMLHttpRequest
const safeFetchBlob = (url, options = {}) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const method = options.method || 'GET';
    
    xhr.open(method, url, true);
    xhr.responseType = 'blob';
    
    // Configurar headers
    if (options.headers) {
      Object.entries(options.headers).forEach(([key, value]) => {
        xhr.setRequestHeader(key, value);
      });
    }
    
    xhr.timeout = 60000; // 60 segundos
    
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        const contentType = xhr.getResponseHeader('content-type') || 'application/octet-stream';
        resolve({ 
          ok: true, 
          status: xhr.status, 
          blob: xhr.response,
          contentType: contentType
        });
      } else {
        // Intentar leer el error como texto
        const reader = new FileReader();
        reader.onload = function() {
          resolve({ 
            ok: false, 
            status: xhr.status, 
            error: reader.result || `Error ${xhr.status}`
          });
        };
        reader.onerror = function() {
          resolve({ 
            ok: false, 
            status: xhr.status, 
            error: `Error ${xhr.status}` 
          });
        };
        reader.readAsText(xhr.response);
      }
    };
    
    xhr.onerror = function() {
      console.error('XHR error for:', url);
      resolve({ ok: false, status: 0, error: 'Error de conexión' });
    };
    
    xhr.ontimeout = function() {
      resolve({ ok: false, status: 0, error: 'Tiempo de espera agotado' });
    };
    
    // Enviar con body si es necesario
    if (options.body) {
      xhr.send(options.body);
    } else {
      xhr.send();
    }
  });
};

// Función para formatear fechas a DD/MM/YYYY
// Importe en euros con formato español (1.234,50 €)
const formatEuros = (n) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(Number(n) || 0);

// Firma de lo que mueve el total de un evento de un día en la ficha (U-10):
// precio, unidades e IVA de cada fila y los suplementos. Si cambia tras la
// última respuesta del servidor, la ficha enseña su vista previa.
const firmaTotalesFicha = (filas, suplementos) => JSON.stringify([
  (filas || []).map(it => [Number(it?.precio_ud) || 0, Number(it?.uds) || 0, Number(it?.iva_percent) || 0]),
  (suplementos || []).map(s => (s && typeof s === 'object'
    ? [Number(s.total) || 0, s.iva ?? null, s.tipo_iva ?? null, s.iva_percent ?? null, !!s.es_cortesia]
    : null)),
]);

// Hora por servicio: al reordenar o quitar líneas, `acompana_a_indice` sigue
// apuntando al mismo servicio (`mapa`: índice viejo -> nuevo, null si se quita).
// `acompana_a_linea_id` (U-14) no cambia: es el de la línea; si se quita, se va.
// Nombres de los servicios sin hora para los avisos: los de la cabecera y, en
// multievento, "Servicio (día N)" de los días sin hora aunque la cabecera la
// tenga (estadoReglas.horarios.sin_hora_jornadas)
const nombresSinHoraServicios = (h) => [
  ...((h && h.nombres_sin_hora) || []),
  ...((h && h.sin_hora_jornadas) || []).map(x => `${x.nombre} (día ${x.numero})`),
];

const remapearAcompana = (menus, mapa) => (menus || []).map((m) => {
  if (!m || m.acompana_a_indice === undefined || m.acompana_a_indice === null) return m;
  const nuevo = mapa(m.acompana_a_indice);
  if (nuevo === m.acompana_a_indice) return m;
  if (nuevo === null || nuevo === undefined) {
    const { acompana_a_linea_id: _quitado, ...resto } = m;
    return { ...resto, acompana_a_indice: nuevo };
  }
  return { ...m, acompana_a_indice: nuevo };
});

// Mover la línea `desde` a la posición `hasta` (la que ocupa en la lista
// resultante): índice viejo -> nuevo de cada línea. La movida pasa a `hasta`;
// las que estaban entre medias se corren un puesto hacia el hueco que deja.
const mapaMoverLinea = (desde, hasta) => (x) => {
  if (x === desde) return hasta;
  if (desde < hasta && x > desde && x <= hasta) return x - 1;
  if (desde > hasta && x >= hasta && x < desde) return x + 1;
  return x;
};

// Filas de la ficha tras mover una línea (en pantalla, antes de que responda
// el servidor): las filas de línea (`personalizadoIndex`) toman su índice
// nuevo según `mapa` y se ordenan por él dentro de los huecos que ocupaban;
// las demás filas (platos sueltos) se quedan donde estaban.
const reordenarItemsR2 = (lista, mapa, lineasNuevas = null) => {
  const huecos = [];
  const deLinea = [];
  (lista || []).forEach((it, pos) => {
    if (it && it.personalizadoIndex !== undefined && it.personalizadoIndex !== null) {
      const nuevo = mapa(it.personalizadoIndex);
      const linea = lineasNuevas ? lineasNuevas[nuevo] : null;
      huecos.push(pos);
      deLinea.push({
        ...it,
        personalizadoIndex: nuevo,
        ...(it.menuPersonalizado && linea ? { menuPersonalizado: linea } : {}),
      });
    }
  });
  deLinea.sort((a, b) => a.personalizadoIndex - b.personalizadoIndex);
  const resultado = [...(lista || [])];
  huecos.forEach((pos, k) => { resultado[pos] = deLinea[k]; });
  return resultado;
};

// Texto de las adaptaciones que se han quedado sin su línea al guardar (U-14)
const textoAdaptacionesHuerfanas = (lista) => (lista || [])
  .map(h => h?.texto).filter(Boolean).join(' ');

const formatFecha = (fechaStr) => {
  if (!fechaStr) return '';
  const fecha = new Date(fechaStr);
  const dia = String(fecha.getDate()).padStart(2, '0');
  const mes = String(fecha.getMonth() + 1).padStart(2, '0');
  const anio = fecha.getFullYear();
  return `${dia}/${mes}/${anio}`;
};

// Niveles de Logística (subpestañas de Logistica2), en su orden
const NIVELES_LOGISTICA = ['lugar', 'horario', 'quien'];

// Pestañas de la ficha en el formato nuevo (diseño A+)
const PESTANAS_FICHA = [
  { clave: 'resumen', etiqueta: 'Resumen' },
  { clave: 'por_hacer', etiqueta: 'Por hacer' },
  // Prueba (09-oct-2026): Resumen con las líneas editables, para comparar
  { clave: 'resumen2', etiqueta: 'Resumen 2' },
  { clave: 'lineas', etiqueta: 'Líneas y menús' },
  { clave: 'alergenos', etiqueta: 'Alérgenos' },
  // Logística en tres niveles (componente Logistica2): 1 lugar y transporte,
  // 2 horario, 3 quién va y camareros
  { clave: 'logistica', etiqueta: 'Logística' },
  { clave: 'material', etiqueta: 'Material' },
  { clave: 'compra', etiqueta: 'Lista de compra' },
  { clave: 'facturacion', etiqueta: 'Facturación y cobros' },
  { clave: 'correos', etiqueta: 'Correos' },
  { clave: 'historial', etiqueta: 'Historial' },
];

// Prueba (10-oct-2026, a petición del usuario): la pestaña Resumen enseña el
// Resumen 2 (líneas editables) y "Resumen 2" y "Líneas y menús" se ocultan unos
// días; sus enlaces (?pestana=lineas, tareas, avisos) llevan a Resumen. El código
// de las dos sigue aquí: para volver atrás basta con poner `false`.
const RESUMEN_NUEVO = true;
const PESTANAS_VISIBLES = RESUMEN_NUEVO
  ? PESTANAS_FICHA.filter(p => p.clave !== 'resumen2' && p.clave !== 'lineas')
  : PESTANAS_FICHA;
// Nombres cortos de las pestañas en el móvil (las demás, el de siempre)
const ETIQUETAS_PESTANA_MOVIL = {
  facturacion: 'Facturación',
  compra: 'Compra',
};
// Pestañas antiguas o retiradas y la que las sustituye
const ALIAS_PESTANAS = {
  // La antigua "Personal y material" es ahora "Material" (el personal está en
  // Logística, Quién va al evento) y la antigua "Logística 2" es Logística
  personal: 'material',
  logistica2: 'logistica',
  ...(RESUMEN_NUEVO ? { lineas: 'resumen', resumen2: 'resumen' } : {}),
};

// Última pestaña usada (medición de uso, oct-2026): al repasar varias fichas
// seguidas, la siguiente se abre en la misma pestaña. Solo vale una hora desde
// el último cambio y solo cuando el enlace no pide una pestaña (?pestana= manda).
const CLAVE_ULTIMA_PESTANA = 'duetto_ficha_ultima_pestana';
const VIGENCIA_ULTIMA_PESTANA_MS = 60 * 60 * 1000;
const leerUltimaPestana = () => {
  try {
    const guardada = JSON.parse(localStorage.getItem(CLAVE_ULTIMA_PESTANA) || 'null');
    if (!guardada || Date.now() - guardada.t > VIGENCIA_ULTIMA_PESTANA_MS) return null;
    const clave = ALIAS_PESTANAS[guardada.clave] || guardada.clave;
    return PESTANAS_VISIBLES.some(p => p.clave === clave) ? clave : null;
  } catch (e) {
    return null;
  }
};
const guardarUltimaPestana = (clave) => {
  try {
    localStorage.setItem(CLAVE_ULTIMA_PESTANA, JSON.stringify({ clave, t: Date.now() }));
  } catch (e) {
    // Sin almacenamiento (modo privado): la ficha se abre en Resumen
  }
};

// ===== Autoguardado de la ficha (formato nuevo) =====
const igualesJSON = (a, b) => {
  if (a === b) return true;
  try {
    return JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
  } catch (e) {
    return false;
  }
};
// Resumen de lo que deshizo cancelar (U-07): "Stock devuelto, 3 lotes
// liberados, pedidos anulados: Alea (email enviado)". null si no hay nada.
const textoResumenCancelacion = (r) => {
  if (!r || typeof r !== 'object') return null;
  const partes = [];
  if (r.evento_pasado && r.estado_anterior === 'confirmado') {
    partes.push('Evento ya celebrado: sin devolver stock ni liberar lotes');
  } else if (r.confirmacion_deshecha) {
    partes.push(r.movimientos_stock_devueltos > 0 ? 'Stock devuelto' : 'Sin stock que devolver');
    const lotes = Number(r.lotes_liberados) || 0;
    partes.push(`${lotes} ${lotes === 1 ? 'lote liberado' : 'lotes liberados'}`);
  }
  const anulados = (r.pedidos_anulados || []).filter(p => p && p.anulada);
  if (anulados.length > 0) {
    const textos = anulados.map((p) => {
      const quien = p.proveedor || (p.tipo === 'alquiler' ? 'alquiler' : 'personal extra');
      if (p.email_enviado) return `${quien} (email enviado)`;
      if (p.error && p.error.includes('email')) return `${quien} (email no enviado)`;
      return `${quien} (sin email)`;
    });
    partes.push(`pedidos anulados: ${textos.join(', ')}`);
  }
  return partes.length > 0 ? `${partes.join(', ')}.` : null;
};
// Campos que no viajan nunca por el PUT de la ficha desde el formato nuevo:
// control, datos del GET y los que tienen su propio endpoint (se guardan allí)
const CAMPOS_FUERA_DE_FICHA = new Set([
  'id', '_id', 'rev', 'campos_conservados', 'updated_at', 'created_at', 'created_by', 'cliente_data',
  'quien_va_evento', 'personal_asignado', 'vehiculos_asignados', 'orden_personal_extra',
  'grupos_dieta', 'comensales_alergicos', 'alergenos_lista', 'lista_alergenos',
  'suplemento_menu_adaptado_regalado', 'material_evento', 'material_validado', 'cancelacion', 'transporte',
  // Costes: los calcula y guarda el servidor, la ficha solo los lee
  'coste_total', 'margen', 'beneficio', 'coste_persona', 'desglose_costes', 'costes_detalle', 'costes_version',
  'costes_calculado_en',
]);
const CAMPOS_CABECERA = ['fecha_evento', 'hora_inicio', 'hora_fin', 'hora_llegada_estimada', 'num_personas'];
// Bloque de cada campo (el resto va con Líneas y menús)
const BLOQUE_DE_CAMPO = {
  ...Object.fromEntries(CAMPOS_CABECERA.map(k => [k, 'cabecera'])),
  ...Object.fromEntries(['cliente_id', 'cliente_nombre', 'persona_contacto_id', 'nombre_evento', 'estado']
    .map(k => [k, 'cabecera'])),
  ...Object.fromEntries(['lugar_evento', 'direccion_exacta', 'coordenadas', 'place_id', 'municipio', 'distancia_km',
    'tiempo_viaje_min', 'coste_transporte', 'ruta_origen', 'ruta_error_origen', 'materiales_alquiler',
    'alquiler_transporte', 'alquiler_fianza'].map(k => [k, 'logistica'])),
  ...Object.fromEntries(['contacto_facturacion_id', 'notas_administracion', 'politica_pago', 'politica_pago_id',
    'facturacion_multi_evento', 'rangos_facturacion'].map(k => [k, 'facturacion'])),
  observaciones: 'resumen',
};
// Campos que la ficha edita en memoria y el autoguardado guarda solo (con
// retardo) al ver que difieren de lo guardado en el servidor
const CAMPOS_AUTOGUARDADO_ESTADO = {
  resumen: ['observaciones'],
  facturacion: ['notas_administracion'],
  // El alquiler (materiales_alquiler, transporte, fianza) lo guarda su propio
  // endpoint (AlquilerEvento): no pasa por aquí para no pisarlo con lo de memoria
  logistica: ['lugar_evento'],
};

// Modales rápidos de "Por hacer" (formato nuevo): abren el bloque de la ficha que
// resuelve la tarea sin salir de la pestaña. `tarea` es la clave de la tarea
// que se muestra como hecha o pendiente dentro del modal; `nivel`, el nivel de
// Logística que abre "Abrir la pestaña completa".
const MODALES_RAPIDOS = {
  direccion: { titulo: 'Dirección y transporte', descripcion: 'Elige la sugerencia de Google para calcular distancia y transporte.', pestana: 'logistica', nivel: 'lugar', tarea: 'direccion' },
  furgonetas: { titulo: 'Furgonetas', descripcion: 'Asigna las furgonetas del evento.', pestana: 'logistica', nivel: 'lugar', tarea: 'furgonetas' },
  personal: { titulo: 'Personal', descripcion: 'Personal asignado y orden de personal extra.', pestana: 'logistica', nivel: 'quien', tarea: 'personal' },
  bebidas: { titulo: 'Bebidas', descripcion: 'Elige el modo de bebidas del evento y valídalo.', pestana: 'lineas', tarea: 'bebidas' },
  contacto_facturacion: { titulo: 'Contacto de facturación', descripcion: 'A quién se enviará la factura.', pestana: 'facturacion', tarea: 'contacto-facturacion' },
  alergenos: { titulo: 'Alérgenos y dietas', descripcion: 'Comensales con alergias o dietas, menú individual y validación con cocina.', pestana: 'alergenos', tarea: 'alergenos' },
  solicitud_extras: { titulo: 'Solicitud de personal extra', descripcion: 'Orden de personal extra con el responsable del montaje y el personal del menú de "Quién va al evento".', pestana: 'logistica', nivel: 'quien', tarea: 'solicitud-extras' },
};

// Indicador "Guardando… / Guardado hace X / Error al guardar" (formato nuevo).
// Lleva su propio reloj para no repintar toda la ficha cada pocos segundos.
const IndicadorGuardado = ({ estado, ultimo, detalle = null }) => {
  const [, setTic] = useState(0);
  useEffect(() => {
    if (estado !== 'guardado' || !ultimo) return undefined;
    const reloj = setInterval(() => setTic(v => v + 1), 5000);
    return () => clearInterval(reloj);
  }, [estado, ultimo]);

  if (estado === 'guardando') {
    return (
      <span className="flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-gray-600" data-testid="indicador-guardado">
        <RefreshCw className="w-4 h-4 animate-spin" /> Guardando…
      </span>
    );
  }
  if (estado === 'sin_conexion') {
    return (
      <span
        className="flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-red-700"
        title="Se reintenta cada 10 segundos. No cierres la página hasta que se guarde."
        data-testid="indicador-guardado"
      >
        <AlertCircle className="w-4 h-4" /> Sin conexión: cambios pendientes
      </span>
    );
  }
  if (estado === 'error') {
    return (
      <span className="flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-red-700" title={detalle || undefined} data-testid="indicador-guardado">
        <AlertCircle className="w-4 h-4" /> {detalle ? 'No guardado: revisa el aviso' : 'Error al guardar'}
      </span>
    );
  }
  if (estado === 'guardado' && ultimo) {
    const segundos = Math.max(0, Math.round((Date.now() - ultimo.getTime()) / 1000));
    let hace;
    if (segundos < 60) hace = 'hace un momento';
    else if (segundos < 3600) hace = `hace ${Math.floor(segundos / 60)} min`;
    else hace = `a las ${ultimo.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}`;
    return (
      <span className="flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-duetto-primary" data-testid="indicador-guardado">
        <CheckCircle className="w-4 h-4" /> Guardado {hace}
      </span>
    );
  }
  return (
    <span className="flex items-center gap-1.5 text-xs sm:text-sm text-gray-500" data-testid="indicador-guardado">
      <CheckCircle className="w-4 h-4" /> Sin cambios pendientes
    </span>
  );
};

// Base y total por tipo de IVA de las líneas de una factura (reparto proporcional)
const pesosIvaDeLineas = (lineas) => {
  const pesos = {};
  (lineas || []).forEach(l => {
    const t = Number(l.tipo_impositivo ?? 10);
    const b = Math.abs(Number(l.base_imponible || 0));
    const c = Math.abs(Number(l.cuota_repercutida || 0));
    if (!pesos[t]) pesos[t] = { base: 0, total: 0 };
    pesos[t].base += b;
    pesos[t].total += b + c;
  });
  return pesos;
};

// Asunto y cuerpo por defecto del email de factura. El tiempo verbal depende
// de si el evento ya pasó o es futuro, y el asunto lleva el nº de factura
// (DC2026XXXX) cuando se conoce, para poder localizarla luego en el correo.
// `rangoFechas` ("17 al 18/11/2026"): multievento de varios días facturado
// entero (factura consolidada o proforma); la de una jornada lleva su fecha.
const construirEmailFacturaDefaults = (fechaIso, numeroFactura, rangoFechas = '') => {
  const meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  let fechaLegible = '';
  let esFuturo = false;
  if (fechaIso) {
    const d = new Date(String(fechaIso).slice(0, 10) + 'T00:00:00');
    if (!isNaN(d.getTime())) {
      fechaLegible = `${d.getDate()} de ${meses[d.getMonth()]}`;
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      esFuturo = d.getTime() > hoy.getTime();
    }
  }
  // Varios días: "los días 17 al 18/11/2026" en vez de "el próximo 17 de noviembre"
  const cuando = rangoFechas ? `los días ${rangoFechas}` : '';
  if (rangoFechas) fechaLegible = rangoFechas;
  let asunto = fechaLegible ? `Factura evento catering ${fechaLegible}` : 'Factura Duetto Catering';
  if (numeroFactura) asunto = `${asunto} ${numeroFactura}`;
  let mensaje;
  if (fechaLegible && esFuturo) {
    mensaje = `Buenos días,

Adjuntamos factura correspondiente al evento que se realizará ${cuando || `el próximo ${fechaLegible}`}, esperamos que todo salga bien y nos volvamos a ver en otras ocasiones.

Muchas gracias, un saludo.`;
  } else if (fechaLegible) {
    mensaje = `Buenos días,

Adjuntamos factura correspondiente al evento que se realizó ${cuando || `el pasado ${fechaLegible}`}, esperamos que todo estuviese bien y nos volvamos a ver en otras ocasiones.

Muchas gracias, un saludo.`;
  } else {
    mensaje = `Buenos días,

Adjuntamos factura correspondiente al evento.

Muchas gracias, un saludo.`;
  }
  return { asunto, mensaje };
};

// Número escrito a mano con coma o punto decimal ("0,5" o "0.5"); NaN si no lo es
const numeroDecimal = (v) => parseFloat(String(v ?? '').trim().replace(',', '.'));

const PresupuestoDetalle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [downloadMessage, setDownloadMessage] = useState('');
  const [presupuesto, setPresupuesto] = useState(null);
  const [desperdicio, setDesperdicio] = useState(null);
  const [desperdicioAbierto, setDesperdicioAbierto] = useState(false);
  const [regalandoSobrante, setRegalandoSobrante] = useState(false);
  const [materialAbierto, setMaterialAbierto] = useState(false);
  const [totalIngAbierto, setTotalIngAbierto] = useState(false);
  const [totalCocinaAbierto, setTotalCocinaAbierto] = useState(false);
  const [totalEventoAbierto, setTotalEventoAbierto] = useState(false);
  const [cliente, setCliente] = useState(null);
  const [menus, setMenus] = useState([]);
  const [platos, setPlatos] = useState([]);
  const [ingredientesCatalogo, setIngredientesCatalogo] = useState([]);
  const [alergenos, setAlergenos] = useState([]);
  const [materiales, setMateriales] = useState([]);
  const [plantillasMenaje, setPlantillasMenaje] = useState([]);
  const [activeTab, setActiveTab] = useState('observaciones');
  const [correosEvento, setCorreosEvento] = useState([]);
  const [cargandoCorreos, setCargandoCorreos] = useState(false);
  const [correosExpandidos, setCorreosExpandidos] = useState(() => new Set());
  const [detalleCorreos, setDetalleCorreos] = useState({});
  const [resumenCorreos, setResumenCorreos] = useState(null);
  // Formato nuevo: al aceptar o deshacer un vínculo de la IA se recarga la lista
  const [recargaCorreos, setRecargaCorreos] = useState(0);
  const [deshaciendoCorreo, setDeshaciendoCorreo] = useState(null);
  // Formato nuevo: buzones del usuario (etiqueta "en N buzones") y filtro por buzón ([] = todos)
  const [cuentasCorreo, setCuentasCorreo] = useState([]);
  const [buzonesCorreos, setBuzonesCorreos] = useState([]);
  const [cargandoResumen, setCargandoResumen] = useState(false);
  const [errorResumen, setErrorResumen] = useState(null);
  const [expandedMenus, setExpandedMenus] = useState({});
  // Resumen 2: filas de líneas desplegadas ({clave: true})
  const [lineasAbiertasR2, setLineasAbiertasR2] = useState({});
  // Reordenar líneas del Resumen 2: movimiento en curso (un solo guardado por
  // movimiento) y arrastre (línea de origen y destino previsto para pintarlo)
  const [reordenandoLinea, setReordenandoLinea] = useState(false);
  const reordenandoLineaRef = useRef(false);
  const [origenArrastreR2, setOrigenArrastreR2] = useState(null);
  const origenArrastreR2Ref = useRef(null);
  const [destinoArrastreR2, setDestinoArrastreR2] = useState(null); // { indice, antes }
  // Resumen 2: bebidas (guardando el modo, error, ver el bloque completo)
  const [bebidasR2, setBebidasR2] = useState({ guardando: false, error: null, completo: false, borradores: {}, pregunta: null });
  const [expandedPlatos, setExpandedPlatos] = useState({});
  const [items, setItems] = useState([]);
  // Totales del servidor de un evento de un día (U-10): {base, iva, total,
  // firma}. `firma` es la de las filas y suplementos de la ficha cuando
  // llegaron; si la ficha cambia después, se enseña la vista previa local
  // (misma regla) hasta la siguiente respuesta del servidor.
  const [totalesServidor, setTotalesServidor] = useState(null);
  // U-33: cambio de personas de la cabecera pendiente de decidir si se aplica
  // a las líneas ({anterior, nuevo, aplicables, distintas, aplicar})
  const [dialogoPersonas, setDialogoPersonas] = useState(null);
  const [adaptaciones, setAdaptaciones] = useState([]);
  const [showAdaptacionModal, setShowAdaptacionModal] = useState(false);
  const [materialesAlquilerCatalogo, setMaterialesAlquilerCatalogo] = useState([]);
  const [selectedMenuForAdaptacion, setSelectedMenuForAdaptacion] = useState(null);
  const [recomendaciones, setRecomendaciones] = useState({});
  const [showAddMenuModal, setShowAddMenuModal] = useState(false);
  // Multievento: jornadas a las que va el menú que se añade (null = todas)
  const [jornadasMenuToAdd, setJornadasMenuToAdd] = useState(null);
  // Enviar una factura al cliente en un clic ({facturaId, numero} o null)
  const [facturaEnvioCliente, setFacturaEnvioCliente] = useState(null);
  // Duplicar el presupuesto entero
  const [showDuplicar, setShowDuplicar] = useState(false);
  const [selectedMenuToAdd, setSelectedMenuToAdd] = useState('');
  const [personasMenuToAdd, setPersonasMenuToAdd] = useState('');
  const [menuSearchQuery, setMenuSearchQuery] = useState('');
  const [bebidaIncluidaMenuToAdd, setBebidaIncluidaMenuToAdd] = useState(false);
  const [bebidasPorPersonaMenuToAdd, setBebidasPorPersonaMenuToAdd] = useState(1);
  const [addingMenu, setAddingMenu] = useState(false); // Loading state para añadir menú
  // Evita dos añadidos a la vez (doble clic antes de que se pinte addingMenu)
  const anadiendoMenuRef = useRef(false);
  // Menús añadidos con el botón rápido sin cerrar el modal ("Añadido: ...")
  const [menusAnadidosRapido, setMenusAnadidosRapido] = useState([]);
  // Al abrir el modal, la novedad del botón "Añadir" puede salir (no hay
  // cambio de ruta que la despierte)
  useEffect(() => {
    if (showAddMenuModal) revisarNovedades();
  }, [showAddMenuModal]);
  const [addingCustomMenu, setAddingCustomMenu] = useState(false); // Loading state para crear menú personalizado
  
  // Estados para suplementos
  const [showAddSuplementoModal, setShowAddSuplementoModal] = useState(false);
  const [suplementoForm, setSuplementoForm] = useState({
    menu_vinculado_id: '',
    nombre: '',
    precio_unitario: '',
    unidades: '',
    iva: '10', // Por defecto 10% para catering
    descuento: '', // Descuento en euros
    es_cortesia: false,
    motivo_cortesia: ''
  });

  // Formato nuevo (en pruebas): todo lo de las reglas comerciales, el modal de
  // cancelación y las condiciones nuevas del PDF solo se ven con él activo.
  // Desactivado, la página se comporta exactamente como antes.
  const [formatoNuevo, setFormatoNuevo] = useFormatoNuevo();

  // Indicador de guardado (solo se muestra en el formato nuevo). Los caminos de
  // guardado existentes solo avisan de inicio/fin/error; no cambia lo que hacen.
  const [estadoGuardado, setEstadoGuardado] = useState({ estado: 'inactivo', ultimo: null });
  const guardadosPendientesRef = useRef(0);
  const formatoNuevoRef = useRef(formatoNuevo);
  formatoNuevoRef.current = formatoNuevo;
  // Formato nuevo: "Convertir a multievento" en curso (bloque de líneas)
  const [convirtiendoMultievento, setConvirtiendoMultievento] = useState(false);
  const notificarGuardado = useCallback((fase) => {
    if (!formatoNuevoRef.current) return;
    if (fase === 'inicio') {
      guardadosPendientesRef.current += 1;
      setEstadoGuardado(prev => (prev.estado === 'guardando' ? prev : { ...prev, estado: 'guardando' }));
      return;
    }
    guardadosPendientesRef.current = Math.max(0, guardadosPendientesRef.current - 1);
    if (fase === 'error') {
      setEstadoGuardado(prev => ({ ...prev, estado: 'error' }));
    } else if (guardadosPendientesRef.current === 0) {
      setEstadoGuardado({ estado: 'guardado', ultimo: new Date() });
    }
  }, []);
  // PersonalAsignado y VehiculosAsignados guardan con fetch y avisan con
  // 'inicio' | 'ok' | 'error' (solo se les pasa en el formato nuevo)
  const notificarGuardadoHijo = useCallback((fase) => {
    notificarGuardado(fase === 'ok' ? 'fin' : fase);
  }, [notificarGuardado]);
  // Guardado sin pisar otras sesiones (solo formato nuevo): la ficha reenvía la
  // `rev` del presupuesto que tiene cargado. Si el servidor conserva cambios más
  // recientes de otra sesión, devuelve `campos_conservados`: se avisa y se recarga.
  const revFichaRef = useRef({ id: null, rev: null });
  const fetchDataRef = useRef(null);
  const [avisoConservados, setAvisoConservados] = useState(null);
  // U-14: adaptaciones de alérgenos que apuntaban a una línea quitada (nada se quita en silencio)
  const [avisoHuerfanas, setAvisoHuerfanas] = useState(null);
  // U-32: avisos de la respuesta del guardado ya enseñados en esta ficha
  const avisosMostradosRef = useRef(new Set());

  // ===== Autoguardado (solo formato nuevo) =====
  // Último documento conocido del servidor (el del GET o el que devuelve el
  // PUT): con él se sabe qué campos ha cambiado la ficha y se envían solo esos.
  const baseServidorRef = useRef(null);
  // Último valor enviado de cada campo (para no reenviar lo mismo)
  const ultimoEnviadoRef = useRef({});
  const anotarBaseServidor = useCallback((datos, campos = null) => {
    if (datos && typeof datos === 'object' && datos.id === id) {
      if (!campos) ultimoEnviadoRef.current = {};
      baseServidorRef.current = datos;
    } else if (campos && baseServidorRef.current && baseServidorRef.current.id === id) {
      baseServidorRef.current = { ...baseServidorRef.current, ...campos };
    }
  }, [id]);
  // Totales que devuelve el servidor tras un guardado (U-10, evento de un
  // día): la ficha los enseña en cuanto llegan (la firma de la ficha se anota
  // en el siguiente render, ver el efecto de `totalesServidor`)
  const capturarTotalesServidor = useCallback((datos) => {
    if (!datos || typeof datos !== 'object' || datos.id !== id) return;
    if (datos.importe_total === undefined || datos.importe_total === null) return;
    setTotalesServidor({
      base: Number(datos.importe_base) || 0,
      iva: Number(datos.iva) || 0,
      total: Number(datos.importe_total) || 0,
      firma: null,
    });
  }, [id]);
  // PUT parcial con los campos tocados (el interceptor añade rev y _formato)
  const enviarCamposFicha = useCallback(async (campos) => {
    const respuesta = await presupuestosAPI.update(id, campos);
    anotarBaseServidor(respuesta?.data, campos);
    capturarTotalesServidor(respuesta?.data);
    ultimoEnviadoRef.current = { ...ultimoEnviadoRef.current, ...campos };
    // El servidor recalcula los costes dentro del PUT: con su updated_at y
    // costes_calculado_en cambia la firma de costes y se relee el Resumen
    const datos = respuesta?.data;
    if (datos && typeof datos === 'object' && datos.id === id) {
      const costes = camposCosteDeRespuesta(datos);
      if (Object.keys(costes).length > 0) {
        setPresupuesto(prev => (prev && prev.id === id ? { ...prev, ...costes } : prev));
      }
    }
    return respuesta;
  }, [id, anotarBaseServidor, capturarTotalesServidor]);
  // Al salir de la página: el mismo PUT parcial con keepalive (sobrevive al
  // cierre). Lleva la rev y la marca del formato nuevo a mano porque no pasa
  // por axios. Devuelve false si no se ha podido mandar.
  const crearEnvioUrgente = useCallback((idPresupuesto) => (campos) => {
    try {
      const { id: idRev, rev } = revFichaRef.current;
      const cuerpo = JSON.stringify({
        ...campos,
        _formato: 'nuevo',
        ...(idRev === idPresupuesto && rev != null ? { rev } : {}),
      });
      if (cuerpo.length > 60000 || typeof fetch !== 'function') return false;
      const token = getAuthToken();
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${idPresupuesto}`, {
        method: 'PUT',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        body: cuerpo,
      })
        .then(r => (r && r.ok ? r.json() : null))
        .then((datos) => {
          // Si la página sigue abierta (se canceló la salida), la ficha va al día
          if (!datos || datos.id !== idPresupuesto) return;
          const nueva = Number(datos.rev);
          const actual = revFichaRef.current;
          if (Number.isFinite(nueva) && (actual.id !== idPresupuesto || actual.rev == null || nueva > actual.rev)) {
            revFichaRef.current = { id: idPresupuesto, rev: nueva };
          }
          if (baseServidorRef.current && baseServidorRef.current.id === idPresupuesto) baseServidorRef.current = datos;
        })
        .catch(() => {});
      return true;
    } catch (e) {
      return false;
    }
  }, []);
  const enviarCamposUrgente = useMemo(() => crearEnvioUrgente(id), [crearEnvioUrgente, id]);
  const autoguardado = useAutoguardado({
    enviarCampos: enviarCamposFicha,
    enviarCamposUrgente,
    onError: (clave, error, mensaje) => {
      toast({ variant: 'destructive', title: 'No se ha guardado', description: mensaje });
    },
  });
  const autoguardadoRef = useRef(autoguardado);
  autoguardadoRef.current = autoguardado;
  // Guardados con endpoint propio (personal, furgonetas): por la misma cola
  const encolarGuardado = useCallback(
    (clave, tarea) => autoguardadoRef.current.programar(`${clave}:${id}`, tarea, { inmediato: true }),
    [id]
  );

  // Guardado del documento desde los manejadores de la ficha.
  // - Formato anterior: exactamente como siempre (PUT con lo que se pase).
  // - Formato nuevo: solo los campos que cambian respecto a lo guardado en el
  //   servidor, cada uno en su bloque y por la cola del autoguardado (nunca dos
  //   PUT a la vez). Los campos que tienen su propio endpoint (Quién va,
  //   alérgenos, personal, furgonetas, material, orden de personal extra...) no
  //   viajan por aquí aunque vengan en el objeto.
  const guardarFicha = (datos) => {
    if (!formatoNuevo) {
      return presupuestosAPI.update(id, datos).then((r) => {
        capturarTotalesServidor(r?.data);
        return r;
      });
    }
    const base = baseServidorRef.current && baseServidorRef.current.id === id ? baseServidorRef.current : null;
    const porBloque = {};
    Object.keys(datos || {}).forEach((k) => {
      if (CAMPOS_FUERA_DE_FICHA.has(k)) return;
      if (base && igualesJSON(datos[k], base[k])) return;
      const bloque = BLOQUE_DE_CAMPO[k] || 'lineas';
      porBloque[bloque] = { ...(porBloque[bloque] || {}), [k]: datos[k] };
    });
    const bloques = Object.keys(porBloque);
    if (bloques.length === 0) return Promise.resolve({ data: base, sinCambios: true });
    return Promise.all(bloques.map(b => autoguardado.programarCampos(b, porBloque[b], { inmediato: true, conservar: false })))
      .then((respuestas) => {
        const conDatos = respuestas.filter(r => r && r.data);
        return conDatos[conDatos.length - 1] || respuestas[respuestas.length - 1];
      });
  };

  // U-32 (lote 7): tras guardar, la ficha pinta el documento que devuelve el
  // servidor (con el mínimo, Madrid Central, la barra libre, los totales y los
  // linea_id que pone él), no su copia: así el siguiente guardado no reenvía
  // una copia sin las líneas del servidor. Sin documento en la respuesta (sin
  // cambios, cancelado), se queda `local` (un objeto o una función prev => nuevo,
  // como en setPresupuesto). Los avisos de la respuesta los enseña el
  // interceptor de la ficha, una vez cada uno.
  const aplicarRespuestaGuardado = (respuesta, local = null) => {
    const datos = respuesta && respuesta.data;
    if (!respuesta || respuesta.sinCambios || !datos || typeof datos !== 'object' || datos.id !== id) {
      if (local) setPresupuesto(local);
      return null;
    }
    setPresupuesto(prev => documentoTrasGuardado(
      datos, typeof local === 'function' ? local(prev) : (prev || local)));
    // Las filas de la tabla salen de las líneas: si el servidor las ha
    // cambiado (barra libre, linea_id, horas...), se vuelven a montar
    const lineasLocales = (local && typeof local === 'object' ? local : presupuesto)?.menus_personalizados;
    if (Array.isArray(datos.menus_personalizados) && !igualesJSON(datos.menus_personalizados, lineasLocales)) {
      initializeItems(documentoTrasGuardado(datos, presupuesto), menus, platos);
    }
    return datos;
  };

  // Cabecera (personas, fecha y horas): se guarda sola 1 s después de
  // cambiarla. Lo que esté a la espera o en marcha se guarda antes de
  // confirmar, generar PDF o enviar (vaciarGuardadosCabecera): confirmar con
  // los datos de antes de un cambio recién hecho dejaba el presupuesto a medias
  // (2214, 11-oct-2026).
  const guardadosCabeceraRef = useRef({ temporizadores: new Map(), enMarcha: new Set() });
  const programarGuardadoCabecera = (clave, tarea, ms = 1000) => {
    const g = guardadosCabeceraRef.current;
    const previo = g.temporizadores.get(clave);
    if (previo) clearTimeout(previo.timer);
    const lanzar = () => {
      g.temporizadores.delete(clave);
      const promesa = Promise.resolve().then(tarea).catch(() => {});
      g.enMarcha.add(promesa);
      promesa.finally(() => g.enMarcha.delete(promesa));
      return promesa;
    };
    g.temporizadores.set(clave, { timer: setTimeout(lanzar, ms), lanzar });
  };
  const cancelarGuardadoCabecera = (clave) => {
    const g = guardadosCabeceraRef.current;
    const previo = g.temporizadores.get(clave);
    if (previo) clearTimeout(previo.timer);
    g.temporizadores.delete(clave);
  };
  const vaciarGuardadosCabecera = async () => {
    const g = guardadosCabeceraRef.current;
    [...g.temporizadores.values()].forEach((t) => { clearTimeout(t.timer); t.lanzar(); });
    await Promise.all([...g.enMarcha]);
  };

  // U-97 (lote 7): las acciones de documentos (PDF, enviar, confirmar)
  // esperan a que se guarde lo pendiente: la cabecera (los dos formatos) y el
  // autoguardado (formato nuevo)
  const esperarAutoguardado = async () => {
    await vaciarGuardadosCabecera();
    const a = autoguardadoRef.current;
    if (!formatoNuevoRef.current || !a || !a.hayPendientes()) return;
    try {
      await a.guardarYa();
    } catch (e) {
      // El error ya lo avisa el autoguardado
    }
  };

  // Avisos de los manejadores de guardado: en el formato anterior, alert como
  // siempre; en el nuevo, el de éxito lo da el indicador de la barra y el de
  // error un toast (si no lo ha dado ya el autoguardado).
  const avisoGuardadoOk = (mensaje) => {
    if (formatoNuevoRef.current) return;
    alert(mensaje);
  };
  const avisoGuardadoError = (mensaje, error = null) => {
    if (!formatoNuevoRef.current) {
      alert(mensaje);
      return;
    }
    if (error && error.autoguardadoNotificado) return;
    toast({ variant: 'destructive', title: 'No se ha guardado', description: mensaje });
  };

  // Horas de servicio de una línea: se guardan con retardo. Formato anterior:
  // como siempre (800 ms y PUT de las líneas); nuevo: por la cola del
  // autoguardado (devuelve la promesa del guardado; null si falla).
  const guardarMenusConRetardo = (menusNuevos) => {
    if (formatoNuevo) {
      return autoguardado.programarCampos('lineas', { menus_personalizados: menusNuevos }).catch(() => null);
    }
    clearTimeout(window._menuHoraTimeout);
    window._menuHoraTimeout = setTimeout(() => {
      presupuestosAPI.update(id, { menus_personalizados: menusNuevos });
    }, 800);
  };

  // Cabecera (formato nuevo): fecha, horas, llegada y personas. Se guardan con
  // retardo y, al guardarse, la ficha toma los valores que devuelve el servidor.
  const programarCabecera = (campos, { recargar = false } = {}) => {
    autoguardado.programarCampos('cabecera', campos)
      .then((r) => {
        const datos = r && r.data;
        if (!datos || datos.id !== id) return;
        setPresupuesto(prev => (prev ? {
          ...prev,
          // Lo que el servidor recalcula al cambiar personas u horas (línea de
          // suplemento mínimo e importes) también se toma de la respuesta
          ...Object.fromEntries([...CAMPOS_CABECERA, 'suplementos', 'importe_base', 'iva', 'importe_total', 'precio_total',
            // U-34: con la hora del evento se movieron las horas de servicio de las líneas
            ...(Number(datos.horas_servicio_desplazadas) > 0 ? ['menus_personalizados'] : [])]
            .filter(k => k in datos).map(k => [k, datos[k]])),
          // Costes recalculados en el PUT (refresca Resumen y Rentabilidad)
          ...camposCosteDeRespuesta(datos),
        } : prev));
        if (recargar && !autoguardadoRef.current.hayPendientes() && fetchDataRef.current) fetchDataRef.current();
      })
      .catch(() => {});
  };

  // Campos editados en memoria (notas, lugar escrito a mano, alquiler...): se
  // guardan solos, con retardo, en cuanto difieren de lo guardado.
  useEffect(() => {
    if (!formatoNuevo || !presupuesto || !presupuesto.id) return;
    const base = baseServidorRef.current;
    if (!base || base.id !== presupuesto.id) return;
    Object.entries(CAMPOS_AUTOGUARDADO_ESTADO).forEach(([bloque, lista]) => {
      const campos = {};
      lista.forEach((c) => {
        const valor = presupuesto[c];
        if (igualesJSON(valor, base[c])) return;
        // Ya enviado con ese valor (el servidor puede devolverlo normalizado)
        if (Object.prototype.hasOwnProperty.call(ultimoEnviadoRef.current, c)
            && igualesJSON(ultimoEnviadoRef.current[c], valor)) return;
        const pendiente = autoguardadoRef.current.campoPendiente(bloque, c);
        if (pendiente.hay && igualesJSON(pendiente.valor, valor)) return;
        campos[c] = valor;
      });
      if (Object.keys(campos).length > 0) autoguardadoRef.current.programarCampos(bloque, campos).catch(() => {});
    });
  }, [presupuesto, formatoNuevo]);

  // Al salir de la página con cambios pendientes: se mandan con keepalive y,
  // si queda algo que no se puede mandar así, el navegador pregunta.
  useEffect(() => {
    if (!formatoNuevo) return undefined;
    const alSalir = (e) => {
      const a = autoguardadoRef.current;
      if (!a.hayPendientes() && a.estado.estado !== 'sin_conexion') return undefined;
      const quedan = a.vaciarUrgente();
      if (!quedan) return undefined;
      a.guardarYa();
      e.preventDefault();
      e.returnValue = '';
      return '';
    };
    window.addEventListener('beforeunload', alSalir);
    return () => window.removeEventListener('beforeunload', alSalir);
  }, [formatoNuevo]);

  // Al salir de la ficha dentro de la aplicación (o al pasar a otro
  // presupuesto): lo pendiente se guarda en el presupuesto que se editaba.
  useEffect(() => {
    const urgenteDeEste = crearEnvioUrgente(id);
    return () => {
      const a = autoguardadoRef.current;
      if (!a.hayPendientes()) return;
      a.vaciarUrgente(urgenteDeEste);
      a.guardarYa();
    };
  }, [id, crearEnvioUrgente]);
  // Resumen (formato nuevo): costes GUARDADOS por el motor único del backend
  // (GET /presupuestos/{id}/costes). No se recalculan al vuelo.
  const [costesGuardados, setCostesGuardados] = useState(null);
  const [cargandoCostes, setCargandoCostes] = useState(false);
  const [recalculandoCostes, setRecalculandoCostes] = useState(false);
  const [errorCostes, setErrorCostes] = useState(null);
  const cargarCostes = useCallback(async () => {
    if (!id) return;
    setCargandoCostes(true);
    try {
      const { data } = await api.get(`/presupuestos/${id}/costes`);
      setCostesGuardados(data || null);
      setErrorCostes(null);
    } catch (error) {
      setErrorCostes('No se pudieron cargar los costes: ' + (error.response?.data?.detail || error.message));
    } finally {
      setCargandoCostes(false);
    }
  }, [id]);
  // Solo al pulsar el botón: recalcula ESTE presupuesto con el motor y lo guarda
  const recalcularCostes = useCallback(async () => {
    if (!id) return;
    setRecalculandoCostes(true);
    try {
      const { data } = await api.post(`/presupuestos/${id}/recalcular-costes`);
      setCostesGuardados(data || null);
      setErrorCostes(null);
    } catch (error) {
      setErrorCostes('No se pudieron recalcular los costes: ' + (error.response?.data?.detail || error.message));
    } finally {
      setRecalculandoCostes(false);
    }
  }, [id]);
  // Se vuelven a leer cuando el backend ha podido recalcularlos: al cargar o
  // guardar el presupuesto, al guardar Quién va y al guardar o enviar la orden.
  const firmaCostes = presupuesto ? JSON.stringify([
    presupuesto.id,
    presupuesto.costes_calculado_en || null,
    presupuesto.updated_at || null,
    presupuesto.quien_va_evento?.actualizado_en || null,
    presupuesto.quien_va_evento?.persona_actualizada_en || null,
    presupuesto.orden_personal_extra
      ? [presupuesto.orden_personal_extra.estado, presupuesto.orden_personal_extra.coste_total, (presupuesto.orden_personal_extra.grupos || []).length]
      : null,
    (presupuesto.jornadas || []).map(j => (j?.orden_personal_extra
      ? [j.orden_personal_extra.estado, j.orden_personal_extra.coste_total] : null)),
  ]) : '';
  // U-40: también en el formato anterior (su "Análisis financiero" enseña el
  // beneficio con estos costes guardados). Solo lee.
  useEffect(() => {
    if (!firmaCostes) return undefined;
    const t = setTimeout(() => { cargarCostes(); }, 300);
    return () => clearTimeout(t);
  }, [firmaCostes, cargarCostes]);
  // Por hacer (formato nuevo): modal rápido abierto (clave de MODALES_RAPIDOS)
  const [modalRapido, setModalRapido] = useState(null);
  // Pestaña Material (formato nuevo): validación de la lista de cada ámbito
  // (evento o jornadas). Se relee si cambian personas, menús o servicios.
  const [estadoMaterial, setEstadoMaterial] = useState(null);
  const firmaMaterial = presupuesto ? JSON.stringify([
    presupuesto.id,
    presupuesto.num_personas,
    (presupuesto.menus_personalizados || []).map(m => [m.menu_id, m.num_personas, m.platos_ids, m.hora_inicio_servicio, m.hora_fin_servicio]),
    (presupuesto.jornadas || []).map(j => [j?.id, j?.num_personas, (j?.menus_personalizados || []).map(m => [m.menu_id, m.num_personas, m.platos_ids]),
      j?.material_validado?.en || null]),
    presupuesto.material_validado?.en || null,
  ]) : '';
  const cargarEstadoMaterial = useCallback(async () => {
    if (!id) return;
    try {
      const { data } = await api.get(`/presupuestos/${id}/material-evento/estado`);
      setEstadoMaterial(data && Array.isArray(data.ambitos) ? data : null);
    } catch (error) {
      setEstadoMaterial(null);
    }
  }, [id]);
  useEffect(() => {
    if (!formatoNuevo || !firmaMaterial) return undefined;
    const t = setTimeout(() => { cargarEstadoMaterial(); }, 300);
    return () => clearTimeout(t);
  }, [formatoNuevo, firmaMaterial, cargarEstadoMaterial]);

  // Modo de bebidas (formato nuevo): variado sin alcohol, con alcohol o
  // personalizado, y si está validado. Lo usan la tarjeta Bebidas y "Por hacer".
  // Se relee si cambian personas, menús o las bebidas personalizadas (el
  // reparto variado depende de ellos).
  const [estadoBebidasModo, setEstadoBebidasModo] = useState(null);
  const [cargandoBebidasModo, setCargandoBebidasModo] = useState(true);
  const firmaBebidasModo = presupuesto ? JSON.stringify([
    presupuesto.id,
    presupuesto.num_personas,
    presupuesto.bebidas_confirmadas || false,
    (presupuesto.bebidas || []).length,
    (presupuesto.menus_personalizados || []).map(m => [m.menu_id, m.num_personas, m.platos_ids, m.bebidas_por_persona]),
    (presupuesto.jornadas || []).map(j => [j?.id, j?.num_personas, (j?.menus_personalizados || []).map(m => [m.menu_id, m.num_personas, m.platos_ids])]),
  ]) : '';
  const cargarBebidasModo = useCallback(async () => {
    if (!id) return;
    setCargandoBebidasModo(true);
    try {
      const { data } = await presupuestosAPI.getBebidasModo(id);
      setEstadoBebidasModo(data && data.modo ? data : null);
    } catch (error) {
      setEstadoBebidasModo(null);
    } finally {
      setCargandoBebidasModo(false);
    }
  }, [id]);
  useEffect(() => {
    if (!formatoNuevo || !firmaBebidasModo) return undefined;
    const t = setTimeout(() => { cargarBebidasModo(); }, 300);
    return () => clearTimeout(t);
  }, [formatoNuevo, firmaBebidasModo, cargarBebidasModo]);

  // Barra libre del lunch (formato nuevo): chip en la línea del lunch que crea
  // o borra la línea "Barra libre lunch" vinculada. Se relee con la misma firma
  // que el modo de bebidas (menús y personas) y tras cada cambio.
  const [estadoBarraLibre, setEstadoBarraLibre] = useState(null);
  const [guardandoBarraLibre, setGuardandoBarraLibre] = useState(null);
  const [errorBarraLibre, setErrorBarraLibre] = useState(null);
  const cargarBarraLibre = useCallback(async () => {
    if (!id) return;
    try {
      const { data } = await presupuestosAPI.getBarraLibreLunch(id);
      setEstadoBarraLibre(data && Array.isArray(data.lineas) ? data : null);
    } catch (error) {
      setEstadoBarraLibre(null);
    }
  }, [id]);
  useEffect(() => {
    if (!formatoNuevo || !firmaBebidasModo) return undefined;
    const t = setTimeout(() => { cargarBarraLibre(); }, 300);
    return () => clearTimeout(t);
  }, [formatoNuevo, firmaBebidasModo, cargarBarraLibre]);

  // Alquiler de material (formato nuevo): líneas, validación y orden al
  // proveedor. Lo usan la pestaña Material y "Por hacer". Una llamada al abrir
  // la ficha; la pestaña lo actualiza al cambiar algo.
  const [estadoAlquiler, setEstadoAlquiler] = useState(null);
  // Multievento (D10): ámbito del panel de alquiler. null = todo el evento
  // (alquiler de la cabecera, se cobra una vez); un id = el de esa jornada
  const [alquilerJornadaId, setAlquilerJornadaId] = useState(null);
  const firmaAlquiler= presupuesto ? JSON.stringify([
    presupuesto.id,
    (presupuesto.materiales_alquiler || []).length,
    presupuesto.fecha_evento || null,
  ]) : '';
  const cargarAlquiler = useCallback(async () => {
    if (!id) return;
    try {
      const { data } = await presupuestosAPI.getAlquiler(id);
      setEstadoAlquiler(data && Array.isArray(data.lineas) ? data : null);
    } catch (error) {
      setEstadoAlquiler(null);
    }
  }, [id]);
  useEffect(() => {
    if (!formatoNuevo || !firmaAlquiler) return undefined;
    const t = setTimeout(() => { cargarAlquiler(); }, 300);
    return () => clearTimeout(t);
  }, [formatoNuevo, firmaAlquiler, cargarAlquiler]);

  // Envío al cliente (formato nuevo): si lo comercial cambió después del
  // último envío ("Modificado tras el envío"). Se relee al guardar (rev /
  // updated_at) y tras un envío (registros_envios).
  const [estadoEnvio, setEstadoEnvio] = useState(null);
  const [cambiosEnvioAbiertos, setCambiosEnvioAbiertos] = useState(false);
  const firmaEnvio = presupuesto ? JSON.stringify([
    presupuesto.id,
    presupuesto.rev ?? null,
    presupuesto.updated_at || null,
    (presupuesto.registros_envios || []).length,
  ]) : '';
  const cargarEstadoEnvio = useCallback(async () => {
    if (!id) return;
    try {
      const { data } = await presupuestosAPI.getEstadoEnvio(id);
      setEstadoEnvio(data || null);
    } catch (error) {
      setEstadoEnvio(null);
    }
  }, [id]);
  useEffect(() => {
    if (!formatoNuevo || !firmaEnvio) return undefined;
    const t = setTimeout(() => { cargarEstadoEnvio(); }, 300);
    return () => clearTimeout(t);
  }, [formatoNuevo, firmaEnvio, cargarEstadoEnvio]);

  // Cobro previo (formato nuevo): 100 % siete días antes del evento salvo
  // clientes con pago aplazado. Tarea de Por hacer, chip de la cabecera y modal
  // "Pedir pago".
  const [cobroPrevio, setCobroPrevio] = useState(null);
  const [modalCobroPrevio, setModalCobroPrevio] = useState(null);
  const [enviandoCobroPrevio, setEnviandoCobroPrevio] = useState(false);
  const firmaCobroPrevio = presupuesto ? JSON.stringify([
    presupuesto.id,
    presupuesto.rev ?? null,
    presupuesto.updated_at || null,
    presupuesto.estado || null,
    presupuesto.estado_pago || null,
    presupuesto.total_pagado ?? null,
    presupuesto.importe_total ?? null,
    presupuesto.fecha_evento || null,
    presupuesto.cliente_id || null,
  ]) : '';
  // Multievento: la referencia de cobro es el total a cobrar del servidor
  // (GET cobro-previo, cobros_total): mientras quede una jornada sin factura,
  // el total del evento. "Cobrado" solo si lo pagado lo cubre, aunque el
  // estado guardado diga pagado. null en un evento de un día o sin datos.
  const cobroMultievento = () => {
    if (!presupuesto?.es_multi_evento || !cobroPrevio || typeof cobroPrevio.importe_total !== 'number') return null;
    const total = Number(cobroPrevio.importe_total) || 0;
    const pagado = Math.max(0, Number(cobroPrevio.pagado) || 0);
    const pendiente = Math.max(0, Number(cobroPrevio.pendiente) || 0);
    return { total, pagado, pendiente, cobrado: total > 0.01 && pendiente <= 0.01 };
  };
  const cargarCobroPrevio = useCallback(async () => {
    if (!id) return;
    try {
      const { data } = await presupuestosAPI.getCobroPrevio(id);
      setCobroPrevio(data && data.motivo ? data : null);
    } catch (error) {
      setCobroPrevio(null);
    }
  }, [id]);
  useEffect(() => {
    if (!formatoNuevo || !firmaCobroPrevio) return undefined;
    const t = setTimeout(() => { cargarCobroPrevio(); }, 300);
    return () => clearTimeout(t);
  }, [formatoNuevo, firmaCobroPrevio, cargarCobroPrevio]);

  // Reglas comerciales (suplemento mínimo, transporte por zonas, camareros en
  // cóctel, requisitos del formato). Los números vienen del backend.
  const [reglasComerciales, setReglasComerciales] = useState(null);
  const [estadoReglas, setEstadoReglas] = useState(null);
  // F1 (16-oct-2026): solo quien tiene el módulo de presupuestos cambia las
  // horas de los servicios, su tipo y "Acompaña a"; el resto las ve
  const puedeEditarHorarios = usePuedeEditarHorarios();
  // M1: aviso de servicios sin hora antes de confirmar y de la orden de cocina nueva
  const { revisarHorarios, dialogoHorarios } = useAvisoHorarios();
  // Sube cuando una hora de servicio ya está guardada: vuelve a pedir las reglas
  // (horarios) y Quién va (tramos) con ella; el cambio en la ficha llega antes
  // que el guardado con retardo y la primera petición podría leer la anterior
  const [recargaHorarios, setRecargaHorarios] = useState(0);
  // Hora por servicio (formato nuevo): "Proponer horas" en curso
  const [proponiendoHoras, setProponiendoHoras] = useState(false);
  // Solape de montaje: clave de la decisión que se está guardando
  const [decidiendoSolape, setDecidiendoSolape] = useState(null);
  const [accionReglaEnCurso, setAccionReglaEnCurso] = useState(null);
  const [avisoSuplementoMinimo, setAvisoSuplementoMinimo] = useState(null);
  const [avisoTransporte, setAvisoTransporte] = useState(null); // { tipo: 'ok' | 'error', texto }

  // Cancelación del evento (modal con motivo)
  const [showCancelarModal, setShowCancelarModal] = useState(false);
  const [cancelacionForm, setCancelacionForm] = useState({ motivo: '', comentario: '', importe_facturado_cancelacion: '' });
  const [cancelando, setCancelando] = useState(false);
  const [errorCancelacion, setErrorCancelacion] = useState(null);
  // Lo que hará cancelar (solo lectura): pedidos pendientes con su casilla de
  // "Enviar anulación al proveedor" (marcada por defecto) y si deshace la confirmación
  const [infoCancelacion, setInfoCancelacion] = useState(null);
  const [cargandoInfoCancelacion, setCargandoInfoCancelacion] = useState(false);
  const [pedidosCancelacion, setPedidosCancelacion] = useState([]);
  // Confirmar en curso: el botón no se puede pulsar dos veces
  const [confirmando, setConfirmando] = useState(false);
  // Aviso del servidor al guardar un confirmado con fecha, personas o líneas cambiadas
  const [avisoConfirmadoModificado, setAvisoConfirmadoModificado] = useState(null);
  // Libro único (B5, lote 5b): el servidor ha rehecho stock, lotes y material
  // del confirmado modificado ({salidas, reservas, material})
  const [stockRehecho, setStockRehecho] = useState(null);
  // Añadir o quitar un plato de una línea (U-30): en un confirmado futuro el
  // servidor devuelve el mismo aviso que el guardado de la ficha
  const avisoTrasCambioPlato = (respuesta) => {
    const aviso = respuesta?.data?.aviso_confirmado_modificado;
    if (aviso) setAvisoConfirmadoModificado(aviso);
    const rehecho = respuesta?.data?.stock_rehecho;
    if (rehecho && !rehecho.error) setStockRehecho(rehecho);
  };

  // Estados para cambiar cliente
  const [showCambiarClienteModal, setShowCambiarClienteModal] = useState(false);
  const [todosClientes, setTodosClientes] = useState([]);
  const [clienteSearchQuery, setClienteSearchQuery] = useState('');
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  
  // Estados para menú personalizado
  const [showCustomMenuModal, setShowCustomMenuModal] = useState(false);
  const [customMenuName, setCustomMenuName] = useState('');
  const [customMenuPrecio, setCustomMenuPrecio] = useState(''); // Precio opcional (permite 0 para placeholder)
  const [customMenuIva, setCustomMenuIva] = useState('10'); // IVA del menú: 10% catering / 21% (p. ej. si incluye transporte)
  const [customMenuBebidaIncluida, setCustomMenuBebidaIncluida] = useState(false);
  const [customMenuBebidasPorPersona, setCustomMenuBebidasPorPersona] = useState(1);
  const [selectedPlatos, setSelectedPlatos] = useState([]); // Array de {platoId, cantidad}
  const [platoFilters, setPlatoFilters] = useState({
    searchText: '',
    precioMax: '',
    alergenosEvitar: [],
    incluirTrazas: false,  // NUEVO: Si debe filtrar también por trazas de alérgenos
    categoria: '',
    tiempoMax: '',
    contiene_carne: false,
    derivado_animal: false,
    contiene_cerdo: false,
    no_apto_embarazadas: false,
    sin_lactosa: false
  });
  const [customMenuPersonas, setCustomMenuPersonas] = useState('');

  // Estados para modal de selección de jornada (multi-evento)
  const [showJornadaSelector, setShowJornadaSelector] = useState(false);
  const [jornadaPendingAction, setJornadaPendingAction] = useState(null); // 'orden' | 'orden_nueva' | 'material' | 'minuta'
  // Modal de la orden de cocina (nueva): esta orden o varias en un solo PDF
  const [showOrdenNuevaModal, setShowOrdenNuevaModal] = useState(false);

  // Estados para modal de minuta
  const [showMinutaModal, setShowMinutaModal] = useState(false);
  const [minutaPreviewHtml, setMinutaPreviewHtml] = useState('');
  const [loadingPreview, setLoadingPreview] = useState(false);
  // Multievento: jornada de la minuta (su fecha y sus líneas)
  const [minutaJornadaId, setMinutaJornadaId] = useState(null);
  const [minutaConfig, setMinutaConfig] = useState({
    menusSeleccionados: [], // Array de menu_ids
    platosOcultos: {}, // {menu_id: [plato_ids]}
    ordenPlatos: {}, // {menu_id: [plato_ids_ordenados]}
    mostrarIngles: false // Toggle para mostrar traducción al inglés
  });

  // Estados para FASE 2: Edición de detalles de menú
  const [editingMenuIndex, setEditingMenuIndex] = useState(null);
  const [editedMenuDetails, setEditedMenuDetails] = useState({});
  const [editingPriceMenuIndex, setEditingPriceMenuIndex] = useState(null);
  const [tempPrecio, setTempPrecio] = useState(0);
  const [editingUnidadesMenuIndex, setEditingUnidadesMenuIndex] = useState(null);
  const [tempUnidades, setTempUnidades] = useState(0);
  const [editingIvaMenuIndex, setEditingIvaMenuIndex] = useState(null);
  const [tempIva, setTempIva] = useState(10);

  // Alias comercial por línea (concepto_cliente): solo afecta a los PDF de
  // presupuesto/factura/proforma. { tipo: 'menu' | 'suplemento', index } | null
  const [editandoConceptoCliente, setEditandoConceptoCliente] = useState(null);
  const [tempConceptoCliente, setTempConceptoCliente] = useState('');
  const [tempMostrarPlatos, setTempMostrarPlatos] = useState(false);
  // Unidades que ve el cliente en un menú con alias: 'reales' (las de la línea),
  // 'manual' (tempUdsCliente) o 'una' (1 ud x total, el disfraz)
  const [tempModoUds, setTempModoUds] = useState('reales');
  const [tempUdsCliente, setTempUdsCliente] = useState('');
  const [guardandoConceptoCliente, setGuardandoConceptoCliente] = useState(false);

  // Estados para gestión de personas de contacto
  const [personasContacto, setPersonasContacto] = useState([]);
  const [showNewContactoModal, setShowNewContactoModal] = useState(false);
  const [newContacto, setNewContacto] = useState({
    nombre: '',
    cargo: '',
    email: '',
    telefono: '',
    telefono_prefijo: '',
    extension: '',
    notas: ''
  });

  // Estados para gestión de pagos (legacy; la tarjeta fue retirada del detalle)
  const [showNewPagoModal, setShowNewPagoModal] = useState(false);
  const [tipoPagoModal, setTipoPagoModal] = useState(null); // 'efectivo' | 'vincular'
  
  // Estados para vincular ingresos bancarios
  const [buscandoIngresos, setBuscandoIngresos] = useState(false);
  const [ingresosDisponibles, setIngresosDisponibles] = useState([]);
  const [busquedaIngreso, setBusquedaIngreso] = useState('');
  const [vinculandoIngreso, setVinculandoIngreso] = useState(false);

  // Estados para depósitos del cliente
  const [depositosCliente, setDepositosCliente] = useState(null);
  const [aplicandoDeposito, setAplicandoDeposito] = useState(false);

  // Estados para descuentos
  const [showDescuentoModal, setShowDescuentoModal] = useState(false);
  const [descuentoMenuIndex, setDescuentoMenuIndex] = useState(null);
  const [descuentoData, setDescuentoData] = useState({
    tipo: 'porcentaje', // 'porcentaje' o 'fijo'
    valor: 0
  });

  // Estados para añadir platos rápido
  const [showAddPlatoModal, setShowAddPlatoModal] = useState(false);
  const [addPlatoMenuIndex, setAddPlatoMenuIndex] = useState(null);
  const [addPlatoSearch, setAddPlatoSearch] = useState('');
  const [addPlatoCantidad, setAddPlatoCantidad] = useState(1);
  const [addPlatoFilters, setAddPlatoFilters] = useState({
    showFilters: false,
    alergenosEvitar: [],
    incluirTrazas: false,  // NUEVO: Si debe filtrar también por trazas de alérgenos
    precioMin: '',
    precioMax: ''
  });

  // Estados para autocompletado inline
  const [inlineAddPlatoSearch, setInlineAddPlatoSearch] = useState({});
  const [inlineAddPlatoCantidad, setInlineAddPlatoCantidad] = useState({});
  const [showInlineSuggestions, setShowInlineSuggestions] = useState({});

  // Close inline suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.inline-autocomplete')) {
        setShowInlineSuggestions({});
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Estados para edición de platos de menú
  const [showEditPlatosModal, setShowEditPlatosModal] = useState(false);
  const [editPlatosMenuIndex, setEditPlatosMenuIndex] = useState(null);
  const [editedPlatos, setEditedPlatos] = useState([]); // Array de {platoId, unidades}
  const [platoSearchTerm, setPlatoSearchTerm] = useState('');
  const [platoFiltersEdit, setPlatoFiltersEdit] = useState({
    precioMax: '',
    categoria: '',
    sinAlergenos: []
  });
  
  // Estados para modal de configuración de menú (FASE 2)
  const [showConfigMenuModal, setShowConfigMenuModal] = useState(false);
  const [configMenuIndex, setConfigMenuIndex] = useState(null);
  const [configMenuTab, setConfigMenuTab] = useState('personal'); // 'personal' o 'tiempos'
  const [configMenuData, setConfigMenuData] = useState({
    // Personal
    ratio_camareros: 20,
    ratio_extras: 100,
    horas_por_camarero: 4,
    coste_camarero_hora: 25,
    // Tiempos
    tiempo_montaje_min: 60,
    duracion_evento_min: 120,
    tiempo_desmontaje_min: 60,
    instrucciones_montaje: '',
    // Material (para futura expansión)
    material_fijo: [],
    material_por_persona: [],
    textiles: []
  });

  // Estados para modal de envío de presupuesto
  const [showPresupuestoModal, setShowPresupuestoModal] = useState(false);
  const [accionPresupuesto, setAccionPresupuesto] = useState('descargar'); // 'descargar' o 'enviar'
  const [emailOrigen, setEmailOrigen] = useState('administracion@duettocatering.com');
  const [contactoDestinoId, setContactoDestinoId] = useState('');
  const [asuntoEmail, setAsuntoEmail] = useState('Presupuesto Duetto Catering');
  const [mensajeEmail, setMensajeEmail] = useState(`Estimado/a cliente,

Adjunto encontrará el presupuesto solicitado para su evento. 

Si tiene alguna duda o necesita realizar alguna modificación, no dude en contactarnos.

Quedamos a su disposición.`);
  
  // Plantillas de firma para emails
  const [firmaSeleccionada, setFirmaSeleccionada] = useState('alfonso');
  const firmasEmail = {
    alfonso: {
      nombre: 'Alfonso Palomares',
      imagen: `${process.env.REACT_APP_BACKEND_URL}/api/firmas/firma_alfonso.png`,
      textoLegal: `Este mensaje es privado y CONFIDENCIAL y se dirige exclusivamente a su destinatario. Si usted ha recibido este mensaje por error, no debe revelar, copiar, distribuir o usarlo en ningún sentido. Le rogamos lo comunique al remitente y borre dicho mensaje y cualquier documento adjunto que pudiera contener. El correo electrónico vía Internet no permite asegurar la confidencialidad de los mensajes que se transmiten ni su integridad o correcta recepción. DUETTO CATERING no asume responsabilidad por estas circunstancias. Si el destinatario de este mensaje no consintiera la utilización del correo electrónico vía Internet y la grabación de los mensajes, rogamos lo ponga en nuestro conocimiento de forma inmediata. Cualquier opinión expresada en este mensaje pertenece únicamente al autor remitente, y no representa necesariamente la opinión de DUETTO CATERING, a no ser que expresamente se diga y el remitente esté autorizado para hacerlo.`
    },
    administracion: {
      nombre: 'Administración',
      imagen: `${process.env.REACT_APP_BACKEND_URL}/api/firmas/firma_administracion.png`,
      textoLegal: `Este mensaje es privado y CONFIDENCIAL y se dirige exclusivamente a su destinatario. Si usted ha recibido este mensaje por error, no debe revelar, copiar, distribuir o usarlo en ningún sentido. Le rogamos lo comunique al remitente y borre dicho mensaje y cualquier documento adjunto que pudiera contener. El correo electrónico vía Internet no permite asegurar la confidencialidad de los mensajes que se transmiten ni su integridad o correcta recepción. DUETTO CATERING no asume responsabilidad por estas circunstancias. Si el destinatario de este mensaje no consintiera la utilización del correo electrónico vía Internet y la grabación de los mensajes, rogamos lo ponga en nuestro conocimiento de forma inmediata. Cualquier opinión expresada en este mensaje pertenece únicamente al autor remitente, y no representa necesariamente la opinión de DUETTO CATERING, a no ser que expresamente se diga y el remitente esté autorizado para hacerlo.`
    },
    ninguna: {
      nombre: 'Sin firma',
      imagen: null,
      textoLegal: ''
    }
  };
  
  // Estados para modal de factura
  const [showFacturaModal, setShowFacturaModal] = useState(false);
  // Al abrir el modal de factura, la novedad del nº de pedido del cliente
  // puede salir (no hay cambio de ruta que la despierte). Va DESPUÉS del
  // useState: antes rompía la ficha entera (TDZ, "Cannot access before initialization").
  useEffect(() => {
    if (showFacturaModal) revisarNovedades();
  }, [showFacturaModal]);
  const [searchParams, setSearchParams] = useSearchParams();
  const openFacturaParam = searchParams.get('openFactura');
  // Formato nuevo: pestaña activa guardada en la URL (?pestana=) para poder
  // enlazarla; las antiguas u ocultas van a la que las sustituye (ALIAS_PESTANAS)
  const pestanaUrl = ALIAS_PESTANAS[searchParams.get('pestana')] || searchParams.get('pestana');
  // Sin ?pestana= en el enlace: la última usada (si es reciente) o Resumen.
  // Se lee una vez al abrir la ficha (y al pasar a otra), no en cada render.
  const ultimaPestanaAlAbrir = useMemo(() => leerUltimaPestana(), [id]); // eslint-disable-line react-hooks/exhaustive-deps
  const pestanaActiva = PESTANAS_VISIBLES.some(p => p.clave === pestanaUrl)
    ? pestanaUrl
    : (ultimaPestanaAlAbrir || 'resumen');
  // Nivel de Logística pedido (?nivel=lugar|horario|quien): lo abre la pestaña y
  // lo quita de la URL (después se navega con sus propias subpestañas)
  const nivelLogisticaUrl = NIVELES_LOGISTICA.includes(searchParams.get('nivel')) ? searchParams.get('nivel') : null;
  const setPestanaActiva = useCallback((clave, nivel = null) => {
    guardarUltimaPestana(ALIAS_PESTANAS[clave] || clave);
    setSearchParams((prev) => {
      const siguiente = new URLSearchParams(prev);
      siguiente.set('pestana', ALIAS_PESTANAS[clave] || clave);
      if (nivel) siguiente.set('nivel', nivel);
      else siguiente.delete('nivel');
      return siguiente;
    }, { replace: true });
  }, [setSearchParams]);

  // ===== Móvil (< 768 px) con el formato nuevo =====
  // Solo cambia la presentación: los datos, los guardados y las reglas son los
  // mismos que en el escritorio (que no cambia nada).
  const esMovil = useEsMovil();
  const movilFicha = esMovil && formatoNuevo;
  // Hoja inferior abierta: null | 'mas' | 'documentos' | 'datos' | 'anadir' |
  // { tipo: 'linea' | 'opciones-linea' | 'suplemento' | 'documento-factura', clave }
  const [hojaMovil, setHojaMovil] = useState(null);
  const cerrarHojaMovil = useCallback(() => setHojaMovil(null), []);
  // Barra de pestañas del móvil: la activa se centra al cambiar
  const pestanasMovilRef = useRef(null);
  useEffect(() => {
    if (!movilFicha) return;
    const barra = pestanasMovilRef.current;
    const activa = barra && barra.querySelector('[aria-selected="true"]');
    if (!activa || typeof barra.scrollTo !== 'function') return;
    barra.scrollTo({ left: Math.max(0, activa.offsetLeft - (barra.clientWidth - activa.offsetWidth) / 2), behavior: 'smooth' });
  }, [movilFicha, pestanaActiva]);
  // Guardar varios campos de una línea desde la hoja del móvil: cada campo se
  // guarda con la función de siempre (edición en línea) ya con el estado del
  // render siguiente, para que un guardado no pise al anterior
  const manejadoresLineaMovilRef = useRef({});
  const resolverRenderMovilRef = useRef([]);
  const [, setTicMovil] = useState(0);
  useEffect(() => {
    if (resolverRenderMovilRef.current.length === 0) return;
    const pendientes = resolverRenderMovilRef.current;
    resolverRenderMovilRef.current = [];
    pendientes.forEach(resolver => resolver());
  });
  const esperarRenderMovil = useCallback(() => new Promise((resolver) => {
    resolverRenderMovilRef.current.push(resolver);
    setTicMovil(n => n + 1);
  }), []);

  // Pestaña Material: panel de alquiler desplegado (encima del material). Se
  // abre al pulsar el botón del resumen, con ?abrir=alquiler o desde Por hacer.
  const [alquilerAbierto, setAlquilerAbierto] = useState(() => searchParams.get('abrir') === 'alquiler');
  const panelAlquilerRef = useRef(null);
  const abrirPanelAlquiler = useCallback(() => {
    setPestanaActiva('material');
    setAlquilerAbierto(true);
    setTimeout(() => {
      if (panelAlquilerRef.current && panelAlquilerRef.current.scrollIntoView) {
        panelAlquilerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 50);
  }, [setPestanaActiva]);
  const limpiarNivelLogistica = useCallback(() => {
    setSearchParams((prev) => {
      if (!prev.get('nivel')) return prev;
      const siguiente = new URLSearchParams(prev);
      siguiente.delete('nivel');
      return siguiente;
    }, { replace: true });
  }, [setSearchParams]);
  const [showEditClienteModal, setShowEditClienteModal] = useState(false);
  const [clienteEditData, setClienteEditData] = useState({});
  const [accionFactura, setAccionFactura] = useState('descargar'); // 'descargar' o 'enviar'
  const [tipoFactura, setTipoFactura] = useState('F1'); // F1, PROFORMA, R1-R5
  // Rectificativa: 'total' anula la factura vigente; 'parcial' descuenta un importe concreto
  const [modoRectificativa, setModoRectificativa] = useState('total');
  // Rectificativa total: además de anular, emitir ya la factura nueva con los
  // datos de hoy (anulacion_total). Por defecto solo anula (pendiente de facturar)
  const [anularYReemitir, setAnularYReemitir] = useState(false);
  const [importeRectificar, setImporteRectificar] = useState('');
  const [ivaRectificar, setIvaRectificar] = useState('10'); // '10', '21' o 'prop' (proporcional a la factura)
  const [ivaIncluidoRectificar, setIvaIncluidoRectificar] = useState(true);
  const [conceptoRectificar, setConceptoRectificar] = useState('');
  // Factura concreta a rectificar (la de una jornada, desde Documentos
  // emitidos). Sin ella, la vigente del presupuesto.
  const [facturaRectificarSel, setFacturaRectificarSel] = useState(null);
  const [fechaEmisionFactura, setFechaEmisionFactura] = useState(() => hoyMadrid());
  const [observacionesFactura, setObservacionesFactura] = useState('');
  const [conceptoUnicoFactura, setConceptoUnicoFactura] = useState(''); // Concepto único para consolidar menús
  // FACe (facturación a administración pública): destino DIR3 + referencias
  const [faceDestinoId, setFaceDestinoId] = useState('');
  const [faceNumPedido, setFaceNumPedido] = useState('');
  const [faceNumExpediente, setFaceNumExpediente] = useState('');
  const [faceNumContrato, setFaceNumContrato] = useState('');
  const [faceObservaciones, setFaceObservaciones] = useState('');
  const [modoFactura, setModoFactura] = useState('normal'); // 'normal' | 'face' (solo relevante si cliente es admin pública)
  const [facePreview, setFacePreview] = useState(null); // {resumen, xml} para la vista previa
  const [facePreviewLoading, setFacePreviewLoading] = useState(false);
  const [faceFirmaLoading, setFaceFirmaLoading] = useState(false);
  const [faceEnviarLoading, setFaceEnviarLoading] = useState(false);
  // Al abrir el modal de factura, si el cliente es administración pública, preselecciona el primer destino DIR3
  useEffect(() => {
    if (showFacturaModal && cliente?.es_administracion_publica) {
      // Por defecto, para administración pública se factura por FACe
      setModoFactura((m) => (m === 'normal' ? 'face' : m));
      if ((cliente.face_destinos || []).length && !faceDestinoId) {
        // Preseleccionar el destino que YA tiene la factura existente (si lo hay y
        // sigue existiendo en el cliente); si no, el primero. Así, regenerar sin
        // tocar el desplegable no cambia el destino por accidente.
        const idFactura = facturaNormalExistente?.face_destino_id;
        const existeEnCliente = (cliente.face_destinos || []).some((d) => d.id === idFactura);
        setFaceDestinoId(existeEnCliente ? idFactura : cliente.face_destinos[0].id);
      }
    } else if (showFacturaModal) {
      setModoFactura('normal');
    }
    // Al cerrar el modal por cualquier vía, olvidar la jornada seleccionada
    // para que la próxima apertura normal no herede el modo por-jornada.
    if (!showFacturaModal) {
      setJornadaFacturaSel(null);
      setDocumentoEnvioSel(null);
    }
  }, [showFacturaModal, cliente]); // eslint-disable-line react-hooks/exhaustive-deps
  const verFacePreview = async (facturaId) => {
    if (!facturaId) return;
    setFacePreviewLoading(true);
    try {
      const { data } = await api.get(`/face/facturas/${facturaId}/preview`);
      setFacePreview(data);
    } catch (e) {
      alert('No se pudo generar la vista previa FACe');
    }
    setFacePreviewLoading(false);
  };
  // Vista previa ANTES de generar: construye el borrador desde el presupuesto + datos FACe del modal
  const verFacePreviewBorrador = async () => {
    setFacePreviewLoading(true);
    try {
      const { data } = await api.post(`/face/presupuestos/${id}/preview-facturae`, {
        fecha_emision: fechaEmisionFactura,
        fecha_operacion: null,
        face_destino_id: faceDestinoId || null,
        face_numero_pedido: faceNumPedido || null,
        face_numero_expediente: faceNumExpediente || null,
        face_numero_contrato: faceNumContrato || null,
        face_observaciones: faceObservaciones || null,
        // Factura de una jornada (multievento por jornada): sus líneas, no las del evento
        jornada_id: jornadaFacturaSel?.id || null,
      });
      setFacePreview(data);
    } catch (e) {
      alert('No se pudo generar la vista previa FACe');
    }
    setFacePreviewLoading(false);
  };
  // Carga autoscript.js (cliente @firma) una sola vez
  const cargarAutoScript = () => new Promise((resolve, reject) => {
    if (window.AutoScript) return resolve();
    const s = document.createElement('script');
    s.src = '/autoscript.js';
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('No se pudo cargar autoscript.js'));
    document.body.appendChild(s);
  });
  // Firma la factura con AutoFirma (escritorio): obtiene el XML, lo firma (FacturaE) y lo guarda
  const firmarConAutoFirma = async (facturaId) => {
    if (!facturaId) return;
    setFaceFirmaLoading(true);
    try {
      await cargarAutoScript();
      window.AutoScript.cargarAppAfirma();
      const { data } = await api.get(`/face/facturas/${facturaId}/preview`);
      const xmlB64 = data.xml_b64;
      window.AutoScript.sign(
        xmlB64,
        'SHA256withRSA',
        'FacturaE',
        '',
        async (firmaB64 /*, certB64 */) => {
          try {
            await api.post(`/face/facturas/${facturaId}/firma`, { xml_firmado_b64: firmaB64 });
            verificarFacturaExistente();  // refrescar para que aparezca el estado "Firmada"
            alert('Factura firmada correctamente con AutoFirma. Queda lista para enviar a FACe.');
          } catch (e) {
            alert('La factura se firmó pero no se pudo guardar: ' + (e.response?.data?.detail || e.message));
          }
          setFaceFirmaLoading(false);
        },
        (errorType, errorMessage) => {
          setFaceFirmaLoading(false);
          if (!/cancel/i.test(errorMessage || '') && !/cancel/i.test(errorType || '')) {
            alert('Error al firmar con AutoFirma: ' + (errorMessage || errorType));
          }
        }
      );
    } catch (e) {
      setFaceFirmaLoading(false);
      alert('No se pudo iniciar AutoFirma: ' + e.message + '. Asegúrate de tener AutoFirma instalado.');
    }
  };
  // Enviar la factura firmada a FACe (Fase 3)
  const enviarAFace = async (facturaId) => {
    if (!window.confirm('¿Enviar esta factura a FACe? Quedará registrada oficialmente en la administración.')) return;
    setFaceEnviarLoading(true);
    try {
      const { data } = await api.post(`/face/facturas/${facturaId}/enviar`);
      verificarFacturaExistente();
      alert(`Factura enviada a FACe.\nNº de registro: ${data.numero_registro || '(consulta el estado)'}\nEstado: ${data.estado}`);
    } catch (e) {
      alert('Error al enviar a FACe: ' + (e.response?.data?.detail || e.message));
    }
    setFaceEnviarLoading(false);
  };
  const actualizarEstadoFace = async (facturaId) => {
    setFaceEnviarLoading(true);
    try {
      // POST: guarda el estado en la factura (el GET ya no escribe, U-04)
      const { data } = await api.post(`/face/facturas/${facturaId}/consultar-estado`);
      verificarFacturaExistente();
      alert('Estado actual en FACe: ' + (data.estado || '(desconocido)'));
    } catch (e) {
      alert('No se pudo consultar el estado: ' + (e.response?.data?.detail || e.message));
    }
    setFaceEnviarLoading(false);
  };
  // Descargar el .xsig firmado (para subirlo a mano al portal de FACe)
  const descargarXsig = (facturaId, numeroFactura) => {
    const token = getAuthToken();
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/face/facturas/${facturaId}/xsig`, true);
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (xhr.status === 200) {
        const url = window.URL.createObjectURL(new Blob([xhr.response], { type: 'application/octet-stream' }));
        const a = document.createElement('a');
        a.href = url;
        a.download = `${numeroFactura || 'factura'}.xsig`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        alert('No se pudo descargar el .xsig (¿está firmada la factura?)');
      }
    };
    xhr.onerror = () => alert('Error al descargar el .xsig');
    xhr.send();
  };
  const [ocultarDatosPago, setOcultarDatosPago] = useState(false); // Si true, el PDF se genera sin la sección de datos bancarios
  const [invitarResenaGoogle, setInvitarResenaGoogle] = useState(false); // Si true, el email incluye CTA a reseña Google al final
  const [facturaGenerada, setFacturaGenerada] = useState(null); // Datos de la factura generada (legacy compat)
  // Tracking independiente de cada tipo de factura
  const [proformaExistente, setProformaExistente] = useState(null);
  const [facturaNormalExistente, setFacturaNormalExistente] = useState(null);
  const [rectificativasExistentes, setRectificativasExistentes] = useState([]);
  const [anuladasExistentes, setAnuladasExistentes] = useState([]);
  // Facturas a terceros: parte del servicio que paga otra empresa (convive con la principal)
  const [tercerosExistentes, setTercerosExistentes] = useState([]);
  // Multievento por jornada: facturas de cada jornada (null = sin cargar)
  const [facturasJornadaExistentes, setFacturasJornadaExistentes] = useState(null);
  const [showFacturarTercero, setShowFacturarTercero] = useState(false);
  // Formato nuevo: apertura preconfigurada del modal de factura desde la tabla
  // de documentos. documentoEnvioSel = documento ya emitido que se descarga o se
  // envía tal cual (sin regenerarlo). aperturaFacturaRef guarda qué preparar
  // cuando el modal termina de cargar las facturas ({ rectificativa, tercero,
  // documento, enfocar }). Si no se usan (null), el modal funciona como siempre.
  const [documentoEnvioSel, setDocumentoEnvioSel] = useState(null);
  const aperturaFacturaRef = useRef(null);
  // Formato nuevo: documentos emitidos para la tabla de la pestaña Facturación.
  // Estado propio (no el del modal) para no tocar lo que el modal prepara al abrirse.
  const [documentosFacturacion, setDocumentosFacturacion] = useState(null);
  const [subiendoA3docId, setSubiendoA3docId] = useState(null);
  const cargarDocumentosFacturacion = useCallback(async () => {
    try {
      const { data } = await api.get(`/presupuestos/${id}/facturas`);
      setDocumentosFacturacion(data || {});
    } catch (e) {
      setDocumentosFacturacion({ error: true });
    }
  }, [id]);
  // Se recarga al entrar en la pestaña y cada vez que se cierra el modal de factura
  useEffect(() => {
    if (!formatoNuevo || pestanaActiva !== 'facturacion' || showFacturaModal) return;
    cargarDocumentosFacturacion();
  }, [formatoNuevo, pestanaActiva, showFacturaModal, cargarDocumentosFacturacion]);

  // Multievento: lo que factura cada jornada (antes de emitir, el total previsto
  // de su factura con sus suplementos y, en la primera, los del evento y el
  // alquiler; después, la factura real y si está cobrada) y si el modo de
  // facturación ya no se cambia. No se usa `jornadas[].total`: no los lleva.
  const [datosFacturacionJornadas, setDatosFacturacionJornadas] = useState(null);
  const claveFacturacionJornadas = presupuesto?.es_multi_evento
    ? [presupuesto.facturacion_multi_evento || 'consolidada', presupuesto.importe_total,
      ...(presupuesto.jornadas || []).map(j => `${j?.id}:${j?.num_personas}:${j?.factura_id || ''}`)].join('|')
    : '';
  const cargarFacturacionJornadas = useCallback(async () => {
    try {
      const { data } = await api.get(`/presupuestos/${id}/facturacion-jornadas`);
      setDatosFacturacionJornadas(data || null);
    } catch (e) {
      setDatosFacturacionJornadas(null);
    }
  }, [id]);
  useEffect(() => {
    if (!claveFacturacionJornadas || showFacturaModal) return;
    cargarFacturacionJornadas();
  }, [claveFacturacionJornadas, showFacturaModal, documentosFacturacion, cargarFacturacionJornadas]);
  const facturacionDeJornada = (jornadaId) =>
    (datosFacturacionJornadas?.jornadas || []).find(x => x.jornada_id === jornadaId) || null;

  // Multievento con facturación por jornada: el evento está facturado cuando
  // TODAS las jornadas tienen su factura emitida (un borrador no cuenta).
  // Con las facturas cargadas (pestaña Facturación o modal) se mira su estado;
  // si no, la marca que deja en cada jornada la emisión de su factura.
  const esFacturacionPorJornada = () => !!(presupuesto?.es_multi_evento
    && presupuesto?.facturacion_multi_evento === 'por_jornada'
    && Array.isArray(presupuesto?.jornadas) && presupuesto.jornadas.length > 0);
  const esFacturaJornadaEmitida = (f) => !!f && !['borrador', 'anulada'].includes(String(f.estado || '').toLowerCase());
  const resumenFacturasJornadas = () => {
    const jornadas = (presupuesto?.jornadas || []).filter(j => j && j.id);
    const lista = Array.isArray(documentosFacturacion?.facturas_jornada)
      ? documentosFacturacion.facturas_jornada
      : (Array.isArray(facturasJornadaExistentes) ? facturasJornadaExistentes : null);
    const emitidaDe = (j) => (lista
      ? lista.some(f => f.jornada_id === j.id && esFacturaJornadaEmitida(f))
      : !!(j.numero_factura || j.facturada));
    return { emitidas: jornadas.filter(emitidaDe).length, total: jornadas.length, lista };
  };
  const [terceroClienteId, setTerceroClienteId] = useState('');
  const [terceroBusqueda, setTerceroBusqueda] = useState('');
  const [terceroImporte, setTerceroImporte] = useState('');
  const [terceroIvaIncluido, setTerceroIvaIncluido] = useState(true);
  const [terceroIva, setTerceroIva] = useState('10');
  const [terceroConcepto, setTerceroConcepto] = useState('');
  const [terceroFecha, setTerceroFecha] = useState(() => hoyMadrid());
  const [terceroEnviando, setTerceroEnviando] = useState(false);
  const [ccEmails, setCcEmails] = useState(''); // Emails en copia separados por coma
  // CCO por defecto al enviar facturas: copia oculta interna para archivo.
  const CCO_FACTURA_DEFAULT = 'a.palomares@duettocatering.com, administracion@duettocatering.com';
  const [ccoEmails, setCcoEmails] = useState(''); // Emails en copia oculta separados por coma
  const [enviandoEmail, setEnviandoEmail] = useState(false);
  const [showHistorialEnvios, setShowHistorialEnvios] = useState(false);
  const [showDetalleMenus, setShowDetalleMenus] = useState(false);
  const [menusExpandidos, setMenusExpandidos] = useState({});
  
  // Estados para editar datos de facturación en factura existente
  const [editandoDatosFacturacion, setEditandoDatosFacturacion] = useState(false);
  const [datosFacturacionEdit, setDatosFacturacionEdit] = useState({
    cliente_nombre: '',
    cliente_nif: '',
    cliente_direccion: ''
  });
  const [guardandoDatosFacturacion, setGuardandoDatosFacturacion] = useState(false);


  // Estados para editar campos del evento
  const [editingEventDetails, setEditingEventDetails] = useState(false);
  const [editedFechaEvento, setEditedFechaEvento] = useState('');
  const [editedHoraInicio, setEditedHoraInicio] = useState('');
  const [editedHoraFin, setEditedHoraFin] = useState('');
  const [editedNumPersonas, setEditedNumPersonas] = useState('');

  // Auto-save observaciones y notas para administración con debounce (formato
  // anterior). U-03 (06-oct-2026): al pasar de un presupuesto a otro sin
  // desmontar la página, lo cargado de la ficha nueva NO se guarda (la
  // referencia se reinicia por presupuesto); nunca se guarda lo que ya coincide
  // con el servidor; lo pendiente se guarda en SU presupuesto al salir o cambiar
  // de ficha; va por `api` (interceptores y `rev`) y no por fetch crudo.
  // Estado en un solo objeto (timer, última copia cargada o guardada por
  // presupuesto, guardado pendiente y la función que guarda).
  const observacionesRef = useRef({ timer: null, prev: null, pendiente: null, guardar: null });
  // Último error al generar factura: en modo silencioso no se muestra alert,
  // pero la descarga necesita poder decir POR QUÉ ha fallado.
  const ultimoErrorFacturaRef = useRef(null);

  observacionesRef.current.guardar = async ({ pid, payload, rev }) => {
    const estadoObs = observacionesRef.current;
    notificarGuardado('inicio');
    try {
      const campos = JSON.parse(payload);
      await api.put(`/presupuestos/${pid}`, rev != null ? { ...campos, rev } : campos);
      if (estadoObs.prev && estadoObs.prev.pid === pid) estadoObs.prev = { pid, payload };
      // Lo guardado pasa a ser lo del servidor (solo si sigue siendo esta ficha)
      anotarBaseServidor(null, campos);
      notificarGuardado('fin');
    } catch (e) {
      console.error('Error auto-guardando observaciones:', e);
      notificarGuardado('error');
    }
  };

  const idObservaciones = presupuesto?.id;
  useEffect(() => {
    if (!idObservaciones) return undefined;
    const estadoObs = observacionesRef.current;
    const payload = JSON.stringify({
      observaciones: presupuesto?.observaciones || '',
      notas_administracion: presupuesto?.notas_administracion || ''
    });
    // Primera carga de ESTE presupuesto (también al llegar desde otra ficha
    // sin desmontar): solo se anota, no se guarda
    if (!estadoObs.prev || estadoObs.prev.pid !== idObservaciones) {
      estadoObs.prev = { pid: idObservaciones, payload };
      return undefined;
    }
    // Formato nuevo: lo guarda el autoguardado de la ficha (misma cola)
    if (formatoNuevo) {
      estadoObs.prev = { pid: idObservaciones, payload };
      estadoObs.pendiente = null;
      return undefined;
    }
    // Sin cambios frente a lo último cargado o guardado: nada pendiente
    if (payload === estadoObs.prev.payload) {
      estadoObs.pendiente = null;
      return undefined;
    }
    // Ya coincide con lo que tiene el servidor (p. ej. recarga tras otro guardado)
    const base = baseServidorRef.current;
    if (base && base.id === idObservaciones && payload === JSON.stringify({
      observaciones: base.observaciones || '',
      notas_administracion: base.notas_administracion || ''
    })) {
      estadoObs.prev = { pid: idObservaciones, payload };
      estadoObs.pendiente = null;
      return undefined;
    }
    const { id: idRev, rev } = revFichaRef.current;
    estadoObs.pendiente = { pid: idObservaciones, payload, rev: idRev === idObservaciones ? rev : null };
    estadoObs.timer = setTimeout(() => {
      estadoObs.timer = null;
      const pendiente = estadoObs.pendiente;
      estadoObs.pendiente = null;
      if (pendiente && estadoObs.guardar) estadoObs.guardar(pendiente);
    }, 800);
    return () => {
      if (estadoObs.timer) {
        clearTimeout(estadoObs.timer);
        estadoObs.timer = null;
      }
    };
  }, [presupuesto?.observaciones, presupuesto?.notas_administracion, idObservaciones, formatoNuevo]);

  // Al pasar a otra ficha o salir de la página: lo que quedaba por guardar se
  // guarda ya, en el presupuesto en el que se escribió (id anterior capturado)
  useEffect(() => {
    if (!idObservaciones) return undefined;
    const estadoObs = observacionesRef.current;
    return () => {
      if (estadoObs.timer) {
        clearTimeout(estadoObs.timer);
        estadoObs.timer = null;
      }
      const pendiente = estadoObs.pendiente;
      estadoObs.pendiente = null;
      if (pendiente && pendiente.pid === idObservaciones && estadoObs.guardar) estadoObs.guardar(pendiente);
    };
  }, [idObservaciones]);

  useEffect(() => {
    fetchData();
  }, [id]);

  // Pestaña de correos visible: la antigua (activeTab) o la del formato nuevo
  // (pestanaActiva); en el formato nuevo también el Resumen, que tiene la tarjeta Correos
  const correosVisibles = formatoNuevo ? (pestanaActiva === 'correos' || pestanaActiva === 'resumen' || pestanaActiva === 'alergenos') : activeTab === 'correos';

  // Formato nuevo: el indicador de guardado escucha las llamadas que modifican
  // este presupuesto (PUT/POST/DELETE a /presupuestos/{id}...), sin tocarlas.
  // Se excluyen las que generan o envían documentos y el resumen de correos.
  useEffect(() => {
    if (!formatoNuevo || !id) return undefined;
    const prefijo = `/presupuestos/${id}`;
    const noEsGuardado = /(pdf|enviar|resumen-correos|generar|factura|proforma|preview|orden-cocina|minuta|hoja-)/i;
    const esGuardado = (config) => {
      const metodo = String(config?.method || 'get').toLowerCase();
      if (metodo === 'get') return false;
      const url = String(config?.url || '');
      if (!(url === prefijo || url.startsWith(`${prefijo}/`) || url.startsWith(`${prefijo}?`))) return false;
      return !noEsGuardado.test(url.slice(prefijo.length));
    };
    const idPeticion = api.interceptors.request.use((config) => {
      if (esGuardado(config)) {
        config.indicadorGuardado = true;
        notificarGuardado('inicio');
      }
      return config;
    });
    const idRespuesta = api.interceptors.response.use(
      (response) => {
        if (response?.config?.indicadorGuardado) notificarGuardado('fin');
        return response;
      },
      (error) => {
        if (error?.config?.indicadorGuardado) notificarGuardado('error');
        return Promise.reject(error);
      }
    );
    return () => {
      api.interceptors.request.eject(idPeticion);
      api.interceptors.response.eject(idRespuesta);
    };
  }, [formatoNuevo, id, notificarGuardado]);

  // `rev` del presupuesto cargado (solo sube; se reinicia al
  // cambiar de presupuesto). La del estado local puede ir por detrás de la
  // última respuesta del PUT, por eso se guarda la mayor.
  const revPresupuesto = presupuesto?.rev;
  const idPresupuestoRev = presupuesto?.id;
  useEffect(() => {
    if (!idPresupuestoRev) return;
    const rev = Number(revPresupuesto);
    const actual = revFichaRef.current;
    if (actual.id !== idPresupuestoRev) {
      revFichaRef.current = { id: idPresupuestoRev, rev: Number.isFinite(rev) ? rev : null };
    } else if (Number.isFinite(rev) && (actual.rev == null || rev > actual.rev)) {
      revFichaRef.current = { id: idPresupuestoRev, rev };
    }
  }, [idPresupuestoRev, revPresupuesto]);

  // Los dos formatos: cada PUT de /presupuestos/{id} lleva la `rev` más alta
  // conocida (la del GET o la del último PUT), así un guardado seguido de otro
  // va al día si nadie más ha tocado el presupuesto. Solo el formato nuevo añade
  // `_formato: 'nuevo'` (sin la marca, el servidor protege los campos de
  // servidor) y muestra el aviso de cambios conservados.
  useEffect(() => {
    if (!id) return undefined;
    const ruta = `/presupuestos/${id}`;
    const anotarRev = (valor) => {
      const rev = Number(valor);
      const actual = revFichaRef.current;
      if (Number.isFinite(rev) && (actual.id !== id || actual.rev == null || rev > actual.rev)) {
        revFichaRef.current = { id, rev };
      }
    };
    const idPeticion = api.interceptors.request.use((config) => {
      const metodo = String(config?.method || '').toLowerCase();
      const datos = config?.data;
      if (String(config?.url || '') !== ruta) return config;
      if (metodo === 'get') {
        config.lecturaFicha = true;
      } else if (metodo === 'put' && datos && typeof datos === 'object' && !Array.isArray(datos)) {
        const { id: idRev, rev } = revFichaRef.current;
        config.data = {
          ...datos,
          ...(formatoNuevo ? { _formato: 'nuevo' } : {}),
          ...(idRev === id && rev != null ? { rev } : {}),
        };
        config.guardadoFicha = true;
      }
      return config;
    });
    const idRespuesta = api.interceptors.response.use((response) => {
      const config = response?.config;
      if (config?.lecturaFicha || config?.guardadoFicha) {
        const datos = response.data || {};
        if (!datos.id || datos.id === id) anotarRev(datos.rev);
        // Los dos formatos: evento confirmado con fecha, personas o líneas
        // cambiadas (el stock, los lotes y el material siguen como estaban)
        if (config.guardadoFicha && datos.aviso_confirmado_modificado && (!datos.id || datos.id === id)) {
          setAvisoConfirmadoModificado(datos.aviso_confirmado_modificado);
        }
        // B5 (lote 5b): con el libro único el servidor rehace stock, lotes y material
        if (config.guardadoFicha && datos.stock_rehecho && !datos.stock_rehecho.error
            && (!datos.id || datos.id === id)) {
          setStockRehecho(datos.stock_rehecho);
        }
        if (config.guardadoFicha && Array.isArray(datos.adaptaciones_huerfanas)
            && datos.adaptaciones_huerfanas.length > 0 && (!datos.id || datos.id === id)) {
          if (formatoNuevo) setAvisoHuerfanas(datos.adaptaciones_huerfanas);
          else window.alert(`Alérgenos: ${textoAdaptacionesHuerfanas(datos.adaptaciones_huerfanas)} Revisa la pestaña Alérgenos.`);
        }
        if (formatoNuevo && config.guardadoFicha
            && Array.isArray(datos.campos_conservados) && datos.campos_conservados.length > 0) {
          setAvisoConservados(datos.campos_conservados);
          if (fetchDataRef.current) fetchDataRef.current();
        }
        // U-32 (lote 7): ruta sin calcular, líneas automáticas congeladas y
        // horas de servicio movidas con la hora del evento (U-34): un toast
        // por aviso, una sola vez mientras la ficha esté abierta
        if (config.guardadoFicha && (!datos.id || datos.id === id)) {
          avisosRespuestaGuardado(datos).forEach((aviso) => {
            const clave = `${aviso.clave}:${aviso.texto}`;
            if (avisosMostradosRef.current.has(clave)) return;
            avisosMostradosRef.current.add(clave);
            toast({ title: aviso.titulo, description: aviso.texto });
          });
        }
      }
      return response;
    });
    return () => {
      api.interceptors.request.eject(idPeticion);
      api.interceptors.response.eject(idRespuesta);
    };
  }, [formatoNuevo, id]);

  // El aviso de "confirmado modificado" es de la ficha abierta
  useEffect(() => {
    setAvisoConfirmadoModificado(null);
    setStockRehecho(null);
    setAvisoHuerfanas(null);
    avisosMostradosRef.current = new Set();
  }, [id]);

  // El aviso de cambios conservados se oculta solo
  useEffect(() => {
    if (!avisoConservados) return undefined;
    const t = setTimeout(() => setAvisoConservados(null), 12000);
    return () => clearTimeout(t);
  }, [avisoConservados]);

  // Carga los correos vinculados a este presupuesto cuando se abre la pestaña.
  useEffect(() => {
    if (!correosVisibles || !presupuesto?.id) return;
    let cancelado = false;
    (async () => {
      setCargandoCorreos(true);
      try {
        const resp = await emailsAPI.listar({ presupuesto_id: presupuesto.id, limit: 100 });
        const datos = Array.isArray(resp.data) ? resp.data : (resp.data?.emails || []);
        if (!cancelado) setCorreosEvento(datos);
      } catch (err) {
        console.error('Error cargando correos del evento:', err);
        if (!cancelado) setCorreosEvento([]);
      } finally {
        if (!cancelado) setCargandoCorreos(false);
      }
    })();
    return () => { cancelado = true; };
  }, [correosVisibles, presupuesto?.id, recargaCorreos]);

  // Formato nuevo: buzones a los que tiene acceso el usuario, para la etiqueta
  // de cada correo y el filtro por buzón de la pestaña Correos.
  useEffect(() => {
    if (!formatoNuevo || !correosVisibles || cuentasCorreo.length > 0) return undefined;
    let cancelado = false;
    emailsAPI.listarCuentas()
      .then(({ data }) => { if (!cancelado) setCuentasCorreo(Array.isArray(data) ? data : []); })
      .catch(() => { if (!cancelado) setCuentasCorreo([]); });
    return () => { cancelado = true; };
  }, [formatoNuevo, correosVisibles, cuentasCorreo.length]);

  // Formato nuevo: quita un enlace hecho por la IA (queda como rechazado)
  const deshacerVinculoIA = useCallback(async (correoId) => {
    setDeshaciendoCorreo(correoId);
    try {
      await vinculoIaAPI.deshacer(correoId);
      setRecargaCorreos((n) => n + 1);
    } catch (err) {
      alert(err?.response?.data?.detail || 'No se pudo deshacer el enlace');
    } finally {
      setDeshaciendoCorreo(null);
    }
  }, []);

  const toggleCorreoExpandido = useCallback(async (correoId) => {
    const estabaAbierto = correosExpandidos.has(correoId);
    setCorreosExpandidos((prev) => {
      const next = new Set(prev);
      if (estabaAbierto) next.delete(correoId);
      else next.add(correoId);
      return next;
    });
    // Lazy fetch del cuerpo si aún no lo tenemos.
    if (!estabaAbierto && !detalleCorreos[correoId]) {
      try {
        const { data } = await emailsAPI.obtener(correoId);
        setDetalleCorreos((prev) => ({ ...prev, [correoId]: data }));
      } catch (err) {
        console.error('Error cargando correo completo:', err);
      }
    }
  }, [correosExpandidos, detalleCorreos]);

  const generarResumenCorreos = useCallback(async (forzar = false) => {
    if (!presupuesto?.id) return;
    setCargandoResumen(true);
    setErrorResumen(null);
    try {
      const { data } = await api.post(`/presupuestos/${presupuesto.id}/resumen-correos`, null, { params: { forzar } });
      setResumenCorreos(data);
    } catch (err) {
      setErrorResumen(err?.response?.data?.detail || 'No se pudo generar el resumen');
    } finally {
      setCargandoResumen(false);
    }
  }, [presupuesto?.id]);

  // Al abrir la pestaña de Correos, si ya existe un resumen guardado lo cargamos.
  useEffect(() => {
    if (!correosVisibles || !presupuesto?.id) return;
    let cancelado = false;
    (async () => {
      try {
        const { data } = await api.get(`/presupuestos/${presupuesto.id}/resumen-correos`);
        if (!cancelado && data) setResumenCorreos(data);
      } catch {
        /* puede no existir todavía */
      }
    })();
    return () => { cancelado = true; };
  }, [correosVisibles, presupuesto?.id]);

  // ===== REGLAS COMERCIALES =====
  // Valores de negocio (tarifas, motivos de cancelación...) desde el backend.
  // Se cargan con los dos formatos: el bloque de transporte (compartido) usa
  // las tarifas de "Quién va al evento" para el coste del personal.
  useEffect(() => {
    let cancelado = false;
    api.get('/reglas-comerciales')
      .then(({ data }) => { if (!cancelado) setReglasComerciales(data); })
      .catch((err) => console.error('Error cargando reglas comerciales:', err));
    return () => { cancelado = true; };
  }, []);

  // Firma de los campos que afectan a las reglas: cuando cambia, se pide al
  // backend el estado de las reglas (con un pequeño retardo para agrupar cambios).
  const firmaReglas = useMemo(() => {
    if (!presupuesto) return null;
    return JSON.stringify([
      presupuesto.num_personas,
      presupuesto.es_multi_evento,
      (presupuesto.menus_personalizados || []).map(m => [m.menu_id, m.num_personas, m.nombre_menu,
        m.hora_inicio_servicio, m.hora_fin_servicio, m.acompana_a_indice, m.requiere_horario]),
      presupuesto.hora_inicio,
      // Hora de fin: la hora extra del lunch con un solo servicio sin hora propia
      presupuesto.hora_fin,
      presupuesto.costes_version,
      (presupuesto.jornadas || []).map(j => [j.id, j.num_personas, (j.menus_personalizados || []).map(m => [m.menu_id, m.num_personas,
        m.hora_inicio_servicio, m.hora_fin_servicio]), j.orden_personal_extra,
        j.fecha, j.hora_inicio, j.hora_fin, j.lugar_evento, j.direccion_exacta, j.coordenadas, j.distancia_km, j.tiempo_viaje_min]),
      (presupuesto.suplementos || []).map(s => [s.id, s.unidades, s.precio_unitario, s.total]),
      presupuesto.distancia_km,
      presupuesto.tiempo_viaje_min,
      presupuesto.direccion_exacta,
      presupuesto.lugar_evento,
      presupuesto.municipio,
      (presupuesto.personal_asignado || []).map(p => [p.empleado_id, p.rol]),
      presupuesto.orden_personal_extra,
      presupuesto.suplemento_minimo_regalado,
      presupuesto.quien_va_evento,
    ]);
  }, [presupuesto]);
  const presupuestoIdReglas = presupuesto?.id;

  useEffect(() => {
    // Con el formato anterior no se consulta el estado de las reglas
    if (!formatoNuevo || !presupuestoIdReglas || !firmaReglas) return undefined;
    let cancelado = false;
    const firmaLineaMinimo = (sups) => JSON.stringify(
      // También Madrid Central (según el lugar del evento) y la hora extra del
      // lunch (según su hora de fin): se añaden o quitan solas
      (sups || []).filter(s => s.es_suplemento_minimo || s.es_suplemento_madrid_central
        || s.es_suplemento_hora_extra_lunch)
        .map(s => [s.id, s.unidades, s.precio_unitario, s.total, !!s.es_cortesia])
    );
    const timer = setTimeout(async () => {
      try {
        const { data } = await api.get(`/presupuestos/${presupuestoIdReglas}/reglas-comerciales`);
        if (cancelado) return;
        setEstadoReglas(data);
        // Al guardar, el backend recalcula la línea "Suplemento hasta 40 personas"
        // si cambian las personas: se refleja aquí sin recargar la página.
        setPresupuesto(prev => {
          if (!prev || firmaLineaMinimo(prev.suplementos) === firmaLineaMinimo(data.suplementos)) return prev;
          return {
            ...prev,
            suplementos: data.suplementos || [],
            importe_base: data.importe_base ?? prev.importe_base,
            iva: data.iva ?? prev.iva,
            importe_total: data.importe_total ?? prev.importe_total,
          };
        });
      } catch (err) {
        console.error('Error consultando reglas del presupuesto:', err);
      }
    }, 1200);
    return () => { cancelado = true; clearTimeout(timer); };
  }, [formatoNuevo, presupuestoIdReglas, firmaReglas, recargaHorarios]);

  // Selección de lugar del evento (autocompletado vía backend /api/places) +
  // cálculo de distancia/coste de transporte desde la sede.
  const seleccionarLugarEvento = async (lugar) => {
    const locationData = {
      lugar_evento: lugar.nombre || lugar.direccion,
      direccion_exacta: lugar.direccion,
      coordenadas: lugar.lat != null ? { lat: lugar.lat, lng: lugar.lng } : null,
      place_id: lugar.place_id || null,
      // Municipio según Google (lo usa la regla de transporte por zonas)
      municipio: lugar.municipio || null,
    };

    let transportData = {};
    if (lugar.lat != null && lugar.lng != null) {
      try {
        // El coste de ida y vuelta (personal + furgoneta) lo calcula el backend
        // con las reglas comerciales y según quién va al evento (propio o extra).
        const { data } = await placesAPI.distancia(lugar.lat, lugar.lng, presupuesto?.quien_va_evento?.modo);
        if (data.disponible) {
          transportData = {
            distancia_km: Number(Number(data.distancia_km).toFixed(2)),
            tiempo_viaje_min: parseInt(data.tiempo_min, 10) || 0,
            coste_transporte: Number(Number(data.coste_transporte || 0).toFixed(2)),
            // Dirección con la que se calculó la ruta (para saber si queda desfasada)
            ruta_origen: locationData.direccion_exacta || locationData.lugar_evento,
            ruta_error_origen: null,
          };
        }
      } catch (error) {
        console.error('Error calculando distancia de transporte:', error);
      }
    }

    setPresupuesto(prev => {
      const updated = { ...prev, ...locationData, ...transportData };
      guardarFicha(updated)
        .then(r => aplicarRespuestaGuardado(r))
        .catch(err => {
          console.error('Error guardando lugar/transporte:', err);
        });
      return updated;
    });
  };

  // Ruta desde la sede con la dirección ya guardada. Desde el 06-oct-2026
  // (auditoría un día, U-02) ya NO se calcula sola al abrir la ficha (abrir
  // escribía en el presupuesto, también en pasados y facturados): se calcula en
  // el alta, al guardar con otra dirección o con el botón "Calcular ruta"
  // (siempre `forzar`). Sin ruta, la ficha enseña un aviso con el botón.
  const presupuestoRutaRef = useRef(presupuesto);
  presupuestoRutaRef.current = presupuesto;
  const [calculandoRuta, setCalculandoRuta] = useState(false);

  const calcularRutaGuardada = useCallback(async () => {
    const pid = presupuestoRutaRef.current?.id;
    if (!pid) return;
    setCalculandoRuta(true);
    try {
      const { data } = await api.post(`/presupuestos/${pid}/calcular-ruta`, { forzar: true });
      if (data?.ruta && (data.calculada || data.motivo === 'sin_ruta_google')) {
        setPresupuesto(prev => (prev && prev.id === pid ? { ...prev, ...data.ruta } : prev));
      }
    } catch (error) {
      console.error('Error calculando la ruta del evento:', error);
    } finally {
      setCalculandoRuta(false);
    }
  }, []);

  // Aviso "Sin ruta calculada" (los dos formatos): hay lugar y no hay km o
  // minutos, o la ruta es de otra dirección, o Google no la encontró
  const avisoSinRuta = useMemo(() => avisoRutaPresupuesto(presupuesto), [presupuesto]);

  // Cargar todos los clientes para el selector
  const cargarTodosClientes = async () => {
    try {
      const response = await clientesAPI.getAll({ limit: 10000 });
      const clientesData = response.data?.clientes || response.data || [];
      // Ordenar alfabéticamente por nombre de empresa
      const clientesOrdenados = clientesData.sort((a, b) => {
        const nombreA = a.nombre_empresa || a.nombre || '';
        const nombreB = b.nombre_empresa || b.nombre || '';
        return nombreA.localeCompare(nombreB);
      });
      setTodosClientes(clientesOrdenados);
    } catch (error) {
      console.error('Error cargando clientes:', error);
    }
  };

  // Cambiar el cliente del presupuesto
  const handleCambiarCliente = async (nuevoClienteId) => {
    try {
      const updatedData = {
        ...presupuesto,
        cliente_id: nuevoClienteId
      };
      
      await guardarFicha(updatedData);
      
      setShowCambiarClienteModal(false);
      
      // Recargar el presupuesto
      await fetchData();
      
      avisoGuardadoOk('Cliente actualizado correctamente');
    } catch (error) {
      console.error('❌ Error cambiando cliente:', error);
      avisoGuardadoError('Error al cambiar el cliente: ' + (error.response?.data?.detail || error.message), error);
    }
  };

  const fetchData = async () => {
    try {
      // El presupuesto SIEMPRE fresco (es específico). Los catálogos van por
      // caché TTL 5 min: al navegar entre presupuestos no se vuelven a pedir.
      const [presupuestoRes, menusRes, platosRes, alergenosRes, materialesRes, ingredientesRes] = await Promise.all([
        presupuestosAPI.getOne(id),
        getCached('menus', () => menusAPI.getAll()),
        getCached('platos', () => platosAPI.getAll()),
        getCached('alergenos', () => alergenosAPI.getAll()),
        getCached('materiales', () => materialesAPI.getAll()),
        getCached('ingredientes', () => ingredientesAPI.getAll())
      ]);
      
      
      // IMPORTANTE: Verificar si data existe
      if (!presupuestoRes || !presupuestoRes.data) {
        console.error('❌ presupuestoRes.data is null or undefined!');
        throw new Error('Presupuesto no encontrado en el servidor');
      }
      
      setPresupuesto(presupuestoRes.data);
      anotarBaseServidor(presupuestoRes.data);

      // Cargar estimación de desperdicio (no bloquea — falla silenciosa)
      try {
        const token = getAuthToken();
        const desRes = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${presupuestoRes.data.id}/desperdicio`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (desRes.ok) setDesperdicio(await desRes.json());
      } catch (_) { /* silencioso */ }

      setMenus(menusRes.data || []);
      setPlatos(platosRes.data || []);
      setIngredientesCatalogo(ingredientesRes.data || []);
      setAlergenos(alergenosRes.data || []);
      setMateriales(materialesRes.data || []);

      // Plantillas de menaje (necesarias para el coste real del menú: los items
      // del menú catálogo enlazan aquí y el precio lo resolvemos en `materiales`).
      try {
        const pmRes = await getCached('plantillas_menaje', () => plantillasMenajeAPI.getAll());
        setPlantillasMenaje(pmRes.data || []);
      } catch (_) { setPlantillasMenaje([]); }

      // Filtrar materiales de alquiler del catálogo
      const matAlquiler = (materialesRes.data || []).filter(m => m.tipo_coste === 'alquiler' && m.activo);
      setMaterialesAlquilerCatalogo(matAlquiler);

      if (presupuestoRes.data.cliente_id) {
        try {
          const clienteRes = await clientesAPI.getOne(presupuestoRes.data.cliente_id);
          setCliente(clienteRes.data);
          
          // Cargar personas de contacto del cliente usando la función auxiliar
          const contactos = await cargarContactosConPrincipal(presupuestoRes.data.cliente_id, clienteRes.data);
          setPersonasContacto(contactos);
          // Los contactos NO se autocompletan: deben elegirse explícitamente
          // (en el modal de nuevo presupuesto o aquí) para no contactar ni
          // facturar a la persona equivocada por un valor puesto por defecto.


          // Check for client deposits
          try {
            const depToken = getAuthToken();
            const depositRes = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/cobros-unificado/depositos-cliente/${presupuestoRes.data.cliente_id}`, {
              headers: { Authorization: `Bearer ${depToken}` }
            });
            if (depositRes.ok) {
              const depData = await depositRes.json();
              if (depData && depData.total_disponible > 0.01) {
                setDepositosCliente(depData);
              }
            }
          } catch (depErr) {
            console.warn('Could not check deposits:', depErr);
          }
        } catch (clienteError) {
          console.error('❌ Error fetching cliente:', clienteError);
          console.error('   This might be a CORS issue if running locally');
          // Continue anyway - presupuesto can still be displayed without cliente details
        }
      }

      initializeItems(presupuestoRes.data, menusRes.data || [], platosRes.data || []);
      
      // Initialize adaptaciones from presupuesto if exists
      if (presupuestoRes.data.menus_personalizados && presupuestoRes.data.menus_personalizados.length > 0) {
        const allAdaptaciones = [];
        presupuestoRes.data.menus_personalizados.forEach(menu => {
          if (menu.adaptaciones && menu.adaptaciones.length > 0) {
            menu.adaptaciones.forEach(adapt => {
              allAdaptaciones.push({
                ...adapt,
                menu_id: menu.menu_id,
                menu_nombre: menu.nombre_menu
              });
            });
          }
        });
        setAdaptaciones(allAdaptaciones);
      }

      // ?openFactura=true: el modal se abre UNA vez desde un efecto, con las
      // facturas cargadas (U-52); antes se abría aquí en cada recarga
    } catch (error) {
      console.error('❌ Error fetching data:', error);
      console.error('   Error details:', error.message);
      if (error.response) {
        console.error('   Response status:', error.response.status);
        console.error('   Response data:', error.response.data);
      }
      if (error.code === 'ERR_NETWORK' || error.message.includes('CORS')) {
        console.error('   ⚠️  CORS or network error detected');
        console.error('   Make sure REACT_APP_BACKEND_URL is correctly configured');
      }
    } finally {
      setLoading(false);
    }
  };
  fetchDataRef.current = fetchData;

  const initializeItems = (presupuestoData, menusData, platosData) => {
    
    // Safety check
    if (!presupuestoData) {
      console.error('❌ presupuestoData is undefined - cannot initialize items');
      setItems([]);
      return;
    }
    
    const initialItems = [];
    

    // Determinar si el evento ya pasó y está confirmado (M-101: en un
    // multievento, cuando ha pasado su última jornada)
    const eventoYaPaso = eventoPasado(presupuestoData);
    const estaConfirmado = presupuestoData.estado === 'confirmado';
    const usarDatosLegacy = eventoYaPaso && estaConfirmado;
    

    // Unidades de una línea: en un multievento, la suma de las personas de
    // las jornadas donde está (la cabecera guarda las de la primera jornada);
    // `udsCabecera` es lo que se vuelve a guardar en la cabecera
    const unidadesDeLinea = (menuPersonalizado) => {
      const multi = unidadesMultievento(menuPersonalizado, presupuestoData);
      return multi
        ? { uds: multi.total, udsCabecera: menuPersonalizado.num_personas, udsJornadas: multi.porJornada }
        : { uds: menuPersonalizado.num_personas };
    };

    // IVA de una línea con la regla única (U-10): el suyo (tipo_iva >
    // iva_percent > iva; 0 respetado); sin IVA, 10 % (nunca el del catálogo)
    const ivaDeLinea = (linea) => tipoIvaDe(linea);
    // Precio de una línea con la regla única: precio_unitario (aunque sea 0) >
    // precio_ud > precio_por_persona > precio_persona > el del catálogo
    const precioDeLinea = (linea, menuCatalogo) => {
      for (const campo of ['precio_unitario', 'precio_ud', 'precio_por_persona', 'precio_persona']) {
        const v = linea[campo];
        if (v !== null && v !== undefined && v !== '' && (campo === 'precio_unitario' || Number(v))) return Number(v) || 0;
      }
      return precioMenuCatalogo(menuCatalogo) || 0;
    };

    // Priorizar menus_personalizados si existen
    if (presupuestoData.menus_personalizados && presupuestoData.menus_personalizados.length > 0) {
      presupuestoData.menus_personalizados.forEach((menuPersonalizado, index) => {

        // Safety check: skip if menuPersonalizado is undefined
        if (!menuPersonalizado) {
          console.warn(`Línea ${index} vacía: no se muestra`);
          return;
        }
        // Una línea sin personas se vende con las del evento (regla única, U-10)
        const udsLinea = (menuPersonalizado.num_personas === null || menuPersonalizado.num_personas === undefined
          || menuPersonalizado.num_personas === '')
          ? { uds: Number(presupuestoData.num_personas) || 0 }
          : unidadesDeLinea(menuPersonalizado);
        
        // CASO 1: Menú legacy (migrado desde sistema antiguo) - SOLO si evento ya pasó y está confirmado
        if (usarDatosLegacy && (menuPersonalizado.tipomenu_legacy || menuPersonalizado.matching_exacto !== undefined)) {
          // Menú histórico migrado - usar precio_unitario del histórico
          const ivaRatio = menuPersonalizado.iva_tipo_legacy || 0.10;
          initialItems.push({
            id: menuPersonalizado.menu_id || `legacy-${index}`,
            personalizadoIndex: index,
            type: 'menu',
            concepto: menuPersonalizado.nombre_menu,
            precio_ud: menuPersonalizado.precio_unitario || 0,
            iva_ud: (menuPersonalizado.precio_unitario || 0) * ivaRatio,
            ...udsLinea,
            iva_percent: ivaRatio * 100,
            menu_data: {
              platos_ids: [],
              nombre: menuPersonalizado.nombre_menu,
              es_personalizado: true,
              es_legacy: true,
              tipomenu_legacy: menuPersonalizado.tipomenu_legacy
            }
          });
        }
        // CASO 2: Menú con menu_id pero evento futuro o no confirmado - buscar en catálogo actual
        else if (menuPersonalizado.menu_id && !usarDatosLegacy) {
          const menu = menusData ? menusData.find(m => m.id === menuPersonalizado.menu_id) : null;
          if (menu) {
            const precioFinal = precioDeLinea(menuPersonalizado, menu);

            // IVA de la línea (regla única): sin IVA guardado, 10 %
            const ivaPercent = ivaDeLinea(menuPersonalizado);
            
            initialItems.push({
              id: menuPersonalizado.menu_id,
              personalizadoIndex: index,
              type: 'menu',
              concepto: menu.nombre,
              precio_ud: precioFinal,
              iva_ud: precioFinal * (ivaPercent / 100),
              ...udsLinea,
              iva_percent: ivaPercent,
              // IMPORTANTE: Siempre usar cantidades del catálogo
              // El campo unidades_por_plato es solo para adaptaciones dietéticas, NO para cantidades base
              menu_data: {
                ...menu,
                platos_ids: menuPersonalizado.platos_ids?.length > 0 
                  ? menuPersonalizado.platos_ids.filter(pid => {
                      const p = platosData.find(pl => pl.id === pid);
                      return !p || p.activo !== false; // Mantener si no se encuentra (safety) o si está activo
                    })
                  : (menu.platos?.map(p => p.plato_id || p.id).filter(pid => {
                      const p = platosData.find(pl => pl.id === pid);
                      return !p || p.activo !== false;
                    }) || []),
                // Usar platos del catálogo directamente - filtrar inactivos
                platos: (menu.platos || []).filter(p => {
                  const platoData = platosData.find(pl => pl.id === (p.plato_id || p.id));
                  return !platoData || platoData.activo !== false;
                }).map(p => ({
                  ...p,
                  cantidad: p.cantidad || 1
                }))
              },
              // Guardar referencia al menú personalizado completo
              menuPersonalizado: menuPersonalizado,
              descuento_info: menuPersonalizado.descuento_valor ? {
                tipo: menuPersonalizado.descuento_tipo,
                valor: menuPersonalizado.descuento_valor,
                precio_original: menuPersonalizado.precio_unitario_original
              } : null
            });
          } else {
            // Menu no encontrado - usar datos del menuPersonalizado
            console.warn(`  ⚠️  Menu ${menuPersonalizado.menu_id} not found - using menuPersonalizado data`);
            // IVA de la línea (regla única)
            const ivaPercent = ivaDeLinea(menuPersonalizado);
            const precioLinea = precioDeLinea(menuPersonalizado, null);
            
            // Construir array de platos con cantidades desde unidades_por_plato
            const platosConCantidad = (menuPersonalizado.platos_ids || []).map(platoId => {
              const cantidad = menuPersonalizado.unidades_por_plato?.[platoId] || 1;
              return {
                plato_id: platoId,
                id: platoId,
                cantidad: cantidad
              };
            });
            
            initialItems.push({
              id: menuPersonalizado.menu_id || `missing-${index}`,
              personalizadoIndex: index,
              type: 'menu',
              concepto: menuPersonalizado.nombre_menu || 'Menú no encontrado',
              precio_ud: precioLinea,
              iva_ud: precioLinea * (ivaPercent / 100),
              ...udsLinea,
              iva_percent: ivaPercent,
              menu_data: {
                platos_ids: menuPersonalizado.platos_ids || [],
                platos: platosConCantidad,
                nombre: menuPersonalizado.nombre_menu || 'Menú no encontrado',
                es_personalizado: false
              },
              menuPersonalizado: menuPersonalizado
            });
          }
        }
        // CASO 3: Menú personalizado (creado desde platos)
        else if (menuPersonalizado.es_personalizado) {
          // IVA de la línea (regla única)
          const ivaPercent = ivaDeLinea(menuPersonalizado);
          const precioLinea = precioDeLinea(menuPersonalizado, null);
          
          // Intentar buscar el menú del catálogo para obtener cantidades originales
          const menuCatalogo = menusData ? menusData.find(m => m.id === menuPersonalizado.menu_id) : null;
          
          // Construir array de platos con cantidades
          const platosConCantidad = (menuPersonalizado.platos_ids || []).map(platoId => {
            // SIEMPRE usar cantidad del catálogo si existe
            // El unidades_por_plato solo se usa para adaptaciones, NO para cantidades base
            let cantidad = 1;
            
            // Buscar en el catálogo primero - esta es la fuente de verdad
            if (menuCatalogo?.platos) {
              const platoCatalogo = menuCatalogo.platos.find(p => (p.plato_id || p.id) === platoId);
              if (platoCatalogo?.cantidad !== undefined) {
                cantidad = platoCatalogo.cantidad;
              }
            }
            
            return {
              plato_id: platoId,
              id: platoId,
              cantidad: cantidad
            };
          });
          
          // Menú personalizado - usar precio_unitario directamente
          initialItems.push({
            id: menuPersonalizado.menu_id,
            personalizadoIndex: index,
            type: 'menu',
            concepto: menuPersonalizado.nombre_menu,
            precio_ud: precioLinea,
            iva_ud: precioLinea * (ivaPercent / 100),
            ...udsLinea,
            iva_percent: ivaPercent,
            menu_data: {
              ...menuCatalogo,
              platos_ids: menuPersonalizado.platos_ids,
              platos: platosConCantidad,
              nombre: menuPersonalizado.nombre_menu,
              es_personalizado: true
            },
            menuPersonalizado: menuPersonalizado
          });
        }
        // CASO 4: Fallback - menú sin menu_id
        else {
          // IVA de la línea (regla única)
          const ivaPercent = ivaDeLinea(menuPersonalizado);
          const precioLinea = precioDeLinea(menuPersonalizado, null);
          
          // Construir array de platos con cantidades
          const platosConCantidadFallback = (menuPersonalizado.platos_ids || []).map(platoId => {
            const cantidad = menuPersonalizado.unidades_por_plato?.[platoId] || 1;
            return {
              plato_id: platoId,
              id: platoId,
              cantidad: cantidad
            };
          });
          
          initialItems.push({
            id: `item-${index}`,
            personalizadoIndex: index,
            type: 'menu',
            concepto: menuPersonalizado.nombre_menu || 'Menú sin nombre',
            precio_ud: precioLinea,
            iva_ud: precioLinea * (ivaPercent / 100),
            ...udsLinea,
            iva_percent: ivaPercent,
            menu_data: {
              platos_ids: menuPersonalizado.platos_ids || [],
              platos: platosConCantidadFallback,
              nombre: menuPersonalizado.nombre_menu || 'Menú sin nombre',
              es_personalizado: true
            },
            menuPersonalizado: menuPersonalizado
          });
        }
      });
    } else {
      // Fallback a menus_ids (deprecated)
      if (presupuestoData.menus_ids && presupuestoData.menus_ids.length > 0) {
        presupuestoData.menus_ids.forEach(menuId => {
          const menu = menusData.find(m => m.id === menuId);
          if (menu) {
            // Obtener IVA del menú
            const ivaRaw = menu.tipo_iva || menu.iva || 10;
            const ivaPercent = ivaRaw < 1 ? ivaRaw * 100 : ivaRaw;
            const precioMenu = menu.precio_por_persona || menu.precio_persona || menu.precio_venta || menu.precio_total || 0;
            
            initialItems.push({
              id: menu.id,
              type: 'menu',
              concepto: menu.nombre,
              precio_ud: precioMenu,
              iva_ud: precioMenu * (ivaPercent / 100),
              uds: presupuestoData.num_personas || 1,
              iva_percent: ivaPercent,
              menu_data: menu
            });
          }
        });
      }
    }

    if (presupuestoData.platos_ids && presupuestoData.platos_ids.length > 0) {
      presupuestoData.platos_ids.forEach(platoId => {
        const plato = platosData.find(p => p.id === platoId);
        if (plato) {
          // Obtener IVA del plato
          const ivaRaw = plato.tipo_iva || plato.iva || 10;
          const ivaPercent = ivaRaw < 1 ? ivaRaw * 100 : ivaRaw;
          
          initialItems.push({
            id: plato.id,
            type: 'plato',
            concepto: plato.nombre,
            precio_ud: plato.coste_racion,
            iva_ud: plato.coste_racion * (ivaPercent / 100),
            uds: presupuestoData.num_personas || 1,
            iva_percent: ivaPercent,
            plato_data: plato
          });
        }
      });
    }

    setItems(initialItems);
    // Totales del servidor (U-10): los del documento recién leído, con la
    // firma de las filas que se acaban de montar
    if (presupuestoData.importe_total !== undefined && presupuestoData.importe_total !== null) {
      setTotalesServidor({
        base: Number(presupuestoData.importe_base) || 0,
        iva: Number(presupuestoData.iva) || 0,
        total: Number(presupuestoData.importe_total) || 0,
        firma: firmaTotalesFicha(initialItems, presupuestoData.suplementos),
      });
    } else {
      setTotalesServidor(null);
    }
  };

  // Helper function to safely format numbers with toFixed
  const safeToFixed = (value, decimals = 2) => {
    if (value === null || value === undefined || isNaN(value)) {
      return (0).toFixed(decimals);
    }
    return Number(value).toFixed(decimals);
  };

  // Línea de venta de una bebida con importe (D9): solo lectura en Líneas y
  // menús, se cambia en la pestaña Bebidas
  const esItemBebida = (item) => !!(item && item.type === 'menu' && item.personalizadoIndex !== undefined
    && esLineaBebida(presupuesto?.menus_personalizados?.[item.personalizadoIndex]));

  // Importe e IVA de una fila con la regla única (U-10): base y cuota
  // redondeadas por línea, como el servidor y la factura
  const calculateImporte = (item) => redondear2((Number(item.precio_ud) || 0) * (Number(item.uds) || 0));

  const calculateIva = (item) => redondear2((calculateImporte(item) * (Number(item.iva_percent) || 0)) / 100);

  // Vista previa local del total (misma regla que el servidor): filas de la
  // ficha y suplementos no cortesía (también los negativos)
  const totalesLocales = () => totalesDesdeItems(items, presupuesto?.suplementos);

  const calculateSubtotal = () => totalesLocales().base;

  // Calcular total de cortesías (para mostrar en el resumen)
  const calculateCortesiasTotal = () => {
    return (presupuesto.suplementos || []).reduce((sum, s) => 
      sum + (s.es_cortesia ? (s.total || 0) : 0), 0
    );
  };

  const calculateTotalIva = () => totalesLocales().cuota;

  const calculateTotal = () => totalesLocales().total;

  // Firma de lo que mueve el total en la ficha (filas y suplementos): con ella
  // se sabe si los totales del servidor siguen valiendo o hay una edición local
  // aún sin respuesta
  const firmaFicha = firmaTotalesFicha(items, presupuesto?.suplementos);
  const firmaFichaRef = useRef(firmaFicha);
  firmaFichaRef.current = firmaFicha;
  // Totales recién llegados de un guardado: se anota la firma de la ficha
  useEffect(() => {
    if (totalesServidor && totalesServidor.firma === null) {
      setTotalesServidor(prev => (prev && prev.firma === null ? { ...prev, firma: firmaFichaRef.current } : prev));
    }
  }, [totalesServidor]);

  // Totales del presupuesto que se enseñan y con los que se comparan los
  // documentos. Multievento: los del servidor (jornadas con el IVA de cada
  // línea, suplementos de jornada y del evento y alquiler de la cabecera), los
  // mismos que la proforma, la factura y el cobro previo; calculateTotal() solo
  // conoce la cabecera. Evento de un día (U-10): también los del servidor
  // (regla única, los de la proforma, la factura y el cobro previo); mientras
  // se edita y hasta que responde el guardado, la vista previa local con la
  // misma regla.
  // (Sin esMultieventoFicha, que se declara más abajo, para poder usarse antes.)
  const totalesDelServidor = () => !!(presupuesto?.es_multi_evento
    && Array.isArray(presupuesto?.jornadas) && presupuesto.jornadas.length > 0);
  const totalesUnDiaServidor = () => (!totalesDelServidor() && totalesServidor
    && totalesServidor.firma !== null && totalesServidor.firma === firmaFicha ? totalesServidor : null);
  const totalPresupuesto = () => {
    if (totalesDelServidor()) return Number(presupuesto?.importe_total) || 0;
    const srv = totalesUnDiaServidor();
    return srv ? srv.total : calculateTotal();
  };
  const ivaPresupuesto = () => {
    if (!totalesDelServidor()) {
      const srv = totalesUnDiaServidor();
      return srv ? srv.iva : calculateTotalIva();
    }
    const iva = Number(presupuesto?.iva);
    if (presupuesto?.iva !== null && presupuesto?.iva !== undefined && Number.isFinite(iva)) return iva;
    const base = Number(presupuesto?.importe_base);
    return Number.isFinite(base) && base > 0 ? totalPresupuesto() - base : 0;
  };
  const basePresupuesto = () => {
    if (totalesDelServidor()) return totalPresupuesto() - ivaPresupuesto();
    const srv = totalesUnDiaServidor();
    return srv ? srv.base : calculateSubtotal();
  };
  // Total GUARDADO con el que se comparan los documentos emitidos (factura y
  // proforma salen de lo guardado): el del servidor; sin él, el que se enseña
  const totalGuardadoPresupuesto = () => {
    if (totalesDelServidor()) return totalPresupuesto();
    return totalesServidor ? totalesServidor.total : totalPresupuesto();
  };
  // E-10 / U-12: en un presupuesto pasado, facturado, con proforma o cancelado
  // las líneas automáticas (mínimo 40, menú adaptado, barra libre, Madrid
  // Central) no se recalculan solas; se avisa si el presupuesto tiene alguna
  const renderAvisoLineasCongeladas = () => {
    const texto = presupuesto && tieneLineasAutomaticas(presupuesto) ? textoLineasAutomaticasCongeladas(presupuesto) : null;
    if (!texto) return null;
    return (
      <p className="mx-4 sm:mx-5 my-3 text-xs text-[#6B4E00] bg-[#FFF8E6] border border-[#F1DFA8] rounded-lg px-3 py-2"
        data-testid="aviso-lineas-congeladas">
        {texto}. Si cambian las personas o los menús, revisa a mano el suplemento de mínimo y el de menú adaptado.
      </p>
    );
  };
  // Un documento está desactualizado si su importe se aparta más de 0,05 €
  const TOLERANCIA_TOTAL_DOCUMENTO = 0.05;
  const difiereDelTotal = (importe, total = totalGuardadoPresupuesto()) => Math.abs((Number(importe) || 0) - total) > TOLERANCIA_TOTAL_DOCUMENTO;

  const handleSaveEventDetails = async () => {
    try {
      const updates = {
        fecha_evento: editedFechaEvento,
        hora_inicio: editedHoraInicio,
        hora_fin: editedHoraFin,
        num_personas: parseInt(editedNumPersonas)
      };

      // Estado local: lo que devuelve el servidor (U-32)
      aplicarRespuestaGuardado(await guardarFicha(updates), prev => ({ ...prev, ...updates }));
      setEditingEventDetails(false);
      
    } catch (error) {
      console.error('Error actualizando detalles del evento:', error);
      avisoGuardadoError('Error al guardar los cambios', error);
    }
  };

  const handleStartEditingEventDetails = () => {
    setEditedFechaEvento(presupuesto.fecha_evento);
    setEditedHoraInicio(presupuesto.hora_inicio);
    setEditedHoraFin(presupuesto.hora_fin);
    setEditedNumPersonas(presupuesto.num_personas.toString());
    setEditingEventDetails(true);
  };

  const handleCancelEditingEventDetails = () => {
    setEditingEventDetails(false);
  };

  const formatHorarioConDia = (horaInicio, horaFin) => {
    if (!horaInicio || !horaFin) return 'Sin horario';
    
    // Parsear horas (formato HH:MM)
    const [horaI, minI] = horaInicio.split(':').map(Number);
    const [horaF, minF] = horaFin.split(':').map(Number);
    
    const minutosInicio = horaI * 60 + minI;
    const minutosFin = horaF * 60 + minF;
    
    // Igual que la de inicio: hora de fin por confirmar (no es el día siguiente)
    if (minutosFin === minutosInicio) {
      return `${horaInicio} (fin por confirmar)`;
    }
    // Si la hora de fin es menor que la de inicio, es al día siguiente
    if (minutosFin < minutosInicio) {
      return `${horaInicio} - ${horaFin} (+1 día)`;
    }
    
    return `${horaInicio} - ${horaFin}`;
  };

  const parseHoraToTimeInput = (horaString) => {
    if (!horaString) return '';
    
    // Si ya está en formato HH:MM, retornar directamente
    if (/^\d{2}:\d{2}$/.test(horaString)) {
      return horaString;
    }
    
    // Si está en formato "Nov 27, 2025 11:30 am" o similar, parsear
    try {
      const date = new Date(horaString);
      if (!isNaN(date.getTime())) {
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      }
    } catch (e) {
      console.error('Error parsing hora:', e);
    }
    
    return '';
  };


  const calculateCostePersonal = () => {
    let costeTotal = 0;
    
    items.forEach(item => {
      if (item.type === 'plato') {
        const plato = platos.find(p => p.id === item.id);
        if (plato && plato.tiempo_activo_min) {
          // Coste = tiempo_activo_min * 0.26€/min * num_personas
          costeTotal += plato.tiempo_activo_min * 0.26 * item.uds;
        }
      } else if (item.type === 'menu') {
        // Para menús, calcular el coste de todos sus platos
        const menu = item.menu_data;
        if (menu && menu.platos_ids) {
          menu.platos_ids.forEach(platoId => {
            const plato = platos.find(p => p.id === platoId);
            if (plato && plato.activo !== false && plato.tiempo_activo_min) {
              costeTotal += plato.tiempo_activo_min * 0.26 * item.uds;
            }
          });
        }
      }
    });
    
    return costeTotal;
  };

  // El personal de más (propio o extra) NO se cobra automáticamente al cliente:
  // si hay que cobrarlo, se mete como línea explícita "servicio de camarero"
  // (U-78: se quitan las funciones que devolvían siempre 0 y su tarjeta).

  // Devuelve { total, detalle: [{ nombre, cantidad, unidad, precio, coste }, ...] }
  // Solo cuenta material consumible (mesas/manteles inventariables son propios).
  const getDesgloseCosteMaterial = () => {
    const consumibles = new Map();
    (materiales || []).forEach(m => {
      if (m.tipo_coste === 'consumible' && m.nombre) {
        consumibles.set(m.nombre.trim().toLowerCase(), {
          precio: parseFloat(m.precio_unitario) || 0,
          unidad: m.unidad || 'ud',
        });
      }
    });

    const acc = new Map(); // nombre → { nombre, cantidad, unidad, precio, coste }
    const sumar = (nombre, cantidad, item) => {
      if (!nombre || cantidad <= 0) return;
      const nm = nombre.trim().toLowerCase();
      const refCat = consumibles.get(nm);
      const itemPrecio = parseFloat(item?.coste_unitario);
      let precio = 0;
      let unidad = item?.unidad || 'ud';
      if (itemPrecio && itemPrecio > 0) {
        precio = itemPrecio;
      } else if (refCat) {
        precio = refCat.precio;
        unidad = item?.unidad || refCat.unidad;
      }
      // Si no es consumible y no trae precio propio, lo descartamos del desglose
      if (precio <= 0 && !refCat) return;
      const cur = acc.get(nm) || { nombre, cantidad: 0, unidad, precio, coste: 0 };
      cur.cantidad += cantidad;
      cur.coste += cantidad * precio;
      cur.precio = precio;
      cur.unidad = unidad;
      acc.set(nm, cur);
    };

    // Menús a procesar (raíz + jornadas)
    const todosMenus = [];
    if (presupuesto?.es_multi_evento && Array.isArray(presupuesto.jornadas) && presupuesto.jornadas.length > 0) {
      presupuesto.jornadas.forEach(j => (j.menus_personalizados || []).forEach(m => todosMenus.push(m)));
    }
    if (todosMenus.length === 0) {
      (presupuesto?.menus_personalizados || []).forEach(m => todosMenus.push(m));
    }

    todosMenus.forEach(menuPers => {
      const numPersonas = menuPers.num_personas || 0;
      if (numPersonas <= 0) return;

      // El material propio de la línea sustituye, lista a lista, al del menú
      // del catálogo (misma regla que utils._lineas_materiales_menu); antes se
      // sumaban los dos y se contaba doble. La plantilla de menaje se suma siempre.
      const fijos = [...(menuPers.material_fijo || [])];
      const porPersona = [...(menuPers.material_por_persona || [])];
      const textiles = [...(menuPers.textiles || [])];

      const menuCat = menuPers.menu_id ? menus.find(m => m.id === menuPers.menu_id) : null;
      if (menuCat) {
        if (fijos.length === 0) fijos.push(...(menuCat.material_fijo || []));
        if (porPersona.length === 0) porPersona.push(...(menuCat.material_por_persona || []));
        if (textiles.length === 0) textiles.push(...(menuCat.textiles || []));
        if (menuCat.plantilla_menaje_id) {
          const plantilla = plantillasMenaje.find(p => p.id === menuCat.plantilla_menaje_id);
          if (plantilla) {
            fijos.push(...(plantilla.material_fijo || []));
            porPersona.push(...(plantilla.material_por_persona || []));
          }
        }
      }

      fijos.forEach(it => sumar(it.nombre, parseFloat(it.cantidad) || 0, it));

      porPersona.forEach(it => {
        // Ratio "cantidad_unidades cada personas_por_unidad" (cantidad_unidades por
        // defecto 1). Prioridad sobre cantidad_pp: si hay personas_por_unidad NO se
        // cuenta 1 por persona (ej. "1 bolsa cada 50 pax").
        const ppu = parseFloat(it.personas_por_unidad ?? it.por_personas);
        let cantidad = 0;
        if (Number.isFinite(ppu) && ppu >= 1) {
          const cu = parseFloat(it.cantidad_unidades ?? it.cantidad);
          cantidad = Math.ceil(numPersonas / ppu) * (Number.isFinite(cu) ? cu : 1);
        } else {
          cantidad = (parseFloat(it.cantidad_pp) || 0) * numPersonas;
        }
        sumar(it.nombre, cantidad, it);
      });

      textiles.forEach(it => {
        const cantidad = parseFloat(it.cantidad) || 0;
        const lav = parseFloat(it.coste_lavanderia) || 0;
        if (cantidad <= 0 || lav <= 0) return;
        const nm = (it.nombre || '').trim().toLowerCase();
        const cur = acc.get(nm) || { nombre: it.nombre, cantidad: 0, unidad: it.unidad || 'ud', precio: lav, coste: 0 };
        cur.cantidad += cantidad;
        cur.coste += cantidad * lav;
        cur.precio = lav;
        acc.set(nm, cur);
      });
    });

    const detalle = Array.from(acc.values())
      .filter(d => d.coste > 0)
      .sort((a, b) => b.coste - a.coste);
    const total = detalle.reduce((s, d) => s + d.coste, 0);
    return { total, detalle };
  };

  // Alias compatible para los usos antiguos
  const calculateCosteMaterial = () => getDesgloseCosteMaterial().total;

  // Helper: en multi-evento, las jornadas suelen tener pax propio (17) pero los
  // `platos_ids` y `unidades_por_plato` viven solo en la jornada 1 o en el raíz.
  // Para calcular bien, hereda los platos del menú equivalente del raíz si la
  // jornada no los trae, manteniendo siempre `num_personas` de la jornada.
  const _resolverPlatosMenu = (menuPers) => {
    if ((menuPers?.platos_ids || []).length > 0) return menuPers;
    const equiv = (presupuesto?.menus_personalizados || []).find(
      m => (menuPers?.menu_id && m.menu_id === menuPers.menu_id) ||
           (menuPers?.nombre_menu && m.nombre_menu === menuPers.nombre_menu)
    );
    if (!equiv || (equiv.platos_ids || []).length === 0) return menuPers;
    return {
      ...menuPers,
      platos_ids: equiv.platos_ids,
      unidades_por_plato: equiv.unidades_por_plato || {},
    };
  };

  // Helper: resuelve (platosIds, unidades) de un menú con fallback al catálogo,
  // igual que el backend (_resolver_platos_y_unidades) y que getDesgloseCostesMenu.
  // Si el menú no tiene `platos_ids` propios (no se personalizaron los platos),
  // hereda los del menú del catálogo (`platos: [{plato_id, cantidad}]`). Así las
  // barras libres / suplementos / servicios heredados costean en los TOTALES igual
  // que en el coste del menú, en vez de salir a 0.
  const resolverPlatosConCatalogo = (menuPers) => {
    let platosIds = menuPers?.platos_ids || [];
    let unidades = menuPers?.unidades_por_plato || {};
    if ((!platosIds || platosIds.length === 0) && menuPers?.menu_id) {
      const cat = menus.find(m => m.id === menuPers.menu_id);
      const catPlatos = cat?.platos || [];
      if (catPlatos.length > 0) {
        platosIds = catPlatos.map(cp => cp.plato_id || cp.id).filter(Boolean);
        unidades = {};
        catPlatos.forEach(cp => {
          const pid = cp.plato_id || cp.id;
          if (pid) unidades[pid] = (cp.cantidad != null ? cp.cantidad : 1);
        });
      }
    }
    return { platosIds, unidades };
  };

  // === Desgloses de los TOTALES (para los desplegables) ===
  // Itera los menus_personalizados del raíz (que en multi-evento ya traen la
  // suma agregada de pax) y agrega por ingrediente / por plato / por tipo.

  const getDesgloseTotalIngredientes = () => {
    const acc = new Map(); // ing_id → { nombre, unidad, cantidad, precio, coste }

    // En multi-evento itera los menús de cada jornada (cada día redondea sus
    // propios no aprovechables por separado, los sobrantes no se reaprovechan).
    // Si no hay menús en jornadas, cae al raíz (single-evento o legacy).
    let menusAProcesar = [];
    const esMultiEvento = presupuesto?.es_multi_evento && Array.isArray(presupuesto?.jornadas) && presupuesto.jornadas.length > 0;
    if (esMultiEvento) {
      presupuesto.jornadas.forEach(j => (j.menus_personalizados || []).forEach(m => menusAProcesar.push(_resolverPlatosMenu(m))));
    }
    if (menusAProcesar.length === 0) {
      menusAProcesar = presupuesto?.menus_personalizados || [];
    }

    menusAProcesar.forEach(menuPers => {
      const numPersonas = menuPers.num_personas || 0;
      if (numPersonas <= 0) return;

      // Por menú: separar aprovechables (proporcional) de no aprovechables (redondeo)
      const aprovechables = new Map();   // ing_id → cantidad
      const noAprovechables = new Map(); // ing_id → { cantidad, envase }

      const { platosIds: _pids, unidades: _uds } = resolverPlatosConCatalogo(menuPers);
      (_pids || []).forEach(platoId => {
        const plato = platos.find(p => p.id === platoId);
        if (!plato || plato.activo === false) return;
        const uds = _uds?.[platoId] || 1;
        const porciones = plato.porciones || 1;
        const totales = uds * numPersonas;
        if (totales <= 0) return;

        Object.entries(plato.ingredientes || {}).forEach(([ingId, raw]) => {
          const cant = typeof raw === 'object' ? raw?.cantidad : raw;
          const cantNum = parseFloat(cant) || 0;
          if (cantNum <= 0) return;
          const cantidadTotal = (cantNum / porciones) * totales;
          const ing = ingredientesCatalogo.find(i => i.id === ingId);
          if (!ing) return;
          if (ing.aprovechable_entre_eventos === false) {
            const envase = ing.unidad_consumible && ing.unidad_consumible > 0
              ? ing.unidad_consumible
              : (ing.unidades_por_paquete && ing.unidades_por_paquete > 0 ? ing.unidades_por_paquete : 1);
            const entry = noAprovechables.get(ingId) || { cantidad: 0, envase };
            entry.cantidad += cantidadTotal;
            noAprovechables.set(ingId, entry);
          } else {
            aprovechables.set(ingId, (aprovechables.get(ingId) || 0) + cantidadTotal);
          }
        });
      });

      aprovechables.forEach((cantidad, ingId) => {
        const ing = ingredientesCatalogo.find(i => i.id === ingId);
        if (!ing) return;
        const precio = ing.precio_unitario || 0;
        const cur = acc.get(ingId) || { nombre: ing.nombre, unidad: ing.unidad || 'ud', cantidad: 0, precio, coste: 0 };
        cur.cantidad += cantidad;
        cur.coste += cantidad * precio;
        cur.precio = precio;
        acc.set(ingId, cur);
      });

      noAprovechables.forEach(({ cantidad, envase }, ingId) => {
        const ing = ingredientesCatalogo.find(i => i.id === ingId);
        if (!ing) return;
        const precio = ing.precio_unitario || 0;
        const envasesEnteros = Math.ceil(cantidad / (envase || 1));
        const cantidadReal = envasesEnteros * envase;
        const cur = acc.get(ingId) || { nombre: ing.nombre, unidad: ing.unidad || 'ud', cantidad: 0, precio, coste: 0 };
        cur.cantidad += cantidadReal;
        cur.coste += cantidadReal * precio;
        cur.precio = precio;
        acc.set(ingId, cur);
      });
    });

    const detalle = Array.from(acc.values())
      .filter(d => d.coste > 0)
      .sort((a, b) => b.coste - a.coste);
    return { total: detalle.reduce((s, d) => s + d.coste, 0), detalle };
  };

  const getDesgloseTotalPersonalCocina = () => {
    const acc = new Map(); // plato_id → { nombre, tiempo_min, coste }

    let menusAProcesar = [];
    const esMultiEvento = presupuesto?.es_multi_evento && Array.isArray(presupuesto?.jornadas) && presupuesto.jornadas.length > 0;
    if (esMultiEvento) {
      presupuesto.jornadas.forEach(j => (j.menus_personalizados || []).forEach(m => menusAProcesar.push(_resolverPlatosMenu(m))));
    }
    if (menusAProcesar.length === 0) {
      menusAProcesar = presupuesto?.menus_personalizados || [];
    }

    menusAProcesar.forEach(menuPers => {
      const numPersonas = menuPers.num_personas || 0;
      if (numPersonas <= 0) return;
      const menuCat = menuPers.menu_id ? menus.find(m => m.id === menuPers.menu_id) : null;
      if ((menuCat?.tipo_menu || '').toLowerCase() === 'otros') return;

      const { platosIds: _pidsPc } = resolverPlatosConCatalogo(menuPers);
      (_pidsPc || []).forEach(platoId => {
        const plato = platos.find(p => p.id === platoId);
        if (!plato || plato.activo === false) return;
        const tiempoActivo = plato.tiempo_activo_min || 0;
        const porciones = plato.porciones || 0;
        if (tiempoActivo <= 0 || porciones <= 0) return;
        const tiempoTotal = (tiempoActivo / porciones) * numPersonas;
        const coste = tiempoTotal * 0.26;
        const cur = acc.get(platoId) || { nombre: plato.nombre, tiempo_min: 0, coste: 0 };
        cur.tiempo_min += tiempoTotal;
        cur.coste += coste;
        acc.set(platoId, cur);
      });
    });

    const detalle = Array.from(acc.values())
      .filter(d => d.coste > 0)
      .sort((a, b) => b.coste - a.coste);
    return { total: detalle.reduce((s, d) => s + d.coste, 0), detalle };
  };

  // Desgloses de coste de todas las líneas del presupuesto (M-44): cada línea
  // de la cabecera (en multievento, sumada jornada a jornada) y, en un
  // multievento, las líneas que solo están en alguna jornada. [{ desglose }]
  const lineasCosteTotales = () => {
    const res = (presupuesto?.menus_personalizados || []).map(menu => ({ desglose: getDesgloseCostesMenu(menu) }));
    lineasSoloJornadas(presupuesto).forEach(x => res.push({ desglose: desgloseCostesLinea(x.linea) }));
    return res;
  };

  // Coste de los menús (ingredientes, material de elaboración, cocina y
  // personal del evento) de todo el presupuesto
  const getCosteMenusTotal = () => lineasCosteTotales()
    .reduce((sum, { desglose }) => sum + (desglose?.costeTotal || 0), 0);

  const getDesgloseTotalPersonalEvento = () => {
    const propio = { cantidad: 0, coste: 0 };
    const camareros = { cantidad: 0, coste: 0 };
    const extras = { cantidad: 0, coste: 0 };

    // `getDesgloseCostesMenu` ya calcula cada línea de la cabecera jornada a
    // jornada en un multievento (M-44); se suman además las líneas que solo
    // están en alguna jornada
    lineasCosteTotales().forEach(({ desglose: d }) => {
      if (!d) return;
      propio.cantidad += d.personalPropio?.cantidad || 0;
      propio.coste += d.personalPropio?.coste || 0;
      camareros.cantidad += d.camareros?.cantidad || 0;
      camareros.coste += d.camareros?.coste || 0;
      extras.cantidad += d.extras?.cantidad || 0;
      extras.coste += d.extras?.coste || 0;
    });
    const detalle = [
      { nombre: 'Personal propio', cantidad: propio.cantidad, coste: propio.coste },
      { nombre: 'Camareros', cantidad: camareros.cantidad, coste: camareros.coste },
      { nombre: 'Extras', cantidad: extras.cantidad, coste: extras.coste },
    ].filter(d => d.coste > 0);
    return { total: detalle.reduce((s, d) => s + d.coste, 0), detalle };
  };

  // Ajuste por la ORDEN DE PERSONAL EXTRA (misma regla que el backend en
  // `utils.calculate_presupuesto_costes`): si hay orden con personas, su coste
  // real sustituye al coste teórico de camareros de los menús de esa jornada.
  // El personal propio y los extras de los menús no se tocan.
  //
  // En multievento (M-44) el teórico de cada jornada son los camareros de SUS
  // líneas con sus personas; un multievento antiguo sin líneas en las
  // jornadas reparte el total entre las jornadas.
  const getAjusteOrdenPersonalExtra = () => {
    const vacio = { ajuste: 0, costeOrdenes: 0, camarerosSustituidos: 0, personasOrden: 0, hayOrden: false };
    if (!presupuesto) return vacio;

    // Coste teórico de camareros (mismo criterio que getDesgloseTotalPersonalEvento)
    const camarerosTeoricos = lineasCosteTotales()
      .reduce((sum, { desglose: d }) => sum + (d?.camareros?.coste || 0), 0);
    const lineasJornadas = lineasCostesMultievento(presupuesto);
    const teoricoDeJornada = (j) => (lineasJornadas.length > 0
      ? lineasJornadas.filter(x => x.jornadaId === j.id)
        .reduce((sum, x) => sum + (desgloseCostesLinea(x.linea, { sinExtraReal: true })?.camareros?.coste || 0), 0)
      : camarerosTeoricos / presupuesto.jornadas.length);

    const esMultiEvento = presupuesto.es_multi_evento && Array.isArray(presupuesto.jornadas) && presupuesto.jornadas.length > 0;

    if (!esMultiEvento) {
      const c = calcularCosteOrdenPersonal(presupuesto.orden_personal_extra);
      if (c.total_personas <= 0) return vacio;
      return {
        ajuste: c.coste_total - camarerosTeoricos,
        costeOrdenes: c.coste_total,
        camarerosSustituidos: camarerosTeoricos,
        personasOrden: c.total_personas,
        hayOrden: true,
      };
    }

    let ajuste = 0;
    let costeOrdenes = 0;
    let camarerosSustituidos = 0;
    let personasOrden = 0;
    let hayOrden = false;
    // Orden única del multievento (sus grupos de cada jornada) o, en
    // presupuestos antiguos sin ella, la orden de cada jornada
    presupuesto.jornadas.forEach(j => {
      const c = calcularCosteOrdenPersonal(ordenDeJornada(presupuesto, j));
      if (c.total_personas <= 0) return;
      const teoricoPorJornada = teoricoDeJornada(j);
      hayOrden = true;
      ajuste += c.coste_total - teoricoPorJornada;
      costeOrdenes += c.coste_total;
      camarerosSustituidos += teoricoPorJornada;
      personasOrden += c.total_personas;
    });
    if (!hayOrden) return vacio;
    return { ajuste, costeOrdenes, camarerosSustituidos, personasOrden, hayOrden };
  };

  // Cálculo de costes de material de alquiler
  const calculateCosteAlquiler = () => {
    const items = presupuesto.materiales_alquiler || [];
    let costeMateriales = 0;
    
    items.forEach(item => {
      const dias = item.dias || 1;
      const precioAlquiler = (item.precio_dia1 || 0) + Math.max(0, dias - 1) * (item.precio_dia_extra || 0);
      const costeLimpieza = item.coste_limpieza || 0;
      costeMateriales += (precioAlquiler + costeLimpieza) * (item.cantidad || 0);
    });
    
    const transporte = parseFloat(presupuesto.alquiler_transporte) || 0;
    const fianza = parseFloat(presupuesto.alquiler_fianza) || 0;
    
    return { costeMateriales, transporte, fianza, total: costeMateriales + transporte };
  };


  // Platos del presupuesto que ya NO existen en el catálogo. Su coste se
  // resuelve como 0 (platos.find no los encuentra), inflando el beneficio/margen.
  // Mismo criterio de resolución que el cálculo de coste (platos.find por id).
  const getPlatosFaltantes = () => {
    if (!platos || platos.length === 0) return []; // catálogo aún no cargado: no alarmar
    const faltantes = [];
    const seen = new Set();
    const revisar = (menusList) => {
      (menusList || []).forEach((menu) => {
        (menu.platos_ids || []).forEach((pid) => {
          if (pid && !seen.has(pid) && !platos.find((p) => p.id === pid)) {
            seen.add(pid);
            faltantes.push({ platoId: pid, menu: menu.nombre_menu || 'Menú' });
          }
        });
      });
    };
    revisar(presupuesto?.menus_personalizados);
    if (presupuesto?.es_multi_evento && Array.isArray(presupuesto?.jornadas)) {
      presupuesto.jornadas.forEach((j) => revisar(j.menus_personalizados));
    }
    return faltantes;
  };

  // Análisis financiero del formato anterior (beneficio y margen), U-40: con
  // los costes GUARDADOS del motor del servidor (GET /presupuestos/{id}/costes,
  // los mismos del Resumen del formato nuevo) y la venta del servidor
  // (`importe_base`; en multievento, la de todas las jornadas). Si el
  // presupuesto no tiene costes del motor nuevo (`costes_version` 2), no se
  // inventa un beneficio: `disponible` = false y el panel pide "Recalcular
  // costes". Antes se calculaba en el navegador sin alquiler, Quién va,
  // combustible del motor ni adaptaciones.
  const getAnalisisFinanciero = () => {
    const cg = costesGuardados;
    const motorNuevo = !!(cg && cg.guardado && cg.metodo === 'nuevo'
      && cg.coste_total !== null && cg.coste_total !== undefined);
    if (!motorNuevo) {
      return { disponible: false, cargando: !cg && cargandoCostes };
    }
    const costesTotal = Number(cg.coste_total) || 0;
    let ingresos;
    if (presupuesto?.es_multi_evento) {
      ingresos = basePresupuesto();
    } else {
      const baseServidor = presupuesto?.importe_base ?? presupuesto?.precio_total;
      ingresos = baseServidor !== null && baseServidor !== undefined && baseServidor !== ''
        ? (parseFloat(baseServidor) || 0)
        : (Number(cg.ingresos) || 0);
    }
    const beneficio = ingresos - costesTotal;
    const margen = ingresos > 0 ? (beneficio / ingresos * 100) : 0;
    return { disponible: true, costesTotal, ingresos, beneficio, margen };
  };
  // Evento ya celebrado (última fecha antes de hoy): sin botón de recalcular
  // en el formato anterior (nada nuevo se escribe en pasados)
  // U-96: el mismo criterio que el servidor (`eventoPasado`)
  const esEventoPasadoFicha = () => !!presupuesto && eventoPasado(presupuesto);

  const toggleMenuExpanded = (menuId) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuId]: !prev[menuId]
    }));
  };

  const togglePlatoExpanded = (platoId) => {
    setExpandedPlatos(prev => ({
      ...prev,
      [platoId]: !prev[platoId]
    }));
  };

  const handleDeleteItem = async (item) => {
    // Multievento: la línea se quita también de las jornadas donde esté
    const lineaQuitada = (esMultieventoFicha() && item.type === 'menu' && item.personalizadoIndex !== undefined)
      ? presupuesto.menus_personalizados?.[item.personalizadoIndex] : null;
    const pregunta = lineaQuitada
      ? `¿Eliminar "${item.concepto}" del presupuesto? Se quitará también de las jornadas donde esté.`
      : `¿Eliminar "${item.concepto}" del presupuesto?`;
    if (!window.confirm(pregunta)) {
      return;
    }

    try {
      let updatedPresupuesto = { ...presupuesto };

      if (item.type === 'menu') {
        // Si el menú está en menus_personalizados
        if (item.personalizadoIndex !== undefined && presupuesto.menus_personalizados) {
          const menusPersonalizados = [...presupuesto.menus_personalizados];
          menusPersonalizados.splice(item.personalizadoIndex, 1);
          const quitado = item.personalizadoIndex;
          updatedPresupuesto.menus_personalizados = remapearAcompana(menusPersonalizados,
            (x) => (x === quitado ? null : (x > quitado ? x - 1 : x)));
        } else {
          // Fallback: eliminar de menus_ids (deprecated)
          updatedPresupuesto.menus_ids = presupuesto.menus_ids.filter(id => id !== item.id);
        }
      } else if (item.type === 'plato') {
        updatedPresupuesto.platos_ids = presupuesto.platos_ids.filter(id => id !== item.id);
      }

      // Recalcular totales y actualizar índices
      let newItems = items.filter((_, idx) => {
        if (item.personalizadoIndex !== undefined) {
          return _.personalizadoIndex !== item.personalizadoIndex || _.type !== item.type;
        }
        return _.id !== item.id || _.type !== item.type;
      });
      
      // Actualizar los personalizadoIndex de los items restantes después de eliminar
      if (item.personalizadoIndex !== undefined) {
        newItems = newItems.map(i => {
          if (i.type === 'menu' && i.personalizadoIndex !== undefined && i.personalizadoIndex > item.personalizadoIndex) {
            return { ...i, personalizadoIndex: i.personalizadoIndex - 1 };
          }
          return i;
        });
      }
      
      setItems(newItems);

      const newSubtotal = newItems.reduce((sum, i) => sum + calculateImporte(i), 0);
      const newIva = newItems.reduce((sum, i) => sum + calculateIva(i), 0);
      const newTotal = newSubtotal + newIva;

      updatedPresupuesto.importe_base = newSubtotal;
      updatedPresupuesto.iva = newIva;
      updatedPresupuesto.importe_total = newTotal;

      aplicarRespuestaGuardado(await guardarFicha(updatedPresupuesto), updatedPresupuesto);
      if (lineaQuitada) {
        await presupuestosAPI.quitarLineaMultievento(presupuesto.id, {
          menu_id: lineaQuitada.menu_id || null,
          nombre_menu: lineaQuitada.menu_id ? null : (lineaQuitada.nombre_menu || null),
          // Línea propia de la cabecera (otro precio para algunas jornadas): solo sus copias
          linea_id: lineaQuitada.linea_id || null,
          jornadas_ids: null,
        });
        await alActualizarMultievento();
      }
      avisoGuardadoOk('Elemento eliminado correctamente');
    } catch (error) {
      console.error('Error deleting item:', error);
      avisoGuardadoError('Error al eliminar el elemento', error);
    }
  };

  // ===== FUNCIONES PARA SUPLEMENTOS =====
  const handleAddSuplemento = async () => {
    // Formato nuevo: el suplemento no se vincula a ningún menú
    if ((!formatoNuevo && !suplementoForm.menu_vinculado_id) || !suplementoForm.nombre || !suplementoForm.precio_unitario || !suplementoForm.unidades) {
      alert('Por favor completa todos los campos obligatorios');
      return;
    }

    try {
      const menuVinculado = presupuesto.menus_personalizados?.find(
        m => m.menu_id === suplementoForm.menu_vinculado_id
      );
      
      // Unidades con decimales (0,5 h de la hora extra del lunch) y coma decimal
      const unidadesSup = numeroDecimal(suplementoForm.unidades);
      if (!(unidadesSup > 0)) {
        alert('Las unidades deben ser un número mayor que 0 (admite decimales: 0,5)');
        return;
      }
      const totalBruto = redondear2(parseFloat(suplementoForm.precio_unitario) * unidadesSup);
      const descuento = parseFloat(suplementoForm.descuento) || 0;
      const totalNeto = Math.max(0, totalBruto - descuento); // No permitir totales negativos
      
      const nuevoSuplemento = {
        id: `sup_${Date.now()}`,
        menu_vinculado_id: formatoNuevo ? '' : suplementoForm.menu_vinculado_id,
        menu_vinculado_nombre: formatoNuevo ? '' : (menuVinculado?.nombre_menu || 'Menú'),
        nombre: suplementoForm.nombre,
        precio_unitario: parseFloat(suplementoForm.precio_unitario),
        unidades: unidadesSup,
        total_bruto: totalBruto, // Total antes del descuento
        descuento: descuento, // Descuento aplicado
        total: totalNeto, // Total después del descuento
        iva: parseInt(suplementoForm.iva), // IVA seleccionado
        es_cortesia: suplementoForm.es_cortesia,
        motivo_cortesia: suplementoForm.motivo_cortesia || ''
      };

      const suplementosActuales = presupuesto.suplementos || [];
      const nuevosSuplementos = [...suplementosActuales, nuevoSuplemento];

      // Totales con la regla única (U-10): el servidor los vuelve a calcular al guardar
      const { base: newSubtotal, cuota: newIva, total: newTotal } = totalesDesdeItems(items, nuevosSuplementos);

      const updatedPresupuesto = {
        ...presupuesto,
        suplementos: nuevosSuplementos,
        importe_base: newSubtotal,
        iva: newIva,
        importe_total: newTotal
      };

      aplicarRespuestaGuardado(await guardarFicha(updatedPresupuesto), updatedPresupuesto);
      
      // Reset form y cerrar modal
      setSuplementoForm({
        menu_vinculado_id: '',
        nombre: '',
        precio_unitario: '',
        unidades: '',
        iva: '10',
        descuento: '',
        es_cortesia: false,
        motivo_cortesia: ''
      });
      setShowAddSuplementoModal(false);
    } catch (error) {
      console.error('Error adding suplemento:', error);
      avisoGuardadoError('Error al añadir suplemento', error);
    }
  };

  const handleDeleteSuplemento = async (suplementoId) => {
    if (!window.confirm('¿Eliminar este suplemento?')) return;

    try {
      const nuevosSuplementos = (presupuesto.suplementos || []).filter(s => s.id !== suplementoId);
      
      // Totales con la regla única (U-10): el servidor los vuelve a calcular al guardar
      const { base: newSubtotal, cuota: newIva, total: newTotal } = totalesDesdeItems(items, nuevosSuplementos);

      const updatedPresupuesto = {
        ...presupuesto,
        suplementos: nuevosSuplementos,
        importe_base: newSubtotal,
        iva: newIva,
        importe_total: newTotal
      };

      aplicarRespuestaGuardado(await guardarFicha(updatedPresupuesto), updatedPresupuesto);
    } catch (error) {
      console.error('Error deleting suplemento:', error);
      avisoGuardadoError('Error al eliminar suplemento', error);
    }
  };

  const handleToggleCortesiaSuplemento = async (suplementoId) => {
    try {
      const nuevosSuplementos = (presupuesto.suplementos || []).map(s => {
        if (s.id === suplementoId) {
          return { ...s, es_cortesia: !s.es_cortesia };
        }
        return s;
      });
      
      // Totales con la regla única (U-10): el servidor los vuelve a calcular al guardar
      const { base: newSubtotal, cuota: newIva, total: newTotal } = totalesDesdeItems(items, nuevosSuplementos);

      const updatedPresupuesto = {
        ...presupuesto,
        suplementos: nuevosSuplementos,
        importe_base: newSubtotal,
        iva: newIva,
        importe_total: newTotal
      };

      aplicarRespuestaGuardado(await guardarFicha(updatedPresupuesto), updatedPresupuesto);
    } catch (error) {
      console.error('Error toggling cortesia:', error);
    }
  };

  // Plantillas rápidas del modal "Añadir suplemento". Precios e IVA desde
  // GET /api/reglas-comerciales (un único sitio para los números de negocio).
  // Con el formato anterior, las plantillas de siempre (fijas).
  const plantillasSuplemento = useMemo(() => {
    if (!formatoNuevo) {
      return {
        'coffee': { nombre: 'Suplemento mínimo 40 personas (Coffee)', precio_unitario: '3.50', iva: '10' },
        'lunch': { nombre: 'Suplemento mínimo 40 personas (Lunch)', precio_unitario: '6.50', iva: '10' },
        'coctel': { nombre: 'Suplemento mínimo 40 personas (Cóctel/Vino)', precio_unitario: '10.00', iva: '10' }
      };
    }
    const sm = reglasComerciales?.suplemento_minimo;
    const cam = reglasComerciales?.camareros;
    if (!sm || !cam) return {};
    const minimo = sm.minimo_personas;
    const precio = (v) => Number(v || 0).toFixed(2);
    return {
      coffee: { nombre: `Suplemento mínimo ${minimo} personas (Coffee)`, precio_unitario: precio(sm.tarifas?.coffee), iva: String(sm.iva) },
      lunch: { nombre: `Suplemento mínimo ${minimo} personas (Lunch)`, precio_unitario: precio(sm.tarifas?.lunch), iva: String(sm.iva) },
      coctel: { nombre: `Suplemento mínimo ${minimo} personas (Cóctel/Vino)`, precio_unitario: precio(sm.tarifas?.coctel), iva: String(sm.iva) },
      camarero_extra: { nombre: cam.extra_por_hora?.nombre, precio_unitario: precio(cam.extra_por_hora?.precio), iva: String(cam.extra_por_hora?.iva) },
      solo_camareros: { nombre: cam.solo_camareros_por_hora?.nombre, precio_unitario: precio(cam.solo_camareros_por_hora?.precio), iva: String(cam.solo_camareros_por_hora?.iva) },
    };
  }, [formatoNuevo, reglasComerciales]);

  const aplicarPlantillaSuplemento = (tipo) => {
    const plantilla = plantillasSuplemento[tipo];
    if (plantilla) {
      setSuplementoForm(prev => ({
        ...prev,
        nombre: plantilla.nombre,
        precio_unitario: plantilla.precio_unitario,
        iva: plantilla.iva
      }));
    }
  };

  // FASE 2: Funciones para editar detalles de menú
  const handleStartEditingMenu = (menuIndex) => {
    const menuPers = presupuesto.menus_personalizados[menuIndex];
    setEditingMenuIndex(menuIndex);
    setEditedMenuDetails({
      personal_propio_real: menuPers.personal_propio_real || 0,
      personal_extra_real: menuPers.personal_extra_real || 0,
      cargar_personal_propio: menuPers.cargar_personal_propio !== false,
      cargar_personal_extra: menuPers.cargar_personal_extra !== false,
      material_fijo: menuPers.material_fijo || [],
      material_por_persona: menuPers.material_por_persona || [],
      textiles: menuPers.textiles || [],
      precio_unitario: menuPers.precio_unitario || 0
    });
  };

  const handleCancelEditingMenu = () => {
    setEditingMenuIndex(null);
    setEditedMenuDetails({});
  };

  const handleSaveMenuDetails = async (menuIndex) => {
    try {
      const updatedMenusPersonalizados = [...presupuesto.menus_personalizados];
      updatedMenusPersonalizados[menuIndex] = {
        ...updatedMenusPersonalizados[menuIndex],
        ...editedMenuDetails
      };

      // Recalcular totales si cambió el precio_unitario
      const updatedItems = [...items];
      const itemIndex = updatedItems.findIndex(item => item.personalizadoIndex === menuIndex);
      if (itemIndex !== -1) {
        updatedItems[itemIndex].precio_ud = editedMenuDetails.precio_unitario;
      }

      const newSubtotal = updatedItems.reduce((sum, i) => sum + calculateImporte(i), 0);
      const newIva = updatedItems.reduce((sum, i) => sum + calculateIva(i), 0);
      const newTotal = newSubtotal + newIva;

      const updatedPresupuesto = {
        ...presupuesto,
        menus_personalizados: updatedMenusPersonalizados,
        importe_base: newSubtotal,
        iva: newIva,
        importe_total: newTotal
      };

      await guardarFicha(updatedPresupuesto);
      
      // Recargar datos
      await fetchData();
      setEditingMenuIndex(null);
      setEditedMenuDetails({});
      avisoGuardadoOk('Detalles del menú actualizados correctamente');
    } catch (error) {
      console.error('Error saving menu details:', error);
      avisoGuardadoError('Error al guardar los cambios: ' + (error.response?.data?.detail || error.message), error);
    }
  };

  const handleUpdateEditedDetail = (field, value) => {
    setEditedMenuDetails(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // FASE 2: Funciones para configuración avanzada de menú
  const handleOpenConfigMenu = (menuIndex) => {
    const menuPers = presupuesto.menus_personalizados[menuIndex];
    const menuCatalogo = menuPers.menu_id ? menus.find(m => m.id === menuPers.menu_id) : null;
    
    // Priorizar config_personalizada si existe, sino usar catálogo
    const config = menuPers.config_personalizada || menuCatalogo;
    
    setConfigMenuIndex(menuIndex);
    setConfigMenuTab('personal');
    setConfigMenuData({
      // Personal - usar valores de config_personalizada si existe, sino del catálogo, sino defaults
      ratio_camareros: config?.ratio_camareros ?? 20,
      ratio_extras: config?.ratio_extras ?? 100,
      horas_por_camarero: config?.horas_por_camarero ?? 4,
      coste_camarero_hora: config?.coste_camarero_hora ?? 25,
      // Tiempos - usar valores de config_personalizada si existe
      tiempo_montaje_min: config?.tiempo_montaje_min ?? 60,
      duracion_evento_min: config?.duracion_evento_min ?? 120,
      tiempo_desmontaje_min: config?.tiempo_desmontaje_min ?? 60,
      instrucciones_montaje: config?.instrucciones_montaje ?? '',
      // Material
      material_fijo: config?.material_fijo ?? [],
      material_por_persona: config?.material_por_persona ?? [],
      textiles: config?.textiles ?? []
    });
    setShowConfigMenuModal(true);
  };

  const handleCloseConfigMenu = () => {
    setShowConfigMenuModal(false);
    setConfigMenuIndex(null);
    setConfigMenuTab('personal');
    setConfigMenuData({
      ratio_camareros: 20,
      ratio_extras: 100,
      horas_por_camarero: 4,
      coste_camarero_hora: 25,
      tiempo_montaje_min: 60,
      duracion_evento_min: 120,
      tiempo_desmontaje_min: 60,
      instrucciones_montaje: '',
      material_fijo: [],
      material_por_persona: [],
      textiles: []
    });
  };

  const handleSaveConfigMenu = async () => {
    try {
      const updatedMenusPersonalizados = [...presupuesto.menus_personalizados];
      const menuPers = updatedMenusPersonalizados[configMenuIndex];
      
      // Crear un menú personalizado con la configuración actualizada
      // Esto sobrescribe la configuración del catálogo para este presupuesto específico
      updatedMenusPersonalizados[configMenuIndex] = {
        ...menuPers,
        // Guardar la configuración personalizada
        config_personalizada: {
          ...configMenuData
        },
        // Flag para indicar que tiene configuración personalizada
        tiene_config_personalizada: true
      };

      const updatedPresupuesto = {
        ...presupuesto,
        menus_personalizados: updatedMenusPersonalizados
      };

      await guardarFicha(updatedPresupuesto);
      
      // Recargar datos
      await fetchData();
      handleCloseConfigMenu();
      avisoGuardadoOk('Configuración del menú actualizada correctamente');
    } catch (error) {
      console.error('Error saving config menu:', error);
      avisoGuardadoError('Error al guardar la configuración: ' + (error.response?.data?.detail || error.message), error);
    }
  };

  const handleUpdateConfigMenu = (field, value) => {
    setConfigMenuData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleAddMaterialFijo = () => {
    setEditedMenuDetails(prev => ({
      ...prev,
      material_fijo: [
        ...(prev.material_fijo || []),
        { nombre: '', cantidad: 0, coste_unitario: 0 }
      ]
    }));
  };

  const handleRemoveMaterialFijo = (index) => {
    setEditedMenuDetails(prev => ({
      ...prev,
      material_fijo: prev.material_fijo.filter((_, i) => i !== index)
    }));
  };

  const handleUpdateMaterialFijo = (index, field, value) => {
    setEditedMenuDetails(prev => ({
      ...prev,
      material_fijo: prev.material_fijo.map((item, i) => 
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  const handleAddMaterialPorPersona = () => {
    setEditedMenuDetails(prev => ({
      ...prev,
      material_por_persona: [
        ...(prev.material_por_persona || []),
        { nombre: '', cantidad_pp: 0, coste_unitario: 0 }
      ]
    }));
  };

  const handleRemoveMaterialPorPersona = (index) => {
    setEditedMenuDetails(prev => ({
      ...prev,
      material_por_persona: prev.material_por_persona.filter((_, i) => i !== index)
    }));
  };

  const handleUpdateMaterialPorPersona = (index, field, value) => {
    setEditedMenuDetails(prev => ({
      ...prev,
      material_por_persona: prev.material_por_persona.map((item, i) => 
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  const handleAddTextil = () => {
    setEditedMenuDetails(prev => ({
      ...prev,
      textiles: [
        ...(prev.textiles || []),
        { nombre: '', cantidad: 0, coste_lavanderia: 0 }
      ]
    }));
  };

  const handleRemoveTextil = (index) => {
    setEditedMenuDetails(prev => ({
      ...prev,
      textiles: prev.textiles.filter((_, i) => i !== index)
    }));
  };

  const handleUpdateTextil = (index, field, value) => {
    setEditedMenuDetails(prev => ({
      ...prev,
      textiles: prev.textiles.map((item, i) => 
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  // Función auxiliar para cargar contactos incluyendo el principal si es necesario
  const cargarContactosConPrincipal = async (clienteId, clienteData = null) => {
    const personasRes = await personasContactoAPI.getAll(clienteId);
    let contactos = personasRes.data || [];
    
    // Si no hay contactos y el cliente tiene email, agregar el contacto principal
    const clienteActual = clienteData || cliente;
    if (contactos.length === 0 && clienteActual && clienteActual.email) {
      contactos = [{
        id: 'principal',
        nombre: clienteActual.persona_contacto || clienteActual.nombre_empresa || 'Cliente',
        email: clienteActual.email,
        telefono: clienteActual.telefono || '',
        cargo: 'Contacto Principal',
        cliente_id: clienteId,
        es_principal: true
      }];
    } else if (contactos.length > 0 && clienteActual && clienteActual.email) {
      // Si hay contactos pero ninguno es el principal, agregarlo al principio
      const tienePrincipal = contactos.some(c => c.id === 'principal');
      if (!tienePrincipal) {
        contactos.unshift({
          id: 'principal',
          nombre: clienteActual.persona_contacto || clienteActual.nombre_empresa || 'Cliente',
          email: clienteActual.email,
          telefono: clienteActual.telefono || '',
          cargo: 'Contacto Principal',
          cliente_id: clienteId,
          es_principal: true
        });
      }
    }
    
    return contactos;
  };

  // Funciones para gestión de personas de contacto
  const handleCreateContacto = async () => {
    if (!newContacto.nombre) {
      alert('El nombre es obligatorio');
      return;
    }

    try {
      const response = await personasContactoAPI.create({
        cliente_id: presupuesto.cliente_id,
        ...newContacto
      });
      

      // Recargar personas de contacto del servidor incluyendo el principal
      const contactos = await cargarContactosConPrincipal(presupuesto.cliente_id);
      setPersonasContacto(contactos);

      // Seleccionar automáticamente el nuevo contacto creado
      if (response.data && response.data.id) {
        const updatedPresupuesto = {
          ...presupuesto,
          persona_contacto_id: response.data.id
        };
        aplicarRespuestaGuardado(await guardarFicha(updatedPresupuesto), updatedPresupuesto);
      }

      // Reset y cerrar modal
      setNewContacto({
        nombre: '',
        cargo: '',
        email: '',
        telefono: '',
        telefono_prefijo: '',
        extension: '',
        notas: ''
      });
      setShowNewContactoModal(false);
      avisoGuardadoOk('Persona de contacto creada y seleccionada correctamente');
    } catch (error) {
      console.error('❌ Error creating contacto:', error);
      console.error('Error details:', error.response?.data);
      avisoGuardadoError('Error al crear persona de contacto: ' + (error.response?.data?.detail || error.message), error);
    }
  };

  const handleUpdateContacto = async (field, value) => {
    try {
      // Asegurar que el valor sea null si es cadena vacía
      const finalValue = value === '' ? null : value;
      
      const updatedPresupuesto = {
        ...presupuesto,
        [field]: finalValue
      };

      
      aplicarRespuestaGuardado(await guardarFicha(updatedPresupuesto), updatedPresupuesto);
      
    } catch (error) {
      console.error('Error updating contacto:', error);
      avisoGuardadoError('Error al actualizar contacto: ' + (error.response?.data?.detail || error.message), error);
    }
  };

  // Pagos: la tarjeta de pagos legacy (alta y borrado de `pagos` a mano) se
  // retiró del detalle; sus manejadores se quitan (U-78). Lo pagado sale del
  // sync de cobros (`total_pagado`).
  const calculateTotalPagado = () => {
    // Incluir pago_reserva importado + pagos manuales
    let total = presupuesto.pago_reserva || 0;
    if (presupuesto.pagos && presupuesto.pagos.length > 0) {
      total += presupuesto.pagos.reduce((sum, pago) => sum + (pago.cantidad || 0), 0);
    }
    return total;
  };

  const calculatePendiente = () => {
    return totalPresupuesto() - calculateTotalPagado();
  };

  // Cargar ingresos bancarios sin vincular para este cliente
  const cargarIngresosSinVincular = async () => {
    setBuscandoIngresos(true);
    try {
      const token = getAuthToken();
      const pendiente = calculatePendiente();
      
      // Buscar ingresos sin vincular, ordenados por cercanía al importe pendiente
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/finanzas/abonos/sin-vincular?limit=50${pendiente > 0 ? `&importe_ref=${pendiente}` : ''}`;
      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setIngresosDisponibles(data.abonos || []);
      }
    } catch (error) {
      console.error('Error cargando ingresos:', error);
    } finally {
      setBuscandoIngresos(false);
    }
  };

  // Vincular un ingreso bancario a este presupuesto
  const vincularIngresoBancario = async (abonoId, importe) => {
    if (!window.confirm(`¿Vincular este ingreso de €${importe.toFixed(2)} al presupuesto #${presupuesto.numero}?`)) {
      return;
    }
    
    setVinculandoIngreso(true);
    try {
      const token = getAuthToken();
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/finanzas/abonos/${abonoId}/vincular-presupuesto?presupuesto_id=${id}`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      if (response.ok) {
        const result = await response.json();
        
        // Actualizar el presupuesto localmente
        setPresupuesto(prev => ({
          ...prev,
          total_pagado: result.total_pagado,
          estado_pago: result.estado_pago
        }));
        
        // Cerrar modal y mostrar éxito
        setShowNewPagoModal(false);
        setTipoPagoModal(null);
        alert(`✅ Ingreso vinculado correctamente.\nTotal pagado: €${result.total_pagado?.toFixed(2)}\nPendiente: €${result.pendiente?.toFixed(2)}`);
        
        // Recargar datos del presupuesto para sincronizar
        fetchData();
      } else {
        const error = await response.json();
        alert('Error: ' + (error.detail || 'No se pudo vincular el ingreso'));
      }
    } catch (error) {
      console.error('Error vinculando ingreso:', error);
      alert('Error al vincular: ' + error.message);
    } finally {
      setVinculandoIngreso(false);
    }
  };

  // Filtrar ingresos por búsqueda
  const ingresosFiltrados = ingresosDisponibles.filter(ingreso => {
    if (!busquedaIngreso) return true;
    const q = busquedaIngreso.toLowerCase();
    return (
      ingreso.concepto?.toLowerCase().includes(q) ||
      ingreso.importe?.toString().includes(q) ||
      ingreso.fecha?.includes(q)
    );
  });

  // Calcula coste de ingredientes con redondeo a envase para no aprovechables.
  // Regla: ingredientes con aprovechable_entre_eventos = false se redondean al alza al
  // tamaño del envase, sumando cantidades del mismo ingrediente usadas en varios platos.
  const calcularCosteIngredientesMenu = (platosDelMenu, numPersonas) => {
    let costeReutilizable = 0;
    const noReutilizables = {}; // {ing_id: {cantidad, precio, envase}}

    // En multi-evento la cantidad teórica del raíz (51 pax) representa N
    // jornadas. Para redondear correctamente los no aprovechables, calculamos
    // por jornada y multiplicamos: 3×ceil(25.5/20)*20 = 120 (no ceil(76.5/20)*20=80).
    const esMultiEvento = presupuesto?.es_multi_evento && Array.isArray(presupuesto?.jornadas) && presupuesto.jornadas.length > 0;
    const numJornadas = esMultiEvento ? presupuesto.jornadas.length : 1;
    const paxJornada = numPersonas / numJornadas;

    platosDelMenu.forEach(platoItem => {
      const plato = platos.find(p => p.id === platoItem.plato_id);
      if (!plato || plato.activo === false) return;
      const udsPlatoPorPersona = platoItem.cantidad || 1;
      const porcionesReceta = plato.porciones || 1;
      const porcionesTotales = udsPlatoPorPersona * numPersonas;
      if (porcionesTotales <= 0) return;

      const ingredientesPlato = plato.ingredientes || {};
      Object.entries(ingredientesPlato).forEach(([ingId, rawCantidad]) => {
        let cantidadReceta = rawCantidad;
        if (cantidadReceta && typeof cantidadReceta === 'object') {
          cantidadReceta = cantidadReceta.cantidad;
        }
        cantidadReceta = parseFloat(cantidadReceta);
        if (!cantidadReceta || cantidadReceta <= 0) return;

        const cantidadTotalEvento = (cantidadReceta / porcionesReceta) * porcionesTotales;
        const ingrediente = ingredientesCatalogo.find(i => i.id === ingId);
        if (!ingrediente) return;
        const precio = ingrediente.precio_unitario || 0;

        if (ingrediente.aprovechable_entre_eventos === false) {
          // Espejo de utils.py: unidad_consumible (brick/lata) prevalece sobre
          // unidades_por_paquete (caja entera). Para soja: cobra por brick (1L)
          // en vez de por caja (6L) cuando solo se abre un brick.
          const envase = ingrediente.unidad_consumible && ingrediente.unidad_consumible > 0
            ? ingrediente.unidad_consumible
            : (ingrediente.unidades_por_paquete && ingrediente.unidades_por_paquete > 0
              ? ingrediente.unidades_por_paquete : 1);
          if (!noReutilizables[ingId]) {
            noReutilizables[ingId] = { cantidad: 0, precio, envase };
          }
          noReutilizables[ingId].cantidad += cantidadTotalEvento;
        } else {
          costeReutilizable += cantidadTotalEvento * precio;
        }
      });
    });

    let costeNoReutilizable = 0;
    Object.values(noReutilizables).forEach(data => {
      const envase = data.envase > 0 ? data.envase : 1;
      // Redondeo POR JORNADA: cantidad total / N jornadas → redondear → × N.
      // En single-evento N=1 y queda como antes.
      const cantidadPorJornada = data.cantidad / numJornadas;
      const envasesPorJornada = Math.ceil(cantidadPorJornada / envase);
      const cantidadRealPorJornada = envasesPorJornada * envase;
      costeNoReutilizable += cantidadRealPorJornada * numJornadas * data.precio;
    });

    return costeReutilizable + costeNoReutilizable;
  };

  // Coste del MATERIAL DE ELABORACIÓN (menaje/consumibles puestos dentro de los
  // platos, p. ej. "servicio mesa sentado"). Mismo criterio que las estadísticas
  // de proveedores: solo consumibles/desechables, escalado por ración × personas.
  // Antes el análisis financiero NO lo contaba (salía "material y menaje" a 0).
  const calcularCosteMaterialElaboracionMenu = (platosDelMenu, numPersonas) => {
    let total = 0;
    const items = [];
    (platosDelMenu || []).forEach(platoItem => {
      const plato = platos.find(p => p.id === platoItem.plato_id);
      if (!plato || plato.activo === false) return;
      const udsPlatoPorPersona = platoItem.cantidad || 1;
      const porcionesReceta = plato.porciones || 1;
      (plato.material_elaboracion || []).forEach(it => {
        if (!it || typeof it !== 'object') return;
        const cant = parseFloat(it.cantidad) || 0;
        if (cant <= 0) return;
        const mat = (it.material_id && materiales.find(m => m.id === it.material_id))
          || materiales.find(m => (m.nombre || '').trim().toLowerCase() === (it.nombre || '').trim().toLowerCase());
        const esConsumible = mat && ((mat.tipo_coste || '').toLowerCase() === 'consumible' || (mat.categoria || '').toLowerCase() === 'desechable');
        if (!esConsumible) return;
        const precioItem = parseFloat(it.coste_unitario);
        const precio = (precioItem && precioItem > 0) ? precioItem : (parseFloat(mat.precio_unitario) || 0);
        if (precio <= 0) return;
        const tipoUso = it.tipo_uso;
        const upm = parseFloat(it.unidades_plato);
        let cantNec;
        if (tipoUso === 'por_unidades' && Number.isFinite(upm) && upm > 0) {
          // Por unidad: escala con las raciones (cada upm raciones, una "cant").
          // No le afecta el redondeo de elaboraciones.
          cantNec = (cant / upm) * udsPlatoPorPersona * numPersonas;
        } else {
          // Fijo = por elaboración: "cant" por cada elaboración (porciones raciones).
          // Si el plato va en elaboraciones enteras, se redondea hacia arriba.
          let numElab = (udsPlatoPorPersona * numPersonas) / (porcionesReceta || 1);
          if (plato.elaboracion_entera) numElab = Math.ceil(numElab);
          cantNec = cant * numElab;
        }
        const coste = cantNec * precio;
        total += coste;
        items.push({ nombre: it.nombre || mat.nombre || 'Material', cantidad: cantNec, unidad: it.unidad || mat.unidad || 'ud', precio, coste });
      });
    });
    return { total, items };
  };

  // Desglose informativo del TOTAL de material y menaje del presupuesto:
  // material a nivel de menú (plantilla/textiles) + menaje dentro de los platos
  // (material de elaboración). SOLO informativo (no afecta al margen, que ya
  // cuenta el menaje de los platos dentro del coste de cada menú).
  const getDesgloseTotalMaterialMenaje = () => {
    const base = getDesgloseCosteMaterial();
    const acc = new Map();
    base.detalle.forEach(d => acc.set((d.nombre || '').trim().toLowerCase(), { ...d }));
    let total = base.total;

    const todosMenus = [];
    if (presupuesto?.es_multi_evento && Array.isArray(presupuesto.jornadas) && presupuesto.jornadas.length > 0) {
      presupuesto.jornadas.forEach(j => (j.menus_personalizados || []).forEach(m => todosMenus.push(m)));
    }
    if (todosMenus.length === 0) {
      (presupuesto?.menus_personalizados || []).forEach(m => todosMenus.push(m));
    }
    todosMenus.forEach(menuPers => {
      const numPersonas = menuPers.num_personas || 0;
      if (numPersonas <= 0) return;
      const { platosIds: _pidsM, unidades: _udsM } = resolverPlatosConCatalogo(menuPers);
      const pdm = (_pidsM || []).map(pid => ({ plato_id: pid, cantidad: _udsM?.[pid] || 1 }));
      const { items } = calcularCosteMaterialElaboracionMenu(pdm, numPersonas);
      items.forEach(it => {
        const nm = (it.nombre || '').trim().toLowerCase();
        const cur = acc.get(nm) || { nombre: it.nombre, cantidad: 0, unidad: it.unidad, precio: it.precio, coste: 0 };
        cur.cantidad += it.cantidad;
        cur.coste += it.coste;
        cur.precio = it.precio;
        acc.set(nm, cur);
        total += it.coste;
      });
    });

    const detalle = Array.from(acc.values()).filter(d => d.coste > 0).sort((a, b) => b.coste - a.coste);
    return { total, detalle };
  };

  // Calcular coste real de un menú. Multievento (M-44): una línea de la
  // cabecera suma el coste de sus líneas en cada jornada, con las personas de
  // cada una; evento de un día, como siempre.
  const calculateCosteMenu = (menuPersonalizado) => {
    if (!menuPersonalizado) return 0;
    const deJornadas = lineasJornadaDeCabecera(menuPersonalizado, presupuesto);
    if (deJornadas.length === 0) return costeMenuLinea(menuPersonalizado);
    return deJornadas.reduce((suma, x) => suma + costeMenuLinea(x.linea), 0);
  };

  // Personas entre las que se reparte el coste de una línea ("coste/pers"): en
  // un multievento, la suma de sus jornadas
  const personasCosteMenu = (menuPersonalizado) => (
    personasLineaCabecera(menuPersonalizado, presupuesto) || menuPersonalizado?.num_personas || 0
  );

  // Coste real de UNA línea con sus personas (un día)
  const costeMenuLinea = (menuPersonalizado) => {
    if (!menuPersonalizado) return 0;

    let costeTotal = 0;
    // Personas por defecto (M-98): en un multievento, las de una jornada
    const numPersonas = menuPersonalizado.num_personas || personasPorDefectoLinea(presupuesto, null, 1);

    // Determinar si es un presupuesto histórico (evento pasado + confirmado;
    // M-101: en un multievento, cuando ha pasado su última jornada)
    const eventoYaPaso = eventoPasado(presupuesto);
    const estaConfirmado = presupuesto.estado === 'confirmado';
    const esHistorico = eventoYaPaso && estaConfirmado;
    
    // SOLO usar coste_unitario_legacy si es histórico
    if (esHistorico && menuPersonalizado.coste_unitario_legacy !== undefined && menuPersonalizado.coste_unitario_legacy !== null) {
      return menuPersonalizado.coste_unitario_legacy * numPersonas;
    }
    
    // Buscar menú en catálogo para obtener configuración
    let menuCatalogo = null;
    if (menuPersonalizado.menu_id) {
      menuCatalogo = menus.find(m => m.id === menuPersonalizado.menu_id);
    }
    
    // Usar configuración personalizada si existe, sino usar catálogo
    const config = menuPersonalizado.config_personalizada || menuCatalogo;
    
    // Tipo "otros" (menús complementarios: suplementos, alquileres, envíos) no
    // arrastra el personal implícito del evento (propio + cocina), pero SÍ cuenta
    // los camareros/extras que tenga configurados a propósito: hay suplementos que
    // son exactamente eso (ej. "Servicio camarero", 1 camarero por unidad).
    const tipoMenu = menuCatalogo?.tipo_menu || '';
    const excluirPersonalPropio = tipoMenu === 'otros';

    // 1. COSTE DE PLATOS (ingredientes) - Filtrar platos inactivos
    let platosDelMenu = [];
    if (menuPersonalizado.platos_ids && menuPersonalizado.platos_ids.length > 0) {
      platosDelMenu = menuPersonalizado.platos_ids.map(platoId => ({
        plato_id: platoId,
        cantidad: menuPersonalizado.unidades_por_plato?.[platoId] || 1
      }));
    } else if (menuCatalogo && menuCatalogo.platos && menuCatalogo.platos.length > 0) {
      platosDelMenu = menuCatalogo.platos;
    }
    
    if (platosDelMenu.length > 0) {
      costeTotal += calcularCosteIngredientesMenu(platosDelMenu, numPersonas);
      costeTotal += calcularCosteMaterialElaboracionMenu(platosDelMenu, numPersonas).total;
    }

    // 2. COSTE DE PERSONAL (usar ratios EXACTOS de la configuración - SIN defaults)
    if (config) {
      const horasServicio = config.horas_por_camarero;

      // Personal propio (SIEMPRE 1 incluido) - solo si hay horas definidas.
      // No aplica a los menús "otros" (el propio ya lo aportan los menús del evento).
      if (horasServicio && horasServicio > 0 && !excluirPersonalPropio) {
        const costePersonalPropio = 1 * horasServicio * 60 * 0.26; // €0.26/min
        costeTotal += costePersonalPropio;
      }

      // Camareros según ratio - SOLO si ratio existe y es > 0
      const ratioCamareros = config.ratio_camareros;
      if (ratioCamareros && ratioCamareros > 0 && horasServicio && horasServicio > 0) {
        const costeCamareroHora = config.coste_camarero_hora;
        if (costeCamareroHora && costeCamareroHora > 0) {
          const numCamareros = Math.ceil(numPersonas / ratioCamareros);
          const costeCamareros = numCamareros * horasServicio * costeCamareroHora;
          costeTotal += costeCamareros;
        }
      }
      
      // Extras según ratio - SOLO si ratio existe y es > 0
      const ratioExtras = config.ratio_extras;
      if (ratioExtras && ratioExtras > 0 && horasServicio && horasServicio > 0) {
        const costeCamareroHora = config.coste_camarero_hora;
        if (costeCamareroHora && costeCamareroHora > 0) {
          const numExtras = Math.floor(numPersonas / ratioExtras);
          const costeExtras = numExtras * horasServicio * costeCamareroHora;
          costeTotal += costeExtras;
        }
      }
    }
    
    // 3. MATERIAL (por ahora 0, se puede añadir después)
    // TODO: agregar material si es necesario
    
    return costeTotal;
  };

  // Desglose detallado de costes por menú (M-44). En un multievento, una línea
  // de la cabecera se calcula jornada a jornada con las personas de cada
  // jornada (20 y 35, nunca las de la cabecera) y se suma; el personal del
  // evento (propio, camareros y extras) es por jornada. Evento de un día (o
  // línea que no está en ninguna jornada): como siempre.
  const getDesgloseCostesMenu = (menuPersonalizado) => {
    if (!menuPersonalizado) return null;
    const deJornadas = lineasJornadaDeCabecera(menuPersonalizado, presupuesto);
    if (deJornadas.length === 0) return desgloseCostesLinea(menuPersonalizado);

    const porJornada = deJornadas.map(x => ({
      numero: x.numero,
      personas: x.personas,
      desglose: desgloseCostesLinea(x.linea, { sinExtraReal: true }),
    }));
    const total = sumarDesglosesCoste(porJornada.map(x => x.desglose));

    // `personal_extra_real` es el TOTAL del evento (no por jornada): si la
    // línea lo tiene, sustituye a los extras por ratio, una sola vez
    const menuCatalogo = menuPersonalizado.menu_id ? menus.find(m => m.id === menuPersonalizado.menu_id) : null;
    const config = menuPersonalizado.config_personalizada || menuCatalogo;
    const personalExtraReal = menuPersonalizado.personal_extra_real;
    if (config && personalExtraReal !== undefined && personalExtraReal !== null && personalExtraReal > 0) {
      const horasServicio = config.horas_por_camarero || 0;
      const costeExtraHora = config.coste_extra_hora || config.coste_camarero_hora || 0;
      const menuTieneExtras = (config.ratio_extras && config.ratio_extras > 0) || (config.coste_extra_hora && config.coste_extra_hora > 0);
      if (menuTieneExtras && horasServicio > 0 && costeExtraHora > 0) {
        const costeReal = personalExtraReal * horasServicio * costeExtraHora;
        const diferencia = costeReal - total.extras.coste;
        total.extras = { cantidad: personalExtraReal, coste: costeReal };
        total.costePersonalEvento += diferencia;
        total.costeTotal += diferencia;
      }
    }
    return {
      ...total,
      porJornada: porJornada.map(x => ({ numero: x.numero, personas: x.personas, costeTotal: x.desglose?.costeTotal || 0 })),
      personasTotal: porJornada.reduce((s, x) => s + x.personas, 0),
    };
  };

  // Desglose de costes de UNA línea con sus personas (un día). `sinExtraReal`:
  // no aplica `personal_extra_real` (en un multievento lo aplica
  // getDesgloseCostesMenu una vez para todo el evento).
  const desgloseCostesLinea = (menuPersonalizado, { sinExtraReal = false } = {}) => {
    if (!menuPersonalizado) return null;

    // Personas por defecto (M-98): en un multievento, las de una jornada
    const numPersonas = menuPersonalizado.num_personas || personasPorDefectoLinea(presupuesto, null, 1);
    
    // Buscar menú en catálogo
    let menuCatalogo = null;
    if (menuPersonalizado.menu_id) {
      menuCatalogo = menus.find(m => m.id === menuPersonalizado.menu_id);
    }
    
    const config = menuPersonalizado.config_personalizada || menuCatalogo;
    
    // Tipo "otros": sin personal propio ni de cocina, pero sí los camareros/extras
    // que el suplemento tenga configurados (ver getCosteMenuPersonalizado).
    const tipoMenu = menuCatalogo?.tipo_menu || '';
    const excluirPersonalPropio = tipoMenu === 'otros';

    // 1. INGREDIENTES (coste de platos) - Filtrar platos inactivos
    let platosDelMenu = [];

    if (menuPersonalizado.platos_ids && menuPersonalizado.platos_ids.length > 0) {
      platosDelMenu = menuPersonalizado.platos_ids.map(platoId => ({
        plato_id: platoId,
        cantidad: menuPersonalizado.unidades_por_plato?.[platoId] || 1
      }));
    } else if (menuCatalogo && menuCatalogo.platos && menuCatalogo.platos.length > 0) {
      platosDelMenu = menuCatalogo.platos;
    }

    const costeIngredientes = calcularCosteIngredientesMenu(platosDelMenu, numPersonas);
    const costeMaterialElaboracion = calcularCosteMaterialElaboracionMenu(platosDelMenu, numPersonas).total;

    // 2. PERSONAL DE COCINA (producción)
    // Excluir si tipo_menu es "otros" (menú complementario)
    let tiempoTotalProduccion = 0;
    
    if (!excluirPersonalPropio) {
      platosDelMenu.forEach(platoItem => {
        const plato = platos.find(p => p.id === platoItem.plato_id);
        if (plato) {
          if (plato.tiempo_activo_min && plato.porciones && plato.porciones > 0) {
            const tiempoPorPersona = plato.tiempo_activo_min / plato.porciones;
            const tiempoPlato = tiempoPorPersona * numPersonas;
            tiempoTotalProduccion += tiempoPlato;
          }
        }
      });
    }
    
    // Coste de personal de cocina: minutos totales × 0.26€/min
    const costePersonalCocina = tiempoTotalProduccion * 0.26;
    
    // 3. PERSONAL DE EVENTO
    // Para las personas de esta línea (un día). En un multievento,
    // getDesgloseCostesMenu llama aquí una vez por jornada con la línea de esa
    // jornada (el ceil/floor de los ratios no es lineal: ceil(20/15) +
    // ceil(35/15) = 5 camareros, no ceil(55/15) = 4).
    let personalPropio = { cantidad: 0, coste: 0 };
    let camareros = { cantidad: 0, coste: 0 };
    let extras = { cantidad: 0, coste: 0 };

    const numJornadas = 1;
    const paxPorJornada = numPersonas;

    if (config) {
      const horasServicio = config.horas_por_camarero || 0;

      // Personal propio: 1 por jornada (o `personal_propio_real` por jornada).
      // Los menús "otros" no lo aportan (ya va en los menús del evento).
      const personalPropioReal = menuPersonalizado.personal_propio_real;
      if (excluirPersonalPropio) {
        // sin personal propio
      } else if (personalPropioReal !== undefined && personalPropioReal !== null && personalPropioReal > 0 && horasServicio > 0) {
        personalPropio.cantidad = personalPropioReal * numJornadas;
        personalPropio.coste = personalPropioReal * horasServicio * 60 * 0.26 * numJornadas;
      } else if (horasServicio > 0) {
        personalPropio.cantidad = 1 * numJornadas;
        personalPropio.coste = 1 * horasServicio * 60 * 0.26 * numJornadas;
      }

      // Camareros: por jornada con pax de la jornada
      const ratioCamareros = config.ratio_camareros;
      if (ratioCamareros && ratioCamareros > 0 && horasServicio > 0) {
        const costeCamareroHora = config.coste_camarero_hora || 0;
        if (costeCamareroHora > 0) {
          const porJornada = Math.ceil(paxPorJornada / ratioCamareros);
          camareros.cantidad = porJornada * numJornadas;
          camareros.coste = porJornada * horasServicio * costeCamareroHora * numJornadas;
        }
      }

      // Extras: `personal_extra_real` si existe, si no por ratio y jornada.
      // OJO: `personal_extra_real` es el TOTAL del evento, no un valor por jornada
      // (al añadir el menú se inicializa como floor(pax_total_del_ítem / ratio):
      // 700 pax / 100 = 7), así que NO se multiplica por numJornadas.
      // Tarifa: `coste_extra_hora` y, si el menú no lo define (caso general del
      // catálogo), la de camarero — antes caía a 0 y los extras no costaban nada.
      // Gate: solo si el menú tiene extras configurados (ratio o tarifa propia);
      // muchos ítems antiguos arrastran un `personal_extra_real` inicializado
      // desde ratios por defecto que ya se han limpiado del catálogo.
      const personalExtraReal = menuPersonalizado.personal_extra_real;
      const costeExtraHora = config.coste_extra_hora || config.coste_camarero_hora || 0;
      const menuTieneExtras = (config.ratio_extras && config.ratio_extras > 0) || (config.coste_extra_hora && config.coste_extra_hora > 0);
      if (!sinExtraReal && menuTieneExtras && personalExtraReal !== undefined && personalExtraReal !== null && personalExtraReal > 0 && horasServicio > 0 && costeExtraHora > 0) {
        extras.cantidad = personalExtraReal;
        extras.coste = personalExtraReal * horasServicio * costeExtraHora;
      } else {
        const ratioExtras = config.ratio_extras;
        if (ratioExtras && ratioExtras > 0 && horasServicio > 0 && costeExtraHora > 0) {
          const porJornada = Math.floor(paxPorJornada / ratioExtras);
          extras.cantidad = porJornada * numJornadas;
          extras.coste = porJornada * horasServicio * costeExtraHora * numJornadas;
        }
      }
    }
    
    const costePersonalEvento = personalPropio.coste + camareros.coste + extras.coste;
    const costeTotal = costeIngredientes + costeMaterialElaboracion + costePersonalCocina + costePersonalEvento;

    return {
      costeIngredientes,
      costeMaterialElaboracion,
      costePersonalCocina,
      costePersonalEvento,
      personalPropio,
      camareros,
      extras,
      costeTotal
    };
  };

  // Funciones para descuentos
  const handleAplicarDescuento = async () => {
    try {
      
      const updatedMenusPersonalizados = [...presupuesto.menus_personalizados];
      const menu = updatedMenusPersonalizados[descuentoMenuIndex];
      
      if (!menu) {
        throw new Error(`Menú no encontrado en index ${descuentoMenuIndex}`);
      }
      
      
      // Obtener precio original - usar undefined check en lugar de ||
      let precioOriginal;
      if (menu.precio_unitario_original !== undefined && menu.precio_unitario_original !== null) {
        // Ya tiene un precio original guardado (descuento previo)
        precioOriginal = menu.precio_unitario_original;
      } else {
        // Primera vez que se aplica descuento - usar precio actual con fallback completo
        precioOriginal = menu.precio_unitario || menu.precio_ud || menu.precio_persona || menu.precio_por_persona || menu.precio_venta || menu.precio_total || 0;
      }
      
      
      let precioConDescuento = precioOriginal;
      
      if (descuentoData.tipo === 'porcentaje') {
        precioConDescuento = precioOriginal * (1 - descuentoData.valor / 100);
      } else {
        // Descuento en valor fijo
        precioConDescuento = precioOriginal - descuentoData.valor;
      }
      
      // Asegurar que no sea negativo
      precioConDescuento = Math.max(0, precioConDescuento);
      
      
      // Actualizar menú con descuento
      updatedMenusPersonalizados[descuentoMenuIndex] = {
        ...menu,
        precio_unitario_original: precioOriginal,
        precio_unitario: precioConDescuento,
        precio_ud: precioConDescuento,
        descuento_tipo: descuentoData.tipo,
        descuento_valor: descuentoData.valor
      };
      
      
      // Recalcular totales
      const updatedItems = [...items];
      const itemIndex = updatedItems.findIndex(item => item.personalizadoIndex === descuentoMenuIndex);
      if (itemIndex !== -1) {
        updatedItems[itemIndex].precio_ud = precioConDescuento;
      }
      
      const newSubtotal = updatedItems.reduce((sum, i) => sum + calculateImporte(i), 0);
      const newIva = updatedItems.reduce((sum, i) => sum + calculateIva(i), 0);
      const newTotal = newSubtotal + newIva;
      
      const updatedPresupuesto = {
        ...presupuesto,
        menus_personalizados: updatedMenusPersonalizados,
        importe_base: newSubtotal,
        iva: newIva,
        importe_total: newTotal
      };
      
      await guardarFicha(updatedPresupuesto);
      await fetchData();
      
      setShowDescuentoModal(false);
      setDescuentoMenuIndex(null);
      setDescuentoData({ tipo: 'porcentaje', valor: 0 });
      avisoGuardadoOk('Descuento aplicado correctamente');
    } catch (error) {
      console.error('❌ Error applying descuento:', error);
      console.error('Error stack:', error.stack);
      avisoGuardadoError('Error al aplicar descuento: ' + error.message, error);
    }
  };

  // Funciones para reordenar menús
  // Multievento: cada jornada con sus líneas en el orden de la cabecera, para
  // que presupuesto, PDF, facturas por jornada y pantallas salgan igual. Las
  // líneas sin línea de cabecera (extras, bebidas, alquiler) quedan al final
  // en su orden. Devuelve cuántas jornadas no se pudieron reordenar.
  const reordenarJornadasSegunCabecera = async (raizNueva) => {
    if (!presupuesto?.id || !presupuesto?.es_multi_evento) return 0;
    let fallos = 0;
    for (const j of presupuesto.jornadas || []) {
      const lineas = (j && j.menus_personalizados) || [];
      if (lineas.length < 2) continue;
      const pos = (l) => {
        const c = lineaCabecera(l, raizNueva);
        const i = c ? raizNueva.indexOf(c) : -1;
        return i < 0 ? Number.MAX_SAFE_INTEGER : i;
      };
      const conPosicion = lineas.map((l, k) => ({ l, k, p: pos(l) }))
        .sort((a, b) => (a.p - b.p) || (a.k - b.k));
      const ordenadas = conPosicion.map(x => x.l);
      if (ordenadas.every((l, i) => l === lineas[i])) continue;
      // "Acompaña a" de la jornada (índice de ESA jornada): sigue con su servicio
      const nuevoIndice = new Map(conPosicion.map((x, i) => [x.k, i]));
      const lineasJornada = remapearAcompana(ordenadas, (x) => (nuevoIndice.has(x) ? nuevoIndice.get(x) : null));
      try {
        await presupuestosAPI.actualizarJornada(presupuesto.id, j.id, { menus_personalizados: lineasJornada });
      } catch (err) {
        fallos += 1;
        console.error('No se pudo reordenar la jornada', j.id, err);
      }
    }
    return fallos;
  };

  // Mover una línea de la cabecera para que quede en la posición `hasta` de la
  // lista resultante, con un solo guardado. `acompana_a_indice` sigue apuntando
  // al mismo servicio (`mapaMoverLinea`). La ficha cambia el orden en pantalla
  // al instante (presupuesto y filas) y guarda detrás; si el guardado falla,
  // vuelve al orden de antes. Mientras dura, se ignoran otros movimientos.
  const handleMoverLinea = async (desde, hasta) => {
    const lista = presupuesto?.menus_personalizados || [];
    const n = lista.length;
    if (!Number.isInteger(desde) || !Number.isInteger(hasta)) return;
    if (desde === hasta || desde < 0 || hasta < 0 || desde >= n || hasta >= n) return;
    if (reordenandoLineaRef.current) return;
    reordenandoLineaRef.current = true;
    setReordenandoLinea(true);

    const presupuestoPrevio = presupuesto;
    const itemsPrevios = items;
    let guardado = false;

    try {
      const updatedMenusPersonalizados = [...lista];
      const [movida] = updatedMenusPersonalizados.splice(desde, 1);
      updatedMenusPersonalizados.splice(hasta, 0, movida);

      // Índice viejo -> nuevo de cada línea
      const mapa = mapaMoverLinea(desde, hasta);
      const lineasNuevas = remapearAcompana(updatedMenusPersonalizados, mapa);

      const updatedPresupuesto = {
        ...presupuesto,
        menus_personalizados: lineasNuevas
      };

      // En pantalla, ya (optimista)
      setPresupuesto(updatedPresupuesto);
      setItems(reordenarItemsR2(items, mapa, lineasNuevas));

      aplicarRespuestaGuardado(await guardarFicha(updatedPresupuesto), updatedPresupuesto);
      guardado = true;
      // Multievento: el mismo orden en cada jornada
      const fallosJornadas = await reordenarJornadasSegunCabecera(updatedPresupuesto.menus_personalizados);
      if (fallosJornadas > 0) {
        avisoGuardadoError(`El orden se cambió en la cabecera, pero ${fallosJornadas === 1 ? 'una jornada no se pudo' : `${fallosJornadas} jornadas no se pudieron`} reordenar (¿facturada?).`);
      }

      // Releer la ficha con lo que ha guardado el servidor
      await fetchData();
    } catch (error) {
      console.error('Error al mover la línea:', error);
      // Sin guardar: vuelve el orden de antes
      if (!guardado) {
        setPresupuesto(presupuestoPrevio);
        setItems(itemsPrevios);
      }
      avisoGuardadoError('Error al reordenar menú: ' + error.message, error);
    } finally {
      reordenandoLineaRef.current = false;
      setReordenandoLinea(false);
    }
  };

  const handleMoveMenuUp = (menuIndex) => handleMoverLinea(menuIndex, menuIndex - 1);

  const handleMoveMenuDown = (menuIndex) => handleMoverLinea(menuIndex, menuIndex + 1);

  // Arrastre de líneas en el Resumen 2 (HTML5 nativo; en móvil, el menú de la
  // línea). Se suelta en cualquier punto de la lista: el destino es la línea
  // movible más cercana al puntero, antes o después de ella.
  const posicionDestinoR2 = (desde, indice, antes) => {
    const p = antes ? indice : indice + 1;
    return p > desde ? p - 1 : p;
  };

  // Línea movible y lado (antes/después) según la altura del puntero, entre
  // las filas con `data-r2-idx` del contenedor (en el orden de pantalla)
  const destinoSegunPunteroR2 = (contenedor, y) => {
    const filas = contenedor ? Array.from(contenedor.querySelectorAll('[data-r2-idx]')) : [];
    if (filas.length === 0) return null;
    const leer = (fila) => {
      const r = fila.getBoundingClientRect();
      return { indice: Number(fila.getAttribute('data-r2-idx')), top: r.top, bottom: r.bottom, mitad: r.top + r.height / 2 };
    };
    const datos = filas.map(leer);
    // Encima de la mitad de la primera: antes de la primera
    if (y < datos[0].mitad) return { indice: datos[0].indice, antes: true };
    const ultima = datos[datos.length - 1];
    // Debajo de la mitad de la última: después de la última
    if (y >= ultima.mitad) return { indice: ultima.indice, antes: false };
    // Sobre una fila movible: su mitad decide
    const encima = datos.find(d => y >= d.top && y < d.bottom);
    if (encima) return { indice: encima.indice, antes: y < encima.mitad };
    // En un hueco o sobre una fila no movible: antes de la siguiente movible
    const siguiente = datos.find(d => d.top > y);
    return siguiente ? { indice: siguiente.indice, antes: true } : { indice: ultima.indice, antes: false };
  };

  const limpiarArrastreR2 = () => {
    origenArrastreR2Ref.current = null;
    setOrigenArrastreR2(null);
    setDestinoArrastreR2(null);
  };

  const alEmpezarArrastreR2 = (e, indice) => {
    if (reordenandoLineaRef.current) {
      e.preventDefault();
      return;
    }
    origenArrastreR2Ref.current = indice;
    try {
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/plain', String(indice));
      // La imagen del arrastre es la fila entera, no solo el asa
      const fila = e.currentTarget.closest('[data-r2-idx]');
      if (fila && e.dataTransfer.setDragImage) e.dataTransfer.setDragImage(fila, 12, 12);
    } catch (err) {
      // Navegadores sin dataTransfer completo: el arrastre sigue con el ref
    }
    // Sin setState aquí: después de que el navegador saque la imagen, para que
    // no salga atenuada
    setTimeout(() => {
      if (origenArrastreR2Ref.current === indice) setOrigenArrastreR2(indice);
    }, 0);
  };

  // dragenter y dragover del contenedor de la lista: aceptar el arrastre en
  // toda la lista y pintar el destino (solo si cambia)
  const alArrastrarSobreListaR2 = (e) => {
    const desde = origenArrastreR2Ref.current;
    if (desde === null || reordenandoLineaRef.current) return;
    e.preventDefault();
    if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
    const destino = destinoSegunPunteroR2(e.currentTarget, e.clientY);
    const siguiente = destino && posicionDestinoR2(desde, destino.indice, destino.antes) !== desde ? destino : null;
    setDestinoArrastreR2(prev => ((prev?.indice === siguiente?.indice && prev?.antes === siguiente?.antes) ? prev : siguiente));
  };

  // Al salir de la lista, sin destino pintado
  const alSalirDeListaR2 = (e) => {
    if (origenArrastreR2Ref.current === null) return;
    if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return;
    setDestinoArrastreR2(prev => (prev === null ? prev : null));
  };

  const alSoltarEnListaR2 = (e) => {
    const desde = origenArrastreR2Ref.current;
    if (desde === null) return;
    e.preventDefault();
    const destino = destinoSegunPunteroR2(e.currentTarget, e.clientY);
    limpiarArrastreR2();
    if (!destino) return;
    const hasta = posicionDestinoR2(desde, destino.indice, destino.antes);
    if (hasta !== desde && !reordenandoLineaRef.current) {
      registrarAccion('presupuesto.linea_soltada');
      handleMoverLinea(desde, hasta);
    }
  };

  // Funciones para edición de platos
  const handleSaveEditedPlatos = async () => {
    try {
      if (!editedPlatos || editedPlatos.length === 0) {
        alert('Debes tener al menos un plato en el menú');
        return;
      }

      const updatedMenusPersonalizados = [...presupuesto.menus_personalizados];
      const menu = updatedMenusPersonalizados[editPlatosMenuIndex];

      // Recalcular el COSTE basado en los nuevos platos con sus unidades
      let nuevoCoste = 0;
      const nuevasUnidadesPorPlato = {};
      
      editedPlatos.forEach(item => {
        const plato = platos.find(p => p.id === item.platoId);
        if (plato) {
          nuevoCoste += (plato.coste_por_porcion || plato.coste_total || 0) * (item.unidades || 1);
          nuevasUnidadesPorPlato[item.platoId] = item.unidades || 1;
        }
      });

      // Actualizar el menú con los nuevos platos
      // Nota: precio_unitario se mantiene o recalcula según lógica de negocio
      updatedMenusPersonalizados[editPlatosMenuIndex] = {
        ...menu,
        platos_ids: editedPlatos.map(item => item.platoId),
        unidades_por_plato: nuevasUnidadesPorPlato,
        // Mantener el precio_unitario actual (el coste solo es informativo)
        es_modificado: true // Flag para indicar que este menú ha sido modificado
      };

      // Recalcular totales
      const newSubtotal = updatedMenusPersonalizados.reduce((sum, menuPers, idx) => {
        const precioFinal = menuPers.precio_unitario || 0;
        return sum + (precioFinal * menuPers.num_personas);
      }, 0);
      
      const newIva = newSubtotal * 0.10; // Simplificado, asumiendo 10% IVA
      const newTotal = newSubtotal + newIva;

      const updatedPresupuesto = {
        ...presupuesto,
        menus_personalizados: updatedMenusPersonalizados,
        importe_base: newSubtotal,
        iva: newIva,
        importe_total: newTotal
      };

      await guardarFicha(updatedPresupuesto);
      await fetchData();

      setShowEditPlatosModal(false);
      setEditPlatosMenuIndex(null);
      setEditedPlatos([]);
      setPlatoSearchTerm('');
      setPlatoFiltersEdit({
        precioMax: '',
        categoria: '',
        sinAlergenos: []
      });
      avisoGuardadoOk('Platos actualizados correctamente');
    } catch (error) {
      console.error('Error updating platos:', error);
      avisoGuardadoError('Error al actualizar platos', error);
    }
  };

  const handleTogglePlatoWithUnits = (platoId) => {
    const existingIndex = editedPlatos.findIndex(item => item.platoId === platoId);
    if (existingIndex >= 0) {
      // Ya existe, lo quitamos
      setEditedPlatos(editedPlatos.filter(item => item.platoId !== platoId));
    } else {
      // No existe, lo añadimos con 1 unidad por defecto
      setEditedPlatos([...editedPlatos, { platoId, unidades: 1 }]);
    }
  };

  const handleUpdatePlatoUnidades = (platoId, unidades) => {
    setEditedPlatos(editedPlatos.map(item => 
      item.platoId === platoId 
        ? { ...item, unidades: Math.max(0.1, parseFloat(unidades) || 1) }
        : item
    ));
  };

  // Funciones para reordenar platos
  const handleMovePlatoUp = (platoId) => {
    const currentIndex = editedPlatos.findIndex(item => item.platoId === platoId);
    if (currentIndex <= 0) return;
    
    const newPlatos = [...editedPlatos];
    [newPlatos[currentIndex - 1], newPlatos[currentIndex]] = [newPlatos[currentIndex], newPlatos[currentIndex - 1]];
    setEditedPlatos(newPlatos);
  };

  const handleMovePlatoDown = (platoId) => {
    const currentIndex = editedPlatos.findIndex(item => item.platoId === platoId);
    if (currentIndex === -1 || currentIndex >= editedPlatos.length - 1) return;
    
    const newPlatos = [...editedPlatos];
    [newPlatos[currentIndex], newPlatos[currentIndex + 1]] = [newPlatos[currentIndex + 1], newPlatos[currentIndex]];
    setEditedPlatos(newPlatos);
  };

  const getFilteredPlatosForEdit = () => {
    let filtered = platos;

    // Buscar por nombre (sin acentos)
    if (platoSearchTerm) {
      filtered = filtered.filter(p => 
        normalizeText(p.nombre).includes(normalizeText(platoSearchTerm))
      );
    }

    // Filtrar por precio máximo
    if (platoFiltersEdit.precioMax) {
      filtered = filtered.filter(p => 
        (p.coste_racion || 0) <= parseFloat(platoFiltersEdit.precioMax)
      );
    }

    // Filtrar por categoría
    if (platoFiltersEdit.categoria) {
      filtered = filtered.filter(p => p.categoria === platoFiltersEdit.categoria);
    }

    // Filtrar por alérgenos a evitar
    if (platoFiltersEdit.sinAlergenos && platoFiltersEdit.sinAlergenos.length > 0) {
      filtered = filtered.filter(p => {
        if (!p.alergenos || p.alergenos.length === 0) return true;
        return !p.alergenos.some(a => platoFiltersEdit.sinAlergenos.includes(a));
      });
    }

    return filtered.sort((a, b) => (a.coste_racion || 0) - (b.coste_racion || 0));
  };

  // Función para editar precio inline
  const handleSavePrecioInline = async (menuIndex) => {
    try {
      
      const menu = presupuesto.menus_personalizados[menuIndex];
      if (!menu) {
        console.error('❌ Menú no encontrado');
        return;
      }
      
      // Crear copia actualizada de menús
      const updatedMenusPersonalizados = [...presupuesto.menus_personalizados];
      updatedMenusPersonalizados[menuIndex] = {
        ...menu,
        precio_unitario: tempPrecio,
        precio_ud: tempPrecio,
        precio_unitario_original: menu.precio_unitario_original || menu.precio_unitario
      };
      
      // Recalcular totales
      const updatedItems = [...items];
      const itemIndex = updatedItems.findIndex(item => item.personalizadoIndex === menuIndex);
      if (itemIndex !== -1) {
        updatedItems[itemIndex].precio_ud = tempPrecio;
      }
      
      const newSubtotal = updatedItems.reduce((sum, i) => sum + calculateImporte(i), 0);
      const newIva = updatedItems.reduce((sum, i) => sum + calculateIva(i), 0);
      const newTotal = newSubtotal + newIva;
      
      const updatedPresupuesto = {
        ...presupuesto,
        menus_personalizados: updatedMenusPersonalizados,
        importe_base: newSubtotal,
        iva: newIva,
        importe_total: newTotal
      };
      
      await guardarFicha(updatedPresupuesto);
      await fetchData(); // Recargar datos del backend para sincronizar
      
      setEditingPriceMenuIndex(null);
    } catch (error) {
      console.error('❌ Error al actualizar precio:', error);
      avisoGuardadoError('Error al actualizar el precio: ' + (error.response?.data?.detail || error.message), error);
    }
  };

  // === ALIAS COMERCIAL POR LÍNEA (concepto_cliente) ===
  // Guarda/borra el concepto que verá el cliente en los PDF de presupuesto,
  // factura y proforma. No toca importes, unidades ni la orden de cocina.
  const abrirConceptoCliente = (tipo, index, valorActual, mostrarPlatosActual = false) => {
    setEditandoConceptoCliente({ tipo, index });
    setTempConceptoCliente(valorActual || '');
    setTempMostrarPlatos(!!mostrarPlatosActual);
    // Cambiar el nombre nunca pasa solo a 1 ud: sin elegir nada, las unidades de la línea
    const linea = tipo === 'menu' ? presupuesto?.menus_personalizados?.[index] : null;
    setTempModoUds(['una', 'manual'].includes(linea?.unidades_cliente_modo) ? linea.unidades_cliente_modo : 'reales');
    setTempUdsCliente(linea?.unidades_cliente ? String(linea.unidades_cliente) : '');
  };

  const cerrarConceptoCliente = () => {
    setEditandoConceptoCliente(null);
    setTempConceptoCliente('');
    setTempMostrarPlatos(false);
    setTempModoUds('reales');
    setTempUdsCliente('');
  };

  // Unidades y precio que verá el cliente en un menú con alias (misma regla que
  // utils.resolver_linea_cliente): con otro número, precio = total / número,
  // enseñado a 2 decimales; el importe de la línea no cambia
  const unidadesClienteLinea = (index, modo, udsTexto) => {
    const item = items.find(it => it.type === 'menu' && it.personalizadoIndex === index);
    if (!item) return null;
    const total = Math.round(calculateImporte(item) * 100) / 100;
    const reales = { unidades: item.uds, precio: item.precio_ud, total, porJornadas: !!item.udsJornadas };
    if (modo === 'una') return { ...reales, unidades: 1, precio: total };
    if (modo === 'manual') {
      const n = Number(udsTexto);
      if (!Number.isInteger(n) || n <= 0) return { ...reales, error: 'Escribe un número de unidades entero.' };
      const precio = Math.round((total / n) * 100) / 100;
      if (Math.abs(Math.round(precio * n * 100) / 100 - total) > 0.001) {
        return { ...reales, unidades: n, precio: Math.round((total / n) * 10000) / 10000, decimales: true };
      }
      return { ...reales, unidades: n, precio };
    }
    return reales;
  };
  const textoUnidadesAlias = (linea) => {
    if (linea?.unidades_cliente_modo === 'manual' && linea?.unidades_cliente) return `x ${linea.unidades_cliente}`;
    if (linea?.unidades_cliente_modo === 'una') return '1 ud con el total';
    return 'con sus unidades';
  };
  // Precio por unidad en formato dinero (2 decimales), como en los PDF
  const formatoPrecioUnidad = (n) => formatEuros(n);

  const esConceptoClienteAbierto = (tipo, index) => (
    editandoConceptoCliente?.tipo === tipo && editandoConceptoCliente?.index === index
  );

  const handleGuardarConceptoCliente = async (tipo, index, quitar = false) => {
    try {
      setGuardandoConceptoCliente(true);
      const nuevoAlias = quitar ? '' : tempConceptoCliente.trim();

      let updatedPresupuesto;
      if (tipo === 'menu') {
        const actualizados = [...(presupuesto.menus_personalizados || [])];
        const linea = actualizados[index];
        if (!linea) {
          console.error('Menú no encontrado para el alias comercial');
          return;
        }
        const nuevaLinea = { ...linea };
        if (nuevoAlias) {
          if (tempModoUds === 'manual') {
            const prev = unidadesClienteLinea(index, 'manual', tempUdsCliente);
            if (prev?.error) {
              avisoGuardadoError(prev.error);
              return;
            }
          }
          nuevaLinea.concepto_cliente = nuevoAlias;
          // Solo tiene sentido con alias: lista los platos bajo el nuevo concepto
          nuevaLinea.mostrar_platos_cliente = !!tempMostrarPlatos;
          nuevaLinea.unidades_cliente_modo = tempModoUds;
          nuevaLinea.unidades_cliente = tempModoUds === 'manual' ? Number(tempUdsCliente) : null;
        } else {
          // Se quitan con null, no borrando la clave: el guardado repone las claves
          // que faltan en una línea (presupuesto_merge.completar_campos_menus)
          nuevaLinea.concepto_cliente = null;
          nuevaLinea.mostrar_platos_cliente = null;
          nuevaLinea.unidades_cliente_modo = null;
          nuevaLinea.unidades_cliente = null;
        }
        actualizados[index] = nuevaLinea;
        updatedPresupuesto = { ...presupuesto, menus_personalizados: actualizados };
      } else {
        const actualizados = [...(presupuesto.suplementos || [])];
        const linea = actualizados[index];
        if (!linea) {
          console.error('Suplemento no encontrado para el alias comercial');
          return;
        }
        const nuevaLinea = { ...linea };
        if (nuevoAlias) {
          nuevaLinea.concepto_cliente = nuevoAlias;
        } else {
          nuevaLinea.concepto_cliente = null;
        }
        actualizados[index] = nuevaLinea;
        updatedPresupuesto = { ...presupuesto, suplementos: actualizados };
      }

      await guardarFicha(updatedPresupuesto);
      await fetchData();
      cerrarConceptoCliente();
    } catch (error) {
      console.error('Error al guardar el concepto para el cliente:', error);
      avisoGuardadoError('Error al guardar el concepto: ' + (error.response?.data?.detail || error.message), error);
    } finally {
      setGuardandoConceptoCliente(false);
    }
  };

  // Bloque desplegable reutilizable (menús y suplementos)
  const renderEditorConceptoCliente = (tipo, index, aliasActual) => {
    if (!esConceptoClienteAbierto(tipo, index)) return null;
    return (
      <div className="mt-2 p-3 bg-violet-50 border border-violet-200 rounded-lg max-w-md">
        <label className="block text-xs font-semibold text-violet-900 mb-1">
          Concepto para mostrar solo en facturas y presupuestos
        </label>
        <input
          type="text"
          value={tempConceptoCliente}
          onChange={(e) => setTempConceptoCliente(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleGuardarConceptoCliente(tipo, index);
            }
            if (e.key === 'Escape') {
              e.preventDefault();
              cerrarConceptoCliente();
            }
          }}
          placeholder="Ej: Transporte, Servicio integral..."
          autoFocus
          data-testid={`concepto-cliente-input-${tipo}-${index}`}
          className="w-full px-2 py-1.5 border border-violet-300 rounded text-sm focus:ring-1 focus:ring-duetto-primary focus:border-duetto-primary"
        />
        {tipo !== 'menu' && (
          <p className="text-xs text-gray-500 mt-1">
            Se mostrará como 1 ud x importe total. La orden de cocina no cambia.
          </p>
        )}
        {/* Menús: cómo ve el cliente las unidades (Menú 14 platos x 100) */}
        {tipo === 'menu' && (() => {
          const vista = unidadesClienteLinea(index, tempModoUds, tempUdsCliente);
          const opcion = (valor, texto) => (
            <label className="flex items-center gap-2 cursor-pointer text-xs text-violet-900">
              <input type="radio" name={`uds-cliente-${index}`} checked={tempModoUds === valor}
                onChange={() => setTempModoUds(valor)}
                data-testid={`concepto-cliente-uds-${valor}-${index}`}
                className="h-3.5 w-3.5 text-duetto-primary focus:ring-duetto-primary" />
              {texto}
            </label>
          );
          return (
            <div className="mt-2 pt-2 border-t border-violet-200 space-y-1.5">
              <div className="text-xs font-semibold text-violet-900">Unidades que ve el cliente</div>
              {opcion('reales', `Las de la línea${vista && !vista.porJornadas ? ` (${vista.unidades})` : ''}`)}
              <div className="flex items-center gap-2">
                {opcion('manual', 'Otro número:')}
                <input type="number" min="1" step="1" value={tempUdsCliente}
                  onChange={(e) => { setTempUdsCliente(e.target.value); setTempModoUds('manual'); }}
                  data-testid={`concepto-cliente-uds-numero-${index}`}
                  className="w-20 px-2 py-0.5 border border-violet-300 rounded text-xs text-right" />
              </div>
              {opcion('una', 'Una sola línea con el total (1 ud)')}
              {vista && (
                vista.error
                  ? <p className="text-xs text-red-700">{vista.error}</p>
                  : (
                    <p className="text-xs text-gray-600">
                      El cliente verá: <span className="font-semibold">{tempConceptoCliente.trim() || 'el nuevo concepto'} · {vista.unidades} x {formatoPrecioUnidad(vista.precio)}</span> = {formatEuros(vista.total)}.
                      {vista.decimales && ' El precio por unidad sale redondeado a céntimos; el total de la línea es el real.'}
                      {vista.porJornadas && tempModoUds !== 'una' && ' En cada jornada, con las personas de ese día.'}
                      {' '}El total y el IVA no cambian; la orden de cocina tampoco.
                    </p>
                  )
              )}
            </div>
          );
        })()}
        {/* Los suplementos no tienen platos: el flag solo aplica a menús */}
        {tipo === 'menu' && (
          <div className="mt-2 pt-2 border-t border-violet-200">
            <label className="flex items-start gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={tempMostrarPlatos}
                onChange={(e) => setTempMostrarPlatos(e.target.checked)}
                data-testid={`concepto-cliente-mostrar-platos-${index}`}
                className="mt-0.5 h-4 w-4 rounded border-violet-300 text-duetto-primary focus:ring-duetto-primary"
              />
              <span className="text-xs font-medium text-violet-900">
                Mostrar platos y alérgenos en el presupuesto
              </span>
            </label>
            <p className="text-xs text-gray-500 mt-1 ml-6">
              Se listarán bajo el nuevo concepto, nunca con el nombre real.
            </p>
          </div>
        )}
        <div className="flex items-center gap-2 mt-2">
          <button
            type="button"
            onClick={() => handleGuardarConceptoCliente(tipo, index)}
            disabled={guardandoConceptoCliente}
            className="px-3 py-1 bg-duetto-primary text-white text-xs font-medium rounded hover:bg-duetto-secondary disabled:opacity-50"
          >
            Guardar
          </button>
          {aliasActual && (
            <button
              type="button"
              onClick={() => handleGuardarConceptoCliente(tipo, index, true)}
              disabled={guardandoConceptoCliente}
              className="px-3 py-1 bg-white border border-red-300 text-red-600 text-xs font-medium rounded hover:bg-red-50 disabled:opacity-50"
            >
              Quitar
            </button>
          )}
          <button
            type="button"
            onClick={cerrarConceptoCliente}
            disabled={guardandoConceptoCliente}
            className="px-3 py-1 bg-white border border-gray-300 text-gray-600 text-xs font-medium rounded hover:bg-gray-50 disabled:opacity-50"
          >
            Cancelar
          </button>
        </div>
      </div>
    );
  };

  const handleSaveUnidadesInline = async (menuIndex) => {
    try {
      
      const menu = presupuesto.menus_personalizados[menuIndex];
      if (!menu) {
        console.error('❌ Menú no encontrado');
        return;
      }

      // Validar que sea un número positivo
      const nuevasUnidades = parseInt(tempUnidades);
      if (isNaN(nuevasUnidades) || nuevasUnidades <= 0) {
        alert('Por favor introduce un número válido de personas (mayor a 0)');
        return;
      }
      
      // Crear copia actualizada de menús
      const updatedMenusPersonalizados = [...presupuesto.menus_personalizados];
      updatedMenusPersonalizados[menuIndex] = {
        ...menu,
        num_personas: nuevasUnidades
      };
      
      // Recalcular totales
      const updatedItems = [...items];
      const itemIndex = updatedItems.findIndex(item => item.personalizadoIndex === menuIndex);
      if (itemIndex !== -1) {
        updatedItems[itemIndex].uds = nuevasUnidades;
      }
      
      const newSubtotal = updatedItems.reduce((sum, i) => sum + calculateImporte(i), 0);
      const newIva = updatedItems.reduce((sum, i) => sum + calculateIva(i), 0);
      const newTotal = newSubtotal + newIva;
      
      const updatedPresupuesto = {
        ...presupuesto,
        menus_personalizados: updatedMenusPersonalizados,
        importe_base: newSubtotal,
        iva: newIva,
        importe_total: newTotal
      };
      
      await guardarFicha(updatedPresupuesto);
      await fetchData(); // Recargar datos del backend para sincronizar
      
      setEditingUnidadesMenuIndex(null);
    } catch (error) {
      console.error('❌ Error al actualizar unidades:', error);
      avisoGuardadoError('Error al actualizar las unidades: ' + (error.response?.data?.detail || error.message), error);
    }
  };

  const handleSaveIvaInline = async (menuIndex, ivaValue = null) => {
    try {
      const menu = presupuesto.menus_personalizados?.[menuIndex];
      if (!menu) {
        console.error('❌ Menú no encontrado');
        return;
      }

      const ivaPercent = parseInt(ivaValue != null ? ivaValue : tempIva) || 10;

      // Actualizar el menú personalizado con el nuevo IVA
      const updatedMenusPersonalizados = [...presupuesto.menus_personalizados];
      updatedMenusPersonalizados[menuIndex] = {
        ...menu,
        tipo_iva: ivaPercent,
        iva_percent: ivaPercent
      };

      // Recalcular totales reflejando el nuevo IVA en el item correspondiente
      const updatedItems = [...items];
      const itemIndex = updatedItems.findIndex(item => item.personalizadoIndex === menuIndex);
      if (itemIndex !== -1) {
        updatedItems[itemIndex].iva_percent = ivaPercent;
      }

      const newSubtotal = updatedItems.reduce((sum, i) => sum + calculateImporte(i), 0);
      const newIva = updatedItems.reduce((sum, i) => sum + calculateIva(i), 0);
      const newTotal = newSubtotal + newIva;

      const updatedPresupuesto = {
        ...presupuesto,
        menus_personalizados: updatedMenusPersonalizados,
        importe_base: newSubtotal,
        iva: newIva,
        importe_total: newTotal
      };

      await guardarFicha(updatedPresupuesto);
      await fetchData(); // Recargar datos del backend para sincronizar

      setEditingIvaMenuIndex(null);
    } catch (error) {
      console.error('❌ Error al actualizar IVA:', error);
      avisoGuardadoError('Error al actualizar el IVA: ' + (error.response?.data?.detail || error.message), error);
    }
  };
  // Móvil: la hoja "Editar línea" guarda con estas mismas funciones (las del render actual)
  manejadoresLineaMovilRef.current = {
    unidades: handleSaveUnidadesInline,
    precio: handleSavePrecioInline,
    iva: handleSaveIvaInline,
  };

  // Función para confirmar presupuesto
  // Confirmación que se quedó a medias (más de 15 minutos en "confirmando",
  // el mismo plazo del servidor): se puede reintentar y el servidor la retoma
  const confirmacionColgada = () => {
    if (presupuesto?.estado !== 'confirmando') return false;
    const desde = presupuesto?.confirmando_desde;
    if (!desde) return true;
    const texto = String(desde);
    const ms = Date.parse(/[zZ]|[+-]\d\d:?\d\d$/.test(texto) ? texto : `${texto}Z`);
    return !Number.isFinite(ms) || Date.now() - ms > 15 * 60 * 1000;
  };
  const confirmacionEnCurso = () => confirmando || (presupuesto?.estado === 'confirmando' && !confirmacionColgada());
  const textoBotonConfirmar = (normal) => {
    if (confirmando) return 'Confirmando...';
    if (presupuesto?.estado === 'confirmando') return confirmacionColgada() ? 'Reintentar la confirmación' : 'Confirmando...';
    return normal;
  };

  // "Poner las horas" del aviso de horas: Logística > Horario (formato nuevo)
  // o el Resumen
  const irAPonerHoras = () => {
    if (formatoNuevo) setPestanaActiva('logistica', 'horario');
    else setPestanaActiva('resumen');
  };

  const handleConfirmar = async () => {
    // Una sola confirmación a la vez (el servidor también lo impide con 409),
    // salvo una que se quedó colgada, que se puede reintentar
    if (confirmacionEnCurso()) return;
    if (presupuesto?.estado === 'cancelado' || presupuesto?.estado === 'rechazado') {
      alert('Un presupuesto cancelado o rechazado hay que reabrirlo como borrador antes de confirmarlo.');
      return;
    }
    // M1: servicios sin hora (o que no cuadran): aviso con "Poner las horas"
    // o "Seguir igualmente"; nunca bloquea
    await esperarAutoguardado();
    const decisionHoras = await revisarHorarios(id, { accion: 'confirmar' });
    if (decisionHoras === 'poner') { irAPonerHoras(); return; }
    if (decisionHoras !== 'seguir') return;
    const confirmed = window.confirm(
      'CONFIRMAR PRESUPUESTO\n\n' +
      'Al confirmar este presupuesto se generarán automáticamente:\n\n' +
      '- Orden de Cocina/Hoja de Producción\n' +
      '- Lista de Compra (ingredientes)\n' +
      '- Tareas Automáticas del evento\n' +
      '- Asignación de Materiales\n\n' +
      'IMPORTANTE: Verifica que el presupuesto tenga:\n' +
      '- Fecha del evento\n' +
      '- Número de personas\n' +
      '- Al menos un menú\n' +
      '- Cliente con teléfono\n' +
      '- Lugar del evento\n\n' +
      '¿Deseas confirmar este presupuesto?'
    );

    if (!confirmed) return;

    setConfirmando(true);
    try {
      // U-97: se confirma con lo último guardado
      await esperarAutoguardado();
      const response = await presupuestosAPI.confirmar(id);
      const data = response.data || {};
      const warnings = (data.warnings || []).filter(w => !data.evento_pasado || w !== data.aviso);
      const alertasMateriales = data.alertas_materiales || [];

      // Multievento: el stock se descuenta por jornada; la orden, la lista y el material no se generan con la cabecera
      // Evento ya celebrado: solo cambia el estado (sin stock, lotes ni documentos)
      let mensaje = data.evento_pasado
        ? 'Presupuesto confirmado.\n\n' + (data.aviso || 'Evento ya celebrado: se confirma sin mover stock')
        : data.confirmacion_multievento
        ? 'Presupuesto confirmado correctamente.\n\n' + (data.confirmacion_multievento.detalle || '')
        : 'Presupuesto confirmado correctamente.\n\nSe han generado todos los documentos y tareas automáticas.';
      
      // Mostrar alertas de material insuficiente
      if (alertasMateriales.length > 0) {
        mensaje += '\n\n--- ALERTAS DE MATERIAL ---\n';
        for (const alerta of alertasMateriales) {
          const otrosDetalle = alerta.demanda_otros_eventos > 0 
            ? ` + ${Math.round(alerta.demanda_otros_eventos)} otros eventos` 
            : '';
          mensaje += `\n${alerta.material}: ` +
            `Stock ${alerta.stock_disponible} ${alerta.unidad}, ` +
            `Necesitas ${Math.round(alerta.demanda_este_evento)}${otrosDetalle} = ` +
            `${Math.round(alerta.demanda_total_dia)} total. ` +
            `FALTAN ${Math.round(alerta.deficit)} ${alerta.unidad}`;
        }
      }
      
      // Mostrar otros warnings
      if (warnings.length > 0) {
        const warningsSinMaterial = warnings.filter(w => !w.startsWith('MATERIAL INSUFICIENTE'));
        if (warningsSinMaterial.length > 0) {
          mensaje += '\n\n--- OTROS AVISOS ---\n';
          for (const w of warningsSinMaterial) {
            mensaje += '\n- ' + w;
          }
        }
      }
      
      alert(mensaje);
      await fetchData(); // Recargar datos
    } catch (error) {
      const errorMsg = error.response?.data?.detail || error.message;
      if (error.response?.status === 409 || error.response?.status === 400) {
        // Ya confirmado, otra confirmación en curso o cancelado: aviso, no error
        alert('Aviso:\n\n' + errorMsg);
        await fetchData();
      } else {
        console.error('Error confirmando presupuesto:', error);
        alert('Error al confirmar presupuesto:\n\n' + errorMsg);
      }
    } finally {
      setConfirmando(false);
    }
  };

  // Cancelado o rechazado -> borrador. No rehace nada: se confirma de nuevo a mano
  const handleReabrir = async () => {
    if (!window.confirm('Reabrir como borrador\n\nEl presupuesto vuelve a borrador. No se rehace nada (ni stock, ni lotes, ni pedidos): si el evento sigue adelante, confírmalo de nuevo.\n\n¿Reabrir?')) return;
    try {
      await presupuestosAPI.reabrir(id);
      await fetchData();
    } catch (error) {
      alert('No se ha podido reabrir: ' + (error.response?.data?.detail || error.message));
    }
  };

  // Función para desconfirmar presupuesto
  const handleDesconfirmar = async () => {
    const confirmed = window.confirm(
      '⚠️ ADVERTENCIA: Al desconfirmar este presupuesto se eliminarán TODOS los documentos generados:\n\n' +
      '• Orden de Cocina\n' +
      '• Lista de Compra\n' +
      '• Tareas Automáticas\n' +
      '• Materiales Asignados\n\n' +
      '¿Estás seguro de que deseas continuar?'
    );

    if (!confirmed) return;

    try {
      const respuesta = await presupuestosAPI.desconfirmar(id);
      const devueltos = respuesta?.data?.stock_devuelto?.movimientos_devueltos || 0;
      alert('Presupuesto desconfirmado correctamente. Los documentos han sido eliminados.' +
        (devueltos > 0 ? ' Se ha devuelto al stock lo que se descontó al confirmar.' : ''));
      await fetchData(); // Recargar datos
    } catch (error) {
      console.error('Error desconfirmando presupuesto:', error);
      alert('Error al desconfirmar presupuesto: ' + (error.response?.data?.detail || error.message));
    }
  };

  // Pestaña Alquiler del formato anterior: guarda solo la lista, marcada como
  // de su pestaña (el servidor conserva `materiales_alquiler` frente a copias
  // viejas de la ficha, U-05)
  const guardarMaterialesAlquilerAnterior = async (lista) => {
    try {
      await presupuestosAPI.update(id, { materiales_alquiler: lista || [], _origen: 'alquiler' });
    } catch (error) {
      console.error('Error guardando el alquiler:', error);
      alert('Error al guardar el alquiler: ' + (error.response?.data?.detail || error.message));
    }
  };

  const handleSave = async (campos) => {
    // Formato nuevo: lo que se edita ya va por el autoguardado; aquí solo se
    // manda lo que se pase (solo si cambia) y se fuerza el guardado de lo pendiente
    if (formatoNuevo) {
      if (campos && typeof campos === 'object' && !campos.nativeEvent && !Array.isArray(campos)) {
        await guardarFicha(campos).catch(() => {});
      }
      return autoguardado.guardarYa();
    }
    try {
      // U-99 (lote 7): en un evento ya celebrado y confirmado, las líneas que
      // la ficha monta con id provisional ("item-N", sin catálogo) se guardan
      // tal y como estaban: no se "arreglan" (nombre, platos, personas)
      const pasadoConfirmado = eventoPasado(presupuesto) && presupuesto.estado === 'confirmado';
      // Construir menus_personalizados desde items
      const menusPersonalizados = items
        .filter(item => item.type === 'menu')
        .map((item, index) => {
          const menu = menus.find(m => m.id === item.id);
          
          // Buscar adaptaciones de este menú (por index o id)
          const adaptacionesMenu = adaptaciones.filter(a => {
            if (item.personalizadoIndex !== undefined) {
              return a.menu_id === item.id && item.personalizadoIndex === index;
            }
            return a.menu_id === item.id;
          });

          // Se parte de la línea ya guardada: el formulario solo edita estos
          // campos y el resto (precio_unitario, tipo_iva, horas,
          // config_personalizada...) no se puede perder al guardar.
          const posGuardada = item.personalizadoIndex !== undefined ? item.personalizadoIndex : index;
          const lineaGuardada = (presupuesto.menus_personalizados || [])[posGuardada];
          // Los ids "item-N" son de la propia lista de la ficha, no del catálogo:
          // en ese caso la línea se empareja por posición y se conserva su menu_id real.
          const idSintetico = typeof item.id === 'string' && item.id.startsWith('item-');
          const base = lineaGuardada && (lineaGuardada.menu_id === item.id || idSintetico) ? lineaGuardada : {};
          if (pasadoConfirmado && idSintetico && lineaGuardada) return lineaGuardada;

          return {
            ...base,
            // Un id provisional ("item-N") nunca se guarda como menu_id: se
            // queda el de la línea guardada (o ninguno)
            ...(idSintetico ? {} : { menu_id: item.id }),
            nombre_menu: menu?.nombre || item.concepto,
            platos_ids: menu?.platos_ids || base.platos_ids || [],
            // Multievento: la cabecera conserva sus personas; las de cada día
            // se cambian en las jornadas
            num_personas: item.udsCabecera ?? item.uds,
            adaptaciones: adaptacionesMenu.map(adapt => ({
              tipo: adapt.tipo,
              num_personas: adapt.num_personas,
              nombres_personas: adapt.nombres_personas || [],
              alergenos_evitar: adapt.alergenos_evitar || [],
              caracteristicas_evitar: adapt.caracteristicas_evitar || [],
              observaciones: adapt.observaciones || '',
              platos_sustitutos: adapt.platos_sustitutos || {},
              platos_modificados: adapt.platos_modificados || {},
              platos_unidades_modificadas: adapt.platos_unidades_modificadas || {},
              requiere_preparacion_separada: adapt.requiere_preparacion_separada || false,
              tipo_bandeja: adapt.tipo_bandeja || null,
              material_bandeja_id: adapt.material_bandeja_id || null,
              instrucciones_especiales: adapt.instrucciones_especiales || '',
              ...(adapt.platos_sustitutos_config ? { platos_sustitutos_config: adapt.platos_sustitutos_config } : {}),
              ...(adapt.origen ? { origen: adapt.origen, comensales_ids: adapt.comensales_ids || [] } : {})
            }))
          };
        });

      // Estado local: lo que devuelve el servidor (U-32)
      aplicarRespuestaGuardado(await guardarFicha({
        ...presupuesto,
        menus_personalizados: menusPersonalizados.length > 0 ? menusPersonalizados : undefined,
        importe_base: calculateSubtotal(),
        iva: calculateTotalIva(),
        importe_total: calculateTotal()
      }));
      alert('Cambios guardados correctamente');
    } catch (error) {
      console.error('Error saving:', error);
      alert('Error al guardar los cambios: ' + (error.response?.data?.detail || error.message));
    }
  };

  const handleDescargarPresupuesto = async () => {
    try {
      setDownloading(true);
      setDownloadMessage('Generando presupuesto PDF...');
      await esperarAutoguardado();
      
      // U-15: las condiciones (forma de pago, alergias) las decide el servidor
      // con el presupuesto y el cliente, no el formato de la ficha
      const response = await api.get(`/presupuestos/${id}/generar-pdf`, {
        responseType: 'blob',
      });
      
      // Verificar el tipo de contenido
      const contentType = response.headers['content-type'];
      
      // Si es HTML (WeasyPrint no disponible), abrir en nueva pestaña
      if (contentType && contentType.includes('text/html')) {
        const htmlBlob = new Blob([response.data], { type: 'text/html' });
        const url = window.URL.createObjectURL(htmlBlob);
        window.open(url, '_blank');
        window.URL.revokeObjectURL(url);
        alert('El servidor devolvió HTML en lugar de PDF. Se abrirá en una nueva pestaña para visualización.');
        return;
      }
      
      // Obtener el nombre del archivo desde el header Content-Disposition
      let filename = `presupuesto_${presupuesto?.numero || id.substring(0, 8)}.pdf`;
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, '');
        }
      }
      
      // Crear un enlace de descarga para PDF
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      setShowPresupuestoModal(false);
    } catch (error) {
      console.error('Error descargando presupuesto:', error);
      alert('Error al descargar el presupuesto');
    } finally {
      setDownloading(false);
    }
  };

  const handleEnviarPresupuesto = async () => {
    if (!contactoDestinoId) {
      alert('Por favor selecciona un contacto destinatario');
      return;
    }
    
    if (!asuntoEmail.trim() || !mensajeEmail.trim()) {
      alert('El asunto y mensaje no pueden estar vacíos');
      return;
    }
    
    // Procesar emails en copia
    const ccEmailsArray = ccEmails
      .split(',')
      .map(email => email.trim())
      .filter(email => email.length > 0);
    
    setEnviandoEmail(true);
    
    try {
      // U-97: el PDF sale con lo último guardado
      await esperarAutoguardado();
      // Preparar datos de firma
      const firmaActual = firmasEmail[firmaSeleccionada];
      const firmaData = firmaSeleccionada !== 'ninguna' ? {
        nombre: firmaActual.nombre,
        imagen_url: firmaActual.imagen,
        texto_legal: firmaActual.textoLegal
      } : null;

      const response = await api.post(`/presupuestos/${id}/enviar-pdf`, {
        presupuesto_id: id,
        tipo_documento: 'presupuesto',
        email_origen: emailOrigen,
        contacto_destino_id: contactoDestinoId,
        asunto: asuntoEmail,
        mensaje: mensajeEmail,
        cc_emails: ccEmailsArray,
        firma: firmaData,
        // U-15: las condiciones del PDF las decide el servidor (mismo PDF que la descarga)
      });
      
      let mensaje = `Presupuesto enviado a ${response.data.contacto_nombre}`;
      if (ccEmailsArray.length > 0) {
        mensaje += `\nCon copia a: ${ccEmailsArray.join(', ')}`;
      }
      
      // Cerrar modal PRIMERO
      setShowPresupuestoModal(false);
      
      // Mostrar mensaje
      alert(mensaje);
      
      // Recargar datos para obtener el historial actualizado
      await fetchData();
      // "Modificado tras el envío" se recalcula con el envío nuevo
      if (formatoNuevo) cargarEstadoEnvio();

    } catch (error) {
      console.error('Error enviando presupuesto:', error);
      alert(`Error al enviar el presupuesto: ${error.response?.data?.detail || error.message}`);
    } finally {
      setEnviandoEmail(false);
    }
  };

  const handleGeneratePDF = (type, tipoInicial) => {

    if (type === 'Presupuesto') {
      setShowPresupuestoModal(true);
      
      // Resetear valores del modal
      setAccionPresupuesto('descargar');
      setEmailOrigen('administracion@duettocatering.com');
      setContactoDestinoId(presupuesto.persona_contacto_id || '');
      setCcEmails(''); // Resetear CC
      setAsuntoEmail('Presupuesto Duetto Catering');
      setMensajeEmail(`Estimado/a cliente,

Adjunto encontrará el presupuesto solicitado para su evento. 

Si tiene alguna duda o necesita realizar alguna modificación, no dude en contactarnos.

Quedamos a su disposición.`);
      
    } else if (type === 'Factura') {
      setShowFacturaModal(true);
      
      // Resetear valores del modal de factura
      setAccionFactura('descargar');
      setTipoFactura(tipoInicial || 'F1');
      setModoRectificativa('total');
      setAnularYReemitir(false);
      setFacturaRectificarSel(null);
      setImporteRectificar('');
      setIvaRectificar('10');
      setIvaIncluidoRectificar(true);
      setConceptoRectificar('');
      setFechaEmisionFactura(hoyMadrid());
      setObservacionesFactura('');
      setConceptoUnicoFactura('');
      setFaceNumPedido(''); // se precarga después si la factura ya tiene nº de pedido
      setOcultarDatosPago(false);
      setFacturaGenerada(null);
      setProformaExistente(null);
      setFacturaNormalExistente(null);
      setRectificativasExistentes([]);
      setTercerosExistentes([]);
      setFacturasJornadaExistentes(null);
      setShowFacturarTercero(false);
      setDocumentoEnvioSel(null);
      aperturaFacturaRef.current = null;
      
      // Valores para email
      setEmailOrigen('administracion@duettocatering.com');
      setFirmaSeleccionada('administracion');
      setContactoDestinoId(presupuesto.contacto_facturacion_id || presupuesto.persona_contacto_id || '');
      setCcEmails('');
      setCcoEmails(CCO_FACTURA_DEFAULT);

      // Verificar facturas existentes
      verificarFacturaExistente();
      
      // Texto predeterminado de envío de factura (replica email_defaults_factura).
      // El nº de factura se añade al asunto cuando se conozca (factura existente
      // en verificarFacturaExistente, o recién generada en handleEnviarFactura).
      const defaultsEmail = construirEmailFacturaDefaults(presupuesto?.fecha_evento, null, rangoFechasMultievento(presupuesto));
      setAsuntoEmail(defaultsEmail.asunto);
      setMensajeEmail(defaultsEmail.mensaje);

    } else if (type === 'Minuta') {
      // Multievento: primero la jornada (la minuta lleva su fecha y sus platos)
      if (esMultievento(presupuesto)) {
        setJornadaPendingAction('minuta');
        setShowJornadaSelector(true);
        return;
      }
      setMinutaJornadaId(null);
      setShowMinutaModal(true);
    } else if (type === 'Hoja Material') {
      handleGenerateHojaMaterial();
    } else {
      alert(`Generando ${type}... (Funcionalidad en desarrollo)`);
    }
  };

  // `diseno` (1 a 5): uno de los diseños en pruebas de la hoja (solo formato nuevo)
  const handleGenerateHojaMaterial = async (jornadaId = null, diseno = null) => {
    // Si es multi-evento y no se ha seleccionado jornada, mostrar selector
    if (presupuesto?.es_multi_evento && presupuesto?.jornadas?.length > 0 && !jornadaId) {
      setJornadaPendingAction('material');
      setShowJornadaSelector(true);
      return;
    }
    try {
      setDownloading(true);
      setDownloadMessage('Generando hoja de material...');
      await esperarAutoguardado();
      
      // Obtener token
      const token = getAuthToken();
      if (!token) {
        alert('Sesión expirada. Por favor, inicia sesión nuevamente.');
        setDownloading(false);
        return;
      }
      
      const params = new URLSearchParams();
      if (jornadaId) params.set('jornada_id', jornadaId);
      if (diseno) params.set('diseno', String(diseno));
      const jornadaParam = params.toString() ? `?${params.toString()}` : '';
      // Usar safeFetchBlob para evitar conflictos con rrweb-recorder
      const result = await safeFetchBlob(`${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/generar-hoja-material${jornadaParam}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!result.ok) {
        throw new Error(result.error || 'Error al generar hoja de material');
      }

      // PDF -> descarga; HTML (fallback local sin WeasyPrint) -> abrir en pestaña
      descargarOAbrirDocumento(result, `hoja_material_${presupuesto.numero || presupuesto.id?.substring(0, 8) || 'documento'}.pdf`);

    } catch (error) {
      alert('Error al generar la hoja de material. Por favor, intenta nuevamente.');
    } finally {
      setDownloading(false);
    }
  };

  // Hoja de alquiler: sin jornada, en un multievento sale una sección por ámbito
  // con alquiler (evento y jornadas); con jornadaId, la de esa jornada
  const handleGenerateHojaAlquiler = async (jornadaId = null) => {
    try {
      setDownloading(true);
      setDownloadMessage('Generando hoja de alquiler...');
      await esperarAutoguardado();
      
      // Obtener token
      const token = getAuthToken();
      if (!token) {
        alert('Sesión expirada. Por favor, inicia sesión nuevamente.');
        setDownloading(false);
        return;
      }
      
      // Usar safeFetchBlob para evitar conflictos con rrweb-recorder
      const queryJornada = jornadaId ? `?jornada_id=${encodeURIComponent(jornadaId)}` : '';
      const result = await safeFetchBlob(`${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/generar-hoja-alquiler${queryJornada}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!result.ok) {
        throw new Error(result.error || 'Error al generar hoja de alquiler');
      }
      
      // Crear URL temporal para descargar
      const url = window.URL.createObjectURL(result.blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `hoja_alquiler_${presupuesto.numero || presupuesto.id?.substring(0, 8) || 'documento'}.pdf`;
      
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      
    } catch (error) {
      alert('Error al generar la hoja de alquiler. Por favor, intenta nuevamente.');
    } finally {
      setDownloading(false);
    }
  };

  const handleGenerateOrdenCocina = async (jornadaId = null) => {
    // Si es multi-evento y no se ha seleccionado jornada, mostrar selector
    if (presupuesto?.es_multi_evento && presupuesto?.jornadas?.length > 0 && !jornadaId) {
      setJornadaPendingAction('orden');
      setShowJornadaSelector(true);
      return;
    }
    try {
      setDownloading(true);
      setDownloadMessage('Generando orden de cocina...');
      await esperarAutoguardado();
      
      // Obtener token
      const token = getAuthToken();
      if (!token) {
        alert('Sesión expirada. Por favor, inicia sesión nuevamente.');
        setDownloading(false);
        return;
      }
      
      const jornadaParam = jornadaId ? `?jornada_id=${jornadaId}` : '';
      // Usar safeFetchBlob para evitar conflictos con rrweb-recorder
      const result = await safeFetchBlob(`${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/generar-orden-cocina${jornadaParam}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!result.ok) {
        throw new Error(result.error || 'Error al generar orden de cocina');
      }
      
      // Crear URL temporal para descargar
      const url = window.URL.createObjectURL(result.blob);
      const a = document.createElement('a');
      a.href = url;
      
      // Determinar extensión según content-type
      if (result.contentType.includes('pdf')) {
        a.download = `orden_cocina_${presupuesto.id?.substring(0, 8) || 'documento'}.pdf`;
      } else {
        a.download = `orden_cocina_${presupuesto.id?.substring(0, 8) || 'documento'}.html`;
      }
      
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      
    } catch (error) {
      let detalle = null;
      try {
        detalle = JSON.parse(error?.message || '')?.detail || null;
      } catch {
        detalle = null;
      }
      alert(typeof detalle === 'string' && detalle
        ? detalle
        : 'Error al generar la orden de cocina. Por favor, intenta nuevamente.');
    } finally {
      setDownloading(false);
    }
  };

  // Orden de cocina (nueva), en pruebas: cantidades del motor de la lista de
  // compra. La que se envía sigue siendo la actual (handleGenerateOrdenCocina).
  const handleGenerateOrdenCocinaNueva = async (jornadaId = null) => {
    if (presupuesto?.es_multi_evento && presupuesto?.jornadas?.length > 0 && !jornadaId) {
      setJornadaPendingAction('orden_nueva');
      setShowJornadaSelector(true);
      return;
    }
    await esperarAutoguardado();
    // M1: servicios sin hora en esa orden (la jornada o el evento): aviso, no bloqueo
    const decisionHoras = await revisarHorarios(id, { accion: 'orden', jornadaId });
    if (decisionHoras === 'poner') { irAPonerHoras(); return; }
    if (decisionHoras !== 'seguir') return;
    try {
      setDownloading(true);
      setDownloadMessage('Generando la orden de cocina (nueva)...');
      await esperarAutoguardado();
      const respuesta = await ordenCocinaV2API.descargar(id, jornadaId);
      const tipo = respuesta.headers?.['content-type'] || 'application/pdf';
      const url = window.URL.createObjectURL(new Blob([respuesta.data], { type: tipo }));
      const a = document.createElement('a');
      a.href = url;
      a.download = `orden_cocina_nueva_${presupuesto?.numero || String(id).substring(0, 8)}.${tipo.includes('pdf') ? 'pdf' : 'html'}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      let detalle = null;
      try {
        const texto = error?.response?.data?.text ? await error.response.data.text() : '';
        detalle = texto ? JSON.parse(texto)?.detail || null : null;
      } catch {
        detalle = null;
      }
      toast({
        variant: 'destructive',
        title: 'No se pudo generar la orden de cocina (nueva)',
        description: typeof detalle === 'string' && detalle ? detalle : (error?.message || 'Inténtalo de nuevo.'),
      });
    } finally {
      setDownloading(false);
    }
  };

  // Handler para seleccionar jornada desde el modal
  const handleJornadaSelected = (jornadaId) => {
    setShowJornadaSelector(false);
    if (jornadaPendingAction === 'orden') {
      handleGenerateOrdenCocina(jornadaId);
    } else if (jornadaPendingAction === 'orden_nueva') {
      handleGenerateOrdenCocinaNueva(jornadaId);
    } else if (jornadaPendingAction === 'material') {
      handleGenerateHojaMaterial(jornadaId);
    } else if (jornadaPendingAction === 'minuta') {
      // Otra jornada, otras líneas: la selección de menús empieza de cero
      if (jornadaId !== minutaJornadaId) {
        setMinutaConfig(prev => ({ ...prev, menusSeleccionados: [], platosOcultos: {}, ordenPlatos: {} }));
        setMinutaPreviewHtml('');
      }
      setMinutaJornadaId(jornadaId);
      setShowMinutaModal(true);
    }
    setJornadaPendingAction(null);
  };

  // Parámetro de la jornada de la minuta (multievento)
  const paramJornadaMinuta = minutaJornadaId ? `?jornada_id=${encodeURIComponent(minutaJornadaId)}` : '';
  // Jornada de la minuta y sus líneas (en un evento de un día, las de la cabecera)
  const jornadaMinuta = minutaJornadaId
    ? (presupuesto?.jornadas || []).find(j => j && j.id === minutaJornadaId) || null
    : null;
  const lineasMinuta = jornadaMinuta
    ? lineasJornadaConPlatos(jornadaMinuta, presupuesto?.menus_personalizados || [])
    : (presupuesto?.menus_personalizados || []);
  const numeroJornadaMinuta = jornadaMinuta ? (presupuesto?.jornadas || []).indexOf(jornadaMinuta) + 1 : null;
  const cerrarMinuta = () => {
    setShowMinutaModal(false);
    setMinutaJornadaId(null);
    setMinutaConfig({
      menusSeleccionados: [],
      platosOcultos: {},
      ordenPlatos: {},
      mostrarIngles: false,
      logoCliente: null
    });
  };

  // Función para actualizar la vista previa del HTML
  const actualizarVistaPrevia = async () => {
    if (minutaConfig.menusSeleccionados.length === 0) {
      setMinutaPreviewHtml('');
      return;
    }
    
    try {
      setLoadingPreview(true);
      await esperarAutoguardado();
      const token = getAuthToken();
      if (!token) return;
      
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/vista-previa-minuta${paramJornadaMinuta}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(minutaConfig)
      });

      if (response.ok) {
        const htmlContent = await response.text();
        setMinutaPreviewHtml(htmlContent);
      }
    } catch (error) {
    } finally {
      setLoadingPreview(false);
    }
  };

  // Efecto para actualizar la vista previa cuando cambia la configuración
  useEffect(() => {
    if (showMinutaModal && minutaConfig.menusSeleccionados.length > 0) {
      const timeoutId = setTimeout(() => {
        actualizarVistaPrevia();
      }, 500); // Debounce de 500ms
      return () => clearTimeout(timeoutId);
    }
  }, [showMinutaModal, minutaJornadaId, minutaConfig.menusSeleccionados, minutaConfig.platosOcultos, minutaConfig.ordenPlatos, minutaConfig.mostrarIngles]);

  const handleVistaPrevia = async () => {
    try {
      await esperarAutoguardado();
      const token = getAuthToken();
      if (!token) {
        alert('Sesión expirada. Por favor, inicia sesión nuevamente.');
        return;
      }
      
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/vista-previa-minuta${paramJornadaMinuta}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(minutaConfig)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const htmlContent = await response.text();
      
      // Abrir en nueva pestaña
      const newWindow = window.open('', '_blank');
      newWindow.document.write(htmlContent);
      newWindow.document.close();
      
      
    } catch (error) {
      alert('Error al generar la vista previa. Por favor, intenta nuevamente.');
    }
  };

  const handleGenerarMinuta = async () => {
    try {
      
      if (minutaConfig.menusSeleccionados.length === 0) {
        alert('Debes seleccionar al menos un menú');
        return;
      }
      await esperarAutoguardado();
      
      const token = getAuthToken();
      if (!token) {
        alert('Sesión expirada. Por favor, inicia sesión nuevamente.');
        return;
      }
      
      // Usar safeFetchBlob para evitar conflictos con rrweb-recorder
      const result = await safeFetchBlob(`${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/generar-minuta${paramJornadaMinuta}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(minutaConfig)
      });
      
      
      if (!result.ok) {
        console.error('Error del servidor:', result.error);
        throw new Error(`HTTP error! status: ${result.status} - ${result.error}`);
      }
      
      const url = window.URL.createObjectURL(result.blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `Minuta_${presupuesto.numero || id}${numeroJornadaMinuta ? `_jornada${numeroJornadaMinuta}` : ''}.pdf`;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      setShowMinutaModal(false);
      
    } catch (error) {
      alert('Error al generar la minuta. Por favor, intenta nuevamente. Revisa la consola para más detalles.');
    }
  };

  const verificarFacturaExistente = async () => {
    try {
      
      const token = getAuthToken();
      if (!token) return;
      
      const xhr = new XMLHttpRequest();
      xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/facturas`, true);
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      
      xhr.onload = function() {
        try {
          if (xhr.status >= 200 && xhr.status < 300) {
            const data = JSON.parse(xhr.responseText);
            // Apertura preconfigurada desde la tabla del formato nuevo (se usa una vez)
            const apertura = aperturaFacturaRef.current;
            aperturaFacturaRef.current = null;
            
            // Guardar cada tipo por separado
            setProformaExistente(data.proforma || null);
            setFacturaNormalExistente(data.factura_normal || null);
            setRectificativasExistentes(data.rectificativas || []);
            setAnuladasExistentes(data.anuladas || []);
            setTercerosExistentes(data.terceros || []);
            setFacturasJornadaExistentes(data.facturas_jornada || []);
            
            // Legacy compat: setFacturaGenerada con la factura más relevante
            if (data.factura_normal) {
              setFacturaGenerada({...data.factura_normal, es_existente: true, es_proforma: false});
            } else if (data.proforma) {
              setFacturaGenerada({...data.proforma, es_existente: true, es_proforma: true});
            }
            
            // Cargar observaciones de la factura normal si existe, sino de la proforma.
            // En multievento por jornada NO se prefija nada desde la factura existente:
            // sería la de la PRIMERA jornada emitida y contaminaría la emisión de las
            // siguientes (fecha de emisión antigua, observaciones de otra jornada).
            const facturaRef = data.factura_normal || data.proforma;
            if (facturaRef && presupuesto?.facturacion_multi_evento !== 'por_jornada') {
              if (facturaRef.observaciones) {
                setObservacionesFactura(facturaRef.observaciones);
              }
              if (facturaRef.concepto_unico) {
                setConceptoUnicoFactura(facturaRef.concepto_unico);
              }
              // Una rectificativa se emite hoy: si el modal se abre ya en
              // rectificativa, no se copia la fecha de la factura emitida
              if (facturaRef.fecha_emision && !apertura?.rectificativa) {
                setFechaEmisionFactura(facturaRef.fecha_emision.split('T')[0]);
              }
              // Referencias FACe ya guardadas en la factura: precargarlas para que el
              // modal muestre lo que hay (y no parezca vacío) y para que regenerar
              // desde la tarjeta no las pierda de vista.
              if (facturaRef.face_numero_pedido) setFaceNumPedido(facturaRef.face_numero_pedido);
              if (facturaRef.face_numero_expediente) setFaceNumExpediente(facturaRef.face_numero_expediente);
              if (facturaRef.face_numero_contrato) setFaceNumContrato(facturaRef.face_numero_contrato);
              if (facturaRef.face_observaciones) setFaceObservaciones(facturaRef.face_observaciones);
              // Añadir el nº de factura al asunto para localizarla en el correo.
              // Si se abre para enviar otro documento concreto, el asunto ya lleva el suyo.
              if (facturaRef.numero_factura && !apertura?.documento) {
                const num = facturaRef.numero_factura;
                setAsuntoEmail(prev => (prev && !prev.includes(num)) ? `${prev} ${num}` : prev);
              }
            }

            // El asunto debe llevar SIEMPRE un nº de factura: si todavía no hay
            // factura con número, pedir el próximo previsto (serie DC, solo
            // lectura, sin reservar) y añadirlo. El usuario es el único que emite
            // facturas, así que el previsto coincide con el que se asignará.
            const numExistente = facturaRef?.numero_factura;
            if (!numExistente && presupuesto?.facturacion_multi_evento !== 'por_jornada' && !apertura?.documento) {
              const xhrNum = new XMLHttpRequest();
              xhrNum.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/facturacion/proximo-numero`, true);
              xhrNum.setRequestHeader('Authorization', `Bearer ${token}`);
              xhrNum.onload = function() {
                try {
                  if (xhrNum.status >= 200 && xhrNum.status < 300) {
                    const num = JSON.parse(xhrNum.responseText)?.proximo_numero;
                    if (num) setAsuntoEmail(prev => (prev && !prev.includes(num)) ? `${prev} ${num}` : prev);
                  }
                } catch (e) {
                  console.error('Error obteniendo próximo número de factura:', e);
                }
              };
              xhrNum.send();
            }

            if (apertura) {
              // Facturar parte a otra empresa: abrir el formulario existente con
              // el IVA proporcional si la factura vigente mezcla tipos
              if (apertura.tercero && data.factura_normal) {
                prepararFacturarTercero(Object.keys(pesosIvaDeLineas(data.factura_normal.lineas)).length > 1);
              }
              // Llevar la vista al bloque de la acción elegida
              if (apertura.enfocar) {
                setTimeout(() => {
                  const el = document.querySelector(apertura.enfocar);
                  if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 150);
              }
            }
          }
        } catch (error) {
          console.error('Error verificando facturas:', error);
        }
      };
      
      xhr.onerror = function() {
        console.error('Error de red verificando facturas');
      };
      
      xhr.send();
    } catch (error) {
      console.error('Error verificando facturas:', error);
    }
  };

  // U-52: ?openFactura=true (Finanzas) abre el modal de factura UNA vez, por
  // el camino normal (`handleGeneratePDF('Factura')`, que carga las facturas
  // existentes con `verificarFacturaExistente`) y quita el parámetro de la
  // URL para que no se vuelva a abrir al recargar los datos
  const facturaUrlAbiertaRef = useRef(false);
  // La versión vigente de handleGeneratePDF (se recrea en cada render)
  const handleGeneratePDFRef = useRef(handleGeneratePDF);
  handleGeneratePDFRef.current = handleGeneratePDF;
  useEffect(() => {
    if (openFacturaParam !== 'true' || !presupuesto?.id || facturaUrlAbiertaRef.current) return;
    facturaUrlAbiertaRef.current = true;
    handleGeneratePDFRef.current('Factura');
    setSearchParams((prev) => {
      const siguiente = new URLSearchParams(prev);
      siguiente.delete('openFactura');
      return siguiente;
    }, { replace: true });
  }, [openFacturaParam, presupuesto, setSearchParams]);

  // Avisos antes de regenerar o borrar una factura emitida (U-18, U-22,
  // E-08): no hay límites; se piden al servidor (solo lectura), se enseñan en
  // la confirmación y, si el usuario sigue, se manda `confirmado`. Devuelve
  // null si cancela o {confirmado} si sigue (confirmado solo si los avisos
  // se han podido leer: si no, el servidor responde 409 con ellos).
  const confirmarConAvisosFactura = async (facturaId, accion, textoBase) => {
    let datos = null;
    try {
      const { data } = await api.get(`/facturas/${facturaId}/avisos-regenerar`, { params: { accion } });
      datos = data;
    } catch (e) {
      datos = null;
    }
    if (datos && datos.se_puede === false) {
      alert(datos.motivo || 'Esta factura no se puede regenerar.');
      return null;
    }
    if (!window.confirm(textoConfirmacionAvisos(textoBase, datos))) return null;
    return { confirmado: !!datos };
  };

  // Si el servidor responde 409 con avisos (no se pudieron leer antes), se
  // enseñan y, si el usuario confirma, se repite con `confirmado`
  const reintentarSiPideConfirmacion = async (status, detalle, repetir) => {
    if (status === 409 && detalle && typeof detalle === 'object' && detalle.requiere_confirmacion) {
      if (window.confirm(textoConfirmacionAvisos(detalle.mensaje || '', detalle))) return repetir();
      return null;
    }
    return undefined;
  };

  // Borrar una factura (U-22): mismos avisos y confirmación que regenerar,
  // más el hueco en la numeración si no es la última de su serie. Devuelve
  // la respuesta del servidor, o null si el usuario cancela. Lanza el error
  // del API si falla.
  const borrarFacturaConAvisos = async (facturaId, textoBase) => {
    const conf = await confirmarConAvisosFactura(facturaId, 'eliminar', textoBase);
    if (!conf) return null;
    const borrar = (confirmado) => api.delete(`/facturas/${facturaId}`, { params: confirmado ? { confirmado: true } : {} });
    try {
      const { data } = await borrar(conf.confirmado);
      return data || {};
    } catch (e) {
      const repetido = await reintentarSiPideConfirmacion(e.response?.status, e.response?.data?.detail, () => borrar(true));
      if (repetido === null) return null;
      if (repetido) return repetido.data || {};
      throw e;
    }
  };

  const handleRegenerarConVerifactu = async () => {
    if (!facturaGenerada || !facturaGenerada.factura_id) {
      alert('⚠️ No hay factura seleccionada');
      return;
    }

    // VeriFactu desactivado - No es obligatorio hasta 2027
    alert('VeriFactu no está activo actualmente. No es obligatorio hasta 2027.');
    return;
  };

  // Función para guardar datos de facturación editados
  const handleGuardarDatosFacturacion = async () => {
    if (!facturaGenerada?.factura_id) {
      alert('No hay factura para actualizar');
      return;
    }
    
    setGuardandoDatosFacturacion(true);
    try {
      const token = getAuthToken();
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/facturas/${facturaGenerada.factura_id}/datos-facturacion`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(datosFacturacionEdit)
        }
      );
      
      if (response.ok) {
        const data = await response.json();
        // Actualizar la factura generada con los nuevos datos
        setFacturaGenerada(prev => ({
          ...prev,
          cliente_nombre: datosFacturacionEdit.cliente_nombre,
          cliente_nif: datosFacturacionEdit.cliente_nif,
          cliente_direccion: datosFacturacionEdit.cliente_direccion
        }));
        setEditandoDatosFacturacion(false);
        alert('✅ Datos de facturación actualizados. El PDF se regenerará con los nuevos datos.');
      } else {
        const errorData = await response.json();
        alert(`❌ Error: ${errorData.detail || 'No se pudieron actualizar los datos'}`);
      }
    } catch (error) {
      console.error('Error actualizando datos de facturación:', error);
      alert('❌ Error de conexión al actualizar los datos');
    } finally {
      setGuardandoDatosFacturacion(false);
    }
  };

  // Jornada seleccionada para facturar en el modal (multievento por_jornada).
  // Cuando está fijada, el modal de factura opera sobre esa jornada en vez del
  // presupuesto completo (misma UI: fecha de emisión, observaciones, enviar por email).
  const [jornadaFacturaSel, setJornadaFacturaSel] = useState(null);

  const abrirModalFacturaJornada = (jornada) => {
    if (!jornada?.id) return;
    if (presupuesto?.estado !== 'confirmado') {
      alert('Confirma el presupuesto para poder emitir la factura de la jornada.');
      return;
    }
    // Reutiliza el setup completo del modal de factura (contacto destino, firma,
    // CCO, asunto/cuerpo por defecto…) para que "Enviar por email" funcione igual
    // que en una factura normal.
    handleGeneratePDF('Factura', 'F1');
    setJornadaFacturaSel(jornada);
    setObservacionesFactura(jornada.observaciones || '');
    // Sobrescribir el texto por defecto del email con la fecha de ESTA jornada
    // (el nº de factura se añade al asunto al enviar, cuando ya está asignado)
    const defaultsJornada = construirEmailFacturaDefaults(jornada.fecha, null);
    setAsuntoEmail(defaultsJornada.asunto);
    setMensajeEmail(defaultsJornada.mensaje);
  };

  const cerrarModalFactura = () => {
    setShowFacturaModal(false);
    setJornadaFacturaSel(null);
    setDocumentoEnvioSel(null);
    setFacturaRectificarSel(null);
  };

  const descargarFacturaJornadaPDF = (facturaId, numero) => {
    if (!facturaId) return;
    const token = getAuthToken();
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/facturas/${facturaId}/pdf`, true);
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.responseType = 'blob';
    xhr.onload = function() {
      if (xhr.status === 200) {
        const blob = new Blob([xhr.response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${numero || 'factura'}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else {
        alert('Error al descargar el PDF de la factura');
      }
    };
    xhr.onerror = () => alert('Error de red al descargar la factura');
    xhr.send();
  };

  // Factura que se rectifica: la de la jornada elegida o la vigente del presupuesto
  const facturaARectificar = facturaRectificarSel || facturaNormalExistente;
  // U-19: lo ya rectificado por parciales de la factura a rectificar y lo
  // que queda vivo (la rectificativa total se emite solo por el resto)
  const idFacturaARectificar = facturaARectificar?.factura_id || facturaARectificar?.id;
  const rectificadoParcialPrevio = Math.round((rectificativasExistentes || [])
    .filter((r) => r && r.rectificacion_parcial && idFacturaARectificar && r.factura_rectificada_id === idFacturaARectificar)
    .reduce((acc, r) => acc + Math.abs(Number(r.importe_total) || 0), 0) * 100) / 100;
  const restoPorRectificar = Math.round(((Number(facturaARectificar?.importe_total) || 0) - rectificadoParcialPrevio) * 100) / 100;
  // Tipos de IVA de la factura vigente (para el reparto proporcional de una rectificativa)
  const tiposIvaFacturaVigente = pesosIvaDeLineas(facturaARectificar?.lineas);
  const facturaVigenteMultiIva = Object.keys(tiposIvaFacturaVigente).length > 1;

  // Misma lógica que _tramos_rectificacion_parcial (backend) para enseñar el resultado
  const calcularTramosImporte = (importeTexto, ivaSel, ivaIncluido) => {
    const importe = Math.round(Math.abs(parseFloat(String(importeTexto).replace(',', '.')) || 0) * 100) / 100;
    if (!importe) return null;
    const r2 = (v) => Math.round(v * 100) / 100;
    let pesos = {};
    if (ivaSel === 'prop') {
      Object.entries(tiposIvaFacturaVigente).forEach(([t, w]) => {
        const peso = ivaIncluido ? w.total : w.base;
        if (peso > 0) pesos[t] = peso;
      });
    }
    if (!Object.keys(pesos).length) pesos = { [ivaSel === 'prop' ? 10 : Number(ivaSel)]: 1 };
    const totalPeso = Object.values(pesos).reduce((a, b) => a + b, 0);
    const tipos = Object.keys(pesos).map(Number).sort((a, b) => a - b);
    let acumulado = 0;
    const tramos = tipos.map((t, i) => {
      const parte = i < tipos.length - 1 ? r2(importe * pesos[t] / totalPeso) : r2(importe - acumulado);
      acumulado = r2(acumulado + parte);
      const base = ivaIncluido ? r2(parte / (1 + t / 100)) : parte;
      const cuota = ivaIncluido ? r2(parte - base) : r2(base * t / 100);
      return { tipo: t, base, cuota };
    });
    const base = r2(tramos.reduce((a, x) => a + x.base, 0));
    const cuota = r2(tramos.reduce((a, x) => a + x.cuota, 0));
    return { tramos, base, cuota, total: r2(base + cuota) };
  };
  const previewRectificativa = calcularTramosImporte(importeRectificar, ivaRectificar, ivaIncluidoRectificar);
  const previewTercero = calcularTramosImporte(terceroImporte, terceroIva, terceroIvaIncluido);

  const prepararFacturarTercero = (multiIva) => {
    setShowFacturarTercero(true);
    setTerceroClienteId('');
    setTerceroBusqueda('');
    setTerceroImporte('');
    setTerceroIvaIncluido(true);
    setTerceroIva(multiIva ? 'prop' : '10');
    setTerceroConcepto('');
    setTerceroFecha(hoyMadrid());
    if (!todosClientes || todosClientes.length === 0) cargarTodosClientes();
  };
  const abrirFacturarTercero = () => prepararFacturarTercero(facturaVigenteMultiIva);

  const handleFacturarTercero = async () => {
    const empresa = (todosClientes || []).find(c => c.id === terceroClienteId);
    if (!empresa) { alert('Elige la empresa que asume la parte (debe existir en el CRM).'); return; }
    if (!previewTercero) { alert('Indica el importe que asume la otra empresa.'); return; }
    const eur = (v) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(v);
    const nombreEmpresa = empresa.nombre_fiscal || empresa.nombre_empresa || empresa.nombre || 'la empresa';
    const ok = window.confirm(
      `Se van a emitir dos facturas:\n\n` +
      `1. Rectificativa a ${facturaNormalExistente?.cliente_nombre || 'el cliente'}: -${eur(previewTercero.total)} (sobre ${facturaNormalExistente?.numero_factura}).\n` +
      `2. Factura a ${nombreEmpresa}: ${eur(previewTercero.total)} (base ${eur(previewTercero.base)} + IVA ${eur(previewTercero.cuota)}).\n\n¿Continuar?`
    );
    if (!ok) return;
    setTerceroEnviando(true);
    try {
      const payload = {
        cliente_id: terceroClienteId,
        importe: parseFloat(String(terceroImporte).replace(',', '.')),
        iva_incluido: terceroIvaIncluido,
        iva_proporcional: terceroIva === 'prop',
        concepto: terceroConcepto.trim() || null,
        fecha_emision: terceroFecha || null,
        observaciones: observacionesFactura || null,
      };
      if (terceroIva !== 'prop') payload.iva = parseFloat(terceroIva);
      const { data } = await api.post(`/presupuestos/${id}/facturar-a-tercero`, payload);
      setShowFacturarTercero(false);
      verificarFacturaExistente();
      alert(`Emitidas:\n\nRectificativa ${data.rectificativa?.numero_factura}\nFactura ${data.factura_tercero?.numero_factura} a ${data.factura_tercero?.cliente_nombre}`);
    } catch (e) {
      alert(e.response?.data?.detail || `Error al facturar a la otra empresa: ${e.message}`);
    } finally {
      setTerceroEnviando(false);
    }
  };

  const handleGenerarFactura = async (silent = false) => {
    ultimoErrorFacturaRef.current = null;
    // Rectificativa: 'total' anula la factura vigente (la nueva se genera después,
    // ya con los datos corregidos); 'parcial' descuenta un importe y la original
    // sigue vigente. Es irreversible, así que se confirma siempre.
    const isRectificativa = tipoFactura.startsWith('R');
    const esRectParcial = isRectificativa && modoRectificativa === 'parcial';
    const importeRect = parseFloat(String(importeRectificar).replace(',', '.'));
    if (isRectificativa) {
      const numOriginal = facturaARectificar?.numero_factura || 'la factura vigente';
      if (esRectParcial && !(importeRect > 0)) {
        ultimoErrorFacturaRef.current = 'Indica el importe a descontar.';
        return null;
      }
      const eur = (v) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(v);
      const prev = esRectParcial ? previewRectificativa : null;
      const textoParciales = rectificadoParcialPrevio > 0
        ? `\n\n${numOriginal} ya tiene rectificativas parciales por ${eur(rectificadoParcialPrevio)}: la total se emite por ${eur(restoPorRectificar)}.`
        : '';
      const textoDespues = anularYReemitir && !facturaRectificarSel
        ? 'Justo después se emitirá la factura nueva con los datos actuales del presupuesto.'
        : 'El presupuesto quedará pendiente de facturar: después emites la nueva factura con los datos corregidos (cliente, importes...).';
      const ok = window.confirm(esRectParcial
        ? `Vas a emitir una factura rectificativa de -${eur(prev?.total || 0)} (base -${eur(prev?.base || 0)} + IVA -${eur(prev?.cuota || 0)}) sobre ${numOriginal}.\n\n${numOriginal} seguirá vigente por el importe restante.\n\n¿Continuar?`
        : `Vas a emitir una factura rectificativa que ANULA ${numOriginal}.${textoParciales}\n\n${textoDespues}\n\n¿Continuar?`);
      if (!ok) {
        ultimoErrorFacturaRef.current = 'Emisión de la rectificativa cancelada.';
        return null;
      }
    }
    return new Promise((resolve, reject) => {
      try {

        // Obtener token
        const token = getAuthToken();
        if (!token) {
          ultimoErrorFacturaRef.current = 'Sesión expirada. Inicia sesión de nuevo.';
          if (!silent) alert('⚠️ Sesión expirada. Por favor, inicia sesión nuevamente.');
          resolve(null);
          return;
        }
        
        // Construir payload. U-17: con la factura normal ya emitida no se
        // manda su fecha (el campo la trae para Regenerar): el servidor no la
        // cambia por aquí
        const reenviaExistente = tipoFactura === 'F1' && !!facturaNormalExistente && !jornadaFacturaSel;
        const facturaPayload = {
          presupuesto_id: id,
          tipo_factura: tipoFactura,
          fecha_emision: reenviaExistente ? null : fechaEmisionFactura,
          observaciones: observacionesFactura || null,
          concepto_unico: conceptoUnicoFactura || null
        };
        // U-90: fecha de operación = la del evento si ya se celebró (si es
        // posterior a la emisión, no se manda)
        const fechaEventoFactura = jornadaFacturaSel?.fecha
          ? String(jornadaFacturaSel.fecha).slice(0, 10)
          : (!esMultievento(presupuesto) && presupuesto?.fecha_evento ? String(presupuesto.fecha_evento).slice(0, 10) : null);
        if (!isRectificativa && tipoFactura !== 'PROFORMA' && fechaEventoFactura && fechaEmisionFactura
            && fechaEventoFactura <= fechaEmisionFactura) {
          facturaPayload.fecha_operacion = fechaEventoFactura;
        }
        // U-21: rectificativa total. "Anular y emitir la nueva" pide al
        // servidor la factura nueva con los datos de hoy; "Solo anular" deja
        // el presupuesto pendiente de facturar
        if (isRectificativa && !esRectParcial) {
          facturaPayload.anulacion_total = anularYReemitir && !facturaRectificarSel;
        }
        // Factura concreta (la de una jornada): el servidor rectifica esa
        if (isRectificativa && facturaRectificarSel?.id) {
          facturaPayload.factura_id = facturaRectificarSel.id;
        }
        if (esRectParcial) {
          facturaPayload.importe_rectificar = importeRect;
          facturaPayload.iva_incluido = ivaIncluidoRectificar;
          facturaPayload.iva_proporcional = ivaRectificar === 'prop';
          if (ivaRectificar !== 'prop') facturaPayload.iva_rectificar = parseFloat(ivaRectificar);
          facturaPayload.concepto_rectificar = conceptoRectificar.trim() || null;
        }

        // Nº de pedido del cliente: para cualquier cliente (se imprime en la
        // cabecera del PDF y viaja en el Facturae si es FACe)
        facturaPayload.face_numero_pedido = faceNumPedido.trim() || null;
        // FACe: solo si está en la pestaña FACe, adjuntar destino DIR3 + referencias
        if (cliente?.es_administracion_publica && modoFactura === 'face') {
          facturaPayload.face_destino_id = faceDestinoId || null;
          facturaPayload.face_numero_expediente = faceNumExpediente || null;
          facturaPayload.face_numero_contrato = faceNumContrato || null;
          facturaPayload.face_observaciones = faceObservaciones || null;
        }
        
        // Determinar endpoint según tipo de factura
        const isProforma = tipoFactura === 'PROFORMA';
        let endpoint;
        if (isProforma) {
          endpoint = `${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/generar-proforma`;
        } else if (jornadaFacturaSel) {
          // Factura de UNA jornada concreta (multievento por_jornada)
          endpoint = `${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/jornadas/${jornadaFacturaSel.id}/generar-factura`;
        } else {
          endpoint = `${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/generar-factura`;
        }
        
        // Usar XMLHttpRequest para evitar interceptación del rrweb-recorder
        const xhr = new XMLHttpRequest();
        xhr.open('POST', endpoint, true);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.setRequestHeader('Content-Type', 'application/json');
        
        xhr.onload = function() {
          try {
            let responseData;
            try {
              responseData = JSON.parse(xhr.responseText);
            } catch (e) {
              responseData = { detail: xhr.responseText };
            }
            
            if (xhr.status >= 200 && xhr.status < 300) {
              
              // Guardar datos de factura generada
              setFacturaGenerada(responseData);
              
              // Actualizar el tracking independiente según tipo
              if (isProforma) {
                setProformaExistente(responseData);
              } else if (tipoFactura.startsWith('R')) {
                setRectificativasExistentes(prev => [...prev, responseData]);
                // La original queda anulada: el presupuesto ya no tiene factura vigente
                if (responseData.factura_anulada) {
                  setFacturaNormalExistente(null);
                }
              } else {
                setFacturaNormalExistente(responseData);
              }
              
              // Recargar todas las facturas
              verificarFacturaExistente();
              
              // Mostrar mensaje solo si no es modo silencioso
              if (!silent) {
                if (isProforma) {
                  alert(`✅ Proforma ${responseData.numero_proforma} generada exitosamente\nImporte: €${responseData.importe_total?.toFixed(2)}`);
                } else if (responseData.nueva_factura_normal) {
                  // Anulación total: rectificativa + nueva normal
                  alert(
                    `✅ Anulación total completada:\n\n` +
                    `📄 Rectificativa: ${responseData.numero_factura}\n` +
                    `📄 Nueva factura: ${responseData.nueva_factura_normal.numero_factura}\n\n` +
                    `La factura original ha sido anulada.`
                  );
                } else if (responseData.nueva_factura_normal_error) {
                  alert(
                    `Rectificativa ${responseData.numero_factura} emitida: ${responseData.factura_anulada || 'la factura'} queda anulada.\n\n` +
                    `No se pudo emitir la factura nueva: ${textoDetalleApi(responseData.nueva_factura_normal_error)}\n\n` +
                    `El presupuesto queda pendiente de facturar.`
                  );
                } else if (responseData.es_existente) {
                  // Si ya existía, solo mostrar mensaje si las observaciones cambiaron
                  if (observacionesFactura && observacionesFactura.trim() !== '') {
                    alert(`✅ Observaciones actualizadas para factura ${responseData.numero_factura}`);
                  } else {
                    alert(`ℹ️ Factura ${responseData.numero_factura} ya existe`);
                  }
                } else {
                  // Verificar si tiene referencia a proforma
                  const proformaRef = presupuesto?.numero_proforma;
                  if (proformaRef) {
                    alert(`✅ Factura ${responseData.numero_factura} generada exitosamente\n📋 Referencia a Proforma: ${proformaRef}`);
                  } else {
                    alert(`✅ Factura ${responseData.numero_factura} generada exitosamente`);
                  }
                }
              }
              // Factura por jornada: el importe guardado no coincide con el
              // recalculado (no bloquea; se corrige al volver a guardar la ficha)
              if (responseData.aviso && !silent) {
                alert(`Aviso: ${responseData.aviso}`);
              }
              
              resolve(responseData);
            } else {
              const errorMessage = textoDetalleApi(responseData.detail || responseData.message, 'Error al generar factura');
              
              // Mensajes de error más específicos
              let errorMsg = errorMessage;
              if (xhr.status === 409) {
                // Facturación por jornada que no cuadra con el total del presupuesto
                errorMsg = `Aviso: ${errorMessage}`;
              } else if (errorMsg.includes('confirmado')) {
                errorMsg = '⚠️ El presupuesto debe estar CONFIRMADO para generar una factura.\n\nPor favor, confirma el presupuesto primero desde el botón "Confirmar Presupuesto".';
              } else if (errorMsg.includes('menú')) {
                errorMsg = '⚠️ El presupuesto debe tener al menos un menú para generar una factura.';
              } else if (errorMsg.includes('Cliente not found')) {
                errorMsg = '⚠️ No se encontró la información del cliente. Por favor, verifica que el presupuesto tenga un cliente asignado.';
              } else if (errorMsg.includes('Ya existe una proforma')) {
                errorMsg = `ℹ️ ${errorMsg}`;
              } else {
                errorMsg = `⚠️ Error al generar la ${isProforma ? 'proforma' : 'factura'}: ${errorMsg}`;
              }
              
              console.error('❌ Error generando factura:', errorMsg);
              ultimoErrorFacturaRef.current = `${errorMessage} (HTTP ${xhr.status})`;
              if (!silent) alert(errorMsg);
              resolve(null);
            }
          } catch (error) {
            console.error('❌ Error procesando respuesta:', error);
            ultimoErrorFacturaRef.current = error.message;
            if (!silent) alert(`⚠️ Error al generar la factura: ${error.message}`);
            resolve(null);
          }
        };

        xhr.onerror = function() {
          console.error('❌ Error de red al generar factura');
          ultimoErrorFacturaRef.current = 'Error de red: el servidor no ha respondido.';
          if (!silent) alert('⚠️ Error de red al generar la factura');
          resolve(null);
        };

        xhr.send(JSON.stringify(facturaPayload));

      } catch (error) {
        console.error('❌ Error generando factura:', error);
        ultimoErrorFacturaRef.current = error.message;
        if (!silent) alert(`⚠️ Error al generar la factura: ${error.message}`);
        resolve(null);
      }
    });
  };

  const handleSaveClienteEdit = async () => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/clientes/${cliente.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(clienteEditData)
      });

      // Leer response UNA SOLA VEZ
      let responseData;
      try {
        const textResponse = await response.text();
        try {
          responseData = JSON.parse(textResponse);
        } catch (e) {
          responseData = { detail: textResponse };
        }
      } catch (e) {
        responseData = { detail: `Error ${response.status}: ${response.statusText}` };
      }

      if (!response.ok) {
        const errorMessage = responseData.detail || responseData.message || 'Error al actualizar cliente';
        throw new Error(errorMessage);
      }

      const updatedCliente = responseData;
      
      // Actualizar el cliente en el estado local
      setCliente(updatedCliente);
      setShowEditClienteModal(false);
      alert('✅ Cliente actualizado correctamente');
      
    } catch (error) {
      console.error('Error:', error);
      alert('⚠️ Error al actualizar el cliente: ' + error.message);
    }
  };

  const handleDescargarFactura = async () => {
    try {
      const token = getAuthToken();
      if (!token) {
        alert('Sesión expirada. Por favor, inicia sesión nuevamente.');
        return;
      }
      
      // Determinar qué factura descargar según el tipo seleccionado.
      // Si se está facturando una jornada suelta, NO usar las facturas de nivel
      // presupuesto: hay que emitir la de esa jornada (cae al camino de generar).
      let facturaId = null;
      let numeroFactura = '';

      if (documentoEnvioSel) {
        // Documento concreto elegido en la tabla del formato nuevo: se descarga tal cual
        facturaId = documentoEnvioSel.factura_id || documentoEnvioSel.id;
        numeroFactura = documentoEnvioSel.numero_factura || documentoEnvioSel.numero_proforma || '';
      } else if (jornadaFacturaSel) {
        facturaId = null;
      } else if (tipoFactura === 'PROFORMA' && proformaExistente) {
        facturaId = proformaExistente.factura_id || proformaExistente.id;
        numeroFactura = proformaExistente.numero_factura;
      } else if (tipoFactura === 'F1' && facturaNormalExistente) {
        facturaId = facturaNormalExistente.factura_id || facturaNormalExistente.id;
        numeroFactura = facturaNormalExistente.numero_factura;
      } else if (tipoFactura.startsWith('R') && rectificativasExistentes.length > 0
                 && modoRectificativa === 'total' && !facturaNormalExistente) {
        // Ya no queda factura vigente que rectificar: descargar la última rectificativa
        const rect = rectificativasExistentes[rectificativasExistentes.length - 1];
        facturaId = rect.factura_id || rect.id;
        numeroFactura = rect.numero_factura;
      }
      // NOTE: Do NOT fall through to facturaGenerada here - it might be a proforma
      // when user wants a normal invoice. Let it go to the "generate and download" path below.
      
      // Si hay factura existente del tipo seleccionado, descargar directamente
      if (facturaId) {
        const xhr = new XMLHttpRequest();
        const queryPago = ocultarDatosPago ? '?ocultar_datos_pago=true' : '';
        xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/facturas/${facturaId}/pdf${queryPago}`, true);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.responseType = 'blob';
        xhr.onload = function() {
          if (xhr.status === 200) {
            const blob = new Blob([xhr.response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${numeroFactura}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          } else {
            alert('Error al descargar el PDF');
          }
        };
        xhr.onerror = function() {
          alert('Error de red al descargar la factura');
        };
        xhr.send();
        return;
      }
      
      // Si no hay factura existente, generar y descargar
      const facturaData = await handleGenerarFactura(true);
      if (!facturaData) {
        const motivo = ultimoErrorFacturaRef.current || 'sin detalle del servidor';
        alert(`Error al preparar la factura para descarga.\n\nMotivo: ${motivo}`);
        return;
      }
      if (!facturaData.factura_id) {
        // Multievento: el servidor procesó la petición pero no hay ninguna
        // factura nueva ni existente que descargar desde aquí.
        alert(
          'No hay ninguna factura que descargar desde este botón.\n\n' +
          (facturaData.message ? `Servidor: ${facturaData.message}\n\n` : '') +
          'Si es un presupuesto multievento, descarga cada factura desde la lista de facturas emitidas.'
        );
        return;
      }
      
      
      const xhr = new XMLHttpRequest();
      const queryPagoNueva = ocultarDatosPago ? '?ocultar_datos_pago=true' : '';
      xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/facturas/${facturaData.factura_id}/pdf${queryPagoNueva}`, true);
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      xhr.responseType = 'blob';

      xhr.onload = function() {
        if (xhr.status === 200) {
          const blob = xhr.response;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `factura_${facturaData.numero_factura}.pdf`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          
          setShowFacturaModal(false);
          fetchData();
        } else {
          alert(`Error al descargar: ${xhr.statusText}`);
        }
      };
      
      xhr.onerror = function() {
        alert('Error de red al descargar la factura');
      };
      
      xhr.send();
      
    } catch (error) {
      console.error('Error descargando factura:', error);
      alert(`Error al descargar: ${error.message}`);
    }
  };

  const handleEnviarFactura = async () => {
    try {
      // Validar que hay un contacto de destino seleccionado
      if (!contactoDestinoId) {
        alert('⚠️ Por favor, selecciona un contacto de destino para el email.');
        return;
      }

      // Confirmar el destinatario antes de enviar (evita facturar a la persona equivocada)
      const contactoDestino = personasContacto.find(p => p.id === contactoDestinoId);
      const nombreDestino = contactoDestino?.nombre || contactoDestinoId;
      const emailDestino = contactoDestino?.email || '';
      const confirmarDestino = window.confirm(
        `Vas a enviar la FACTURA a:\n\n${nombreDestino}${emailDestino ? `  <${emailDestino}>` : ''}\n\n¿Es el destinatario correcto?`
      );
      if (!confirmarDestino) return;

      // SIEMPRE actualizar observaciones antes de enviar. Excepción: rectificativa
      // total ya emitida (no queda factura vigente) → se envía la última existente.
      const reenviarRect = tipoFactura.startsWith('R') && modoRectificativa === 'total'
        && !facturaNormalExistente && rectificativasExistentes.length > 0;
      // Documento concreto elegido en la tabla del formato nuevo: se envía tal cual
      const facturaData = documentoEnvioSel
        ? { ...documentoEnvioSel, factura_id: documentoEnvioSel.factura_id || documentoEnvioSel.id }
        : reenviarRect
        ? (() => {
            const r = rectificativasExistentes[rectificativasExistentes.length - 1];
            return { ...r, factura_id: r.factura_id || r.id };
          })()
        : await handleGenerarFactura(true); // true = modo silencioso
      if (!facturaData) {
        alert(`⚠️ Error al preparar la factura para envío${ultimoErrorFacturaRef.current ? `\n\nMotivo: ${ultimoErrorFacturaRef.current}` : ''}`);
        return;
      }
      
      
      // Obtener token
      const token = getAuthToken();
      if (!token) {
        alert('⚠️ Sesión expirada. Por favor, inicia sesión nuevamente.');
        return;
      }

      // Asegurar que el asunto lleva el nº definitivo de la factura que se envía
      // (recién generado en facturas nuevas, incluida la factura por jornada)
      let asuntoFinal = asuntoEmail;
      const numFacturaEnvio = facturaData.numero_factura || facturaData.numero_proforma;
      if (numFacturaEnvio && !asuntoFinal.includes(numFacturaEnvio)) {
        asuntoFinal = `${asuntoFinal} ${numFacturaEnvio}`.trim();
      }

      // Preparar datos del email
      const firmaActual = firmasEmail[firmaSeleccionada];
      const emailData = {
        remitente: emailOrigen,
        contacto_id: contactoDestinoId,
        asunto: asuntoFinal,
        mensaje: mensajeEmail,
        cc: ccEmails || '',
        cco: ccoEmails || '',
        firma: firmaSeleccionada !== 'ninguna' ? {
          nombre: firmaActual.nombre,
          imagen_url: firmaActual.imagen,
          texto_legal: firmaActual.textoLegal
        } : null,
        ocultar_datos_pago: ocultarDatosPago,
        invitar_resena_google: invitarResenaGoogle,
      };

      // Enviar email con la factura usando XMLHttpRequest
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${process.env.REACT_APP_BACKEND_URL}/api/facturas/${facturaData.factura_id}/enviar-email`, true);
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      xhr.setRequestHeader('Content-Type', 'application/json');
      
      xhr.onload = function() {
        try {
          if (xhr.status >= 200 && xhr.status < 300) {
            const result = JSON.parse(xhr.responseText);
            alert(`✅ Factura ${facturaData.numero_factura} enviada exitosamente por email a:\n\n${result.destinatario}${result.cc && result.cc.length > 0 ? '\nCC: ' + result.cc.join(', ') : ''}`);
            
            // Cerrar modal
            setShowFacturaModal(false);
            
            // Recargar datos
            fetchData();
          } else {
            const errorData = JSON.parse(xhr.responseText);
            throw new Error(errorData.detail || 'Error al enviar email');
          }
        } catch (error) {
          console.error('❌ Error enviando factura:', error);
          alert(`⚠️ Error al enviar: ${error.message}`);
        }
      };
      
      xhr.onerror = function() {
        console.error('❌ Error de red al enviar factura');
        alert('⚠️ Error de red al enviar la factura por email');
      };
      
      xhr.send(JSON.stringify(emailData));
      
    } catch (error) {
      console.error('❌ Error enviando factura:', error);
      
      // Mensajes de error más específicos
      let errorMsg = error.message;
      if (errorMsg.includes('confirmado')) {
        errorMsg = '⚠️ El presupuesto debe estar CONFIRMADO para generar una factura.\n\nPor favor, confirma el presupuesto primero desde el botón "Confirmar Presupuesto".';
      } else if (errorMsg.includes('menú')) {
        errorMsg = '⚠️ El presupuesto debe tener al menos un menú para generar una factura.';
      } else if (errorMsg.includes('Cliente not found')) {
        errorMsg = '⚠️ No se encontró la información del cliente. Por favor, verifica que el presupuesto tenga un cliente asignado.';
      } else {
        errorMsg = `⚠️ Error al enviar: ${errorMsg}`;
      }
      
      alert(errorMsg);
    }
  };

  const generateCustomMenuName = () => {
    const empresaNombre = cliente?.nombre_empresa || 'Cliente';
    const fechaEvento = presupuesto?.fecha_evento || hoyMadrid();
    const [year, month, day] = fechaEvento.split('-');
    return `Menú personalizado ${empresaNombre} / ${day}/${month}/${year}`;
  };

  const handleOpenCustomMenuModal = () => {
    setCustomMenuName(generateCustomMenuName());
    setCustomMenuPrecio(''); // Inicializar precio vacío
    setSelectedPlatos([]); // Array vacío para platos con cantidades
    setPlatoFilters({
      precioMax: '',
      alergenosEvitar: [],
      categoria: '',
      tiempoMax: '',
      contiene_carne: false,
      derivado_animal: false,
      contiene_cerdo: false,
      no_apto_embarazadas: false,
      sin_lactosa: false
    });
    setCustomMenuPersonas('');
    setShowCustomMenuModal(true);
  };

  const togglePlatoSelection = (platoId) => {
    setSelectedPlatos(prev => {
      const exists = prev.find(p => p.platoId === platoId);
      if (exists) {
        // Deseleccionar - eliminar del array
        return prev.filter(p => p.platoId !== platoId);
      } else {
        // Seleccionar - añadir con cantidad 1
        return [...prev, { platoId, cantidad: 1 }];
      }
    });
  };

  const updatePlatoCantidad = (platoId, cantidad) => {
    setSelectedPlatos(prev => 
      prev.map(p => p.platoId === platoId ? { ...p, cantidad: cantidad === '' ? '' : parseFloat(cantidad) || 0.5 } : p)
    );
  };

  const getFilteredPlatos = () => {
    return platos.filter(plato => {
      if (!plato.activo) return false;
      
      // Filtro de búsqueda por texto (nombre del plato)
      if (platoFilters.searchText && platoFilters.searchText.trim()) {
        const searchLower = platoFilters.searchText.toLowerCase();
        const nombreLower = plato.nombre.toLowerCase();
        if (!nombreLower.includes(searchLower)) return false;
      }
      
      // Filtro por precio máximo
      if (platoFilters.precioMax && plato.coste_racion > parseFloat(platoFilters.precioMax)) {
        return false;
      }
      
      // Filtro por alérgenos (CONTIENE)
      if (platoFilters.alergenosEvitar.length > 0) {
        const contieneAlergeno = plato.alergenos_ids?.some(
          alergId => platoFilters.alergenosEvitar.includes(alergId)
        );
        if (contieneAlergeno) return false;
        
        // Si incluirTrazas está activo, también excluir por trazas
        if (platoFilters.incluirTrazas) {
          const contieneTrazas = plato.trazas_alergenos_ids?.some(
            trazaId => platoFilters.alergenosEvitar.includes(trazaId)
          );
          if (contieneTrazas) return false;
        }
      }
      
      // Filtro por tiempo de preparación
      if (platoFilters.tiempoMax && plato.tiempo_preparacion_min > parseInt(platoFilters.tiempoMax)) {
        return false;
      }
      
      // Filtro por categoría
      if (platoFilters.categoria && plato.categoria !== platoFilters.categoria) {
        return false;
      }
      
      // Características del plato (desde plato.caracteristicas que viene del backend)
      const caracteristicas = plato.caracteristicas || {};
      
      // Filtro EVITAR contiene carne
      if (platoFilters.contiene_carne && caracteristicas.contiene_carne) {
        return false;
      }
      
      // Filtro EVITAR derivado animal (origen animal)
      if (platoFilters.derivado_animal && caracteristicas.origen_animal) {
        return false;
      }
      
      // Filtro EVITAR contiene cerdo
      if (platoFilters.contiene_cerdo && caracteristicas.contiene_cerdo) {
        return false;
      }
      
      // Filtro EVITAR no apto embarazadas
      if (platoFilters.no_apto_embarazadas && caracteristicas.no_apto_embarazadas) {
        return false;
      }
      
      // Filtro INCLUIR solo sin lactosa (si está activo, excluir los que contienen lactosa)
      if (platoFilters.sin_lactosa && caracteristicas.sin_lactosa === false) {
        return false;
      }
      
      return true;
    });
  };

  const calculateCustomMenuPrice = () => {
    return selectedPlatos.reduce((total, { platoId, cantidad }) => {
      const plato = platos.find(p => p.id === platoId);
      const cantidadFinal = cantidad === '' ? 0 : (parseFloat(cantidad) || 0.5);
      const costePlato = plato?.coste_por_porcion || plato?.coste_total || plato?.coste_racion || 0;
      return total + (costePlato * cantidadFinal);
    }, 0);
  };

  const handleSaveCustomMenu = async () => {
    // Permitir menús placeholder sin platos y con precio 0
    // No se requiere validación de platos ni precio mínimo

    setAddingCustomMenu(true); // Activar loading
    
    try {
      const menusPersonalizados = presupuesto.menus_personalizados || [];
      
      const precioTotal = customMenuPrecio ? parseFloat(customMenuPrecio) : 0;
      // Personas por defecto (M-98): en un multievento, las de una jornada
      const numPersonas = customMenuPersonas ? parseInt(customMenuPersonas) : personasPorDefectoLinea(presupuesto);
      // IVA elegido (un 0 se respeta); vacío o no válido, 10 %
      const ivaPercent = Number.isFinite(parseInt(customMenuIva, 10)) ? parseInt(customMenuIva, 10) : 10;

      const nuevaLinea = {
        menu_id: `custom-${Date.now()}`,
        nombre_menu: customMenuName,
        platos_ids: selectedPlatos.map(p => p.platoId), // Solo IDs para compatibilidad
        platos_cantidades: selectedPlatos, // Guardar con cantidades
        num_personas: numPersonas,
        adaptaciones: [],
        es_personalizado: true,
        precio_unitario: precioTotal,
        precio_ud: precioTotal,
        // IVA del menú (10% catering por defecto, 21% p. ej. si incluye transporte)
        tipo_iva: ivaPercent,
        iva_percent: ivaPercent,
        // Bebida incluida
        bebida_incluida: customMenuBebidaIncluida,
        bebidas_por_persona: customMenuBebidaIncluida ? customMenuBebidasPorPersona : 0,
        // Personal por defecto (4 horas)
        horas_por_camarero: 4,
        coste_camarero_hora: 25,
        coste_personal_propio_hora: 15.6
      };

      // Multievento: a las jornadas elegidas, con las personas de cada una
      if (esMultieventoFicha()) {
        await presupuestosAPI.anadirLineaMultievento(presupuesto.id, {
          linea: nuevaLinea,
          jornadas_ids: jornadasMenuToAdd,
          num_personas: customMenuPersonas ? parseInt(customMenuPersonas, 10) : null,
        });
        await alActualizarMultievento();
        setShowCustomMenuModal(false);
        setCustomMenuName('');
        setCustomMenuPrecio('');
        setCustomMenuIva('10');
        setCustomMenuPersonas('');
        setSelectedPlatos([]);
        setCustomMenuBebidaIncluida(false);
        setCustomMenuBebidasPorPersona(1);
        setJornadasMenuToAdd(null);
        toast({ title: 'Menú personalizado añadido', description: 'En las jornadas elegidas, con sus personas.' });
        return;
      }
      menusPersonalizados.push(nuevaLinea);

      // Calcular nuevos totales
      const importeNuevoMenu = precioTotal * numPersonas;
      const ivaNuevoMenu = importeNuevoMenu * (ivaPercent / 100);
      
      const nuevoSubtotal = calculateSubtotal() + importeNuevoMenu;
      const nuevoIva = calculateTotalIva() + ivaNuevoMenu;
      const nuevoTotal = nuevoSubtotal + nuevoIva;

      const updatedPresupuesto = {
        ...presupuesto,
        menus_personalizados: menusPersonalizados,
        importe_base: nuevoSubtotal,
        iva: nuevoIva,
        importe_total: nuevoTotal
      };

      await guardarFicha(updatedPresupuesto);
      
      // Recargar datos y resetear estados
      await fetchData();
      setShowCustomMenuModal(false);
      setCustomMenuName('');
      setCustomMenuPrecio('');
      setCustomMenuIva('10');
      setCustomMenuPersonas('');
      setSelectedPlatos([]);
      setCustomMenuBebidaIncluida(false);
      setCustomMenuBebidasPorPersona(1);
      avisoGuardadoOk('Menú personalizado añadido correctamente');
    } catch (error) {
      console.error('Error saving custom menu:', error);
      avisoGuardadoError('Error al guardar el menú personalizado: ' + (error.response?.data?.detail || error.message), error);
    } finally {
      setAddingCustomMenu(false); // Desactivar loading
    }
  };

  // Aplica el sobrante de un ingrediente como cortesía al cliente:
  // sube `unidades_por_plato[plato_id]` del menú de esa jornada para que
  // la cocina prepare las uds redondeadas (envase entero). El cliente recibe
  // las uds extra sin coste adicional para Duetto.
  const handleRegalarSobrante = async (jornadaId, detalleIng) => {
    const platosUso = detalleIng.platos_uso || [];
    if (platosUso.length === 0) {
      alert('No hay platos asociados a este ingrediente para aplicar el regalo.');
      return;
    }

    // Si hay varios platos candidatos, pedir al usuario que elija
    let platoId;
    if (platosUso.length === 1) {
      platoId = platosUso[0].plato_id;
    } else {
      const opciones = platosUso
        .map((p, i) => `${i + 1}) ${p.nombre} (uds actuales: ${p.uds_actuales})`)
        .join('\n');
      const respuesta = window.prompt(
        `El ingrediente "${detalleIng.nombre}" se usa en varios platos. ¿A cuál añadir las uds extra?\n\n${opciones}\n\nEscribe el número:`
      );
      const idx = parseInt(respuesta, 10) - 1;
      if (isNaN(idx) || idx < 0 || idx >= platosUso.length) return;
      platoId = platosUso[idx].plato_id;
    }

    const platoElegido = platosUso.find(p => p.plato_id === platoId);
    const sobranteTxt = `${detalleIng.sobrante_uds.toFixed(2)} ${detalleIng.unidad} (${detalleIng.sobrante_eur.toFixed(2)} €)`;
    if (!window.confirm(
      `¿Regalar al cliente ${sobranteTxt} de "${detalleIng.nombre}"?\n\n` +
      `Se subirán las uds por persona del plato "${platoElegido?.nombre}" para que la cocina prepare el envase entero.`
    )) return;

    setRegalandoSobrante(true);
    try {
      const token = getAuthToken();
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/regalar-sobrante`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({
            jornada_id: jornadaId || null,
            ingrediente_id: detalleIng.ingrediente_id,
            plato_id: platoId,
          }),
        }
      );
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || 'Error al aplicar el regalo');
      }
      const data = await res.json();
      if (data.desperdicio) setDesperdicio(data.desperdicio);
      // Refrescar el presupuesto entero para que se vean las nuevas uds en menús
      await fetchData();
    } catch (e) {
      console.error('Error regalando sobrante:', e);
      alert('Error: ' + e.message);
    } finally {
      setRegalandoSobrante(false);
    }
  };

  // Cancelar evento: abre el modal con el motivo (también sirve para registrar
  // el motivo de un evento ya cancelado que no lo tenía). Los dos formatos van
  // por POST /cancelar (U-07): si estaba confirmado se deshace la confirmación
  // y se pueden anular los pedidos pendientes (alquiler y personal extra).
  const handleCancelarEvento = async () => {
    setCancelacionForm({ motivo: '', comentario: '', importe_facturado_cancelacion: '' });
    setErrorCancelacion(null);
    setInfoCancelacion(null);
    setPedidosCancelacion([]);
    setShowCancelarModal(true);
    setCargandoInfoCancelacion(true);
    try {
      const { data } = await presupuestosAPI.cancelacionPendientes(id);
      setInfoCancelacion(data || null);
      // Casilla "Enviar anulación al proveedor" marcada por defecto
      setPedidosCancelacion((data?.pedidos || []).map(p => ({ ...p, anular: true, enviar_email: true })));
    } catch (error) {
      setErrorCancelacion('No se han podido leer los pedidos pendientes: ' + (error.response?.data?.detail || error.message));
    } finally {
      setCargandoInfoCancelacion(false);
    }
  };

  const cambiarPedidoCancelacion = (indice, campo, valor) => {
    setPedidosCancelacion(prev => prev.map((p, i) => {
      if (i !== indice) return p;
      const nuevo = { ...p, [campo]: valor };
      // Sin anular no se envía nada
      if (campo === 'anular' && !valor) nuevo.enviar_email = false;
      return nuevo;
    }));
  };

  const handleConfirmarCancelacion = async () => {
    if (!cancelacionForm.motivo) {
      setErrorCancelacion('Elige el motivo de la cancelación.');
      return;
    }
    const importeTexto = String(cancelacionForm.importe_facturado_cancelacion || '').trim().replace(',', '.');
    const importe = importeTexto === '' ? null : Number(importeTexto);
    if (importe !== null && (Number.isNaN(importe) || importe < 0)) {
      setErrorCancelacion('El importe facturado por la cancelación no es válido.');
      return;
    }
    setCancelando(true);
    setErrorCancelacion(null);
    try {
      const { data } = await presupuestosAPI.cancelar(id, {
        motivo: cancelacionForm.motivo,
        comentario: cancelacionForm.comentario || null,
        importe_facturado_cancelacion: importe,
        anular_pedidos: pedidosCancelacion
          .filter(p => p.anular)
          .map(p => ({ tipo: p.tipo, id: p.id || null, jornada_id: p.jornada_id || null, enviar_email: !!p.enviar_email && !!p.email })),
      });
      setShowCancelarModal(false);
      // Se queda en la ficha: el Resumen enseña qué se ha deshecho y anulado.
      // Lo que no ha salido bien (un email que no se envió...) se dice aquí
      const avisos = data?.resumen_cancelacion?.avisos || [];
      if (avisos.length > 0) {
        alert('Evento cancelado, con avisos:\n\n' + avisos.map(a => '- ' + a).join('\n'));
      }
      await fetchData();
    } catch (error) {
      console.error('Error cancelando el evento:', error);
      setErrorCancelacion(error.response?.data?.detail || 'No se pudo cancelar el evento.');
    } finally {
      setCancelando(false);
    }
  };

  // 1.1 Suplemento hasta el mínimo de personas, por servicio (clave jornada|menú):
  // anadir, volver_a_anadir, quitar, regalar, cobrar. Va por la cola del
  // autoguardado (nunca a la vez que otro guardado de la ficha).
  const handleSuplementoMinimo = async (accion, clave = null) => {
    setAccionReglaEnCurso(`${accion}:${clave || ''}`);
    setAvisoSuplementoMinimo(null);
    try {
      const cuerpo = clave ? { accion, clave } : { accion };
      const r = await autoguardado.programar(`suplemento_minimo:${id}`, async () => {
        try {
          return { res: await api.post(`/presupuestos/${id}/suplemento-minimo`, cuerpo) };
        } catch (error) {
          return { error };
        }
      }, { inmediato: true });
      if (r && r.error) throw r.error;
      await fetchData();
    } catch (error) {
      console.error('Error aplicando el suplemento mínimo:', error);
      setAvisoSuplementoMinimo(error.response?.data?.detail || 'No se pudo aplicar el suplemento.');
    } finally {
      setAccionReglaEnCurso(null);
    }
  };

  // Hora extra del lunch (más de 1 h 30), por lunch (clave jornada|línea):
  // anadir, volver_a_anadir, quitar, regalar, cobrar. Misma cola del autoguardado.
  const handleHoraExtraLunch = async (accion, clave = null) => {
    setAccionReglaEnCurso(`hora_extra:${accion}:${clave || ''}`);
    setAvisoSuplementoMinimo(null);
    try {
      const cuerpo = clave ? { accion, clave } : { accion };
      const r = await autoguardado.programar(`hora_extra_lunch:${id}`, async () => {
        try {
          return { res: await api.post(`/presupuestos/${id}/hora-extra-lunch`, cuerpo) };
        } catch (error) {
          return { error };
        }
      }, { inmediato: true });
      if (r && r.error) throw r.error;
      await fetchData();
    } catch (error) {
      console.error('Error aplicando la hora extra del lunch:', error);
      setAvisoSuplementoMinimo(error.response?.data?.detail || 'No se pudo aplicar la hora extra del lunch.');
    } finally {
      setAccionReglaEnCurso(null);
    }
  };

  // 1.2 Transporte por zonas: añade/actualiza la línea "Transporte zona N"
  const handleAnadirTransporte = async () => {
    setAccionReglaEnCurso('transporte');
    setAvisoTransporte(null);
    try {
      const { data } = await api.post(`/presupuestos/${id}/transporte-zona`);
      if (data.zona_gratuita) {
        const muni = data.transporte?.municipio;
        setAvisoTransporte({ tipo: 'ok', texto: `Transporte incluido (zona gratuita${muni ? `: ${muni}` : ''}).` });
        // Si faltaba la ruta, el backend la ha calculado con la dirección guardada
        if (!presupuesto.distancia_km) await fetchData();
      } else {
        setAvisoTransporte({
          tipo: 'ok',
          texto: `Añadida la línea "Transporte zona ${data.transporte?.zona}" por ${formatEuros(data.transporte?.importe)}. Puedes editarla como cualquier suplemento.`,
        });
        await fetchData();
      }
    } catch (error) {
      console.error('Error añadiendo transporte:', error);
      setAvisoTransporte({ tipo: 'error', texto: error.response?.data?.detail || 'No se pudo calcular el transporte.' });
    } finally {
      setAccionReglaEnCurso(null);
    }
  };

  // Formato nuevo: acciones de transporte con endpoint propio (importe a mano,
  // volver al automático, Madrid Central). Van por la cola del autoguardado
  // (nunca a la vez que otro guardado) y el error se enseña en la tarjeta.
  const accionTransporte = async (clave, ruta, cuerpo, textoOk) => {
    setAccionReglaEnCurso(clave);
    setAvisoTransporte(null);
    try {
      const r = await autoguardado.programar(`${clave}:${id}`, async () => {
        try {
          return { res: await api.post(`/presupuestos/${id}/${ruta}`, cuerpo) };
        } catch (error) {
          return { error };
        }
      }, { inmediato: true });
      if (r && r.error) throw r.error;
      const data = r?.res?.data || {};
      if (data.transporte) setEstadoReglas(prev => (prev ? { ...prev, transporte: data.transporte } : prev));
      if (textoOk) setAvisoTransporte({ tipo: 'ok', texto: typeof textoOk === 'function' ? textoOk(data) : textoOk });
      await fetchData();
    } catch (error) {
      setAvisoTransporte({ tipo: 'error', texto: error.response?.data?.detail || 'No se pudo guardar el transporte.' });
    } finally {
      setAccionReglaEnCurso(null);
    }
  };
  const handleTransporteManual = (importe) => accionTransporte(
    'transporte_manual', 'transporte-zona', { accion: 'manual', importe_manual: importe },
    `Transporte a mano: ${formatEuros(importe)}. Prevalece sobre la zona hasta volver al automático.`
  );
  const handleTransporteAutomatico = () => accionTransporte(
    'transporte_automatico', 'transporte-zona', { accion: 'volver_automatico' },
    (data) => (data.transporte?.linea ? `Vuelve el transporte por zonas: "${data.transporte.linea.nombre}".` : 'Sin importe a mano: la zona es gratuita, no lleva línea de transporte.')
  );
  // Interruptor "Cobrar transporte al cliente": Sí crea la línea (zona, o 0 €
  // si la zona es gratuita); No la quita junto con Madrid Central
  const handleCobrarTransporte = (cobrar) => accionTransporte(
    'transporte_cobrar', 'transporte-zona', { accion: cobrar ? 'cobrar' : 'no_cobrar' },
    (data) => {
      if (!cobrar) return 'Transporte sin cobrar: quitada la línea de transporte (y Madrid Central).';
      const t = data.transporte || {};
      if (!t.linea) return t.motivo ? `Transporte a cobrar. ${t.motivo}` : 'Transporte a cobrar: falta la ruta para crear la línea.';
      if (t.importe_manual) return `Transporte a cobrar: se mantiene el importe a mano de ${formatEuros(t.importe_manual)}.`;
      if (t.zona_gratuita) return 'Zona gratuita: línea "Transporte" a 0 € hasta que elijas un importe.';
      return `Añadida la línea "${t.linea.nombre}" por ${formatEuros(t.linea.total)}.`;
    }
  );
  const handleMadridCentral = (accion) => accionTransporte(
    'madrid_central', 'madrid-central', { accion },
    {
      activar: 'Añadido el suplemento Madrid Central.',
      desactivar: 'Quitado el suplemento Madrid Central.',
      regalar: 'Suplemento Madrid Central regalado.',
      quitar_regalo: 'El suplemento Madrid Central vuelve a cobrarse.',
    }[accion] || null
  );

  // Barra libre del lunch (formato nuevo): estado del chip de una línea de la
  // tabla (por índice en la cabecera) y acción de activar o quitar. Va por la
  // cola del autoguardado; el error se enseña en la propia línea.
  // Evento ya celebrado (`aplica: false`): ni chip ni línea vinculada; todo
  // como una línea normal (los cálculos quedan como estaban)
  const barraLibreAplica = !!estadoBarraLibre && estadoBarraLibre.aplica !== false;
  const entradaBarraLibre = (indice) => (barraLibreAplica ? (estadoBarraLibre?.lineas || []).find(
    (l) => !l.jornada_id && l.indice === indice
  ) : null) || null;
  const alternarBarraLibre = async (entrada, activar, clave) => {
    if (!entrada) return;
    setGuardandoBarraLibre(clave);
    setErrorBarraLibre(null);
    try {
      const r = await encolarGuardado(`barra_libre:${clave}`, async () => {
        try {
          return {
            res: await presupuestosAPI.setBarraLibreLunch(id, {
              linea_id: entrada.linea_id || null,
              jornada_id: entrada.jornada_id || null,
              indice: entrada.indice,
              activar,
            }),
          };
        } catch (error) {
          return { error };
        }
      });
      if (r && r.error) throw r.error;
      const data = r?.res?.data || {};
      if (data.estado) setEstadoBarraLibre(data.estado);
      await fetchData();
      cargarBebidasModo();
    } catch (error) {
      setErrorBarraLibre({
        clave,
        texto: error.response?.data?.detail || 'No se pudo cambiar la barra libre del lunch.',
      });
    } finally {
      setGuardandoBarraLibre(null);
    }
  };
  // Línea vinculada: su botón de borrar apaga el chip del lunch
  const quitarBarraLibreVinculada = (indiceBarra) => {
    const barra = presupuesto?.menus_personalizados?.[indiceBarra];
    if (!barra) return;
    const entrada = (estadoBarraLibre?.lineas || []).find(
      (l) => !l.jornada_id && l.linea_id && l.linea_id === barra.barra_libre_de_linea_id
    ) || { linea_id: barra.barra_libre_de_linea_id, jornada_id: null, indice: null };
    alternarBarraLibre(entrada, false, `barra:${indiceBarra}`);
  };
  const renderChipBarraLibre = (indice) => {
    const entrada = entradaBarraLibre(indice);
    if (!entrada) return null;
    const clave = `raiz:${indice}`;
    const guardando = guardandoBarraLibre === clave;
    const error = errorBarraLibre && errorBarraLibre.clave === clave ? errorBarraLibre.texto : null;
    let texto = 'Barra libre';
    let titulo = 'Añadir la barra libre del lunch (cubre la bebida incluida)';
    let clases = 'border-gray-300 text-gray-600 bg-white hover:border-duetto-primary hover:text-duetto-primary';
    if (entrada.legado) {
      texto = 'Barra libre (línea suelta)';
      titulo = 'La barra libre de este lunch es una línea suelta: se gestiona desde su propia línea de la tabla';
      clases = 'bg-[#E3F3EC] text-[#0F5E43] border-[#BFE3D2] cursor-default';
    } else if (entrada.activa) {
      texto = 'Barra libre activa';
      titulo = 'Quitar la barra libre del lunch';
      clases = 'bg-[#E3F3EC] text-[#0F5E43] border-[#BFE3D2]';
    }
    return (
      <>
        <button
          type="button"
          onClick={() => {
            if (entrada.legado || guardando) return;
            alternarBarraLibre(entrada, !entrada.activa, clave);
          }}
          disabled={guardando}
          title={titulo}
          data-testid={`chip-barra-libre-${indice}`}
          className={`ml-2 px-2 py-0.5 text-xs rounded-full border transition-colors disabled:opacity-60 ${clases}`}
        >
          {guardando ? 'Guardando...' : texto}
        </button>
        {error && (
          <p className="mt-1 text-xs text-red-600" data-testid={`chip-barra-libre-error-${indice}`}>{error}</p>
        )}
      </>
    );
  };
  const esBarraLibreVinculada = (indice) => {
    if (!barraLibreAplica) return false;
    const m = presupuesto?.menus_personalizados?.[indice];
    return !!(m && m.es_barra_libre_lunch && m.barra_libre_de_linea_id);
  };

  // 1.4 Camareros y mesas altas recomendados en cóctel (solo informativo)
  const textoRecomendacionCoctel = (c) => (
    `Cóctel de ${c.personas} personas: se recomiendan ${c.camareros_recomendados} ${c.camareros_recomendados === 1 ? 'camarero' : 'camareros'} y ${c.mesas_recomendadas} ${c.mesas_recomendadas === 1 ? 'mesa alta' : 'mesas altas'}. ` +
    `Hay ${c.camareros_asignados} ${c.camareros_asignados === 1 ? 'camarero asignado' : 'camareros asignados'}.`
  );

  // Requisitos de montaje de un menú (Fase 1): del estado de reglas (fresco) si
  // ya llegó; si no, del catálogo en caché
  const obtenerRequisitosMontaje = (menuId) => {
    if (!menuId) return '';
    return (estadoReglas
      ? (estadoReglas.requisitos_montaje || []).find(r => r.menu_id === menuId)?.requisitos || ''
      : (menus.find(m => m.id === menuId)?.requisitos_montaje || '')).trim();
  };

  const renderRecomendacionCoctel = (detalle = false) => {
    if (!estadoReglas) return null;
    const filas = [];
    if (estadoReglas.coctel?.aplica) filas.push({ clave: 'evento', etiqueta: null, c: estadoReglas.coctel });
    (estadoReglas.jornadas || []).forEach((j) => {
      if (j.coctel?.aplica) {
        filas.push({
          clave: j.jornada_id || `jornada-${j.indice}`,
          etiqueta: `Jornada ${j.indice}${j.fecha ? ` (${formatFecha(j.fecha)})` : ''}`,
          c: j.coctel,
        });
      }
    });
    if (filas.length === 0) return null;
    return (
      <div className="space-y-1" data-testid="recomendacion-coctel">
        {filas.map(({ clave, etiqueta, c }) => (
          <div
            key={clave}
            className={`rounded-[10px] border px-3.5 py-3 text-sm ${c.faltan_camareros > 0 ? 'bg-[#FDF0DC] border-[#F4D9AE] text-[#7A3A06]' : 'bg-[#F7F9F8] border-[#E1E6E3] text-[#33443C]'}`}
          >
            {etiqueta && <span className="font-semibold">{etiqueta}: </span>}
            {textoRecomendacionCoctel(c)}
            {detalle && (
              <span className="block mt-0.5 text-xs opacity-80">
                Se cuentan el personal asignado con rol camarero ({c.camareros_plantilla}) y la orden de personal extra ({c.camareros_orden_extra}).
              </span>
            )}
          </div>
        ))}
      </div>
    );
  };

  // 1.1 Suplemento hasta el mínimo por servicio: líneas (automáticas o a
  // mano) con Regalar / Cobrar y Quitar, pendientes y quitadas a mano
  const renderAvisoSuplementoMinimo = () => {
    const sm = estadoReglas?.suplemento_minimo;
    if (!sm) return null;
    const hayAlgo = (sm.lineas || []).length > 0 || (sm.pendientes || []).length > 0
      || (sm.quitadas || []).length > 0 || (!!sm.regalado && (sm.lineas || []).length === 0);
    if (!hayAlgo) return null;
    return (
      <SuplementoMinimoAviso
        estado={sm}
        enCurso={accionReglaEnCurso}
        onAccion={handleSuplementoMinimo}
        formatEuros={formatEuros}
      />
    );
  };

  // Hora extra del lunch sin línea: pendientes (Añadir) y quitadas a mano
  const renderAvisoHoraExtraLunch = () => {
    const he = estadoReglas?.hora_extra_lunch;
    if (!he || ((he.pendientes || []).length === 0 && (he.quitadas || []).length === 0)) return null;
    return (
      <HoraExtraLunchAviso
        estado={he}
        enCurso={accionReglaEnCurso}
        onAccion={handleHoraExtraLunch}
        formatEuros={formatEuros}
      />
    );
  };

  if (loading) {
    return <div className="flex items-center justify-center h-64">Cargando...</div>;
  }

  if (!presupuesto) {
    return <div className="flex items-center justify-center h-64">Presupuesto no encontrado</div>;
  }

  
  // ===== Bloques de la ficha reutilizados por el formato anterior y el nuevo =====
  // Cada función devuelve exactamente el JSX que había en el formato anterior.
  // Confirmado con fecha, personas o líneas cambiadas (U-09): el aviso del
  // último guardado o la marca guardada en el presupuesto
  const renderAvisoConfirmadoModificado = (claseContenedor = '') => {
    if (presupuesto.estado !== 'confirmado') return null;
    // B5 (lote 5b): con el libro único, en vez del aviso se dice lo rehecho
    if (stockRehecho && !avisoConfirmadoModificado) {
      return (
        <div className={claseContenedor} data-testid="aviso-stock-rehecho">
          <div className="bg-green-50 border border-green-300 rounded-lg p-3 text-sm text-green-900 flex items-start justify-between gap-3">
            <span>
              Evento confirmado modificado: se han rehecho el stock, los lotes y el material
              ({stockRehecho.salidas || 0} salidas de stock, {stockRehecho.reservas || 0} reservas de lote, {stockRehecho.material || 0} materiales).
            </span>
            <button type="button" onClick={() => setStockRehecho(null)} className="shrink-0 text-xs font-bold hover:underline">
              Cerrar
            </button>
          </div>
        </div>
      );
    }
    const marca = presupuesto.confirmado_modificado;
    const texto = avisoConfirmadoModificado || (marca
      ? 'Has cambiado un evento confirmado: el stock, los lotes y el material siguen reservados como estaban. Desconfirma y vuelve a confirmar para rehacerlos.'
      : null);
    if (!texto) return null;
    return (
      <div className={claseContenedor} data-testid="aviso-confirmado-modificado">
        <div className="bg-amber-50 border border-amber-300 rounded-lg p-3 text-sm text-amber-900 flex items-start justify-between gap-3">
          <span>{texto}</span>
          {avisoConfirmadoModificado && (
            <button type="button" onClick={() => setAvisoConfirmadoModificado(null)} className="shrink-0 text-xs font-bold hover:underline">
              Cerrar
            </button>
          )}
        </div>
      </div>
    );
  };

  // Evento cancelado: cuándo, por qué y con cuánta antelación
  const renderInfoCancelacion = () => (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            {presupuesto.cancelacion ? (
              <div className="text-sm text-red-800">
                <p className="font-semibold">
                  Cancelado el {formatFecha(presupuesto.cancelacion.fecha)} · {presupuesto.cancelacion.motivo}
                  {presupuesto.cancelacion.dias_antelacion != null && (
                    presupuesto.cancelacion.dias_antelacion >= 0
                      ? ` · ${presupuesto.cancelacion.dias_antelacion} ${presupuesto.cancelacion.dias_antelacion === 1 ? 'día' : 'días'} antes del evento`
                      : ` · ${Math.abs(presupuesto.cancelacion.dias_antelacion)} ${Math.abs(presupuesto.cancelacion.dias_antelacion) === 1 ? 'día' : 'días'} después de la fecha del evento`
                  )}
                </p>
                {presupuesto.cancelacion.comentario && (
                  <p className="text-xs text-red-700 mt-1">{presupuesto.cancelacion.comentario}</p>
                )}
                {textoResumenCancelacion(presupuesto.cancelacion.resumen_deshecho) && (
                  <p className="text-xs text-red-700 mt-1" data-testid="cancelacion-resumen">
                    {textoResumenCancelacion(presupuesto.cancelacion.resumen_deshecho)}
                  </p>
                )}
                <p className="text-xs text-red-600 mt-1">
                  {presupuesto.cancelacion.usuario_nombre || presupuesto.cancelacion.usuario_email || ''}
                  {presupuesto.cancelacion.importe_facturado_cancelacion != null
                    ? `${presupuesto.cancelacion.usuario_nombre || presupuesto.cancelacion.usuario_email ? ' · ' : ''}Facturado por la cancelación: ${formatEuros(presupuesto.cancelacion.importe_facturado_cancelacion)}`
                    : ''}
                </p>
              </div>
            ) : (
              <p className="text-sm text-red-800 font-semibold">Evento cancelado sin motivo registrado.</p>
            )}
            {!presupuesto.cancelacion && (
              <button
                type="button"
                onClick={handleCancelarEvento}
                className="px-3 py-1.5 text-sm bg-white border border-red-300 text-red-700 rounded-lg hover:bg-red-100 transition-colors whitespace-nowrap"
              >
                Registrar motivo
              </button>
            )}
          </div>
  );

  // Aviso "Sin ruta calculada" de los dos formatos (U-02, 06-oct-2026): la ruta
  // ya no se calcula sola al abrir la ficha; se ofrece el botón
  const renderAvisoSinRuta = () => (
    <div
      role="status"
      className="bg-yellow-50 border border-yellow-200 rounded-lg px-4 py-3 flex flex-wrap items-center justify-between gap-3"
      data-testid="aviso-sin-ruta"
    >
      <p className="text-sm text-yellow-800 font-medium">
        {calculandoRuta ? 'Calculando la ruta desde la nave...' : avisoSinRuta}
      </p>
      {!calculandoRuta && (
        <button
          type="button"
          onClick={() => calcularRutaGuardada()}
          className="px-3 py-1.5 text-sm font-medium bg-white border border-yellow-300 text-yellow-900 rounded-lg hover:bg-yellow-100"
          data-testid="aviso-sin-ruta-calcular"
        >
          Calcular ruta
        </button>
      )}
    </div>
  );

  // Madrid Central sin suplemento: el evento (o alguna jornada) cae dentro de
  // la zona de bajas emisiones y no lleva la línea. Solo aviso: no se añade
  // nada. Formato nuevo: detección al día de las reglas; formato anterior: la
  // guardada. Nada en eventos cancelados, rechazados, facturados o pasados.
  const avisoMadridCentral = (() => {
    if (!presupuesto || ['cancelado', 'rechazado'].includes(presupuesto.estado)) return null;
    if (presupuesto.tiene_factura || presupuesto.numero_factura || eventoPasado(presupuesto)) return null;
    if ((presupuesto.suplementos || []).some(sp => sp && sp.es_suplemento_madrid_central)) return null;
    const t = estadoReglas?.transporte;
    const dentro = t
      ? (t.madrid_central_dentro === true || (t.jornadas || []).some(j => j?.madrid_central_dentro === true))
      : (presupuesto.madrid_central_detectado === true
        || (presupuesto.jornadas || []).some(j => j?.madrid_central_detectado === true));
    return dentro
      ? 'El evento está dentro de Madrid Central (zona de bajas emisiones) y no lleva el suplemento de Madrid Central. Revísalo.'
      : null;
  })();
  const renderAvisoMadridCentral = () => (
    <div
      role="status"
      className="bg-amber-50 border border-amber-300 rounded-lg px-4 py-3 flex flex-wrap items-center justify-between gap-3"
      data-testid="aviso-madrid-central"
    >
      <p className="text-sm text-amber-900 font-medium">{avisoMadridCentral}</p>
      {formatoNuevo && (
        <button
          type="button"
          onClick={() => setPestanaActiva('logistica', 'lugar')}
          className="px-3 py-1.5 text-sm font-medium bg-white border border-amber-300 text-amber-900 rounded-lg hover:bg-amber-100"
          data-testid="aviso-madrid-central-ir"
        >
          Ver en Logística
        </button>
      )}
    </div>
  );

  // Depósito a favor del cliente con 'Aplicar a este presupuesto'
  const renderAvisoDeposito = () => (
          <div className="bg-emerald-50 border border-emerald-300 rounded-lg p-4 flex items-center justify-between gap-4">
            <div className="flex items-center gap-3 min-w-0">
              <div className="p-2 bg-emerald-100 rounded-full flex-shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-emerald-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="12" x="2" y="6" rx="2"/><circle cx="12" cy="12" r="2"/><path d="M6 12h.01M18 12h.01"/></svg>
              </div>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-emerald-800">
                  Este cliente tiene {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(depositosCliente.total_disponible)} a su favor
                </p>
                <p className="text-xs text-emerald-600 mt-0.5">
                  {depositosCliente.depositos.length} depósito{depositosCliente.depositos.length !== 1 ? 's' : ''} disponible{depositosCliente.depositos.length !== 1 ? 's' : ''} — 
                  Origen: {depositosCliente.depositos.map(d => `Ppto #${d.presupuesto_origen_numero}`).join(', ')}
                </p>
              </div>
            </div>
            <button
              data-testid="aplicar-deposito-btn"
              disabled={aplicandoDeposito}
              onClick={async () => {
                if (!window.confirm(`¿Aplicar ${new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(depositosCliente.total_disponible)} del depósito a este presupuesto?`)) return;
                setAplicandoDeposito(true);
                try {
                  const tk = getAuthToken();
                  for (const dep of depositosCliente.depositos) {
                    await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/cobros-unificado/aplicar-deposito?presupuesto_id=${presupuesto.id}&deposito_id=${dep.id}&importe=${dep.importe_disponible}`, {
                      method: 'POST',
                      headers: { 'Authorization': `Bearer ${tk}`, 'Content-Type': 'application/json' }
                    });
                  }
                  setDepositosCliente(null);
                  alert('Depósito aplicado correctamente');
                } catch (e) {
                  alert('Error al aplicar depósito: ' + e.message);
                }
                setAplicandoDeposito(false);
              }}
              className="flex-shrink-0 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 text-sm font-medium disabled:opacity-50 transition-colors"
            >
              {aplicandoDeposito ? 'Aplicando...' : 'Aplicar a este presupuesto'}
            </button>
          </div>
  );

  // Sobrante estimado por redondeo a unidad consumible (desplegable con 'Regalar')
  const renderSobrante = () => {
    if (!(desperdicio && desperdicio.total_eur > 0 && desperdicio.detalle && desperdicio.detalle.length > 0)) return null;
    return (
          <div className="bg-amber-50 border border-amber-200 rounded-md text-sm">
            <button
              type="button"
              onClick={() => setDesperdicioAbierto(v => !v)}
              className="w-full flex items-center gap-2 px-3 py-2 text-amber-900 hover:bg-amber-100 transition-colors rounded-md"
            >
              {desperdicioAbierto ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
              <span>⚠️</span>
              <span className="font-medium">Sobrante estimado:</span>
              <span className="font-bold">
                {desperdicio.detalle.length} ingrediente{desperdicio.detalle.length === 1 ? '' : 's'} por valor de {desperdicio.total_eur.toFixed(2)} €
              </span>
              <span className="text-amber-700 text-xs ml-auto hidden sm:inline">
                💡 Ofrécelo gratis al cliente — el coste ya está hecho
              </span>
            </button>
            {desperdicioAbierto && (() => {
              const fmtFecha = (s) => {
                if (!s || s.length < 10) return s || '';
                const [y, m, dd] = s.slice(0, 10).split('-');
                return `${dd}/${m}/${y}`;
              };
              const porJornada = desperdicio.por_jornada || [];
              // Mostramos por jornada siempre que el backend devuelva ese array
              // (en single-evento es 1 sola jornada). Así el botón "Regalar"
              // y los platos_uso están disponibles uniformemente.
              if (porJornada.length > 0) {
                const conJornadas = porJornada.length > 1;
                return (
                  <div className="border-t border-amber-200 px-3 py-2 space-y-3">
                    {porJornada.map((j, jIdx) => (
                      <div key={j.jornada_id || jIdx}>
                        {conJornadas && (
                          <div className="flex justify-between text-xs font-semibold text-amber-900 mb-1">
                            <span>{j.etiqueta || `Jornada ${jIdx + 1}`} · {fmtFecha(j.fecha)}</span>
                            <span>{j.total_uds.toFixed(2)} uds · {j.total_eur.toFixed(2)} €</span>
                          </div>
                        )}
                        <table className="w-full text-xs">
                          <thead>
                            <tr className="text-amber-800 border-b border-amber-200">
                              <th className="text-left py-1 font-medium">Ingrediente</th>
                              <th className="text-right py-1 font-medium">Necesario</th>
                              <th className="text-right py-1 font-medium">A consumir</th>
                              <th className="text-right py-1 font-medium">Sobrante</th>
                              <th className="text-right py-1 font-medium">Coste sobra</th>
                              <th className="text-right py-1 pr-1 font-medium">Acción</th>
                            </tr>
                          </thead>
                          <tbody>
                            {j.detalle.map(d => (
                              <tr key={d.ingrediente_id} className="text-amber-900 border-b border-amber-100 last:border-b-0">
                                <td className="py-1 pr-2">{d.nombre}</td>
                                <td className="py-1 text-right">{d.cantidad_teorica.toFixed(2)} {d.unidad}</td>
                                <td className="py-1 text-right">{d.cantidad_real.toFixed(2)} {d.unidad}</td>
                                <td className="py-1 text-right font-medium">{d.sobrante_uds.toFixed(2)} {d.unidad}</td>
                                <td className="py-1 text-right font-medium">{d.sobrante_eur.toFixed(2)} €</td>
                                <td className="py-1 pr-1 text-right">
                                  <button
                                    type="button"
                                    onClick={() => handleRegalarSobrante(j.jornada_id, d)}
                                    className="text-[10px] px-2 py-0.5 bg-amber-700 text-white rounded hover:bg-amber-800 disabled:opacity-50"
                                    disabled={!d.platos_uso || d.platos_uso.length === 0 || regalandoSobrante}
                                    title="Sube las uds del plato para preparar el envase entero y regalarlo al cliente"
                                  >
                                    Regalar 🎁
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ))}
                    {conJornadas && (
                      <div className="flex justify-between text-xs font-bold text-amber-900 border-t border-amber-300 pt-2">
                        <span>Total del presupuesto</span>
                        <span>{desperdicio.total_uds.toFixed(2)} uds · {desperdicio.total_eur.toFixed(2)} €</span>
                      </div>
                    )}
                  </div>
                );
              }
              // Fallback (no debería ocurrir si hay sobrante > 0): tabla global vacía
              return null;
            })()}
          </div>
    );
  };

  // Multievento con jornadas: las personas y las líneas van por jornada
  const esMultieventoFicha = () => !!(presupuesto?.es_multi_evento
    && Array.isArray(presupuesto?.jornadas) && presupuesto.jornadas.length > 0);

  // "55 en total · 20 a 35 por jornada" (o "30 por jornada" si todas igual)
  const textoPersonasMultievento = () => {
    const pax = (presupuesto?.jornadas || []).map(j => Number(j?.num_personas) || 0).filter(n => n > 0);
    if (pax.length === 0) return 'Sin personas en las jornadas';
    const total = pax.reduce((a, b) => a + b, 0);
    const min = Math.min(...pax);
    const max = Math.max(...pax);
    return min === max ? `${total} en total · ${min} por jornada` : `${total} en total · ${min} a ${max} por jornada`;
  };

  // "¿A qué jornadas?" al añadir un menú o un menú personalizado en un
  // multievento (todas marcadas por defecto; null = todas)
  const renderSelectorJornadasAnadir = () => {
    if (!esMultieventoFicha()) return null;
    const todas = (presupuesto.jornadas || []).map(x => x.id);
    return (
      <fieldset className="p-3 border border-gray-200 rounded-lg" data-testid="anadir-menu-jornadas">
        <legend className="px-1 text-sm font-medium text-gray-700">¿A qué jornadas?</legend>
        <div className="flex flex-col gap-1.5">
          {(presupuesto.jornadas || []).map((j, i) => {
            const marcada = jornadasMenuToAdd === null || jornadasMenuToAdd.includes(j.id);
            return (
              <label key={j.id} className="flex items-center gap-2 text-sm text-gray-700">
                <input
                  type="checkbox"
                  checked={marcada}
                  onChange={() => {
                    const actuales = jornadasMenuToAdd === null ? todas : jornadasMenuToAdd;
                    const nuevas = marcada ? actuales.filter(x => x !== j.id) : [...actuales, j.id];
                    setJornadasMenuToAdd(nuevas.length === todas.length ? null : nuevas);
                  }}
                  data-testid={`anadir-menu-jornada-${j.id}`}
                />
                Jornada {i + 1}{j.fecha ? ` (${formatFecha(j.fecha)})` : ''} · {j.num_personas || 0} personas
              </label>
            );
          })}
        </div>
        <p className="text-xs text-gray-500 mt-1">Se añade a las jornadas marcadas con sus personas: así se cobra y se cocina. Su precio y su IVA quedan en la cabecera (Líneas y menús), que es donde se cambian.</p>
      </fieldset>
    );
  };
  const sinJornadasElegidas = () => esMultieventoFicha() && Array.isArray(jornadasMenuToAdd) && jornadasMenuToAdd.length === 0;

  // Tras un cambio por los endpoints de multievento (personas de una jornada,
  // líneas por jornada): la ficha se recarga del servidor (y con ella la base
  // del autoguardado y la rev)
  // Antes de un endpoint que escribe las horas (horario del multievento): lo
  // pendiente de la ficha se guarda primero, para que un guardado con la
  // cabecera vieja no pise luego la hora nueva
  const guardarPendienteFicha = () => (autoguardado ? autoguardado.guardarYa() : Promise.resolve());

  const alActualizarMultievento = async () => {
    await fetchData();
    if (formatoNuevo) cargarCostes();
  };

  // Modal "Añadir Menú al Presupuesto": deja el formulario como al abrirlo
  // (y, si se pide, lo cierra)
  const limpiarModalAnadirMenu = (cerrar = true) => {
    if (cerrar) setShowAddMenuModal(false);
    setSelectedMenuToAdd('');
    setPersonasMenuToAdd('');
    setMenuSearchQuery('');
    setBebidaIncluidaMenuToAdd(false);
    setBebidasPorPersonaMenuToAdd(1);
    setJornadasMenuToAdd(null);
    if (cerrar) setMenusAnadidosRapido([]);
  };

  // Añade un menú del catálogo como línea del presupuesto (regla única
  // lineaDesdeMenu). La usan el botón "Añadir Menú" del modal (con lo
  // elegido) y el botón "Añadir" de cada fila (con los valores por defecto).
  // - numPersonas: null = las del presupuesto (multievento: las de cada jornada)
  // - jornadasIds: null = todas las jornadas (multievento)
  // - cerrar: true cierra el modal; false lo deja abierto con el buscador vacío
  //   y apunta el menú en "Añadido: ..."
  const anadirMenuDelCatalogo = async ({
    menu, numPersonas = null, bebidaIncluida = false, bebidasPorPersona = 1, jornadasIds = null, cerrar = true,
  }) => {
    if (!menu || anadiendoMenuRef.current) return;
    anadiendoMenuRef.current = true;
    setAddingMenu(true);
    try {
      // Personas por defecto (M-98): en un multievento, las de una jornada
      const personasElegidas = numPersonas ? parseInt(numPersonas, 10) : null;
      const pax = personasElegidas || personasPorDefectoLinea(presupuesto);
      // Personal calculado con los ratios del menú
      const personalPropioCalculado = 1; // Siempre 1 por defecto
      // Extras: desde que se ALCANZA el ratio; hacia arriba salvo que el exceso
      // no pase del 20 % (ratio 100: 99 pax -> 0; 120 -> 1; 130 -> 2)
      const extrasCalculado = personalPorRatio(pax, menu.ratio_extras, true);

      // Horas totales del servicio desde los tiempos del menú
      const tiempoTotalMinutos = (menu.tiempo_montaje_min || 0) + (menu.duracion_evento_min || 0) + (menu.tiempo_desmontaje_min || 0);
      const horasTotales = tiempoTotalMinutos / 60;
      // Si el menú tiene horas_por_camarero configurado, ese; si no, el calculado
      const horasServicio = menu.horas_por_camarero || horasTotales || 4; // 4 solo si no hay ningún dato

      const menusPersonalizados = [...(presupuesto.menus_personalizados || [])];

      // Línea del catálogo con la regla única (U-11, la misma que el alta
      // desde el listado): precio de venta (nunca el coste), IVA del catálogo
      // o 10, platos activos y unidades por plato
      const lineaCatalogo = lineaDesdeMenu(menu, pax, {
        platoActivo: (pid) => {
          const p = platos.find(pl => pl.id === pid);
          return !!(p && p.activo !== false);
        },
      });
      const precioMenu = lineaCatalogo.precio_unitario;
      const ivaNormalizado = lineaCatalogo.tipo_iva;

      const nuevaLinea = {
        ...lineaCatalogo,
        menu_id: menu.id,
        precio_ud: precioMenu,
        iva_percent: ivaNormalizado,

        // Bebida incluida: la del toggle del modal o la del catálogo
        bebida_incluida: !!bebidaIncluida,
        bebidas_por_persona: bebidaIncluida ? (bebidasPorPersona || 1) : 0,

        // Datos del menú (para cálculos)
        ratio_camareros: menu.ratio_camareros || 0,
        ratio_extras: menu.ratio_extras || 0,
        horas_por_camarero: horasServicio || 4, // Default 4 horas
        coste_camarero_hora: menu.coste_camarero_hora || 25, // Default 25€/hora
        coste_extra_hora: menu.coste_extra_hora || 25,
        coste_personal_propio_hora: menu.coste_personal_propio_hora || 15.6,
        // Material: no se copia el del catálogo en la línea (se lee del menú por
        // menu_id, igual que en el alta); la línea solo lleva ajustes propios
        material_fijo: [],
        material_por_persona: [],
        textiles: [],
        tiempo_montaje_min: menu.tiempo_montaje_min || 60,
        duracion_evento_min: menu.duracion_evento_min || 60,
        tiempo_desmontaje_min: menu.tiempo_desmontaje_min || 60,

        // Personal editable (valores iniciales calculados)
        personal_propio_real: personalPropioCalculado,
        personal_extra_real: extrasCalculado,
        cargar_personal_propio: true, // Por defecto se cobra
        cargar_personal_extra: true, // Por defecto se cobra

        adaptaciones: []
      };

      const trasAnadir = () => {
        if (cerrar) {
          limpiarModalAnadirMenu(true);
        } else {
          setMenuSearchQuery('');
          setMenusAnadidosRapido(prev => [...prev, menu.nombre]);
        }
      };

      // Multievento: la línea va a las jornadas elegidas (con las personas
      // de cada una), no a la cabecera
      if (esMultieventoFicha()) {
        const { data } = await presupuestosAPI.anadirLineaMultievento(presupuesto.id, {
          linea: nuevaLinea,
          jornadas_ids: jornadasIds,
          num_personas: personasElegidas,
        });
        await alActualizarMultievento();
        trasAnadir();
        const nJornadas = (data?.jornadas_ids || []).length;
        toast({
          title: 'Menú añadido',
          description: `${menu.nombre} en ${nJornadas} ${nJornadas === 1 ? 'jornada' : 'jornadas'}.`,
        });
        return;
      }
      menusPersonalizados.push(nuevaLinea);

      // Nuevos totales
      const importeNuevoItem = precioMenu * pax;
      const ivaNuevoItem = importeNuevoItem * (ivaNormalizado / 100);
      const nuevoSubtotal = calculateSubtotal() + importeNuevoItem;
      const nuevoIva = calculateTotalIva() + ivaNuevoItem;

      await guardarFicha({
        ...presupuesto,
        menus_personalizados: menusPersonalizados,
        importe_base: nuevoSubtotal,
        iva: nuevoIva,
        importe_total: nuevoSubtotal + nuevoIva,
      });

      // Formato nuevo: hora propuesta para la línea nueva si es un servicio
      // con montaje (editable; no toca las demás)
      if (formatoNuevo) {
        try {
          await api.post(`/presupuestos/${presupuesto.id}/horarios/proponer`, {
            indices: [menusPersonalizados.length - 1],
          });
        } catch (errHora) {
          console.error('No se pudo proponer la hora del servicio:', errHora);
        }
      }

      await fetchData();
      trasAnadir();
      if (cerrar) {
        avisoGuardadoOk('Menú añadido correctamente con todos sus detalles');
      } else {
        toast({ title: 'Menú añadido', description: menu.nombre });
      }
    } catch (error) {
      console.error('Error adding menu:', error);
      avisoGuardadoError('Error al añadir menú: ' + (error.response?.data?.detail || error.message), error);
    } finally {
      anadiendoMenuRef.current = false;
      setAddingMenu(false);
    }
  };

  // U-33: guarda las personas de la cabecera de un evento de un día y, si se
  // pide, las aplica en el servidor a las líneas que tenían las anteriores (o
  // ninguna). Formato nuevo: por el autoguardado de la cabecera; anterior: PUT.
  const guardarPersonasCabecera = async (n, aplicar) => {
    const campos = aplicar ? { num_personas: n, aplicar_personas_lineas: true } : { num_personas: n };
    if (formatoNuevo) {
      programarCabecera(campos, { recargar: aplicar });
      return;
    }
    try {
      const respuesta = await guardarFicha(campos);
      if (aplicar) {
        await fetchData();
      } else {
        aplicarRespuestaGuardado(respuesta, prev => ({ ...prev, num_personas: n }));
      }
    } catch (error) {
      console.error('Error al guardar las personas:', error);
      avisoGuardadoError('No se han podido guardar las personas', error);
    }
  };
  const cambiarPersonasCabecera = (n) => {
    const anterior = presupuesto?.num_personas;
    const { aplicables, distintas } = lineasAfectadasPorPersonas(presupuesto?.menus_personalizados, anterior, n);
    if (Number(anterior) !== n && aplicables.length > 0) {
      setDialogoPersonas({ anterior, nuevo: n, aplicables, distintas, aplicar: true });
      return;
    }
    guardarPersonasCabecera(n, false);
  };
  const renderDialogoPersonas = () => {
    const d = dialogoPersonas;
    const cerrar = () => {
      setEditedNumPersonas(d ? String(d.anterior ?? '') : '');
      setDialogoPersonas(null);
    };
    return (
      <Dialog open={!!d} onOpenChange={(abierto) => { if (!abierto) cerrar(); }}>
        {d && (
          <DialogContent className="w-[calc(100%-2rem)] max-w-lg bg-white p-5 sm:p-6 gap-3" data-testid="dialogo-personas-cabecera">
            <div className="pr-8">
              <DialogTitle className="text-lg font-extrabold text-[#16221D]">
                {`Personas del evento: de ${d.anterior ?? '-'} a ${d.nuevo}`}
              </DialogTitle>
              <DialogDescription className="text-sm text-[#5B6B64] mt-1">
                El número de personas de la cabecera es el que sale en el PDF. Las líneas llevan sus propias personas.
              </DialogDescription>
            </div>
            <label className="flex items-start gap-2 text-sm text-[#16221D]">
              <input
                type="checkbox"
                className="mt-1"
                checked={d.aplicar}
                onChange={(e) => setDialogoPersonas({ ...d, aplicar: e.target.checked })}
                data-testid="aplicar-personas-lineas"
              />
              <span>
                <strong>Aplicar a las líneas con las mismas personas</strong>
                <span className="block text-[#5B6B64]">
                  {`Pasan a ${d.nuevo}: ${d.aplicables.map(a => a.nombre_menu).join(', ')}.`}
                </span>
              </span>
            </label>
            {d.distintas.length > 0 && (
              <p className="text-sm text-[#6B4E00] bg-[#FFF8E6] border border-[#F1DFA8] rounded-lg px-3 py-2">
                {`Se dejan como están (tienen otro número): ${d.distintas.map(x => `${x.nombre_menu} (${x.num_personas})`).join(', ')}.`}
              </p>
            )}
            <div className="flex flex-wrap items-center justify-end gap-2 border-t border-[#E1E6E3] pt-3">
              <button
                type="button"
                onClick={cerrar}
                className="h-[34px] px-3 rounded-lg border border-[#CBD3CF] bg-white text-[13px] font-bold text-[#16221D] hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={() => {
                  const { nuevo, aplicar } = d;
                  setDialogoPersonas(null);
                  guardarPersonasCabecera(nuevo, aplicar);
                }}
                className="h-[34px] px-4 rounded-lg bg-duetto-primary text-white text-[13px] font-bold hover:bg-opacity-90"
                data-testid="guardar-personas-cabecera"
              >
                Guardar
              </button>
            </div>
          </DialogContent>
        )}
      </Dialog>
    );
  };

  const renderCampoPersonas = (clase) => (esMultieventoFicha() ? (
                <span
                  className="font-semibold"
                  title="En un multievento las personas se cambian en cada jornada (Líneas y menús o Logística)"
                  data-testid="personas-multievento"
                >
                  {textoPersonasMultievento()}
                </span>
  ) : (
                <input
                  type="number"
                  value={editedNumPersonas || presupuesto.num_personas}
                  onChange={(e) => {
                    setEditedNumPersonas(e.target.value);
                    // Se guarda 1 segundo después de dejar de escribir; si hay
                    // líneas con las personas anteriores, antes se pregunta si
                    // se aplican también a ellas (U-33)
                    cancelarGuardadoCabecera('personas');
                    const n = parseInt(e.target.value, 10);
                    if (!Number.isFinite(n) || n <= 0) return;
                    programarGuardadoCabecera('personas', () => cambiarPersonasCabecera(n));
                  }}
                  className={clase}
                  min="1"
                />
  ));

  // Multievento: la fecha y las horas de la cabecera salen de las jornadas
  // (el servidor las deriva en cada guardado); aquí solo se enseñan
  const claseSoloLectura = (clase) => `${String(clase || '').split(' ').filter(c => !/^(sm:)?w-/.test(c)).join(' ')} whitespace-nowrap cursor-help`;
  const renderCampoSoloLectura = (clase, texto, testId) => (
    <span className={claseSoloLectura(clase)} title={TEXTO_FECHA_EN_JORNADAS} data-testid={testId}>{texto || '-'}</span>
  );

  const renderCampoFecha = (clase) => (esMultievento(presupuesto)
    ? renderCampoSoloLectura(clase, textoFechasEvento(presupuesto), 'cabecera-fecha-multievento')
    : (
                <input
                  type="date"
                  value={editedFechaEvento || presupuesto.fecha_evento}
                  onChange={(e) => {
                    setEditedFechaEvento(e.target.value);
                    if (formatoNuevo) {
                      if (e.target.value) programarCabecera({ fecha_evento: e.target.value }, { recargar: true });
                      return;
                    }
                    // Se guarda sola al segundo (y antes de confirmar)
                    const valorFecha = e.target.value;
                    programarGuardadoCabecera('fecha', async () => {
                      try {
                        aplicarRespuestaGuardado(await guardarFicha({ fecha_evento: valorFecha }),
                          prev => ({ ...prev, fecha_evento: valorFecha }));
                        await fetchData(); // Reload to update legacy status
                      } catch (error) {
                        console.error('Error updating fecha:', error);
                      }
                    });
                  }}
                  className={clase}
                />
  ));

  const renderCampoHoraInicio = (clase) => (esMultievento(presupuesto)
    ? renderCampoSoloLectura(clase, parseHoraToTimeInput(primeraJornada(presupuesto)?.hora_inicio || presupuesto.hora_inicio), 'cabecera-hora-inicio-multievento')
    : (
                  <input
                    type="time"
                    value={editedHoraInicio || parseHoraToTimeInput(presupuesto.hora_inicio)}
                    onChange={(e) => {
                      setEditedHoraInicio(e.target.value);
                      if (formatoNuevo) {
                        programarCabecera({ hora_inicio: e.target.value });
                        return;
                      }
                      const valorHora = e.target.value;
                      programarGuardadoCabecera('hora_inicio', async () => {
                        try {
                          aplicarRespuestaGuardado(await guardarFicha({ hora_inicio: valorHora }),
                            prev => ({ ...prev, hora_inicio: valorHora }));
                        } catch (error) {
                          console.error('Error updating hora inicio:', error);
                        }
                      });
                    }}
                    className={clase}
                  />
  ));

  // Guarda la hora de fin de la cabecera (al escribirla o al confirmar la provisional)
  const guardarHoraFinCabecera = (valor) => {
    setEditedHoraFin(valor);
    if (formatoNuevo) {
      programarCabecera({ hora_fin: valor });
      return;
    }
    programarGuardadoCabecera('hora_fin', async () => {
      try {
        aplicarRespuestaGuardado(await guardarFicha({ hora_fin: valor }),
          prev => ({ ...prev, hora_fin: valor }));
      } catch (error) {
        console.error('Error updating hora fin:', error);
      }
    });
  };

  const renderCampoHoraFin = (clase) => {
    if (esMultievento(presupuesto)) {
      return renderCampoSoloLectura(clase, parseHoraToTimeInput(primeraJornada(presupuesto)?.hora_fin || presupuesto.hora_fin), 'cabecera-hora-fin-multievento');
    }
    const provisional = horaFinProvisional();
    return (
                  <input
                    type="time"
                    value={editedHoraFin || provisional || parseHoraToTimeInput(presupuesto.hora_fin)}
                    onChange={(e) => guardarHoraFinCabecera(e.target.value)}
                    title={provisional ? 'Hora de fin provisional, sin confirmar: pon la real o pulsa Confirmar' : undefined}
                    className={provisional ? `${clase} !bg-amber-200 !border-amber-500 ring-2 ring-amber-400 rounded px-1` : clase}
                    data-testid={provisional ? 'cabecera-hora-fin-provisional' : undefined}
                  />
    );
  };

  const renderCampoLlegada = (clase) => (
                  <input
                    type="time"
                    defaultValue={presupuesto.hora_llegada_estimada || ''}
                    onChange={formatoNuevo ? (e) => programarCabecera({ hora_llegada_estimada: e.target.value }) : undefined}
                    onBlur={async (e) => {
                      // Formato nuevo: lo guarda el autoguardado (al escribir y al salir del campo)
                      if (formatoNuevo) return;
                      if (e.target.value !== presupuesto.hora_llegada_estimada) {
                        try {
                          aplicarRespuestaGuardado(await guardarFicha({ hora_llegada_estimada: e.target.value }),
                            prev => ({ ...prev, hora_llegada_estimada: e.target.value }));
                        } catch (error) {
                          console.error('Error updating hora llegada:', error);
                        }
                      }
                    }}
                    className={clase}
                  />
  );

  // Hora de fin provisional (evento de un día sin hora de fin o igual a la de
  // inicio): la calcula el servidor (2 h con un servicio, 4 h con varios) y la
  // cabecera la enseña sin guardarla, marcada "provisional", hasta que se ponga
  // la real. Mismo criterio que fin_sin_definir del backend.
  const horaFinProvisional = () => {
    if (esMultievento(presupuesto) || editedHoraFin) return null;
    const horaI = editedHoraInicio || parseHoraToTimeInput(presupuesto.hora_inicio);
    if (!finSinDefinir(horaI, parseHoraToTimeInput(presupuesto.hora_fin))) return null;
    return estadoReglas?.quien_va?.hora_fin_provisional || null;
  };

  const renderIndicadorDiaSiguiente = () => {
                    const provisional = horaFinProvisional();
                    if (provisional) {
                      // Fin sin confirmar: afecta al cliente y a los trabajadores
                      // (no saben a qué hora se termina). Muy visible y con botón.
                      return (
                        <span className="inline-flex items-center gap-1.5" data-testid="cabecera-fin-provisional">
                          <span className="text-xs bg-amber-300 text-amber-950 border border-amber-500 px-2 py-0.5 rounded-full font-bold"
                            title={estadoReglas?.quien_va?.aviso_fin_sin_definir || 'Hora de fin provisional: confírmala'}>
                            Fin sin confirmar
                          </span>
                          <button
                            type="button"
                            onClick={() => guardarHoraFinCabecera(provisional)}
                            className="text-xs bg-amber-500 hover:bg-amber-600 text-white px-2 py-0.5 rounded-full font-semibold"
                            title={`Guarda ${provisional} como hora de fin`}
                            data-testid="cabecera-confirmar-fin"
                            data-uso="presupuesto.confirmar_hora_fin"
                          >
                            Confirmar {provisional}
                          </button>
                        </span>
                      );
                    }
                    const horaI = editedHoraInicio || parseHoraToTimeInput(presupuesto.hora_inicio);
                    const horaF = editedHoraFin || parseHoraToTimeInput(presupuesto.hora_fin);
                    if (!horaI || !horaF) return null;
                    const [hI, mI] = horaI.split(':').map(Number);
                    const [hF, mF] = horaF.split(':').map(Number);
                    // Solo si termina ANTES de la hora de inicio (igual = fin sin definir)
                    const esDiaSiguiente = (hF * 60 + mF) < (hI * 60 + mI);
                    return esDiaSiguiente ? (
                      <span className="text-xs bg-orange-100 text-orange-700 px-1.5 sm:px-2 py-0.5 rounded-full font-medium">
                        +1
                      </span>
                    ) : null;
                  };

  // Multievento: gestor de jornadas y botón para convertir
  const renderMultievento = () => (
      <>
        {presupuesto.es_multi_evento && (presupuesto.jornadas?.length || 0) > 1 && (
          <div className="mb-4 sm:mb-6">
            <JornadasManager
              presupuesto={presupuesto}
              jornadas={presupuesto.jornadas || []}
              onJornadaCreated={() => fetchData()}
              onJornadaUpdated={() => fetchData()}
              onJornadaDeleted={() => fetchData()}
              onGenerarJornadas={() => fetchData()}
              onRefresh={() => fetchData()}
              onGenerarOrdenCocina={(jornadaId) => handleGenerateOrdenCocina(jornadaId)}
              onGenerarOrdenCocinaNueva={(jornadaId) => handleGenerateOrdenCocinaNueva(jornadaId)}
              menusDisponibles={menus}
              platosDisponibles={platos}
            />
          </div>
        )}

        {/* Opción para gestionar multi-evento cuando es_multi_evento=true pero solo tiene 1 jornada */}
        {presupuesto.es_multi_evento && (presupuesto.jornadas?.length || 0) <= 1 && (
          <div className="mb-4 sm:mb-6">
            <JornadasManager
              presupuesto={presupuesto}
              jornadas={presupuesto.jornadas || []}
              onJornadaCreated={() => fetchData()}
              onJornadaUpdated={() => fetchData()}
              onJornadaDeleted={() => fetchData()}
              onGenerarJornadas={() => fetchData()}
              onRefresh={() => fetchData()}
              onGenerarOrdenCocina={(jornadaId) => handleGenerateOrdenCocina(jornadaId)}
              onGenerarOrdenCocinaNueva={(jornadaId) => handleGenerateOrdenCocinaNueva(jornadaId)}
              menusDisponibles={menus}
              platosDisponibles={platos}
            />
          </div>
        )}

        {/* Botón para convertir a multi-evento (solo si no es multi-evento y está
            en borrador o enviado: el servidor también exige futuro y sin facturas) */}
        {!presupuesto.es_multi_evento && ['borrador', 'enviado', 'aceptado'].includes(presupuesto.estado || 'borrador') && (
          <div className="mb-4 sm:mb-6">
            <button
              onClick={async () => {
                if (window.confirm('¿Convertir este presupuesto a multi-evento? Se creará la primera jornada con los datos actuales.')) {
                  try {
                    const response = await fetch(
                      `${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${id}/convertir-a-multi-evento`,
                      {
                        method: 'POST',
                        headers: {
                          'Authorization': `Bearer ${getAuthToken()}`
                        }
                      }
                    );
                    if (response.ok) {
                      const datos = await response.json().catch(() => ({}));
                      alert('Presupuesto convertido a multi-evento' +(datos?.aviso ? `\n\n${datos.aviso}` : ''));
                      fetchData();
                    } else {
                      const error = await response.json();
                      alert(`Error: ${error.detail}`);
                    }
                  } catch (error) {
                    console.error('Error:', error);
                    alert('Error al convertir el presupuesto');
                  }
                }
              }}
              className="w-full sm:w-auto flex items-center justify-center space-x-2 px-4 py-3 bg-indigo-50 text-indigo-700 border border-indigo-200 rounded-lg hover:bg-indigo-100 transition-colors"
            >
              <Layers className="w-5 h-5" />
              <span>Convertir a Multi-Evento (varios días)</span>
            </button>
          </div>
        )}
      </>
  );

  // Formato nuevo: convertir un evento de un día (borrador) en multievento. La
  // primera jornada se crea con los datos actuales; el servidor exige además
  // evento futuro y sin facturas (lo dice con el motivo si no se puede)
  const convertirAMultieventoFormatoNuevo = async () => {
    if (!window.confirm('¿Convertir este presupuesto en multievento (varios días)? Se creará la primera jornada con los datos actuales.')) return;
    setConvirtiendoMultievento(true);
    try {
      await esperarAutoguardado();
      const { data } = await presupuestosAPI.convertirAMultiEvento(id);
      toast({ title: 'Presupuesto convertido en multievento', description: data?.aviso || 'Añade las demás jornadas en Líneas y menús.' });
      await alActualizarMultievento();
    } catch (error) {
      toast({ variant: 'destructive', title: 'No se ha convertido en multievento', description: textoDetalleApi(error?.response?.data?.detail, error?.message || 'Inténtalo de nuevo.') });
    } finally {
      setConvirtiendoMultievento(false);
    }
  };
  const puedeConvertirMultievento = () => formatoNuevo && !!presupuesto && !presupuesto.es_multi_evento
    && (presupuesto.estado || 'borrador') === 'borrador' && !esEventoPasadoFicha();

  // Tabla de líneas con sus botones, avisos de reglas y 'Añadir'
  // `compacta` (Resumen 2): título "Líneas del presupuesto" con los botones de
  // añadir pequeños arriba y sin los grandes del pie
  const renderTablaLineas = ({ compacta = false } = {}) => (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-4 sm:mb-6">
            <div className="p-3 sm:p-6 border-b border-gray-200 flex flex-wrap items-center justify-between gap-2">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900">{compacta ? 'Líneas del presupuesto' : 'Detalle del Presupuesto'}</h2>
              {compacta && (
                <div className="flex flex-wrap items-center gap-2" data-testid="lineas-botones-compactos">
                  <button type="button" onClick={() => setShowAddMenuModal(true)}
                    className="h-8 px-3 rounded-lg border border-[#CBD3CF] bg-white text-xs font-semibold text-[#16221D] hover:bg-gray-50 inline-flex items-center gap-1"
                    data-testid="lineas-anadir-menu" data-uso="lineas.anadir_menu">
                    <Plus className="w-3.5 h-3.5" /> Menú existente
                  </button>
                  <button type="button" onClick={handleOpenCustomMenuModal}
                    className="h-8 px-3 rounded-lg border border-duetto-secondary bg-white text-xs font-semibold text-[#11704F] hover:bg-[#E3F3EC] inline-flex items-center gap-1"
                    data-testid="lineas-menu-personalizado" data-uso="lineas.menu_personalizado">
                    <Plus className="w-3.5 h-3.5" /> Menú personalizado
                  </button>
                  <button type="button" onClick={() => setShowAddSuplementoModal(true)}
                    className="h-8 px-3 rounded-lg border border-amber-400 bg-white text-xs font-semibold text-amber-700 hover:bg-amber-50 inline-flex items-center gap-1"
                    data-testid="lineas-anadir-suplemento" data-uso="lineas.anadir_suplemento">
                    <Plus className="w-3.5 h-3.5" /> Suplemento
                  </button>
                </div>
              )}
              {puedeConvertirMultievento() && (
                <button
                  type="button"
                  onClick={convertirAMultieventoFormatoNuevo}
                  disabled={convirtiendoMultievento}
                  className="h-8 px-3 rounded-lg border border-[#CBD3CF] bg-white text-xs font-semibold text-[#16221D] hover:bg-gray-50 disabled:opacity-50 inline-flex items-center gap-1.5"
                  title="Varios días: crea la primera jornada con los datos actuales"
                  data-testid="convertir-multievento-nuevo"
                >
                  <Layers className="w-3.5 h-3.5" />
                  {convirtiendoMultievento ? 'Convirtiendo...' : 'Convertir a multievento'}
                </button>
              )}
            </div>

            <div className="p-2 sm:p-6">
              <div className="overflow-x-auto -mx-2 sm:mx-0">
                <table className="min-w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase">Concepto</th>
                      {/* Formato nuevo: los costes solo están en el Resumen de costes */}
                      {!formatoNuevo && (
                      <th className="px-2 sm:px-4 py-2 sm:py-3 text-right text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Coste</th>
                      )}
                      <th className="px-2 sm:px-4 py-2 sm:py-3 text-right text-xs font-medium text-gray-500 uppercase">Precio</th>
                      <th className="px-2 sm:px-4 py-2 sm:py-3 text-right text-xs font-medium text-gray-500 uppercase">UDS</th>
                      <th className="px-2 sm:px-4 py-2 sm:py-3 text-right text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">IVA</th>
                      <th className="px-2 sm:px-4 py-2 sm:py-3 text-right text-xs font-medium text-gray-500 uppercase">Total</th>
                      <th className="px-2 sm:px-4 py-2 sm:py-3 text-right text-xs font-medium text-gray-500 uppercase">Acc.</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {items.map((item, index) => (
                      <React.Fragment key={index}>
                        <tr className="hover:bg-gray-50">
                          <td className={`px-4 py-4${formatoNuevo && item.type === 'menu' && item.personalizadoIndex !== undefined && esBarraLibreVinculada(item.personalizadoIndex) ? ' pl-10' : ''}`}>
                            <div className="flex items-center space-x-2">
                              {item.type === 'menu' && !esItemBebida(item) && (
                                <button
                                  onClick={() => toggleMenuExpanded(item.id)}
                                  className="text-duetto-primary hover:text-duetto-secondary"
                                >
                                  {expandedMenus[item.id] ? <ChevronDown className="w-5 h-5" /> : <ChevronRight className="w-5 h-5" />}
                                </button>
                              )}
                              {item.type === 'plato' && (
                                <button
                                  onClick={() => togglePlatoExpanded(item.id)}
                                  className="text-duetto-primary hover:text-duetto-secondary"
                                >
                                  {expandedPlatos[item.id] ? <ChevronDown className="w-5 h-5" /> : <ChevronRight className="w-5 h-5" />}
                                </button>
                              )}
                              <div>
                                <span className="text-sm font-semibold text-gray-900">{item.concepto}</span>
                                {/* Alias comercial: solo se aplica a menús personalizados */}
                                {item.type === 'menu' && item.personalizadoIndex !== undefined && !esItemBebida(item) && (
                                  <button
                                    type="button"
                                    onClick={() => (
                                      esConceptoClienteAbierto('menu', item.personalizadoIndex)
                                        ? cerrarConceptoCliente()
                                        : abrirConceptoCliente(
                                            'menu',
                                            item.personalizadoIndex,
                                            presupuesto.menus_personalizados?.[item.personalizadoIndex]?.concepto_cliente,
                                            presupuesto.menus_personalizados?.[item.personalizadoIndex]?.mostrar_platos_cliente
                                          )
                                    )}
                                    title="Concepto para mostrar solo en facturas y presupuestos"
                                    data-testid={`concepto-cliente-btn-menu-${item.personalizadoIndex}`}
                                    className="ml-2 align-middle text-gray-400 hover:text-duetto-primary transition-colors"
                                  >
                                    <Pencil className="w-3.5 h-3.5" />
                                  </button>
                                )}
                                {item.type === 'menu' && !esItemBebida(item) && (
                                  <span className="ml-2 px-2 py-1 bg-duetto-primary bg-opacity-10 text-duetto-primary text-xs rounded-full">Menú</span>
                                )}
                                {/* Bebida con importe (D9): su línea la escribe la pestaña Bebidas */}
                                {esItemBebida(item) && (
                                  <>
                                    <span className="ml-2 px-2 py-1 bg-sky-50 text-sky-800 border border-sky-200 text-xs rounded-full"
                                      data-testid={`linea-bebida-${item.personalizadoIndex}`}>
                                      Bebidas
                                    </span>
                                    <p className="mt-1 text-xs text-gray-500">El precio y las unidades se cambian en la pestaña Bebidas.</p>
                                  </>
                                )}
                                {/* Formato nuevo: chip de la barra libre del lunch (solo en líneas con la bebida incluida) */}
                                {formatoNuevo && item.type === 'menu' && item.personalizadoIndex !== undefined
                                  && renderChipBarraLibre(item.personalizadoIndex)}
                                {/* Línea creada por el chip: vinculada al lunch */}
                                {formatoNuevo && item.type === 'menu' && item.personalizadoIndex !== undefined
                                  && esBarraLibreVinculada(item.personalizadoIndex) && (
                                  <>
                                    <span
                                      className="ml-2 px-2 py-0.5 text-xs rounded-full border bg-[#E3F3EC] text-[#0F5E43] border-[#BFE3D2]"
                                      data-testid={`barra-libre-vinculada-${item.personalizadoIndex}`}
                                    >
                                      Cubre la bebida del lunch
                                    </span>
                                    {errorBarraLibre && errorBarraLibre.clave === `barra:${item.personalizadoIndex}` && (
                                      <p className="mt-1 text-xs text-red-600">{errorBarraLibre.texto}</p>
                                    )}
                                  </>
                                )}
                                {item.type === 'plato' && (
                                  <span className="ml-2 px-2 py-1 bg-duetto-yellow bg-opacity-20 text-duetto-yellow text-xs rounded-full">Plato</span>
                                )}
                                {/* Horario del servicio (solo para menús; formato nuevo: solo servicios con montaje) */}
                                {/* F5: en multievento (y sin el módulo de presupuestos) solo lectura: aquí
                                    solo se escribía la cabecera; las horas van por el Resumen */}
                                {item.type === 'menu' && item.personalizadoIndex !== undefined && !esItemBebida(item)
                                  && !(formatoNuevo&& horarioLinea(item.personalizadoIndex)?.clase === 'complemento')
                                  && (horasLineasSoloLectura ? (
                                  <span className="ml-2 inline-flex items-center gap-1 text-xs text-gray-500"
                                    data-testid={`menu-horas-texto-${item.personalizadoIndex}`}>
                                    {textoHorasServicio(
                                      presupuesto.menus_personalizados?.[item.personalizadoIndex]?.hora_inicio_servicio || '',
                                      presupuesto.menus_personalizados?.[item.personalizadoIndex]?.hora_fin_servicio || '')}
                                    {esMultieventoHoras && <span className="text-gray-400">· Las horas se cambian en el Resumen</span>}
                                  </span>
                                ) : (
                                  <span className="ml-2 inline-flex items-center gap-1 text-xs text-gray-500">
                                    <input
                                      type="time"
                                      value={presupuesto.menus_personalizados?.[item.personalizadoIndex]?.hora_inicio_servicio || ''}
                                      placeholder={presupuesto.hora_inicio || ''}
                                      onChange={(e) => {
                                        const newMenus = [...(presupuesto.menus_personalizados || [])];
                                        newMenus[item.personalizadoIndex] = {
                                          ...newMenus[item.personalizadoIndex],
                                          hora_inicio_servicio: e.target.value
                                        };
                                        setPresupuesto(prev => ({...prev, menus_personalizados: newMenus}));
                                        guardarMenusConRetardo(newMenus);
                                      }}
                                      data-testid={`menu-hora-inicio-${item.personalizadoIndex}`}
                                      className="w-[70px] px-1 py-0.5 border border-gray-200 rounded text-xs text-gray-600 focus:ring-1 focus:ring-duetto-primary"
                                      title="Hora inicio servicio"
                                    />
                                    <span className="text-gray-400">-</span>
                                    <input
                                      type="time"
                                      value={presupuesto.menus_personalizados?.[item.personalizadoIndex]?.hora_fin_servicio || ''}
                                      placeholder={presupuesto.hora_fin || ''}
                                      onChange={(e) => {
                                        const newMenus = [...(presupuesto.menus_personalizados || [])];
                                        newMenus[item.personalizadoIndex] = {
                                          ...newMenus[item.personalizadoIndex],
                                          hora_fin_servicio: e.target.value
                                        };
                                        setPresupuesto(prev => ({...prev, menus_personalizados: newMenus}));
                                        guardarMenusConRetardo(newMenus);
                                      }}
                                      data-testid={`menu-hora-fin-${item.personalizadoIndex}`}
                                      className="w-[70px] px-1 py-0.5 border border-gray-200 rounded text-xs text-gray-600 focus:ring-1 focus:ring-duetto-primary"
                                      title="Hora fin servicio"
                                    />
                                  </span>
                                ))}
                                {/* Formato nuevo: servicio con hora o complemento que acompaña a un servicio */}
                                {formatoNuevo && item.type === 'menu' && item.personalizadoIndex !== undefined && !esItemBebida(item)
                                  && renderHorarioLinea(item.personalizadoIndex)}
                                {/* Alias comercial guardado: aviso permanente para el comercial */}
                                {item.type === 'menu' && item.personalizadoIndex !== undefined
                                  && presupuesto.menus_personalizados?.[item.personalizadoIndex]?.concepto_cliente && (
                                  <p className="mt-1 text-xs text-violet-700">
                                    En factura/presupuesto: "{presupuesto.menus_personalizados[item.personalizadoIndex].concepto_cliente}" ({textoUnidadesAlias(presupuesto.menus_personalizados[item.personalizadoIndex])})
                                    {presupuesto.menus_personalizados[item.personalizadoIndex].mostrar_platos_cliente && (
                                      <span className="ml-1 text-violet-500">(platos visibles)</span>
                                    )}
                                  </p>
                                )}
                                {/* Requisitos del formato (se configuran en la ficha del menú; formato nuevo) */}
                                {formatoNuevo && item.type === 'menu' && item.personalizadoIndex !== undefined && (() => {
                                  const menuIdReq = presupuesto.menus_personalizados?.[item.personalizadoIndex]?.menu_id;
                                  const requisitos = obtenerRequisitosMontaje(menuIdReq);
                                  return requisitos ? (
                                    <p className="mt-1 text-xs text-orange-700" data-testid={`requisitos-montaje-${item.personalizadoIndex}`}>
                                      <span className="font-semibold">Requisitos:</span> {requisitos}
                                    </p>
                                  ) : null;
                                })()}
                                {item.type === 'menu' && item.personalizadoIndex !== undefined
                                  && renderEditorConceptoCliente(
                                    'menu',
                                    item.personalizadoIndex,
                                    presupuesto.menus_personalizados?.[item.personalizadoIndex]?.concepto_cliente
                                  )}
                              </div>
                            </div>
                          </td>
                          
                          {/* Columna de Coste TOTAL por persona con desglose (solo formato anterior) */}
                          {!formatoNuevo && (
                          <td className="px-4 py-4 text-right group relative">
                            {item.type === 'menu' && item.personalizadoIndex !== undefined && presupuesto.menus_personalizados && presupuesto.menus_personalizados[item.personalizadoIndex] ? (
                              <>
                                <div className="text-sm">
                                  <span className="text-gray-600 cursor-help">
                                    €{safeToFixed(calculateCosteMenu(presupuesto.menus_personalizados[item.personalizadoIndex]) / (personasCosteMenu(presupuesto.menus_personalizados[item.personalizadoIndex]) || item.uds || 1), 2)}
                                  </span>
                                  <div className="text-xs text-gray-500">coste/pers</div>
                                </div>
                                {/* Tooltip con desglose detallado */}
                                <div className="hidden group-hover:block absolute right-0 top-full mt-2 bg-gray-900 text-white text-xs rounded-lg shadow-lg p-3 z-50 whitespace-nowrap">
                                  <div className="font-semibold mb-2 border-b border-gray-700 pb-2">Desglose de Coste</div>
                                  {(() => {
                                    const menuPers = presupuesto.menus_personalizados[item.personalizadoIndex];
                                    if (!menuPers) return null;
                                    const numPersonas = menuPers.num_personas || item.uds;

                                    // Multievento (M-44): el desglose jornada a jornada con las
                                    // personas de cada una, repartido entre todas sus personas
                                    const desgloseJornadas = getDesgloseCostesMenu(menuPers);
                                    if (desgloseJornadas?.porJornada) {
                                      const pax = desgloseJornadas.personasTotal || 1;
                                      const porPersona = (v) => `€${safeToFixed((v || 0) / pax, 2)}/pers`;
                                      return (
                                        <>
                                          <div className="flex justify-between gap-4 mb-1">
                                            <span>Platos:</span>
                                            <span>{porPersona(desgloseJornadas.costeIngredientes)}</span>
                                          </div>
                                          <div className="flex justify-between gap-4 mb-1">
                                            <span>Personal:</span>
                                            <span>{porPersona(desgloseJornadas.costePersonalEvento)}</span>
                                          </div>
                                          <div className="flex justify-between gap-4 mb-2">
                                            <span>Material:</span>
                                            <span>{porPersona(desgloseJornadas.costeMaterialElaboracion)}</span>
                                          </div>
                                          <div className="flex justify-between gap-4 pt-2 border-t border-gray-700 font-semibold">
                                            <span>Total:</span>
                                            {/* Mismo criterio que la cifra de la celda (calculateCosteMenu, sin cocina) */}
                                            <span>{porPersona(desgloseJornadas.costeTotal - desgloseJornadas.costePersonalCocina)}</span>
                                          </div>
                                          <div className="text-xs opacity-75 mt-2 pt-2 border-t border-gray-700">
                                            Por jornada: {desgloseJornadas.porJornada.map(x => `J${x.numero} ${x.personas} pers.`).join(', ')}
                                          </div>
                                        </>
                                      );
                                    }

                                    // Determinar si es histórico
                                    // M-101: en un multievento, cuando ha pasado su última jornada
                                    const eventoYaPaso = eventoPasado(presupuesto);
                                    const estaConfirmado = presupuesto.estado === 'confirmado';
                                    const esHistorico = eventoYaPaso && estaConfirmado;
                                    
                                    // CASO ESPECIAL: Menú histórico (solo si evento pasó y está confirmado)
                                    if (esHistorico && menuPers.coste_unitario_legacy !== undefined && menuPers.coste_unitario_legacy !== null) {
                                      return (
                                        <div>
                                          <div className="flex justify-between gap-4 mb-1">
                                            <span className="text-purple-300">📜 Menú histórico:</span>
                                            <span>€{menuPers.coste_unitario_legacy.toFixed(2)}/pers</span>
                                          </div>
                                          <div className="text-xs opacity-75 mt-2 pt-2 border-t border-gray-700">
                                            Coste fijo del sistema antiguo
                                          </div>
                                        </div>
                                      );
                                    }
                                    
                                    // Coste dinámico de platos - buscar en ediciones locales primero
                                    let costePlatos = 0;
                                    let platosDelMenu = [];
                                    
                                    if (menuPers.platos_ids && menuPers.platos_ids.length > 0) {
                                      platosDelMenu = menuPers.platos_ids.map(platoId => ({
                                        plato_id: platoId,
                                        cantidad: menuPers.unidades_por_plato?.[platoId] || 1
                                      }));
                                    } else if (menuPers.menu_id) {
                                      const menuEnCatalogo = menus.find(m => m.id === menuPers.menu_id);
                                      if (menuEnCatalogo && menuEnCatalogo.platos && menuEnCatalogo.platos.length > 0) {
                                        platosDelMenu = menuEnCatalogo.platos;
                                      }
                                    }
                                    
                                    if (platosDelMenu.length > 0) {
                                      costePlatos = calcularCosteIngredientesMenu(platosDelMenu, numPersonas);
                                    }

                                    // Buscar configuración (primero personalizada, luego catálogo)
                                    const menuCatalogo = menuPers.menu_id ? menus.find(m => m.id === menuPers.menu_id) : null;
                                    const config = menuPers.config_personalizada || menuCatalogo;
                                    
                                    // Tipo "otros": sin personal propio, pero con sus camareros/extras
                                    const tipoMenu = menuCatalogo?.tipo_menu || '';
                                    const excluirPersonalPropio = tipoMenu === 'otros';

                                    // USAR LA MISMA LÓGICA QUE calculateCosteMenu PARA CONSISTENCIA

                                    // Coste de personal PROPIO (siempre 1 incluido)
                                    let costePersonalPropio = 0;
                                    if (config && config.horas_por_camarero && !excluirPersonalPropio) {
                                      const horasServicio = config.horas_por_camarero;
                                      costePersonalPropio = 1 * horasServicio * 60 * 0.26; // €0.26/min
                                    }
                                    
                                    // Camareros según ratio (solo si existe y > 0)
                                    let costeCamareros = 0;
                                    let numCamareros = 0;
                                    if (config && config.ratio_camareros && config.ratio_camareros > 0) {
                                      const horasServicio = config.horas_por_camarero || 0;
                                      const costePorHora = config.coste_camarero_hora || 0;
                                      if (horasServicio > 0 && costePorHora > 0) {
                                        numCamareros = personalPorRatio(numPersonas, config.ratio_camareros);
                                        costeCamareros = numCamareros * horasServicio * costePorHora;
                                      }
                                    }
                                    
                                    // Extras según ratio (solo si existe y > 0)
                                    let costeExtras = 0;
                                    let numExtras = 0;
                                    if (config && config.ratio_extras && config.ratio_extras > 0) {
                                      const horasServicio = config.horas_por_camarero || 0;
                                      const costePorHora = config.coste_camarero_hora || 0;
                                      if (horasServicio > 0 && costePorHora > 0) {
                                        numExtras = personalPorRatio(numPersonas, config.ratio_extras, true);
                                        costeExtras = numExtras * horasServicio * costePorHora;
                                      }
                                    }
                                    
                                    const costePersonalTotal = costePersonalPropio + costeCamareros + costeExtras;
                                    
                                    // Material de elaboración (menaje dentro de los platos), IGUAL que
                                    // calculateCosteMenu (el nº de arriba) para que el desglose cuadre.
                                    // El material a nivel de menú se cuenta aparte en "Material y menaje".
                                    let costeMaterial = 0;
                                    if (platosDelMenu.length > 0) {
                                      costeMaterial = calcularCosteMaterialElaboracionMenu(platosDelMenu, numPersonas).total;
                                    }

                                    const safeNumPersonas = numPersonas || 1; // Evitar división por cero
                                    return (
                                      <>
                                        <div className="flex justify-between gap-4 mb-1">
                                          <span>Platos:</span>
                                          <span>€{safeToFixed(costePlatos / safeNumPersonas, 2)}/pers</span>
                                        </div>
                                        <div className="flex justify-between gap-4 mb-1">
                                          <span>Personal:</span>
                                          <span>€{safeToFixed(costePersonalTotal / safeNumPersonas, 2)}/pers</span>
                                        </div>
                                        {costePersonalPropio > 0 && (
                                          <div className="flex justify-between gap-4 mb-1 text-xs opacity-75">
                                            <span className="ml-2">↳ Propio (1 pers × {config?.horas_por_camarero || 0}h):</span>
                                            <span>€{safeToFixed(costePersonalPropio / safeNumPersonas, 2)}/pers</span>
                                          </div>
                                        )}
                                        {costeCamareros > 0 && (
                                          <div className="flex justify-between gap-4 mb-1 text-xs opacity-75">
                                            <span className="ml-2">↳ Camareros ({numCamareros} × {config?.horas_por_camarero || 0}h × €{config?.coste_camarero_hora || 0}):</span>
                                            <span>€{safeToFixed(costeCamareros / safeNumPersonas, 2)}/pers</span>
                                          </div>
                                        )}
                                        {costeExtras > 0 && (
                                          <div className="flex justify-between gap-4 mb-1 text-xs opacity-75">
                                            <span className="ml-2">↳ Extras ({numExtras} × {config?.horas_por_camarero || 0}h × €{config?.coste_camarero_hora || 0}):</span>
                                            <span>€{safeToFixed(costeExtras / safeNumPersonas, 2)}/pers</span>
                                          </div>
                                        )}
                                        <div className="flex justify-between gap-4 mb-2">
                                          <span>Material:</span>
                                          <span>€{safeToFixed(costeMaterial / safeNumPersonas, 2)}/pers</span>
                                        </div>
                                        <div className="flex justify-between gap-4 pt-2 border-t border-gray-700 font-semibold">
                                          <span>Total:</span>
                                          <span>€{safeToFixed((costePlatos + costePersonalTotal + costeMaterial) / safeNumPersonas, 2)}/pers</span>
                                        </div>
                                      </>
                                    );
                                  })()}
                                </div>
                              </>
                            ) : (
                              <span className="text-xs text-gray-400">-</span>
                            )}
                          </td>
                          )}
                          
                          {/* Columna de Precio por persona */}
                          <td className="px-4 py-4 text-right">
                            <div>
                              {/* Precio editable solo para menús (las bebidas, en su pestaña) */}
                              {item.type === 'menu' && item.personalizadoIndex !== undefined && !esItemBebida(item) ? (
                                editingPriceMenuIndex === item.personalizadoIndex ? (
                                  <div className="flex items-center gap-1 justify-end">
                                    <span className="text-sm">€</span>
                                    <input
                                      type="number"
                                      step="0.01"
                                      value={tempPrecio}
                                      onChange={(e) => setTempPrecio(parseFloat(e.target.value) || 0)}
                                      onBlur={() => handleSavePrecioInline(item.personalizadoIndex)}
                                      onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                          handleSavePrecioInline(item.personalizadoIndex);
                                        }
                                      }}
                                      className="w-20 border border-blue-300 rounded px-2 py-1 text-sm font-medium text-right"
                                      autoFocus
                                    />
                                  </div>
                                ) : (
                                  <span 
                                    className="text-sm font-medium text-gray-900 cursor-pointer hover:text-blue-600 hover:underline"
                                    onClick={() => {
                                      setEditingPriceMenuIndex(item.personalizadoIndex);
                                      setTempPrecio(item.precio_ud);
                                    }}
                                    title="Click para editar precio"
                                  >
                                    €{safeToFixed(item.precio_ud, 2)}
                                  </span>
                                )
                              ) : (
                                <span className="text-sm font-medium text-gray-900">€{safeToFixed(item.precio_ud, 2)}</span>
                              )}
                              
                              {item.type === 'menu' && item.personalizadoIndex !== undefined && presupuesto.menus_personalizados?.[item.personalizadoIndex]?.descuento_valor && (
                                <div className="text-xs text-green-600">
                                  -{presupuesto.menus_personalizados[item.personalizadoIndex].descuento_tipo === 'porcentaje' 
                                    ? `${presupuesto.menus_personalizados[item.personalizadoIndex].descuento_valor}%` 
                                    : `€${presupuesto.menus_personalizados[item.personalizadoIndex].descuento_valor}`}
                                </div>
                              )}
                              <div className="text-xs text-gray-500">precio/pers</div>
                            </div>
                          </td>
                          <td className="px-4 py-4 text-right">
                            {item.udsJornadas ? (
                              // Multievento: el total del evento; las personas se cambian en cada jornada
                              <div data-testid={`uds-multievento-${item.personalizadoIndex}`}>
                                <div className="text-sm font-bold text-gray-900">{item.uds}</div>
                                <div className="text-xs text-gray-500">{textoUnidadesJornadas(item.udsJornadas)}</div>
                                <div className="text-xs text-gray-500">Se cambian en cada jornada</div>
                              </div>
                            ) : formatoNuevo && item.type === 'menu' && item.personalizadoIndex !== undefined
                              && esBarraLibreVinculada(item.personalizadoIndex) ? (
                              <input
                                type="number"
                                value={item.uds}
                                disabled
                                readOnly
                                title="Sigue a las personas del lunch"
                                data-testid={`uds-barra-libre-${item.personalizadoIndex}`}
                                className="w-20 border border-gray-200 bg-gray-50 text-gray-500 rounded px-2 py-1 text-sm font-medium text-right cursor-not-allowed"
                              />
                            ) : item.type === 'menu' && item.personalizadoIndex !== undefined && !esItemBebida(item) ? (
                              editingUnidadesMenuIndex === item.personalizadoIndex ? (
                                <input
                                  type="number"
                                  min="1"
                                  value={tempUnidades}
                                  onChange={(e) => setTempUnidades(parseInt(e.target.value) || 0)}
                                  onBlur={() => handleSaveUnidadesInline(item.personalizadoIndex)}
                                  onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                      handleSaveUnidadesInline(item.personalizadoIndex);
                                    }
                                  }}
                                  className="w-20 border border-blue-300 rounded px-2 py-1 text-sm font-medium text-right"
                                  autoFocus
                                />
                              ) : (
                                <span 
                                  className="text-sm font-medium text-gray-900 cursor-pointer hover:text-blue-600 hover:underline"
                                  onClick={() => {
                                    setEditingUnidadesMenuIndex(item.personalizadoIndex);
                                    setTempUnidades(item.uds);
                                  }}
                                  title="Click para editar personas"
                                >
                                  {item.uds}
                                </span>
                              )
                            ) : (
                              <span className="text-sm font-medium text-gray-900">{item.uds}</span>
                            )}
                          </td>
                          <td className="px-4 py-4 text-right">
                            {item.type === 'menu' && item.personalizadoIndex !== undefined && !esItemBebida(item) ? (
                              editingIvaMenuIndex === item.personalizadoIndex ? (
                                <select
                                  value={tempIva}
                                  onChange={(e) => {
                                    const v = parseInt(e.target.value);
                                    setTempIva(v);
                                    handleSaveIvaInline(item.personalizadoIndex, v);
                                  }}
                                  onBlur={() => setEditingIvaMenuIndex(null)}
                                  className="border border-blue-300 rounded px-2 py-1 text-sm text-right"
                                  autoFocus
                                >
                                  <option value={10}>10%</option>
                                  <option value={21}>21%</option>
                                </select>
                              ) : (
                                <span
                                  className="text-sm text-gray-600 cursor-pointer hover:text-blue-600 hover:underline"
                                  onClick={() => {
                                    setEditingIvaMenuIndex(item.personalizadoIndex);
                                    setTempIva(item.iva_percent || 10);
                                  }}
                                  title="Click para editar IVA"
                                >
                                  {item.iva_percent}%
                                </span>
                              )
                            ) : (
                              <span className="text-sm text-gray-600">{item.iva_percent}%</span>
                            )}
                          </td>
                          <td className="px-4 py-4 text-right">
                            <div>
                              {/* Mostrar coste total SIN IVA si es un menú */}
                              {item.type === 'menu' && item.personalizadoIndex !== undefined && presupuesto.menus_personalizados && presupuesto.menus_personalizados[item.personalizadoIndex] && (
                                <div className="text-xs text-gray-500 mb-1">
                                  Coste: €{safeToFixed(calculateCosteMenu(presupuesto.menus_personalizados[item.personalizadoIndex]), 2)}
                                </div>
                              )}
                              <span className="text-sm font-bold text-gray-900">€{safeToFixed(calculateImporte(item), 2)}</span>
                            </div>
                          </td>
                          <td className="px-4 py-4 text-right">
                            <div className="flex justify-end gap-2">
                              {/* Botones de reordenar - solo para menús */}
                              {item.type === 'menu' && item.personalizadoIndex !== undefined && (
                                <>
                                  <button 
                                    onClick={() => handleMoveMenuUp(item.personalizadoIndex)}
                                    disabled={item.personalizadoIndex === 0}
                                    className={`p-1 ${item.personalizadoIndex === 0 ? 'text-gray-300 cursor-not-allowed' : 'text-blue-600 hover:text-blue-800'}`}
                                    title="Mover menú arriba"
                                  >
                                    <ChevronUp className="w-4 h-4" />
                                  </button>
                                  <button 
                                    onClick={() => handleMoveMenuDown(item.personalizadoIndex)}
                                    disabled={item.personalizadoIndex >= (presupuesto.menus_personalizados?.length || 0) - 1}
                                    className={`p-1 ${item.personalizadoIndex >= (presupuesto.menus_personalizados?.length || 0) - 1 ? 'text-gray-300 cursor-not-allowed' : 'text-blue-600 hover:text-blue-800'}`}
                                    title="Mover menú abajo"
                                  >
                                    <ChevronDown className="w-4 h-4" />
                                  </button>
                                </>
                              )}
                              {item.type === 'menu' && item.personalizadoIndex !== undefined && !esItemBebida(item) && (
                                <button
                                  onClick={() => {
                                    setDescuentoMenuIndex(item.personalizadoIndex);
                                    const menu = presupuesto.menus_personalizados[item.personalizadoIndex];
                                    setDescuentoData({
                                      tipo: menu.descuento_tipo || 'porcentaje',
                                      valor: menu.descuento_valor || 0
                                    });
                                    setShowDescuentoModal(true);
                                  }}
                                  className="text-green-600 hover:text-green-800 p-1"
                                  title="Aplicar descuento"
                                >
                                  <DollarSign className="w-4 h-4" />
                                </button>
                              )}
                              {!esItemBebida(item) && (
                              <button
                                onClick={() => (
                                  formatoNuevo && item.type === 'menu' && item.personalizadoIndex !== undefined
                                    && esBarraLibreVinculada(item.personalizadoIndex)
                                    ? quitarBarraLibreVinculada(item.personalizadoIndex)
                                    : handleDeleteItem(item)
                                )}
                                disabled={guardandoBarraLibre === `barra:${item.personalizadoIndex}`}
                                className="text-red-600 hover:text-red-800 p-1"
                              >
                                <Trash2 className="w-4 h-4" />
                              </button>
                              )}
                            </div>
                          </td>
                        </tr>

                        {/* Expanded Menu Details - FASE 2: Editable */}
                        {item.type === 'menu' && !esItemBebida(item) && expandedMenus[item.id] && item.menu_data && (
                          <tr>
                            <td colSpan={formatoNuevo ? 6 : 7} className="px-4 py-3 bg-duetto-primary bg-opacity-5">
                              <div className="ml-12 space-y-4">
                                {/* Platos del Menú */}
                                <div>
                                  <div className="flex justify-between items-center mb-2">
                                    <p className="font-semibold text-sm text-gray-700">Platos incluidos en el menú:</p>
                                    <div className="flex gap-2">
                                      <button
                                        onClick={() => {
                                          setSelectedMenuForAdaptacion(item);
                                          setShowAdaptacionModal(true);
                                        }}
                                        className="px-3 py-1.5 bg-orange-500 text-white text-xs rounded-lg hover:bg-orange-600 transition flex items-center gap-1"
                                      >
                                        <AlertCircle className="w-3 h-3" />
                                        {formatoNuevo ? 'Adaptación manual (avanzado)' : 'Gestionar Adaptaciones Dietéticas'}
                                      </button>
                                      <button
                                        onClick={() => {
                                          setEditPlatosMenuIndex(item.personalizadoIndex);
                                          const menuPers = presupuesto.menus_personalizados[item.personalizadoIndex];
                                          // Inicializar con los platos actuales y sus unidades - filtrar inactivos
                                          const platosConUnidades = (menuPers.platos_ids || [])
                                            .filter(platoId => {
                                              const p = platos.find(pl => pl.id === platoId);
                                              return !p || p.activo !== false;
                                            })
                                            .map(platoId => ({
                                            platoId,
                                            unidades: menuPers.unidades_por_plato?.[platoId] || 1
                                          }));
                                          setEditedPlatos(platosConUnidades);
                                          setPlatoSearchTerm('');
                                          setPlatoFiltersEdit({
                                            precioMax: '',
                                            categoria: '',
                                            sinAlergenos: []
                                          });
                                          setShowEditPlatosModal(true);
                                        }}
                                        className="px-3 py-1.5 bg-blue-500 text-white text-xs rounded-lg hover:bg-blue-600 transition flex items-center gap-1"
                                      >
                                        <MenuIcon className="w-3 h-3" />
                                        Editar Platos
                                      </button>
                                    </div>
                                  </div>
                                  {/* Listado de platos mejorado */}
                                  <div className="space-y-2">
                                    {item.menu_data.es_legacy ? (
                                      <div className="text-sm text-purple-600 bg-purple-50 border border-purple-200 px-4 py-3 rounded-lg">
                                        <span className="font-semibold">📜 Menú histórico</span>
                                        <p className="text-xs mt-1 text-gray-600">
                                          Este menú fue migrado del sistema antiguo. El detalle de platos no está disponible, 
                                          pero se conservan los precios y costes históricos.
                                        </p>
                                        {item.menu_data.tipomenu_legacy && (
                                          <p className="text-xs mt-1 text-gray-600">
                                            Tipo: <span className="font-semibold">{item.menu_data.tipomenu_legacy}</span>
                                          </p>
                                        )}
                                      </div>
                                    ) : (
                                      <>
                                        {/* Resumen de gastos al inicio */}
                                        {(() => {
                                          const menuPers = presupuesto.menus_personalizados[item.personalizadoIndex];
                                          const numPersonas = menuPers.num_personas || personasPorDefectoLinea(presupuesto, null, 1);
                                          
                                          // Buscar el menú en el catálogo para obtener ratios
                                          let menuCatalogo = null;
                                          if (menuPers.menu_id) {
                                            menuCatalogo = menus.find(m => m.id === menuPers.menu_id);
                                          }
                                          
                                          // Usar configuración personalizada si existe, sino usar catálogo
                                          const config = menuPers.config_personalizada || menuCatalogo;
                                          
                                          // Calcular coste de platos (con redondeo a envase para ingredientes no aprovechables)
                                          let costePlatos = 0;
                                          const platosIds = menuPers.platos_ids || [];
                                          const unidadesPorPlato = menuPers.unidades_por_plato || {};
                                          let platosDelMenuAdapt = [];

                                          if (platosIds.length > 0) {
                                            platosDelMenuAdapt = platosIds.map(platoId => ({
                                              plato_id: platoId,
                                              cantidad: unidadesPorPlato[platoId] || 1
                                            }));
                                          } else if (menuCatalogo && menuCatalogo.platos) {
                                            platosDelMenuAdapt = menuCatalogo.platos;
                                          }

                                          if (platosDelMenuAdapt.length > 0) {
                                            costePlatos = calcularCosteIngredientesMenu(platosDelMenuAdapt, numPersonas);
                                          }
                                          
                                          // Calcular personal usando config_personalizada si existe.
                                          // Tipo "otros": sin personal propio, pero con sus camareros/extras
                                          const tipoMenu = menuCatalogo?.tipo_menu || '';
                                          const excluirPersonalPropio = tipoMenu === 'otros';
                                          let costePersonalPropio = 0;
                                          let costeCamareros = 0;
                                          let costeExtras = 0;

                                          if (config) {
                                            // Personal propio (siempre 1 incluido, salvo en menús "otros")
                                            const horasServicio = config.horas_por_camarero || 4;
                                            if (!excluirPersonalPropio) {
                                              costePersonalPropio = 1 * horasServicio * 60 * 0.26; // 1 persona x horas x minutos x €0.26/min
                                            }

                                            // Camareros según ratio (solo si existe y > 0)
                                            const ratioCamareros = config.ratio_camareros;
                                            if (ratioCamareros && ratioCamareros > 0) {
                                              const numerosCamareros = Math.ceil(numPersonas / ratioCamareros);
                                              const horasPorCamarero = config.horas_por_camarero || 0;
                                              const costeCamareroHora = config.coste_camarero_hora || 0;
                                              if (horasPorCamarero > 0 && costeCamareroHora > 0) {
                                                costeCamareros = numerosCamareros * horasPorCamarero * costeCamareroHora;
                                              }
                                            }
                                            
                                            // Extras según ratio (solo si existe y > 0)
                                            const ratioExtras = config.ratio_extras;
                                            if (ratioExtras && ratioExtras > 0) {
                                              const numerosExtras = Math.floor(numPersonas / ratioExtras);
                                              const horasPorCamarero = config.horas_por_camarero || 0;
                                              const costeCamareroHora = config.coste_camarero_hora || 0;
                                              if (horasPorCamarero > 0 && costeCamareroHora > 0) {
                                                costeExtras = numerosExtras * horasPorCamarero * costeCamareroHora;
                                              }
                                            }
                                          }
                                          
                                          let costePlatoPorPersona = costePlatos / numPersonas;
                                          const costeMaterialTotalAdapt = platosDelMenuAdapt.length > 0
                                            ? calcularCosteMaterialElaboracionMenu(platosDelMenuAdapt, numPersonas).total : 0;
                                          let costeMaterialPorPersona = costeMaterialTotalAdapt / numPersonas;
                                          let costePersonalPorPersona = (costePersonalPropio + costeCamareros + costeExtras) / numPersonas;
                                          // Multievento (M-44): jornada a jornada con las personas de cada
                                          // una, repartido entre todas sus personas
                                          const desgloseJornadasMenu = getDesgloseCostesMenu(menuPers);
                                          if (desgloseJornadasMenu?.porJornada) {
                                            const paxMenu = desgloseJornadasMenu.personasTotal || 1;
                                            costePlatoPorPersona = desgloseJornadasMenu.costeIngredientes / paxMenu;
                                            costeMaterialPorPersona = desgloseJornadasMenu.costeMaterialElaboracion / paxMenu;
                                            costePersonalPorPersona = desgloseJornadasMenu.costePersonalEvento / paxMenu;
                                          }
                                          const costeTotalPorPersona = costePlatoPorPersona + costeMaterialPorPersona + costePersonalPorPersona;
                                          
                                          return (
                                            <div className="bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-lg px-4 py-3 mb-3">
                                              <div className="grid grid-cols-3 gap-4 text-xs">
                                                <div>
                                                  <span className="text-gray-600">Platos</span>
                                                  <p className="font-semibold text-gray-800 mt-1">€{costePlatoPorPersona.toFixed(2)}/pers</p>
                                                </div>
                                                <div>
                                                  <span className="text-gray-600">📦 Material</span>
                                                  <p className="font-semibold text-gray-800 mt-1">€{costeMaterialPorPersona.toFixed(2)}/pers</p>
                                                </div>
                                                <div>
                                                  <span className="text-gray-600">👥 Personal</span>
                                                  <p className="font-semibold text-gray-800 mt-1">€{costePersonalPorPersona.toFixed(2)}/pers</p>
                                                </div>
                                              </div>
                                              <div className="mt-2 pt-2 border-t border-blue-300 flex justify-between items-center">
                                                <span className="text-xs font-medium text-gray-700">TOTAL POR PERSONA:</span>
                                                <span className="text-sm font-bold text-duetto-primary">€{costeTotalPorPersona.toFixed(2)}</span>
                                              </div>
                                            </div>
                                          );
                                        })()}
                                        
                                        {/* Autocompletado inline para añadir plato rápido */}
                                        <div className="flex items-center gap-2 mb-3 pb-3 border-b border-gray-200">
                                          {/* Autocompletado inline más compacto */}
                                          <div className="flex items-center gap-2 relative inline-autocomplete">
                                            <input
                                              type="text"
                                              placeholder="Buscar plato..."
                                              value={inlineAddPlatoSearch[item.personalizadoIndex] || ''}
                                              onChange={(e) => {
                                                setInlineAddPlatoSearch(prev => ({...prev, [item.personalizadoIndex]: e.target.value}));
                                                setShowInlineSuggestions(prev => ({...prev, [item.personalizadoIndex]: true}));
                                              }}
                                              onFocus={() => setShowInlineSuggestions(prev => ({...prev, [item.personalizadoIndex]: true}))}
                                              className="w-64 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            />
                                            <input
                                              type="number"
                                              placeholder="Uds"
                                              min="0.5"
                                              step="0.5"
                                              value={inlineAddPlatoCantidad[item.personalizadoIndex] || 1}
                                              onChange={(e) => setInlineAddPlatoCantidad(prev => ({...prev, [item.personalizadoIndex]: parseFloat(e.target.value) || 1}))}
                                              className="w-20 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                            />
                                            
                                            {/* Sugerencias inline - filtrar duplicados */}
                                            {showInlineSuggestions[item.personalizadoIndex] && inlineAddPlatoSearch[item.personalizadoIndex] && (
                                              <div className="absolute top-full left-0 right-20 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto z-50">
                                                {(() => {
                                                  const menuPers = presupuesto.menus_personalizados[item.personalizadoIndex];
                                                  const platosYaIncluidos = menuPers.platos_ids || [];
                                                  
                                                  return platos
                                                    .filter(p => {
                                                      // Filtrar duplicados
                                                      if (platosYaIncluidos.includes(p.id)) return false;
                                                      // Filtrar por búsqueda (sin acentos)
                                                      return normalizeText(p.nombre).includes(normalizeText(inlineAddPlatoSearch[item.personalizadoIndex] || ''));
                                                    })
                                                    .slice(0, 5)
                                                    .map(plato => (
                                                      <button
                                                        key={plato.id}
                                                        onClick={async () => {
                                                          try {
                                                            const cantidad = inlineAddPlatoCantidad[item.personalizadoIndex] || 1;
                                                            avisoTrasCambioPlato(await presupuestosAPI.addPlatoToMenu(id, item.personalizadoIndex, {
                                                              plato_id: plato.id,
                                                              cantidad: cantidad
                                                            }));
                                                            setInlineAddPlatoSearch(prev => ({...prev, [item.personalizadoIndex]: ''}));
                                                            setShowInlineSuggestions(prev => ({...prev, [item.personalizadoIndex]: false}));
                                                            await fetchData();
                                                          } catch (error) {
                                                            console.error('Error adding plato:', error);
                                                            alert('Error al añadir el plato');
                                                          }
                                                        }}
                                                        className="w-full text-left px-3 py-2 hover:bg-green-50 text-sm border-b border-gray-100 last:border-b-0"
                                                      >
                                                        <div className="font-medium">{plato.nombre}</div>
                                                        <div className="text-xs text-gray-500">€{(plato.coste_por_porcion || 0).toFixed(2)}/porción</div>
                                                      </button>
                                                    ));
                                                })()}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                        
                                        {/* Platos del presupuesto (usar platos_ids del menu_personalizado) */}
                                        {(() => {
                                          const menuPers = presupuesto.menus_personalizados[item.personalizadoIndex];
                                          const platosIds = menuPers.platos_ids || [];
                                          const unidadesPorPlato = menuPers.unidades_por_plato || {};
                                          
                                          // Si el menú tiene platos_ids propios, usarlos
                                          if (platosIds.length > 0) {
                                            return platosIds.map((platoId, pIndex) => {
                                              const plato = platos.find(p => p.id === platoId);
                                              if (!plato || plato.activo === false) return null;
                                              const cantidad = unidadesPorPlato[platoId] || 1;
                                              
                                              return plato ? (
                                                <div key={pIndex} className="flex items-center justify-between text-sm bg-white px-4 py-3 rounded-lg border border-gray-200 hover:border-duetto-primary hover:shadow-sm transition">
                                                  <div className="flex items-center space-x-3 flex-1">
                                                    <span className="w-2 h-2 bg-duetto-primary rounded-full flex-shrink-0"></span>
                                                    <div className="flex-1 min-w-0">
                                                      <p className="font-medium text-gray-800">{plato.nombre}</p>
                                                      <p className="text-xs text-gray-500 mt-0.5">
                                                        Coste: €{(plato.coste_por_porcion || plato.coste_total || 0).toFixed(2)}/porción
                                                      </p>
                                                    </div>
                                                  </div>
                                                  <div className="flex items-center gap-3 ml-4">
                                                    {/* Input editable de cantidad */}
                                                    <div className="flex items-center bg-duetto-primary bg-opacity-10 rounded-full px-2 py-1">
                                                      <input
                                                        type="number"
                                                        value={typeof cantidad === 'number' ? +cantidad.toFixed(2) : cantidad}
                                                        min="0.01"
                                                        step="0.01"
                                                        onChange={async (e) => {
                                                          const nuevaCantidad = parseFloat(e.target.value);
                                                          if (nuevaCantidad > 0) {
                                                            try {
                                                              // Actualizar cantidad
                                                              avisoTrasCambioPlato(await presupuestosAPI.addPlatoToMenu(id, item.personalizadoIndex, {
                                                                plato_id: plato.id,
                                                                cantidad: nuevaCantidad
                                                              }));
                                                              await fetchData();
                                                            } catch (error) {
                                                              console.error('Error updating cantidad:', error);
                                                            }
                                                          }
                                                        }}
                                                        className="w-12 text-xs font-bold text-duetto-primary bg-transparent border-0 text-center focus:outline-none focus:ring-1 focus:ring-duetto-primary rounded"
                                                      />
                                                      <span className="text-xs text-duetto-primary ml-1">uds</span>
                                                    </div>
                                                    <button
                                                      onClick={async () => {
                                                        if (window.confirm(`¿Quitar "${plato.nombre}" del menú?`)) {
                                                          try {
                                                            avisoTrasCambioPlato(await presupuestosAPI.removePlatoFromMenu(id, item.personalizadoIndex, plato.id));
                                                            await fetchData();
                                                          } catch (error) {
                                                            console.error('Error removing plato:', error);
                                                            alert('Error al eliminar el plato');
                                                          }
                                                        }
                                                      }}
                                                      className="p-1.5 text-red-500 hover:bg-red-50 rounded transition"
                                                      title="Quitar plato"
                                                    >
                                                      <X className="w-4 h-4" />
                                                    </button>
                                                  </div>
                                                </div>
                                              ) : null;
                                            });
                                          }
                                          
                                          // Si no tiene platos_ids propios, mostrar del catálogo (solo lectura)
                                          else if (item.menu_data.platos && item.menu_data.platos.length > 0) {
                                            return (
                                              <>
                                                <div className="text-xs text-blue-600 bg-blue-50 px-3 py-2 rounded mb-2">
                                                  📋 Platos del menú original (añade para editar)
                                                </div>
                                                {item.menu_data.platos.map((platoItem, pIndex) => {
                                                  const plato = platos.find(p => p.id === platoItem.plato_id);
                                                  if (!plato || plato.activo === false) return null;
                                                  const cantidad = platoItem.cantidad || 1;
                                                  
                                                  return plato ? (
                                                    <div key={pIndex} className="flex items-center justify-between text-sm bg-gray-50 px-4 py-3 rounded-lg border border-gray-200 opacity-75">
                                                      <div className="flex items-center space-x-3 flex-1">
                                                        <span className="w-2 h-2 bg-gray-400 rounded-full flex-shrink-0"></span>
                                                        <div className="flex-1 min-w-0">
                                                          <p className="font-medium text-gray-700">{plato.nombre}</p>
                                                          <p className="text-xs text-gray-500 mt-0.5">
                                                            Coste: €{(plato.coste_por_porcion || plato.coste_total || 0).toFixed(2)}/porción
                                                          </p>
                                                        </div>
                                                      </div>
                                                      <span className="text-xs font-bold text-gray-500 bg-gray-200 px-3 py-1.5 rounded-full">
                                                        {cantidad} {cantidad === 1 ? 'ud' : 'uds'}
                                                      </span>
                                                    </div>
                                                  ) : null;
                                                })}
                                              </>
                                            );
                                          }
                                          
                                          return (
                                            <div className="text-sm text-gray-500 italic text-center py-4">
                                              No hay platos configurados. Usa el buscador para añadir.
                                            </div>
                                          );
                                        })()}
                                        
                                        {/* Subtotal de ingredientes/platos */}
                                        {(() => {
                                          const menuPers = presupuesto.menus_personalizados[item.personalizadoIndex];
                                          const platosIds = menuPers.platos_ids || [];
                                          const unidadesPorPlato = menuPers.unidades_por_plato || {};
                                          // Multievento (M-44): las personas de todas las jornadas
                                          const numPersonas = personasCosteMenu(menuPers) || presupuesto.num_personas || 1;

                                          let totalCostePlatos = 0;
                                          
                                          if (platosIds.length > 0) {
                                            platosIds.forEach(platoId => {
                                              const plato = platos.find(p => p.id === platoId);
                                              if (plato && plato.activo !== false) {
                                                const cantidad = unidadesPorPlato[platoId] || 1;
                                                const coste = (plato.coste_por_porcion || plato.coste_total || 0) * cantidad * numPersonas;
                                                totalCostePlatos += coste;
                                              }
                                            });
                                            
                                            return (
                                              <div className="mt-3 pt-3 border-t border-gray-300 flex justify-between items-center px-4 py-2 bg-gray-50 rounded-lg">
                                                <span className="text-sm text-gray-600">Subtotal Platos:</span>
                                                <span className="font-semibold text-gray-800">€{totalCostePlatos.toFixed(2)}</span>
                                              </div>
                                            );
                                          }
                                          
                                          return null;
                                        })()}
                                      </>
                                    )}
                                  </div>
                                  
                                  {/* Mostrar adaptaciones existentes para este menú */}
                                  {adaptaciones.filter(a => a.menu_id === item.id).length > 0 && (
                                    <div className="mt-3 p-3 bg-orange-50 border border-orange-200 rounded-lg">
                                      <p className="text-xs font-semibold text-orange-800 mb-2">⚠️ Adaptaciones Activas:</p>
                                      {adaptaciones.filter(a => a.menu_id === item.id).map((adapt, idx) => (
                                        <div key={idx} className="text-xs text-orange-700 mb-1">
                                          • {adapt.num_personas} personas - {(adapt.tipo || 'adaptación').replace('_', ' ')}
                                          {adapt.platos_sustitutos && Object.keys(adapt.platos_sustitutos).length > 0 && (
                                            <span className="ml-2">({Object.keys(adapt.platos_sustitutos).length} platos sustituidos)</span>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>

                              </div>
                            </td>
                          </tr>
                        )}

                        {/* Expanded Plato Details */}
                        {item.type === 'plato' && expandedPlatos[item.id] && item.plato_data && (
                          <tr>
                            <td colSpan={formatoNuevo ? 5 : 6} className="px-4 py-3 bg-duetto-yellow bg-opacity-5">
                              <div className="ml-12 space-y-2">
                                <p className="font-semibold text-sm text-gray-700 mb-2">Información del plato:</p>
                                <div className="grid grid-cols-3 gap-4">
                                  <div className="bg-white px-3 py-2 rounded-lg">
                                    <p className="text-xs text-gray-500">Tiempo preparación</p>
                                    <p className="text-sm font-semibold text-gray-900">{item.plato_data.tiempo_preparacion_min} min</p>
                                  </div>
                                  <div className="bg-white px-3 py-2 rounded-lg">
                                    <p className="text-xs text-gray-500">Coste unitario</p>
                                    <p className="text-sm font-semibold text-gray-900">€{item.plato_data.coste_total?.toFixed(2)}</p>
                                  </div>
                                  <div className="bg-white px-3 py-2 rounded-lg">
                                    <p className="text-xs text-gray-500">Ingredientes</p>
                                    <p className="text-sm font-semibold text-gray-900">{item.plato_data.ingredientes_ids?.length || 0} items</p>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                    
                    {/* === SUPLEMENTOS === */}
                    {presupuesto.suplementos && presupuesto.suplementos.length > 0 && (
                      <>
                        <tr className="bg-amber-50 border-t-2 border-amber-200">
                          <td colSpan={formatoNuevo ? 6 : 7} className="px-4 py-2 text-sm font-bold text-amber-800">
                            📌 Suplementos
                          </td>
                        </tr>
                        {presupuesto.suplementos.map((suplemento, idx) => {
                          const menuVinculado = presupuesto.menus_personalizados?.find(
                            m => m.menu_id === suplemento.menu_vinculado_id
                          );
                          const totalBruto = suplemento.total_bruto || (suplemento.precio_unitario * suplemento.unidades);
                          const descuento = suplemento.descuento || 0;
                          const tieneDescuento = descuento > 0;
                          return (
                            <tr key={suplemento.id} className={`border-b border-amber-100 ${suplemento.es_cortesia ? 'bg-green-50' : tieneDescuento ? 'bg-orange-50/50' : 'bg-amber-50/50'}`}>
                              <td className="px-4 py-3">
                                <div className="flex items-center gap-2">
                                  <span className="text-amber-600">📌</span>
                                  <div>
                                    <p className="font-medium text-gray-900 text-sm">
                                      {suplemento.nombre}
                                      <button
                                        type="button"
                                        onClick={() => (
                                          esConceptoClienteAbierto('suplemento', idx)
                                            ? cerrarConceptoCliente()
                                            : abrirConceptoCliente('suplemento', idx, suplemento.concepto_cliente)
                                        )}
                                        title="Concepto para mostrar solo en facturas y presupuestos"
                                        data-testid={`concepto-cliente-btn-suplemento-${idx}`}
                                        className="ml-2 align-middle text-gray-400 hover:text-duetto-primary transition-colors"
                                      >
                                        <Pencil className="w-3.5 h-3.5" />
                                      </button>
                                    </p>
                                    {/* Formato nuevo: los suplementos no van vinculados a ningún servicio */}
                                    {!formatoNuevo && (
                                    <p className="text-xs text-gray-500">
                                      Vinculado a: {suplemento.menu_vinculado_nombre || menuVinculado?.nombre_menu || 'N/A'}
                                    </p>
                                    )}
                                    {suplemento.concepto_cliente && (
                                      <p className="text-xs text-violet-700 mt-0.5">
                                        En factura/presupuesto: "{suplemento.concepto_cliente}"
                                      </p>
                                    )}
                                    {tieneDescuento && !suplemento.es_cortesia && (
                                      <p className="text-xs text-orange-600 font-medium mt-0.5">
                                        Descuento: -€{descuento.toFixed(2)}
                                      </p>
                                    )}
                                    {renderEditorConceptoCliente('suplemento', idx, suplemento.concepto_cliente)}
                                  </div>
                                </div>
                              </td>
                              <td className="px-4 py-3 text-center text-sm text-gray-700">{numeroEs(suplemento.unidades, 2)}</td>
                              <td className="px-4 py-3 text-center text-sm text-gray-700">€{suplemento.precio_unitario.toFixed(2)}</td>
                              <td className="px-4 py-3 text-center text-sm text-gray-700">{tipoIvaDe(suplemento, CAMPOS_IVA_SUPLEMENTO)}%</td>
                              <td className="px-4 py-3 text-center">
                                <button
                                  onClick={() => handleToggleCortesiaSuplemento(suplemento.id)}
                                  className={`px-2 py-1 text-xs rounded-full font-medium transition-colors ${
                                    suplemento.es_cortesia
                                      ? 'bg-green-100 text-green-700 hover:bg-green-200'
                                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                  }`}
                                  title={suplemento.es_cortesia ? 'Quitar cortesía' : 'Aplicar cortesía'}
                                >
                                  {suplemento.es_cortesia ? '🎁 Cortesía' : 'Sin cortesía'}
                                </button>
                              </td>
                              <td className="px-4 py-3 text-right">
                                {suplemento.es_cortesia ? (
                                  <div>
                                    <span className="text-gray-400 line-through text-sm">€{totalBruto.toFixed(2)}</span>
                                    <span className="text-green-600 font-bold ml-2">€0.00</span>
                                  </div>
                                ) : tieneDescuento ? (
                                  <div>
                                    <span className="text-gray-400 line-through text-xs">€{totalBruto.toFixed(2)}</span>
                                    <span className="font-bold text-gray-900 ml-1">€{suplemento.total.toFixed(2)}</span>
                                  </div>
                                ) : (
                                  <span className="font-bold text-gray-900">€{suplemento.total.toFixed(2)}</span>
                                )}
                              </td>
                              <td className="px-4 py-3 text-center">
                                <button
                                  onClick={() => handleDeleteSuplemento(suplemento.id)}
                                  className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                                  title="Eliminar suplemento"
                                >
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    )}
                  </tbody>
                  
                  {/* Totals */}
                  <tfoot className="bg-gradient-to-r from-gray-50 to-gray-100 border-t-2 border-gray-300">
                    <tr>
                      <td colSpan={formatoNuevo ? 4 : 5} className="px-4 py-3 text-right text-sm font-semibold text-gray-700">Subtotal (sin IVA)</td>
                      <td className="px-4 py-3 text-right text-base font-bold text-gray-900">€{basePresupuesto().toFixed(2)}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colSpan={formatoNuevo ? 4 : 5} className="px-4 py-2 text-right text-sm font-semibold text-gray-700">IVA Total</td>
                      <td className="px-4 py-2 text-right text-base font-bold text-gray-900">€{ivaPresupuesto().toFixed(2)}</td>
                      <td></td>
                    </tr>
                    <tr className="border-t-2 border-gray-300">
                      <td colSpan={formatoNuevo ? 4 : 5} className="px-4 py-4 text-right text-lg font-bold text-gray-900">TOTAL A PAGAR</td>
                      <td className="px-4 py-4 text-right text-2xl font-bold text-duetto-primary">€{totalPresupuesto().toFixed(2)}</td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              {renderAvisoLineasCongeladas()}

              {/* Reglas comerciales: suplemento mínimo, errores y recomendación de cóctel (formato nuevo) */}
              {formatoNuevo && (renderAvisoSuplementoMinimo() || renderAvisoHoraExtraLunch() || avisoSuplementoMinimo || renderRecomendacionCoctel()) && (
                <div className="mt-4 space-y-2">
                  {renderAvisoSuplementoMinimo()}
                  {renderAvisoHoraExtraLunch()}
                  {avisoSuplementoMinimo && (
                    <p className="text-xs text-red-700">{avisoSuplementoMinimo}</p>
                  )}
                  {renderRecomendacionCoctel()}
                </div>
              )}

              {/* Add Item Button (en la tabla compacta van arriba, pequeños) */}
              {!compacta && <div className="mt-6">
                <div className="flex gap-2">
                  <button 
                    onClick={() => setShowAddMenuModal(true)}
                    className="flex-1 px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-duetto-primary hover:text-duetto-primary hover:bg-duetto-primary hover:bg-opacity-5 transition-all flex items-center justify-center space-x-2 font-medium">
                    <Plus className="w-5 h-5" />
                    <span>Añadir Menú Existente</span>
                  </button>
                  <button 
                    onClick={handleOpenCustomMenuModal}
                    className="flex-1 px-4 py-3 border-2 border-dashed border-duetto-secondary rounded-lg text-duetto-secondary hover:border-duetto-secondary hover:bg-duetto-secondary hover:bg-opacity-10 transition-all flex items-center justify-center space-x-2 font-medium">
                    <Plus className="w-5 h-5" />
                    <span>Crear Menú Personalizado</span>
                  </button>
                  <button 
                    onClick={() => setShowAddSuplementoModal(true)}
                    className="flex-1 px-4 py-3 border-2 border-dashed border-amber-500 rounded-lg text-amber-600 hover:border-amber-600 hover:bg-amber-50 transition-all flex items-center justify-center space-x-2 font-medium">
                    <Plus className="w-5 h-5" />
                    <span>Añadir Suplemento</span>
                  </button>
                </div>
              </div>}
            </div>
          </div>
  );

  const renderCabeceraContacto = () => (
      <>
              <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center justify-between">
                Información de Contacto
                <button
                  onClick={() => setShowNewContactoModal(true)}
                  className="px-3 py-1 bg-duetto-primary text-white text-xs rounded-lg hover:bg-opacity-90 flex items-center gap-1"
                >
                  <Plus className="w-3 h-3" />
                  Nuevo Contacto
                </button>
              </h3>

              {!presupuesto.persona_contacto_id && (
                <div className="mb-4 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
                  ⚠️ Falta asignar el contacto del evento. Selecciónalo abajo para evitar
                  contactar o facturar a la persona equivocada.
                </div>
              )}
      </>
  );

  const renderContactoEvento = () => (
              <div className="mb-4 pb-4 border-b border-gray-200">
                <label className="block text-xs font-semibold text-gray-700 mb-2">
                  👤 Contacto del Evento (Obligatorio)
                </label>
                <select
                  value={presupuesto.persona_contacto_id || ''}
                  onChange={(e) => handleUpdateContacto('persona_contacto_id', e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                >
                  <option value="">-- Selecciona persona de contacto --</option>
                  {/* Contacto principal del cliente - SIEMPRE mostrar si hay email o teléfono */}
                  {cliente && (cliente.email || cliente.telefono) && (
                    <option value="principal">
                      {cliente.persona_contacto || cliente.nombre_empresa || 'Contacto Principal'} (Contacto Principal)
                    </option>
                  )}
                  {/* Contactos adicionales */}
                  {[...personasContacto].sort((a, b) => a.nombre.localeCompare(b.nombre)).map(persona => (
                    <option key={persona.id} value={persona.id}>
                      {persona.nombre}{persona.cargo ? ` - ${persona.cargo}` : ''}
                    </option>
                  ))}
                </select>
                {presupuesto.persona_contacto_id && (
                  <div className="mt-2 space-y-1">
                    {(() => {
                      // Si es "principal", usar datos del cliente
                      if (presupuesto.persona_contacto_id === 'principal' && cliente) {
                        return (
                          <>
                            {cliente.persona_contacto && (
                              <div className="flex items-center text-xs text-gray-600">
                                <span className="font-semibold mr-2">👤</span>
                                {cliente.persona_contacto}
                              </div>
                            )}
                            {cliente.telefono && (
                              <div className="flex items-center text-xs text-gray-600">
                                <Phone className="w-3 h-3 mr-2" />
                                {cliente.telefono}
                              </div>
                            )}
                            {cliente.email && (
                              <div className="flex items-center text-xs text-gray-600">
                                <Mail className="w-3 h-3 mr-2" />
                                {cliente.email}
                              </div>
                            )}
                          </>
                        );
                      }
                      // Si no, buscar en personas de contacto
                      const persona = personasContacto.find(p => p.id === presupuesto.persona_contacto_id);
                      return persona ? (
                        <>
                          <div className="flex items-center text-xs text-gray-600">
                            <span className="font-semibold mr-2">👤</span>
                            {persona.nombre}{persona.cargo ? ` - ${persona.cargo}` : ''}
                          </div>
                          {persona.telefono && (
                            <div className="flex items-center text-xs text-gray-600">
                              <Phone className="w-3 h-3 mr-2" />
                              {persona.telefono}
                            </div>
                          )}
                          {persona.email && (
                            <div className="flex items-center text-xs text-gray-600">
                              <Mail className="w-3 h-3 mr-2" />
                              {persona.email}
                            </div>
                          )}
                        </>
                      ) : null;
                    })()}
                  </div>
                )}
                <p className="text-xs text-gray-500 mt-1">
                  ℹ️ Persona que estará presente en el evento
                </p>
              </div>
  );

  const renderContactoFacturacion = () => (
              <div className="mb-4">
                <label className="block text-xs font-semibold text-gray-700 mb-2">
                  📄 Contacto de Facturación
                </label>
                <select
                  value={presupuesto.contacto_facturacion_id || ''}
                  onChange={(e) => handleUpdateContacto('contacto_facturacion_id', e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                >
                  <option value="">-- Mismo que contacto del evento --</option>
                  {/* Contacto principal del cliente - SIEMPRE mostrar si hay email */}
                  {cliente && cliente.email && (
                    <option value="principal">
                      {cliente.persona_contacto || cliente.nombre_empresa || 'Contacto Principal'} (Contacto Principal)
                    </option>
                  )}
                  {/* Contactos adicionales */}
                  {[...personasContacto].sort((a, b) => a.nombre.localeCompare(b.nombre)).map(persona => (
                    <option key={persona.id} value={persona.id}>
                      {persona.nombre}{persona.cargo ? ` - ${persona.cargo}` : ''}
                    </option>
                  ))}
                </select>
                {presupuesto.contacto_facturacion_id && (
                  <div className="mt-2 space-y-1">
                    {(() => {
                      // Si es "principal", usar datos del cliente
                      if (presupuesto.contacto_facturacion_id === 'principal' && cliente) {
                        return (
                          <>
                            {cliente.persona_contacto && (
                              <div className="flex items-center text-xs text-gray-600">
                                <span className="font-semibold mr-2">👤</span>
                                {cliente.persona_contacto}
                              </div>
                            )}
                            {cliente.email && (
                              <div className="flex items-center text-xs text-gray-600">
                                <Mail className="w-3 h-3 mr-2" />
                                {cliente.email}
                              </div>
                            )}
                          </>
                        );
                      }
                      // Si no, buscar en personas de contacto
                      const persona = personasContacto.find(p => p.id === presupuesto.contacto_facturacion_id);
                      return persona ? (
                        <>
                          <div className="flex items-center text-xs text-gray-600">
                            <span className="font-semibold mr-2">👤</span>
                            {persona.nombre}{persona.cargo ? ` - ${persona.cargo}` : ''}
                          </div>
                          {persona.email && (
                            <div className="flex items-center text-xs text-gray-600">
                              <Mail className="w-3 h-3 mr-2" />
                              {persona.email}
                            </div>
                          )}
                        </>
                      ) : null;
                    })()}
                  </div>
                )}
                <p className="text-xs text-gray-500 mt-1">
                  ℹ️ A quien se enviará la factura
                </p>
              </div>
  );

  // Modo de facturación multievento y factura por jornada. La facturación por
  // rango se retiró el 04-oct-2026 (no sumaba suplementos ni alquiler y nadie
  // la usaba). Con facturas emitidas el modo no se cambia: se facturaría dos
  // veces el mismo evento (el servidor también lo rechaza).
  const renderFacturacionMultievento = () => {
    if (!presupuesto.es_multi_evento) return null;
    const modoActual = presupuesto.facturacion_multi_evento || 'consolidada';
    const modoBloqueado = !!datosFacturacionJornadas?.modo_bloqueado;
    const eur = (v) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(Number(v) || 0);
    const fechaCorta = (v) => {
      const t = String(v || '').slice(0, 10);
      return /^\d{4}-\d{2}-\d{2}$/.test(t) ? `${t.slice(8, 10)}/${t.slice(5, 7)}/${t.slice(0, 4)}` : '';
    };
    const cambiarModo = async (modo) => {
      if (modoBloqueado || modo === modoActual) return;
      // Formato nuevo: por la cola del autoguardado
      if (formatoNuevo) {
        guardarFicha({ facturacion_multi_evento: modo })
          .then(r => aplicarRespuestaGuardado(r, prev => ({ ...prev, facturacion_multi_evento: modo })))
          .catch(() => {});
        return;
      }
      try {
        notificarGuardado('inicio');
        const respuesta = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/presupuestos/${presupuesto.id}`,
          {
            method: 'PUT',
            headers: {
              'Authorization': `Bearer ${getAuthToken()}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ facturacion_multi_evento: modo })
          }
        );
        if (!respuesta.ok) {
          const error = await respuesta.json().catch(() => ({}));
          notificarGuardado('error');
          alert(error.detail || 'No se ha podido cambiar el modo de facturación');
          return;
        }
        setPresupuesto(prev => ({ ...prev, facturacion_multi_evento: modo }));
        notificarGuardado('fin');
      } catch (e) { console.error(e); notificarGuardado('error'); }
    };
    const opciones = [
      { valor: 'consolidada', titulo: 'Factura consolidada', texto: 'Una única factura por todo el evento multi-día' },
      { valor: 'por_jornada', titulo: 'Facturas por jornada', texto: 'Una factura independiente por cada día/jornada' },
    ];
    const dias = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
    const filas = (presupuesto.jornadas || []).filter(j => j && j.id).map((j) => {
      // Datos del servidor (facturacion-jornadas); si aún no han llegado, la
      // marca que deja en la jornada la emisión de su factura
      const fj = facturacionDeJornada(j.id);
      const factura = fj ? fj.factura : null;
      const yaFacturada = fj ? !!factura : !!(j.numero_factura || j.facturada);
      return {
        jornada: j,
        fj,
        factura,
        yaFacturada,
        numero: factura?.numero_factura || j.numero_factura,
        facturaId: factura?.id || j.factura_id,
        fechaFactura: factura?.fecha_emision || j.fecha_factura,
        // Antes de emitir, lo que saldrá su factura (con sus suplementos y, en
        // la primera, los del evento y el alquiler); después, la factura real
        importe: factura ? factura.total : (fj ? fj.total_previsto : null),
      };
    });
    return (
                <div className="mb-4 p-3 bg-indigo-50 border border-indigo-200 rounded-lg">
                  <label className="block text-xs font-semibold text-indigo-700 mb-2">
                    Modo de facturación multievento
                  </label>
                  {modoBloqueado && (
                    <p className="text-xs text-indigo-800 mb-2" data-testid="modo-facturacion-bloqueado">
                      Hay facturas emitidas: el modo no se cambia.
                    </p>
                  )}
                  {modoActual === 'por_rango' && (
                    <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded px-2 py-1 mb-2">
                      La facturación por rango se retiró: elige consolidada o por jornada.
                    </p>
                  )}
                  <div className="space-y-2">
                    {opciones.map(op => (
                      <label key={op.valor} className={`flex items-start space-x-2 ${modoBloqueado ? 'cursor-not-allowed opacity-70' : 'cursor-pointer'}`}>
                        <input
                          type="radio"
                          name="facturacion_multi"
                          checked={modoActual === op.valor}
                          disabled={modoBloqueado}
                          onChange={() => cambiarModo(op.valor)}
                          className="mt-0.5 text-indigo-600"
                        />
                        <div>
                          <span className="text-sm font-medium text-gray-900">{op.titulo}</span>
                          <p className="text-xs text-gray-500">{op.texto}</p>
                        </div>
                      </label>
                    ))}
                  </div>

                  {modoActual === 'por_jornada' && (
                    <div className="mt-3 pt-3 border-t border-indigo-200">
                      <p className="text-xs text-indigo-700 mb-2">
                        Emite cada jornada por separado. {filas.filter(f => f.yaFacturada).length}/{filas.length} facturadas.
                      </p>
                      {presupuesto.estado !== 'confirmado' && (
                        <p className="text-xs text-orange-600 mb-2">
                          Confirma el presupuesto para poder emitir las facturas.
                        </p>
                      )}
                      <div className="space-y-1">
                        {filas.map(({ jornada: j, fj, factura, yaFacturada, numero, facturaId, fechaFactura, importe }) => {
                          const fecha = new Date(j.fecha);
                          return (
                            <div key={j.id} className="text-xs bg-white rounded px-2 py-1.5" data-testid={`factura-jornada-${j.id}`}>
                              <div className="flex items-center justify-between gap-2 max-md:flex-wrap max-md:text-[13px]">
                                <span className="text-gray-700 whitespace-nowrap">
                                  {dias[fecha.getUTCDay()]} {fecha.getUTCDate()}/{fecha.getUTCMonth()+1}
                                </span>
                                <span className="font-medium text-gray-900 flex-1 text-right" title={yaFacturada ? 'Total de la factura emitida' : 'Total previsto de su factura'}>
                                  {importe != null ? eur(importe) : '-'}
                                </span>
                                {yaFacturada ? (
                                  <span className="flex items-center gap-1 whitespace-nowrap">
                                    <span className="px-2 py-0.5 rounded bg-green-100 text-green-700 font-medium">
                                      {numero || 'Facturada'}
                                      {fechaCorta(fechaFactura) ? ` · ${fechaCorta(fechaFactura)}` : ''}
                                    </span>
                                    {factura?.cobrada && (
                                      <span className="px-2 py-0.5 rounded bg-[#E3F3EC] text-[#0F5E43] font-medium">Cobrada</span>
                                    )}
                                    {facturaId && (
                                      <button
                                        type="button"
                                        onClick={() => descargarFacturaJornadaPDF(facturaId, numero)}
                                        title="Descargar PDF de la factura"
                                        className="px-1.5 py-0.5 rounded bg-blue-100 text-blue-700 hover:bg-blue-200 font-medium"
                                      >
                                        PDF
                                      </button>
                                    )}
                                  </span>
                                ) : (
                                  <button
                                    type="button"
                                    onClick={() => abrirModalFacturaJornada(j)}
                                    disabled={presupuesto.estado !== 'confirmado'}
                                    className="px-2 py-0.5 rounded bg-duetto-primary text-white font-medium whitespace-nowrap hover:bg-duetto-primary-dark disabled:opacity-50 disabled:cursor-not-allowed"
                                  >
                                    Emitir factura…
                                  </button>
                                )}
                              </div>
                              {!yaFacturada && fj?.incluye_suplementos_raiz && (
                                <p className="text-[11px] text-indigo-700 mt-0.5 text-right">
                                  Incluye los suplementos del evento y el alquiler
                                </p>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
    );
  };

  // Lugar con Google y transporte
  const renderLugarYTransporte = () => (
              <div className="space-y-2">
                <div className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-gray-400 mt-0.5" />
                  <div className="flex-1">
                    <p className="text-xs text-gray-500 mb-1">Lugar del evento</p>
                    <DireccionAutocomplete
                      id="address-autocomplete"
                      value={presupuesto.lugar_evento || ''}
                      onChange={(lugar) => setPresupuesto(prev => ({ ...prev, lugar_evento: lugar }))}
                      onSelect={seleccionarLugarEvento}
                      placeholder="Busca el lugar o la dirección..."
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                    />
                    {presupuesto.direccion_exacta && (
                      <p className="text-xs text-gray-600 mt-1">
                        📍 {presupuesto.direccion_exacta}
                      </p>
                    )}
                    {avisoSinRuta && (
                      <div className="mt-2 px-3 py-2 bg-yellow-50 border border-yellow-200 rounded-lg flex flex-wrap items-center justify-between gap-2">
                        <p className="text-xs text-yellow-800 font-medium">
                          {calculandoRuta
                            ? 'Calculando la ruta desde la nave con la dirección guardada...'
                            : avisoSinRuta}
                        </p>
                        {!calculandoRuta && (
                          <button
                            type="button"
                            onClick={() => calcularRutaGuardada()}
                            className="px-2.5 py-1 text-xs font-medium bg-white border border-yellow-300 text-yellow-900 rounded-lg hover:bg-yellow-100"
                          >
                            Calcular ruta
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                
                {/* Información de Transporte */}
                {presupuesto.distancia_km && (
                  <div className="ml-8 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-xs font-semibold text-blue-900 mb-2">🚗 Información de Transporte</p>
                    <div className="grid grid-cols-2 gap-2 text-xs text-blue-800">
                      <div>
                        <span className="font-medium">Distancia (ida y vuelta):</span>
                        <br />
                        <span className="text-sm font-bold">{(parseFloat(presupuesto.distancia_km) * 2).toFixed(2)} km</span>
                      </div>
                      <div>
                        <span className="font-medium">Tiempo (ida y vuelta):</span>
                        <br />
                        <span className="text-sm font-bold">{(parseInt(presupuesto.tiempo_viaje_min) * 2)} min</span>
                      </div>
                      <div className="col-span-2 border-t border-blue-300 pt-2 mt-1">
                        <span className="font-medium">Coste Personal (ida y vuelta):</span>
                        <br />
                        {/* Tarifa según quién va al evento (propio o extra; sin elegir, equipo
                            propio). Mismo cálculo que el backend y el botón "Añadir transporte". */}
                        {reglasComerciales ? (() => {
                          const minutosIV = (parseInt(presupuesto.tiempo_viaje_min, 10) || 0) * 2;
                          const tarifa = tarifaTransportePersonal(presupuesto.quien_va_evento?.modo, reglasComerciales);
                          return (
                            <>
                              <span className="text-sm font-bold">{formatEuros(Math.round(minutosIV * tarifa.tarifaHora / 60 * 100) / 100)}</span>
                              <span className="text-xs ml-1">({minutosIV} min × {formatEuros(tarifa.tarifaMinuto)}/min, {tarifa.etiqueta})</span>
                            </>
                          );
                        })() : (
                          <span className="text-sm font-bold">...</span>
                        )}
                      </div>
                      <div className="col-span-2 border-t border-blue-300 pt-2">
                        <span className="font-medium">Coste Combustible/Desgaste:</span>
                        <br />
                        {formatoNuevo ? (
                          <>
                            <span className="text-sm font-bold">
                              {estadoReglas?.transporte?.coste_combustible != null ? formatEuros(estadoReglas.transporte.coste_combustible) : '...'}
                            </span>
                            {estadoReglas?.transporte?.combustible ? (
                              <DetalleCombustible combustible={estadoReglas.transporte.combustible} />
                            ) : reglasComerciales?.transporte && (
                              <span className="text-xs ml-1">({(parseFloat(presupuesto.distancia_km) * 2).toFixed(2)} km × {formatEuros(reglasComerciales.transporte.coste_km)}/km)</span>
                            )}
                          </>
                        ) : (
                          <>
                            <span className="text-sm font-bold">
                              €{((parseFloat(presupuesto.distancia_km) * 2) * 0.10).toFixed(2)}
                            </span>
                            <span className="text-xs ml-1">({(parseFloat(presupuesto.distancia_km) * 2).toFixed(2)} km × €10/100km)</span>
                          </>
                        )}
                      </div>
                      <div className="col-span-2 border-t border-blue-300 pt-2 bg-blue-100 rounded p-2">
                        <span className="font-bold text-blue-900">COSTE TOTAL TRANSPORTE:</span>
                        <br />
                        <span className="text-lg font-bold text-blue-900">
                          {formatEuros(presupuesto.coste_transporte)}
                        </span>
                        {formatoNuevo && (
                          <p className="text-xs text-blue-800 mt-1" data-testid="transporte-nota-costes">
                            En el Resumen de costes, el tiempo de ida y vuelta va en el responsable del montaje y aquí solo cuentan el combustible y el desgaste.
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Transporte por zonas: gratis en Madrid capital y noroeste; fuera, tramos de 10 € (formato nuevo) */}
                {formatoNuevo && (
                <div className="ml-8 mt-2" data-testid="transporte-zona">
                  <div className="flex flex-wrap items-center gap-2">
                    <button
                      type="button"
                      onClick={handleAnadirTransporte}
                      disabled={!!accionReglaEnCurso}
                      className="px-3 py-1.5 text-xs font-medium bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                    >
                      {accionReglaEnCurso === 'transporte' ? 'Calculando...' : 'Añadir transporte'}
                    </button>
                    {estadoReglas?.transporte && (() => {
                      const t = estadoReglas.transporte;
                      if (!t.disponible) {
                        return <span className="text-xs text-amber-700">{t.motivo}</span>;
                      }
                      const municipio = t.municipio
                        ? `${t.municipio}${t.confianza === 'baja' ? ' (revisa la dirección)' : ''}`
                        : 'municipio no detectado';
                      return (
                        <span className="text-xs text-gray-600">
                          {t.zona_gratuita
                            ? `${municipio}: zona gratuita`
                            : `${municipio}: zona ${t.zona} (${formatEuros(t.importe)}, coste ida y vuelta ${formatEuros(t.coste_total)})`}
                          {t.linea ? ` · En el presupuesto: "${t.linea.nombre}" ${formatEuros(t.linea.total)}` : ''}
                        </span>
                      );
                    })()}
                  </div>
                  {avisoTransporte && (
                    <p className={`text-xs mt-1 ${avisoTransporte.tipo === 'error' ? 'text-red-700' : 'text-green-700'}`}>
                      {avisoTransporte.texto}
                    </p>
                  )}
                  {estadoReglas?.transporte?.multievento && (
                    <p className="text-xs text-gray-500 mt-1">
                      Multievento: el transporte se calcula con la dirección principal. Si alguna jornada es en otro sitio, revísalo a mano.
                    </p>
                  )}
                </div>
                )}
              </div>
  );

  // Observaciones del evento
  const renderObservaciones = () => (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Observaciones del evento</label>
                      <textarea
                        value={presupuesto.observaciones || ''}
                        onChange={(e) => setPresupuesto({ ...presupuesto, observaciones: e.target.value })}
                        className="w-full h-32 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-duetto-primary resize-none"
                        placeholder="Observaciones del evento..."
                      />
                    </div>
  );

  // Notas para administración (facturación)
  const renderNotasAdministracion = () => (
                    <div>
                      <label className="flex items-center gap-1 text-sm font-medium text-amber-700 mb-1">
                        <AlertCircle className="w-4 h-4" />
                        Notas para administración (facturación)
                      </label>
                      <textarea
                        value={presupuesto.notas_administracion || ''}
                        onChange={(e) => setPresupuesto({ ...presupuesto, notas_administracion: e.target.value })}
                        className="w-full h-32 px-3 py-2 text-sm border border-amber-300 bg-amber-50 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-400 resize-none"
                        placeholder="Indicaciones para quien haga la factura: ej. factura en inglés, no desglosar el transporte (incluirlo en el precio), observación concreta a añadir, etc."
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Notas internas. Aparecerán resaltadas en el modal de factura al descargar o enviar.
                      </p>
                    </div>
  );

  // Personal asignado y orden de personal extra
  const renderPersonal = () => (
                  <div className="space-y-4">
                    {formatoNuevo && renderRecomendacionCoctel(true)}
                    <PersonalAsignado
                      presupuestoId={presupuesto?.id}
                      presupuestoNumero={presupuesto?.numero}
                      personalActual={presupuesto?.personal_asignado || []}
                      onUpdate={(nuevoPersonal) => {
                        setPresupuesto(prev => ({ ...prev, personal_asignado: nuevoPersonal }));
                      }}
                      inTab={true}
                      onGuardado={formatoNuevo ? notificarGuardadoHijo : undefined}
                      variante={formatoNuevo ? 'nuevo' : undefined}
                      encolar={formatoNuevo ? encolarGuardado : undefined}
                    />

                    {/* Orden de personal extra: una sola, también en multievento
                        (con un bloque por jornada dentro de la orden) */}
                    <OrdenPersonalExtra
                      presupuesto={presupuesto}
                      onUpdate={(campos) => setPresupuesto(prev => ({ ...prev, ...campos }))}
                    />
                  </div>
  );

  const renderFurgonetas = () => (
                  <VehiculosAsignados 
                    presupuestoId={presupuesto?.id}
                    presupuestoNumero={presupuesto?.numero}
                    fechaEvento={presupuesto?.fecha_evento}
                    jornadas={esMultievento(presupuesto) ? presupuesto.jornadas : undefined}
                    vehiculosActuales={presupuesto?.vehiculos_asignados || []}
                    onUpdate={(nuevosVehiculos) => {
                      setPresupuesto(prev => ({ ...prev, vehiculos_asignados: nuevosVehiculos }));
                    }}
                    inTab={true}
                    onGuardado={formatoNuevo ? notificarGuardadoHijo : undefined}
                  />
  );

  const renderBebidasPersonalizadas = () => (
                  <BebidasAsignadas
                    presupuestoId={presupuesto?.id}
                    recargar={presupuesto?.rev}
                    presupuestoNumero={presupuesto?.numero}
                    bebidasActuales={presupuesto?.bebidas || []}
                    bebidasConfirmadas={presupuesto?.bebidas_confirmadas || false}
                    onUpdate={(datosBebidas) => {
                      setPresupuesto(prev => ({
                        ...prev,
                        bebidas: datosBebidas.bebidas,
                        bebidas_confirmadas: datosBebidas.bebidas_confirmadas,
                        total_suplemento_bebidas: datosBebidas.total_suplemento_bebidas,
                        total_bebidas_extra: datosBebidas.total_bebidas_extra,
                        coste_bebidas: datosBebidas.coste_bebidas,
                        ...(datosBebidas.nuevo_importe_total !== undefined && {
                          importe_total: datosBebidas.nuevo_importe_total
                        })
                      }));
                      // Formato nuevo: el modo y su validación dependen de las
                      // bebidas personalizadas confirmadas
                      if (formatoNuevo) cargarBebidasModo();
                      // D9: las bebidas con importe son líneas del presupuesto (y
                      // cambian la versión): se recarga para verlas en Líneas y menús
                      fetchData();
                    }}
                    inTab={true}
                  />
  );

  // Formato nuevo: modo de bebidas (variado o personalizado) con validación;
  // en personalizado va debajo el bloque de bebidas por menú de siempre.
  // Formato anterior: solo el bloque de bebidas personalizadas, como antes.
  const renderBebidas = () => (formatoNuevo ? (
    <BebidasModo
      presupuestoId={presupuesto?.id}
      estado={estadoBebidasModo}
      cargando={cargandoBebidasModo}
      onCambio={(data) => {
        if (data && data.modo) setEstadoBebidasModo(data);
        cargarBebidasModo();
      }}
      onEstadoGuardado={notificarGuardadoHijo}
    >
      {renderBebidasPersonalizadas()}
    </BebidasModo>
  ) : renderBebidasPersonalizadas());

  // Material de alquiler
  const renderAlquiler = () => (
                  <div className="space-y-4" data-testid="tab-alquiler-content">
                    {/* Header */}
                    <div>
                      <h3 className="text-lg font-bold text-purple-900">Material de Alquiler</h3>
                      <p className="text-sm text-gray-500">Material alquilado a proveedores externos para este evento</p>
                    </div>

                    {/* Lista de materiales de alquiler asignados */}
                    {(presupuesto.materiales_alquiler || []).length > 0 ? (
                      <div className="space-y-2">
                        {(presupuesto.materiales_alquiler || []).map((item, idx) => {
                          const dias = item.dias || 1;
                          const precioAlquiler = (item.precio_dia1 || 0) + Math.max(0, dias - 1) * (item.precio_dia_extra || 0);
                          const costeLimpieza = item.coste_limpieza || 0;
                          const totalItem = (precioAlquiler + costeLimpieza) * (item.cantidad || 0);
                          
                          return (
                            <div key={idx} className="bg-purple-50 border border-purple-200 rounded-lg p-3" data-testid={`alquiler-item-${idx}`}>
                              <div className="flex items-center justify-between">
                                <div className="flex-1">
                                  <p className="font-semibold text-purple-900">{item.nombre}</p>
                                  {item.proveedor && <p className="text-xs text-purple-600">{item.proveedor}</p>}
                                </div>
                                <button
                                  onClick={() => {
                                    const updated = [...(presupuesto.materiales_alquiler || [])];
                                    updated.splice(idx, 1);
                                    guardarMaterialesAlquilerAnterior(updated);
                                    setPresupuesto(prev => ({ ...prev, materiales_alquiler: updated }));
                                  }}
                                  className="text-red-400 hover:text-red-600 ml-2"
                                  title="Eliminar"
                                >
                                  <X className="w-4 h-4" />
                                </button>
                              </div>
                              <div className="grid grid-cols-3 gap-2 mt-2">
                                <div>
                                  <label className="text-xs text-gray-500">Cantidad</label>
                                  <input
                                    type="number" min="1" value={item.cantidad || 1}
                                    onChange={(e) => {
                                      const updated = [...(presupuesto.materiales_alquiler || [])];
                                      updated[idx] = { ...updated[idx], cantidad: parseInt(e.target.value) || 1 };
                                      setPresupuesto(prev => ({ ...prev, materiales_alquiler: updated }));
                                    }}
                                    onBlur={() => guardarMaterialesAlquilerAnterior(presupuesto.materiales_alquiler)}
                                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                    data-testid={`alquiler-cantidad-${idx}`}
                                  />
                                </div>
                                <div>
                                  <label className="text-xs text-gray-500">Días</label>
                                  <input
                                    type="number" min="1" value={item.dias || 1}
                                    onChange={(e) => {
                                      const updated = [...(presupuesto.materiales_alquiler || [])];
                                      updated[idx] = { ...updated[idx], dias: parseInt(e.target.value) || 1 };
                                      setPresupuesto(prev => ({ ...prev, materiales_alquiler: updated }));
                                    }}
                                    onBlur={() => guardarMaterialesAlquilerAnterior(presupuesto.materiales_alquiler)}
                                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                    data-testid={`alquiler-dias-${idx}`}
                                  />
                                </div>
                                <div className="text-right">
                                  <label className="text-xs text-gray-500">Total</label>
                                  <p className="font-bold text-purple-800">{totalItem.toFixed(2)}€</p>
                                </div>
                              </div>
                              <div className="text-xs text-gray-500 mt-1">
                                Alquiler: {precioAlquiler.toFixed(2)}€/ud ({item.precio_dia1}€ día 1{dias > 1 ? ` + ${(dias-1)}x${item.precio_dia_extra}€` : ''})
                                {costeLimpieza > 0 && ` + Limpieza: ${costeLimpieza.toFixed(2)}€/ud`}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center py-6 text-gray-400 border-2 border-dashed border-gray-200 rounded-lg">
                        <p>No hay material de alquiler asignado</p>
                        <p className="text-xs mt-1">Añade material del catálogo de alquiler</p>
                      </div>
                    )}

                    {/* Selector de material para añadir */}
                    <div className="bg-white border border-purple-300 rounded-lg p-3">
                      <label className="text-sm font-semibold text-purple-800 mb-2 block">Añadir material de alquiler</label>
                      {materialesAlquilerCatalogo.length > 0 ? (
                        <div className="grid grid-cols-1 gap-2 max-h-48 overflow-y-auto">
                          {materialesAlquilerCatalogo
                            .filter(m => !(presupuesto.materiales_alquiler || []).find(a => a.material_id === m.id))
                            .map(mat => (
                              <button
                                key={mat.id}
                                onClick={() => {
                                  const nuevoItem = {
                                    material_id: mat.id,
                                    nombre: mat.nombre,
                                    cantidad: 1,
                                    dias: 1,
                                    precio_dia1: mat.precio_alquiler_dia1 || 0,
                                    precio_dia_extra: mat.precio_alquiler_dia_extra || 0,
                                    coste_limpieza: mat.coste_limpieza || 0,
                                    proveedor: mat.proveedor_alquiler_nombre || ''
                                  };
                                  const updated = [...(presupuesto.materiales_alquiler || []), nuevoItem];
                                  guardarMaterialesAlquilerAnterior(updated);
                                  setPresupuesto(prev => ({ ...prev, materiales_alquiler: updated }));
                                }}
                                className="flex items-center justify-between p-2 bg-gray-50 hover:bg-purple-50 rounded border border-gray-200 hover:border-purple-300 transition-colors text-left"
                                data-testid={`add-alquiler-${mat.id}`}
                              >
                                <div>
                                  <p className="text-sm font-medium text-gray-900">{mat.nombre}</p>
                                  <p className="text-xs text-gray-500">{mat.proveedor_alquiler_nombre || 'Sin proveedor'} · {mat.precio_alquiler_dia1}€/día</p>
                                </div>
                                <span className="text-purple-600 text-lg font-bold">+</span>
                              </button>
                            ))}
                          {materialesAlquilerCatalogo.filter(m => !(presupuesto.materiales_alquiler || []).find(a => a.material_id === m.id)).length === 0 && (
                            <p className="text-xs text-gray-400 text-center py-2">Todos los materiales de alquiler ya están asignados</p>
                          )}
                        </div>
                      ) : (
                        <p className="text-xs text-gray-400">No hay materiales de alquiler en el catálogo. Créalos en Catálogo Materiales.</p>
                      )}
                    </div>

                    {/* Costes del evento (transporte + fianza) */}
                    <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                      <h4 className="text-sm font-semibold text-purple-900 mb-3">Costes adicionales del evento</h4>
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="text-xs text-gray-600 mb-1 block">Transporte (ida + vuelta)</label>
                          <div className="relative">
                            <span className="absolute left-2 top-1.5 text-gray-500 text-sm">€</span>
                            <input
                              type="number" step="0.01" min="0"
                              value={presupuesto.alquiler_transporte || ''}
                              onChange={(e) => setPresupuesto(prev => ({ ...prev, alquiler_transporte: parseFloat(e.target.value) || 0 }))}
                              onBlur={() => handleSave({ alquiler_transporte: presupuesto.alquiler_transporte || 0 })}
                              className="w-full pl-6 pr-2 py-1.5 border border-gray-300 rounded text-sm"
                              placeholder="0.00"
                              data-testid="alquiler-transporte"
                            />
                          </div>
                          <p className="text-xs text-green-600 mt-0.5">✓ Incluido en costes</p>
                        </div>
                        <div>
                          <label className="text-xs text-gray-600 mb-1 block">Fianza (depósito)</label>
                          <div className="relative">
                            <span className="absolute left-2 top-1.5 text-gray-500 text-sm">€</span>
                            <input
                              type="number" step="0.01" min="0"
                              value={presupuesto.alquiler_fianza || ''}
                              onChange={(e) => setPresupuesto(prev => ({ ...prev, alquiler_fianza: parseFloat(e.target.value) || 0 }))}
                              onBlur={() => handleSave({ alquiler_fianza: presupuesto.alquiler_fianza || 0 })}
                              className="w-full pl-6 pr-2 py-1.5 border border-gray-300 rounded text-sm"
                              placeholder="0.00"
                              data-testid="alquiler-fianza"
                            />
                          </div>
                          <p className="text-xs text-amber-600 mt-0.5">⚠ No es gasto (se devuelve)</p>
                        </div>
                      </div>
                    </div>

                    {/* Resumen de costes de alquiler (formato nuevo: en el Resumen de costes) */}
                    {!formatoNuevo && (presupuesto.materiales_alquiler || []).length > 0 && (() => {
                      const costes = calculateCosteAlquiler();
                      return (
                        <div className="bg-purple-100 border border-purple-300 rounded-lg p-3">
                          <div className="flex justify-between text-sm">
                            <span className="text-purple-700">Material alquiler:</span>
                            <span className="font-bold">{costes.costeMateriales.toFixed(2)}€</span>
                          </div>
                          {costes.transporte > 0 && (
                            <div className="flex justify-between text-sm">
                              <span className="text-purple-700">Transporte:</span>
                              <span className="font-bold">{costes.transporte.toFixed(2)}€</span>
                            </div>
                          )}
                          <div className="flex justify-between text-sm font-bold border-t border-purple-300 pt-1 mt-1">
                            <span className="text-purple-900">Total coste alquiler:</span>
                            <span className="text-purple-900">{costes.total.toFixed(2)}€</span>
                          </div>
                          {costes.fianza > 0 && (
                            <div className="flex justify-between text-xs text-purple-600 mt-1">
                              <span>Fianza (depósito reembolsable):</span>
                              <span>{costes.fianza.toFixed(2)}€</span>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
  );

  // Formato nuevo: correos del evento en los buzones elegidos (un mensaje que
  // está en varios buzones sale si alguno de ellos está elegido).
  const cuentasCorreoPorId = Object.fromEntries(cuentasCorreo.map((c) => [c.id, c]));
  const variosBuzonesCorreo = formatoNuevo && cuentasCorreo.length > 1;
  const buzonesDeCorreo = (correo) => (correo.en_buzones?.length ? correo.en_buzones : [correo.cuenta_id]).filter(Boolean);
  const filtrarCorreosPorBuzon = (lista) => {
    const elegidos = variosBuzonesCorreo ? buzonesCorreos.filter((id) => cuentasCorreoPorId[id]) : [];
    if (!elegidos.length) return lista;
    return lista.filter((c) => buzonesDeCorreo(c).some((id) => elegidos.includes(id)));
  };

  // Correos vinculados, resumen IA y discrepancias
  const renderCorreos = () => {
    const correosLista = filtrarCorreosPorBuzon(correosEvento);
    return (
                  <div className="space-y-3" data-testid="tab-correos-content">
                    <div className="flex items-center justify-between max-md:flex-wrap max-md:gap-2">
                      <div>
                        <h3 className="text-lg font-bold text-gray-900">Correos vinculados</h3>
                        <p className="text-sm text-gray-500">Conversaciones de IAmail asociadas a este evento.</p>
                      </div>
                      <button
                        onClick={() => navigate('/emails')}
                        className="text-sm text-duetto-primary hover:underline flex items-center gap-1"
                      >
                        <Mail className="w-4 h-4" /> Abrir IAmail
                      </button>
                    </div>

                    {/* Resumen IA de la conversación + discrepancias */}
                    {correosEvento.length > 0 && (
                      <div className="border border-duetto-secondary/40 rounded-lg bg-gradient-to-br from-green-50 to-white">
                        <div className="flex items-center justify-between px-3 py-2 border-b border-duetto-secondary/30">
                          <div className="flex items-center gap-2 text-sm font-semibold text-duetto-primary">
                            <Sparkles className="w-4 h-4" /> Resumen IA de la conversación
                          </div>
                          <button
                            onClick={() => generarResumenCorreos(true)}
                            disabled={cargandoResumen}
                            className="text-xs text-duetto-primary hover:underline disabled:opacity-50 inline-flex items-center gap-1"
                          >
                            <RefreshCw className={`w-3 h-3 ${cargandoResumen ? 'animate-spin' : ''}`} />
                            {resumenCorreos ? 'Regenerar' : 'Generar'}
                          </button>
                        </div>
                        <div className="p-3 text-sm">
                          {errorResumen && (
                            <div className="text-xs text-red-700 bg-red-50 border border-red-200 rounded p-2">{errorResumen}</div>
                          )}
                          {!resumenCorreos && !cargandoResumen && !errorResumen && (
                            <div className="text-xs text-gray-500 italic">
                              Aún no hay resumen. Pulsa "Generar" para que la IA analice los correos y detecte discrepancias con el presupuesto.
                            </div>
                          )}
                          {cargandoResumen && !resumenCorreos && (
                            <div className="text-xs text-gray-600">Analizando la conversación con Gemini…</div>
                          )}
                          {resumenCorreos && (
                            <div className="space-y-3">
                              {resumenCorreos.resumen && (
                                <p className="text-gray-800 leading-relaxed whitespace-pre-line">{resumenCorreos.resumen}</p>
                              )}
                              {Array.isArray(resumenCorreos.linea_tiempo) && resumenCorreos.linea_tiempo.length > 0 && (
                                <div className="space-y-1">
                                  <div className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Cronología</div>
                                  <ol className="relative border-l-2 border-duetto-primary/30 ml-2 pl-3 space-y-2">
                                    {resumenCorreos.linea_tiempo.map((ev, i) => {
                                      let fechaFmt = ev.fecha;
                                      try {
                                        if (ev.fecha) {
                                          const d = new Date(ev.fecha);
                                          if (!isNaN(d.getTime())) {
                                            fechaFmt = d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
                                          }
                                        }
                                      } catch (e) {}
                                      return (
                                        <li key={i} className="relative">
                                          <span className="absolute -left-[17px] top-1 w-2 h-2 rounded-full bg-duetto-primary"></span>
                                          <div className="text-[11px] max-md:text-xs font-semibold text-duetto-primary">{fechaFmt || '—'}</div>
                                          <div className="text-xs text-gray-800">{ev.hito}</div>
                                        </li>
                                      );
                                    })}
                                  </ol>
                                </div>
                              )}
                              {Array.isArray(resumenCorreos.discrepancias) && resumenCorreos.discrepancias.length > 0 && (
                                <div className="space-y-1.5">
                                  <div className="text-xs font-semibold text-amber-800 uppercase tracking-wide flex items-center gap-1">
                                    <AlertCircle className="w-3.5 h-3.5" /> Posibles discrepancias ({resumenCorreos.discrepancias.length})
                                  </div>
                                  <ul className="space-y-1.5">
                                    {resumenCorreos.discrepancias.map((d, idx) => (
                                      <li key={idx} className="p-2 border border-amber-200 bg-amber-50 rounded text-xs text-amber-900">
                                        <div className="font-semibold">{d.campo || 'Dato'}</div>
                                        <div className="mt-0.5">
                                          <span className="text-gray-600">Presupuesto:</span> <span className="font-medium">{d.valor_presupuesto || '—'}</span>
                                          {' · '}
                                          <span className="text-gray-600">Correos:</span> <span className="font-medium">{d.valor_correos || '—'}</span>
                                        </div>
                                        {d.explicacion && <div className="text-[11px] max-md:text-xs text-amber-800 mt-0.5">{d.explicacion}</div>}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                              {Array.isArray(resumenCorreos.datos_mencionados?.horarios) && resumenCorreos.datos_mencionados.horarios.length > 0 && (
                                <div className="text-xs">
                                  <span className="text-gray-500">Horarios comentados: </span>
                                  {resumenCorreos.datos_mencionados.horarios.map((h, i) => (
                                    <span key={i} className="inline-block px-1.5 py-0.5 rounded bg-white border border-gray-200 text-gray-700 mr-1 mb-1">{h.valor || h}</span>
                                  ))}
                                </div>
                              )}
                              {Array.isArray(resumenCorreos.datos_mencionados?.personas) && resumenCorreos.datos_mencionados.personas.length > 0 && (
                                <div className="text-xs">
                                  <span className="text-gray-500">Nº personas comentado: </span>
                                  {resumenCorreos.datos_mencionados.personas.map((p, i) => (
                                    <span key={i} className="inline-block px-1.5 py-0.5 rounded bg-white border border-gray-200 text-gray-700 mr-1 mb-1">{p.valor || p}</span>
                                  ))}
                                </div>
                              )}
                              {Array.isArray(resumenCorreos.datos_mencionados?.menus) && resumenCorreos.datos_mencionados.menus.length > 0 && (
                                <div className="text-xs">
                                  <span className="text-gray-500">Menús comentados: </span>
                                  <span className="text-gray-700">
                                    {resumenCorreos.datos_mencionados.menus.map((m) => m.texto || m).join(' · ')}
                                  </span>
                                </div>
                              )}
                              {resumenCorreos.generado_en && (
                                <div className="text-[10px] max-md:text-xs text-gray-400 pt-1 border-t">
                                  Generado {new Date(resumenCorreos.generado_en).toLocaleString('es-ES')}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {formatoNuevo && presupuesto?.id && (
                      <SugerenciasCorreosIA
                        presupuestoId={presupuesto.id}
                        onCambio={() => setRecargaCorreos((n) => n + 1)}
                      />
                    )}

                    {variosBuzonesCorreo && correosEvento.length > 0 && (
                      <div className="flex flex-wrap items-center gap-2 text-xs text-gray-500" data-testid="filtro-buzon-correos">
                        <span>Buzones:</span>
                        <SelectorBuzones
                          cuentas={cuentasCorreo}
                          seleccion={buzonesCorreos}
                          onChange={setBuzonesCorreos}
                          variante="compacto"
                          testid="selector-buzon-correos"
                        />
                        {correosLista.length !== correosEvento.length && (
                          <span>{correosLista.length} de {correosEvento.length} correos</span>
                        )}
                      </div>
                    )}

                    {cargandoCorreos ? (
                      <div className="text-center text-sm text-gray-500 py-6">Cargando correos...</div>
                    ) : correosEvento.length === 0 ? (
                      <div className="text-center text-sm text-gray-500 py-6 border border-dashed border-gray-200 rounded-lg">
                        Aún no hay correos vinculados a este evento. Desde IAmail puedes vincular un correo usando el botón del enlace en la cabecera del mensaje.
                      </div>
                    ) : correosLista.length === 0 ? (
                      <div className="text-center text-sm text-gray-500 py-6 border border-dashed border-gray-200 rounded-lg">
                        Ningún correo del evento está en los buzones elegidos.
                      </div>
                    ) : (
                      <ul className="divide-y divide-gray-200 border border-gray-200 rounded-lg overflow-hidden">
                        {correosLista
                          .slice()
                          .sort((a, b) => new Date(b.fecha || 0) - new Date(a.fecha || 0))
                          .map((correo) => {
                            const fecha = correo.fecha ? new Date(correo.fecha) : null;
                            const fechaStr = fecha ? fecha.toLocaleString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';
                            const direccion = correo.es_enviado ? (correo.destinatarios || []).join(', ') : (correo.remitente_nombre || correo.remitente || '');
                            const abierto = correosExpandidos.has(correo.id);
                            const detalle = detalleCorreos[correo.id];
                            return (
                              <li key={correo.id} className="bg-white">
                                <button
                                  type="button"
                                  onClick={() => toggleCorreoExpandido(correo.id)}
                                  className="w-full text-left p-3 hover:bg-gray-50 flex items-start gap-2"
                                >
                                  <span className="mt-1 text-gray-400 shrink-0">
                                    {abierto ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
                                  </span>
                                  <div className="min-w-0 flex-1">
                                    <div className="flex items-center gap-2 text-xs text-gray-500">
                                      <span className={`px-1.5 py-0.5 rounded ${correo.es_enviado ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700'}`}>
                                        {correo.es_enviado ? 'Enviado' : 'Recibido'}
                                      </span>
                                      <span>{fechaStr}</span>
                                      {correo.adjuntos && correo.adjuntos.length > 0 && (
                                        <span className="inline-flex items-center gap-1 text-gray-500">
                                          <Package className="w-3 h-3" />{correo.adjuntos.length}
                                        </span>
                                      )}
                                    </div>
                                    <p className="text-sm font-semibold text-gray-900 truncate mt-0.5">{correo.asunto || '(sin asunto)'}</p>
                                    <p className="text-xs text-gray-600 truncate">{direccion}</p>
                                    {variosBuzonesCorreo && (
                                      <div className="mt-1" data-testid="correo-en-buzones">
                                        <EtiquetaBuzones ids={buzonesDeCorreo(correo)} cuentasPorId={cuentasCorreoPorId} />
                                      </div>
                                    )}
                                    {!abierto && correo.snippet && (
                                      <p className="text-xs text-gray-500 truncate mt-0.5">{correo.snippet}</p>
                                    )}
                                  </div>
                                </button>
                                {formatoNuevo && correo.presupuesto_vinculo_origen === 'ia' && (
                                  <div className="px-3 pb-2 pl-9 flex flex-wrap items-center gap-2 text-xs">
                                    <span className="px-1.5 py-0.5 rounded bg-[#E3F4EC] text-[#11704F] font-semibold">Enlazado por IA</span>
                                    {correo.vinculo_ia?.motivo && (
                                      <span className="text-gray-600 min-w-0 truncate">{correo.vinculo_ia.motivo}</span>
                                    )}
                                    <button
                                      type="button"
                                      disabled={deshaciendoCorreo === correo.id}
                                      onClick={() => deshacerVinculoIA(correo.id)}
                                      className="font-semibold text-[#11704F] hover:text-[#0B5139] hover:underline disabled:opacity-50"
                                    >
                                      Deshacer
                                    </button>
                                  </div>
                                )}
                                {abierto && (
                                  <div className="px-3 pb-3 pl-9 border-t border-gray-100 bg-gray-50/50">
                                    {!detalle ? (
                                      <div className="text-xs text-gray-500 py-3">Cargando mensaje…</div>
                                    ) : (
                                      <>
                                        <div className="pt-3 flex flex-wrap gap-3 text-xs">
                                          <a
                                            href={`/emails?email=${correo.id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="inline-flex items-center gap-1 text-duetto-primary hover:underline"
                                          >
                                            <ExternalLink className="w-3 h-3" /> Abrir en IAmail
                                          </a>
                                          {detalle.destinatarios && detalle.destinatarios.length > 0 && (
                                            <span className="text-gray-500">Para: <span className="text-gray-700">{detalle.destinatarios.join(', ')}</span></span>
                                          )}
                                          {detalle.cc && detalle.cc.length > 0 && (
                                            <span className="text-gray-500">CC: <span className="text-gray-700">{detalle.cc.join(', ')}</span></span>
                                          )}
                                        </div>
                                        {detalle.body_html ? (
                                          <div
                                            className="prose prose-sm max-w-none mt-2 p-3 bg-white border border-gray-200 rounded max-md:overflow-x-auto max-md:break-words"
                                            dangerouslySetInnerHTML={{ __html: detalle.body_html }}
                                          />
                                        ) : (
                                          <pre className="whitespace-pre-wrap text-xs text-gray-700 mt-2 p-3 bg-white border border-gray-200 rounded">{detalle.body_text || '(sin contenido)'}</pre>
                                        )}
                                        {detalle.adjuntos && detalle.adjuntos.length > 0 && (
                                          <div className="mt-2 flex flex-wrap gap-1.5">
                                            {detalle.adjuntos.map((adj, idx) => (
                                              <span key={idx} className="inline-flex items-center gap-1 text-xs px-2 py-0.5 bg-white border border-gray-200 rounded">
                                                <Package className="w-3 h-3 text-gray-500" />{adj.nombre || `Adjunto ${idx + 1}`}
                                              </span>
                                            ))}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                )}
                              </li>
                            );
                          })}
                      </ul>
                    )}
                  </div>
    );
  };

  // Aviso: platos del presupuesto que ya no existen en catálogo (coste 0, margen inflado)
  const renderAvisoPlatosFaltantes = () => {
                  const faltantes = getPlatosFaltantes();
                  if (faltantes.length === 0) return null;
                  const menusAfectados = [...new Set(faltantes.map((f) => f.menu))];
                  return (
                    <div className="mb-4 bg-red-50 border-2 border-red-300 rounded-lg p-3">
                      <div className="flex items-start gap-2">
                        <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                        <div className="text-sm text-red-800">
                          <p className="font-bold">
                            Atención: {faltantes.length} plato(s) ya no existen en el catálogo
                          </p>
                          <p className="text-xs mt-1">
                            Su coste se calcula como 0, así que el beneficio y el margen de abajo
                            pueden estar inflados. Menús afectados: {menusAfectados.join(', ')}.
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                };

  // Análisis financiero (costes internos, ingresos, beneficio y margen)
  const renderAnalisisFinanciero = () => (
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
              <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
                <h3 className="text-xl font-bold text-white flex items-center">
                  <DollarSign className="w-6 h-6 mr-2" />
                  Análisis Financiero
                </h3>
              </div>
              
              <div className="p-6">
                {/* Aviso: platos del presupuesto que ya no existen en catálogo
                    (su coste sale 0 y el margen queda inflado) */}
                {renderAvisoPlatosFaltantes()}
                {/* Sección: COSTES */}
                <div className="mb-6">
                  <div className="flex items-center mb-3">
                    <div className="w-1 h-6 bg-red-500 rounded-full mr-2"></div>
                    <h4 className="text-sm font-bold text-gray-700 uppercase tracking-wide">Costes Internos</h4>
                  </div>
                  
                  <div className="space-y-2 ml-3">
                    {/* Desglose jerárquico por menú */}
                    {presupuesto.menus_personalizados?.map((menuPers, idx) => {
                      const desglose = getDesgloseCostesMenu(menuPers);
                      if (!desglose) return null;

                      const isExpanded = menusExpandidos[idx] || false;

                      return (
                        <div key={idx} className="mb-4 border-l-4 border-indigo-400 pl-4 bg-gradient-to-r from-indigo-50 to-white rounded-r-lg py-3">
                          {/* Header con nombre del menú y botón colapsar */}
                          <button
                            onClick={() => setMenusExpandidos({...menusExpandidos, [idx]: !isExpanded})}
                            className="w-full flex justify-between items-center mb-2 hover:bg-indigo-100 rounded px-2 py-1 transition-colors"
                          >
                            <div className="flex items-center gap-2">
                              <span className="text-gray-500">
                                {isExpanded ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
                              </span>
                              <h4 className="font-bold text-indigo-900 text-base">
                                {menuPers.nombre_menu}
                                {/* Multievento (M-44): personas de cada jornada, "20 + 35 = 55 pax" */}
                                {desglose.porJornada && (
                                  <span className="ml-2 text-xs font-normal text-indigo-600">
                                    {desglose.porJornada.length > 1
                                      ? `${desglose.porJornada.map(x => x.personas).join(' + ')} = ${desglose.personasTotal} pax`
                                      : `${desglose.personasTotal} pax en la jornada ${desglose.porJornada[0].numero}`}
                                  </span>
                                )}
                              </h4>
                            </div>
                            <span className="font-bold text-indigo-700 text-lg">€{desglose.costeTotal.toFixed(2)}</span>
                          </button>
                          
                          {/* Detalle expandible */}
                          {isExpanded && (
                            <div className="ml-4 space-y-1 mt-2">
                              {/* Ingredientes */}
                              <div className="flex justify-between items-center text-sm py-1">
                                <span className="text-gray-700 flex items-center">
                                  <span className="w-2 h-2 bg-orange-400 rounded-full mr-2"></span>
                                  Ingredientes
                                </span>
                                <span className="font-semibold text-gray-800">€{desglose.costeIngredientes.toFixed(2)}</span>
                              </div>

                              {/* Material / menaje de elaboración (consumibles dentro de los platos) */}
                              {desglose.costeMaterialElaboracion > 0 && (
                                <div className="flex justify-between items-center text-sm py-1">
                                  <span className="text-gray-700 flex items-center">
                                    <span className="w-2 h-2 bg-rose-400 rounded-full mr-2"></span>
                                    Material / menaje
                                  </span>
                                  <span className="font-semibold text-gray-800">€{desglose.costeMaterialElaboracion.toFixed(2)}</span>
                                </div>
                              )}

                              {/* Personal de cocina */}
                              <div className="flex justify-between items-center text-sm py-1">
                                <span className="text-gray-700 flex items-center">
                                  <span className="w-2 h-2 bg-yellow-400 rounded-full mr-2"></span>
                                  Personal de cocina (producción)
                                </span>
                                <span className="font-semibold text-gray-800">€{desglose.costePersonalCocina.toFixed(2)}</span>
                              </div>
                              
                              {/* Personal de evento */}
                              <div className="border-l-2 border-green-300 pl-3 py-1">
                                <div className="flex justify-between items-center text-sm font-semibold text-green-800 mb-1">
                                  <span className="flex items-center">
                                    <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                                    Personal de evento
                                  </span>
                                  <span>€{desglose.costePersonalEvento.toFixed(2)}</span>
                                </div>
                                
                                <div className="ml-4 space-y-0.5 text-xs">
                                  {/* Personal propio */}
                                  {desglose.personalPropio.cantidad > 0 && (
                                    <div className="flex justify-between items-center text-gray-600">
                                      <span>• Personal propio × {desglose.personalPropio.cantidad}</span>
                                      <span className="font-medium">€{desglose.personalPropio.coste.toFixed(2)}</span>
                                    </div>
                                  )}
                                  
                                  {/* Camareros */}
                                  {desglose.camareros.cantidad > 0 && (
                                    <div className="flex justify-between items-center text-gray-600">
                                      <span>• Camareros × {desglose.camareros.cantidad}</span>
                                      <span className="font-medium">€{desglose.camareros.coste.toFixed(2)}</span>
                                    </div>
                                  )}
                                  
                                  {/* Extras */}
                                  {desglose.extras.cantidad > 0 && (
                                    <div className="flex justify-between items-center text-gray-600">
                                      <span>• Extras × {desglose.extras.cantidad}</span>
                                      <span className="font-medium">€{desglose.extras.coste.toFixed(2)}</span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                    
                    {/* TOTALES desplegables — para ver dónde se gasta más */}
                    <div className="border-t-2 border-gray-300 pt-3 mt-4 space-y-1">
                      {/* TOTAL Ingredientes */}
                      {(() => {
                        const ing = getDesgloseTotalIngredientes();
                        return (
                          <div className="border-b border-gray-100">
                            <button
                              type="button"
                              onClick={() => setTotalIngAbierto(v => !v)}
                              className="w-full flex justify-between items-center py-2 hover:bg-gray-50 rounded px-1 text-left"
                            >
                              <span className="text-sm font-semibold text-gray-800 flex items-center">
                                {totalIngAbierto ? <ChevronDown className="w-3 h-3 mr-1" /> : <ChevronRight className="w-3 h-3 mr-1" />}
                                TOTAL Ingredientes
                                {ing.detalle.length > 0 && (
                                  <span className="ml-2 text-xs text-gray-500 font-normal">({ing.detalle.length})</span>
                                )}
                              </span>
                              <span className="font-bold text-gray-900">€{ing.total.toFixed(2)}</span>
                            </button>
                            {totalIngAbierto && ing.detalle.length > 0 && (
                              <table className="w-full text-xs ml-6 mb-2">
                                <thead>
                                  <tr className="text-gray-500 border-b border-gray-200">
                                    <th className="text-left py-1 font-medium">Ingrediente</th>
                                    <th className="text-right py-1 font-medium">Cantidad</th>
                                    <th className="text-right py-1 font-medium">€/ud</th>
                                    <th className="text-right py-1 pr-3 font-medium">Coste</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ing.detalle.map((d, i) => (
                                    <tr key={i} className="border-b border-gray-100 last:border-b-0">
                                      <td className="py-1 pr-2 text-gray-800">{d.nombre}</td>
                                      <td className="py-1 text-right text-gray-700">{d.cantidad.toFixed(2)} {d.unidad}</td>
                                      <td className="py-1 text-right text-gray-500">{d.precio.toFixed(4)} €</td>
                                      <td className="py-1 pr-3 text-right font-medium text-gray-900">{d.coste.toFixed(2)} €</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        );
                      })()}

                      {/* TOTAL Personal cocina */}
                      {(() => {
                        const pc = getDesgloseTotalPersonalCocina();
                        return (
                          <div className="border-b border-gray-100">
                            <button
                              type="button"
                              onClick={() => setTotalCocinaAbierto(v => !v)}
                              className="w-full flex justify-between items-center py-2 hover:bg-gray-50 rounded px-1 text-left"
                            >
                              <span className="text-sm font-semibold text-gray-800 flex items-center">
                                {totalCocinaAbierto ? <ChevronDown className="w-3 h-3 mr-1" /> : <ChevronRight className="w-3 h-3 mr-1" />}
                                TOTAL Personal cocina
                                {pc.detalle.length > 0 && (
                                  <span className="ml-2 text-xs text-gray-500 font-normal">({pc.detalle.length} platos)</span>
                                )}
                              </span>
                              <span className="font-bold text-gray-900">€{pc.total.toFixed(2)}</span>
                            </button>
                            {totalCocinaAbierto && pc.detalle.length > 0 && (
                              <table className="w-full text-xs ml-6 mb-2">
                                <thead>
                                  <tr className="text-gray-500 border-b border-gray-200">
                                    <th className="text-left py-1 font-medium">Plato</th>
                                    <th className="text-right py-1 font-medium">Tiempo</th>
                                    <th className="text-right py-1 pr-3 font-medium">Coste</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {pc.detalle.map((d, i) => (
                                    <tr key={i} className="border-b border-gray-100 last:border-b-0">
                                      <td className="py-1 pr-2 text-gray-800">{d.nombre}</td>
                                      <td className="py-1 text-right text-gray-700">{d.tiempo_min.toFixed(0)} min</td>
                                      <td className="py-1 pr-3 text-right font-medium text-gray-900">{d.coste.toFixed(2)} €</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        );
                      })()}

                      {/* TOTAL Personal evento */}
                      {(() => {
                        const pe = getDesgloseTotalPersonalEvento();
                        const ordenPersonal = getAjusteOrdenPersonalExtra();
                        const totalPersonalEvento = pe.total + ordenPersonal.ajuste;

                        // Con orden de personal extra: la parte teórica de camareros
                        // que sustituye la orden se descuenta de su fila y se muestra
                        // aparte, para que las filas sigan sumando el total.
                        let detallePersonal = pe.detalle;
                        if (ordenPersonal.hayOrden) {
                          detallePersonal = pe.detalle
                            .map(d => (d.nombre === 'Camareros'
                              ? {
                                  ...d,
                                  coste: Math.max(0, d.coste - ordenPersonal.camarerosSustituidos),
                                  sustituido: true,
                                }
                              : d))
                            .filter(d => !d.sustituido || d.coste > 0.01);
                          detallePersonal = [...detallePersonal, {
                            nombre: 'Personal extra (orden)',
                            cantidad: ordenPersonal.personasOrden,
                            coste: ordenPersonal.costeOrdenes,
                          }];
                        }

                        return (
                          <div className="border-b border-gray-100">
                            <button
                              type="button"
                              onClick={() => setTotalEventoAbierto(v => !v)}
                              className="w-full flex justify-between items-center py-2 hover:bg-gray-50 rounded px-1 text-left"
                            >
                              <span className="text-sm font-semibold text-gray-800 flex items-center">
                                {totalEventoAbierto ? <ChevronDown className="w-3 h-3 mr-1" /> : <ChevronRight className="w-3 h-3 mr-1" />}
                                TOTAL Personal evento
                              </span>
                              <span className="font-bold text-gray-900">€{totalPersonalEvento.toFixed(2)}</span>
                            </button>
                            {totalEventoAbierto && detallePersonal.length > 0 && (
                              <table className="w-full text-xs ml-6 mb-2">
                                <thead>
                                  <tr className="text-gray-500 border-b border-gray-200">
                                    <th className="text-left py-1 font-medium">Tipo</th>
                                    <th className="text-right py-1 font-medium">Cantidad</th>
                                    <th className="text-right py-1 pr-3 font-medium">Coste</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {detallePersonal.map((d) => (
                                    <tr key={d.nombre} className="border-b border-gray-100 last:border-b-0">
                                      <td className="py-1 pr-2 text-gray-800">
                                        {d.nombre}
                                        {d.sustituido && (
                                          <span className="ml-1 text-gray-400">(resto no cubierto por la orden)</span>
                                        )}
                                      </td>
                                      <td className="py-1 text-right text-gray-700">{d.sustituido ? '-' : `× ${d.cantidad}`}</td>
                                      <td className="py-1 pr-3 text-right font-medium text-gray-900">{d.coste.toFixed(2)} €</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                            {ordenPersonal.hayOrden && (
                              <p className="ml-6 mb-2 text-xs text-gray-500">
                                Camareros de los menús sustituidos por la orden de personal extra
                                {ordenPersonal.camarerosSustituidos > 0 ? ` (coste teórico: €${ordenPersonal.camarerosSustituidos.toFixed(2)})` : ''}.
                              </p>
                            )}
                          </div>
                        );
                      })()}

                      {/* TOTAL Material y menaje (material de menú + menaje de los
                          platos). Informativo; se oculta si es 0. */}
                      {(() => {
                        const mat = getDesgloseTotalMaterialMenaje();
                        if (!mat || mat.total <= 0) return null;
                        return (
                          <div className="border-b border-gray-100">
                            <button
                              type="button"
                              onClick={() => setMaterialAbierto(v => !v)}
                              disabled={mat.detalle.length === 0}
                              className="w-full flex justify-between items-center py-2 hover:bg-gray-50 rounded px-1 text-left disabled:cursor-default disabled:hover:bg-transparent"
                            >
                              <span className="text-sm font-semibold text-gray-800 flex items-center">
                                {mat.detalle.length > 0 && (materialAbierto ? <ChevronDown className="w-3 h-3 mr-1" /> : <ChevronRight className="w-3 h-3 mr-1" />)}
                                {mat.detalle.length === 0 && <span className="w-3 h-3 mr-1 inline-block" />}
                                TOTAL Material y menaje
                                {mat.detalle.length > 0 && (
                                  <span className="ml-2 text-xs text-gray-500 font-normal">({mat.detalle.length} ítem{mat.detalle.length === 1 ? '' : 's'})</span>
                                )}
                              </span>
                              <span className="font-bold text-gray-900">€{mat.total.toFixed(2)}</span>
                            </button>
                            {materialAbierto && mat.detalle.length > 0 && (
                              <table className="w-full text-xs ml-6 mb-2">
                                <thead>
                                  <tr className="text-gray-500 border-b border-gray-200">
                                    <th className="text-left py-1 font-medium">Material</th>
                                    <th className="text-right py-1 font-medium">Cantidad</th>
                                    <th className="text-right py-1 font-medium">€/ud</th>
                                    <th className="text-right py-1 pr-3 font-medium">Coste</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {mat.detalle.map((d, i) => (
                                    <tr key={i} className="border-b border-gray-100 last:border-b-0">
                                      <td className="py-1 pr-2 text-gray-800">{d.nombre}</td>
                                      <td className="py-1 text-right text-gray-700">{d.cantidad.toFixed(2)} {d.unidad}</td>
                                      <td className="py-1 text-right text-gray-500">{d.precio.toFixed(4)} €</td>
                                      <td className="py-1 pr-3 text-right font-medium text-gray-900">{d.coste.toFixed(2)} €</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        );
                      })()}
                    </div>
                    
                    {(() => {
                      // Transporte: en multi-evento suma el de cada jornada (cada día puede
                      // ser una dirección distinta). Cae al del raíz para jornadas sin
                      // valor propio (mismo lugar que el principal).
                      const raizT = parseFloat(presupuesto.coste_transporte || 0) || 0;
                      const esMulti = presupuesto.es_multi_evento && Array.isArray(presupuesto.jornadas) && presupuesto.jornadas.length > 0;
                      let total = 0;
                      const detalle = [];
                      if (esMulti) {
                        presupuesto.jornadas.forEach((j, i) => {
                          const t = j.coste_transporte != null ? parseFloat(j.coste_transporte) : raizT;
                          total += t;
                          detalle.push({ idx: i + 1, fecha: j.fecha, lugar: j.lugar_evento || presupuesto.lugar_evento, coste: t, propio: j.coste_transporte != null });
                        });
                      } else {
                        total = raizT;
                      }
                      if (total <= 0) return null;
                      return (
                        <div className="py-2 border-b border-gray-100">
                          <div className="flex justify-between items-center">
                            <span className="text-sm text-gray-700 flex items-center">
                              <span className="w-2 h-2 bg-teal-400 rounded-full mr-2"></span>
                              Transporte (ida y vuelta){esMulti ? ` · ${presupuesto.jornadas.length} jornadas` : ''}
                            </span>
                            <span className="font-semibold text-gray-900">€{total.toFixed(2)}</span>
                          </div>
                          {esMulti && detalle.length > 0 && (
                            <ul className="mt-1 ml-4 text-xs text-gray-500 space-y-0.5">
                              {detalle.map(d => {
                                let fechaCorta = d.fecha || '';
                                if (fechaCorta && fechaCorta.length >= 10) {
                                  const [y, m, dd] = fechaCorta.slice(0, 10).split('-');
                                  fechaCorta = `${dd}/${m}/${y}`;
                                }
                                return (
                                  <li key={d.idx} className="flex justify-between gap-3">
                                    <span>
                                      Jornada {d.idx} · {fechaCorta}
                                      {!d.propio && <span className="text-gray-400" title="Usa la misma dirección del presupuesto principal. Edita la jornada para asignar otra y recalcular su transporte."> · usa dirección principal</span>}
                                    </span>
                                    <span className="whitespace-nowrap">€{d.coste.toFixed(2)}</span>
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                  
                  {/* Vehículos de alquiler */}
                  {presupuesto.vehiculos_asignados?.filter(v => v.es_alquiler).length > 0 && (
                    <div className="flex justify-between items-center py-1 border-b border-gray-100">
                      <div className="flex items-center">
                        <span className="w-2 h-2 bg-orange-400 rounded-full mr-2"></span>
                        <span className="text-sm text-gray-600">Vehículos alquiler</span>
                      </div>
                      <span className="text-sm font-medium text-orange-600">
                        €{presupuesto.vehiculos_asignados.filter(v => v.es_alquiler).reduce((sum, v) => sum + (v.coste_alquiler || 0), 0).toFixed(2)}
                      </span>
                    </div>
                  )}
                  
                  {/* Coste de bebidas */}
                  {(presupuesto.coste_bebidas > 0 || presupuesto.bebidas?.length > 0) && (
                    <div className="flex justify-between items-center py-1 border-b border-gray-100">
                      <div className="flex items-center">
                        <span className="w-2 h-2 bg-purple-400 rounded-full mr-2"></span>
                        <span className="text-sm text-gray-600">🍷 Bebidas ({presupuesto.bebidas?.length || 0})</span>
                      </div>
                      <span className="text-sm font-medium text-purple-600">
                        €{(presupuesto.coste_bebidas || presupuesto.bebidas?.reduce((sum, b) => sum + (b.coste_total || 0), 0) || 0).toFixed(2)}
                      </span>
                    </div>
                  )}
                  
                  {/* Coste de material de alquiler - con desglose */}
                  {calculateCosteAlquiler().total > 0 && (() => {
                    const costes = calculateCosteAlquiler();
                    return (
                      <div className="ml-3 py-1 border-l-2 border-purple-300 pl-2">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-purple-700">Material alquiler</span>
                          <span className="text-sm font-semibold text-purple-700">
                            €{costes.costeMateriales.toFixed(2)}
                          </span>
                        </div>
                        {costes.transporte > 0 && (
                          <div className="flex justify-between items-center">
                            <span className="text-sm text-purple-600">Transporte alquiler</span>
                            <span className="text-sm font-semibold text-purple-600">
                              €{costes.transporte.toFixed(2)}
                            </span>
                          </div>
                        )}
                        {costes.fianza > 0 && (
                          <div className="flex justify-between items-center text-xs text-gray-500 italic">
                            <span>Fianza (reembolsable, no es coste)</span>
                            <span>€{costes.fianza.toFixed(2)}</span>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                  
                  <div className="mt-3 ml-3 bg-red-50 border-l-4 border-red-500 rounded-r-lg p-3">
                    <div className="flex justify-between items-center">
                      <span className="text-sm font-bold text-red-900">TOTAL COSTES</span>
                      <span className="font-bold text-xl text-red-700">€{(() => {
                        // Sumar ingredientes + personal cocina + personal evento de todos los menús
                        // (multievento: jornada a jornada con sus personas, M-44)
                        const costeMenus = getCosteMenusTotal();
                        
                        // Sumar material y transporte
                        const costeMaterial = calculateCosteMaterial();
                        const costeTransporte = presupuesto.coste_transporte ? parseFloat(presupuesto.coste_transporte) : 0;
                        // Incluir coste de vehículos de alquiler
                        const costeVehiculosAlquiler = presupuesto.vehiculos_asignados?.filter(v => v.es_alquiler).reduce((sum, v) => sum + (v.coste_alquiler || 0), 0) || 0;
                        // Incluir coste de bebidas
                        const costeBebidas = presupuesto.coste_bebidas || presupuesto.bebidas?.reduce((sum, b) => sum + (b.coste_total || 0), 0) || 0;
                        // Incluir coste de material de alquiler
                        const costeAlquiler = calculateCosteAlquiler().total;
                        // La orden de personal extra sustituye el coste teórico de camareros
                        const ajusteOrdenPersonal = getAjusteOrdenPersonalExtra().ajuste;

                        // U-40: con costes guardados del motor, el total es el suyo
                        const analisisMotor = getAnalisisFinanciero();
                        if (analisisMotor.disponible) return analisisMotor.costesTotal.toFixed(2);

                        return (costeMenus + costeMaterial + costeTransporte + costeVehiculosAlquiler + costeBebidas + costeAlquiler + ajusteOrdenPersonal).toFixed(2);
                      })()}</span>
                    </div>
                    {getAnalisisFinanciero().disponible && (
                      <p className="mt-1 text-xs text-red-800">
                        Costes guardados del motor de costes (los mismos del Resumen). El desglose de arriba es orientativo.
                      </p>
                    )}
                  </div>
                </div>
                
                {/* Sección: INGRESOS */}
                <div className="mb-6">
                  <div className="flex items-center mb-3">
                    <div className="w-1 h-6 bg-green-500 rounded-full mr-2"></div>
                    <h4 className="text-sm font-bold text-gray-700 uppercase tracking-wide">Ingresos</h4>
                  </div>
                  
                  <div className="ml-3 bg-green-50 border-l-4 border-green-500 rounded-r-lg p-3">
                    {(() => {
                      // Calcular subtotal SIN descuentos y CON descuentos
                      let subtotalSinDescuento = 0;
                      let totalDescuentos = 0;
                      
                      items.forEach(item => {
                        if (item.type === 'menu' && item.personalizadoIndex !== undefined) {
                          const menu = presupuesto.menus_personalizados?.[item.personalizadoIndex];
                          if (menu) {
                            let precioOriginal;
                            let precioConDescuento = menu.precio_unitario || menu.precio_ud || 0;
                            const numPersonas = menu.num_personas || item.uds || 0;
                            
                            // Si tiene descuento aplicado, calcular precio original
                            if (menu.descuento_tipo && menu.descuento_valor && menu.descuento_valor > 0) {
                              if (menu.precio_unitario_original) {
                                // Ya tenemos el precio original guardado
                                precioOriginal = menu.precio_unitario_original;
                              } else {
                                // Calcular precio original desde el precio con descuento
                                if (menu.descuento_tipo === 'porcentaje') {
                                  // precioConDescuento = precioOriginal * (1 - descuento/100)
                                  // precioOriginal = precioConDescuento / (1 - descuento/100)
                                  precioOriginal = precioConDescuento / (1 - menu.descuento_valor / 100);
                                } else {
                                  // Descuento fijo
                                  precioOriginal = precioConDescuento + menu.descuento_valor;
                                }
                              }
                            } else {
                              // Sin descuento
                              precioOriginal = menu.precio_unitario_original || precioConDescuento;
                            }
                            
                            subtotalSinDescuento += precioOriginal * numPersonas;
                            totalDescuentos += (precioOriginal - precioConDescuento) * numPersonas;
                          }
                        } else {
                          subtotalSinDescuento += calculateImporte(item);
                        }
                      });
                      
                      const subtotalConDescuento = calculateSubtotal();
                      
                      return (
                        <>
                          {totalDescuentos > 0.01 && (
                            <>
                              <div className="flex justify-between items-center text-sm text-gray-600 mb-2">
                                <span>Subtotal antes de descuentos</span>
                                <span>€{safeToFixed(subtotalSinDescuento, 2)}</span>
                              </div>
                              <div className="flex justify-between items-center text-sm text-red-600 mb-2">
                                <span>Descuentos aplicados</span>
                                <span>-€{safeToFixed(totalDescuentos, 2)}</span>
                              </div>
                              <div className="border-t border-green-300 pt-2 mt-2"></div>
                            </>
                          )}
                          <div className="flex justify-between items-center">
                            <span className="text-sm font-bold text-green-900">Del Cliente</span>
                            <span className="font-bold text-xl text-green-700">€{safeToFixed(subtotalConDescuento, 2)}</span>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                </div>
                
                {/* Sección: BENEFICIO Y MARGEN (U-40: con los costes guardados del
                    motor y la venta del servidor; sin ellos, no se inventa) */}
                {(() => {
                  const analisis = getAnalisisFinanciero();
                  if (analisis.disponible) return null;
                  const pasado = esEventoPasadoFicha();
                  return (
                    <div className="border-t-2 border-gray-200 pt-4">
                      <div className="bg-gray-50 border border-gray-300 rounded-lg p-4 text-sm text-gray-700">
                        {analisis.cargando ? (
                          <p>Cargando los costes guardados...</p>
                        ) : (
                          <>
                            <p className="font-semibold">
                              {pasado
                                ? 'Costes del método anterior: el beneficio no se calcula con ellos (evento celebrado).'
                                : 'Costes del método anterior: pulsa Recalcular costes'}
                            </p>
                            {errorCostes && <p className="mt-1 text-xs text-red-600">{errorCostes}</p>}
                            {!pasado && (
                              <button
                                type="button"
                                onClick={recalcularCostes}
                                disabled={recalculandoCostes}
                                className="mt-3 px-3 py-1.5 rounded-md bg-indigo-600 text-white text-xs font-semibold hover:bg-indigo-700 disabled:opacity-60"
                              >
                                {recalculandoCostes ? 'Recalculando...' : 'Recalcular costes'}
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  );
                })()}
                {getAnalisisFinanciero().disponible && (
                <div className="border-t-2 border-gray-200 pt-4">
                  <div className="bg-gradient-to-r from-emerald-500 to-teal-500 rounded-lg p-4 mb-3">
                    <div className="flex justify-between items-center">
                      <span className="text-white font-semibold flex items-center">
                        <TrendingUp className="w-5 h-5 mr-2" />
                        Beneficio Estimado
                      </span>
                      <span className="font-bold text-2xl text-white">€{safeToFixed(getAnalisisFinanciero().beneficio, 2)}</span>
                    </div>
                  </div>
                  
                  <div className="bg-gradient-to-r from-indigo-500 to-purple-500 rounded-lg p-4">
                    <div className="flex justify-between items-center">
                      <span className="text-white font-semibold flex items-center">
                        <DollarSign className="w-5 h-5 mr-2" />
                        Margen de Beneficio
                      </span>
                      <span className="font-bold text-3xl text-white">
                        {safeToFixed(getAnalisisFinanciero().margen, 1)}%
                      </span>
                    </div>
                  </div>
                </div>
                )}
              </div>
            </div>
  );

  // Avisos "!" de las pestañas (mismas condiciones en el formato anterior y el nuevo)
  const faltaPersonal = !presupuesto?.personal_asignado || presupuesto.personal_asignado.length === 0;
  // Formato nuevo: el personal también queda cubierto con la persona elegida en Quién va
  const faltaPersonalFicha = faltaPersonal && !presupuesto?.quien_va_evento?.persona_id;
  const faltanFurgonetas = !presupuesto?.vehiculos_asignados || presupuesto.vehiculos_asignados.length === 0;
  const faltanBebidas = !presupuesto?.bebidas_confirmadas;
  // Formato nuevo: falta validar el modo de bebidas o, en personalizado,
  // confirmar las bebidas por menú. Sin el estado del modo cargado, el criterio
  // de siempre.
  const bebidasModoActual = estadoBebidasModo?.modo || null;
  const bebidasModoValidadoEn = estadoBebidasModo?.validado_en || null;
  // Si ningún menú lleva el plato de bebida mixto no hay modo que validar:
  // solo cuentan las bebidas elegidas a mano sin confirmar
  const bebidasModoNoAplica = !!estadoBebidasModo && estadoBebidasModo.aplica === false;
  const faltanBebidasFicha = estadoBebidasModo
    ? (bebidasModoNoAplica
      ? ((presupuesto?.bebidas || []).length > 0 && !presupuesto?.bebidas_confirmadas)
      : (!bebidasModoValidadoEn || (bebidasModoActual === 'personalizado' && faltanBebidas)))
    : faltanBebidas;
  const bebidasSinValidar = !!estadoBebidasModo && !bebidasModoNoAplica && !bebidasModoValidadoEn;
  // Tarjeta Bebidas de Líneas: fuera del todo si no hay modo ni bebidas que mostrar
  const ocultarTarjetaBebidas = bebidasModoNoAplica && !estadoBebidasModo.hay_bebidas_personalizadas
    && !(estadoBebidasModo.menus_con_bebida_incluida > 0) && !(estadoBebidasModo.cubiertas_barra_libre > 0);
  const hayDepositoCliente = !!(depositosCliente && depositosCliente.total_disponible > 0.01);

  // ===== FORMATO NUEVO (diseño A+) =====

  // Ciclo del evento calculado con los datos que ya existen (estado, fecha del
  // evento frente a hoy, facturas y estado de pago). No hay estados nuevos en BD.
  const calcularCicloEvento = () => {
    const estado = presupuesto.estado;
    const jornadas = presupuesto.jornadas || [];
    // Facturación por jornada: facturado solo con TODAS las jornadas emitidas
    // (tiene_factura y numero_factura los deja también la primera factura o un
    // borrador, y facturaNormalExistente sería la de una sola jornada)
    const facturacionJornadas = esFacturacionPorJornada() ? resumenFacturasJornadas() : null;
    const facturado = facturacionJornadas
      ? facturacionJornadas.total > 0 && facturacionJornadas.emitidas === facturacionJornadas.total
      : !!(
        presupuesto.tiene_factura ||
        presupuesto.numero_factura ||
        facturaNormalExistente ||
        (presupuesto.es_multi_evento && jornadas.length > 0 && jornadas.every(j => j.numero_factura || j.facturada))
      );
    const cobroMe = cobroMultievento();
    const cobrado = cobroMe ? cobroMe.cobrado : ['pagado', 'si'].includes(String(presupuesto.estado_pago || '').toLowerCase());
    // U-96: "celebrado" con el criterio del servidor (`eventoPasado`)
    const celebrado = estado === 'confirmado' && eventoPasado(presupuesto);
    const alcanzados = [
      true,
      ['enviado', 'aceptado', 'confirmado'].includes(estado) || (presupuesto.registros_envios || []).length > 0,
      estado === 'confirmado',
      celebrado,
      facturado,
      cobrado,
    ];
    const ultimo = alcanzados.lastIndexOf(true);
    const facturadoParcial = !!facturacionJornadas && !facturado && facturacionJornadas.emitidas > 0;
    const etiquetas = ['Borrador', 'Enviado', 'Confirmado', 'Celebrado',
      facturadoParcial
        ? `Facturado parcialmente: ${facturacionJornadas.emitidas} de ${facturacionJornadas.total} jornadas`
        : 'Facturado',
      'Cobrado'];
    return {
      pasos: etiquetas.map((etiqueta, i) => ({ etiqueta, hecho: i <= ultimo, actual: i === ultimo + 1 })),
      cerrado: estado === 'cancelado' || estado === 'rechazado',
      celebrado,
      facturado,
      facturacionJornadas,
    };
  };

  // "Enviar presupuesto": el mismo modal de siempre, ya en modo envío por email
  const abrirEnvioPresupuesto = () => {
    handleGeneratePDF('Presupuesto');
    setAccionPresupuesto('enviar');
  };

  // Cobro previo: modal "Pedir pago" con el correo propuesto por el servidor
  // (destinatario de facturación, importe pendiente, IBAN y plazo)
  const abrirModalCobroPrevio = async () => {
    let datos = cobroPrevio;
    try {
      const { data } = await presupuestosAPI.getCobroPrevio(id);
      if (data && data.motivo) {
        datos = data;
        setCobroPrevio(data);
      }
    } catch (error) {
      // Se usa lo ya cargado
    }
    const propuesta = datos?.propuesta || {};
    setModalCobroPrevio({
      para: propuesta.para || '',
      cc: (propuesta.cc || []).join(', '),
      asunto: propuesta.asunto || '',
      cuerpo: propuesta.cuerpo || '',
      confirmar: false,
      error: null,
    });
  };

  const enviarCobroPrevio = async () => {
    const m = modalCobroPrevio;
    if (!m) return;
    if (!m.para.trim() || !m.asunto.trim() || !m.cuerpo.trim()) {
      setModalCobroPrevio({ ...m, error: 'Faltan el destinatario, el asunto o el texto del correo.', confirmar: false });
      return;
    }
    // Primer clic: pide confirmación; el segundo envía
    if (!m.confirmar) {
      setModalCobroPrevio({ ...m, confirmar: true, error: null });
      return;
    }
    setEnviandoCobroPrevio(true);
    try {
      const { data } = await presupuestosAPI.pedirCobroPrevio(id, {
        para: m.para.trim(),
        cc: m.cc.split(',').map(e => e.trim()).filter(Boolean),
        asunto: m.asunto,
        cuerpo: m.cuerpo,
      });
      if (data && data.motivo) setCobroPrevio(data);
      setModalCobroPrevio(null);
      toast({ title: 'Petición de pago enviada', description: `Enviada a ${m.para.trim()} desde administracion@duettocatering.com` });
      // El envío queda en el historial y cambia la rev del presupuesto; la
      // proforma adjunta (nueva o actualizada) aparece en Facturación y cobros
      await fetchData();
      cargarDocumentosFacturacion();
    } catch (error) {
      setModalCobroPrevio({ ...m, confirmar: false, error: error.response?.data?.detail || error.message || 'No se ha podido enviar' });
    } finally {
      setEnviandoCobroPrevio(false);
    }
  };

  const renderModalCobroPrevio = () => {
    const m = modalCobroPrevio;
    const claseInput = 'w-full rounded-lg border border-[#CBD3CF] px-3 py-2 text-sm text-[#16221D] focus:outline-none focus:border-duetto-primary';
    const cambiar = (campo) => (e) => setModalCobroPrevio({ ...m, [campo]: e.target.value, confirmar: false });
    const cc = m ? m.cc.split(',').map(e => e.trim()).filter(Boolean) : [];
    return (
      <Dialog open={!!m} onOpenChange={(abierto) => { if (!abierto && !enviandoCobroPrevio) setModalCobroPrevio(null); }}>
        {m && (
          <DialogContent className="w-[calc(100%-2rem)] max-w-2xl max-h-[92vh] overflow-y-auto bg-white p-5 sm:p-6 gap-3" data-testid="modal-cobro-previo">
            <div className="pr-8">
              <DialogTitle className="text-lg font-extrabold text-[#16221D]">Pedir el pago al cliente</DialogTitle>
              <DialogDescription className="text-sm text-[#5B6B64] mt-1">
                {cobroPrevio
                  ? `Pendiente ${formatoEur(cobroPrevio.pendiente)} · el cobro previo vence el ${cobroPrevio.vence_el ? formatFecha(cobroPrevio.vence_el) : '-'}.${textoDetalleImporteCobroPrevio(cobroPrevio) ? ` ${textoDetalleImporteCobroPrevio(cobroPrevio)}.` : ''} Se envía desde administracion@duettocatering.com con la proforma.`
                  : 'Se envía desde administracion@duettocatering.com con la proforma.'}
              </DialogDescription>
              {cobroPrevio?.proforma?.texto && (
                <p className="mt-2 text-sm font-semibold text-[#0F5E43] bg-[#E3F3EC] border border-[#B9DFCD] rounded-lg px-3 py-2" data-testid="cobro-previo-proforma">
                  {cobroPrevio.proforma.texto}.
                </p>
              )}
            </div>
            <label className="flex flex-col gap-1 text-xs font-bold text-[#33443C]">
              Para
              <input type="email" value={m.para} onChange={cambiar('para')} className={claseInput} data-testid="cobro-previo-para" />
            </label>
            <label className="flex flex-col gap-1 text-xs font-bold text-[#33443C]">
              Copia (separados por comas)
              <input type="text" value={m.cc} onChange={cambiar('cc')} className={claseInput} data-testid="cobro-previo-cc" />
            </label>
            <label className="flex flex-col gap-1 text-xs font-bold text-[#33443C]">
              Asunto
              <input type="text" value={m.asunto} onChange={cambiar('asunto')} className={claseInput} data-testid="cobro-previo-asunto" />
            </label>
            <label className="flex flex-col gap-1 text-xs font-bold text-[#33443C]">
              Texto del correo
              <textarea value={m.cuerpo} onChange={cambiar('cuerpo')} rows={14} className={`${claseInput} font-normal`} data-testid="cobro-previo-cuerpo" />
            </label>
            {m.error && (
              <p className="text-sm text-[#8A1C12] bg-[#FDE8E6] border border-[#F5C2BC] rounded-lg px-3 py-2" role="alert">{m.error}</p>
            )}
            {m.confirmar && (
              <p className="text-sm text-[#6B4E00] bg-[#FFF8E6] border border-[#F1DFA8] rounded-lg px-3 py-2" data-testid="cobro-previo-confirmar">
                {`Se enviará a ${m.para.trim()}${cc.length > 0 ? ` con copia a ${cc.join(', ')}` : ''}. Pulsa "Confirmar envío" para mandarlo.`}
              </p>
            )}
            <div className="flex flex-wrap items-center justify-end gap-2 border-t border-[#E1E6E3] pt-3">
              <button
                type="button"
                onClick={() => (m.confirmar ? setModalCobroPrevio({ ...m, confirmar: false }) : setModalCobroPrevio(null))}
                disabled={enviandoCobroPrevio}
                className="h-[34px] px-3 rounded-lg border border-[#CBD3CF] bg-white text-[13px] font-bold text-[#16221D] hover:bg-gray-50 disabled:opacity-50"
              >
                {m.confirmar ? 'Volver' : 'Cancelar'}
              </button>
              <button
                type="button"
                onClick={enviarCobroPrevio}
                disabled={enviandoCobroPrevio}
                className="h-[34px] px-3 rounded-lg border border-duetto-primary bg-duetto-primary text-white text-[13px] font-bold flex items-center gap-1.5 hover:bg-opacity-90 disabled:opacity-50"
                data-testid="cobro-previo-enviar"
              >
                <Send className="w-3.5 h-3.5" />
                {enviandoCobroPrevio ? 'Enviando...' : (m.confirmar ? 'Confirmar envío' : 'Enviar petición')}
              </button>
            </div>
          </DialogContent>
        )}
      </Dialog>
    );
  };

  // `movil`: en la barra inferior del móvil (más estrecho; mismo botón y mismos avisos)
  const renderSiguientePaso = (ciclo, { movil = false } = {}) => {
    const estado = presupuesto.estado;
    if (ciclo.cerrado) return null;
    const clasePrincipal = movil
      ? 'h-11 px-3 min-w-0 max-w-full rounded-lg bg-duetto-primary text-white text-sm font-bold flex items-center gap-1.5 whitespace-nowrap overflow-hidden active:bg-opacity-90'
      : 'h-11 px-5 rounded-lg bg-duetto-primary text-white text-sm font-semibold flex items-center gap-2 hover:bg-opacity-90 transition-colors whitespace-nowrap';
    if (estado === 'borrador') {
      return (
        <button type="button" onClick={abrirEnvioPresupuesto} className={clasePrincipal} data-testid="siguiente-paso" data-uso="presupuesto.email">
          <Send className="w-4 h-4 shrink-0" /> {movil ? 'Enviar' : 'Enviar presupuesto'}
        </button>
      );
    }
    if (estado !== 'confirmado') {
      return (
        <button type="button" onClick={handleConfirmar} disabled={confirmacionEnCurso()} className={`${clasePrincipal} disabled:opacity-60`} data-testid="siguiente-paso" data-uso="presupuesto.confirmar">
          <CheckCircle className="w-4 h-4 shrink-0" /> {textoBotonConfirmar(movil ? 'Confirmar' : 'Confirmar evento')}
        </button>
      );
    }
    if (!ciclo.facturado) {
      return (
        <button type="button" onClick={() => handleGeneratePDF('Factura')} className={clasePrincipal} data-testid="siguiente-paso" data-uso="presupuesto.factura">
          <Receipt className="w-4 h-4 shrink-0" /> {movil ? 'Facturar' : 'Emitir factura'}
        </button>
      );
    }
    return (
      <button
        type="button"
        onClick={() => setPestanaActiva('facturacion')}
        className={movil
          ? 'h-11 px-3 min-w-0 max-w-full rounded-lg border border-[#CBD3CF] bg-white text-[#16221D] text-sm font-bold flex items-center gap-1.5 whitespace-nowrap overflow-hidden active:bg-gray-50'
          : 'h-11 px-5 rounded-lg border border-[#CBD3CF] bg-white text-[#16221D] text-sm font-semibold flex items-center gap-2 hover:bg-gray-50 transition-colors whitespace-nowrap'}
        data-testid="siguiente-paso"
        data-uso="presupuesto.ver_facturacion"
      >
        <Receipt className="w-4 h-4 shrink-0" /> {movil ? 'Facturación' : 'Ver facturación'}
      </button>
    );
  };

  // Acciones secundarias del estado (mismos handlers que la barra antigua): el
  // menú ⋯ de la cabecera y, en el móvil, la hoja Más
  const accionesEstadoFicha = () => {
    const estado = presupuesto.estado;
    const acciones = [];
    if (estado === 'confirmado') {
      acciones.push({ clave: 'desconfirmar', etiqueta: 'Desconfirmar', onSelect: handleDesconfirmar });
      acciones.push({ clave: 'cancelar', etiqueta: 'Cancelar evento', onSelect: handleCancelarEvento, peligro: true });
    } else if (estado === 'borrador') {
      // En "enviado" y "aceptado" confirmar ya es el botón principal
      if (!confirmando) acciones.push({ clave: 'confirmar', etiqueta: 'Confirmar evento', onSelect: handleConfirmar });
    } else if (estado === 'cancelado' || estado === 'rechazado') {
      // Cancelado o rechazado: primero se reabre como borrador (no se confirma directamente)
      acciones.push({ clave: 'reabrir', etiqueta: 'Reabrir como borrador', onSelect: handleReabrir });
    }
    if (estado === 'cancelado' && !presupuesto.cancelacion) {
      acciones.push({ clave: 'motivo', etiqueta: 'Registrar motivo de la cancelación', onSelect: handleCancelarEvento });
    }
    return acciones;
  };

  // Menú de acciones secundarias del estado (mismos handlers que la barra antigua)
  const renderMenuAcciones = () => {
    const acciones = accionesEstadoFicha();
    if (acciones.length === 0) return null;
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="h-11 w-11 rounded-lg border border-[#CBD3CF] bg-white text-[#16221D] flex items-center justify-center hover:bg-gray-50"
            title="Más acciones"
            data-testid="menu-acciones"
          >
            <MoreHorizontal className="w-5 h-5" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-white">
          {acciones.map((a) => (
            <DropdownMenuItem
              key={a.clave}
              onSelect={() => a.onSelect()}
              className={`cursor-pointer ${a.peligro ? 'text-red-700 focus:text-red-800' : ''}`}
            >
              {a.etiqueta}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  };

  // `compacta`: en el móvil, más baja y más cerca de la cabecera
  const renderBarraCiclo = (ciclo, { compacta = false } = {}) => (
    <div className={`flex items-center ${compacta ? 'mt-3 -mx-4 px-4' : 'mt-5'} overflow-x-auto pb-1`} data-testid="barra-ciclo">
      {ciclo.pasos.map((paso, i) => (
        <React.Fragment key={paso.etiqueta}>
          {i > 0 && (
            <div className={`flex-grow min-w-[16px] h-0.5 mx-2 sm:mx-3 ${paso.hecho ? 'bg-duetto-primary' : 'bg-[#E1E6E3]'}`} />
          )}
          <div
            className={`flex items-center gap-2 text-xs sm:text-sm font-semibold whitespace-nowrap ${
              paso.hecho ? 'text-[#0F5E43]' : paso.actual && !ciclo.cerrado ? 'text-[#16221D]' : 'text-[#8A9892]'
            }`}
          >
            {paso.hecho ? (
              <span className="w-[22px] h-[22px] rounded-full bg-duetto-primary text-white flex items-center justify-center">
                <CheckCircle className="w-3.5 h-3.5" />
              </span>
            ) : (
              <span
                className={`w-[22px] h-[22px] rounded-full border-2 box-border ${
                  paso.actual && !ciclo.cerrado ? 'border-duetto-primary' : 'border-dashed border-[#B7C1BC]'
                }`}
              />
            )}
            {paso.etiqueta}
          </div>
        </React.Fragment>
      ))}
      {ciclo.cerrado && (
        <span className="ml-4 px-2.5 py-1 rounded-full text-xs font-bold bg-[#FDE8E6] text-[#8A1C12] whitespace-nowrap">
          {presupuesto.estado === 'cancelado' ? 'Evento cancelado' : 'Presupuesto rechazado'}
        </span>
      )}
    </div>
  );

  // Tarjeta blanca del formato nuevo
  const renderTarjetaNueva = (titulo, contenido, { accion = null, testid } = {}) => (
    <section className="bg-white border border-[#E1E6E3] rounded-xl p-4 sm:p-5" data-testid={testid}>
      {(titulo || accion) && (
        <div className="flex items-center justify-between gap-3 mb-3">
          {titulo && <h2 className="text-xs font-bold tracking-wider uppercase text-[#5B6B64]">{titulo}</h2>}
          {accion}
        </div>
      )}
      {contenido}
    </section>
  );

  // Material sin validar (formato nuevo): obligatorio antes del evento. Aviso en
  // la cabecera, en la pestaña y en la hoja de material (sale como borrador) y
  // la orden de cocina (solo aviso, no bloquea). Multievento: por jornada.
  const materialSinValidar = () => {
    if (!estadoMaterial || (estadoMaterial.ambitos || []).length === 0) return false;
    return !estadoMaterial.validado || !!estadoMaterial.huella_cambiada;
  };

  // Fila de documento: nombre y acciones (mismos handlers que la barra antigua)

  // Botones de documentos (Presupuesto, órdenes, hoja de material, alquiler, minuta, facturas).
  // Formato antiguo: barra de acciones. Formato nuevo (compacto): bajo la cabecera.
  const renderBotonesDocumentos = ({ compacto = false } = {}) => {
    const claseBoton = compacto
      ? 'px-2.5 py-1.5 rounded-lg transition-colors flex items-center gap-2 text-xs font-medium'
      : 'px-3 py-2 rounded-lg transition-colors flex items-center gap-2 text-sm font-medium';
    const claseIcono = compacto ? 'w-3.5 h-3.5' : 'w-4 h-4';
    const texto = (t) => (compacto ? <span>{t}</span> : <span className="hidden sm:inline">{t}</span>);
    const botonOrdenNueva = (
      <button
        onClick={() => setShowOrdenNuevaModal(true)}
        className={`${claseBoton} bg-white text-orange-700 border border-orange-400 hover:bg-orange-50`}
        title={TEXTO_ORDEN_NUEVA_PRUEBAS}
        data-testid="boton-orden-cocina-nueva"
        data-uso="presupuesto.pdf_orden_cocina_nueva"
      >
        <ChefHat className={claseIcono} />
        {texto('Orden de cocina (nueva)')}
      </button>
    );
    return (
      <div
        className="flex flex-wrap items-center gap-2"
        data-testid={compacto ? 'accesos-documentos' : undefined}
      >
        {/* Presupuesto: descarga el PDF directamente; el sobre abre el envío por
            email (destinatario, CC, mensaje e historial de envíos) */}
        <span className="inline-flex items-stretch">
          <button
            onClick={handleDescargarPresupuesto}
            disabled={downloading}
            className={`${claseBoton} rounded-r-none bg-duetto-yellow text-gray-900 hover:bg-opacity-90 disabled:opacity-60`}
            data-uso="presupuesto.pdf"
            title="Descargar el PDF del presupuesto"
          >
            <FileText className={claseIcono} />
            {texto('Presupuesto')}
          </button>
          <button
            onClick={abrirEnvioPresupuesto}
            className={`${claseBoton} rounded-l-none border-l border-yellow-600/30 bg-duetto-yellow text-gray-900 hover:bg-opacity-90`}
            data-uso="presupuesto.email"
            title="Enviar el presupuesto por email"
            aria-label="Enviar el presupuesto por email"
            data-testid="boton-presupuesto-email"
          >
            <Mail className={claseIcono} />
          </button>
        </span>
        <button
          onClick={() => handleGenerateOrdenCocina()}
          className={`${claseBoton} bg-orange-500 text-white hover:bg-orange-600`}
          data-uso="presupuesto.pdf_orden_cocina"
          title="Descargar Orden de Cocina"
        >
          <ChefHat className={claseIcono} />
          {texto('Orden Cocina')}
        </button>
        {compacto ? botonOrdenNueva : (
          <span className="flex flex-col items-start">
            {botonOrdenNueva}
            <span className="text-[10px] text-gray-500 mt-0.5 max-w-[180px] leading-tight">{TEXTO_ORDEN_NUEVA_PRUEBAS}</span>
          </span>
        )}
        <button
          onClick={() => handleGenerateHojaMaterial()}
          className={`${claseBoton} bg-emerald-600 text-white hover:bg-emerald-700`}
          data-uso="presupuesto.pdf_hoja_material"
          title="Descargar Hoja de Material"
        >
          <Package className={claseIcono} />
          {texto('Hoja Material')}
        </button>
        {(presupuesto?.materiales_alquiler?.length > 0
          || (presupuesto?.jornadas || []).some(j => j?.materiales_alquiler?.length > 0)) && (
          <button
            onClick={() => handleGenerateHojaAlquiler()}
            className={`${claseBoton} bg-purple-600 text-white hover:bg-purple-700`}
            data-uso="presupuesto.pdf_alquiler"
            title="Descargar Hoja de Pedido Alquiler"
          >
            <Truck className={claseIcono} />
            {texto('Alquiler')}
          </button>
        )}
        <button
          onClick={() => handleGeneratePDF('Minuta')}
          className={`${claseBoton} bg-duetto-terracotta text-white hover:bg-opacity-90`}
          data-uso="presupuesto.pdf_minuta"
        >
          <MenuIcon className={claseIcono} />
          {texto('Minuta')}
        </button>
        <button
          onClick={() => handleGeneratePDF('Factura')}
          className={`${claseBoton} bg-blue-600 text-white hover:bg-blue-700`}
          data-uso="presupuesto.factura"
        >
          <Receipt className={claseIcono} />
          {texto('Factura')}
        </button>
      </div>
    );
  };

  // ===== Fase 2B: Resumen en tarjetas y pestaña Por hacer =====

  // Enlace de texto que lleva a otra pestaña de la ficha
  const renderEnlacePestana = (clave, texto) => (
    <button
      type="button"
      onClick={() => setPestanaActiva(clave)}
      className="self-start text-sm font-semibold text-[#11704F] hover:text-[#0B5139] hover:underline"
    >
      {texto}
    </button>
  );

  // Adaptaciones dietéticas guardadas en los menús del presupuesto
  const getResumenAlergenos = () => {
    const comensales = (presupuesto.comensales_alergicos || []).filter(Boolean);
    const lista = presupuesto.alergenos_lista || {};
    const estado = lista.estado || 'sin_lista';
    const porAlergeno = new Map();
    const porDieta = new Map();
    // Una fila puede ser un grupo sin nombres ("5 vegetarianos"): cuenta sus personas
    const personas = (c) => Math.max(1, parseInt(c.cantidad, 10) || 1);
    comensales.forEach((c) => (c.alergenos_ids || []).forEach((id) => porAlergeno.set(id, (porAlergeno.get(id) || 0) + personas(c))));
    comensales.forEach((c) => (c.dietas || []).forEach((id) => porDieta.set(id, (porDieta.get(id) || 0) + personas(c))));
    const texto = [
      ...[...porAlergeno.entries()]
        .map(([id, n]) => `${n} ${(ALERGENOS_OFICIALES.find(a => a.id === id)?.nombre || id).toLowerCase()}`),
      ...[...porDieta.entries()]
        .map(([id, n]) => `${n} ${(DIETAS.find(d => d.id === id)?.nombre || id).toLowerCase()}`),
    ].join(' · ');
    return {
      comensales: comensales.reduce((s, c) => s + personas(c), 0),
      estado,
      estadoTexto: TEXTO_ESTADO_LISTA[estado] || estado,
      texto,
      huellaCambiada: !!(lista.huella_cambiada && estado === 'validada_cocina'),
      aviso: lista.aviso || null,
      sinAlergicosPor: lista.sin_alergicos_por || null,
      sinAlergicosEn: lista.sin_alergicos_en || null,
    };
  };

  // Adaptaciones dietéticas del Resumen y de Por hacer. Multievento (M-65):
  // las de cada jornada con su etiqueta ("2 sin gluten (J2)"); las de la
  // pestaña Alérgenos se cuentan en esa pestaña.
  const getResumenAdaptaciones = () => resumenAdaptaciones(presupuesto);

  // Aviso de la fecha límite de cambios (informativo): 7 días antes del evento
  const renderAvisoFechaLimite = () => {
    if (presupuesto.estado === 'cancelado' || presupuesto.estado === 'rechazado') return null;
    const { inicio } = obtenerFechasEvento(presupuesto);
    const limite = calcularFechaLimiteCambios(inicio);
    if (!limite) return null;
    const hoy = inicioDelDia(new Date());
    if (inicio < hoy) return null;
    const fueraDePlazo = hoy > limite;
    const quedan = diasEntre(hoy, limite);
    return (
      <div
        className={`flex items-start gap-2.5 rounded-[10px] border px-3.5 py-3 text-sm ${
          fueraDePlazo ? 'bg-[#FDF0DC] border-[#F4D9AE] text-[#7A3A06]' : 'bg-[#E3F3EC] border-[#BFE3D2] text-[#0F5E43]'
        }`}
        data-testid="aviso-fecha-limite"
      >
        <Calendar className="w-4 h-4 flex-shrink-0 mt-0.5" />
        {fueraDePlazo ? (
          <span>
            <strong>Cambios fuera de plazo desde el {formatoDiaMes(sumarDias(limite, 1))}.</strong>{' '}
            La fecha límite era el {formatoDiaMes(limite)} ({DIAS_LIMITE_CAMBIOS} días antes del evento); lo que llegue ahora se acepta igual, pero queda fuera de plazo.
          </span>
        ) : (
          <span>
            <strong>Fecha límite de cambios: {formatoDiaMes(limite)}.</strong>{' '}
            {quedan === 0 ? 'Es hoy.' : `Quedan ${quedan} ${quedan === 1 ? 'día' : 'días'}.`}
          </span>
        )}
      </div>
    );
  };

  // Líneas del presupuesto en solo lectura (mismas funciones de totales que la tabla editable)
  // `editable` (Resumen 2): uds, precio e IVA de los menús con un clic, papelera
  // y botones pequeños de añadir; lo avanzado sigue en Líneas y menús
  const renderLineasCompactas = ({ editable = false } = {}) => {
    const costesTotal = costesGuardados?.guardado ? costesGuardados.coste_total : null;
    const claseTh = 'px-3.5 py-2.5 text-xs font-bold tracking-wide uppercase text-[#5B6B64] border-b border-[#E1E6E3]';
    const claseTd = 'px-3.5 py-3 text-sm border-b border-[#EEF1EF] align-top';
    const filas = [];
    items.forEach((item) => {
      const menuPers = item.type === 'menu' && item.personalizadoIndex !== undefined
        ? presupuesto.menus_personalizados?.[item.personalizadoIndex]
        : null;
      const detalles = [item.type === 'plato' ? 'Plato' : 'Menú'];
      if (item.udsJornadas) detalles.push(textoUnidadesJornadas(item.udsJornadas));
      if (menuPers?.hora_inicio_servicio || menuPers?.hora_fin_servicio) {
        detalles.push(`${menuPers.hora_inicio_servicio || '?'} a ${menuPers.hora_fin_servicio || '?'}`);
      }
      // Multievento (M-65): las adaptaciones de sus líneas en las jornadas
      const numAdaptaciones = menuPers ? numAdaptacionesLinea(menuPers, presupuesto) : 0;
      if (numAdaptaciones > 0) detalles.push(`${numAdaptaciones} ${numAdaptaciones === 1 ? 'adaptación' : 'adaptaciones'}`);
      filas.push({
        clave: `linea-${item.type}-${item.personalizadoIndex ?? item.id}`,
        item,
        concepto: item.concepto,
        detalle: detalles.join(' · '),
        requisitos: obtenerRequisitosMontaje(menuPers?.menu_id),
        uds: item.uds || 0,
        precio: item.precio_ud || 0,
        iva: item.iva_percent || 0,
        importe: calculateImporte(item),
      });
    });
    (presupuesto.suplementos || []).forEach((s) => {
      filas.push({
        clave: `suplemento-${s.id}`,
        suplemento: s,
        concepto: s.nombre,
        detalle: s.es_cortesia ? 'Suplemento · cortesía' : 'Suplemento',
        uds: s.unidades || 0,
        precio: s.precio_unitario || 0,
        iva: tipoIvaDe(s, CAMPOS_IVA_SUPLEMENTO),
        importe: s.es_cortesia ? 0 : (s.total || 0),
      });
    });
    return (
      <section className="bg-white border border-[#E1E6E3] rounded-xl overflow-hidden" data-testid="resumen-lineas">
        <div className="flex flex-wrap items-center justify-between gap-3 px-4 sm:px-5 py-4">
          <h2 className="text-base font-bold text-[#16221D]">Líneas del presupuesto</h2>
          {editable ? (
            <div className="flex flex-wrap items-center gap-2" data-testid="lineas-botones-compactos">
              <button type="button" onClick={() => setShowAddMenuModal(true)}
                className="h-8 px-3 rounded-lg border border-[#CBD3CF] bg-white text-xs font-semibold text-[#16221D] hover:bg-gray-50 inline-flex items-center gap-1"
                data-testid="lineas-anadir-menu" data-uso="lineas.anadir_menu">
                <Plus className="w-3.5 h-3.5" /> Menú existente
              </button>
              <button type="button" onClick={handleOpenCustomMenuModal}
                className="h-8 px-3 rounded-lg border border-duetto-secondary bg-white text-xs font-semibold text-[#11704F] hover:bg-[#E3F3EC] inline-flex items-center gap-1"
                data-testid="lineas-menu-personalizado" data-uso="lineas.menu_personalizado">
                <Plus className="w-3.5 h-3.5" /> Menú personalizado
              </button>
              <button type="button" onClick={() => setShowAddSuplementoModal(true)}
                className="h-8 px-3 rounded-lg border border-amber-400 bg-white text-xs font-semibold text-amber-700 hover:bg-amber-50 inline-flex items-center gap-1"
                data-testid="lineas-anadir-suplemento" data-uso="lineas.anadir_suplemento">
                <Plus className="w-3.5 h-3.5" /> Suplemento
              </button>
              {renderEnlacePestana('lineas', 'Más opciones')}
            </div>
          ) : renderEnlacePestana('lineas', 'Editar en Líneas y menús')}
        </div>
        {filas.length === 0 ? (
          <p className="px-4 sm:px-5 pb-4 text-sm text-[#5B6B64]">Todavía no hay menús ni suplementos.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[520px] border-collapse">
              <thead>
                <tr>
                  <th className={`${claseTh} text-left`}>Concepto</th>
                  <th className={`${claseTh} text-right`}>Uds</th>
                  <th className={`${claseTh} text-right`}>Precio</th>
                  <th className={`${claseTh} text-right`}>IVA</th>
                  <th className={`${claseTh} text-right`}>Total</th>
                  {editable && <th className={`${claseTh} w-24`} aria-label="Acciones" />}
                </tr>
              </thead>
              <tbody>
                {filas.map((f) => (
                  <tr key={f.clave}>
                    <td className={claseTd}>
                      <div className="font-semibold text-[#16221D]">{f.concepto}</div>
                      <div className="text-xs text-[#5B6B64]">{f.detalle}</div>
                      {f.requisitos && (
                        <div className="inline-flex items-center gap-1.5 mt-1.5 px-2 py-0.5 rounded-md text-xs font-bold text-[#92400E] bg-[#FDF0DC]">
                          <AlertCircle className="w-3.5 h-3.5 flex-shrink-0" /> Requisitos: {f.requisitos}
                        </div>
                      )}
                    </td>
                    {(() => {
                      // Menú editable: el mismo criterio que la tabla de Líneas y menús
                      const it = f.item;
                      const idx = it?.personalizadoIndex;
                      const editableMenu = editable && it && it.type === 'menu' && idx !== undefined && !esItemBebida(it);
                      const udsEditables = editableMenu && !it.udsJornadas
                        && !(formatoNuevo && esBarraLibreVinculada(idx));
                      const claseClic = 'cursor-pointer hover:text-[#11704F] hover:underline decoration-dotted';
                      const claseInput = 'w-20 border border-[#7FA897] rounded px-2 py-1 text-sm text-right tabular-nums';
                      return (
                        <>
                          <td className={`${claseTd} text-right tabular-nums`}>
                            {udsEditables && editingUnidadesMenuIndex === idx ? (
                              <input type="number" min="1" value={tempUnidades} autoFocus className={claseInput}
                                onChange={(e) => setTempUnidades(parseInt(e.target.value) || 0)}
                                onBlur={() => handleSaveUnidadesInline(idx)}
                                onKeyPress={(e) => { if (e.key === 'Enter') handleSaveUnidadesInline(idx); }} />
                            ) : udsEditables ? (
                              <span className={claseClic} title="Clic para cambiar las personas"
                                onClick={() => { setEditingUnidadesMenuIndex(idx); setTempUnidades(it.uds); }}>{f.uds}</span>
                            ) : (f.suplemento ? numeroEs(f.uds, 2) : f.uds)}
                          </td>
                          <td className={`${claseTd} text-right tabular-nums whitespace-nowrap`}>
                            {editableMenu && editingPriceMenuIndex === idx ? (
                              <input type="number" step="0.01" value={tempPrecio} autoFocus className={claseInput}
                                onChange={(e) => setTempPrecio(parseFloat(e.target.value) || 0)}
                                onBlur={() => handleSavePrecioInline(idx)}
                                onKeyPress={(e) => { if (e.key === 'Enter') handleSavePrecioInline(idx); }} />
                            ) : editableMenu ? (
                              <span className={claseClic} title="Clic para cambiar el precio por persona"
                                onClick={() => { setEditingPriceMenuIndex(idx); setTempPrecio(it.precio_ud); }}>{formatEuros(f.precio)}</span>
                            ) : formatEuros(f.precio)}
                          </td>
                          <td className={`${claseTd} text-right tabular-nums`}>
                            {editableMenu && editingIvaMenuIndex === idx ? (
                              <select value={tempIva} autoFocus className="border border-[#7FA897] rounded px-1 py-1 text-sm"
                                onChange={(e) => { const v = parseInt(e.target.value); setTempIva(v); handleSaveIvaInline(idx, v); }}
                                onBlur={() => setEditingIvaMenuIndex(null)}>
                                <option value={10}>10%</option>
                                <option value={21}>21%</option>
                              </select>
                            ) : editableMenu ? (
                              <span className={claseClic} title="Clic para cambiar el IVA"
                                onClick={() => { setEditingIvaMenuIndex(idx); setTempIva(it.iva_percent || 10); }}>{f.iva} %</span>
                            ) : `${f.iva} %`}
                          </td>
                          <td className={`${claseTd} text-right tabular-nums font-bold whitespace-nowrap`}>{formatEuros(f.importe)}</td>
                          {editable && (
                            <td className={`${claseTd} text-right`}>
                              {f.suplemento ? (
                                <button type="button" onClick={() => handleDeleteSuplemento(f.suplemento.id)}
                                  className="p-1 text-[#B42318] hover:text-[#8A1C12]" title="Quitar suplemento"
                                  data-testid={`resumen2-quitar-${f.clave}`}>
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              ) : it && !esItemBebida(it) ? (
                                <span className="inline-flex items-center gap-1">
                                {/* Dietas y alergias: todo en la pestaña Alérgenos (los 14
                                    alérgenos garantizados y las dietas sin garantía) */}
                                {it.type === 'menu' && it.menu_data && (
                                  <button type="button"
                                    onClick={() => setPestanaActiva('alergenos')}
                                    className="h-7 px-2 rounded-md border border-orange-300 text-[11px] font-semibold text-orange-700 hover:bg-orange-50"
                                    title="Alergias y dietas (vegetariano, vegano, sin cerdo, embarazada, sin lactosa) en la pestaña Alérgenos"
                                    data-testid={`resumen2-dietas-${f.clave}`} data-uso="lineas.dietas_alergias">
                                    Dietas y alergias
                                  </button>
                                )}
                                <button type="button"
                                  onClick={() => (formatoNuevo && it.type === 'menu' && idx !== undefined && esBarraLibreVinculada(idx)
                                    ? quitarBarraLibreVinculada(idx) : handleDeleteItem(it))}
                                  disabled={guardandoBarraLibre === `barra:${idx}`}
                                  className="p-1 text-[#B42318] hover:text-[#8A1C12] disabled:opacity-50" title="Quitar línea"
                                  data-testid={`resumen2-quitar-${f.clave}`}>
                                  <Trash2 className="w-4 h-4" />
                                </button>
                                </span>
                              ) : null}
                            </td>
                          )}
                        </>
                      );
                    })()}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="flex flex-wrap justify-end gap-x-8 gap-y-2 px-4 sm:px-5 py-4 bg-[#F7F9F8] text-sm">
          <span className="text-[#5B6B64]">Base <strong className="text-[#16221D] tabular-nums">{formatEuros(basePresupuesto())}</strong></span>
          <span className="text-[#5B6B64]">IVA <strong className="text-[#16221D] tabular-nums">{formatEuros(ivaPresupuesto())}</strong></span>
          <span className="text-[#5B6B64]">Coste interno <strong className="text-[#16221D] tabular-nums">{costesTotal === null ? 'sin calcular' : formatEuros(costesTotal)}</strong></span>
          <span className="text-base font-extrabold text-[#16221D] tabular-nums">Total {formatEuros(totalPresupuesto())}</span>
        </div>
        {renderAvisoLineasCongeladas()}
      </section>
    );
  };

  // Tarjeta "Resumen de costes · INTERNO": lo guardado por el motor único, con
  // la vista por partida y por menú dentro de la propia tarjeta
  const renderTarjetaCostes = () => (
    <ResumenCostes
      costes={costesGuardados}
      cargando={cargandoCostes}
      error={errorCostes}
      recalculando={recalculandoCostes}
      onRecalcular={recalcularCostes}
      hayPlatosBorrados={getPlatosFaltantes().length > 0}
    />
  );

  const renderPestanaResumen = () => {
    return (
      <div className="space-y-6">
        {avisoSinRuta && renderAvisoSinRuta()}
        {avisoMadridCentral && renderAvisoMadridCentral()}
        {/* Cancelado: motivo y lo que se deshizo (stock, lotes, pedidos anulados) */}
        {presupuesto.estado === 'cancelado' && (
          <div data-testid="resumen-cancelacion">{renderInfoCancelacion()}</div>
        )}
        {renderAvisoConfirmadoModificado()}
        {hayDepositoCliente && <div data-testid="deposito-cliente-alert">{renderAvisoDeposito()}</div>}
        {renderSobrante()}
        {renderAvisoFechaLimite()}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
          <div className="lg:col-span-2 space-y-6 min-w-0">
            {renderLineasCompactas()}
            {/* Cliente arriba; debajo, a la izquierda el contacto del evento con sus
                observaciones y a la derecha el de facturación con las notas para
                administración (mismos campos que en Líneas y menús y Facturación) */}
            {renderTarjetaNueva(null, (
              <>
                {renderCabeceraContacto()}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start" data-testid="resumen-contactos">
                  <div className="min-w-0" data-testid="resumen-observaciones">
                    {renderContactoEvento()}
                    {renderObservaciones()}
                  </div>
                  {/* Facturación en otro color para distinguirla del evento (en blanco) */}
                  <div className="min-w-0 rounded-xl border border-amber-200 bg-amber-50 p-3" data-testid="resumen-notas-administracion">
                    {renderContactoFacturacion()}
                    {renderNotasAdministracion()}
                  </div>
                </div>
              </>
            ), { testid: 'resumen-contacto' })}
          </div>
          <div className="space-y-6 min-w-0">
            {renderTarjetaCostes()}
          </div>
        </div>
      </div>
    );
  };


  // ===== Resumen 2: tarjeta de Líneas (diseño nuevo) =====
  // Una fila compacta por línea (concepto, personas, €/persona, IVA y total;
  // los tres primeros con un clic), etiquetas solo cuando aplican, "⋯" con lo
  // avanzado y una flecha que despliega los platos y, en la línea que lleva la
  // bebida incluida, las bebidas. Reutiliza las funciones de guardado de
  // Líneas y menús; el diseño es nuevo.
  const abrirEditarPlatosR2 = (idx) => {
    const menuPers = presupuesto.menus_personalizados?.[idx];
    if (!menuPers) return;
    setEditPlatosMenuIndex(idx);
    setEditedPlatos((menuPers.platos_ids || [])
      .filter(pid => { const p = platos.find(pl => pl.id === pid); return !p || p.activo !== false; })
      .map(pid => ({ platoId: pid, unidades: menuPers.unidades_por_plato?.[pid] || 1 })));
    setPlatoSearchTerm('');
    setPlatoFiltersEdit({ precioMax: '', categoria: '', sinAlergenos: [] });
    setShowEditPlatosModal(true);
  };

  const abrirDescuentoR2 = (idx) => {
    const menu = presupuesto.menus_personalizados?.[idx];
    if (!menu) return;
    setDescuentoMenuIndex(idx);
    setDescuentoData({ tipo: menu.descuento_tipo || 'porcentaje', valor: menu.descuento_valor || 0 });
    setShowDescuentoModal(true);
  };

  // Bebidas en una línea (Resumen 2): modo como selector, validar y el reparto
  // en texto; el bloque completo (personalizado) solo si se pide
  const guardarModoBebidasR2 = async (modo) => {
    if (!presupuesto?.id || bebidasR2.guardando) return;
    setBebidasR2(prev => ({ ...prev, guardando: true, error: null }));
    notificarGuardadoHijo('inicio');
    try {
      const { data } = await presupuestosAPI.setBebidasModo(presupuesto.id, modo);
      if (data && data.modo) setEstadoBebidasModo(data);
      cargarBebidasModo();
      notificarGuardadoHijo('ok');
      setBebidasR2(prev => ({ ...prev, guardando: false }));
    } catch (err) {
      notificarGuardadoHijo('error');
      setBebidasR2(prev => ({ ...prev, guardando: false, error: err?.response?.data?.detail || err.message }));
    }
  };

  // Unidades de cada bebida (ajuste del reparto): sin bajar del total
  // incluido; lo que pasa, "Bebida extra" cobrada o cortesía
  // `clave`: 'evento' o el id de la jornada (multievento), para su borrador
  const guardarUnidadesBebidasR2 = async (unidades, extra = null, jornadaId = null) => {
    if (!presupuesto?.id) return;
    const clave = jornadaId || 'evento';
    setBebidasR2(prev => ({ ...prev, guardando: true, error: null }));
    notificarGuardadoHijo('inicio');
    try {
      const { data } = await presupuestosAPI.setBebidasUnidades(presupuesto.id, unidades, extra, jornadaId);
      if (data && data.modo) setEstadoBebidasModo(data);
      notificarGuardadoHijo('ok');
      setBebidasR2(prev => {
        const borradores = { ...(prev.borradores || {}) };
        delete borradores[clave];
        return { ...prev, guardando: false, borradores, pregunta: null };
      });
      // El suplemento "Bebida extra" cambia importes y costes: se recarga la ficha
      if (fetchDataRef.current) fetchDataRef.current();
    } catch (err) {
      notificarGuardadoHijo('error');
      setBebidasR2(prev => ({ ...prev, guardando: false, error: err?.response?.data?.detail || err.message }));
    }
  };

  const renderBebidasCompactoR2 = () => {
    const est = estadoBebidasModo;
    if (!est || est.aplica === false || bebidasR2.completo) {
      return (
        <div>
          {renderBebidas()}
          {bebidasR2.completo && (
            <button type="button" onClick={() => setBebidasR2(prev => ({ ...prev, completo: false }))}
              className="mt-2 text-xs font-semibold text-[#11704F] hover:underline">Ver resumido</button>
          )}
        </div>
      );
    }
    const modos = Array.isArray(est.modos) && est.modos.length > 0 ? est.modos : [
      { valor: 'sin_alcohol', texto: 'Variado sin alcohol' },
      { valor: 'con_alcohol', texto: 'Variado con alcohol' },
    ];
    const modo = est.modo || 'sin_alcohol';
    const modosVisibles = modos.filter(m => ['sin_alcohol', 'con_alcohol'].includes(m.valor || m.id) || (m.valor || m.id) === modo);
    const validado = !!est.validado_en;
    const corto = (n) => String(n || '').replace(/\s+\d+\s*c?l\b/i, '');
    const ajusteJornadas = Array.isArray(est.ajuste_jornadas) ? est.ajuste_jornadas : [];

    // Editor de unidades: el del evento (un día) o el de una jornada
    const renderEditor = ({ clave, jornadaId, titulo, variado, aj }) => {
      const borrador = (bebidasR2.borradores || {})[clave];
      const valorDe = (b) => (borrador && borrador[b.ingrediente_id] !== undefined
        ? borrador[b.ingrediente_id] : (b.unidades_enteras ?? Math.ceil(Number(b.unidades) || 0)));
      const total = variado.reduce((acc, b) => acc + (parseInt(valorDe(b), 10) || 0), 0);
      const minimo = Number(aj.minimo) || 0;
      const unidadesBorrador = () => Object.fromEntries(variado.map(b => [b.ingrediente_id, parseInt(valorDe(b), 10) || 0]));
      const pregunta = bebidasR2.pregunta && bebidasR2.pregunta.clave === clave ? bebidasR2.pregunta.n : 0;
      const guardarBorrador = () => {
        if (total < minimo) {
          const faltan = minimo - total;
          setBebidasR2(prev => ({ ...prev, error: `${titulo ? `${titulo}: ` : ''}${faltan === 1 ? 'Falta 1 bebida' : `Faltan ${faltan} bebidas`}: el total incluido es ${minimo}.` }));
          return;
        }
        if (total > minimo) {
          setBebidasR2(prev => ({ ...prev, error: null, pregunta: { clave, n: total - minimo } }));
          return;
        }
        guardarUnidadesBebidasR2(unidadesBorrador(), null, jornadaId);
      };
      if (!aj.editable) {
        return (
          <p key={clave} className="text-xs text-[#33443C]">
            {titulo && <span className="font-semibold text-[#5B6B64] mr-1">{titulo}:</span>}
            {variado.map(b => `${corto(b.nombre)} ${b.unidades_enteras ?? Math.ceil(Number(b.unidades) || 0)}`).join(' · ')}
          </p>
        );
      }
      return (
        <div key={clave} className="space-y-1.5" data-testid={`r2-bebidas-unidades-${clave}`}>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
            {titulo && <span className="text-xs font-semibold text-[#5B6B64]">{titulo}:</span>}
            {variado.map(b => (
              <label key={b.ingrediente_id} className="inline-flex items-center gap-1 text-xs max-md:text-sm text-[#33443C]">
                {corto(b.nombre)}
                <input type="number" min="0" value={valorDe(b)}
                  onChange={(e) => {
                    const v = e.target.value;
                    setBebidasR2(prev => ({ ...prev, error: null, pregunta: null,
                      borradores: { ...(prev.borradores || {}), [clave]: { ...((prev.borradores || {})[clave] || unidadesBorrador()), [b.ingrediente_id]: v } } }));
                  }}
                  className="w-12 max-md:w-16 max-md:h-10 max-md:text-base border border-[#CBD3CF] rounded px-1 py-0.5 text-xs text-right tabular-nums"
                  data-testid={`r2-bebida-uds-${clave}-${b.ingrediente_id}`} />
              </label>
            ))}
          </div>
          <div className="flex flex-wrap items-center gap-2 text-xs">
            <span className={total < minimo ? 'text-[#8A1C12] font-semibold' : 'text-[#5B6B64]'}>
              Total {total} · incluidas {minimo}{total > minimo ? ` · ${total - minimo} de más` : ''}
            </span>
            {aj.extra > 0 && !borrador && (
              <span className="px-1.5 py-px rounded bg-[#FDF0DC] text-[#92400E] font-semibold">
                {aj.extra} Bebida extra{aj.extra_cortesia ? ' · cortesía' : ` · ${formatEuros(aj.extra * 1.5)}`}
              </span>
            )}
            {borrador && (
              <>
                <button type="button" disabled={bebidasR2.guardando} onClick={guardarBorrador}
                  className="h-7 max-md:h-10 px-2.5 rounded-md bg-duetto-primary text-white font-bold disabled:opacity-50"
                  data-testid={`r2-bebidas-guardar-${clave}`}>{bebidasR2.guardando ? 'Guardando...' : 'Guardar'}</button>
                <button type="button"
                  onClick={() => setBebidasR2(prev => { const bs = { ...(prev.borradores || {}) }; delete bs[clave]; return { ...prev, borradores: bs, pregunta: null, error: null }; })}
                  className="h-7 max-md:h-10 px-2 text-[#5B6B64] hover:underline">Cancelar</button>
              </>
            )}
            {!borrador && aj.vigente && (
              <button type="button" disabled={bebidasR2.guardando}
                onClick={() => guardarUnidadesBebidasR2(aj.reparto || {}, null, jornadaId)}
                className="h-7 max-md:h-10 px-2 text-[#11704F] font-semibold hover:underline" data-testid={`r2-bebidas-reparto-${clave}`}>
                Volver al reparto
              </button>
            )}
          </div>
          {aj.desfasado && !borrador && (
            <p className="text-xs text-[#92400E]">El ajuste anterior ya no vale porque cambiaron las personas o el modo: revisa las unidades.</p>
          )}
          {pregunta > 0 && (
            <div className="rounded-lg border border-amber-300 bg-amber-50 p-2.5 space-y-2" data-testid={`r2-bebidas-pregunta-${clave}`}>
              <p className="text-xs text-[#7A3A06] font-semibold">
                Has puesto {pregunta} {pregunta === 1 ? 'bebida' : 'bebidas'} más de las incluidas. Se añade la línea "Bebida extra" ({pregunta} × 1,50 €){titulo ? ` en ${titulo}` : ''}:
              </p>
              <div className="flex flex-wrap gap-2">
                <button type="button" disabled={bebidasR2.guardando} onClick={() => guardarUnidadesBebidasR2(unidadesBorrador(), 'cobrar', jornadaId)}
                  className="h-7 max-md:h-10 px-2.5 rounded-md bg-duetto-primary text-white text-xs font-bold disabled:opacity-50"
                  data-testid={`r2-bebidas-cobrar-${clave}`}>Cobrar {formatEuros(pregunta * 1.5)}</button>
                <button type="button" disabled={bebidasR2.guardando} onClick={() => guardarUnidadesBebidasR2(unidadesBorrador(), 'cortesia', jornadaId)}
                  className="h-7 max-md:h-10 px-2.5 rounded-md border border-amber-400 bg-white text-xs font-semibold text-amber-800 disabled:opacity-50"
                  data-testid={`r2-bebidas-cortesia-${clave}`}>Cortesía (sin cobrar)</button>
                <button type="button" onClick={() => setBebidasR2(prev => ({ ...prev, pregunta: null }))}
                  className="h-7 max-md:h-10 px-2 text-xs text-[#5B6B64] hover:underline">Volver</button>
              </div>
            </div>
          )}
        </div>
      );
    };

    return (
      <div className="space-y-2" data-testid="r2-bebidas-compacto">
        <div className="flex flex-wrap items-center gap-2">
          <select value={modo} disabled={bebidasR2.guardando}
            onChange={(e) => guardarModoBebidasR2(e.target.value)}
            className="h-8 max-md:h-11 max-md:text-base border border-[#CBD3CF] rounded-lg px-2 text-sm bg-white" data-testid="r2-bebidas-modo">
            {modosVisibles.map(m => <option key={m.valor || m.id} value={m.valor || m.id}>{m.nombre || m.texto || m.valor}</option>)}
          </select>
          <span className={`px-1.5 py-px rounded text-[11px] max-md:text-xs font-semibold ${validado ? 'bg-[#E3F3EC] text-[#0F5E43]' : 'bg-[#FDF0DC] text-[#92400E]'}`}>
            {validado ? 'validado' : 'pendiente de validar'}
          </span>
          {!validado && (
            <button type="button" disabled={bebidasR2.guardando} onClick={() => guardarModoBebidasR2(modo)}
              className="h-7 max-md:h-10 px-2.5 rounded-md bg-duetto-primary text-white text-xs font-bold disabled:opacity-50"
              data-testid="r2-bebidas-validar" data-uso="bebidas.validar">
              {bebidasR2.guardando ? 'Guardando...' : 'Validar'}
            </button>
          )}
          {modo === 'personalizado' && (
            <button type="button" onClick={() => setBebidasR2(prev => ({ ...prev, completo: true }))}
              className="text-xs font-semibold text-[#11704F] hover:underline">Elegir bebidas</button>
          )}
        </div>
        {ajusteJornadas.length > 0
          // Multievento: un editor por jornada (cada una con su total y su Bebida extra)
          ? ajusteJornadas.map(j => renderEditor({
            clave: j.jornada_id, jornadaId: j.jornada_id, titulo: j.etiqueta, variado: j.bebidas || [], aj: j,
          }))
          : renderEditor({
            clave: 'evento', jornadaId: null, titulo: null,
            variado: Array.isArray(est.bebidas_variado) ? est.bebidas_variado : [], aj: est.ajuste || {},
          })}
        {bebidasR2.error && <p className="text-xs text-[#8A1C12]">{bebidasR2.error}</p>}
      </div>
    );
  };

  const renderLineasResumen2 = () => {
    const menus = presupuesto.menus_personalizados || [];
    // La bebida va dentro de la primera línea que la lleva incluida (el lunch)
    const idxBebida = ocultarTarjetaBebidas ? -1 : menus.findIndex(m => m && m.bebida_incluida);
    const etiquetaBebida = faltanBebidasFicha ? (bebidasSinValidar ? 'sin validar' : 'sin confirmar') : 'validada';
    const chip = (texto, tono = 'gris', extra = {}) => (
      <span key={texto} className={`inline-flex items-center px-1.5 py-px rounded ${movilFicha ? 'text-xs' : 'text-[11px]'} font-semibold ${{
        gris: 'bg-[#EEF1EF] text-[#4A5A53]',
        ambar: 'bg-[#FDF0DC] text-[#92400E]',
        verde: 'bg-[#E3F3EC] text-[#0F5E43]',
        violeta: 'bg-violet-50 text-violet-800',
      }[tono]}`} {...extra}>{texto}</span>
    );
    const celdaEditable = (activa, valor, onEditar, input) => (activa ? input : (
      <button type="button" onClick={onEditar}
        className="tabular-nums rounded px-1 -mx-1 hover:bg-[#E3F3EC] hover:text-[#11704F]" title="Clic para cambiar">
        {valor}
      </button>
    ));
    const claseInput = 'w-16 border border-[#7FA897] rounded px-1.5 py-0.5 text-sm text-right tabular-nums';
    // Primera columna: el asa para arrastrar la línea
    const cols = 'grid grid-cols-[1.5rem_1.25rem_minmax(0,1fr)_3.5rem_5rem_3.25rem_5.5rem_3.5rem] items-center gap-x-2';
    const filas = [];
    // Horario en la fila: inputs de al menos 32 px en móvil, compactos en escritorio
    const claseHorario = 'h-8 sm:h-6 px-1 border border-[#CBD3CF] rounded text-xs text-[#33443C] bg-white tabular-nums focus:outline-none focus:ring-1 focus:ring-duetto-primary';
    const serviciosHorario = (estadoReglas?.horarios?.lineas || []).filter(x => x.clase === 'servicio');
    // La guía de la novedad señala el control de horas de la primera línea de servicio
    let guiaHorasPuesta = false;
    // Multievento: la hora, el tipo y "Acompaña a" de cada línea se guardan con
    // su endpoint y llegan al mismo servicio de cada jornada
    const esME = esMultieventoFicha();
    // Móvil: horas grandes (16 px, 44 px de alto) en la hoja "Editar línea"
    const claseHorarioMovil = 'h-11 px-2 border border-[#CBD3CF] rounded-lg text-base text-[#33443C] bg-white tabular-nums focus:outline-none focus:ring-2 focus:ring-duetto-primary disabled:opacity-60';
    // Móvil: la línea con una hoja abierta (editar u opciones)
    let lineaHojaMovil = null;
    let guiaLineaMovilPuesta = false;

    items.forEach((item) => {
      const idx = item.personalizadoIndex;
      const esMenu = item.type === 'menu' && idx !== undefined;
      const menuPers = esMenu ? menus[idx] : null;
      const bebida = esItemBebida(item);
      const editable = esMenu && !bebida;
      const barraVinculada = formatoNuevo && esMenu && esBarraLibreVinculada(idx);
      const udsEditables = editable && !item.udsJornadas && !barraVinculada;
      const clave = `r2-${item.type}-${idx ?? item.id}`;
      const abierta = !!lineasAbiertasR2[clave];
      const nDietas = menuPers ? numAdaptacionesLinea(menuPers, presupuesto) : 0;
      const requisitos = obtenerRequisitosMontaje(menuPers?.menu_id);
      const llevaBebidas = idx === idxBebida;
      // Horario del servicio editable en la fila. Servicio (o sin clasificar
      // todavía): hora de inicio y fin; complemento: a qué servicio acompaña;
      // suplemento: nada. En multievento se aplica a todos los días (con la
      // hora de cada día debajo: HorarioServicioMultievento).
      const fHorario = editable ? horarioLinea(idx) : null;
      const marcaHorario = menuPers?.requiere_horario === true ? 'servicio'
        : (menuPers?.requiere_horario === false ? 'complemento' : 'auto');
      const horarioEnFila = editable && !(esME && menuPers?.es_alquiler)
        && !(formatoNuevo && fHorario?.clase === 'suplemento');
      const complementoEnFila = horarioEnFila && formatoNuevo && fHorario?.clase === 'complemento';
      const horasEnFila = horarioEnFila && !complementoEnFila;
      const guiaHoras = horasEnFila && !guiaHorasPuesta;
      if (guiaHoras) guiaHorasPuesta = true;
      const etiquetas = [];
      if (item.udsJornadas) etiquetas.push(chip(textoUnidadesJornadas(item.udsJornadas)));
      if (!horarioEnFila && (menuPers?.hora_inicio_servicio || menuPers?.hora_fin_servicio)) {
        etiquetas.push(chip(`${menuPers.hora_inicio_servicio || '?'} a ${menuPers.hora_fin_servicio || '?'}`));
      }
      if (llevaBebidas) etiquetas.push(chip(`Bebida incluida · ${etiquetaBebida}`, faltanBebidasFicha ? 'ambar' : 'verde'));
      if (nDietas > 0) etiquetas.push(chip(`${nDietas} ${nDietas === 1 ? 'dieta' : 'dietas'}`, 'ambar'));
      if (menuPers?.descuento_valor) {
        etiquetas.push(chip(`Dto. ${menuPers.descuento_tipo === 'porcentaje' ? `${menuPers.descuento_valor} %` : formatEuros(menuPers.descuento_valor)}`, 'verde'));
      }
      if (requisitos) etiquetas.push(chip(`Requisitos: ${requisitos}`, 'ambar'));
      if (menuPers?.concepto_cliente) {
        etiquetas.push(chip(`El cliente ve: ${menuPers.concepto_cliente} (${textoUnidadesAlias(menuPers)})`, 'violeta'));
      }
      const platosMenu = (menuPers?.platos_ids || [])
        .map(pid => ({ plato: platos.find(pl => pl.id === pid), uds: menuPers.unidades_por_plato?.[pid] || 1 }))
        .filter(x => x.plato && x.plato.activo !== false);
      const desplegable = editable && (platosMenu.length > 0 || llevaBebidas);
      // Las mismas líneas que tienen las flechas se pueden arrastrar
      const movible = esMenu && !bebida;
      const destinoAqui = movible && destinoArrastreR2?.indice === idx ? destinoArrastreR2 : null;
      // Opciones de la línea (menú ⋯ del escritorio y hoja del móvil): mismas
      // condiciones y mismos handlers en los dos
      const accionesLinea = [];
      if (editable && menuPers) accionesLinea.push({ clave: 'platos', texto: 'Cambiar platos', onSelect: () => abrirEditarPlatosR2(idx) });
      if (editable && item.menu_data) {
        accionesLinea.push({ clave: 'dietas', texto: 'Dietas y alergias', onSelect: () => setPestanaActiva('alergenos'), navega: true });
        accionesLinea.push({ clave: 'adaptacion', texto: 'Adaptación manual (avanzado)', onSelect: () => { setSelectedMenuForAdaptacion(item); setShowAdaptacionModal(true); } });
      }
      if (editable) accionesLinea.push({ clave: 'descuento', texto: 'Descuento', onSelect: () => abrirDescuentoR2(idx) });
      if (editable && menuPers) {
        accionesLinea.push({
          clave: 'concepto-cliente', texto: 'Nombre para el cliente', testid: `r2-concepto-cliente-${idx}`,
          onSelect: () => abrirConceptoCliente('menu', idx, menuPers.concepto_cliente, menuPers.mostrar_platos_cliente),
        });
      }
      // Tipo de línea para el horario: servicio con hora, complemento o automático
      if (editable && formatoNuevo && fHorario && fHorario.clase !== 'suplemento' && puedeEditarHorarios) {
        accionesLinea.push({ tipo: 'separador', clave: 'sep-tipo-1' });
        accionesLinea.push({ tipo: 'titulo', clave: 'titulo-tipo', texto: 'Tipo de línea' });
        [
          ['servicio', 'Servicio con hora'],
          ['complemento', 'Complemento (acompaña a un servicio)'],
          ['auto', marcaHorario === 'auto'
            ? `Automático: ${fHorario.clase === 'servicio' ? 'servicio' : 'complemento'}` : 'Automático'],
        ].forEach(([valor, texto]) => accionesLinea.push({
          clave: `tipo-${valor}`, texto, marcado: marcaHorario === valor, testid: `r2-tipo-${valor}-${idx}`,
          onSelect: () => {
            if (valor === marcaHorario) return;
            const requiereHorario = valor === 'auto' ? null : valor === 'servicio';
            if (esME) {
              // Multievento: también en el mismo servicio de cada jornada
              guardarHorarioServicio({
                presupuestoId: presupuesto.id, indice: idx, linea: menuPers,
                cambios: { requiere_horario: requiereHorario }, antes: guardarPendienteFicha,
              }).then((data) => { if (data) alActualizarMultievento(); });
              return;
            }
            actualizarHorarioLinea(idx, { requiere_horario: requiereHorario });
          },
        }));
        accionesLinea.push({ tipo: 'separador', clave: 'sep-tipo-2' });
      }
      if (esMenu && idx > 0) accionesLinea.push({ clave: 'subir', texto: 'Subir', disabled: reordenandoLinea, onSelect: () => handleMoveMenuUp(idx) });
      if (esMenu && idx < menus.length - 1) accionesLinea.push({ clave: 'bajar', texto: 'Bajar', disabled: reordenandoLinea, onSelect: () => handleMoveMenuDown(idx) });
      if (esMenu && idx > 0) {
        accionesLinea.push({ clave: 'principio', texto: 'Mover al principio', disabled: reordenandoLinea, testid: `r2-mover-principio-${idx}`, onSelect: () => handleMoverLinea(idx, 0) });
      }
      if (esMenu && idx < menus.length - 1) {
        accionesLinea.push({ clave: 'final', texto: 'Mover al final', disabled: reordenandoLinea, testid: `r2-mover-final-${idx}`, onSelect: () => handleMoverLinea(idx, menus.length - 1) });
      }
      accionesLinea.push({
        clave: 'quitar', texto: 'Quitar', peligro: true,
        onSelect: () => (barraVinculada ? quitarBarraLibreVinculada(idx) : handleDeleteItem(item)),
      });
      // El control de horario de la línea (fila del escritorio y hoja del móvil)
      const controlHorario = (claseH, conGuia) => (
        <>
                {esME && (
                  <HorarioServicioMultievento
                    presupuesto={presupuesto}
                    indice={idx}
                    linea={menuPers}
                    fHorario={formatoNuevo ? fHorario : null}
                    serviciosHorario={serviciosHorario}
                    claseHorario={claseH}
                    guia={conGuia}
                    chip={chip}
                    onActualizado={alActualizarMultievento}
                    onAntesDeGuardar={guardarPendienteFicha}
                  />
                )}
                {!esME && (
                  <HorarioServicioUnDia
                    indice={idx}
                    linea={menuPers}
                    fHorario={fHorario}
                    esComplemento={complementoEnFila}
                    serviciosHorario={serviciosHorario}
                    claseHorario={claseH}
                    guia={conGuia}
                    chip={chip}
                    placeholderInicio={presupuesto.hora_inicio || ''}
                    placeholderFin={presupuesto.hora_fin || ''}
                    menus={presupuesto?.menus_personalizados}
                    onCambiar={actualizarHorarioLinea}
                    prefijo="r2"
                  />
                )}
        </>
      );
      // Móvil: horario de la tarjeta en texto
      let textoHorarioMovil = null;
      let horarioMovilSinHora = false;
      if (movilFicha && horarioEnFila) {
        if (complementoEnFila) {
          textoHorarioMovil = textoAcompana(fHorario, serviciosHorario);
        } else if (menuPers?.hora_inicio_servicio || menuPers?.hora_fin_servicio) {
          textoHorarioMovil = textoHorasServicio(menuPers.hora_inicio_servicio, menuPers.hora_fin_servicio);
        } else {
          textoHorarioMovil = 'Sin hora';
          horarioMovilSinHora = true;
        }
      }
      if (movilFicha && hojaMovil && typeof hojaMovil === 'object' && hojaMovil.clave === clave) {
        lineaHojaMovil = {
          clave, idx, item, acciones: accionesLinea, editable, udsEditables, barraVinculada,
          horario: horarioEnFila ? controlHorario(claseHorarioMovil, false) : null,
        };
      }
      const guiaLineaMovil = movilFicha && editable && !guiaLineaMovilPuesta;
      if (guiaLineaMovil) guiaLineaMovilPuesta = true;
      const tarjetaMovil = movilFicha ? (
        <div className="py-3">
          <div className="flex items-start gap-1">
            <button
              type="button"
              onClick={() => {
                if (editable) setHojaMovil({ tipo: 'linea', clave });
                else if (desplegable) setLineasAbiertasR2(prev => ({ ...prev, [clave]: !prev[clave] }));
              }}
              className={`min-w-0 flex-1 text-left rounded-lg -mx-1 px-1 ${editable ? 'active:bg-[#F4F6F4]' : 'cursor-default'}`}
              data-testid={`r2-tarjeta-${idx ?? item.id}`}
              data-guia={guiaLineaMovil ? 'ficha-movil-linea' : undefined}
            >
              <div className="flex items-start justify-between gap-3">
                <span className="min-w-0 font-semibold text-[15px] leading-snug text-[#16221D] line-clamp-2 break-words">{item.concepto}</span>
                <span className="shrink-0 text-[15px] font-bold tabular-nums text-[#16221D]">{formatEuros(calculateImporte(item))}</span>
              </div>
              <p className="mt-0.5 text-[13px] text-[#5B6B64] tabular-nums">
                {item.udsJornadas
                  ? `${formatEuros(item.precio_ud)} por persona · IVA ${item.iva_percent} %`
                  : `${item.uds} pers. × ${formatEuros(item.precio_ud)} · IVA ${item.iva_percent} %`}
              </p>
              {etiquetas.length > 0 && <div className="mt-1.5 flex flex-wrap gap-1">{etiquetas}</div>}
              {textoHorarioMovil && (
                <p className={`mt-1 text-[13px] tabular-nums ${horarioMovilSinHora ? 'font-semibold text-[#92400E]' : 'text-[#33443C]'}`}
                  data-testid={`r2-horario-texto-${idx}`}>
                  <Clock className="w-3.5 h-3.5 inline -mt-0.5 mr-1" />{textoHorarioMovil}
                </p>
              )}
            </button>
            {!bebida && (
              <button
                type="button"
                onClick={() => setHojaMovil({ tipo: 'opciones-linea', clave })}
                className="h-11 w-11 -mt-2 -mr-2 shrink-0 rounded-full flex items-center justify-center text-[#5B6B64] active:bg-[#EEF1EF]"
                aria-label="Opciones de la línea"
                data-testid={`r2-opciones-${idx ?? item.id}`}
              >
                <MoreHorizontal className="w-5 h-5" />
              </button>
            )}
          </div>
          {desplegable && (
            <button
              type="button"
              onClick={() => setLineasAbiertasR2(prev => ({ ...prev, [clave]: !prev[clave] }))}
              className="mt-1 h-10 pr-2 text-sm font-semibold text-[#11704F] flex items-center gap-1"
              aria-expanded={abierta}
            >
              {abierta ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
              {abierta ? 'Ocultar' : (llevaBebidas ? 'Ver platos y bebidas' : 'Ver platos')}
            </button>
          )}
        </div>
      ) : null;

      filas.push(
        <div key={clave}
          className={`relative border-b border-[#EEF1EF] last:border-b-0${movible && origenArrastreR2 === idx ? ' opacity-50' : ''}`}
          data-testid={`r2-linea-${idx ?? item.id}`}
          data-r2-idx={movible ? idx : undefined}>
          {destinoAqui && (
            <div className={`pointer-events-none absolute left-0 right-0 h-0.5 bg-[#1A9169] ${destinoAqui.antes ? '-top-px' : '-bottom-px'}`} />
          )}
          {movilFicha ? tarjetaMovil : (
          <div className={`${cols} py-2`}>
            {movible ? (
              <span draggable={!reordenandoLinea}
                onDragStart={(e) => alEmpezarArrastreR2(e, idx)}
                onDragEnd={limpiarArrastreR2}
                className={`-my-1.5 h-8 w-6 rounded flex items-center justify-center text-[#9AA8A2] hover:text-[#11704F] hover:bg-[#E3F3EC] ${reordenandoLinea ? 'cursor-wait opacity-40' : 'cursor-grab active:cursor-grabbing'}`}
                title="Arrastrar para reordenar" data-uso="presupuesto.linea_arrastrar" data-testid={`r2-arrastrar-${idx}`}>
                <GripVertical className="w-4 h-4" />
              </span>
            ) : <span />}
            {desplegable ? (
              <button type="button" onClick={() => setLineasAbiertasR2(prev => ({ ...prev, [clave]: !prev[clave] }))}
                className="text-[#5B6B64] hover:text-[#16221D]" aria-expanded={abierta}
                title={abierta ? 'Plegar' : (llevaBebidas ? 'Ver platos y bebidas' : 'Ver platos')}>
                {abierta ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
              </button>
            ) : <span />}
            <div className="min-w-0">
              <div className="font-semibold text-sm text-[#16221D] truncate" title={item.concepto}>{item.concepto}</div>
              {etiquetas.length > 0 && <div className="flex flex-wrap gap-1 mt-0.5">{etiquetas}</div>}
            </div>
            <div className="text-right text-sm">
              {celdaEditable(udsEditables && editingUnidadesMenuIndex === idx, item.uds,
                udsEditables ? () => { setEditingUnidadesMenuIndex(idx); setTempUnidades(item.uds); } : null,
                <input type="number" min="1" value={tempUnidades} autoFocus className={claseInput}
                  onChange={(e) => setTempUnidades(parseInt(e.target.value) || 0)}
                  onBlur={() => handleSaveUnidadesInline(idx)}
                  onKeyPress={(e) => { if (e.key === 'Enter') handleSaveUnidadesInline(idx); }} />)}
            </div>
            <div className="text-right text-sm whitespace-nowrap">
              {editable ? celdaEditable(editingPriceMenuIndex === idx, formatEuros(item.precio_ud),
                () => { setEditingPriceMenuIndex(idx); setTempPrecio(item.precio_ud); },
                <input type="number" step="0.01" value={tempPrecio} autoFocus className={claseInput}
                  onChange={(e) => setTempPrecio(parseFloat(e.target.value) || 0)}
                  onBlur={() => handleSavePrecioInline(idx)}
                  onKeyPress={(e) => { if (e.key === 'Enter') handleSavePrecioInline(idx); }} />)
                : <span className="tabular-nums">{formatEuros(item.precio_ud)}</span>}
            </div>
            <div className="text-right text-sm text-[#5B6B64]">
              {editable ? celdaEditable(editingIvaMenuIndex === idx, `${item.iva_percent} %`,
                () => { setEditingIvaMenuIndex(idx); setTempIva(item.iva_percent || 10); },
                <select value={tempIva} autoFocus className="border border-[#7FA897] rounded px-0.5 py-0.5 text-sm"
                  onChange={(e) => { const v = parseInt(e.target.value); setTempIva(v); handleSaveIvaInline(idx, v); }}
                  onBlur={() => setEditingIvaMenuIndex(null)}>
                  <option value={10}>10 %</option>
                  <option value={21}>21 %</option>
                </select>)
                : <span className="tabular-nums">{item.iva_percent} %</span>}
            </div>
            <div className="text-right text-sm font-bold text-[#16221D] tabular-nums whitespace-nowrap">{formatEuros(calculateImporte(item))}</div>
            {!bebida ? (
              <div className="flex items-center justify-end">
              {/* Mover la línea: el orden sale igual en presupuesto, PDF y facturas */}
              {esMenu && (
                <div className="flex flex-col -my-1">
                  <button type="button" disabled={idx === 0 || reordenandoLinea} onClick={() => handleMoveMenuUp(idx)}
                    className="h-3.5 w-5 flex items-center justify-center text-[#5B6B64] hover:text-[#11704F] disabled:opacity-25"
                    title="Subir" data-testid={`r2-subir-${idx}`}><ChevronUp className="w-3.5 h-3.5" /></button>
                  <button type="button" disabled={idx >= menus.length - 1 || reordenandoLinea} onClick={() => handleMoveMenuDown(idx)}
                    className="h-3.5 w-5 flex items-center justify-center text-[#5B6B64] hover:text-[#11704F] disabled:opacity-25"
                    title="Bajar" data-testid={`r2-bajar-${idx}`}><ChevronDown className="w-3.5 h-3.5" /></button>
                </div>
              )}
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button type="button" className="h-7 w-7 rounded-md flex items-center justify-center text-[#5B6B64] hover:bg-[#EEF1EF]"
                    title="Más opciones" data-testid={`r2-opciones-${idx ?? item.id}`}
                    data-guia={movible ? 'linea-opciones' : undefined}>
                    <MoreHorizontal className="w-4 h-4" />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="bg-white border-[#E1E6E3]">
                  {accionesLinea.map((a) => {
                    if (a.tipo === 'separador') return <DropdownMenuSeparator key={a.clave} className="bg-[#EEF1EF]" />;
                    if (a.tipo === 'titulo') {
                      return (
                        <DropdownMenuLabel key={a.clave} className="py-1 text-[11px] font-bold uppercase tracking-wide text-[#8A9892]">
                          {a.texto}
                        </DropdownMenuLabel>
                      );
                    }
                    return (
                      <DropdownMenuItem key={a.clave} disabled={a.disabled} className={a.peligro ? 'text-[#B42318]' : undefined}
                        onSelect={a.onSelect} data-testid={a.testid}>
                        {a.marcado !== undefined && (
                          <span className="w-4 inline-flex justify-center text-[#11704F]">
                            {a.marcado && <Check className="w-3.5 h-3.5" strokeWidth={3} />}
                          </span>
                        )}
                        {a.texto}
                      </DropdownMenuItem>
                    );
                  })}
                </DropdownMenuContent>
              </DropdownMenu>
              </div>
            ) : <span />}
            {/* Segunda fila de la rejilla, bajo el concepto y hasta el final: el horario */}
            {horarioEnFila && (
              <div className="col-start-3 col-span-6 mt-1 flex flex-wrap items-center gap-1.5 text-[11px] text-[#5B6B64]"
                data-testid={`r2-horario-${idx}`}>
                {controlHorario(claseHorario, guiaHoras)}
              </div>
            )}
          </div>
          )}
          {esMenu && esConceptoClienteAbierto('menu', idx) && (
            <div className="pl-[3.75rem] max-md:pl-0 pr-2 pb-2.5">
              {renderEditorConceptoCliente('menu', idx, menuPers?.concepto_cliente)}
            </div>
          )}
          {abierta && desplegable && (
            <div className="pl-[3.75rem] max-md:pl-0 pr-2 pb-2.5 space-y-2" data-testid={`r2-desplegable-${idx}`}>
              {platosMenu.length > 0 && (
                <div className="text-xs max-md:text-sm text-[#33443C]">
                  <span className="font-semibold text-[#5B6B64] mr-1">Platos:</span>
                  {platosMenu.map((x, i) => (
                    <span key={x.plato.id}>
                      {x.plato.nombre}{Number(x.uds) !== 1 ? ` ×${x.uds}` : ''}{i < platosMenu.length - 1 ? ' · ' : ''}
                    </span>
                  ))}
                  <button type="button" onClick={() => abrirEditarPlatosR2(idx)} className="ml-2 max-md:h-10 max-md:px-1 font-semibold text-[#11704F] hover:underline">
                    Cambiar
                  </button>
                </div>
              )}
              {llevaBebidas && (
                <div className="flex max-md:flex-col items-start gap-2" data-testid="r2-bebidas">
                  <span className="text-xs max-md:text-sm font-semibold text-[#5B6B64] pt-1.5">Bebidas:</span>
                  <div className="min-w-0 flex-1 max-md:w-full">{renderBebidasCompactoR2()}</div>
                </div>
              )}
            </div>
          )}
        </div>
      );
    });

    let suplementoHojaMovil = null;
    (presupuesto.suplementos || []).forEach((s) => {
      if (movilFicha) {
        const claveSup = `r2-sup-${s.id}`;
        if (hojaMovil && typeof hojaMovil === 'object' && hojaMovil.clave === claveSup) suplementoHojaMovil = s;
        filas.push(
          <div key={claveSup} className="py-3 border-b border-[#EEF1EF] last:border-b-0 flex items-start gap-1" data-testid={`r2-suplemento-${s.id}`}>
            <div className="min-w-0 flex-1">
              <div className="flex items-start justify-between gap-3">
                <span className="min-w-0 font-semibold text-[15px] leading-snug text-[#16221D] line-clamp-2 break-words">{s.nombre}</span>
                <span className="shrink-0 text-[15px] font-bold tabular-nums text-[#16221D]">{formatEuros(s.es_cortesia ? 0 : (s.total || 0))}</span>
              </div>
              <p className="mt-0.5 text-[13px] text-[#5B6B64] tabular-nums">
                {`${numeroEs(s.unidades || 0, 2)} × ${formatEuros(s.precio_unitario || 0)} · IVA ${tipoIvaDe(s, CAMPOS_IVA_SUPLEMENTO)} %`}
              </p>
              <div className="mt-1.5 flex flex-wrap gap-1">{chip(s.es_cortesia ? 'Suplemento · cortesía' : 'Suplemento', s.es_cortesia ? 'verde' : 'gris')}</div>
            </div>
            <button
              type="button"
              onClick={() => setHojaMovil({ tipo: 'suplemento', clave: claveSup })}
              className="h-11 w-11 -mt-2 -mr-2 shrink-0 rounded-full flex items-center justify-center text-[#5B6B64] active:bg-[#EEF1EF]"
              aria-label="Opciones del suplemento"
              data-testid={`r2-sup-opciones-${s.id}`}
            >
              <MoreHorizontal className="w-5 h-5" />
            </button>
          </div>
        );
        return;
      }
      filas.push(
        <div key={`r2-sup-${s.id}`} className={`${cols} py-2 border-b border-[#EEF1EF] last:border-b-0`}>
          <span />
          <span />
          <div className="min-w-0">
            <div className="font-semibold text-sm text-[#16221D] truncate" title={s.nombre}>{s.nombre}</div>
            <div className="flex flex-wrap gap-1 mt-0.5">{chip(s.es_cortesia ? 'Suplemento · cortesía' : 'Suplemento', s.es_cortesia ? 'verde' : 'gris')}</div>
          </div>
          <div className="text-right text-sm tabular-nums">{numeroEs(s.unidades || 0, 2)}</div>
          <div className="text-right text-sm tabular-nums whitespace-nowrap">{formatEuros(s.precio_unitario || 0)}</div>
          <div className="text-right text-sm text-[#5B6B64] tabular-nums">{tipoIvaDe(s, CAMPOS_IVA_SUPLEMENTO)} %</div>
          <div className="text-right text-sm font-bold text-[#16221D] tabular-nums whitespace-nowrap">{formatEuros(s.es_cortesia ? 0 : (s.total || 0))}</div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button type="button" className="h-7 w-7 rounded-md flex items-center justify-center text-[#5B6B64] hover:bg-[#EEF1EF]" title="Más opciones">
                <MoreHorizontal className="w-4 h-4" />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-white border-[#E1E6E3]">
              <DropdownMenuItem onSelect={() => handleToggleCortesiaSuplemento(s.id)}>
                {s.es_cortesia ? 'Quitar cortesía' : 'Marcar como cortesía'}
              </DropdownMenuItem>
              <DropdownMenuItem className="text-[#B42318]" onSelect={() => handleDeleteSuplemento(s.id)}>Quitar</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      );
    });

    // Bebidas sin línea que las lleve incluidas (elegidas a mano): fila propia plegable
    if (!ocultarTarjetaBebidas && idxBebida < 0) {
      const abierta = !!lineasAbiertasR2['r2-bebidas'];
      filas.push(
        <div key="r2-bebidas" className="border-b border-[#EEF1EF] last:border-b-0">
          {movilFicha ? (
            <button type="button" onClick={() => setLineasAbiertasR2(prev => ({ ...prev, 'r2-bebidas': !prev['r2-bebidas'] }))}
              className="w-full min-h-[48px] py-2 flex items-center gap-2 text-left" aria-expanded={abierta}>
              {abierta ? <ChevronDown className="w-4 h-4 shrink-0 text-[#5B6B64]" /> : <ChevronRight className="w-4 h-4 shrink-0 text-[#5B6B64]" />}
              <span className="font-semibold text-[15px] text-[#16221D]">Bebidas</span>
              {chip(etiquetaBebida, faltanBebidasFicha ? 'ambar' : 'verde')}
            </button>
          ) : (
          <div className={`${cols} py-2`}>
            <span />
            <button type="button" onClick={() => setLineasAbiertasR2(prev => ({ ...prev, 'r2-bebidas': !prev['r2-bebidas'] }))}
              className="text-[#5B6B64] hover:text-[#16221D]" aria-expanded={abierta}>
              {abierta ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
            </button>
            <div className="min-w-0 col-span-6">
              <span className="font-semibold text-sm text-[#16221D]">Bebidas</span>{' '}
              {chip(etiquetaBebida, faltanBebidasFicha ? 'ambar' : 'verde')}
            </div>
          </div>
          )}
          {abierta && <div className="pl-[3.75rem] max-md:pl-0 pr-2 pb-3">{renderBebidasCompactoR2()}</div>}
        </div>
      );
    }

    return (
      <section className="bg-white border border-[#E1E6E3] rounded-xl" data-testid="r2-lineas">
        <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-[#E1E6E3]">
          <h2 className="text-base font-bold text-[#16221D]">
            Líneas
            {presupuesto?.es_multi_evento && <span className="ml-2 text-xs font-semibold text-[#5B6B64]">de la cabecera: precio e IVA (las personas, en cada jornada)</span>}
          </h2>
          {!movilFicha && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button type="button" className="h-8 px-3 rounded-lg bg-duetto-primary text-white text-xs font-bold inline-flex items-center gap-1 hover:bg-opacity-90"
                data-testid="r2-anadir" data-uso="lineas.anadir">
                <Plus className="w-3.5 h-3.5" /> Añadir
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-white border-[#E1E6E3]">
              <DropdownMenuItem onSelect={() => setShowAddMenuModal(true)}>Menú del catálogo</DropdownMenuItem>
              <DropdownMenuItem onSelect={handleOpenCustomMenuModal}>Menú personalizado</DropdownMenuItem>
              <DropdownMenuItem onSelect={() => setShowAddSuplementoModal(true)}>Suplemento</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          )}
        </div>
        {/* Toda la lista es zona de soltar: el destino sale de la altura del puntero */}
        <div className="px-4" data-testid="r2-lista"
          onDragEnter={alArrastrarSobreListaR2}
          onDragOver={alArrastrarSobreListaR2}
          onDragLeave={alSalirDeListaR2}
          onDrop={alSoltarEnListaR2}>
          {!movilFicha && (
          <div className={`${cols} py-2 text-[11px] font-bold uppercase tracking-wide text-[#8A9892] border-b border-[#EEF1EF]`}>
            <span /><span /><span>Concepto</span><span className="text-right">Pers.</span><span className="text-right">€/pers.</span>
            <span className="text-right">IVA</span><span className="text-right">Total</span><span />
          </div>
          )}
          {filas.length === 0
            ? <p className="py-4 text-sm text-[#5B6B64]">{movilFicha ? 'Todavía no hay líneas: añade una abajo.' : 'Todavía no hay líneas: pulsa Añadir.'}</p>
            : filas}
        </div>
        {/* Móvil: añadir a ancho completo (mismas acciones que el desplegable Añadir) */}
        {movilFicha && (
          <div className="px-4 py-3 border-t border-[#E1E6E3] grid gap-2" data-testid="r2-anadir-movil">
            <button type="button" onClick={() => setShowAddMenuModal(true)}
              className="h-11 w-full rounded-lg border border-[#CBD3CF] bg-white text-[15px] font-semibold text-[#16221D] flex items-center justify-center gap-1.5 active:bg-gray-50"
              data-uso="lineas.anadir" data-uso-detalle="menu_catalogo">
              <Plus className="w-4 h-4" /> Menú del catálogo
            </button>
            <button type="button" onClick={handleOpenCustomMenuModal}
              className="h-11 w-full rounded-lg border border-duetto-secondary bg-white text-[15px] font-semibold text-[#11704F] flex items-center justify-center gap-1.5 active:bg-[#E3F3EC]"
              data-uso="lineas.anadir" data-uso-detalle="menu_personalizado">
              <Plus className="w-4 h-4" /> Menú personalizado
            </button>
            <button type="button" onClick={() => setShowAddSuplementoModal(true)}
              className="h-11 w-full rounded-lg border border-amber-400 bg-white text-[15px] font-semibold text-amber-700 flex items-center justify-center gap-1.5 active:bg-amber-50"
              data-uso="lineas.anadir" data-uso-detalle="suplemento">
              <Plus className="w-4 h-4" /> Suplemento
            </button>
          </div>
        )}
        <div className="flex flex-wrap justify-end gap-x-6 gap-y-1 px-4 py-3 bg-[#F7F9F8] border-t border-[#E1E6E3] rounded-b-xl text-sm">
          <span className="text-[#5B6B64]">Base <strong className="text-[#16221D] tabular-nums">{formatEuros(basePresupuesto())}</strong></span>
          <span className="text-[#5B6B64]">IVA <strong className="text-[#16221D] tabular-nums">{formatEuros(ivaPresupuesto())}</strong></span>
          <span className="text-base font-extrabold text-[#16221D] tabular-nums">Total {formatEuros(totalPresupuesto())}</span>
        </div>
        {renderAvisoLineasCongeladas()}
        {movilFicha && renderHojasLineaMovil(lineaHojaMovil, suplementoHojaMovil)}
      </section>
    );
  };

  // Móvil: guarda los campos cambiados en la hoja "Editar línea", uno detrás de
  // otro, con las funciones de la edición en línea (cada una con el estado del
  // render siguiente, como si se editaran de uno en uno)
  const guardarLineaMovil = async (idx, cambios) => {
    if (cambios.uds !== undefined) {
      setTempUnidades(cambios.uds);
      await esperarRenderMovil();
      await manejadoresLineaMovilRef.current.unidades(idx);
      await esperarRenderMovil();
    }
    if (cambios.precio !== undefined) {
      setTempPrecio(cambios.precio);
      await esperarRenderMovil();
      await manejadoresLineaMovilRef.current.precio(idx);
      await esperarRenderMovil();
    }
    if (cambios.iva !== undefined) {
      setTempIva(cambios.iva);
      await esperarRenderMovil();
      await manejadoresLineaMovilRef.current.iva(idx, cambios.iva);
    }
  };

  // Móvil: hojas de una línea del Resumen (editar y opciones) y de un suplemento
  const renderHojasLineaMovil = (linea, suplemento) => {
    const tipo = hojaMovil && typeof hojaMovil === 'object' ? hojaMovil.tipo : null;
    const item = linea?.item;
    // Sin separadores sueltos: el título del grupo ya lleva su raya
    const acciones = (linea?.acciones || []).filter((a, i, lista) => a.tipo !== 'separador'
      || (i > 0 && i < lista.length - 1 && lista[i + 1]?.tipo !== 'titulo'));
    return (
      <>
        <HojaEditarLineaMovil
          abierta={tipo === 'linea' && !!linea}
          onCerrar={cerrarHojaMovil}
          titulo={item?.concepto || 'Editar línea'}
          subtitulo="Editar línea"
          valores={{ uds: item?.uds, precio: item?.precio_ud, iva: item?.iva_percent || 10 }}
          editables={{ uds: !!linea?.udsEditables, precio: !!linea?.editable, iva: !!linea?.editable }}
          notaUds={linea && linea.editable && !linea.udsEditables
            ? (item?.udsJornadas ? 'Las personas se cambian en cada jornada.' : 'Las personas de esta línea no se cambian aquí.')
            : null}
          totalTexto={item ? `Total de la línea: ${formatEuros(calculateImporte(item))}` : null}
          onGuardar={(cambios) => guardarLineaMovil(linea.idx, cambios)}
          testid="hoja-editar-linea"
        >
          {linea?.horario && (
            <div className="pt-1">
              <p className="text-[13px] font-semibold text-[#5B6B64] mb-2">Horario (se guarda al cambiarlo)</p>
              <div className="flex flex-wrap items-center gap-2 text-sm text-[#5B6B64]" data-testid="hoja-editar-linea-horario">
                {linea.horario}
              </div>
            </div>
          )}
          {linea && (
            <button
              type="button"
              onClick={() => setHojaMovil({ tipo: 'opciones-linea', clave: linea.clave })}
              className="w-full h-11 rounded-lg border border-[#CBD3CF] bg-white text-[15px] font-semibold text-[#16221D] flex items-center justify-center gap-1.5 active:bg-gray-50"
              data-testid="hoja-editar-linea-mas-opciones"
            >
              <MoreHorizontal className="w-5 h-5" /> Más opciones
            </button>
          )}
        </HojaEditarLineaMovil>

        <HojaMovil
          abierta={tipo === 'opciones-linea' && !!linea}
          onCerrar={cerrarHojaMovil}
          titulo={item?.concepto || 'Opciones de la línea'}
          clave="ficha-hoja-opciones-linea"
          testid="hoja-opciones-linea"
        >
          <div className="py-1">
            {linea?.editable && (
              <FilaHojaMovil
                icono={Pencil}
                texto="Cambiar personas, precio, IVA u hora"
                onClick={() => setHojaMovil({ tipo: 'linea', clave: linea.clave })}
                data-testid="hoja-opciones-editar"
              />
            )}
            {acciones.map((a) => {
              if (a.tipo === 'titulo') return <SeparadorHojaMovil key={a.clave} titulo={a.texto} />;
              if (a.tipo === 'separador') return <SeparadorHojaMovil key={a.clave} />;
              return (
                <FilaHojaMovil
                  key={a.clave}
                  texto={a.texto}
                  marcado={a.marcado}
                  disabled={a.disabled}
                  tono={a.peligro ? 'peligro' : 'normal'}
                  onClick={enHojaMovil(a.onSelect, { navega: !!a.navega })}
                  data-testid={a.testid ? `${a.testid}-movil` : `hoja-opciones-${a.clave}`}
                />
              );
            })}
          </div>
        </HojaMovil>

        <HojaMovil
          abierta={tipo === 'suplemento' && !!suplemento}
          onCerrar={cerrarHojaMovil}
          titulo={suplemento?.nombre || 'Suplemento'}
          clave="ficha-hoja-suplemento"
          testid="hoja-suplemento"
        >
          {suplemento && (
            <div className="py-1">
              <FilaHojaMovil
                texto={suplemento.es_cortesia ? 'Quitar cortesía' : 'Marcar como cortesía'}
                onClick={enHojaMovil(() => handleToggleCortesiaSuplemento(suplemento.id))}
              />
              <FilaHojaMovil
                icono={Trash2}
                texto="Quitar"
                tono="peligro"
                onClick={enHojaMovil(() => handleDeleteSuplemento(suplemento.id))}
              />
            </div>
          )}
        </HojaMovil>
      </>
    );
  };

  // Resumen 2 (prueba para comparar): las líneas editables a todo el ancho,
  // bebidas, y debajo contactos y observaciones con el Resumen de costes
  const renderPestanaResumen2 = () => (
      <div className="space-y-6" data-testid="pestana-resumen2">
        {avisoSinRuta && renderAvisoSinRuta()}
        {avisoMadridCentral && renderAvisoMadridCentral()}
        {presupuesto.estado === 'cancelado' && (
          <div>{renderInfoCancelacion()}</div>
        )}
        {renderAvisoConfirmadoModificado()}
        {hayDepositoCliente && <div>{renderAvisoDeposito()}</div>}
        {renderSobrante()}
        {renderAvisoFechaLimite()}
        {renderAvisoPlatosFaltantes()}
        {/* Con "Líneas y menús" oculta: su aviso de horas de servicio, solo si
            falta alguna hora o hay un solape sin decidir */}
        {RESUMEN_NUEVO && ((estadoReglas?.horarios?.sin_hora || 0) > 0
          || (estadoReglas?.horarios?.sin_hora_jornadas || []).length > 0
          || (estadoReglas?.horarios?.solapes_pendientes || []).length > 0) && renderAvisoHorarios()}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
          <div className="lg:col-span-2 space-y-3 min-w-0">
            {renderLineasResumen2()}
            {/* Multievento: las jornadas con sus líneas y personas (el mismo
                bloque de Líneas y menús); el precio y el IVA, en la cabecera */}
            {(formatoNuevo ? !!presupuesto?.es_multi_evento : esMultieventoFicha()) && (
              <LineasPorJornada
                presupuesto={presupuesto}
                onActualizado={alActualizarMultievento}
                barraLibre={formatoNuevo ? {
                  estado: estadoBarraLibre,
                  guardando: guardandoBarraLibre,
                  error: errorBarraLibre,
                  alternar: alternarBarraLibre,
                } : null}
                soloLectura={lineasJornadaSoloLectura()}
                onOrdenCocina={(jornadaId) => handleGenerateOrdenCocina(jornadaId)}
                onOrdenCocinaNueva={(jornadaId) => handleGenerateOrdenCocinaNueva(jornadaId)}
              />
            )}
            {/* Avisos de reglas (suplemento mínimo, recomendación de cóctel) */}
            {formatoNuevo && (renderAvisoSuplementoMinimo() || renderAvisoHoraExtraLunch() || avisoSuplementoMinimo || renderRecomendacionCoctel()) && (
              <div className="space-y-2">
                {renderAvisoSuplementoMinimo()}
                {renderAvisoHoraExtraLunch()}
                {avisoSuplementoMinimo && <p className="text-xs text-red-700">{avisoSuplementoMinimo}</p>}
                {renderRecomendacionCoctel()}
              </div>
            )}
          </div>
          <div className="space-y-6 min-w-0">
            {renderTarjetaCostes()}
          </div>
        </div>
        {renderTarjetaNueva(null, (
          <>
            {renderCabeceraContacto()}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
              <div className="min-w-0">
                {renderContactoEvento()}
                {renderObservaciones()}
              </div>
              <div className="min-w-0 rounded-xl border border-amber-200 bg-amber-50 p-3">
                {renderContactoFacturacion()}
                {renderNotasAdministracion()}
              </div>
            </div>
          </>
        ), { testid: 'resumen2-contacto' })}
      </div>
  );

  // Tareas "Por hacer": se calculan con datos existentes del presupuesto
  const calcularTareasFicha = () => {
    const { inicio, fin } = obtenerFechasEvento(presupuesto);
    const ciclo = calcularCicloEvento();
    let coctel = null;
    if (estadoReglas) {
      coctel = [];
      const anadir = (c, etiqueta) => coctel.push({
        etiqueta,
        personas: c.personas,
        recomendados: c.camareros_recomendados,
        asignados: c.camareros_asignados,
        faltan: c.faltan_camareros,
      });
      if (estadoReglas.coctel?.aplica) anadir(estadoReglas.coctel, null);
      (estadoReglas.jornadas || []).forEach((j) => {
        if (j.coctel?.aplica) anadir(j.coctel, `Jornada ${j.indice}${j.fecha ? ` (${formatFecha(j.fecha).slice(0, 5)})` : ''}`);
      });
    }
    const haySobrante = !!(desperdicio && desperdicio.total_eur > 0 && desperdicio.detalle && desperdicio.detalle.length > 0);
    // U-96 (lote 7): "celebrado" con un solo criterio, el del servidor (la
    // última fecha del evento es anterior a hoy); ya no se usa la hora de fin
    return calcularTareasPorHacer({
      hoy: new Date(),
      // Lista de compra: resumen de seguimiento del GET (solo confirmados)
      compraResumen: presupuesto.estado === 'confirmado' ? (presupuesto.compra_resumen ?? null) : undefined,
      ahora: new Date(),
      estado: presupuesto.estado,
      fechaInicio: inicio,
      fechaFin: fin,
      // U-09: confirmado con fecha, personas o líneas cambiadas tras confirmar
      confirmadoModificado: presupuesto.confirmado_modificado
        || (avisoConfirmadoModificado ? { campos: [] } : null),
      numMenus: items.length,
      numSuplementos: (presupuesto.suplementos || []).length,
      baseImponible: basePresupuesto(),
      totalConIvaTexto: formatEuros(totalPresupuesto()),
      // Solo los envíos del presupuesto (no las peticiones de pago ni las órdenes a proveedores)
      envios: (presupuesto.registros_envios || []).filter(e => (e?.tipo_documento || 'presupuesto') === 'presupuesto'),
      bebidasConfirmadas: !faltanBebidas,
      // Del GET bebidas-modo que ya carga la ficha (null si aún no ha llegado)
      bebidasModo: bebidasModoActual,
      bebidasModoValidadoEn,
      bebidasModoAplica: estadoBebidasModo ? estadoBebidasModo.aplica !== false : null,
      hayBebidasPersonalizadas: (presupuesto.bebidas || []).length > 0,
      coctel,
      adaptaciones: getResumenAdaptaciones(),
      alergenos: getResumenAlergenos(),
      // Observaciones generales y de cada jornada: si mencionan una alergia o
      // una dieta sin registrar, la tarea de alérgenos queda pendiente
      observacionesTexto: textoObservacionesPresupuesto(presupuesto),
      // La persona elegida en Quién va cuenta como personal (también si aún
      // no figura en Personal asignado)
      numPersonal: (() => {
        const lista = presupuesto.personal_asignado || [];
        const pid = presupuesto.quien_va_evento?.persona_id;
        return lista.length + (pid && !lista.some(p => p.empleado_id === pid) ? 1 : 0);
      })(),
      numFurgonetas: (presupuesto.vehiculos_asignados || []).length,
      lugarEvento: presupuesto.lugar_evento,
      distanciaKm: presupuesto.distancia_km,
      // Sin ruta calculada (U-02): tarea con el botón Calcular ruta
      avisoRuta: avisoSinRuta,
      // Hora de fin sin definir (o igual a la de inicio): tarea para ponerla
      avisoHoraFin: avisoFinSinDefinir(presupuesto),
      sobrante: haySobrante
        ? { ingredientes: desperdicio.detalle.length, importe: desperdicio.total_eur, importeTexto: formatEuros(desperdicio.total_eur) }
        : null,
      contactoFacturacion: !!presupuesto.contacto_facturacion_id,
      facturado: ciclo.facturado,
      // Facturación por jornada: { emitidas, total } ("Facturado parcialmente")
      facturacionJornadas: ciclo.facturacionJornadas
        ? { emitidas: ciclo.facturacionJornadas.emitidas, total: ciclo.facturacionJornadas.total }
        : null,
      numeroFactura: presupuesto.numero_factura || facturaNormalExistente?.numero_factura || null,
      estadoPago: presupuesto.estado_pago,
      // Del GET estado-envio: cambios después del último envío al cliente
      envio: estadoEnvio && estadoEnvio.modificado_tras_envio ? {
        modificado: true,
        cambios: estadoEnvio.cambios || [],
        fecha: estadoEnvio.ultimo_envio?.fecha || null,
      } : null,
      // Del GET cobro-previo (null si aún no ha llegado)
      cobroPrevio,
      quienVa: getQuienVa(),
      // Multievento (D10): alquiler propio de cada jornada
      alquilerJornadas: resumenAlquilerJornadas(presupuesto),
      alquiler: estadoAlquiler && ((estadoAlquiler.lineas || []).length > 0 || estadoAlquiler.hay_recepcion) ? {
        lineas: estadoAlquiler.lineas.length,
        validado: !!estadoAlquiler.validado,
        validadoPor: estadoAlquiler.validado?.por || null,
        huellaCambiada: !!estadoAlquiler.huella_cambiada,
        estadoOrden: estadoAlquiler.orden ? (estadoAlquiler.orden.estado || 'borrador') : null,
        pagadoEn: estadoAlquiler.orden?.fianza_pagada_en || null,
        fianzaDevueltaEn: estadoAlquiler.orden?.fianza_devuelta_en || null,
        proveedor: estadoAlquiler.orden?.proveedor_nombre || estadoAlquiler.proveedor?.nombre || null,
        avisoFechas: estadoAlquiler.aviso_fechas || null,
        cotizacion: estadoAlquiler.orden?.cotizacion_recibida || null,
        // Recepción en el evento (se comprueba en la hoja de material impresa)
        hayRecepcion: !!estadoAlquiler.hay_recepcion,
        recepcionAplica: !!estadoAlquiler.recepcion_aplica,
        recepcionComprobada: !!estadoAlquiler.recepcion?.comprobada,
        recepcionPor: estadoAlquiler.recepcion?.por || null,
        recepcionEn: estadoAlquiler.recepcion?.en || null,
        recepcionIncidencias: estadoAlquiler.recepcion?.incidencias || '',
      } : null,
      material: estadoMaterial ? {
        validado: !!estadoMaterial.validado,
        validados: estadoMaterial.validados || 0,
        total: (estadoMaterial.ambitos || []).length,
        huellaCambiada: !!estadoMaterial.huella_cambiada,
        por: (estadoMaterial.ambitos || [])[0]?.por || null,
      } : null,
      // Suplemento de mínimo que faltaría en un presupuesto ya enviado o confirmado
      suplementoMinimo: estadoReglas?.suplemento_minimo ? {
        minimo: estadoReglas.suplemento_minimo.minimo,
        pendientes: (estadoReglas.suplemento_minimo.pendientes || []).map(sp => ({
          clave: sp.clave,
          servicio: sp.menu_vinculado_nombre || sp.formato_nombre || 'el servicio',
          jornada: sp.jornada_etiqueta || null,
          faltan: sp.faltan,
          importeTexto: `${sp.faltan} × ${formatEuros(sp.tarifa)} = ${formatEuros(sp.importe)}`,
        })),
      } : null,
      // Hora extra del lunch que faltaría en un presupuesto ya enviado o confirmado
      horaExtraLunch: estadoReglas?.hora_extra_lunch ? {
        pendientes: (estadoReglas.hora_extra_lunch.pendientes || []).map(sp => ({
          clave: sp.clave,
          jornada: sp.jornada_etiqueta || null,
          horaFin: sp.hora_fin,
          minutosExtra: sp.minutos_extra,
          importeTexto: formatEuros(sp.importe),
        })),
      } : null,
      horarios: estadoReglas?.horarios ? {
        aplica: !!estadoReglas.horarios.aplica,
        servicios: estadoReglas.horarios.servicios || 0,
        // Multievento: también los días sin hora con la cabecera con hora
        sinHora: (estadoReglas.horarios.sin_hora || 0) + (estadoReglas.horarios.sin_hora_jornadas || []).length,
        nombresSinHora: nombresSinHoraServicios(estadoReglas.horarios),
        // Solo los solapes de montaje sin decidir (aviso con dos botones)
        solapes: (estadoReglas.horarios.solapes_pendientes || [])
          .map(sol => ({ clave: sol.clave_decision, texto: sol.texto })),
      } : null,
      // Multievento: subtareas por jornada (dirección, hoja de material, orden
      // de cocina, personal si hay quién va por jornada y, en facturación por
      // jornada, la factura de cada día). Vacío en un evento de un día.
      jornadas: jornadasParaTareas(presupuesto, {
        materialAmbitos: estadoMaterial?.ambitos,
        // Con las facturas cargadas, una jornada está facturada si su factura está emitida
        facturasJornada: esFacturacionPorJornada() ? resumenFacturasJornadas().lista : null,
      }),
      modoFacturacion: presupuesto.facturacion_multi_evento || null,
    });
  };

  // Botón de cada tarea: abre el modal rápido con su bloque, lleva al sitio o
  // abre el modal que ya existe
  // "No hay alérgicos" desde Por hacer: el mismo POST que el botón de la
  // pestaña Alérgenos; la tarea pasa a "Sin alérgicos" hecha
  const marcarSinAlergicos = async () => {
    if (!presupuesto?.id) return;
    try {
      const { data } = await api.post(`/presupuestos/${presupuesto.id}/alergenos/estado`, { accion: 'sin_alergicos' });
      if (data && data.alergenos_lista) {
        setPresupuesto(prev => (prev ? { ...prev, alergenos_lista: data.alergenos_lista } : prev));
      } else if (fetchDataRef.current) {
        fetchDataRef.current();
      }
    } catch (error) {
      alert(error?.response?.data?.detail || 'No se pudo marcar Sin alérgicos');
    }
  };

  const ejecutarAccionTarea = (accion) => {
    switch (accion?.tipo) {
      case 'rapido':
        // El alquiler no es un modal: abre su panel en la pestaña Material
        if (accion.modal === 'alquiler') abrirPanelAlquiler();
        else setModalRapido(MODALES_RAPIDOS[accion.modal] ? accion.modal : null);
        break;
      case 'enviar_presupuesto': abrirEnvioPresupuesto(); break;
      case 'confirmar': handleConfirmar(); break;
      case 'desconfirmar': handleDesconfirmar(); break;
      case 'ir_lineas': setPestanaActiva('lineas'); break;
      case 'ir_alergenos': setPestanaActiva('alergenos'); break;
      case 'ir_personal': setPestanaActiva('logistica', 'quien'); break;
      case 'ir_material': setPestanaActiva('material'); break;
      case 'ir_compra': setPestanaActiva('compra'); break;
      case 'ir_logistica': setPestanaActiva('logistica', 'lugar'); break;
      case 'ir_horario': setPestanaActiva('logistica', 'horario'); break;
      case 'ir_facturacion': setPestanaActiva('facturacion'); break;
      case 'orden_cocina': handleGenerateOrdenCocina(accion.jornadaId || null); break;
      case 'orden_cocina_nueva': handleGenerateOrdenCocinaNueva(accion.jornadaId || null); break;
      case 'emitir_factura_jornada': {
        const jornada = (presupuesto.jornadas || []).find(j => j && j.id === accion.jornadaId);
        if (jornada) abrirModalFacturaJornada(jornada);
        break;
      }
      case 'proponer_horas': proponerHoras(); break;
      case 'calcular_ruta': calcularRutaGuardada(); break;
      case 'suplemento_minimo': handleSuplementoMinimo(accion.accion, accion.clave); break;
      case 'hora_extra_lunch': handleHoraExtraLunch(accion.accion, accion.clave); break;
      case 'solape': decidirSolape(accion.clave, accion.decision); break;
      case 'emitir_factura': handleGeneratePDF('Factura'); break;
      case 'pedir_cobro_previo': abrirModalCobroPrevio(); break;
      case 'sin_alergicos': marcarSinAlergicos(); break;
      default: break;
    }
  };

  const renderIconoTarea = (estado) => {
    if (estado === 'hecha') {
      return (
        <span className="w-[22px] h-[22px] rounded-full bg-duetto-primary text-white flex items-center justify-center" title="Hecha">
          <Check className="w-3 h-3" strokeWidth={3} />
        </span>
      );
    }
    if (estado === 'bloqueada') {
      return <span className="w-[22px] h-[22px] rounded-full border-2 border-dashed border-[#B7C1BC] box-border" title="Bloqueada" />;
    }
    if (estado === 'info') {
      return (
        <span className="w-[22px] h-[22px] rounded-full bg-[#EEF1EF] text-[#4A5A53] flex items-center justify-center" title="Informativa">
          <Info className="w-3.5 h-3.5" />
        </span>
      );
    }
    return <span className="w-[22px] h-[22px] rounded-full border-2 border-[#C9870F] box-border" title="Pendiente" />;
  };

  const renderPestanaPorHacer = (tareas) => {
    const porcentaje = tareas.total > 0 ? Math.round((tareas.hechas / tareas.total) * 100) : 0;
    const hoy = inicioDelDia(new Date());
    const cerrado = presupuesto.estado === 'cancelado' || presupuesto.estado === 'rechazado';
    let textoEvento = null;
    if (tareas.diasParaEvento !== null && !cerrado) {
      if (tareas.celebrado) textoEvento = 'Evento celebrado';
      else if (tareas.diasParaEvento > 0) textoEvento = `Evento en ${tareas.diasParaEvento} ${tareas.diasParaEvento === 1 ? 'día' : 'días'}`;
      else textoEvento = 'Evento en curso';
      if (tareas.diasParaEvento === 0) textoEvento = 'Evento hoy';
    }
    const limiteAbierto = tareas.fechaLimiteCambios && hoy <= tareas.fechaLimiteCambios;
    const hito = tareas.siguienteHito;
    const fechaHito = hito?.fecha
      ? hito.fecha.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'short' })
      : '';
    return (
      <div className="flex flex-col gap-3.5" data-testid="por-hacer">
        <div className="flex flex-wrap justify-between items-center gap-3">
          <div className="flex items-baseline gap-3.5">
            <span className="text-xl font-extrabold text-[#16221D]">Por hacer</span>
            <span className="text-sm text-[#5B6B64]" data-testid="por-hacer-progreso">
              {tareas.hechas} de {tareas.total} tareas hechas
            </span>
          </div>
          <div className="flex flex-wrap items-center gap-3 text-sm">
            {textoEvento && (
              <span className="font-bold text-[#0F5E43] bg-[#E3F3EC] px-3 py-1.5 rounded-full">{textoEvento}</span>
            )}
            {tareas.fechaLimiteCambios && !cerrado && !tareas.celebrado && (
              <span className={`font-bold px-3 py-1.5 rounded-full ${limiteAbierto ? 'text-[#92400E] bg-[#FDF0DC]' : 'text-[#8A1C12] bg-[#FDE8E6]'}`}>
                {limiteAbierto
                  ? `Fecha límite de cambios: ${formatoDiaMesCorto(tareas.fechaLimiteCambios)}`
                  : `Fuera de plazo desde el ${formatoDiaMesCorto(sumarDias(tareas.fechaLimiteCambios, 1))}`}
              </span>
            )}
            {hito && (
              <span className="text-[#33443C]" data-testid="siguiente-hito">
                Siguiente hito: <strong>{hito.texto}{fechaHito ? `, ${fechaHito}` : ''}</strong>
              </span>
            )}
          </div>
        </div>
        <div className="h-2 rounded-full bg-[#E6ECE9] overflow-hidden">
          <div className="h-2 bg-duetto-primary" style={{ width: `${porcentaje}%` }} />
        </div>
        {cerrado && (
          <p className="text-sm text-[#8A1C12] bg-[#FDE8E6] border border-[#F5C2BC] rounded-[10px] px-3.5 py-3">
            {presupuesto.estado === 'cancelado' ? 'Evento cancelado' : 'Presupuesto rechazado'}: no quedan tareas pendientes.
          </p>
        )}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-start">
          {tareas.fases.map((fase) => (
            <section
              key={fase.clave}
              className={`bg-white rounded-xl px-4 sm:px-[18px] py-4 ${fase.actual ? 'border-2 border-duetto-primary' : 'border border-[#E1E6E3]'}`}
              data-testid={`fase-${fase.clave}`}
            >
              <div className="flex justify-between items-center gap-2 mb-1">
                <span className="text-[15px] font-extrabold text-[#16221D]">
                  {fase.titulo}
                  {fase.actual && (
                    <span className="ml-1.5 text-xs font-bold text-[#0F5E43] bg-[#E3F3EC] px-2 py-0.5 rounded-full align-middle">FASE ACTUAL</span>
                  )}
                </span>
                <span className={`text-xs font-bold whitespace-nowrap ${fase.hechas === fase.total ? 'text-[#0F5E43]' : 'text-[#5B6B64]'}`}>
                  {fase.hechas} de {fase.total}
                </span>
              </div>
              {fase.tareas.map((t, i) => (
                <React.Fragment key={t.clave}>
                {t.jornada && t.jornada.id !== fase.tareas[i - 1]?.jornada?.id && (
                  // Multievento: las subtareas de cada jornada, agrupadas bajo su cabecera
                  <div
                    className="mt-2 pt-2 text-xs font-extrabold uppercase tracking-wide text-[#0F5E43]"
                    data-testid={`grupo-jornada-${fase.clave}-${t.jornada.id}`}
                  >
                    {t.jornada.etiqueta}
                  </div>
                )}
                <div
                  className={`grid grid-cols-[24px_minmax(0,1fr)_auto] gap-3 items-start py-3 border-b border-[#EEF1EF] last:border-b-0${t.jornada ? ' pl-3' : ''}`}
                  data-testid={`tarea-${t.clave}`}
                  data-estado={t.estado}
                >
                  {renderIconoTarea(t.estado)}
                  <div>
                    <div className={`text-sm font-bold ${t.estado === 'bloqueada' ? 'text-[#5B6B64]' : 'text-[#16221D]'}`}>{t.jornada ? (t.tituloEnGrupo || t.titulo) : t.titulo}</div>
                    <div className="text-[13px] text-[#5B6B64] mt-0.5">{t.descripcion}</div>
                    {t.nota && <div className="text-xs text-[#92400E] mt-0.5" data-testid={`tarea-nota-${t.clave}`}>{t.nota}</div>}
                  </div>
                  {Array.isArray(t.acciones) && t.acciones.length > 0 ? (
                    // Varias acciones (solape de montaje: "Añadir 1 extra" / "Ignorar";
                    // orden de cocina: descargar / nueva): siempre en columna y con
                    // ancho limitado, para que el título y la descripción no queden
                    // a una palabra por línea en la columna estrecha de la fase
                    <div className="flex flex-col gap-1.5 items-end max-w-[10.5rem]">
                      {t.acciones.map((a, i) => (
                        <button
                          key={a.etiqueta}
                          type="button"
                          onClick={() => ejecutarAccionTarea(a)}
                          disabled={a.tipo === 'solape' && !!decidiendoSolape}
                          data-testid={i === 0 ? `tarea-accion-${t.clave}` : `tarea-accion-${t.clave}-${i + 1}`}
                          className={`min-h-[34px] px-3 py-1.5 rounded-lg border text-[13px] font-bold leading-tight text-right disabled:opacity-50 disabled:cursor-not-allowed ${
                            a.principal
                              ? 'bg-duetto-primary border-duetto-primary text-white hover:bg-opacity-90'
                              : 'bg-white border-[#CBD3CF] text-[#16221D] hover:bg-gray-50'
                          }`}
                        >
                          {a.etiqueta}
                        </button>
                      ))}
                    </div>
                  ) : t.accion ? (
                    <button
                      type="button"
                      onClick={() => ejecutarAccionTarea(t.accion)}
                      data-testid={`tarea-accion-${t.clave}`}
                      className={`h-[34px] px-3 rounded-lg border text-[13px] font-bold whitespace-nowrap ${
                        t.accion.principal
                          ? 'bg-duetto-primary border-duetto-primary text-white hover:bg-opacity-90'
                          : 'bg-white border-[#CBD3CF] text-[#16221D] hover:bg-gray-50'
                      }`}
                    >
                      {t.accion.etiqueta}
                    </button>
                  ) : <span />}
                </div>
                </React.Fragment>
              ))}
            </section>
          ))}
        </div>
      </div>
    );
  };

  const renderPestanaProximamente = (texto) => renderTarjetaNueva(null, (
    <div className="py-8 text-center">
      <p className="text-base font-semibold text-[#16221D]">Próximamente</p>
      <p className="mt-1 text-sm text-[#5B6B64]">{texto}</p>
      <button
        type="button"
        onClick={() => setPestanaActiva('resumen')}
        className="mt-4 text-sm font-semibold text-[#11704F] hover:underline"
      >
        Ir a Resumen
      </button>
    </div>
  ));

  // ===== Hora por servicio (formato nuevo) =====
  // Clasificación de una línea (servicio o complemento) según el backend; solo
  // si corresponde a la línea que hay ahora en esa posición
  // Horas en solo lectura en la pestaña antigua "Líneas y menús": en
  // multievento (F5: escribía solo la cabecera; las horas van por el Resumen)
  // y sin el módulo de presupuestos (F1)
  const esMultieventoHoras = !!presupuesto?.es_multi_evento && (presupuesto?.jornadas || []).length > 0;
  const horasLineasSoloLectura = esMultieventoHoras || !puedeEditarHorarios;
  const horarioLinea = (indice) => {
    const f = estadoReglas?.horarios?.lineas?.[indice];
    const m = presupuesto?.menus_personalizados?.[indice];
    if (!f || !m || (f.menu_id || '') !== (m.menu_id || '')) return null;
    return f;
  };

  // Cambia campos de horario de una línea y guarda (con un pequeño retardo).
  // La usan el Resumen y Logística > Horario (HorasServicios). Ya guardado, se
  // recargan las reglas y los tramos de Quién va con la hora nueva.
  const actualizarHorarioLinea = (indice, cambios) => {
    const nuevos = [...(presupuesto.menus_personalizados || [])];
    nuevos[indice] = { ...nuevos[indice], ...cambios };
    setPresupuesto(prev => ({ ...prev, menus_personalizados: nuevos }));
    const guardado = guardarMenusConRetardo(nuevos);
    if (guardado && typeof guardado.then === 'function') {
      guardado.then((r) => {
        if (r && r.data && !r.sinCambios && !r.pendiente && !r.cancelado) setRecargaHorarios(n => n + 1);
      });
    }
  };

  // `jornadaId` (Logística > Horario con una jornada): las horas de ESA jornada
  // con su hora de inicio. Desde un botón llega el evento del clic: se ignora.
  const proponerHoras = async (jornadaId = null) => {
    if (!presupuesto?.id) return;
    const jid = typeof jornadaId === 'string' && jornadaId ? jornadaId : null;
    setProponiendoHoras(true);
    try {
      clearTimeout(window._menuHoraTimeout);
      // Lo pendiente de la ficha se guarda antes (no pisa luego las horas propuestas)
      await autoguardado.guardarYa();
      const { data } = await api.post(`/presupuestos/${presupuesto.id}/horarios/proponer`, jid ? { jornada_id: jid } : {});
      if (data?.horarios) setEstadoReglas(prev => (prev ? { ...prev, horarios: data.horarios } : prev));
      await fetchData();
      if ((data?.cambiados || []).length === 0 && (data?.jornadas_actualizadas || []).length === 0) {
        alert('No hay horas que proponer: todos los servicios ya tienen hora.');
      }
    } catch (error) {
      alert(`No se pudieron proponer las horas: ${error?.response?.data?.detail || error.message}`);
    } finally {
      setProponiendoHoras(false);
    }
  };

  const renderHorarioLinea = (indice) => {
    const f = horarioLinea(indice);
    const m = presupuesto?.menus_personalizados?.[indice] || {};
    // Los suplementos no llevan hora ni acompañan a ningún servicio
    if (!f || f.clase === 'suplemento') return null;
    const marca = m.requiere_horario === true ? 'servicio' : (m.requiere_horario === false ? 'complemento' : 'auto');
    const servicios = (estadoReglas?.horarios?.lineas || []).filter(x => x.clase === 'servicio');
    const claseSelect = 'px-1 py-0.5 border border-gray-200 rounded text-xs text-gray-700 bg-white focus:ring-1 focus:ring-duetto-primary';
    if (horasLineasSoloLectura) {
      // F5 / F1: multievento (el tipo y "Acompaña a" van por el Resumen, que
      // los lleva a todos los días) o sin el módulo de presupuestos
      const sv = servicios.find(x => x.indice === f.acompana_a_indice);
      return (
        <div className="mt-1 flex flex-wrap items-center gap-2 text-xs" data-testid={`horario-linea-${indice}`}>
          <span className="px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-700 font-semibold">
            {f.clase === 'servicio' ? (f.familia_nombre || 'Servicio con hora') : 'Complemento'}
          </span>
          {f.clase === 'servicio' && f.sin_hora && (
            <span className="px-1.5 py-0.5 rounded-full bg-[#FDF0DC] text-[#92400E] font-semibold" data-testid={`horario-sin-hora-${indice}`}>
              Sin hora
            </span>
          )}
          {f.clase === 'complemento' && (sv || f.acompana_a_nombre) && (
            <span className="text-gray-600">Acompaña a {sv?.nombre || f.acompana_a_nombre}</span>
          )}
          {esMultieventoHoras && <span className="text-gray-400">Se cambia en el Resumen</span>}
        </div>
      );
    }
    return (
      <div className="mt-1 flex flex-wrap items-center gap-2 text-xs" data-testid={`horario-linea-${indice}`}>
        <select
          value={marca}
          onChange={(e) => {
            const v = e.target.value;
            actualizarHorarioLinea(indice, { requiere_horario: v === 'auto' ? null : v === 'servicio' });
          }}
          className={claseSelect}
          title="Servicio con montaje (lleva hora) o complemento (acompaña a un servicio)"
          data-testid={`horario-tipo-${indice}`}
        >
          <option value="auto">{marca === 'auto' ? `Automático: ${f.clase === 'servicio' ? 'servicio' : 'complemento'}` : 'Automático'}</option>
          <option value="servicio">Servicio con hora</option>
          <option value="complemento">Complemento</option>
        </select>
        {f.clase === 'servicio' && f.familia_nombre && (
          <span className="px-1.5 py-0.5 rounded-full bg-[#E3F3EC] text-[#0F5E43] font-semibold">{f.familia_nombre}</span>
        )}
        {f.clase === 'servicio' && f.sin_hora && (
          <span className="px-1.5 py-0.5 rounded-full bg-[#FDF0DC] text-[#92400E] font-semibold" data-testid={`horario-sin-hora-${indice}`}>
            Sin hora{f.propuesta_inicio ? ` (propuesta ${f.propuesta_inicio} - ${f.propuesta_fin || '?'})` : ''}
          </span>
        )}
        {f.clase === 'complemento' && servicios.length > 0 && (
          <label className="inline-flex items-center gap-1 text-gray-600">
            Acompaña a
            <select
              value={f.acompana_a_indice ?? ''}
              onChange={(e) => {
                const destino = parseInt(e.target.value, 10);
                // U-14: también por linea_id (manda al leer; así no se mueve al quitar líneas)
                const lid = presupuesto?.menus_personalizados?.[destino]?.linea_id || null;
                actualizarHorarioLinea(indice, { acompana_a_indice: destino, acompana_a_linea_id: lid });
              }}
              className={claseSelect}
              data-testid={`horario-acompana-${indice}`}
            >
              {servicios.map(sv => (
                <option key={sv.indice} value={sv.indice}>
                  {sv.nombre}{sv.hora_inicio ? ` (${sv.hora_inicio})` : ''}
                </option>
              ))}
            </select>
          </label>
        )}
      </div>
    );
  };

  // Solape de montaje: "Añadir 1 extra" / "Ignorar" / restablecer (null).
  // Se guarda en quien_va_evento.solapes por el PUT de Quién va.
  const decidirSolape = async (clave, decision) => {
    if (!presupuesto?.id || !clave || decidiendoSolape) return;
    setDecidiendoSolape(clave);
    try {
      const { data } = await api.put(`/presupuestos/${presupuesto.id}/quien-va-evento`, { solapes: { [clave]: decision } });
      // Estado de Quién va al momento (tarea de extras); los horarios se
      // recargan solos al cambiar quien_va_evento
      if (data && data.tramos_defecto) setEstadoReglas(prev => (prev ? { ...prev, quien_va: data } : prev));
      setPresupuesto(prev => ({
        ...prev,
        quien_va_evento: data?.guardado || { ...(prev.quien_va_evento || {}), solapes: { ...((prev.quien_va_evento || {}).solapes || {}), [clave]: decision } },
      }));
    } catch (error) {
      alert(`No se pudo guardar la decisión del solape: ${error?.response?.data?.detail || error.message}`);
    } finally {
      setDecidiendoSolape(null);
    }
  };

  const renderAvisoHorarios = () => {
    const h = estadoReglas?.horarios;
    if (!h || !h.aplica || !(h.servicios > 0)) return null;
    // Multievento: también los días sin hora aunque la cabecera la tenga
    const n = (h.sin_hora || 0) + (h.sin_hora_jornadas || []).length;
    // Solo los solapes sin decidir: aviso con dos opciones, nada se impone
    const solapes = h.solapes_pendientes || [];
    return (
      <div
        className={`rounded-[10px] border px-3.5 py-3 text-sm flex flex-wrap items-center justify-between gap-3 ${
          n > 0 ? 'bg-[#FDF0DC] border-[#F4D9AE] text-[#7A3A06]' : 'bg-white border-[#E1E6E3] text-[#33443C]'}`}
        data-testid="horarios-servicios"
      >
        <div className="min-w-0 flex flex-col gap-1">
          <span>
            {n > 0
              ? <><strong>Falta la hora de {n} {n === 1 ? 'servicio' : 'servicios'}</strong> ({nombresSinHoraServicios(h).join(', ')}). Se puede guardar, enviar y confirmar, pero sin ella la orden de cocina y la hoja de material salen sin la hora{(h.sin_hora_jornadas || []).length > 0 ? ' (en los días sin hora, "Igualar todas" pone la del resto)' : ''}.</>
              : <>Hora de los servicios: {h.servicios} {h.servicios === 1 ? 'servicio' : 'servicios'} con hora. Los complementos van con el servicio al que acompañan.</>}
          </span>
          {solapes.map(sol => (
            <span key={sol.clave_decision} className="flex flex-wrap items-center gap-2 text-xs text-[#7A3A06]" data-testid="horarios-solape">
              <span>{sol.texto}</span>
              <button
                type="button"
                onClick={() => decidirSolape(sol.clave_decision, 'extra')}
                disabled={!!decidiendoSolape}
                className="h-[28px] px-2.5 rounded-lg border text-xs font-bold whitespace-nowrap bg-duetto-primary border-duetto-primary text-white hover:bg-opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
                data-testid="horarios-solape-extra"
              >
                Añadir 1 extra
              </button>
              <button
                type="button"
                onClick={() => decidirSolape(sol.clave_decision, 'ignorado')}
                disabled={!!decidiendoSolape}
                className="h-[28px] px-2.5 rounded-lg border text-xs font-bold whitespace-nowrap bg-white border-[#CBD3CF] text-[#16221D] hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                data-testid="horarios-solape-ignorar"
              >
                Ignorar
              </button>
            </span>
          ))}
        </div>
        {puedeEditarHorarios && <button
          type="button"
          onClick={proponerHoras}
          disabled={proponiendoHoras || n === 0}
          className={`h-[34px] px-3 rounded-lg border text-[13px] font-bold whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed ${
            n > 0 ? 'bg-duetto-primary border-duetto-primary text-white hover:bg-opacity-90' : 'bg-white border-[#CBD3CF] text-[#16221D] hover:bg-gray-50'}`}
          title="Rellena la hora de los servicios que no la tienen (no cambia las ya puestas)"
          data-testid="proponer-horas"
        >
          {proponiendoHoras ? 'Proponiendo...' : 'Proponer horas'}
        </button>}
      </div>
    );
  };

  // Líneas por jornada en solo lectura: evento pasado, facturado, cancelado o
  // rechazado (mismo criterio que la ficha: eventoPasado y estado)
  const lineasJornadaSoloLectura = () => {
    if (!presupuesto) return true;
    if (esEventoPasadoFicha()) return true;
    if (['cancelado', 'rechazado'].includes(presupuesto.estado)) return true;
    return !!calcularCicloEvento().facturado;
  };

  const renderPestanaLineas = () => (
    <div className="space-y-6">
      {renderAvisoHorarios()}
      {(!formatoNuevo || MOSTRAR_GESTOR_HEREDADO) && renderMultievento()}
      {(formatoNuevo ? !!presupuesto?.es_multi_evento : esMultieventoFicha()) && (
        <LineasPorJornada
          presupuesto={presupuesto}
          onActualizado={alActualizarMultievento}
          barraLibre={formatoNuevo ? {
            estado: estadoBarraLibre,
            guardando: guardandoBarraLibre,
            error: errorBarraLibre,
            alternar: alternarBarraLibre,
          } : null}
          soloLectura={lineasJornadaSoloLectura()}
          onOrdenCocina={(jornadaId) => handleGenerateOrdenCocina(jornadaId)}
          onOrdenCocinaNueva={(jornadaId) => handleGenerateOrdenCocinaNueva(jornadaId)}
        />
      )}
      {renderAvisoPlatosFaltantes()}
      {renderSobrante()}
      {renderTablaLineas()}
      {!ocultarTarjetaBebidas && renderTarjetaNueva('Bebidas', renderBebidas(), {
        accion: faltanBebidasFicha ? (
          <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-[#FDF0DC] text-[#92400E]">
            {bebidasSinValidar ? 'Sin validar' : 'Sin confirmar'}
          </span>
        ) : null,
        testid: 'lineas-bebidas',
      })}
      {/* Observaciones del evento y notas de facturación también aquí (las
          mismas del Resumen: se guardan solas en el mismo campo) */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
        {renderTarjetaNueva(null, renderObservaciones(), { testid: 'lineas-observaciones' })}
        {renderTarjetaNueva(null, renderNotasAdministracion(), { testid: 'lineas-notas-administracion' })}
      </div>
    </div>
  );

  // Furgonetas y personal asignado con el diseño de las tarjetas nuevas
  const renderFurgonetasNuevo = () => (
    <VehiculosAsignados
      presupuestoId={presupuesto?.id}
      presupuestoNumero={presupuesto?.numero}
      fechaEvento={presupuesto?.fecha_evento}
      jornadas={esMultievento(presupuesto) ? presupuesto.jornadas : undefined}
      vehiculosActuales={presupuesto?.vehiculos_asignados || []}
      onUpdate={(nuevosVehiculos) => {
        setPresupuesto(prev => ({ ...prev, vehiculos_asignados: nuevosVehiculos }));
      }}
      inTab={true}
      onGuardado={notificarGuardadoHijo}
      variante="nuevo"
      encolar={encolarGuardado}
    />
  );

  // Logística por jornada (multievento): guarda solo los campos que cambian de
  // una jornada (PUT de la jornada; `borrar` para vaciarlos), por la cola del
  // autoguardado, y la refleja en la ficha. Las reglas (zona, Madrid Central)
  // y los costes se vuelven a pedir solos al cambiar la jornada.
  const guardarJornadaLogistica = async (jornadaId, cambios) => {
    const tarea = async () => {
      try {
        return { res: await presupuestosAPI.updateJornada(id, jornadaId, cambios) };
      } catch (error) {
        return { error };
      }
    };
    const r = autoguardado
      ? await autoguardado.programar(`jornada:${jornadaId}:${Object.keys(cambios).sort().join(',')}`, tarea, { inmediato: true })
      : await tarea();
    if (r && r.error) throw r.error;
    const jornada = r?.res?.data?.jornada;
    if (jornada) {
      setPresupuesto(prev => (prev ? {
        ...prev,
        jornadas: (prev.jornadas || []).map(j => (j.id === jornadaId ? { ...j, ...jornada } : j)),
      } : prev));
    }
    if (formatoNuevo) cargarCostes();
    // Cambio de hora de inicio: servicios desplazados y aviso de los que tienen
    // hora fija o empiezan antes de la llegada (lo muestra el horario de la jornada)
    if (jornada) {
      return {
        ...jornada,
        serviciosDesplazados: Number(r?.res?.data?.servicios_desplazados) || 0,
        avisoHoras: r?.res?.data?.aviso_horas || null,
      };
    }
    return jornada;
  };

  // Logística en tres niveles (1 lugar y transporte, 2 horario, 3 quién va y
  // camareros). `soloNivel`: solo ese nivel, sin subpestañas (modal rápido de
  // "Dirección y transporte"); si no, abre el nivel pedido por la URL.
  const renderLogistica = ({ soloNivel = null } = {}) => (
    <Logistica2
      soloNivel={soloNivel}
      nivelPedido={soloNivel ? null : nivelLogisticaUrl}
      onNivelAplicado={limpiarNivelLogistica}
      presupuesto={presupuesto}
      onCambiarLugar={(lugar) => setPresupuesto(prev => ({ ...prev, lugar_evento: lugar }))}
      onSeleccionarLugar={seleccionarLugarEvento}
      onCalcularRuta={calcularRutaGuardada}
      calculandoRuta={calculandoRuta}
      reglasComerciales={reglasComerciales}
      estadoReglas={estadoReglas}
      accionEnCurso={accionReglaEnCurso}
      avisoTransporte={avisoTransporte}
      onAnadirTransporte={handleAnadirTransporte}
      onTransporteManual={handleTransporteManual}
      onTransporteAutomatico={handleTransporteAutomatico}
      onMadridCentral={handleMadridCentral}
      onCobrarTransporte={handleCobrarTransporte}
      hayOrdenExtra={getAjusteOrdenPersonalExtra().hayOrden}
      personasOrdenExtra={getAjusteOrdenPersonalExtra().personasOrden}
      onGuardado={alGuardarQuienVa}
      onAbrirSolicitud={() => setModalRapido('solicitud_extras')}
      onEstadoGuardado={notificarGuardadoHijo}
      autoguardado={autoguardado}
      onAbrirPersonal={() => setModalRapido('personal')}
      numPersonalAsignado={(presupuesto.personal_asignado || []).length}
      onPersonaGuardada={alGuardarPersonaQuienVa}
      slotExtra={renderSolicitudExtras()}
      slotFurgonetas={soloNivel ? null : renderFurgonetasNuevo()}
      onGuardarJornada={guardarJornadaLogistica}
      onPersonasJornada={alActualizarMultievento}
      onCambiarHorarioLinea={actualizarHorarioLinea}
      onProponerHoras={proponerHoras}
      proponiendoHoras={proponiendoHoras}
      onRecargarFicha={alActualizarMultievento}
      onAntesDeGuardarHorario={guardarPendienteFicha}
      recargaHorarios={recargaHorarios}
    />
  );

  // ===== Formato nuevo: quién va al evento (4.5) y modales rápidos de Por hacer =====

  // Estado guardado de "Quién va al evento" y si ya existe la orden de personal extra
  // Personal del menú: el estado de las reglas (recalculado por el backend con
  // los ratios del catálogo) y, mientras carga, lo guardado.
  const getFilasPersonalMenu = () => (
    estadoReglas?.quien_va?.personal_menu || presupuesto?.quien_va_evento?.personal_menu || []
  );

  const getQuienVa = () => {
    const q = presupuesto?.quien_va_evento || {};
    const modo = q.modo || null;
    // Las filas que cubre la persona que va al evento no cuentan como externas.
    // Multievento: la jornada que más personal lleva (cada una con sus menús).
    const sumaPersonas = (filas) => (filas || []).reduce((s, f) => s + personasFila(f), 0);
    const jornadasQv = estadoReglas?.quien_va?.jornadas || [];
    const personasMenu = jornadasQv.length > 0
      ? Math.max(0, ...jornadasQv.map(j => sumaPersonas(j.personal_menu)))
      : sumaPersonas(getFilasPersonalMenu());
    if (!modo && personasMenu === 0) return null;
    const orden = getAjusteOrdenPersonalExtra();
    return {
      modo,
      personasMenu,
      personasExternas: personasMenu + (modo === 'extra' ? 1 : 0),
      hayOrdenExtra: orden.hayOrden,
      personasOrden: orden.personasOrden,
    };
  };

  // Quién va guardado (Logística): quién va, coste de transporte y
  // línea de venta "Recogida" con los importes
  const alGuardarQuienVa = (quienVa, respuesta) => setPresupuesto(prev => ({
    ...prev,
    quien_va_evento: quienVa,
    // El coste de transporte depende de quién va (lo recalcula el backend)
    ...(respuesta && respuesta.coste_transporte !== undefined ? { coste_transporte: respuesta.coste_transporte } : {}),
    // Línea de venta "Recogida" (se añade, se quita o se regala sola) e importes
    ...(respuesta && Array.isArray(respuesta.suplementos) ? {
      suplementos: respuesta.suplementos,
      ...Object.fromEntries(['precio_total', 'importe_base', 'iva', 'importe_total']
        .filter(k => respuesta[k] !== undefined && respuesta[k] !== null).map(k => [k, respuesta[k]])),
    } : {}),
  }));
  // Equipo propio: persona elegida (queda como responsable en Personal asignado)
  const alGuardarPersonaQuienVa = (datos) => setPresupuesto(prev => ({
    ...prev,
    ...(datos?.quien_va_evento ? { quien_va_evento: datos.quien_va_evento } : {}),
    ...(Array.isArray(datos?.personal_asignado) ? { personal_asignado: datos.personal_asignado } : {}),
  }));

  // Orden de personal extra con las horas por tramos ya puestas (si no existe)
  const renderSolicitudExtras = () => {
    const q = presupuesto.quien_va_evento || {};
    const estado = estadoReglas?.quien_va || null;
    const tarifaExtra = estado?.calculo?.tarifa_extra ?? q.tarifa_extra ?? reglasComerciales?.quien_va_evento?.coste_hora_extra ?? 25;
    const tramos = estado?.tramos || q.tramos || {};
    // Multievento: cada jornada con sus tramos, su personal y su hora de
    // recogida (lo mismo que el motor de costes); si no, los del evento
    const estadoJornada = (jornada) => (estado?.jornadas || []).find(j => j.id === jornada?.id) || null;
    const sugerenciaPara = (horaInicio, horaLlegada, jornada = null) => {
      const ej = jornada ? estadoJornada(jornada) : null;
      return sugerenciaOrdenExtra({
        modo: q.modo,
        tramos: ej ? ej.tramos : tramos,
        horaInicio,
        horaLlegada,
        horaRecogida: ej ? ej.hora_recogida : (estado?.hora_recogida || q.hora_recogida || null),
        filasMenu: ej ? ej.personal_menu : getFilasPersonalMenu(),
        tarifaExtra,
        // Recogida (mismo día u otro día, quién recoge) y fecha del evento o de la jornada
        recogida: (ej ? ej.recogida : estado?.recogida) || q.recogida || null,
        fechaEvento: jornada?.fecha || presupuesto.fecha_evento || null,
      });
    };
    const onUpdate = (campos) => setPresupuesto(prev => ({ ...prev, ...campos }));
    const hayExternos = presupuesto.es_multi_evento && presupuesto.jornadas?.length > 0
      ? presupuesto.jornadas.some(j => !!sugerenciaPara(j.hora_inicio || presupuesto.hora_inicio, j.hora_llegada_estimada || presupuesto.hora_llegada_estimada, j))
      : !!sugerenciaPara(presupuesto.hora_inicio, presupuesto.hora_llegada_estimada);
    return (
      <div className="space-y-3" data-testid="solicitud-extras">
        {!hayExternos && (
          <p className="text-sm text-[#5B6B64]">En "Quién va al evento" no hay personal externo: la orden se abre con el sugerido de los menús.</p>
        )}
        {presupuesto.es_multi_evento && presupuesto.jornadas?.length > 0 ? (
          // Una sola orden para todo el multievento, con un bloque por jornada
          <OrdenPersonalExtra
            presupuesto={presupuesto}
            onUpdate={onUpdate}
            sugerenciasJornada={Object.fromEntries(presupuesto.jornadas.map(jornada => [
              jornada.id,
              sugerenciaPara(jornada.hora_inicio || presupuesto.hora_inicio, jornada.hora_llegada_estimada || presupuesto.hora_llegada_estimada, jornada),
            ]).filter(([, sug]) => !!sug))}
          />
        ) : (
          <OrdenPersonalExtra
            presupuesto={presupuesto}
            onUpdate={onUpdate}
            sugerencia={sugerenciaPara(presupuesto.hora_inicio, presupuesto.hora_llegada_estimada)}
          />
        )}
      </div>
    );
  };

  const renderContenidoModalRapido = (clave) => {
    switch (clave) {
      case 'direccion': return renderLogistica({ soloNivel: 'lugar' });
      case 'furgonetas': return renderFurgonetasNuevo();
      case 'personal': return renderPersonal();
      case 'bebidas': return renderBebidas();
      case 'contacto_facturacion':
        return (
          <div>
            {renderContactoFacturacion()}
            <button
              type="button"
              onClick={() => { setModalRapido(null); setShowNewContactoModal(true); }}
              className="px-3 py-1 bg-duetto-primary text-white text-xs rounded-lg hover:bg-opacity-90 flex items-center gap-1"
            >
              <Plus className="w-3 h-3" />
              Nuevo contacto
            </button>
          </div>
        );
      case 'alergenos':
        return (
          <PestanaAlergenos
            presupuestoId={id}
            presupuesto={presupuesto}
            correos={correosEvento}
            onActualizado={fetchData}
          />
        );
      case 'solicitud_extras': return renderSolicitudExtras();
      default: return null;
    }
  };

  // Modal rápido: el mismo bloque de la ficha; la tarea se recalcula al guardar
  const renderModalRapido = (tareas) => {
    const cfg = modalRapido ? MODALES_RAPIDOS[modalRapido] : null;
    const tarea = cfg ? tareas.fases.flatMap(f => f.tareas).find(t => t.clave === cfg.tarea) : null;
    let ancho = 'max-w-2xl';
    if (modalRapido === 'alergenos') ancho = 'max-w-6xl';
    else if (['personal', 'solicitud_extras', 'bebidas', 'direccion'].includes(modalRapido)) ancho = 'max-w-4xl';
    return (
      <Dialog open={!!cfg} onOpenChange={(abierto) => { if (!abierto) setModalRapido(null); }}>
        {cfg && (
          <DialogContent
            // Sin transform: los modales internos de los bloques (fixed) se
            // colocan respecto a la ventana y no respecto a este modal.
            className={`left-0 right-0 top-[4vh] mx-auto translate-x-0 translate-y-0 transform-none w-[calc(100%-2rem)] ${ancho} max-h-[92vh] overflow-y-auto bg-white p-5 sm:p-6 gap-3`}
            data-testid="modal-rapido"
            data-modal={modalRapido}
          >
            <div className="flex flex-wrap items-start justify-between gap-3 pr-8">
              <div className="min-w-0">
                <DialogTitle className="text-lg font-extrabold text-[#16221D]">{cfg.titulo}</DialogTitle>
                <DialogDescription className="text-sm text-[#5B6B64] mt-1">{cfg.descripcion}</DialogDescription>
              </div>
              {tarea && tarea.estado !== 'info' && (
                <span
                  className={`px-2.5 py-1 rounded-full text-xs font-bold whitespace-nowrap ${
                    tarea.estado === 'hecha' ? 'bg-[#E3F3EC] text-[#0F5E43]' : 'bg-[#FDF0DC] text-[#92400E]'
                  }`}
                  data-testid="modal-rapido-estado"
                  data-estado={tarea.estado}
                >
                  {tarea.estado === 'hecha' ? 'Tarea hecha' : 'Tarea pendiente'}
                </span>
              )}
            </div>
            <div className="min-w-0">{renderContenidoModalRapido(modalRapido)}</div>
            <div className="flex flex-wrap items-center justify-between gap-3 border-t border-[#E1E6E3] pt-3">
              <button
                type="button"
                onClick={() => { const { pestana: destino, nivel } = cfg; setModalRapido(null); setPestanaActiva(destino, nivel || null); }}
                className="text-sm font-semibold text-[#11704F] hover:text-[#0B5139] hover:underline"
                data-testid="modal-rapido-pestana"
              >
                Abrir la pestaña completa
              </button>
              <button
                type="button"
                onClick={() => setModalRapido(null)}
                className="h-[34px] px-3 rounded-lg border border-[#CBD3CF] bg-white text-[13px] font-bold text-[#16221D] hover:bg-gray-50"
              >
                Cerrar
              </button>
            </div>
          </DialogContent>
        )}
      </Dialog>
    );
  };

  // Material del evento: lista consolidada, ajustes a mano y validación; la
  // respuesta se copia al estado de la ficha para no reenviar una copia vieja
  // (función normal: aquí ya no puede haber hooks, hay returns antes)
  const alCambiarMaterial = (datos) => {
    if (!datos) return;
    const campos = {
      material_validado: datos.validado || null,
      ...(datos.material_evento !== undefined ? { material_evento: datos.material_evento } : {}),
    };
    setPresupuesto((prev) => {
      if (!prev) return prev;
      if (!datos.jornada_id) {
        const igual = JSON.stringify([prev.material_validado || null, prev.material_evento || null])
          === JSON.stringify([campos.material_validado, campos.material_evento || null]);
        return igual ? prev : { ...prev, ...campos };
      }
      const jornadasPrev = prev.jornadas || [];
      const j = jornadasPrev.find(x => x?.id === datos.jornada_id);
      if (!j) return prev;
      const igual = JSON.stringify([j.material_validado || null, j.material_evento || null])
        === JSON.stringify([campos.material_validado, campos.material_evento || null]);
      if (igual) return prev;
      return { ...prev, jornadas: jornadasPrev.map(x => (x?.id === datos.jornada_id ? { ...x, ...campos } : x)) };
    });
    cargarEstadoMaterial();
  };

  // Alquiler (formato nuevo): la línea de venta al cliente y los costes los
  // recalcula el backend; se recarga el presupuesto si no hay nada pendiente
  const alCambiarAlquiler = (datos) => {
    // El estado del Resumen y de Por hacer es el del evento; el de una jornada
    // sale de sus `materiales_alquiler` al recargar el presupuesto
    if (!alquilerJornadaId && datos && Array.isArray(datos.lineas)) setEstadoAlquiler(datos);
    if (!autoguardadoRef.current.hayPendientes() && fetchDataRef.current) fetchDataRef.current();
    cargarCostes();
  };

  // Pestaña Material: a la izquierda "Material del evento" y a la derecha el
  // resumen "Material a alquilar" (encima en móvil, fijo al bajar en
  // escritorio). Al abrir el alquiler, su panel se despliega a ancho completo
  // ENCIMA del material y el resumen se oculta hasta "Cerrar alquiler".
  const renderPestanaMaterial = () => {
    const articulosAlquiler = (estadoAlquiler?.lineas || []).length;
    return (
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
        {alquilerAbierto && (
          <div className="lg:col-span-3 min-w-0 scroll-mt-4" ref={panelAlquilerRef}>
            {renderTarjetaNueva(null, (
              <div className="flex flex-col gap-3">
                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={() => setAlquilerAbierto(false)}
                    className="text-sm font-semibold text-duetto-primary hover:underline"
                    data-testid="alquiler-cerrar"
                  >
                    Cerrar alquiler
                  </button>
                </div>
                {/* Multievento (D10): alquiler del evento o de una jornada, como en Material */}
                {esMultievento(presupuesto) && (
                  <div className="flex flex-wrap items-center justify-between gap-3">
                    <SelectorJornadas
                      jornadas={opcionesAlquilerJornadas(presupuesto).filter(o => o.id)}
                      jornadaId={alquilerJornadaId}
                      onChange={setAlquilerJornadaId}
                      conTodas
                      textoTodas="Todo el evento"
                      idDe={(o) => o.id}
                      etiqueta={(o) => o.etiqueta}
                      testid="alquiler-jornadas"
                      prefijoTestid="alquiler-jornada"
                    />
                    {alquilerJornadaId && (
                      <button
                        type="button"
                        onClick={() => handleGenerateHojaAlquiler(alquilerJornadaId)}
                        className="text-sm font-semibold text-duetto-primary hover:underline"
                        data-testid="alquiler-hoja-jornada"
                      >
                        Hoja de alquiler de esta jornada
                      </button>
                    )}
                  </div>
                )}
                {esMultievento(presupuesto) && (
                  <p className="text-xs text-[#5B6B64]" data-testid="alquiler-ambito">
                    {alquilerJornadaId
                      ? 'Alquiler solo de esta jornada: se pide para su fecha y se cobra en su factura.'
                      : 'Alquiler de todo el evento: se pide una vez y se cobra una vez, con la primera factura.'}
                  </p>
                )}
                <AlquilerEvento
                  key={alquilerJornadaId || 'evento'}
                  presupuestoId={presupuesto.id}
                  presupuesto={presupuesto}
                  jornadaId={alquilerJornadaId}
                  datosIniciales={alquilerJornadaId ? null : estadoAlquiler}
                  onCambio={alCambiarAlquiler}
                  onEstadoGuardado={notificarGuardadoHijo}
                />
              </div>
            ), { testid: 'material-alquiler' })}
          </div>
        )}
        {!alquilerAbierto && (
          <div className="min-w-0 lg:col-start-3 lg:row-start-1 lg:sticky lg:top-4">
            {renderTarjetaNueva(null, (
              <>
                <ResumenAlquiler
                  datos={estadoAlquiler}
                  fechaEvento={presupuesto.fecha_evento}
                  onAbrir={abrirPanelAlquiler}
                />
                {/* Multievento (D10): alquiler propio de cada jornada */}
                {resumenAlquilerJornadas(presupuesto).length > 0 && (
                  <ul className="mt-3 flex flex-col gap-1 text-sm text-[#33443C]" data-testid="alquiler-resumen-jornadas">
                    {resumenAlquilerJornadas(presupuesto).map(r => (
                      <li key={r.jornadaId} className="flex items-center justify-between gap-2">
                        <span className={r.validado ? '' : 'text-[#7A3A06]'}>{r.texto}</span>
                        <button
                          type="button"
                          onClick={() => { setAlquilerJornadaId(r.jornadaId); abrirPanelAlquiler(); }}
                          className="text-xs font-semibold text-duetto-primary hover:underline"
                          data-testid={`alquiler-resumen-jornada-${r.jornadaId}`}
                        >
                          Abrir
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </>
            ), { testid: 'material-alquiler-resumen' })}
          </div>
        )}
        <div className={`lg:col-span-2 min-w-0 ${alquilerAbierto ? '' : 'lg:col-start-1 lg:row-start-1'}`}>
          {renderTarjetaNueva('Material del evento', (
            <PestanaMaterial
              presupuestoId={presupuesto.id}
              presupuesto={presupuesto}
              onCambio={alCambiarMaterial}
              onEstadoGuardado={notificarGuardadoHijo}
              onDescargarHoja={(jornadaId, diseno) => handleGenerateHojaMaterial(jornadaId, diseno)}
              autoguardado={autoguardado}
              articulosAlquiler={articulosAlquiler}
              onAbrirAlquiler={abrirPanelAlquiler}
            />
          ), { testid: 'material-evento' })}
        </div>
      </div>
    );
  };

  // Lista de compra (motor nuevo, en paralelo a Compras): la calcula el backend
  const renderPestanaListaCompra = () => renderTarjetaNueva('Lista de compra', (
    <PestanaListaCompra presupuestoId={presupuesto.id} presupuesto={presupuesto} />
  ), { testid: 'lista-compra' });

  // ===== Formato nuevo: pestaña Facturación y cobros =====

  const fechaDocumento = (valor) => {
    const t = String(valor || '').slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(t)) return '-';
    return `${t.slice(8, 10)}/${t.slice(5, 7)}/${t.slice(0, 4)}`;
  };

  const esFacturaPorJornada = () => !!(presupuesto.es_multi_evento && presupuesto.facturacion_multi_evento === 'por_jornada');

  // Una fila por documento: proforma, factura vigente, facturas de jornada o
  // rango (multievento), rectificativas, facturas a otra empresa y anuladas.
  // Mismos datos que carga el modal (/presupuestos/{id}/facturas) más las
  // facturas de jornada que el presupuesto ya guarda.
  const construirDocumentosEmitidos = () => {
    const datos = documentosFacturacion || {};
    const porJornada = esFacturaPorJornada();
    const filas = [];
    const vistas = new Map();
    const idDe = (f) => f?.factura_id || f?.id || null;
    const anadir = (tipo, doc, extra = {}) => {
      const facturaId = idDe(doc);
      if (facturaId && vistas.has(facturaId)) {
        if (extra.jornada) vistas.get(facturaId).jornada = extra.jornada;
        return;
      }
      const fila = { clave: facturaId || `${tipo}-${filas.length}`, tipo, doc, facturaId, ...extra };
      if (facturaId) vistas.set(facturaId, fila);
      filas.push(fila);
    };
    const jornadaDe = (jornadaId) => (presupuesto.jornadas || []).find(j => j && j.id === jornadaId) || null;
    if (datos.proforma) anadir('proforma', datos.proforma);
    if (datos.factura_normal) {
      anadir(porJornada ? 'jornada' : 'factura', datos.factura_normal,
        { esVigente: true, ...(datos.factura_normal.jornada_id ? { jornada: jornadaDe(datos.factura_normal.jornada_id) } : {}) });
    }
    // Facturas de jornada vigentes: el documento real (importe y cobro de la factura)
    (datos.facturas_jornada || []).forEach(f => anadir('jornada', f, { jornada: jornadaDe(f.jornada_id) }));
    (datos.rectificativas || []).forEach((r, indice) => anadir('rectificativa', r, { indice }));
    (datos.terceros || []).forEach(t => anadir('tercero', t));
    (datos.anuladas || []).forEach(a => anadir('anulada', a));
    // Respaldo si aún no han llegado los documentos: lo que guarda el presupuesto
    // (el importe, el de la factura en facturas_info, nunca `jornadas[].total`)
    const infoDe = (facturaId) => (presupuesto.facturas_info || []).find(fi => (fi.factura_id || fi.id) === facturaId) || null;
    (presupuesto.jornadas || []).filter(j => j.factura_id || j.numero_factura).forEach(j => anadir('jornada', {
      id: j.factura_id, numero_factura: j.numero_factura, fecha_emision: j.fecha_factura,
      importe_total: infoDe(j.factura_id)?.total ?? null,
    }, { jornada: j }));
    (presupuesto.facturas_info || []).forEach(fi => anadir('jornada', {
      id: fi.factura_id || fi.id, numero_factura: fi.numero_factura, fecha_emision: fi.fecha_factura, importe_total: fi.total,
    }));
    return filas;
  };

  const etiquetaDocumento = (fila) => {
    const d = fila.doc;
    switch (fila.tipo) {
      case 'proforma': return 'Proforma';
      case 'factura': return d.tipo_factura === 'F2' ? 'Factura simplificada' : 'Factura';
      case 'jornada': return fila.jornada?.fecha ? `Factura de la jornada ${fechaDocumento(fila.jornada.fecha)}` : 'Factura';
      case 'rectificativa':
        return `Rectificativa${d.rectificacion_parcial ? ' parcial' : ''}${d.factura_rectificada_numero ? ` de ${d.factura_rectificada_numero}` : ''}`;
      case 'tercero': return `Factura a otra empresa${d.factura_tercero_de_numero ? ` (parte de ${d.factura_tercero_de_numero})` : ''}`;
      case 'anulada': return `Anulada${d.anulada_por_rectificativa ? ` por ${d.anulada_por_rectificativa}` : ''}`;
      default: return '';
    }
  };

  const CLASES_PILDORA = {
    ok: 'bg-[#E3F3EC] text-[#0F5E43]',
    ambar: 'bg-amber-100 text-amber-800',
    rojo: 'bg-[#FDE8E6] text-[#8A1C12]',
    azul: 'bg-blue-100 text-blue-800',
    neutro: 'bg-[#EEF1EF] text-[#4A5A53]',
  };
  const renderPildora = (texto, tono = 'neutro', testid) => (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-bold whitespace-nowrap ${CLASES_PILDORA[tono]}`} data-testid={testid}>
      {texto}
    </span>
  );

  const estadoDocumento = (fila) => {
    const d = fila.doc;
    if (fila.tipo === 'anulada' || d.estado === 'anulada') return { texto: 'Anulada', tono: 'neutro' };
    const pago = String(d.estado_pago || '').toLowerCase();
    if (['pagada', 'pagado', 'cobrada'].includes(pago)) return { texto: 'Cobrada', tono: 'ok' };
    if (pago === 'parcial') return { texto: 'Cobro parcial', tono: 'ambar' };
    if ((d.registros_envio || []).length > 0) return { texto: 'Enviada', tono: 'azul' };
    return { texto: 'Emitida', tono: 'neutro' };
  };

  // Estado FACe de la factura (solo clientes de administración pública)
  const estadoFaceDocumento = (fila) => {
    if (!cliente?.es_administracion_publica || !['factura', 'jornada'].includes(fila.tipo)) return null;
    const d = fila.doc;
    if (d.face_numero_registro) return { texto: `FACe: ${d.face_estado || 'Registrada'}`, tono: 'azul' };
    if (d.face_xml_firmado) return { texto: 'FACe: firmada, sin enviar', tono: 'ambar' };
    if (fila.esVigente) return { texto: 'FACe: sin firmar', tono: 'neutro' };
    return null;
  };

  // Abre el modal de factura de siempre, ya preparado para la acción elegida
  const abrirModalFacturaPreconfigurado = ({
    tipo = 'F1', accion = 'descargar', documento = null, rectificativa = false, tercero = false, enfocar = null, fechaEmail = null,
  } = {}) => {
    handleGeneratePDF('Factura', tipo);
    aperturaFacturaRef.current = { rectificativa, tercero, documento: !!documento, enfocar };
    if (accion === 'enviar') setAccionFactura('enviar');
    if (documento) {
      setDocumentoEnvioSel(documento);
      const defaults = construirEmailFacturaDefaults(
        fechaEmail || presupuesto?.fecha_evento,
        documento.numero_factura || documento.numero_proforma || null,
        // Factura de jornada (con su fecha): un día; el resto, el rango del multievento
        fechaEmail || documento.jornada_id || documento.jornada_fecha ? '' : rangoFechasMultievento(presupuesto)
      );
      setAsuntoEmail(defaults.asunto);
      setMensajeEmail(defaults.mensaje);
    }
  };

  // Documento ya emitido que no gestiona el camino normal del modal (rectificativas,
  // facturas a otra empresa, facturas de jornada, simplificadas): se envía tal cual
  const documentoParaModal = (fila) => ({
    ...fila.doc,
    factura_id: fila.facturaId,
    etiquetaTipo: etiquetaDocumento(fila),
  });

  const enviarDocumentoPorEmail = (fila) => {
    if (fila.tipo === 'proforma') {
      abrirModalFacturaPreconfigurado({ tipo: 'PROFORMA', accion: 'enviar' });
    } else if (fila.tipo === 'factura' && fila.doc.tipo_factura !== 'F2') {
      abrirModalFacturaPreconfigurado({ tipo: 'F1', accion: 'enviar' });
    } else {
      abrirModalFacturaPreconfigurado({
        accion: 'enviar',
        documento: documentoParaModal(fila),
        fechaEmail: fila.jornada?.fecha || null,
      });
    }
  };

  const regenerarDocumento = (fila) => {
    if (fila.tipo === 'proforma') {
      abrirModalFacturaPreconfigurado({ tipo: 'PROFORMA', enfocar: '[data-testid="regenerar-proforma"]' });
    } else if (fila.tipo === 'factura') {
      abrirModalFacturaPreconfigurado({ tipo: 'F1', enfocar: '[data-testid="regenerar-factura-normal"]' });
    } else if (fila.tipo === 'rectificativa') {
      abrirModalFacturaPreconfigurado({ tipo: 'F1', enfocar: `[data-testid="regenerar-rectificativa-${fila.indice}"]` });
    }
  };

  // Rectificar: la factura vigente del presupuesto o, en por jornada, la factura
  // de esa jornada (se manda su factura_id)
  const rectificarDocumento = (fila) => {
    const facturaJornada = fila && fila.tipo === 'jornada' && fila.doc?.id ? fila.doc : null;
    abrirModalFacturaPreconfigurado({ tipo: 'R1', rectificativa: true, enfocar: '[data-testid="rectificativa-opciones"]' });
    setFacturaRectificarSel(facturaJornada);
  };

  const abrirFacturarParteOtraEmpresa = () => {
    abrirModalFacturaPreconfigurado({ tipo: 'F1', tercero: true, enfocar: '[data-testid="form-facturar-tercero"]' });
  };

  const firmarYEnviarFace = () => {
    abrirModalFacturaPreconfigurado({ tipo: 'F1', enfocar: '[data-testid="face-firmar-btn"]' });
  };

  // Mismas confirmaciones que los botones Eliminar del modal
  const eliminarDocumento = async (fila) => {
    const d = fila.doc;
    const num = d.numero_factura;
    let aviso = null;
    let hecho = 'Eliminada';
    if (fila.tipo === 'proforma') {
      aviso = `¿Eliminar proforma ${num}?`;
      hecho = 'Proforma eliminada';
    } else if (fila.tipo === 'factura') {
      aviso = `¿Eliminar factura ${num}?`;
      hecho = 'Factura eliminada';
    } else if (fila.tipo === 'rectificativa') {
      aviso = d.factura_tercero_numero
        ? `¿Eliminar la rectificativa ${num}?\n\nSe eliminará también la factura ${d.factura_tercero_numero} a la otra empresa, porque se emitieron juntas.\n\nHazlo solo si no se han enviado a nadie ni subido a a3doc.`
        : `¿Eliminar rectificativa ${num}?`;
      hecho = 'Rectificativa eliminada';
    } else if (fila.tipo === 'tercero') {
      aviso = `¿Eliminar la factura ${num} a ${d.cliente_nombre}?` +
        (d.rectificativa_asociada_numero
          ? `\n\nSe eliminará también la rectificativa ${d.rectificativa_asociada_numero}, porque se emitieron juntas.`
          : '') +
        `\n\nHazlo solo si no se han enviado a nadie ni subido a a3doc.`;
    }
    if (!aviso || !fila.facturaId) return;
    try {
      // U-22: avisos (enviada, a3doc, cobros, hueco en la numeración) y confirmación
      const data = await borrarFacturaConAvisos(fila.facturaId, aviso);
      if (!data) return;
      const texto = fila.tipo === 'tercero' ? (data?.message || hecho) : hecho;
      alert(data?.aviso ? `${texto}\n\n${data.aviso}` : texto);
      cargarDocumentosFacturacion();
    } catch (e) {
      alert(textoDetalleApi(e.response?.data?.detail, `Error al eliminar: ${e.message}`));
    }
  };

  const subirDocumentoA3doc = async (fila) => {
    const num = fila.doc.numero_factura || 'la factura';
    if (!fila.facturaId) return;
    if (!window.confirm(`¿Subir ${num} a a3doc?\n\na3doc no permite borrar documentos: una vez subida, la gestoría la procesará.`)) return;
    setSubiendoA3docId(fila.facturaId);
    try {
      const { data } = await api.post(`/facturas/${fila.facturaId}/subir-a3doc`);
      alert(data?.ya_estaba ? `${num} ya estaba subida a a3doc.` : `${num} subida a a3doc.`);
      cargarDocumentosFacturacion();
    } catch (e) {
      alert(`No se pudo subir a a3doc: ${e.response?.data?.detail || e.message}`);
    }
    setSubiendoA3docId(null);
  };

  const accionesDocumento = (fila) => {
    const porJornada = esFacturaPorJornada();
    const acciones = [];
    const conId = !!fila.facturaId;
    if (conId) {
      acciones.push({ clave: 'descargar', etiqueta: 'Descargar PDF', onClick: () => descargarFacturaJornadaPDF(fila.facturaId, fila.doc.numero_factura) });
    }
    // Factura emitida: envío al cliente en un clic (destinatario, asunto y texto ya puestos)
    if (conId && ['factura', 'jornada', 'rectificativa', 'tercero'].includes(fila.tipo)) {
      acciones.push({
        clave: 'enviar-cliente',
        etiqueta: 'Enviar al cliente',
        onClick: () => setFacturaEnvioCliente({ facturaId: fila.facturaId, numero: fila.doc.numero_factura }),
      });
    }
    if (conId && fila.tipo !== 'anulada') {
      acciones.push({ clave: 'enviar', etiqueta: 'Enviar por email', onClick: () => enviarDocumentoPorEmail(fila) });
    }
    if (conId && (fila.tipo === 'proforma' || fila.tipo === 'rectificativa' || (fila.tipo === 'factura' && !porJornada))) {
      acciones.push({ clave: 'regenerar', etiqueta: 'Regenerar', onClick: () => regenerarDocumento(fila) });
    }
    if (fila.tipo === 'factura' && fila.esVigente && !porJornada && fila.doc.tipo_factura !== 'F2') {
      acciones.push({ clave: 'rectificar', etiqueta: 'Rectificar', onClick: () => rectificarDocumento(null) });
    }
    // Factura de jornada vigente: su propio Rectificar (total o por importe)
    if (conId && fila.tipo === 'jornada' && porJornada && fila.doc.jornada_id
        && fila.doc.estado !== 'anulada' && fila.doc.tipo_factura !== 'F2') {
      acciones.push({ clave: 'rectificar', etiqueta: 'Rectificar', onClick: () => rectificarDocumento(fila) });
    }
    if (conId && cliente?.es_administracion_publica && ['factura', 'jornada'].includes(fila.tipo)) {
      acciones.push({ clave: 'face-preview', etiqueta: 'Vista previa Facturae', onClick: () => verFacePreview(fila.facturaId) });
      if (fila.esVigente && !fila.doc.face_numero_registro) {
        acciones.push({ clave: 'face-firmar', etiqueta: 'Firmar y enviar', onClick: firmarYEnviarFace });
      }
    }
    if (conId && ['proforma', 'factura', 'rectificativa', 'tercero'].includes(fila.tipo)) {
      acciones.push({ clave: 'eliminar', etiqueta: 'Eliminar', onClick: () => eliminarDocumento(fila), peligro: true });
    }
    return acciones;
  };

  // Último envío de una factura al cliente (registros_envios del presupuesto)
  const ultimoEnvioFactura = (facturaId) => {
    if (!facturaId) return null;
    const envios = (presupuesto.registros_envios || [])
      .filter(e => e && e.tipo_documento === 'factura' && e.factura_id === facturaId);
    return envios.length > 0 ? envios[envios.length - 1] : null;
  };
  const textoEnvioFactura = (envio) => {
    if (!envio) return null;
    const bruto = String(envio.fecha_envio || '');
    const d = new Date(/Z|[+-]\d\d:\d\d$/.test(bruto) || !bruto.includes('T') ? bruto : `${bruto}Z`);
    const fecha = Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' });
    return `Enviada${fecha ? ` el ${fecha}` : ''} a ${envio.contacto_destino_nombre || envio.email_destino || 'el cliente'}`;
  };

  const renderCeldaA3doc = (fila) => {
    if (fila.tipo === 'proforma') return <span className="text-[#5B6B64]">No aplica</span>;
    if (fila.doc.a3doc_document_id) return renderPildora('Subida', 'ok');
    if (!fila.facturaId) return <span className="text-[#5B6B64]">-</span>;
    return (
      <button
        type="button"
        onClick={() => subirDocumentoA3doc(fila)}
        disabled={subiendoA3docId === fila.facturaId}
        className="text-xs font-semibold text-[#11704F] hover:underline disabled:opacity-50 whitespace-nowrap"
        data-testid="doc-subir-a3doc"
      >
        {subiendoA3docId === fila.facturaId ? 'Subiendo...' : 'Subir a a3doc'}
      </button>
    );
  };

  const renderDocumentosEmitidos = () => {
    const porJornada = esFacturaPorJornada();
    const filas = construirDocumentosEmitidos();
    // Móvil: el documento con la hoja de acciones abierta
    let documentoHojaMovil = null;
    const hayFacturaVigente = !!documentosFacturacion?.factura_normal;
    const claseSecundario = 'h-9 px-3 rounded-lg border border-[#CBD3CF] bg-white text-[#16221D] text-sm font-semibold flex items-center gap-1.5 hover:bg-gray-50 whitespace-nowrap';
    const cabecera = (
      <div className="flex flex-wrap items-center gap-2">
        {hayFacturaVigente && (
          <button type="button" onClick={abrirFacturarParteOtraEmpresa} className={claseSecundario} data-testid="facturacion-facturar-tercero">
            Facturar parte a otra empresa
          </button>
        )}
        {!porJornada && (
          <div className="flex items-stretch">
            <button
              type="button"
              onClick={() => abrirModalFacturaPreconfigurado({ tipo: 'F1' })}
              className="h-9 px-3 rounded-l-lg bg-duetto-primary text-white text-sm font-semibold flex items-center gap-1.5 hover:bg-opacity-90 whitespace-nowrap"
              data-testid="facturacion-emitir-factura"
            >
              <Receipt className="w-4 h-4" /> Emitir factura
            </button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button
                  type="button"
                  className="h-9 px-2 rounded-r-lg bg-duetto-primary text-white border-l border-white/40 flex items-center hover:bg-opacity-90"
                  title="Otros documentos"
                  data-testid="facturacion-emitir-mas"
                >
                  <ChevronDown className="w-4 h-4" />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="bg-white">
                <DropdownMenuItem onSelect={() => abrirModalFacturaPreconfigurado({ tipo: 'PROFORMA' })} className="cursor-pointer">
                  Emitir proforma
                </DropdownMenuItem>
                <DropdownMenuItem onSelect={() => abrirModalFacturaPreconfigurado({ tipo: 'F2' })} className="cursor-pointer">
                  Factura simplificada
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        )}
      </div>
    );

    let cuerpo;
    if (documentosFacturacion === null) {
      cuerpo = <p className="px-4 sm:px-5 py-6 text-sm text-[#5B6B64]">Cargando documentos...</p>;
    } else if (documentosFacturacion.error) {
      cuerpo = (
        <p className="px-4 sm:px-5 py-6 text-sm text-red-700">
          No se han podido cargar los documentos.{' '}
          <button type="button" onClick={cargarDocumentosFacturacion} className="font-semibold underline">Reintentar</button>
        </p>
      );
    } else if (filas.length === 0) {
      cuerpo = (
        <p className="px-4 sm:px-5 py-6 text-sm text-[#5B6B64]" data-testid="documentos-vacio">
          Todavía no hay documentos emitidos para este presupuesto.
        </p>
      );
    } else if (movilFicha) {
      // Móvil: una tarjeta por documento; las acciones de la fila, en una hoja (⋯)
      cuerpo = (
        <ul className="border-t border-[#E1E6E3]" data-testid="documentos-movil">
          {filas.map((fila) => {
            const estado = estadoDocumento(fila);
            const face = estadoFaceDocumento(fila);
            const anulada = fila.tipo === 'anulada';
            const importe = Number(fila.doc.importe_total || 0);
            const acciones = accionesDocumento(fila);
            if (hojaMovil && typeof hojaMovil === 'object' && hojaMovil.clave === `doc-${fila.clave}`) {
              documentoHojaMovil = { fila, acciones };
            }
            return (
              <li key={fila.clave} className="px-4 py-3 border-b border-[#EEF1EF] last:border-b-0 flex items-start gap-1" data-testid={`fila-documento-${fila.tipo}`}>
                <div className="min-w-0 flex-1">
                  <div className="flex items-start justify-between gap-3">
                    <span className={`font-bold text-[15px] break-all ${anulada ? 'line-through text-[#5B6B64]' : 'text-[#16221D]'}`}>
                      {fila.doc.numero_factura || fila.doc.numero_proforma || 'Sin número'}
                    </span>
                    <span className={`shrink-0 font-bold text-[15px] tabular-nums ${importe < 0 ? 'text-red-700' : anulada ? 'text-[#5B6B64]' : 'text-[#16221D]'}`}>
                      {formatEuros(importe)}
                    </span>
                  </div>
                  <p className="text-[13px] text-[#5B6B64]">
                    {etiquetaDocumento(fila)} · {fechaDocumento(fila.doc.fecha_emision || fila.doc.fecha_factura)}
                  </p>
                  <p className="text-[13px] text-[#33443C] break-words">
                    {fila.doc.cliente_nombre || cliente?.nombre_fiscal || cliente?.nombre_empresa || presupuesto.cliente_nombre || '-'}
                  </p>
                  {fila.tipo !== 'proforma' && ultimoEnvioFactura(fila.facturaId) && (
                    <p className="text-[13px] text-[#0F5E43] font-semibold" data-testid="doc-enviada">
                      {textoEnvioFactura(ultimoEnvioFactura(fila.facturaId))}
                    </p>
                  )}
                  <div className="mt-1.5 flex flex-wrap items-center gap-1.5 text-[13px]">
                    {renderPildora(estado.texto, estado.tono)}
                    {face && renderPildora(face.texto, face.tono, 'doc-estado-face')}
                    <span className="inline-flex items-center gap-1 min-h-[32px] text-[#5B6B64]">a3doc: {renderCeldaA3doc(fila)}</span>
                  </div>
                </div>
                {acciones.length > 0 && (
                  <button
                    type="button"
                    onClick={() => setHojaMovil({ tipo: 'documento-factura', clave: `doc-${fila.clave}` })}
                    className="h-11 w-11 -mt-2 -mr-2 shrink-0 rounded-full flex items-center justify-center text-[#5B6B64] active:bg-[#EEF1EF]"
                    aria-label="Acciones del documento"
                    data-testid={`doc-acciones-movil-${fila.tipo}`}
                  >
                    <MoreHorizontal className="w-5 h-5" />
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      );
    } else {
      cuerpo = (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[760px] text-sm border-collapse">
            <thead>
              <tr className="text-left text-xs font-bold uppercase tracking-wider text-[#5B6B64] border-y border-[#E1E6E3] bg-[#F7F9F8]">
                <th className="px-4 py-2.5">Documento</th>
                <th className="px-3 py-2.5">Fecha</th>
                <th className="px-3 py-2.5">Destinatario</th>
                <th className="px-3 py-2.5 text-right">Importe</th>
                <th className="px-3 py-2.5">Estado</th>
                <th className="px-3 py-2.5">a3doc</th>
                <th className="px-4 py-2.5 text-right">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filas.map((fila) => {
                const estado = estadoDocumento(fila);
                const face = estadoFaceDocumento(fila);
                const anulada = fila.tipo === 'anulada';
                const importe = Number(fila.doc.importe_total || 0);
                return (
                  <tr key={fila.clave} className="border-b border-[#EEF1EF] align-top" data-testid={`fila-documento-${fila.tipo}`}>
                    <td className="px-4 py-3">
                      <div className={`font-bold ${anulada ? 'line-through text-[#5B6B64]' : 'text-[#16221D]'}`}>
                        {fila.doc.numero_factura || fila.doc.numero_proforma || 'Sin número'}
                      </div>
                      <div className="text-xs text-[#5B6B64]">{etiquetaDocumento(fila)}</div>
                      {fila.tipo !== 'proforma' && ultimoEnvioFactura(fila.facturaId) && (
                        <div className="text-xs text-[#0F5E43] font-semibold mt-0.5" data-testid="doc-enviada">
                          {textoEnvioFactura(ultimoEnvioFactura(fila.facturaId))}
                        </div>
                      )}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">{fechaDocumento(fila.doc.fecha_emision || fila.doc.fecha_factura)}</td>
                    <td className="px-3 py-3">{fila.doc.cliente_nombre || cliente?.nombre_fiscal || cliente?.nombre_empresa || presupuesto.cliente_nombre || '-'}</td>
                    <td className={`px-3 py-3 text-right font-bold whitespace-nowrap ${importe < 0 ? 'text-red-700' : anulada ? 'text-[#5B6B64]' : 'text-[#16221D]'}`}>
                      {formatEuros(importe)}
                    </td>
                    <td className="px-3 py-3">
                      <div className="flex flex-col items-start gap-1">
                        {renderPildora(estado.texto, estado.tono)}
                        {face && renderPildora(face.texto, face.tono, 'doc-estado-face')}
                      </div>
                    </td>
                    <td className="px-3 py-3">{renderCeldaA3doc(fila)}</td>
                    <td className="px-4 py-3">
                      <div className="flex flex-wrap justify-end gap-x-3 gap-y-1 max-w-[260px] ml-auto">
                        {accionesDocumento(fila).map((a) => (
                          <button
                            key={a.clave}
                            type="button"
                            onClick={a.onClick}
                            className={`text-xs font-semibold whitespace-nowrap hover:underline ${a.peligro ? 'text-red-700' : 'text-[#11704F]'}`}
                            data-testid={`doc-${a.clave}`}
                          >
                            {a.etiqueta}
                          </button>
                        ))}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <section className="bg-white border border-[#E1E6E3] rounded-xl overflow-hidden" data-testid="facturacion-documentos">
        <div className="flex flex-wrap items-center justify-between gap-3 px-4 sm:px-5 py-4">
          <h2 className="text-xs font-bold tracking-wider uppercase text-[#5B6B64]">Documentos emitidos</h2>
          {cabecera}
        </div>
        {cuerpo}
        {porJornada && (
          <p className="px-4 sm:px-5 py-3 text-sm text-[#33443C] bg-[#F7F9F8] border-t border-[#E1E6E3]">
            Este presupuesto se factura por jornada: emite cada factura desde la lista de jornadas de abajo.
          </p>
        )}
        {presupuesto.es_multi_evento && (
          <div className="px-4 sm:px-5 pt-4 border-t border-[#E1E6E3]">{renderFacturacionMultievento()}</div>
        )}
        {movilFicha && (
          <HojaMovil
            abierta={!!documentoHojaMovil && hojaMovil?.tipo === 'documento-factura'}
            onCerrar={cerrarHojaMovil}
            titulo={documentoHojaMovil
              ? (documentoHojaMovil.fila.doc.numero_factura || documentoHojaMovil.fila.doc.numero_proforma || 'Documento')
              : 'Documento'}
            subtitulo={documentoHojaMovil ? etiquetaDocumento(documentoHojaMovil.fila) : null}
            clave="ficha-hoja-documento-factura"
            testid="hoja-documento-factura"
          >
            <div className="py-1">
              {(documentoHojaMovil?.acciones || []).map(a => (
                <FilaHojaMovil
                  key={a.clave}
                  texto={a.etiqueta}
                  tono={a.peligro ? 'peligro' : 'normal'}
                  onClick={enHojaMovil(a.onClick)}
                  data-testid={`doc-${a.clave}-movil`}
                />
              ))}
            </div>
          </HojaMovil>
        )}
      </section>
    );
  };

  const textoPoliticaPago = () => {
    if (!cliente) return null;
    if (cliente.pago_face) return 'Factura por FACe: el plazo depende de la administración';
    if (cliente.pago_dias === null || cliente.pago_dias === undefined) return null;
    return `Transferencia a ${cliente.pago_dias} días${cliente.pago_dia_mes ? `, pagan el día ${cliente.pago_dia_mes} de cada mes` : ''}`;
  };

  const renderTarjetaCobros = () => {
    const estadoPago = String(presupuesto.estado_pago || '').toLowerCase();
    const cobroMe = cobroMultievento();
    const pagado = cobroMe
      ? cobroMe.pagado
      : (typeof presupuesto.total_pagado === 'number' ? presupuesto.total_pagado : calculateTotalPagado());
    const pendiente = cobroMe
      ? cobroMe.pendiente
      : (typeof presupuesto.pendiente_cobro === 'number'
        ? presupuesto.pendiente_cobro
        : Math.max(0, totalPresupuesto() - pagado));
    const total = pagado + pendiente;
    const porcentaje = total > 0 ? Math.max(0, Math.min(100, (pagado / total) * 100)) : 0;
    const cobradoTarjeta = cobroMe ? cobroMe.cobrado : ['pagado', 'si'].includes(estadoPago);
    const parcialTarjeta = cobroMe ? (!cobroMe.cobrado && pagado > 0.01) : estadoPago === 'parcial';
    const estado = cobradoTarjeta
      ? { texto: 'Cobrado', tono: 'ok' }
      : parcialTarjeta
        ? { texto: 'Cobro parcial', tono: 'ambar' }
        : { texto: 'Pendiente de cobro', tono: 'neutro' };
    const politica = textoPoliticaPago();
    return renderTarjetaNueva('Cobros', (
      <div className="space-y-3 text-sm">
        <div className="flex items-center justify-between gap-3">
          {renderPildora(estado.texto, estado.tono, 'cobros-estado')}
          <button type="button" onClick={() => navigate('/control-cobros')} className="text-xs font-semibold text-[#11704F] hover:underline">
            Ver en Control de cobros
          </button>
        </div>
        <div className="h-2.5 rounded-full bg-[#E6ECE9] overflow-hidden" title={`${Math.round(porcentaje)} % cobrado`}>
          <div className="h-full bg-duetto-primary" style={{ width: `${porcentaje}%` }} />
        </div>
        <div className="flex justify-between gap-3 border-b border-[#EEF1EF] pb-2">
          <span className="text-[#5B6B64]">Cobrado</span>
          <strong className="text-[#16221D]">{formatEuros(pagado)}</strong>
        </div>
        <div className="flex justify-between gap-3">
          <span className="text-[#5B6B64]">Pendiente</span>
          <strong className={pendiente > 0.01 ? 'text-amber-800' : 'text-[#16221D]'}>{formatEuros(pendiente)}</strong>
        </div>
        {presupuesto.factura_desactualizada && (
          <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2" data-testid="aviso-factura-desactualizada">
            La factura no coincide con el presupuesto: revisa si hace falta rectificativa
            {' '}(presupuesto {formatEuros(presupuesto.factura_desactualizada.importe_presupuesto)}, facturado {formatEuros(presupuesto.factura_desactualizada.importe_facturado)}).
          </p>
        )}
        <p className="text-xs text-[#5B6B64]">
          Política de pago del cliente: {politica || 'sin configurar (se toma el estándar de 30 días)'}
        </p>
        {hayDepositoCliente && <div data-testid="deposito-cliente-alert">{renderAvisoDeposito()}</div>}
      </div>
    ), { testid: 'facturacion-cobros' });
  };

  const nombreContactoFacturacion = () => {
    const cid = presupuesto.contacto_facturacion_id;
    if (!cid) return null;
    if (cid === 'principal') return cliente?.persona_contacto || cliente?.nombre_empresa || 'Contacto principal';
    const persona = personasContacto.find(p => p.id === cid);
    return persona ? `${persona.nombre}${persona.email ? ` (${persona.email})` : ''}` : null;
  };

  const abrirEditarDatosFiscales = () => {
    setClienteEditData({
      nombre_empresa: cliente?.nombre_empresa || '',
      cif: cliente?.cif || '',
      direccion: cliente?.direccion || '',
      ciudad: cliente?.ciudad || '',
      codigo_postal: cliente?.codigo_postal || '',
      telefono: cliente?.telefono || '',
      email: cliente?.email || ''
    });
    setShowEditClienteModal(true);
  };

  const renderTarjetaDatosFiscales = () => {
    const cif = cliente?.cif || cliente?.nif;
    const direccion = cliente?.direccion_fiscal
      || [cliente?.direccion, cliente?.codigo_postal, cliente?.ciudad, cliente?.provincia].filter(Boolean).join(', ');
    const contacto = nombreContactoFacturacion();
    const fila = (etiqueta, valor, testid) => (
      <div className="flex justify-between gap-4 py-1.5 border-b border-[#EEF1EF] last:border-b-0" data-testid={testid}>
        <span className="text-[#5B6B64] flex-shrink-0">{etiqueta}</span>
        <span className="text-right text-[#16221D] break-words min-w-0">{valor}</span>
      </div>
    );
    return renderTarjetaNueva('Datos fiscales', (
      <div className="text-sm">
        {fila('Razón social', cliente?.nombre_fiscal || cliente?.nombre_empresa || presupuesto.cliente_nombre || '-')}
        {fila('CIF', cif || <span className="font-semibold text-red-700">Sin CIF</span>)}
        {fila('Dirección fiscal', direccion || <span className="font-semibold text-red-700">Sin dirección fiscal</span>)}
        {fila('Condición de pago', textoPoliticaPago() || 'Sin configurar')}
        {fila('Contacto de facturación', contacto || renderPildora('Sin asignar', 'ambar'), 'datos-fiscales-contacto')}
        <button
          type="button"
          onClick={abrirEditarDatosFiscales}
          className="mt-3 h-9 px-3 rounded-lg border border-[#CBD3CF] bg-white text-[#16221D] text-sm font-semibold flex items-center gap-1.5 hover:bg-gray-50"
          data-testid="editar-datos-fiscales"
        >
          <Pencil className="w-4 h-4" /> Editar datos fiscales
        </button>
      </div>
    ), { testid: 'facturacion-datos-fiscales' });
  };

  const renderTarjetaRequisitos = () => {
    const datos = documentosFacturacion || {};
    const ref = datos.factura_normal || datos.proforma || null;
    const referenciasFace = ref ? [
      ref.face_numero_pedido && `Nº de pedido ${ref.face_numero_pedido}`,
      ref.face_numero_expediente && `Expediente ${ref.face_numero_expediente}`,
      ref.face_numero_contrato && `Contrato ${ref.face_numero_contrato}`,
      ref.face_observaciones && `Observación FACe: ${ref.face_observaciones}`,
    ].filter(Boolean) : [];
    const esPublica = !!cliente?.es_administracion_publica;
    const destinos = cliente?.face_destinos || [];
    const hayAlgo = esPublica || referenciasFace.length > 0 || ref?.observaciones || ref?.concepto_unico;
    return renderTarjetaNueva('Requisitos de facturación del cliente', (
      <div className="space-y-3 text-sm">
        {esPublica && (
          <div data-testid="requisitos-face">
            <p className="font-semibold text-[#16221D]">Administración pública: se factura por FACe</p>
            {destinos.length === 0 ? (
              <p className="text-amber-800 mt-1">Sin destinos DIR3 configurados en la ficha del cliente.</p>
            ) : (
              <ul className="mt-1 space-y-1">
                {destinos.map((d) => (
                  <li key={d.id} className="text-[#33443C]">
                    <span className="font-medium">{d.nombre_interno || d.nombre || 'Destino'}</span>
                    <span className="text-xs text-[#5B6B64]">
                      {' '}· OC {d.oficina_contable || '-'} · OG {d.organo_gestor || '-'} · UT {d.unidad_tramitadora || '-'}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
        {referenciasFace.length > 0 && (
          <p className="text-[#33443C]"><span className="text-[#5B6B64]">Referencias en la factura:</span> {referenciasFace.join(' · ')}</p>
        )}
        {ref?.observaciones && (
          <p className="text-[#33443C] whitespace-pre-wrap"><span className="text-[#5B6B64]">Observaciones en la factura:</span> {ref.observaciones}</p>
        )}
        {ref?.concepto_unico && (
          <p className="text-[#33443C]"><span className="text-[#5B6B64]">Concepto único:</span> {ref.concepto_unico}</p>
        )}
        {!hayAlgo && <p className="text-[#5B6B64]">Sin requisitos registrados para este cliente.</p>}
        <p className="text-xs text-[#5B6B64]">
          Los destinos DIR3 se configuran en la ficha del cliente; las referencias y observaciones, al emitir la factura.
        </p>
        {presupuesto.cliente_id && (
          <button
            type="button"
            onClick={() => window.open(`/clientes?cliente_id=${presupuesto.cliente_id}`, '_blank')}
            className="text-xs font-semibold text-[#11704F] hover:underline"
          >
            Abrir ficha del cliente
          </button>
        )}
      </div>
    ), { testid: 'facturacion-requisitos' });
  };

  const renderPestanaFacturacion = () => (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 items-start">
      <div className="xl:col-span-2 space-y-6 min-w-0">
        {renderDocumentosEmitidos()}
        {renderTarjetaCobros()}
      </div>
      <div className="space-y-6 min-w-0">
        {renderTarjetaDatosFiscales()}
        {renderTarjetaRequisitos()}
        {renderTarjetaNueva(null, renderNotasAdministracion(), { testid: 'facturacion-notas' })}
        {renderTarjetaNueva('Contacto de facturación', renderContactoFacturacion(), {
          accion: (
            <button
              type="button"
              onClick={() => setShowNewContactoModal(true)}
              className="px-3 py-1 bg-duetto-primary text-white text-xs rounded-lg hover:bg-opacity-90 flex items-center gap-1"
            >
              <Plus className="w-3 h-3" />
              Nuevo contacto
            </button>
          ),
          testid: 'facturacion-contacto',
        })}
      </div>
    </div>
  );

  const renderPestanaHistorial = () => (
    <div className="space-y-6">
      {presupuesto.estado === 'cancelado' && (
        <div data-testid="cancelacion-info">{renderInfoCancelacion()}</div>
      )}
      {presupuesto.duplicado_de?.id && renderTarjetaNueva('Origen', (
        <div className="text-sm text-[#33443C]" data-testid="historial-duplicado">
          <p>
            Duplicado del presupuesto{' '}
            <button
              type="button"
              onClick={() => navigate(`/presupuestos/${presupuesto.duplicado_de.id}`)}
              className="font-semibold text-[#11704F] hover:underline"
            >
              #{presupuesto.duplicado_de.numero || 'anterior'}
            </button>
            .
          </p>
          {(presupuesto.historial || []).filter(h => h && h.tipo === 'duplicado').map(h => (
            <p key={`${h.tipo}-${h.fecha}`} className="text-xs text-[#5B6B64] mt-1">
              {h.fecha ? `${formatFecha(h.fecha)}: ` : ''}{h.texto}
            </p>
          ))}
        </div>
      ), { testid: 'tarjeta-origen' })}
      {renderPestanaProximamente('Versiones enviadas del presupuesto y registro de cambios.')}
    </div>
  );

  // ===== Móvil (< 768 px), formato nuevo: cabecera, pestañas, barra inferior y hojas =====
  // Mismos datos, handlers y avisos que el escritorio; solo cambia la presentación.

  // Una acción de una hoja: primero se cierra la hoja y después se hace. Las
  // que cambian la URL (pestaña, otra ruta) esperan a que el atrás de la hoja
  // termine, para no pisar la entrada del historial.
  const enHojaMovil = (fn, { navega = false } = {}) => () => {
    setHojaMovil(null);
    if (navega) setTimeout(() => fn(), 400);
    else fn();
  };

  // Documentos del presupuesto (los mismos botones que bajo la cabecera del escritorio)
  const documentosMovil = () => {
    const lista = [
      { clave: 'presupuesto', icono: FileText, texto: 'Presupuesto (PDF)', descripcion: 'Descargar el PDF', onClick: handleDescargarPresupuesto, disabled: downloading, uso: 'presupuesto.pdf' },
      { clave: 'presupuesto-email', icono: Mail, texto: 'Enviar el presupuesto por email', onClick: abrirEnvioPresupuesto, uso: 'presupuesto.email' },
      { clave: 'orden-cocina', icono: ChefHat, texto: 'Orden de cocina', onClick: () => handleGenerateOrdenCocina(), uso: 'presupuesto.pdf_orden_cocina' },
      { clave: 'orden-cocina-nueva', icono: ChefHat, texto: 'Orden de cocina (nueva)', descripcion: TEXTO_ORDEN_NUEVA_PRUEBAS, onClick: () => setShowOrdenNuevaModal(true), uso: 'presupuesto.pdf_orden_cocina_nueva' },
      { clave: 'hoja-material', icono: Package, texto: 'Hoja de material', onClick: () => handleGenerateHojaMaterial(), uso: 'presupuesto.pdf_hoja_material' },
    ];
    if (presupuesto?.materiales_alquiler?.length > 0
      || (presupuesto?.jornadas || []).some(j => j?.materiales_alquiler?.length > 0)) {
      lista.push({ clave: 'alquiler', icono: Truck, texto: 'Hoja de pedido de alquiler', onClick: () => handleGenerateHojaAlquiler(), uso: 'presupuesto.pdf_alquiler' });
    }
    lista.push({ clave: 'minuta', icono: MenuIcon, texto: 'Minuta', onClick: () => handleGeneratePDF('Minuta'), uso: 'presupuesto.pdf_minuta' });
    lista.push({ clave: 'factura', icono: Receipt, texto: 'Factura', onClick: () => handleGeneratePDF('Factura'), uso: 'presupuesto.factura' });
    return lista;
  };

  // Lleva al Resumen de costes (tarjeta del Resumen), por debajo de las barras fijas
  const irACostesMovil = () => {
    const ir = () => {
      const el = document.querySelector('[data-testid="resumen-costes"]');
      if (!el) return;
      window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.scrollY - 112), behavior: 'smooth' });
    };
    if (pestanaActiva !== 'resumen') {
      setPestanaActiva('resumen');
      setTimeout(ir, 250);
    } else {
      ir();
    }
  };

  const renderCabeceraMovil = ({
    ciclo, nombreCliente, claseEstado, chipsAvisoCabecera, costesOk, margen, textoMargen, MARGEN_MINIMO,
    diaSemana, fechaCabecera, avisos, renderBotonPestana,
  }) => {
    const me = esMultievento(presupuesto);
    const hora = (v) => parseHoraToTimeInput(v || '') || '';
    const horaIni = me ? hora(primeraJornada(presupuesto)?.hora_inicio || presupuesto.hora_inicio) : (editedHoraInicio || hora(presupuesto.hora_inicio));
    const provisional = horaFinProvisional();
    const horaFin = me ? hora(primeraJornada(presupuesto)?.hora_fin || presupuesto.hora_fin) : (editedHoraFin || provisional || hora(presupuesto.hora_fin));
    const fechaTexto = me
      ? textoFechasEvento(presupuesto)
      : (fechaCabecera ? `${diaSemana ? `${diaSemana.slice(0, 3)} ` : ''}${fechaCabecera.split('-').reverse().join('/')}` : 'Sin fecha');
    const partes = [
      fechaTexto,
      horaIni ? `${horaIni}${horaFin ? ` a ${horaFin}${provisional && !me ? ' (fin sin confirmar)' : ''}` : ''}` : 'Sin hora',
      esMultieventoFicha() ? textoPersonasMultievento() : `${editedNumPersonas || presupuesto.num_personas || 0} pers.`,
      presupuesto.lugar_evento || 'Sin lugar',
    ].filter(Boolean);
    const hayChips = !!presupuesto.es_migracion_historica || (getQuienVa()?.personasExternas > 0) || materialSinValidar()
      || (!!estadoEnvio?.modificado_tras_envio && !['cancelado', 'rechazado'].includes(presupuesto.estado) && !ciclo.celebrado)
      || (!!cobroPrevio?.aplica && !!cobroPrevio?.vencido);
    const avisoActiva = avisos[pestanaActiva];
    return (
      <>
        <div className="bg-white border-b border-[#E1E6E3] px-4 pt-3 pb-1" data-testid="cabecera-movil">
          <div className="flex items-start gap-2">
            <h1 className="flex-1 min-w-0 text-lg font-extrabold leading-snug line-clamp-2 break-words">{nombreCliente}</h1>
            <span className={`shrink-0 mt-0.5 px-2 py-0.5 rounded-full text-xs font-bold ${claseEstado}`}>
              {String(presupuesto.estado || '').toUpperCase()}
            </span>
          </div>
          <p className="mt-1 text-[13px] leading-snug text-[#5B6B64] line-clamp-2" data-testid="cabecera-movil-datos">
            {partes.join(' · ')}
          </p>
          {hayChips && <div className="mt-2 flex flex-wrap items-center gap-1.5">{chipsAvisoCabecera}</div>}
          <div className="mt-3 flex items-end justify-between gap-3">
            <div className="min-w-0">
              <span className="block text-xs font-semibold text-[#5B6B64]">Total con IVA</span>
              <span className="block text-2xl font-extrabold tabular-nums leading-tight">{formatEuros(totalPresupuesto())}</span>
            </div>
            <button
              type="button"
              onClick={irACostesMovil}
              className="text-right shrink-0 rounded-lg px-1 -mx-1 active:bg-gray-100"
              data-testid="margen-interno"
            >
              <span className="block text-xs font-semibold text-[#0F5E43]">Margen interno</span>
              <span className={`block text-base font-extrabold tabular-nums ${costesOk ? textoMargen : 'text-[#5B6B64]'}`}>
                {costesOk ? `${margen.toLocaleString('es-ES', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %` : 'Sin calcular'}
              </span>
              {costesOk && (
                <span className="block text-xs text-[#5B6B64] tabular-nums">{formatEuros(costesGuardados.beneficio)} · mín. {MARGEN_MINIMO} %</span>
              )}
            </button>
          </div>
          <div className="mt-3 grid grid-cols-2 gap-2">
            <button
              type="button"
              onClick={() => setHojaMovil('datos')}
              className="h-11 rounded-lg border border-[#CBD3CF] bg-white text-[15px] font-semibold text-[#16221D] flex items-center justify-center gap-2 active:bg-gray-50"
              data-testid="boton-datos-evento-movil"
            >
              <Calendar className="w-4 h-4" /> Datos del evento
            </button>
            <button
              type="button"
              onClick={() => setHojaMovil('documentos')}
              className="h-11 rounded-lg border border-[#CBD3CF] bg-white text-[15px] font-semibold text-[#16221D] flex items-center justify-center gap-2 active:bg-gray-50"
              data-testid="boton-documentos-movil"
            >
              <FolderOpen className="w-4 h-4" /> Documentos
            </button>
          </div>
          {renderBarraCiclo(ciclo, { compacta: true })}
        </div>
        {/* Pestañas fijas bajo la barra superior (48 px), con degradado si hay más */}
        <div className="sticky top-12 z-20 bg-white border-b border-[#E1E6E3]" data-testid="pestanas-movil">
          <div className="relative">
            <div
              ref={pestanasMovilRef}
              className="relative flex overflow-x-auto px-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
              role="tablist"
            >
              {PESTANAS_VISIBLES.map(p => renderBotonPestana(p, true))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-white to-transparent" />
          </div>
          {avisoActiva && (
            <p className="px-4 py-2 text-[13px] leading-snug font-semibold text-[#92400E] bg-[#FFF4E5] border-t border-[#F4D9AE]" role="status" data-testid="aviso-pestana-movil">
              Aviso: {avisoActiva}
            </p>
          )}
        </div>
      </>
    );
  };

  // Campo de la hoja "Datos del evento": 16 px (sin zoom de iOS) y 44 px de alto
  const CLASE_CAMPO_MOVIL = 'w-full h-11 px-3 border border-[#CBD3CF] rounded-lg text-base font-semibold text-[#16221D] bg-white flex items-center focus:outline-none focus:ring-2 focus:ring-duetto-primary';

  const renderBarraInferiorMovil = ({ ciclo, numero, costesOk, margen, textoMargen }) => {
    const nombreCliente = presupuesto.cliente_nombre || cliente?.nombre_empresa || cliente?.nombre || 'Cliente';
    const etiquetaCampo = 'block text-[13px] font-semibold text-[#5B6B64] mb-1';
    const indicadorDiaMovil = hojaMovil === 'datos' ? renderIndicadorDiaSiguiente() : null;
    return (
      <>
        <BarraInferiorMovil data-testid="barra-inferior-ficha" data-guia="ficha-movil-barra">
          <div className="flex items-center gap-2 px-3 py-2">
            <button
              type="button"
              onClick={irACostesMovil}
              className="min-w-0 flex-1 text-left rounded-lg active:bg-gray-50"
              data-testid="barra-movil-total"
            >
              <span className="block text-xs font-semibold text-[#5B6B64] leading-tight">Total con IVA</span>
              <span className="block text-lg font-extrabold tabular-nums leading-tight truncate">{formatEuros(totalPresupuesto())}</span>
              {costesOk && (
                <span className={`block text-xs font-semibold leading-tight ${textoMargen}`}>
                  Margen {margen.toLocaleString('es-ES', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %
                </span>
              )}
            </button>
            <div className="min-w-0 flex justify-end">{renderSiguientePaso(ciclo, { movil: true })}</div>
            <button
              type="button"
              onClick={() => setHojaMovil('mas')}
              className="h-11 px-3 shrink-0 rounded-lg border border-[#CBD3CF] bg-white text-sm font-bold text-[#16221D] flex items-center gap-1 active:bg-gray-50"
              aria-label="Más acciones"
              data-testid="barra-movil-mas"
            >
              <MoreHorizontal className="w-5 h-5" /> Más
            </button>
          </div>
        </BarraInferiorMovil>

        {/* Más: duplicar, acciones del estado, guardar y volver al formato anterior */}
        <HojaMovil
          abierta={hojaMovil === 'mas'}
          onCerrar={cerrarHojaMovil}
          titulo={`Presupuesto #${numero}`}
          subtitulo="Formato nuevo (en pruebas)"
          clave="ficha-hoja-mas"
          testid="hoja-mas-ficha"
        >
          <div className="py-1">
            <FilaHojaMovil
              icono={Copy}
              texto="Duplicar"
              descripcion="Una copia con otra fecha (y otro cliente si quieres)"
              onClick={enHojaMovil(() => setShowDuplicar(true))}
              data-testid="hoja-mas-duplicar"
            />
            {accionesEstadoFicha().map(a => (
              <FilaHojaMovil
                key={a.clave}
                texto={a.etiqueta}
                tono={a.peligro ? 'peligro' : 'normal'}
                onClick={enHojaMovil(() => a.onSelect())}
                data-testid={`hoja-mas-${a.clave}`}
              />
            ))}
            <SeparadorHojaMovil />
            <FilaHojaMovil
              icono={Save}
              texto="Guardar ahora"
              descripcion="Los cambios se guardan solos: esto guarda ya lo pendiente."
              onClick={enHojaMovil(() => autoguardado.guardarYa())}
              data-testid="ficha-guardar-movil"
              data-uso="presupuesto.guardar"
              data-uso-detalle="movil"
            />
            <FilaHojaMovil
              icono={Undo2}
              texto="Volver al formato anterior"
              onClick={enHojaMovil(async () => {
                // Lo pendiente se guarda antes de cambiar de formato
                await autoguardado.guardarYa();
                setFormatoNuevo(false);
              })}
              data-testid="hoja-mas-formato-anterior"
            />
          </div>
        </HojaMovil>

        {/* Documentos: una fila por documento (mismos botones que en el escritorio) */}
        <HojaMovil
          abierta={hojaMovil === 'documentos'}
          onCerrar={cerrarHojaMovil}
          titulo="Documentos"
          clave="ficha-hoja-documentos"
          testid="hoja-documentos"
        >
          <div className="py-1">
            {documentosMovil().map(d => (
              <FilaHojaMovil
                key={d.clave}
                icono={d.icono}
                texto={d.texto}
                descripcion={d.descripcion}
                disabled={d.disabled}
                onClick={enHojaMovil(d.onClick)}
                data-uso={d.uso}
                data-uso-detalle="movil"
                data-testid={`hoja-documentos-${d.clave}`}
              />
            ))}
          </div>
        </HojaMovil>

        {/* Datos del evento: los mismos campos de la cabecera, grandes */}
        <HojaMovil
          abierta={hojaMovil === 'datos'}
          onCerrar={cerrarHojaMovil}
          titulo="Datos del evento"
          subtitulo="Se guardan solos al cambiarlos"
          clave="ficha-hoja-datos"
          testid="hoja-datos-evento"
        >
          <div className="px-5 py-4 space-y-4">
            <div>
              <span className={etiquetaCampo}>Cliente</span>
              <p className="text-[15px] font-semibold text-[#16221D] break-words">{nombreCliente}</p>
              <div className="mt-2 grid grid-cols-2 gap-2">
                <button
                  type="button"
                  onClick={() => window.open(`/clientes?cliente_id=${presupuesto.cliente_id}`, '_blank')}
                  className="h-11 rounded-lg border border-[#CBD3CF] bg-white text-sm font-semibold text-[#11704F] active:bg-gray-50"
                >
                  Ver cliente
                </button>
                <button
                  type="button"
                  onClick={enHojaMovil(() => {
                    setShowCambiarClienteModal(true);
                    cargarTodosClientes();
                  })}
                  className="h-11 rounded-lg border border-[#CBD3CF] bg-white text-sm font-semibold text-[#16221D] active:bg-gray-50"
                  data-testid="hoja-datos-cambiar-cliente"
                >
                  Cambiar cliente
                </button>
              </div>
            </div>
            <div>
              <span className={etiquetaCampo}>Fecha</span>
              {renderCampoFecha(CLASE_CAMPO_MOVIL)}
              <div className="mt-1"><VerEnCalendario presupuesto={presupuesto} /></div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <label className="block min-w-0">
                <span className={etiquetaCampo}>Hora de inicio</span>
                {renderCampoHoraInicio(CLASE_CAMPO_MOVIL)}
              </label>
              <label className="block min-w-0">
                <span className={etiquetaCampo}>Hora de fin</span>
                {renderCampoHoraFin(CLASE_CAMPO_MOVIL)}
              </label>
            </div>
            {indicadorDiaMovil && <div className="flex flex-wrap items-center gap-2">{indicadorDiaMovil}</div>}
            <label className="block">
              <span className={etiquetaCampo}>Hora de llegada</span>
              {renderCampoLlegada(CLASE_CAMPO_MOVIL)}
            </label>
            <label className="block">
              <span className={etiquetaCampo}>Personas</span>
              {renderCampoPersonas(`${CLASE_CAMPO_MOVIL} tabular-nums`)}
            </label>
            <div>
              <span className={etiquetaCampo}>Lugar</span>
              <button
                type="button"
                onClick={enHojaMovil(() => setPestanaActiva('logistica', 'lugar'), { navega: true })}
                className="w-full min-h-[44px] px-3 py-2 rounded-lg border border-[#CBD3CF] bg-white text-left text-[15px] text-[#16221D] flex items-center gap-2 active:bg-gray-50"
                data-testid="hoja-datos-lugar"
              >
                <MapPin className="w-4 h-4 shrink-0 text-[#5B6B64]" />
                <span className="min-w-0 flex-1 break-words">{presupuesto.lugar_evento || 'Sin lugar'}</span>
                <ChevronRight className="w-4 h-4 shrink-0 text-[#5B6B64]" />
              </button>
              <p className="mt-1 text-[13px] text-[#5B6B64]">La dirección y el transporte se cambian en Logística.</p>
            </div>
          </div>
        </HojaMovil>
      </>
    );
  };

  const renderLayoutNuevo = () => {
    const ciclo = calcularCicloEvento();
    // Margen GUARDADO por el motor único (el mismo que Resumen de costes y Rentabilidad)
    const costesOk = !!costesGuardados?.guardado;
    const margen = costesOk ? (Number(costesGuardados.margen) || 0) : 0;
    const MARGEN_MINIMO = 35;
    // Escala literal 0-100 %: el relleno es el margen tal cual y la marca del
    // mínimo va al 35 % del ancho
    const anchoMargen = Math.max(0, Math.min(100, margen));
    const colorMargen = margen >= MARGEN_MINIMO ? 'bg-duetto-primary' : margen >= 20 ? 'bg-amber-500' : 'bg-red-600';
    const textoMargen = margen >= MARGEN_MINIMO ? 'text-[#0F5E43]' : margen >= 20 ? 'text-amber-700' : 'text-red-700';
    const numero = presupuesto.numero || presupuesto.numero_presupuesto_legacy || id.split('-').pop();
    const nombreCliente = presupuesto.cliente_nombre || cliente?.nombre_empresa || cliente?.nombre || 'Cliente';
    const fechaCabecera = String(editedFechaEvento || presupuesto.fecha_evento || '').slice(0, 10);
    const fechaObj = fechaCabecera ? new Date(`${fechaCabecera}T00:00:00`) : null;
    const diaSemanaRaw = fechaObj && !Number.isNaN(fechaObj.getTime())
      ? fechaObj.toLocaleDateString('es-ES', { weekday: 'long' })
      : '';
    // Multievento: la cabecera enseña el rango de las jornadas, sin día de la semana
    const diaSemana = diaSemanaRaw && !esMultievento(presupuesto)
      ? diaSemanaRaw.charAt(0).toUpperCase() + diaSemanaRaw.slice(1) : '';
    const claseEstado = {
      confirmado: 'bg-[#E3F3EC] text-[#0F5E43]',
      enviado: 'bg-blue-100 text-blue-800',
      aceptado: 'bg-blue-100 text-blue-800',
      cancelado: 'bg-[#FDE8E6] text-[#8A1C12]',
      rechazado: 'bg-[#FDE8E6] text-[#8A1C12]',
    }[presupuesto.estado] || 'bg-[#EEF1EF] text-[#4A5A53]';
    const claseCampo = 'bg-transparent border-0 border-b border-dashed border-[#7FA897] hover:border-duetto-primary focus:border-duetto-primary focus:outline-none font-semibold text-[#16221D] px-0.5';
    const tareas = calcularTareasFicha();
    const quienVa = getQuienVa();
    // Avisos de envío y cobro previo (mismo criterio que sus tareas de Por hacer)
    const presupuestoCerrado = presupuesto.estado === 'cancelado' || presupuesto.estado === 'rechazado';
    const mostrarModificadoEnvio = !!estadoEnvio?.modificado_tras_envio && !presupuestoCerrado && !ciclo.celebrado;
    const fechaUltimoEnvioRaw = estadoEnvio?.ultimo_envio?.fecha ? parsearFechaServidor(estadoEnvio.ultimo_envio.fecha) : null;
    const fechaUltimoEnvio = fechaUltimoEnvioRaw && !Number.isNaN(fechaUltimoEnvioRaw.getTime()) ? fechaUltimoEnvioRaw : null;
    const cobroPrevioVencido = !!cobroPrevio?.aplica && !!cobroPrevio?.vencido;
    const venceCobroPrevio = parsearFechaDia(cobroPrevio?.vence_el);
    // Aviso "!" de cada pestaña con su motivo (title y aria-label del badge)
    const platosFaltantes = getPlatosFaltantes().length;
    const motivosAviso = {
      lineas: [
        faltanBebidasFicha
          ? (bebidasSinValidar ? 'Bebidas sin validar' : 'Bebidas sin confirmar')
          : null,
        platosFaltantes > 0 ? `Faltan ${platosFaltantes} ${platosFaltantes === 1 ? 'plato' : 'platos'} del catálogo` : null,
      ],
      logistica: [
        !presupuesto.distancia_km && !!presupuesto.lugar_evento ? 'Falta la dirección o la ruta' : null,
        faltanFurgonetas ? 'Furgonetas sin asignar' : null,
        faltaPersonalFicha ? 'Personal sin asignar' : null,
      ],
      material: [materialSinValidar() ? 'Material sin validar' : null],
      facturacion: [ciclo.celebrado && !ciclo.facturado ? 'Evento celebrado sin facturar' : null],
      // Sin responder "¿Hay alérgicos?" (mismo criterio que la pregunta inicial de la pestaña)
      alergenos: [(() => {
        if (presupuestoCerrado || ciclo.celebrado) return null;
        const r = getResumenAlergenos();
        const adaptacionesEnMenus = [
          ...(presupuesto.menus_personalizados || []),
          ...((presupuesto.jornadas || []).flatMap(j => (j && j.menus_personalizados) || [])),
        ].some(m => m && Array.isArray(m.adaptaciones) && m.adaptaciones.length > 0);
        return r.comensales === 0 && r.estado === 'sin_lista' && !adaptacionesEnMenus
          ? 'Falta indicar si hay alérgicos o dietas' : null;
      })()],
    };
    // Con "Líneas y menús" oculta, su "!" va en Resumen (donde están las líneas)
    if (RESUMEN_NUEVO) motivosAviso.resumen = motivosAviso.lineas;
    const avisos = Object.fromEntries(Object.entries(motivosAviso).map(([clave, lista]) => [clave, lista.filter(Boolean).join(' · ')]));
    // Indicador de la barra: el autoguardado (pendiente, sin conexión, error de
    // datos) manda sobre el indicador de las llamadas de guardado
    const auto = autoguardado.estado;
    const erroresAuto = Object.values(auto.errores || {});
    let indicador = estadoGuardado;
    if (auto.estado === 'sin_conexion') indicador = { estado: 'sin_conexion', ultimo: estadoGuardado.ultimo };
    else if (auto.estado === 'guardando' || auto.estado === 'pendiente' || estadoGuardado.estado === 'guardando') indicador = { estado: 'guardando', ultimo: estadoGuardado.ultimo };
    else if (erroresAuto.length > 0) indicador = { estado: 'error', ultimo: estadoGuardado.ultimo, detalle: erroresAuto.join(' · ') };
    else if (auto.ultimo && (!estadoGuardado.ultimo || auto.ultimo > estadoGuardado.ultimo) && estadoGuardado.estado !== 'error') indicador = { estado: 'guardado', ultimo: auto.ultimo };

    // Chips de aviso de la cabecera (escritorio en la fila del nombre; móvil debajo)
    const chipsAvisoCabecera = (
      <>
                {presupuesto.es_migracion_historica && (
                  <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-purple-100 text-purple-800">HISTÓRICO</span>
                )}
                {quienVa?.personasExternas > 0 && (
                  <button
                    type="button"
                    onClick={() => setPestanaActiva('logistica', 'quien')}
                    className="px-2.5 py-1 rounded-full text-xs font-bold bg-[#FDF0DC] text-[#92400E] border border-[#F4D9AE] hover:bg-[#FBE6C4]"
                    title="Ver quién va al evento en Logística"
                    data-testid="aviso-cabecera-extra"
                  >
                    {`Personal externo: ${quienVa.personasExternas} ${quienVa.personasExternas === 1 ? 'persona' : 'personas'}${quienVa.hayOrdenExtra ? '' : ' · falta la solicitud'}`}
                  </button>
                )}
                {materialSinValidar() && (
                  <button
                    type="button"
                    onClick={() => setPestanaActiva('material')}
                    className="px-2.5 py-1 rounded-full text-xs font-bold bg-[#FDF0DC] text-[#92400E] border border-[#F4D9AE] hover:bg-[#FBE6C4]"
                    title="Validar el material en la pestaña Material"
                    data-testid="aviso-cabecera-material"
                  >
                    {estadoMaterial?.huella_cambiada && estadoMaterial?.validado ? 'Material: revisar tras los cambios' : 'Material sin validar'}
                  </button>
                )}
                {mostrarModificadoEnvio && (
                  <div className="relative">
                    <button
                      type="button"
                      onClick={() => setCambiosEnvioAbiertos(v => !v)}
                      aria-expanded={cambiosEnvioAbiertos}
                      className="px-2.5 py-1 rounded-full text-xs font-bold bg-[#FDF0DC] text-[#92400E] border border-[#F4D9AE] hover:bg-[#FBE6C4] flex items-center gap-1"
                      title="Ver qué ha cambiado desde el último envío al cliente"
                      data-testid="aviso-cabecera-modificado-envio"
                    >
                      {`Modificado tras el envío${fechaUltimoEnvio ? ` del ${formatoDiaMes(fechaUltimoEnvio)}` : ''}`}
                      <ChevronDown className={`w-3.5 h-3.5 transition-transform ${cambiosEnvioAbiertos ? 'rotate-180' : ''}`} />
                    </button>
                    {cambiosEnvioAbiertos && (
                      <div
                        className={movilFicha
                          ? 'fixed inset-x-4 top-28 z-[45] bg-white border border-[#E1E6E3] rounded-xl shadow-lg p-3.5 flex flex-col gap-2.5'
                          : 'absolute left-0 top-full mt-1.5 z-30 w-[min(24rem,calc(100vw-2rem))] bg-white border border-[#E1E6E3] rounded-xl shadow-lg p-3.5 flex flex-col gap-2.5'}
                        data-testid="cambios-envio"
                      >
                        <p className="text-xs font-bold text-[#5B6B64]">
                          {`Cambios desde el envío${fechaUltimoEnvio ? ` del ${formatoDiaMes(fechaUltimoEnvio)}` : ''}${estadoEnvio?.ultimo_envio?.email_destino ? ` a ${estadoEnvio.ultimo_envio.email_destino}` : ''}`}
                        </p>
                        <ul className="list-disc pl-4 text-[13px] text-[#16221D] flex flex-col gap-1">
                          {(estadoEnvio?.cambios || []).map(c => <li key={c}>{c}</li>)}
                        </ul>
                        <div className="flex justify-end gap-2">
                          <button
                            type="button"
                            onClick={() => setCambiosEnvioAbiertos(false)}
                            className="h-[32px] px-3 rounded-lg border border-[#CBD3CF] bg-white text-[13px] font-bold text-[#16221D] hover:bg-gray-50"
                          >
                            Cerrar
                          </button>
                          <button
                            type="button"
                            onClick={() => { setCambiosEnvioAbiertos(false); abrirEnvioPresupuesto(); }}
                            className="h-[32px] px-3 rounded-lg border border-duetto-primary bg-duetto-primary text-white text-[13px] font-bold flex items-center gap-1.5 hover:bg-opacity-90"
                            data-testid="cambios-envio-reenviar"
                          >
                            <Send className="w-3.5 h-3.5" /> Reenviar
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {cobroPrevioVencido && (
                  <button
                    type="button"
                    onClick={abrirModalCobroPrevio}
                    className="px-2.5 py-1 rounded-full text-xs font-bold bg-[#FDE8E6] text-[#8A1C12] border border-[#F5C2BC] hover:bg-[#FBD5D1]"
                    title={`Pendiente ${formatoEur(cobroPrevio.pendiente)}${venceCobroPrevio ? `; vencía el ${formatoDiaMes(venceCobroPrevio)}` : ''}. Pulsa para pedir el pago.`}
                    data-testid="aviso-cabecera-cobro-previo"
                  >
                    {/* Móvil: el detalle del title, a la vista */}
                    {movilFicha
                      ? `Cobro previo vencido · pendiente ${formatoEur(cobroPrevio.pendiente)}${venceCobroPrevio ? `, vencía el ${formatoDiaMes(venceCobroPrevio)}` : ''}`
                      : 'Cobro previo vencido'}
                  </button>
                )}
      </>
    );

    // Botón de una pestaña (escritorio dentro de la cabecera; móvil en la barra fija)
    const renderBotonPestana = (p, movil) => {
              const activa = pestanaActiva === p.clave;
              return (
                <button
                  key={p.clave}
                  type="button"
                  role="tab"
                  aria-selected={activa}
                  onClick={() => {
                    // Al cambiar de pestaña se guarda lo pendiente
                    autoguardado.guardarYa();
                    setPestanaActiva(p.clave);
                  }}
                  className={`${movil ? 'shrink-0 py-3 px-3 text-[15px]' : 'py-3.5 px-0.5 text-sm'} font-semibold whitespace-nowrap border-b-[3px] transition-colors flex items-center ${
                    activa ? 'text-[#11704F] border-duetto-primary' : 'text-[#5B6B64] border-transparent hover:text-[#16221D]'
                  }`}
                  data-testid={`pestana-${p.clave}`}
                  data-uso="presupuesto.pestana"
                  data-uso-detalle={p.clave}
                >
                  {movil ? (ETIQUETAS_PESTANA_MOVIL[p.clave] || p.etiqueta) : p.etiqueta}
                  {p.clave === 'correos' && correosEvento.length > 0 && ` (${correosEvento.length})`}
                  {p.clave === 'alergenos' && (() => {
                    const r = getResumenAlergenos();
                    if (r.comensales === 0 && r.estado === 'sin_lista') return null;
                    if (r.comensales === 0 && r.estado === 'sin_alergicos') {
                      return (
                        <span
                          className="ml-1.5 px-[7px] py-px rounded-full text-xs font-bold bg-[#E3F3EC] text-[#0F5E43]"
                          title="El cliente ha confirmado que no hay alérgicos"
                          data-testid="badge-alergenos"
                        >
                          sin alérgicos
                        </span>
                      );
                    }
                    const clase = r.estado === 'validada_cocina' && !r.huellaCambiada
                      ? 'bg-[#E3F3EC] text-[#0F5E43]'
                      : (r.estado === 'recibida' || r.huellaCambiada ? 'bg-[#FDF0DC] text-[#92400E]' : 'bg-[#EEF1EF] text-[#4A5A53]');
                    return (
                      <span
                        className={`ml-1.5 px-[7px] py-px rounded-full text-xs font-bold ${clase}`}
                        title={`${r.comensales} ${r.comensales === 1 ? 'comensal' : 'comensales'} · ${r.estadoTexto}`}
                        data-testid="badge-alergenos"
                      >
                        {r.comensales} · {r.estadoTexto.toLowerCase()}
                      </span>
                    );
                  })()}
                  {p.clave === 'por_hacer' && tareas.pendientes > 0 && (
                    <span
                      className="ml-1.5 px-[7px] py-px rounded-full text-xs font-extrabold text-white bg-[#C2620A]"
                      title={`${tareas.pendientes} ${tareas.pendientes === 1 ? 'tarea pendiente' : 'tareas pendientes'}`}
                      data-testid="badge-por-hacer"
                    >
                      {tareas.pendientes}
                    </span>
                  )}
                  {avisos[p.clave] && (
                    <span
                      className="ml-1.5 w-5 h-5 bg-orange-500 text-white text-xs rounded-full flex items-center justify-center font-bold"
                      title={avisos[p.clave]}
                      aria-label={avisos[p.clave]}
                      data-testid={`aviso-pestana-${p.clave}`}
                    >
                      !
                    </span>
                  )}
                </button>
              );
    };

    return (
      <div
        className={`bg-[#F4F6F4] text-[#16221D]${movilFicha ? ' pb-24' : ''}`}
        data-testid="ficha-formato-nuevo"
        // Al salir de un campo se guarda lo pendiente (sin esperar el retardo)
        onBlurCapture={(e) => {
          const t = e.target;
          if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT')) autoguardado.guardarYa();
        }}
      >
        {/* Barra superior */}
        {movilFicha ? (
          // Móvil: volver, número e indicador de guardado (Guardar y el formato, en Más)
          <div className="sticky top-0 z-30 bg-white border-b border-[#E1E6E3] h-12 pl-1 pr-3 flex items-center gap-1" data-testid="barra-superior-movil">
            <button
              type="button"
              onClick={() => navigate('/presupuestos')}
              className="h-11 px-2 flex items-center gap-1 text-[15px] font-semibold text-[#11704F] active:bg-gray-100 rounded-lg shrink-0"
            >
              <ArrowLeft className="w-5 h-5" /> Presupuestos
            </button>
            <span className="text-[15px] font-bold text-[#16221D] shrink-0">#{numero}</span>
            <div className="ml-auto min-w-0 overflow-hidden flex justify-end">
              <IndicadorGuardado estado={indicador.estado} ultimo={indicador.ultimo} detalle={indicador.detalle || null} />
            </div>
          </div>
        ) : (
        <div className="bg-white border-b border-[#E1E6E3] px-4 sm:px-8 py-2.5 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2.5 text-sm text-[#5B6B64]">
            <button
              type="button"
              onClick={() => navigate('/presupuestos')}
              className="flex items-center gap-1.5 font-semibold text-[#11704F] hover:text-[#0B5139]"
            >
              <ArrowLeft className="w-4 h-4" /> Presupuestos
            </button>
            <span>/</span>
            <span className="font-semibold text-[#16221D]">Presupuesto #{numero}</span>
          </div>
          <div className="flex flex-wrap items-center gap-3 sm:gap-4">
            <span className="px-2.5 py-1 rounded-full text-xs font-bold text-[#5B3E96] bg-[#F0EBFA] border border-[#D9CCF2]">
              Formato nuevo (en pruebas)
            </span>
            <button
              type="button"
              onClick={async () => {
                // Lo pendiente se guarda antes de cambiar de formato
                await autoguardado.guardarYa();
                setFormatoNuevo(false);
              }}
              className="h-8 px-3 rounded-lg border border-[#CBD3CF] bg-white text-xs sm:text-sm font-bold text-[#16221D] flex items-center gap-1.5 hover:bg-gray-50"
            >
              <Undo2 className="w-4 h-4" /> Volver al formato anterior
            </button>
            <span className="hidden sm:block w-px h-5 bg-[#E1E6E3]" />
            <IndicadorGuardado estado={indicador.estado} ultimo={indicador.ultimo} detalle={indicador.detalle || null} />
            {/* Los cambios se guardan solos; esto solo fuerza lo pendiente */}
            <button
              type="button"
              onClick={() => autoguardado.guardarYa()}
              className="h-8 px-2.5 rounded-lg border border-transparent text-xs sm:text-sm font-semibold text-[#33443C] flex items-center gap-1.5 hover:bg-gray-50 hover:border-[#CBD3CF]"
              title="Los cambios se guardan solos. Pulsa para guardar ya lo pendiente."
              data-testid="ficha-guardar"
              data-uso="presupuesto.guardar"
            >
              <Save className="w-4 h-4" /> Guardar
            </button>
          </div>
        </div>
        )}
        <Toaster />
        {avisoConservados && (
          <div
            role="status"
            className="px-4 sm:px-8 py-2 bg-[#FFF8E6] border-b border-[#F1DFA8] text-xs sm:text-sm text-[#6B4E00] flex items-start justify-between gap-3"
          >
            <span>
              Se han conservado cambios más recientes de otra sesión en: {avisoConservados.join(', ')}. Se ha recargado el presupuesto.
            </span>
            <button
              type="button"
              onClick={() => setAvisoConservados(null)}
              className="shrink-0 font-bold hover:underline"
            >
              Cerrar
            </button>
          </div>
        )}
        {avisoHuerfanas && (
          <div
            role="status"
            className="px-4 sm:px-8 py-2 bg-[#FFF8E6] border-b border-[#F1DFA8] text-xs sm:text-sm text-[#6B4E00] flex items-start justify-between gap-3"
            data-testid="aviso-adaptaciones-huerfanas"
          >
            <span>
              Alérgenos: {textoAdaptacionesHuerfanas(avisoHuerfanas)} Revisa la pestaña Alérgenos.
            </span>
            <button
              type="button"
              onClick={() => setAvisoHuerfanas(null)}
              className="shrink-0 font-bold hover:underline"
            >
              Cerrar
            </button>
          </div>
        )}

        {/* Cabecera */}
        {movilFicha ? renderCabeceraMovil({
          ciclo, numero, nombreCliente, claseEstado, chipsAvisoCabecera, costesOk, margen, textoMargen, MARGEN_MINIMO,
          diaSemana, fechaCabecera, avisos, renderBotonPestana,
        }) : (
        <div className="bg-white border-b border-[#E1E6E3] px-4 sm:px-8 pt-5 sm:pt-6">
          <div className="flex flex-col xl:flex-row xl:justify-between xl:items-start gap-5">
            <div className="flex flex-col gap-3 min-w-0">
              <div className="flex flex-wrap items-center gap-3">
                <h1 className="text-2xl sm:text-[28px] font-extrabold tracking-tight leading-tight break-words">{nombreCliente}</h1>
                <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${claseEstado}`}>
                  {String(presupuesto.estado || '').toUpperCase()}
                </span>
                {chipsAvisoCabecera}
              </div>
              <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-[#33443C]">
                <span className="flex items-center gap-1.5">
                  <Building2 className="w-4 h-4 flex-shrink-0" />
                  <button
                    type="button"
                    onClick={() => window.open(`/clientes?cliente_id=${presupuesto.cliente_id}`, '_blank')}
                    className="font-semibold text-[#11704F] hover:underline"
                    title="Ver detalles del cliente"
                  >
                    {nombreCliente}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setShowCambiarClienteModal(true);
                      cargarTodosClientes();
                    }}
                    className="ml-1 px-2 py-0.5 rounded-md border border-[#CBD3CF] text-xs font-semibold text-[#33443C] hover:bg-gray-50"
                    title="Cambiar cliente del presupuesto"
                  >
                    Cambiar cliente
                  </button>
                </span>
                <span className="flex flex-wrap items-center gap-1.5">
                  <Calendar className="w-4 h-4 flex-shrink-0" />
                  {diaSemana && <span>{diaSemana}</span>}
                  {renderCampoFecha(`${claseCampo} w-[8.5rem]`)}
                  <VerEnCalendario presupuesto={presupuesto} className="ml-1" />
                </span>
                <span className="flex flex-wrap items-center gap-1.5">
                  <Clock className="w-4 h-4 flex-shrink-0" />
                  {renderCampoHoraInicio(`${claseCampo} w-[5.5rem]`)}
                  <span>a</span>
                  {renderCampoHoraFin(`${claseCampo} w-[5.5rem]`)}
                  {renderIndicadorDiaSiguiente()}
                  <span className="text-[#5B6B64]">· llegada</span>
                  {renderCampoLlegada(`${claseCampo} w-[5.5rem]`)}
                </span>
                <button
                  type="button"
                  onClick={() => setPestanaActiva('logistica', 'lugar')}
                  className="flex items-center gap-1.5 hover:text-[#11704F] text-left"
                  title="Ver lugar y transporte"
                >
                  <MapPin className="w-4 h-4 flex-shrink-0" />
                  <span className="truncate max-w-[18rem]">{presupuesto.lugar_evento || 'Sin lugar'}</span>
                </button>
                <span className="flex items-center gap-1.5">
                  <Users className="w-4 h-4 flex-shrink-0" />
                  {renderCampoPersonas(`${claseCampo} w-16`)}
                  {!esMultieventoFicha() && <span>personas</span>}
                </span>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-4 sm:gap-6 flex-shrink-0">
              <div className="flex flex-col items-start xl:items-end gap-0.5 whitespace-nowrap">
                <span className="text-xs font-semibold text-[#5B6B64]">TOTAL CON IVA</span>
                <span className="text-2xl sm:text-[28px] font-extrabold tabular-nums">
                  {/* Multievento: el total del servidor (jornadas y suplementos), no el de la cabecera */}
                  {formatEuros(totalPresupuesto())}
                </span>
              </div>
              <div className="flex flex-col gap-1.5 w-[170px] px-3 py-2 border border-dashed border-duetto-primary rounded-[10px]" data-testid="margen-interno">
                <span className="text-[11px] font-bold tracking-wider text-[#0F5E43]">MARGEN · INTERNO</span>
                <div className="flex justify-between items-baseline">
                  <span className={`text-[22px] font-extrabold ${costesOk ? textoMargen : 'text-[#5B6B64]'}`}>
                    {costesOk ? `${margen.toLocaleString('es-ES', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %` : 'Sin calcular'}
                  </span>
                  {costesOk && <span className="text-xs text-[#5B6B64]">{formatEuros(costesGuardados.beneficio)}</span>}
                </div>
                <div
                  className="h-1.5 rounded-full bg-[#E6ECE9] relative"
                  title={`Margen interno sobre la venta sin IVA: beneficio / ingresos. Mínimo de la casa: ${MARGEN_MINIMO} %`}
                  data-testid="margen-barra"
                >
                  <div className={`h-1.5 rounded-full ${colorMargen}`} style={{ width: `${anchoMargen}%` }} />
                  <div
                    className="absolute -top-[3px] w-0.5 h-3 bg-[#16221D]"
                    style={{ left: `${MARGEN_MINIMO}%` }}
                  />
                </div>
                <div className="relative h-3.5 text-[10px] leading-none text-[#8A9892]">
                  <span className="absolute left-0 top-0.5">0 %</span>
                  <span
                    className="absolute top-0.5 -translate-x-1/2 whitespace-nowrap font-semibold text-[#5B6B64]"
                    style={{ left: `${MARGEN_MINIMO}%` }}
                  >
                    mín. {MARGEN_MINIMO} %
                  </span>
                  <span className="absolute right-0 top-0.5">100 %</span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {renderSiguientePaso(ciclo)}
                <button
                  type="button"
                  onClick={() => setShowDuplicar(true)}
                  className="h-11 px-3 rounded-lg border border-[#CBD3CF] bg-white text-[#16221D] text-sm font-semibold flex items-center gap-1.5 hover:bg-gray-50"
                  title="Crear una copia con otra fecha (y otro cliente si quieres)"
                  data-testid="boton-duplicar"
                >
                  <Copy className="w-4 h-4" /> Duplicar
                </button>
                {renderMenuAcciones()}
              </div>
            </div>
          </div>

          <div className="mt-3">{renderBotonesDocumentos({ compacto: true })}</div>

          {/* Barra de estados del ciclo */}
          {renderBarraCiclo(ciclo)}

          {/* Pestañas */}
          <div className="flex gap-5 sm:gap-7 mt-3 overflow-x-auto" role="tablist">
            {PESTANAS_VISIBLES.map(p => renderBotonPestana(p, false))}
          </div>
        </div>
        )}

        {/* Contenido de la pestaña */}
        <div className={movilFicha ? 'px-3 py-4' : 'px-4 sm:px-8 py-6'} role="tabpanel">
          {pestanaActiva === 'resumen' && (RESUMEN_NUEVO ? renderPestanaResumen2() : renderPestanaResumen())}
          {pestanaActiva === 'por_hacer' && renderPestanaPorHacer(tareas)}
          {pestanaActiva === 'resumen2' && renderPestanaResumen2()}
          {pestanaActiva === 'lineas' && renderPestanaLineas()}
          {pestanaActiva === 'alergenos' && (
            <PestanaAlergenos
              presupuestoId={id}
              presupuesto={presupuesto}
              correos={correosEvento}
              onActualizado={fetchData}
            />
          )}
          {pestanaActiva === 'logistica' && renderLogistica()}
          {pestanaActiva === 'material' && renderPestanaMaterial()}
          {pestanaActiva === 'compra' && renderPestanaListaCompra()}
          {pestanaActiva === 'facturacion' && renderPestanaFacturacion()}
          {pestanaActiva === 'correos' && renderTarjetaNueva(null, renderCorreos(), { testid: 'correos' })}
          {pestanaActiva === 'historial' && renderPestanaHistorial()}
        </div>
        {renderModalRapido(tareas)}
        {renderModalCobroPrevio()}
        <EnviarFacturaCliente
          factura={facturaEnvioCliente}
          onCerrar={() => setFacturaEnvioCliente(null)}
          onEnviada={() => { fetchData(); cargarDocumentosFacturacion(); }}
        />
        <DuplicarPresupuesto
          abierto={showDuplicar}
          presupuesto={presupuesto}
          onCerrar={() => setShowDuplicar(false)}
          onCreado={(nuevo) => {
            setShowDuplicar(false);
            if (nuevo?.id) navigate(`/presupuestos/${nuevo.id}`);
          }}
        />
        {/* Móvil: barra inferior con el total, el siguiente paso y Más; y sus hojas */}
        {movilFicha && renderBarraInferiorMovil({ ciclo, numero, costesOk, margen, textoMargen })}
      </div>
    );
  };

  return (
    <div className={formatoNuevo ? 'min-h-screen bg-[#F4F6F4] pb-8' : 'min-h-screen bg-gray-50 pb-8'}>
      {/* Overlay de descarga/carga */}
      <LoadingOverlay 
        isLoading={downloading} 
        message={downloadMessage || 'Generando documento...'} 
      />
      
      {/* U-33: aplicar el cambio de personas de la cabecera a las líneas */}
      {renderDialogoPersonas()}

      {/* Formato nuevo (diseño A+) */}
      {formatoNuevo && renderLayoutNuevo()}

      {/* Formato anterior: se renderiza exactamente igual que antes */}
      {!formatoNuevo && (<>
      {/* Header with gradient - Responsive */}
      <div className="bg-gradient-to-r from-duetto-primary to-duetto-secondary text-white px-4 sm:px-8 py-4 sm:py-6 shadow-lg">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
          <div>
            <div className="flex flex-wrap items-center gap-2 sm:gap-3 mb-2">
              <h1 className="text-xl sm:text-3xl font-bold">
                Presupuesto #{presupuesto.numero || presupuesto.numero_presupuesto_legacy || id.split('-').pop()}
              </h1>
              <span className={`px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-semibold ${
                presupuesto.estado === 'confirmado' ? 'bg-green-500' : 
                presupuesto.estado === 'enviado' ? 'bg-blue-500' : 'bg-gray-500'
              }`}>
                {presupuesto.estado.toUpperCase()}
              </span>
              {presupuesto.es_migracion_historica && (
                <span className="px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-semibold bg-purple-500">
                  HISTÓRICO
                </span>
              )}
            </div>
            <p className="text-white text-opacity-90 text-sm sm:text-lg flex items-center flex-wrap gap-2">
              <span className="flex items-center">
                <Building2 className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2" />
                <button
                  onClick={() => window.open(`/clientes?cliente_id=${presupuesto.cliente_id}`, '_blank')}
                  className="hover:underline hover:text-white cursor-pointer"
                  title="Ver detalles del cliente"
                >
                  {presupuesto.cliente_nombre || cliente?.nombre_empresa || cliente?.nombre || 'Cliente'}
                </button>
              </span>
              <button
                onClick={() => {
                  setShowCambiarClienteModal(true);
                  cargarTodosClientes();
                }}
                className="px-2 sm:px-3 py-1 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg text-xs sm:text-sm transition-colors"
                title="Cambiar cliente del presupuesto"
              >
                Cambiar cliente
              </button>
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {/* Interruptor del formato nuevo (en pruebas): se guarda en este navegador */}
            {formatoNuevo ? (
              <>
                <span className="px-2 py-1 rounded-full text-xs font-semibold bg-white text-duetto-primary">
                  Formato nuevo (en pruebas)
                </span>
                <button
                  type="button"
                  onClick={() => setFormatoNuevo(false)}
                  className="px-2 sm:px-3 py-1 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg text-xs sm:text-sm transition-colors"
                >
                  Volver al formato anterior
                </button>
              </>
            ) : (
              <button
                type="button"
                onClick={() => setFormatoNuevo(true)}
                className="px-2 sm:px-3 py-1 bg-white bg-opacity-10 hover:bg-opacity-20 rounded-lg text-xs transition-colors"
                title="Activa en este navegador las novedades en pruebas del presupuesto"
              >
                Probar formato nuevo
              </button>
            )}
            <button
              onClick={() => navigate('/presupuestos')}
              className="absolute top-4 right-4 sm:relative sm:top-0 sm:right-0 p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
            >
              <X className="w-5 h-5 sm:w-6 sm:h-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Evento cancelado: cuándo, por qué, con cuánta antelación y qué se
          deshizo (formato anterior; el nuevo lo enseña en su cabecera) */}
      {presupuesto.estado === 'cancelado' && (
        <div className="px-3 sm:px-8 mt-4" data-testid="cancelacion-info">
          {renderInfoCancelacion()}
        </div>
      )}

      {/* Sin ruta calculada (formato anterior; el nuevo la enseña en el Resumen) */}
      {!formatoNuevo && avisoSinRuta && (
        <div className="px-3 sm:px-8 mt-4">
          {renderAvisoSinRuta()}
        </div>
      )}
      {!formatoNuevo && avisoMadridCentral && (
        <div className="px-3 sm:px-8 mt-4">
          {renderAvisoMadridCentral()}
        </div>
      )}
      {/* Confirmado modificado (U-09): el stock, los lotes y el material siguen como estaban */}
      {renderAvisoConfirmadoModificado('px-3 sm:px-8 mt-4')}

      {/* Alerta de depósitos del cliente */}
      {depositosCliente && depositosCliente.total_disponible > 0.01 && (
        <div className="px-3 sm:px-8 mt-4" data-testid="deposito-cliente-alert">
          {renderAvisoDeposito()}
        </div>
      )}

      {/* Barra de Acciones Principal */}
      <div className="px-3 sm:px-8 mt-4">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 flex flex-wrap items-center justify-between gap-3">
          {/* Botones de Documentos - Izquierda */}
          {renderBotonesDocumentos()}

          {/* Botones de Estado - Derecha */}
          <div className="flex items-center gap-2">
            {presupuesto.estado === 'confirmado' ? (
              <>
                <button
                  onClick={handleDesconfirmar}
                  className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors text-sm font-medium flex items-center gap-2"
                >
                  <AlertCircle className="w-4 h-4" />
                  Desconfirmar
                </button>
                <button
                  onClick={handleCancelarEvento}
                  className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium flex items-center gap-2"
                >
                  <X className="w-4 h-4" />
                  Cancelar Evento
                </button>
              </>
            ) : (presupuesto.estado === 'cancelado' || presupuesto.estado === 'rechazado') ? (
              // Cancelado o rechazado: se reabre como borrador antes de confirmar
              <button
                onClick={handleReabrir}
                className="px-4 py-2 bg-white border border-gray-300 text-gray-800 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium flex items-center gap-2"
                data-testid="reabrir-borrador"
              >
                Reabrir como borrador
              </button>
            ) : (
              <button
                onClick={handleConfirmar}
                data-uso="presupuesto.confirmar"
                disabled={confirmacionEnCurso()}
                className="px-6 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-bold flex items-center gap-2 shadow-lg disabled:opacity-60"
              >
                <CheckCircle className="w-5 h-5" />
                {textoBotonConfirmar('Confirmar Evento')}
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="px-3 sm:px-8 mt-4 sm:mt-6 space-y-4 sm:space-y-6">

        {/* Sobrante estimado: OCULTO a petición del usuario (30-sep-2026) hasta afinar el cálculo.
            Para reactivarlo, volver a llamar a renderSobrante() aquí. */}
        {false && renderSobrante()}

        {/* Event Info Cards - Responsive */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4">
          {/* Personas - Editable inline */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 sm:p-4 hover:border-blue-300 transition-colors">
            <div className="flex items-center space-x-2 sm:space-x-3">
              <div className="p-2 sm:p-3 bg-duetto-primary bg-opacity-10 rounded-lg">
                <Users className="w-5 h-5 sm:w-6 sm:h-6 text-duetto-primary" />
              </div>
              <div className="flex-1">
                <p className="text-xs sm:text-sm text-gray-600">Personas</p>
                {renderCampoPersonas("text-lg sm:text-2xl font-bold text-gray-900 border-0 border-b-2 border-transparent hover:border-blue-300 focus:border-blue-500 focus:outline-none w-16 sm:w-20 transition-colors")}
              </div>
            </div>
          </div>

          {/* Fecha - Editable inline */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 sm:p-4 hover:border-blue-300 transition-colors">
            <div className="flex items-center space-x-2 sm:space-x-3">
              <div className="p-2 sm:p-3 bg-duetto-yellow bg-opacity-20 rounded-lg">
                <Calendar className="w-5 h-5 sm:w-6 sm:h-6 text-duetto-yellow" />
              </div>
              <div className="flex-1">
                <p className="text-xs sm:text-sm text-gray-600">Fecha</p>
                {renderCampoFecha("text-xs sm:text-sm font-bold text-gray-900 border-0 border-b-2 border-transparent hover:border-blue-300 focus:border-blue-500 focus:outline-none transition-colors w-full")}
                <VerEnCalendario presupuesto={presupuesto} className="mt-1" />
              </div>
            </div>
          </div>

          {/* Horario - Editable inline con indicador de día siguiente */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 sm:p-4 hover:border-blue-300 transition-colors">
            <div className="flex items-center space-x-2 sm:space-x-3">
              <div className="p-2 sm:p-3 bg-duetto-blue bg-opacity-20 rounded-lg">
                <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-duetto-blue" />
              </div>
              <div className="flex-1">
                <p className="text-xs sm:text-sm text-gray-600">Horario</p>
                <div className="flex gap-1 items-center">
                  {renderCampoHoraInicio("text-xs sm:text-sm font-bold text-gray-900 border-0 border-b-2 border-transparent hover:border-blue-300 focus:border-blue-500 focus:outline-none w-16 sm:w-20 transition-colors")}
                  <span className="text-gray-600 hidden sm:inline">-</span>
                  {renderCampoHoraFin("text-sm font-bold text-gray-900 border-0 border-b-2 border-transparent hover:border-blue-300 focus:border-blue-500 focus:outline-none w-20 transition-colors")}
                  {renderIndicadorDiaSiguiente()}
                </div>
                {/* Hora de llegada estimada */}
                <div className="hidden sm:flex items-center gap-2 mt-2">
                  <span className="text-xs text-gray-500">🚚 Llegada:</span>
                  {renderCampoLlegada("text-xs font-medium text-orange-600 border border-orange-200 rounded px-2 py-0.5 w-20 focus:border-orange-500 focus:outline-none")}
                </div>
              </div>
            </div>
          </div>

          {/* Total Card - Responsive */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 sm:p-4">
            <div className="flex items-center space-x-2 sm:space-x-3">
              <div className="p-2 sm:p-3 bg-green-100 rounded-lg">
                <DollarSign className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" />
              </div>
              <div>
                <p className="text-xs sm:text-sm text-gray-600">Total</p>
                <p className="text-lg sm:text-2xl font-bold text-duetto-primary">€{totalPresupuesto().toFixed(2)}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Sección Multi-Evento - Solo mostrar si tiene 2+ jornadas */}
        {renderMultievento()}

        {/* Main Content - Layout Optimizado y Compacto */}
        
        {/* Tabla de Presupuesto (ancho completo) */}
        {renderTablaLineas()}

          {/* Grid de 2 columnas para Contacto/Info y Análisis/Pagos */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
            
            {/* Columna Izquierda: Contacto e Información */}
            <div className="space-y-4">
            
            {/* Contact Info - MEJORADO con selectores */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
              {renderCabeceraContacto()}

              {/* Persona de Contacto del Evento */}
              {renderContactoEvento()}

              {/* Contacto de Facturación */}
              {renderContactoFacturacion()}

              {/* Opciones de Facturación Multi-Evento */}
              {renderFacturacionMultievento()}

              {/* Lugar del Evento - Editable con Google Maps Autocomplete */}
              {renderLugarYTransporte()}
            </div>

            {/* Tabs - Notas, Personal, Furgonetas, Bebidas */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200">
              <div className="border-b border-gray-200">
                <nav className="flex">
                  <button
                    onClick={() => setActiveTab('observaciones')}
                    className={`flex-1 px-4 py-3 text-sm font-medium ${
                      activeTab === 'observaciones'
                        ? 'border-b-2 border-duetto-primary text-duetto-primary bg-duetto-primary bg-opacity-5'
                        : 'text-gray-600 hover:text-gray-900'
                    }`}
                  >
                    Notas
                  </button>
                  <button
                    onClick={() => setActiveTab('personal')}
                    className={`flex-1 px-4 py-3 text-sm font-medium relative ${
                      activeTab === 'personal'
                        ? 'border-b-2 border-duetto-primary text-duetto-primary bg-duetto-primary bg-opacity-5'
                        : 'text-gray-600 hover:text-gray-900'
                    }`}
                  >
                    Personal
                    {faltaPersonal && (
                      <span className="absolute -top-1 -right-1 w-5 h-5 bg-orange-500 text-white text-xs rounded-full flex items-center justify-center font-bold">!</span>
                    )}
                  </button>
                  <button
                    onClick={() => setActiveTab('furgonetas')}
                    className={`flex-1 px-4 py-3 text-sm font-medium relative ${
                      activeTab === 'furgonetas'
                        ? 'border-b-2 border-duetto-primary text-duetto-primary bg-duetto-primary bg-opacity-5'
                        : 'text-gray-600 hover:text-gray-900'
                    }`}
                  >
                    Furgonetas
                    {faltanFurgonetas && (
                      <span className="absolute -top-1 -right-1 w-5 h-5 bg-orange-500 text-white text-xs rounded-full flex items-center justify-center font-bold">!</span>
                    )}
                  </button>
                  <button
                    onClick={() => setActiveTab('bebidas')}
                    className={`flex-1 px-4 py-3 text-sm font-medium relative ${
                      activeTab === 'bebidas'
                        ? 'border-b-2 border-duetto-primary text-duetto-primary bg-duetto-primary bg-opacity-5'
                        : 'text-gray-600 hover:text-gray-900'
                    }`}
                  >
                    Bebidas
                    {faltanBebidas && (
                      <span className="absolute -top-1 -right-1 w-5 h-5 bg-orange-500 text-white text-xs rounded-full flex items-center justify-center font-bold">!</span>
                    )}
                  </button>
                  <button
                    onClick={() => setActiveTab('alquiler')}
                    className={`flex-1 px-4 py-3 text-sm font-medium relative ${
                      activeTab === 'alquiler'
                        ? 'border-b-2 border-purple-600 text-purple-600 bg-purple-50'
                        : 'text-gray-600 hover:text-gray-900'
                    }`}
                    data-testid="tab-alquiler"
                  >
                    Alquiler
                    {(presupuesto?.materiales_alquiler?.length > 0) && (
                      <span className="ml-1 px-1.5 py-0.5 text-xs bg-purple-100 text-purple-700 rounded-full">{presupuesto.materiales_alquiler.length}</span>
                    )}
                  </button>
                  <button
                    onClick={() => setActiveTab('correos')}
                    className={`flex-1 px-4 py-3 text-sm font-medium relative ${
                      activeTab === 'correos'
                        ? 'border-b-2 border-duetto-primary text-duetto-primary bg-duetto-primary bg-opacity-5'
                        : 'text-gray-600 hover:text-gray-900'
                    }`}
                    data-testid="tab-correos"
                  >
                    Correos
                  </button>
                </nav>
              </div>

              <div className="p-4">
                {activeTab === 'observaciones' && (
                  <div className="space-y-4">
                    {renderObservaciones()}
                    {renderNotasAdministracion()}
                  </div>
                )}

                {activeTab === 'personal' && (
                  renderPersonal()
                )}

                {activeTab === 'furgonetas' && (
                  renderFurgonetas()
                )}

                {activeTab === 'bebidas' && (
                  renderBebidas()
                )}

                {/* TAB: Material de Alquiler */}
                {activeTab === 'alquiler' && (
                  renderAlquiler()
                )}

                {activeTab === 'correos' && (
                  renderCorreos()
                )}
              </div>
            </div>

          </div>

          {/* Columna Derecha: Análisis Financiero + Pagos + Acciones */}
          <div className="space-y-4">
            {/* Financial Summary - REDISEÑADO */}
            {renderAnalisisFinanciero()}

          </div>
        </div>

      </div>
      </>)}

      {/* Modal: Nueva Persona de Contacto */}
      {showNewContactoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4" style={{zIndex: 10000}}>
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Nueva Persona de Contacto</h3>
            
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nombre *</label>
                <input
                  type="text"
                  value={newContacto.nombre}
                  onChange={(e) => setNewContacto({...newContacto, nombre: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  placeholder="Nombre completo"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Cargo</label>
                <input
                  type="text"
                  value={newContacto.cargo}
                  onChange={(e) => setNewContacto({...newContacto, cargo: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  placeholder="Ej: Gerente de Eventos"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  value={newContacto.email}
                  onChange={(e) => setNewContacto({...newContacto, email: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  placeholder="email@ejemplo.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
                <div className="flex gap-2">
                  <select
                    value={newContacto.telefono_prefijo || ''}
                    onChange={(e) => setNewContacto({...newContacto, telefono_prefijo: e.target.value})}
                    className="w-24 border border-gray-300 rounded-lg px-2 py-2 text-sm"
                  >
                    <option value="">🇪🇸 +34</option>
                    <option value="+33">🇫🇷 +33</option>
                    <option value="+351">🇵🇹 +351</option>
                    <option value="+44">🇬🇧 +44</option>
                    <option value="+49">🇩🇪 +49</option>
                    <option value="+39">🇮🇹 +39</option>
                    <option value="+1">🇺🇸 +1</option>
                    <option value="+41">🇨🇭 +41</option>
                    <option value="+31">🇳🇱 +31</option>
                    <option value="+32">🇧🇪 +32</option>
                  </select>
                  <input
                    type="tel"
                    value={newContacto.telefono}
                    onChange={(e) => setNewContacto({...newContacto, telefono: e.target.value})}
                    className="flex-1 border border-gray-300 rounded-lg px-3 py-2"
                    placeholder="600 000 000"
                  />
                  <input
                    type="text"
                    value={newContacto.extension || ''}
                    onChange={(e) => setNewContacto({...newContacto, extension: e.target.value})}
                    className="w-20 border border-gray-300 rounded-lg px-3 py-2"
                    placeholder="Ext."
                    title="Extensión del teléfono"
                    data-testid="contacto-ficha-extension"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Notas</label>
                <textarea
                  value={newContacto.notas}
                  onChange={(e) => setNewContacto({...newContacto, notas: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  rows="2"
                  placeholder="Información adicional"
                />
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={() => {
                  setShowNewContactoModal(false);
                  setNewContacto({nombre: '', cargo: '', email: '', telefono: '', telefono_prefijo: '', notas: ''});
                }}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                onClick={handleCreateContacto}
                className="flex-1 px-4 py-2 bg-duetto-primary text-white rounded-lg hover:bg-opacity-90"
              >
                Crear Contacto
              </button>
            </div>
          </div>
        </div>
      )}

 

      {/* Modal: Descuento */}
      {showDescuentoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Aplicar Descuento al Menú</h3>
            
            <div className="space-y-4">
              {/* Tipo de descuento */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Tipo de Descuento</label>
                <div className="grid grid-cols-2 gap-3">
                  <button
                    onClick={() => setDescuentoData({...descuentoData, tipo: 'porcentaje'})}
                    className={`px-4 py-2 rounded-lg border-2 transition ${
                      descuentoData.tipo === 'porcentaje'
                        ? 'border-duetto-primary bg-duetto-primary bg-opacity-10 text-duetto-primary font-semibold'
                        : 'border-gray-300 text-gray-700'
                    }`}
                  >
                    % Porcentaje
                  </button>
                  <button
                    onClick={() => setDescuentoData({...descuentoData, tipo: 'fijo'})}
                    className={`px-4 py-2 rounded-lg border-2 transition ${
                      descuentoData.tipo === 'fijo'
                        ? 'border-duetto-primary bg-duetto-primary bg-opacity-10 text-duetto-primary font-semibold'
                        : 'border-gray-300 text-gray-700'
                    }`}
                  >
                    € Importe Fijo
                  </button>
                </div>
              </div>

              {/* Valor del descuento */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {descuentoData.tipo === 'porcentaje' ? 'Porcentaje (%)' : 'Importe (€)'}
                </label>
                <input
                  type="number"
                  step={descuentoData.tipo === 'porcentaje' ? '1' : '0.01'}
                  min="0"
                  max={descuentoData.tipo === 'porcentaje' ? '100' : undefined}
                  value={descuentoData.valor}
                  onChange={(e) => setDescuentoData({...descuentoData, valor: parseFloat(e.target.value) || 0})}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  placeholder={descuentoData.tipo === 'porcentaje' ? '0-100' : '0.00'}
                />
              </div>

              {/* Vista previa */}
              {descuentoMenuIndex !== null && presupuesto.menus_personalizados?.[descuentoMenuIndex] && (
                <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
                  <div className="text-xs text-blue-700">
                    <div className="flex justify-between mb-1">
                      <span>Precio Original:</span>
                      <span className="font-bold">
                        €{safeToFixed(presupuesto.menus_personalizados[descuentoMenuIndex].precio_unitario_original || 
                           presupuesto.menus_personalizados[descuentoMenuIndex].precio_unitario ||
                           presupuesto.menus_personalizados[descuentoMenuIndex].precio_ud ||
                           presupuesto.menus_personalizados[descuentoMenuIndex].precio_persona ||
                           presupuesto.menus_personalizados[descuentoMenuIndex].precio_por_persona ||
                           presupuesto.menus_personalizados[descuentoMenuIndex].precio_venta ||
                           presupuesto.menus_personalizados[descuentoMenuIndex].precio_total, 2)}
                      </span>
                    </div>
                    <div className="flex justify-between mb-1">
                      <span>Descuento:</span>
                      <span className="font-bold text-red-600">
                        -{descuentoData.tipo === 'porcentaje' 
                          ? `${descuentoData.valor}%` 
                          : `€${safeToFixed(descuentoData.valor, 2)}`}
                      </span>
                    </div>
                    <div className="border-t border-blue-300 pt-1 mt-1">
                      <div className="flex justify-between">
                        <span className="font-semibold">Precio Final:</span>
                        <span className="font-bold text-green-600">
                          €{(() => {
                            const precioOriginal = presupuesto.menus_personalizados[descuentoMenuIndex].precio_unitario_original || 
                                                  presupuesto.menus_personalizados[descuentoMenuIndex].precio_unitario ||
                                                  presupuesto.menus_personalizados[descuentoMenuIndex].precio_ud ||
                                                  presupuesto.menus_personalizados[descuentoMenuIndex].precio_persona ||
                                                  presupuesto.menus_personalizados[descuentoMenuIndex].precio_por_persona ||
                                                  presupuesto.menus_personalizados[descuentoMenuIndex].precio_venta ||
                                                  presupuesto.menus_personalizados[descuentoMenuIndex].precio_total || 0;
                            let precioFinal = precioOriginal;
                            if (descuentoData.tipo === 'porcentaje') {
                              precioFinal = precioOriginal * (1 - (descuentoData.valor || 0) / 100);
                            } else {
                              precioFinal = precioOriginal - (descuentoData.valor || 0);
                            }
                            return safeToFixed(Math.max(0, precioFinal), 2);
                          })()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={() => {
                  setShowDescuentoModal(false);
                  setDescuentoMenuIndex(null);
                  setDescuentoData({ tipo: 'porcentaje', valor: 0 });
                }}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                onClick={handleAplicarDescuento}
                className="flex-1 px-4 py-2 bg-duetto-primary text-white rounded-lg hover:bg-opacity-90"
              >
                Aplicar Descuento
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Editar Platos del Menú - VERSIÓN MEJORADA */}
      {showEditPlatosModal && editPlatosMenuIndex !== null && presupuesto.menus_personalizados?.[editPlatosMenuIndex] && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 max-md:p-0 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-6xl w-full max-h-[90vh] overflow-hidden flex flex-col max-md:max-w-none max-md:h-full max-md:max-h-none max-md:rounded-none max-md:[&_input]:text-base max-md:[&_select]:text-base max-md:[&_textarea]:text-base">
            {/* Header */}
            <div className="px-6 max-md:px-4 py-4 border-b border-gray-200 flex justify-between items-center bg-gradient-to-r from-blue-50 to-blue-100">
              <div>
                <h3 className="text-xl font-bold text-gray-900">🍽️ Editar Platos del Menú</h3>
                <p className="text-sm text-gray-600">
                  {presupuesto.menus_personalizados[editPlatosMenuIndex].nombre_menu}
                </p>
              </div>
              <button 
                onClick={() => {
                  setShowEditPlatosModal(false);
                  setEditPlatosMenuIndex(null);
                  setEditedPlatos([]);
                  setPlatoSearchTerm('');
                  setPlatoFiltersEdit({
                    precioMax: '',
                    categoria: '',
                    sinAlergenos: []
                  });
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6 max-md:p-4">
              {/* Info Banner */}
              <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                <p className="text-sm text-blue-800">
                  ℹ️ Puedes modificar los platos de este menú específico sin afectar al menú base del catálogo.
                  Define las unidades de cada plato (ej: 0.5 para media ración, 2 para doble).
                </p>
              </div>

              {/* Switch Bebida Incluida */}
              <div className="mb-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">
                <div className="flex items-center justify-between max-md:flex-wrap max-md:gap-3">
                  <div className="flex items-center gap-3">
                    <span className="text-2xl">🍷</span>
                    <div>
                      <h5 className="font-semibold text-amber-900">Bebida incluida</h5>
                      <p className="text-xs text-amber-700">¿Este menú incluye bebida por persona?</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    {presupuesto.menus_personalizados[editPlatosMenuIndex].bebida_incluida && (
                      <div className="flex items-center gap-2">
                        <label className="text-sm text-amber-800">Cantidad:</label>
                        <input
                          type="number"
                          min="1"
                          max="5"
                          value={presupuesto.menus_personalizados[editPlatosMenuIndex].bebidas_por_persona || ''}
                          onChange={async (e) => {
                            const valor = e.target.value;
                            const cantidad = valor === '' ? '' : (parseInt(valor) || 1);
                            const updatedMenus = [...presupuesto.menus_personalizados];
                            updatedMenus[editPlatosMenuIndex] = {
                              ...updatedMenus[editPlatosMenuIndex],
                              bebidas_por_persona: cantidad
                            };
                            const updatedPresupuesto = { ...presupuesto, menus_personalizados: updatedMenus };
                            setPresupuesto(updatedPresupuesto);
                            if (cantidad !== '') {
                              await guardarFicha(updatedPresupuesto);
                            }
                          }}
                          onBlur={async (e) => {
                            if (e.target.value === '') {
                              const updatedMenus = [...presupuesto.menus_personalizados];
                              updatedMenus[editPlatosMenuIndex] = {
                                ...updatedMenus[editPlatosMenuIndex],
                                bebidas_por_persona: 1
                              };
                              const updatedPresupuesto = { ...presupuesto, menus_personalizados: updatedMenus };
                              setPresupuesto(updatedPresupuesto);
                              await guardarFicha(updatedPresupuesto);
                            }
                          }}
                          className="w-16 px-2 py-1 border border-amber-300 rounded text-center text-sm"
                        />
                      </div>
                    )}
                    <button
                      onClick={async () => {
                        const currentValue = presupuesto.menus_personalizados[editPlatosMenuIndex].bebida_incluida || false;
                        const updatedMenus = [...presupuesto.menus_personalizados];
                        updatedMenus[editPlatosMenuIndex] = {
                          ...updatedMenus[editPlatosMenuIndex],
                          bebida_incluida: !currentValue,
                          bebidas_por_persona: !currentValue ? 1 : 0
                        };
                        const updatedPresupuesto = { ...presupuesto, menus_personalizados: updatedMenus };
                        setPresupuesto(updatedPresupuesto);
                        aplicarRespuestaGuardado(await guardarFicha(updatedPresupuesto), updatedPresupuesto);
                      }}
                      className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors ${
                        presupuesto.menus_personalizados[editPlatosMenuIndex].bebida_incluida
                          ? 'bg-amber-500'
                          : 'bg-gray-300'
                      }`}
                    >
                      <span
                        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-transform ${
                          presupuesto.menus_personalizados[editPlatosMenuIndex].bebida_incluida
                            ? 'translate-x-8'
                            : 'translate-x-1'
                        }`}
                      />
                    </button>
                  </div>
                </div>
              </div>

              {/* Platos seleccionados actualmente */}
              <div className="mb-6">
                <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-sm">
                    {editedPlatos.length} platos seleccionados
                  </span>
                  <span className="text-xs text-gray-500 ml-2">Usa las flechas para reordenar</span>
                </h4>
                {editedPlatos.length > 0 ? (
                  <div className="space-y-2 md:max-h-[300px] md:overflow-y-auto pr-2">
                    {editedPlatos.map((item, index) => {
                      const plato = platos.find(p => p.id === item.platoId);
                      if (!plato) return null;
                      const costoPlato = plato.coste_por_porcion || plato.coste_total || 0;
                      const isFirst = index === 0;
                      const isLast = index === editedPlatos.length - 1;
                      return (
                        <div 
                          key={item.platoId}
                          className="flex items-center gap-2 p-2 bg-green-50 border border-green-300 rounded-lg"
                        >
                          {/* Botones de ordenar */}
                          <div className="flex flex-col gap-0.5">
                            <button
                              onClick={() => handleMovePlatoUp(item.platoId)}
                              disabled={isFirst}
                              className={`p-1 rounded ${isFirst ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-200'}`}
                              title="Mover arriba"
                            >
                              <ChevronUp className="w-4 h-4" />
                            </button>
                            <button
                              onClick={() => handleMovePlatoDown(item.platoId)}
                              disabled={isLast}
                              className={`p-1 rounded ${isLast ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-200'}`}
                              title="Mover abajo"
                            >
                              <ChevronDown className="w-4 h-4" />
                            </button>
                          </div>
                          
                          {/* Número de orden */}
                          <span className="text-xs text-gray-400 w-5">{index + 1}.</span>
                          
                          {/* Info del plato */}
                          <div className="flex-1 min-w-0">
                            <p className="font-medium text-gray-900 text-sm truncate">{plato.nombre}</p>
                            <p className="text-xs text-gray-600">
                              €{costoPlato.toFixed(2)} × {item.unidades} = 
                              <span className="font-semibold text-green-700 ml-1">
                                €{(costoPlato * item.unidades).toFixed(2)}
                              </span>
                            </p>
                          </div>
                          
                          {/* Controles */}
                          <div className="flex items-center gap-2 flex-shrink-0">
                            <input
                              type="number"
                              min="0.1"
                              step="0.1"
                              value={item.unidades}
                              onChange={(e) => handleUpdatePlatoUnidades(item.platoId, e.target.value)}
                              className="w-16 px-2 py-1 border border-gray-300 rounded text-sm text-center"
                              placeholder="Uds"
                            />
                            <button
                              onClick={() => handleTogglePlatoWithUnits(item.platoId)}
                              className="p-1.5 bg-red-500 text-white rounded hover:bg-red-600"
                              title="Quitar plato"
                            >
                              <X className="w-4 h-4" />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-8 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                    <p className="text-gray-600">No hay platos seleccionados</p>
                  </div>
                )}
              </div>

              <div className="border-t border-gray-200 pt-6">
                {/* Buscador y Filtros */}
                <div className="mb-4">
                  <h4 className="font-semibold text-gray-900 mb-3">
                    🔍 Buscar y añadir platos
                  </h4>
                  
                  {/* Buscador */}
                  <div className="mb-3">
                    <input
                      type="text"
                      value={platoSearchTerm}
                      onChange={(e) => setPlatoSearchTerm(e.target.value)}
                      placeholder="Buscar por nombre de plato..."
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>

                  {/* Filtros */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Precio máximo
                      </label>
                      <input
                        type="number"
                        min="0"
                        step="0.5"
                        value={platoFiltersEdit.precioMax}
                        onChange={(e) => setPlatoFiltersEdit({...platoFiltersEdit, precioMax: e.target.value})}
                        placeholder="€ máximo"
                        className="w-full px-3 py-1.5 border border-gray-300 rounded text-sm"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">
                        Categoría
                      </label>
                      <select
                        value={platoFiltersEdit.categoria}
                        onChange={(e) => setPlatoFiltersEdit({...platoFiltersEdit, categoria: e.target.value})}
                        className="w-full px-3 py-1.5 border border-gray-300 rounded text-sm"
                      >
                        <option value="">Todas</option>
                        {[...new Set(platos.map(p => p.categoria).filter(Boolean))].sort((a, b) => a.localeCompare(b)).map(cat => (
                          <option key={cat} value={cat}>{cat}</option>
                        ))}
                      </select>
                    </div>
                    <div className="flex items-end">
                      <button
                        onClick={() => {
                          setPlatoSearchTerm('');
                          setPlatoFiltersEdit({
                            precioMax: '',
                            categoria: '',
                            sinAlergenos: []
                          });
                        }}
                        className="w-full px-3 py-1.5 bg-gray-100 text-gray-700 text-sm rounded hover:bg-gray-200"
                      >
                        Limpiar filtros
                      </button>
                    </div>
                  </div>
                </div>

                {/* Lista de platos disponibles */}
                <div>
                  <h5 className="font-medium text-gray-700 mb-2">
                    Platos disponibles ({getFilteredPlatosForEdit().filter(p => !editedPlatos.find(item => item.platoId === p.id)).length})
                  </h5>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:max-h-64 md:overflow-y-auto border border-gray-200 rounded-lg p-3">
                    {getFilteredPlatosForEdit()
                      .filter(p => !editedPlatos.find(item => item.platoId === p.id))
                      .map(plato => (
                        <div 
                          key={plato.id}
                          className="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-lg hover:border-blue-400 hover:shadow-sm transition"
                        >
                          <div className="flex-1">
                            <p className="font-medium text-gray-900">{plato.nombre}</p>
                            <div className="flex items-center gap-2 mt-1">
                              <span className="text-sm text-gray-600">Coste: €{(plato.coste_por_porcion || plato.coste_total || 0).toFixed(2)}</span>
                              {plato.categoria && (
                                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded">
                                  {plato.categoria}
                                </span>
                              )}
                            </div>
                          </div>
                          <button
                            onClick={() => handleTogglePlatoWithUnits(plato.id)}
                            className="px-3 py-1.5 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 flex items-center gap-1"
                          >
                            <span>+</span> Añadir
                          </button>
                        </div>
                      ))}
                    {getFilteredPlatosForEdit().filter(p => !editedPlatos.find(item => item.platoId === p.id)).length === 0 && (
                      <div className="col-span-2 text-center py-6 text-gray-500">
                        No se encontraron platos con estos filtros
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Vista previa de coste */}
              <div className="mt-6 p-4 bg-gradient-to-r from-yellow-50 to-orange-50 border border-yellow-300 rounded-lg">
                <h5 className="font-semibold text-yellow-900 mb-3 flex items-center gap-2">
                  <DollarSign className="w-5 h-5" />
                  Resumen de Coste
                </h5>
                <div className="space-y-2 text-sm">
                  {(() => {
                    // Calcular coste total de los platos seleccionados (nuevos)
                    let costoTotal = 0;
                    editedPlatos.forEach(item => {
                      const plato = platos.find(p => p.id === item.platoId);
                      if (plato) {
                        costoTotal += (plato.coste_por_porcion || plato.coste_total || 0) * (item.unidades || 1);
                      }
                    });
                    
                    // Calcular coste original basándose en los platos_ids originales del menú
                    let costoOriginal = 0;
                    const menuActual = presupuesto.menus_personalizados[editPlatosMenuIndex];
                    const platosIdsOriginales = menuActual?.platos_ids || [];
                    platosIdsOriginales.forEach(platoId => {
                      const plato = platos.find(p => p.id === platoId);
                      if (plato) {
                        // Por defecto 1 unidad por plato en el menú original
                        costoOriginal += (plato.coste_por_porcion || plato.coste_total || 0);
                      }
                    });
                    
                    return (
                      <>
                        <div className="flex justify-between items-center p-2 bg-white rounded">
                          <span className="text-gray-700">Coste total de platos:</span>
                          <span className="font-bold text-lg text-gray-900">€{costoTotal.toFixed(2)}</span>
                        </div>
                        <div className="flex justify-between p-2 bg-yellow-100 rounded">
                          <span className="text-yellow-800">Coste anterior del menú:</span>
                          <span className="font-medium">
                            €{costoOriginal.toFixed(2)}
                          </span>
                        </div>
                        <div className="flex justify-between items-center p-3 bg-white border-2 border-yellow-400 rounded-lg">
                          <span className="text-yellow-900 font-semibold text-base">Diferencia:</span>
                          <span className={`font-bold text-lg ${costoTotal > costoOriginal ? 'text-red-600' : 'text-green-600'}`}>
                            {costoTotal > costoOriginal ? '+' : ''}
                            €{(costoTotal - costoOriginal).toFixed(2)}
                          </span>
                        </div>
                      </>
                    );
                  })()}
                </div>
                <p className="text-xs text-yellow-800 mt-3 italic bg-yellow-100 p-2 rounded">
                  {presupuesto.menus_personalizados[editPlatosMenuIndex].descuento_valor 
                    ? '⚠️ Nota: El descuento aplicado se mantendrá sobre el nuevo precio' 
                    : '✅ El precio final se calculará basándose en el nuevo coste de platos'}
                </p>
              </div>
            </div>

            {/* Footer con botones */}
            <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex gap-3 max-md:flex-wrap max-md:px-4 max-md:pb-[calc(env(safe-area-inset-bottom)+1rem)] max-md:[&_button]:min-h-[44px]">
              <button
                onClick={() => {
                  setShowEditPlatosModal(false);
                  setEditPlatosMenuIndex(null);
                  setEditedPlatos([]);
                  setPlatoSearchTerm('');
                  setPlatoFiltersEdit({
                    precioMax: '',
                    categoria: '',
                    sinAlergenos: []
                  });
                }}
                className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-100 transition"
              >
                Cancelar
              </button>
              <button
                onClick={handleSaveEditedPlatos}
                disabled={editedPlatos.length === 0}
                className={`flex-1 px-4 py-2.5 font-medium rounded-lg transition ${
                  editedPlatos.length === 0
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-duetto-primary text-white hover:bg-opacity-90 shadow-md'
                }`}
              >
                💾 Guardar Cambios ({editedPlatos.length} platos)
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Gestión de Adaptaciones */}
      {showAdaptacionModal && selectedMenuForAdaptacion && (
        <AdaptacionModal
          menu={selectedMenuForAdaptacion}
          platos={platos}
          alergenos={alergenos}
          adaptaciones={(() => {
            // Cargar adaptaciones directamente del presupuesto para este menú
            const menuIndex = selectedMenuForAdaptacion.personalizadoIndex;
            const menuPers = presupuesto.menus_personalizados?.[menuIndex];
            if (menuPers?.adaptaciones?.length > 0) {
              return menuPers.adaptaciones.map(a => ({
                ...a,
                menu_id: menuPers.menu_id || selectedMenuForAdaptacion.id,
                menu_nombre: menuPers.nombre_menu
              }));
            }
            // Fallback al estado local de adaptaciones
            return adaptaciones.filter(a => 
              a.menu_id === selectedMenuForAdaptacion.id || 
              a.menu_id === selectedMenuForAdaptacion.menuPersonalizado?.menu_id
            );
          })()}
          onClose={() => {
            setShowAdaptacionModal(false);
            setSelectedMenuForAdaptacion(null);
          }}
          onSave={async (nuevasAdaptaciones) => {
            try {
              
              // Eliminar adaptaciones antiguas de este menú en el estado local
              const adaptacionesFiltradas = adaptaciones.filter(a => a.menu_id !== selectedMenuForAdaptacion.id);
              // Añadir las nuevas al estado local
              const todasAdaptaciones = [...adaptacionesFiltradas, ...nuevasAdaptaciones];
              setAdaptaciones(todasAdaptaciones);
              
              // PERSISTIR EN BACKEND: Actualizar menus_personalizados con las adaptaciones
              // Usar personalizadoIndex si está disponible para mayor precisión
              const targetIndex = selectedMenuForAdaptacion.personalizadoIndex;
              
              const menusActualizados = (presupuesto.menus_personalizados || []).map((menu, idx) => {
                // Comparar por índice si está disponible, o por ID
                const esMenuObjetivo = targetIndex !== undefined 
                  ? idx === targetIndex
                  : (menu.id === selectedMenuForAdaptacion.id || menu.menu_id === selectedMenuForAdaptacion.id);
                
                
                if (esMenuObjetivo) {
                  // Encontramos el menú, actualizar sus adaptaciones
                  nuevasAdaptaciones.forEach((a, i) => {
                  });
                  return {
                    ...menu,
                    adaptaciones: nuevasAdaptaciones.map(a => ({
                      num_personas: a.num_personas || 0,
                      nombres_personas: a.nombres_personas || [],
                      alergenos_evitar: a.alergenos_evitar || [],
                      caracteristicas_evitar: a.caracteristicas_evitar || [],
                      tipo: a.tipo || null,
                      observaciones: a.observaciones || '',
                      platos_modificados: a.platos_modificados || {},
                      platos_sustitutos: a.platos_sustitutos || {},
                      platos_unidades_modificadas: a.platos_unidades_modificadas || {},
                      // Campos para preparación separada (alérgicos severos)
                      requiere_preparacion_separada: a.requiere_preparacion_separada || false,
                      tipo_bandeja: a.tipo_bandeja || null,
                      material_bandeja_id: a.material_bandeja_id || null,
                      instrucciones_especiales: a.instrucciones_especiales || '',
                      // Cantidad del sustituto y origen (pestaña Alérgenos), si los hay
                      ...(a.platos_sustitutos_config ? { platos_sustitutos_config: a.platos_sustitutos_config } : {}),
                      ...(a.origen ? { origen: a.origen, comensales_ids: a.comensales_ids || [] } : {})
                    }))
                  };
                }
                return menu;
              });
              
              
              // Guardar en el backend
              const response = await guardarFicha({
                menus_personalizados: menusActualizados
              });
              
              // Estado local: lo que devuelve el servidor (U-32)
              aplicarRespuestaGuardado(response, prev => ({
                ...prev,
                menus_personalizados: menusActualizados
              }));
              
            } catch (error) {
              console.error('❌ Error guardando adaptaciones:', error);
              avisoGuardadoError('Error al guardar las adaptaciones. Por favor, inténtalo de nuevo.', error);
            }
            
            setShowAdaptacionModal(false);
            setSelectedMenuForAdaptacion(null);
          }}
        />
      )}

      {/* Modal: Menú Personalizado */}
      {showCustomMenuModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 max-md:p-0">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col max-md:max-w-none max-md:h-full max-md:max-h-none max-md:rounded-none max-md:[&_input]:text-base max-md:[&_select]:text-base max-md:[&_textarea]:text-base">
            {/* Header */}
            <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
              <div>
                <h3 className="text-lg font-bold text-gray-900">Crear Menú Personalizado</h3>
                <p className="text-sm text-gray-600">Selecciona platos individuales para crear un menú a medida</p>
              </div>
              <button 
                onClick={() => setShowCustomMenuModal(false)} 
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6 max-md:p-4 space-y-6">
              {/* Configuración del menú */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nombre del Menú</label>
                  <input
                    type="text"
                    value={customMenuName}
                    onChange={(e) => setCustomMenuName(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                    placeholder="Nombre del menú personalizado"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Número de Personas</label>
                  <input
                    type="number"
                    value={customMenuPersonas}
                    onChange={(e) => setCustomMenuPersonas(e.target.value)}
                    placeholder={esMultieventoFicha() ? 'Por defecto: las de cada jornada' : `Por defecto: ${presupuesto.num_personas || 0} personas`}
                    min="1"
                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Precio/Persona (€) <span className="text-gray-400 text-xs">(opcional)</span>
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={customMenuPrecio}
                    onChange={(e) => setCustomMenuPrecio(e.target.value)}
                    placeholder="0.00 - Dejar vacío para menú placeholder"
                    min="0"
                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    Coste total platos: €{selectedPlatos.reduce((sum, sp) => {
                      const plato = platos.find(p => p.id === sp.platoId);
                      const costePlato = plato?.coste_por_porcion || plato?.coste_total || plato?.coste_racion || 0;
                      return sum + costePlato * (sp.cantidad || 0);
                    }, 0).toFixed(2)}
                  </p>
                </div>
              </div>
              
              {/* Bebida incluida */}
              <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-xl">🍷</span>
                    <div>
                      <h5 className="font-medium text-amber-900 text-sm">Bebida incluida</h5>
                      <p className="text-xs text-amber-700">¿Este menú incluye bebida por persona?</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    {customMenuBebidaIncluida && (
                      <div className="flex items-center gap-1">
                        <label className="text-xs text-amber-800">Cant:</label>
                        <input
                          type="number"
                          min="1"
                          max="5"
                          value={customMenuBebidasPorPersona}
                          onChange={(e) => setCustomMenuBebidasPorPersona(e.target.value === '' ? '' : (parseInt(e.target.value) || 1))}
                          onBlur={(e) => { if (e.target.value === '') setCustomMenuBebidasPorPersona(1); }}
                          className="w-14 px-2 py-1 border border-amber-300 rounded text-center text-sm"
                        />
                      </div>
                    )}
                    <button
                      type="button"
                      onClick={() => setCustomMenuBebidaIncluida(!customMenuBebidaIncluida)}
                      className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors ${
                        customMenuBebidaIncluida ? 'bg-amber-500' : 'bg-gray-300'
                      }`}
                    >
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-md transition-transform ${
                        customMenuBebidaIncluida ? 'translate-x-7' : 'translate-x-1'
                      }`} />
                    </button>
                  </div>
                </div>
              </div>

              {/* IVA del menú */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">IVA del menú</label>
                <div className="flex gap-2">
                  <label className={`flex-1 flex items-center justify-center gap-1 p-2 rounded-lg border-2 cursor-pointer transition-colors text-sm ${
                    customMenuIva === '10'
                      ? 'border-blue-500 bg-blue-50 text-blue-700'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}>
                    <input
                      type="radio"
                      name="customMenuIva"
                      value="10"
                      checked={customMenuIva === '10'}
                      onChange={(e) => setCustomMenuIva(e.target.value)}
                      className="sr-only"
                    />
                    <span className="font-medium">10%</span>
                    <span className="text-xs text-gray-500">Catering</span>
                  </label>
                  <label className={`flex-1 flex items-center justify-center gap-1 p-2 rounded-lg border-2 cursor-pointer transition-colors text-sm ${
                    customMenuIva === '21'
                      ? 'border-orange-500 bg-orange-50 text-orange-700'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}>
                    <input
                      type="radio"
                      name="customMenuIva"
                      value="21"
                      checked={customMenuIva === '21'}
                      onChange={(e) => setCustomMenuIva(e.target.value)}
                      className="sr-only"
                    />
                    <span className="font-medium">21%</span>
                    <span className="text-xs text-gray-500">Con transporte / otros</span>
                  </label>
                </div>
              </div>

              {/* Filtros */}
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="font-semibold text-gray-900 mb-3">Filtros de Platos</h4>
                
                {/* Filtros básicos */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Precio máximo</label>
                    <input
                      type="number"
                      value={platoFilters.precioMax}
                      onChange={(e) => setPlatoFilters({...platoFilters, precioMax: e.target.value})}
                      placeholder="€"
                      className="w-full px-3 py-2 text-sm border rounded-lg"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Tiempo máx. (min)</label>
                    <input
                      type="number"
                      value={platoFilters.tiempoMax}
                      onChange={(e) => setPlatoFilters({...platoFilters, tiempoMax: e.target.value})}
                      placeholder="minutos"
                      className="w-full px-3 py-2 text-sm border rounded-lg"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Categoría</label>
                    <select
                      value={platoFilters.categoria}
                      onChange={(e) => setPlatoFilters({...platoFilters, categoria: e.target.value})}
                      className="w-full px-3 py-2 text-sm border rounded-lg"
                    >
                      <option value="">Todas</option>
                      <option value="desayuno">Desayuno</option>
                      <option value="comida">Comida</option>
                      <option value="postre">Postre</option>
                      <option value="bebida">Bebida</option>
                    </select>
                  </div>
                </div>

                {/* Características alimentarias */}
                <div className="mb-4">
                  <label className="block text-xs font-medium text-gray-700 mb-2">Evitar características:</label>
                  <div className="flex flex-wrap gap-3">
                    <label className="flex items-center text-sm">
                      <input
                        type="checkbox"
                        checked={platoFilters.contiene_carne}
                        onChange={(e) => setPlatoFilters({...platoFilters, contiene_carne: e.target.checked})}
                        className="mr-2"
                      />
                      Contiene carne
                    </label>
                    <label className="flex items-center text-sm">
                      <input
                        type="checkbox"
                        checked={platoFilters.derivado_animal}
                        onChange={(e) => setPlatoFilters({...platoFilters, derivado_animal: e.target.checked})}
                        className="mr-2"
                      />
                      Derivado animal
                    </label>
                    <label className="flex items-center text-sm">
                      <input
                        type="checkbox"
                        checked={platoFilters.contiene_cerdo}
                        onChange={(e) => setPlatoFilters({...platoFilters, contiene_cerdo: e.target.checked})}
                        className="mr-2"
                      />
                      Contiene cerdo
                    </label>
                    <label className="flex items-center text-sm">
                      <input
                        type="checkbox"
                        checked={platoFilters.no_apto_embarazadas}
                        onChange={(e) => setPlatoFilters({...platoFilters, no_apto_embarazadas: e.target.checked})}
                        className="mr-2"
                      />
                      No apto embarazadas
                    </label>
                    <label className="flex items-center text-sm">
                      <input
                        type="checkbox"
                        checked={platoFilters.sin_lactosa}
                        onChange={(e) => setPlatoFilters({...platoFilters, sin_lactosa: e.target.checked})}
                        className="mr-2"
                      />
                      Solo sin lactosa
                    </label>
                  </div>
                </div>

                {/* Alérgenos - TODOS los 14 legales */}
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-2">Evitar alérgenos (14 legales):</label>
                  
                  {/* Checkbox para incluir trazas */}
                  <div className="mb-3 p-2 bg-orange-50 border border-orange-200 rounded-lg">
                    <label className="flex items-center text-sm cursor-pointer">
                      <input
                        type="checkbox"
                        checked={platoFilters.incluirTrazas}
                        onChange={(e) => setPlatoFilters({...platoFilters, incluirTrazas: e.target.checked})}
                        className="mr-2 rounded border-orange-300 text-orange-500 focus:ring-orange-400"
                      />
                      <span className="font-medium text-orange-800">Incluir trazas en el filtro</span>
                      <span className="ml-2 text-xs text-orange-600">(también excluirá platos que pueden contener trazas)</span>
                    </label>
                  </div>
                  
                  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2">
                    {alergenos.map(alergeno => (
                      <label key={alergeno.id} className="flex items-center text-xs">
                        <input
                          type="checkbox"
                          checked={platoFilters.alergenosEvitar.includes(alergeno.id)}
                          onChange={(e) => {
                            const updated = e.target.checked
                              ? [...platoFilters.alergenosEvitar, alergeno.id]
                              : platoFilters.alergenosEvitar.filter(id => id !== alergeno.id);
                            setPlatoFilters({...platoFilters, alergenosEvitar: updated});
                          }}
                          className="mr-1"
                        />
                        <AlergenoIcon nombre={alergeno.nombre} size="sm" />
                        <span className="ml-1">{alergeno.nombre}</span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              {/* Buscador de platos - Cerca de la lista */}
              <div className="bg-white border border-gray-200 rounded-lg p-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Search className="inline w-4 h-4 mr-1" />
                  Buscar plato por nombre
                </label>
                <div className="relative">
                  <input
                    type="text"
                    value={platoFilters.searchText}
                    onChange={(e) => setPlatoFilters({...platoFilters, searchText: e.target.value})}
                    placeholder="Ej: Bollería, Salmorejo, Hummus..."
                    className="w-full px-4 py-3 pr-10 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                  />
                  {platoFilters.searchText && (
                    <button
                      onClick={() => setPlatoFilters({...platoFilters, searchText: ''})}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                      <X className="w-5 h-5" />
                    </button>
                  )}
                </div>
                {platoFilters.searchText && getFilteredPlatos().length === 0 && (
                  <p className="mt-2 text-sm text-red-600">
                    No se encontraron platos con "{platoFilters.searchText}"
                  </p>
                )}
              </div>

              {/* Lista de platos */}
              <div>
                <div className="flex justify-between items-center mb-3">
                  <h4 className="font-semibold text-gray-900">
                    Platos Disponibles ({getFilteredPlatos().length})
                  </h4>
                  <div className="text-sm text-gray-600">
                    {selectedPlatos.length} seleccionados - Total: €{calculateCustomMenuPrice().toFixed(2)}
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:max-h-96 md:overflow-y-auto">
                  {getFilteredPlatos().map(plato => {
                    const platoSelected = selectedPlatos.find(p => p.platoId === plato.id);
                    const isSelected = !!platoSelected;
                    
                    return (
                      <div 
                        key={plato.id}
                        className={`border rounded-lg p-3 transition-all ${
                          isSelected
                            ? 'border-duetto-primary bg-duetto-primary bg-opacity-5'
                            : 'border-gray-200 hover:border-gray-300'
                        }`}
                      >
                        <div className="flex justify-between items-start">
                          <div className="flex-1">
                            <div className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => togglePlatoSelection(plato.id)}
                                className="text-duetto-primary"
                              />
                              <h5 className="font-medium text-gray-900">{plato.nombre}</h5>
                            </div>
                            <div className="mt-1 flex items-center space-x-4 text-xs text-gray-600">
                              <span>Coste: €{safeToFixed(plato.coste_por_porcion || plato.coste_total, 2)}/ración</span>
                              <span>{plato.tiempo_preparacion_min} min</span>
                              {plato.categoria && (
                                <span className="capitalize bg-gray-100 px-2 py-0.5 rounded">{plato.categoria}</span>
                              )}
                              {plato.alergenos_ids && plato.alergenos_ids.length > 0 && (
                                <div className="flex space-x-1">
                                  {plato.alergenos_ids.slice(0, 3).map(alergId => {
                                    const alergeno = alergenos.find(a => a.id === alergId);
                                    return alergeno ? (
                                      <AlergenoIcon key={alergId} nombre={alergeno.nombre} size="sm" />
                                    ) : null;
                                  })}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        
                        {/* Input de cantidad si está seleccionado */}
                        {isSelected && (
                          <div className="mt-3 pt-3 border-t border-gray-200">
                            <div className="flex items-center justify-between">
                              <label className="text-xs font-medium text-gray-700">Cantidad por menú:</label>
                              <div className="flex items-center space-x-2">
                                <input
                                  type="number"
                                  min="0.5"
                                  step="0.5"
                                  value={platoSelected.cantidad}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    updatePlatoCantidad(plato.id, e.target.value);
                                  }}
                                  onBlur={(e) => {
                                    // Si está vacío o menor a 0.5 al perder foco, poner 0.5
                                    if (e.target.value === '' || parseFloat(e.target.value) < 0.5) {
                                      updatePlatoCantidad(plato.id, 0.5);
                                    }
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                  className="w-16 px-2 py-1 text-sm border border-gray-300 rounded"
                                />
                                <span className="text-xs text-gray-600">
                                  = €{((plato.coste_por_porcion || plato.coste_total || plato.coste_racion || 0) * (platoSelected.cantidad || 0)).toFixed(2)}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {esMultieventoFicha() && (
              <div className="px-6 pt-4">{renderSelectorJornadasAnadir()}</div>
            )}

            {/* Footer */}
            <div className="px-6 py-4 border-t border-gray-200 flex justify-between items-center max-md:gap-2 max-md:flex-wrap max-md:px-4 max-md:pb-[calc(env(safe-area-inset-bottom)+1rem)] max-md:[&_button]:min-h-[44px]">
              <div className="text-sm text-gray-600">
                {selectedPlatos.length > 0 
                  ? `${selectedPlatos.length} platos seleccionados` 
                  : 'Sin platos (menú vacío)'
                }
              </div>
              <div className="flex space-x-3 max-md:w-full max-md:[&>button]:flex-1 max-md:[&>button]:justify-center">
                <button
                  onClick={() => setShowCustomMenuModal(false)}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button
                  onClick={handleSaveCustomMenu}
                  disabled={!customMenuName.trim() || addingCustomMenu || sinJornadasElegidas()}
                  className="px-4 py-2 bg-duetto-primary text-white rounded-lg hover:bg-opacity-90 disabled:opacity-50 flex items-center gap-2"
                >
                  {addingCustomMenu ? (
                    <>
                      <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Creando...
                    </>
                  ) : (
                    <>Crear Menú {selectedPlatos.length > 0 ? `(€${calculateCustomMenuPrice().toFixed(2)})` : '(sin platos)'}</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Cancelar evento (motivo obligatorio; los dos formatos) */}
      {showCancelarModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-testid="modal-cancelar-evento">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6 max-h-[90vh] overflow-y-auto">
            <h3 className="text-xl font-bold mb-1 text-gray-900">
              {presupuesto.estado === 'cancelado' ? 'Registrar motivo de la cancelación' : 'Cancelar evento'}
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Queda registrado el motivo, la fecha y los días de antelación respecto al evento.
            </p>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Motivo <span className="text-red-500">*</span>
                </label>
                <select
                  value={cancelacionForm.motivo}
                  onChange={(e) => setCancelacionForm(prev => ({ ...prev, motivo: e.target.value }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-400"
                >
                  <option value="">Elige un motivo</option>
                  {(reglasComerciales?.motivos_cancelacion || infoCancelacion?.motivos || []).map(m => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </select>
                {!reglasComerciales && !infoCancelacion && (
                  <p className="text-xs text-gray-500 mt-1">Cargando motivos...</p>
                )}
              </div>
              {infoCancelacion?.aviso && (
                <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2" data-testid="cancelar-aviso">
                  {infoCancelacion.aviso}
                </p>
              )}
              {cargandoInfoCancelacion && (
                <p className="text-xs text-gray-500">Buscando pedidos pendientes...</p>
              )}
              {pedidosCancelacion.length > 0 && (
                <div data-testid="cancelar-pedidos">
                  <p className="block text-sm font-medium text-gray-700 mb-1">Pedidos pendientes con proveedores</p>
                  <p className="text-xs text-gray-500 mb-2">
                    Se marcan como anulados. El email de anulación solo se envía a los que tengan la casilla marcada.
                  </p>
                  <div className="space-y-2">
                    {pedidosCancelacion.map((pedido, i) => (
                      <div key={`${pedido.tipo}-${pedido.jornada_id || 'evento'}-${pedido.id || i}`} className="border border-gray-200 rounded-lg p-2 text-sm">
                        <label className="flex items-start gap-2">
                          <input
                            type="checkbox"
                            checked={!!pedido.anular}
                            onChange={(e) => cambiarPedidoCancelacion(i, 'anular', e.target.checked)}
                            className="mt-1"
                          />
                          <span>
                            <span className="font-medium">{pedido.proveedor || (pedido.tipo === 'alquiler' ? 'Proveedor de alquiler' : 'Proveedor de personal')}</span>
                            {' · '}{pedido.descripcion}
                            {pedido.jornada_fecha ? ` · jornada del ${pedido.jornada_fecha}` : ''}
                            {' · '}{pedido.estado === 'confirmada' ? 'confirmado' : 'enviado'}
                          </span>
                        </label>
                        <label className={`flex items-center gap-2 mt-1 ml-6 text-xs ${pedido.anular && pedido.email ? 'text-gray-700' : 'text-gray-400'}`}>
                          <input
                            type="checkbox"
                            checked={!!pedido.enviar_email && !!pedido.anular && !!pedido.email}
                            disabled={!pedido.anular || !pedido.email}
                            onChange={(e) => cambiarPedidoCancelacion(i, 'enviar_email', e.target.checked)}
                          />
                          {pedido.email
                            ? `Enviar anulación al proveedor (${pedido.email})`
                            : 'Sin email del proveedor: avísale por otro medio'}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nota</label>
                <textarea
                  value={cancelacionForm.comentario}
                  onChange={(e) => setCancelacionForm(prev => ({ ...prev, comentario: e.target.value }))}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm resize-none focus:outline-none focus:ring-2 focus:ring-red-400"
                  placeholder="Detalles que ayuden a entender la cancelación (opcional)"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Importe facturado por la cancelación (€)</label>
                <input
                  type="text"
                  inputMode="decimal"
                  value={cancelacionForm.importe_facturado_cancelacion}
                  onChange={(e) => setCancelacionForm(prev => ({ ...prev, importe_facturado_cancelacion: e.target.value }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-400"
                  placeholder="Opcional"
                />
              </div>
              {errorCancelacion && (
                <p className="text-sm text-red-700">{errorCancelacion}</p>
              )}
            </div>

            <div className="flex justify-end gap-2 mt-6">
              <button
                type="button"
                onClick={() => setShowCancelarModal(false)}
                disabled={cancelando}
                className="px-4 py-2 text-sm border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-50"
              >
                Volver
              </button>
              <button
                type="button"
                onClick={handleConfirmarCancelacion}
                disabled={cancelando || cargandoInfoCancelacion || !cancelacionForm.motivo}
                className="px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50"
              >
                {cancelando ? 'Guardando...' : (presupuesto.estado === 'cancelado' ? 'Guardar motivo' : 'Cancelar evento')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Añadir Suplemento */}
      {showAddSuplementoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto">
            <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
              <span className="text-amber-500">📌</span>
              Añadir Suplemento
            </h3>
            
            {/* Plantillas rápidas */}
            <div className="mb-4 p-3 bg-amber-50 rounded-lg">
              <p className="text-xs font-semibold text-amber-700 mb-2">Plantillas rápidas:</p>
              <div className="flex gap-2 flex-wrap">
                {!formatoNuevo ? (
                <>
                <button
                  type="button"
                  onClick={() => aplicarPlantillaSuplemento('coffee')}
                  className="px-3 py-1.5 text-xs bg-amber-100 text-amber-800 rounded-full hover:bg-amber-200 transition-colors"
                >
                  ☕ Mínimo Coffee €3.50
                </button>
                <button
                  type="button"
                  onClick={() => aplicarPlantillaSuplemento('lunch')}
                  className="px-3 py-1.5 text-xs bg-orange-100 text-orange-800 rounded-full hover:bg-orange-200 transition-colors"
                >
                  🍽️ Mínimo Lunch €6.50
                </button>
                <button
                  type="button"
                  onClick={() => aplicarPlantillaSuplemento('coctel')}
                  className="px-3 py-1.5 text-xs bg-purple-100 text-purple-800 rounded-full hover:bg-purple-200 transition-colors"
                >
                  🍷 Mínimo Cóctel €10.00
                </button>
                </>
                ) : [
                  { tipo: 'coffee', etiqueta: 'Mínimo Coffee', clase: 'bg-amber-100 text-amber-800 hover:bg-amber-200' },
                  { tipo: 'lunch', etiqueta: 'Mínimo Lunch', clase: 'bg-orange-100 text-orange-800 hover:bg-orange-200' },
                  { tipo: 'coctel', etiqueta: 'Mínimo Cóctel', clase: 'bg-purple-100 text-purple-800 hover:bg-purple-200' },
                  { tipo: 'camarero_extra', etiqueta: 'Camarero extra', sufijo: '/h', clase: 'bg-blue-100 text-blue-800 hover:bg-blue-200' },
                  { tipo: 'solo_camareros', etiqueta: 'Solo camareros', sufijo: '/h', clase: 'bg-sky-100 text-sky-800 hover:bg-sky-200' },
                ].map(({ tipo, etiqueta, sufijo, clase }) => {
                  const plantilla = plantillasSuplemento[tipo];
                  return (
                    <button
                      key={tipo}
                      type="button"
                      disabled={!plantilla}
                      onClick={() => aplicarPlantillaSuplemento(tipo)}
                      title={plantilla ? `${plantilla.nombre} · IVA ${plantilla.iva} %` : 'Cargando tarifas...'}
                      className={`px-3 py-1.5 text-xs rounded-full transition-colors disabled:opacity-50 ${clase}`}
                    >
                      {etiqueta}{plantilla ? ` ${formatEuros(plantilla.precio_unitario)}${sufijo || ''}` : ''}
                    </button>
                  );
                })}
              </div>
              {formatoNuevo && (
                <p className="text-xs text-gray-500 mt-2" data-testid="plantillas-dieta-aviso">
                  Vegetariano, sin cerdo y otras dietas se apuntan en la pestaña Alérgenos y se cobran solas con el suplemento por menú adaptado.
                </p>
              )}
            </div>

            {/* Formulario en grid de 2 columnas */}
            <div className="grid grid-cols-2 gap-4">
              {/* Vincular a menú (formato nuevo: los suplementos no se vinculan) */}
              {!formatoNuevo && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Vincular a menú <span className="text-red-500">*</span>
                </label>
                <select
                  value={suplementoForm.menu_vinculado_id}
                  onChange={(e) => {
                    const menuId = e.target.value;
                    const menu = presupuesto.menus_personalizados?.find(m => m.menu_id === menuId);
                    setSuplementoForm(prev => ({
                      ...prev,
                      menu_vinculado_id: menuId,
                      unidades: menu && prev.nombre.includes('mínimo 40') 
                        ? Math.max(0, 40 - (menu.num_personas || 0)).toString()
                        : prev.unidades
                    }));
                  }}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                >
                  <option value="">-- Seleccionar menú --</option>
                  {presupuesto.menus_personalizados?.map((menu, idx) => (
                    <option key={menu.menu_id || idx} value={menu.menu_id}>
                      {menu.nombre_menu} ({menu.num_personas} pax)
                    </option>
                  ))}
                </select>
              </div>
              )}

              {/* Nombre del suplemento */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nombre del suplemento <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={suplementoForm.nombre}
                  onChange={(e) => setSuplementoForm(prev => ({ ...prev, nombre: e.target.value }))}
                  placeholder="Ej: Suplemento mínimo 40 personas"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                />
              </div>

              {/* Precio */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Precio unitario (€) <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={suplementoForm.precio_unitario}
                  onChange={(e) => setSuplementoForm(prev => ({ ...prev, precio_unitario: e.target.value }))}
                  placeholder="3.50"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                />
              </div>

              {/* Unidades */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Unidades <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  inputMode="decimal"
                  value={suplementoForm.unidades}
                  onChange={(e) => setSuplementoForm(prev => ({ ...prev, unidades: e.target.value }))}
                  placeholder="15"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                />
                {!formatoNuevo && suplementoForm.menu_vinculado_id && (
                  <p className="text-xs text-gray-500 mt-1">
                    {(() => {
                      const menu = presupuesto.menus_personalizados?.find(m => m.menu_id === suplementoForm.menu_vinculado_id);
                      if (menu) {
                        const diff = 40 - (menu.num_personas || 0);
                        return diff > 0 ? `Sugerido: ${diff} (40 - ${menu.num_personas} pax)` : 'Ya alcanza el mínimo';
                      }
                      return '';
                    })()}
                  </p>
                )}
              </div>

              {/* Descuento */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Descuento (€) <span className="text-xs text-gray-400">(opcional)</span>
                </label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  max={(parseFloat(suplementoForm.precio_unitario) || 0) * (numeroDecimal(suplementoForm.unidades) || 0)}
                  value={suplementoForm.descuento}
                  onChange={(e) => setSuplementoForm(prev => ({ ...prev, descuento: e.target.value }))}
                  placeholder="0.00"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                />
              </div>

              {/* IVA */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Tipo de IVA</label>
                <div className="flex gap-2">
                  <label className={`flex-1 flex items-center justify-center gap-1 p-2 rounded-lg border-2 cursor-pointer transition-colors text-sm ${
                    suplementoForm.iva === '10' 
                      ? 'border-blue-500 bg-blue-50 text-blue-700' 
                      : 'border-gray-200 hover:border-gray-300'
                  }`}>
                    <input
                      type="radio"
                      name="iva"
                      value="10"
                      checked={suplementoForm.iva === '10'}
                      onChange={(e) => setSuplementoForm(prev => ({ ...prev, iva: e.target.value }))}
                      className="sr-only"
                    />
                    <span className="font-medium">10%</span>
                    <span className="text-xs text-gray-500">Catering</span>
                  </label>
                  <label className={`flex-1 flex items-center justify-center gap-1 p-2 rounded-lg border-2 cursor-pointer transition-colors text-sm ${
                    suplementoForm.iva === '21' 
                      ? 'border-orange-500 bg-orange-50 text-orange-700' 
                      : 'border-gray-200 hover:border-gray-300'
                  }`}>
                    <input
                      type="radio"
                      name="iva"
                      value="21"
                      checked={suplementoForm.iva === '21'}
                      onChange={(e) => setSuplementoForm(prev => ({ ...prev, iva: e.target.value }))}
                      className="sr-only"
                    />
                    <span className="font-medium">21%</span>
                    <span className="text-xs text-gray-500">Otros</span>
                  </label>
                </div>
              </div>
            </div>

            {/* Total calculado y cortesía en una fila */}
            <div className="grid grid-cols-2 gap-4 mt-4">
              {/* Total calculado */}
              <div className="bg-gray-50 rounded-lg p-3">
                {(() => {
                  const totalBruto = redondear2((parseFloat(suplementoForm.precio_unitario) || 0) * (numeroDecimal(suplementoForm.unidades) || 0));
                  const descuento = parseFloat(suplementoForm.descuento) || 0;
                  const totalNeto = Math.max(0, totalBruto - descuento);
                  return (
                    <div className="flex items-center justify-between">
                      <span className="font-medium text-gray-700">Total:</span>
                      <span className="text-xl font-bold text-duetto-primary">
                        €{totalNeto.toFixed(2)}
                        {descuento > 0 && <span className="text-xs text-red-500 ml-2">(-€{descuento.toFixed(2)})</span>}
                      </span>
                    </div>
                  );
                })()}
              </div>

              {/* Cortesía */}
              <div className="flex items-center gap-3 p-3 bg-green-50 rounded-lg">
                <input
                  type="checkbox"
                  id="es_cortesia"
                  checked={suplementoForm.es_cortesia}
                  onChange={(e) => setSuplementoForm(prev => ({ ...prev, es_cortesia: e.target.checked }))}
                  className="w-4 h-4 text-green-600"
                />
                <label htmlFor="es_cortesia" className="text-sm text-gray-700">
                  <span className="font-medium">🎁 Cortesía</span>
                  <span className="text-xs text-gray-500 ml-1">(descuento visible)</span>
                </label>
              </div>
            </div>

            {/* Botones */}
            <div className="flex justify-end gap-2 mt-4 pt-4 border-t">
              <button
                onClick={() => {
                  setShowAddSuplementoModal(false);
                  setSuplementoForm({
                    menu_vinculado_id: '',
                    nombre: '',
                    precio_unitario: '',
                    unidades: '',
                    iva: '10',
                    descuento: '',
                    es_cortesia: false,
                    motivo_cortesia: ''
                  });
                }}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={handleAddSuplemento}
                className="px-4 py-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition-colors font-medium"
              >
                Añadir Suplemento
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Aviso de horas de servicio (M1): antes de confirmar y de la orden nueva */}
      {dialogoHorarios}

      {/* Modal: Orden de cocina (nueva), esta orden o varias en un solo PDF */}
      <OrdenCocinaDescargaModal
        open={showOrdenNuevaModal}
        onClose={() => setShowOrdenNuevaModal(false)}
        presupuesto={presupuesto}
        onDescargarEsta={() => { setShowOrdenNuevaModal(false); handleGenerateOrdenCocinaNueva(); }}
        esperarAutoguardado={esperarAutoguardado}
      />

      {/* Modal: Seleccionar Jornada (Multi-evento) */}
      {showJornadaSelector && presupuesto?.jornadas && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-testid="jornada-selector-modal">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold text-gray-900">
                Seleccionar jornada
              </h3>
              <button
                onClick={() => { setShowJornadaSelector(false); setJornadaPendingAction(null); }}
                className="text-gray-400 hover:text-gray-600"
                data-testid="jornada-selector-close"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>
            <p className="text-sm text-gray-500 mb-4">
              Este presupuesto tiene {presupuesto.jornadas.length} jornadas. Selecciona para qué día quieres generar el documento:
            </p>
            <div className="space-y-2">
              {presupuesto.jornadas.map((jornada, idx) => {
                const fechaJ = jornada.fecha ? new Date(jornada.fecha).toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' }) : `Jornada ${idx + 1}`;
                return (
                  <button
                    key={jornada.id}
                    onClick={() => handleJornadaSelected(jornada.id)}
                    className="w-full text-left px-4 py-3 rounded-lg border border-gray-200 hover:border-blue-400 hover:bg-blue-50 transition-colors group"
                    data-testid={`jornada-option-${idx}`}
                  >
                    <div className="flex justify-between items-center">
                      <div>
                        <span className="font-medium text-gray-900 capitalize">{fechaJ}</span>
                        {jornada.observaciones && (
                          <p className="text-sm text-gray-500 mt-0.5">{jornada.observaciones}</p>
                        )}
                      </div>
                      <div className="text-right">
                        <span className="text-sm font-medium text-gray-600">{jornada.num_personas || '?'} pax</span>
                        {jornada.lugar_evento && (
                          <p className="text-xs text-gray-400 mt-0.5">{jornada.lugar_evento.substring(0, 30)}</p>
                        )}
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Modal: Añadir Menú */}
      {showAddMenuModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 max-md:p-0">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 max-md:p-4 max-md:pb-0 max-md:overflow-y-auto max-md:max-w-none max-md:h-full max-md:max-h-none max-md:rounded-none max-md:[&_input]:text-base max-md:[&_select]:text-base max-md:[&_textarea]:text-base">
            <h3 className="text-xl font-bold mb-4">Añadir Menú al Presupuesto</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Seleccionar Menú</label>
                
                {/* Input de búsqueda/autocompletado */}
                <input
                  type="text"
                  placeholder="Buscar menú por nombre..."
                  value={menuSearchQuery}
                  onChange={(e) => setMenuSearchQuery(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-2"
                />
                {menusAnadidosRapido.length > 0 && (
                  <p className="text-xs text-duetto-primary mb-2" data-testid="menus-anadidos-rapido">
                    Añadido: {menusAnadidosRapido.join(', ')}
                  </p>
                )}

                {/* Lista de menús filtrados */}
                <div className="border border-gray-300 rounded-lg md:max-h-60 md:overflow-y-auto">
                  {menus
                    .filter(m => m.activo) // Solo menús activos
                    .filter(m => {
                      // Filtrar por búsqueda (sin acentos)
                      if (!menuSearchQuery) return true;
                      return normalizeText(m.nombre).includes(normalizeText(menuSearchQuery));
                    })
                    .sort((a, b) => a.nombre.localeCompare(b.nombre)) // Orden alfabético
                    .map((menu, posicion) => (
                      <div
                        key={menu.id}
                        onClick={() => {
                          setSelectedMenuToAdd(menu.id);
                          // Auto-configurar bebida incluida según el catálogo
                          setBebidaIncluidaMenuToAdd(!!menu.bebida_incluida);
                          setBebidasPorPersonaMenuToAdd(menu.bebidas_por_persona || 1);
                        }}
                        className={`px-3 py-2 cursor-pointer hover:bg-blue-50 border-b border-gray-100 last:border-b-0 ${
                          selectedMenuToAdd === menu.id ? 'bg-blue-100 font-semibold' : ''
                        }`}
                      >
                        <div className="flex justify-between items-center gap-2">
                          <span className="text-sm">{menu.nombre}</span>
                          <div className="flex items-center gap-2 shrink-0">
                            <span className="text-sm text-gray-600">€{safeToFixed(precioMenuCatalogo(menu) || 0, 2)}</span>
                            {/* Añadir en un clic: personas del presupuesto (o de
                                cada jornada), bebida del catálogo y todas las
                                jornadas; el modal se queda abierto */}
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                anadirMenuDelCatalogo({
                                  menu,
                                  numPersonas: null,
                                  bebidaIncluida: !!menu.bebida_incluida,
                                  bebidasPorPersona: menu.bebidas_por_persona || 1,
                                  jornadasIds: null,
                                  cerrar: false,
                                });
                              }}
                              disabled={addingMenu}
                              data-uso="presupuesto.menu_anadir_rapido"
                              data-guia={posicion === 0 ? 'menu-anadir-rapido' : undefined}
                              title="Añadir con las personas del presupuesto y la bebida del catálogo"
                              className="px-2 py-0.5 text-xs font-medium text-white bg-duetto-primary rounded hover:bg-opacity-90 disabled:opacity-50"
                            >
                              Añadir
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  {menus.filter(m => m.activo && normalizeText(m.nombre).includes(normalizeText(menuSearchQuery))).length === 0 && (
                    <div className="px-3 py-4 text-center text-gray-500 text-sm">
                      No se encontraron menús activos
                    </div>
                  )}
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Número de Personas
                </label>
                <input
                  type="number"
                  value={personasMenuToAdd}
                  onChange={(e) => setPersonasMenuToAdd(e.target.value)}
                  placeholder={esMultieventoFicha() ? 'Por defecto: las de cada jornada' : `Por defecto: ${presupuesto.num_personas || 0} personas`}
                  min="1"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2"
                />
                <p className="text-xs text-gray-500 mt-1">
                  {esMultieventoFicha()
                    ? 'Déjalo vacío para usar las personas de cada jornada'
                    : `Déjalo vacío para usar las personas del presupuesto (${presupuesto.num_personas || 0})`}
                </p>
              </div>

              {renderSelectorJornadasAnadir()}
              
              {/* Bebida incluida - toggle con auto-configuración del catálogo */}
              {selectedMenuToAdd && (
                <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
                  <div className="flex items-center justify-between">
                    <div>
                      <h5 className="font-medium text-amber-900 text-sm">Bebida incluida</h5>
                      <p className="text-xs text-amber-700">
                        {(() => {
                          const m = menus.find(x => x.id === selectedMenuToAdd);
                          return m?.bebida_incluida ? 'Este menú incluye bebida por defecto' : 'Este menú no incluye bebida';
                        })()}
                      </p>
                    </div>
                    <div className="flex items-center gap-3">
                      {bebidaIncluidaMenuToAdd && (
                        <div className="flex items-center gap-1">
                          <label className="text-xs text-amber-800">Cant:</label>
                          <input
                            type="number"
                            min="1"
                            max="5"
                            value={bebidasPorPersonaMenuToAdd}
                            onChange={(e) => setBebidasPorPersonaMenuToAdd(parseInt(e.target.value) || 1)}
                            className="w-14 px-2 py-1 border border-amber-300 rounded text-center text-sm"
                            data-testid="bebidas-por-persona-input"
                          />
                        </div>
                      )}
                      <button
                        type="button"
                        onClick={() => setBebidaIncluidaMenuToAdd(!bebidaIncluidaMenuToAdd)}
                        data-testid="bebida-incluida-toggle"
                        className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors ${
                          bebidaIncluidaMenuToAdd ? 'bg-amber-500' : 'bg-gray-300'
                        }`}
                      >
                        <span className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-md transition-transform ${
                          bebidaIncluidaMenuToAdd ? 'translate-x-7' : 'translate-x-1'
                        }`} />
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex space-x-3 mt-6 max-md:sticky max-md:bottom-0 max-md:bg-white max-md:-mx-4 max-md:px-4 max-md:pt-3 max-md:border-t max-md:border-gray-200 max-md:pb-[calc(env(safe-area-inset-bottom)+1rem)] max-md:[&_button]:min-h-[44px]">
              <button
                type="button"
                onClick={() => limpiarModalAnadirMenu(true)}
                className="flex-1 border border-gray-300 text-gray-700 py-2 rounded-lg hover:bg-gray-50"
              >
                {menusAnadidosRapido.length > 0 ? 'Cerrar' : 'Cancelar'}
              </button>
              <button
                type="button"
                onClick={() => {
                  const menu = menus.find(m => m.id === selectedMenuToAdd);
                  if (!menu) {
                    toast({ variant: 'destructive', title: 'Elige un menú', description: 'Selecciona un menú de la lista.' });
                    return;
                  }
                  anadirMenuDelCatalogo({
                    menu,
                    numPersonas: personasMenuToAdd || null,
                    bebidaIncluida: bebidaIncluidaMenuToAdd,
                    bebidasPorPersona: bebidasPorPersonaMenuToAdd,
                    jornadasIds: jornadasMenuToAdd,
                    cerrar: true,
                  });
                }}
                disabled={!selectedMenuToAdd || addingMenu || sinJornadasElegidas()}
                className="flex-1 bg-duetto-primary text-white py-2 rounded-lg hover:bg-opacity-90 disabled:opacity-50 flex items-center justify-center gap-2"
              >
                {addingMenu ? (
                  <>
                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Añadiendo...
                  </>
                ) : (
                  'Añadir Menú'
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Presupuesto - Descargar o Enviar */}
      {showPresupuestoModal && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4" 
          style={{zIndex: 9999}}
        >
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-bold text-gray-900">Presupuesto PDF</h3>
              <button
                onClick={() => setShowPresupuestoModal(false)}
                className="text-gray-400 hover:text-gray-600 text-2xl"
              >
                ✕
              </button>
            </div>

            {/* Selector de acción */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">Acción</label>
              <div className="grid grid-cols-2 gap-3">
                <button
                  onClick={() => setAccionPresupuesto('descargar')}
                  className={`p-4 border-2 rounded-lg transition-all ${
                    accionPresupuesto === 'descargar'
                      ? 'border-duetto-primary bg-green-50'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  <FileText className="w-6 h-6 mx-auto mb-2" />
                  <div className="text-sm font-semibold">Descargar</div>
                  <div className="text-xs text-gray-500">Guardar en tu dispositivo</div>
                </button>
                <button
                  onClick={() => setAccionPresupuesto('enviar')}
                  className={`p-4 border-2 rounded-lg transition-all ${
                    accionPresupuesto === 'enviar'
                      ? 'border-duetto-primary bg-green-50'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  <Send className="w-6 h-6 mx-auto mb-2" />
                  <div className="text-sm font-semibold">Enviar por Email</div>
                  <div className="text-xs text-gray-500">Enviar directamente al cliente</div>
                </button>
              </div>
            </div>

            {/* Historial de envíos - Tarjeta informativa ARRIBA */}
            {(() => {
              return presupuesto.registros_envios && presupuesto.registros_envios.length > 0;
            })() && (
              <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-center gap-2 mb-3">
                  <Mail className="w-5 h-5 text-blue-600" />
                  <h4 className="text-sm font-bold text-blue-900">
                    Historial de Envíos ({presupuesto.registros_envios.length})
                  </h4>
                </div>
                <div className="space-y-2 max-h-48 overflow-y-auto">
                  {presupuesto.registros_envios.slice().reverse().map((registro, index) => (
                    <div key={index} className="p-3 bg-white rounded border border-blue-100 text-xs">
                      <div className="flex justify-between items-start mb-2">
                        <div className="flex items-center gap-2">
                          <span className="font-semibold text-gray-900">
                            {/* U-95: guardada en UTC sin zona */}
                            {(parsearFechaServidor(registro.fecha_envio) || new Date(NaN)).toLocaleDateString('es-ES', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </span>
                          <span className="px-2 py-0.5 bg-green-100 text-green-700 rounded text-xs">
                            ✓ Enviado
                          </span>
                        </div>
                      </div>
                      <div className="space-y-1 text-gray-600">
                        <div>
                          <strong>A:</strong> {registro.contacto_destino_nombre} ({registro.email_destino})
                        </div>
                        {registro.cc_emails && registro.cc_emails.length > 0 && (
                          <div>
                            <strong>CC:</strong> {registro.cc_emails.join(', ')}
                          </div>
                        )}
                        <div>
                          <strong>Desde:</strong> {registro.email_origen}
                        </div>
                        <div>
                          <strong>Asunto:</strong> {registro.asunto}
                        </div>
                        <div className="text-gray-500 text-xs mt-1">
                          Por: {registro.enviado_por}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Opciones de envío (solo si se selecciona enviar) */}
            {accionPresupuesto === 'enviar' && (
              <div className="space-y-4 border-t border-gray-200 pt-4">
                {/* Cuenta de origen */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Enviar desde *
                  </label>
                  <select
                    value={emailOrigen}
                    onChange={(e) => {
                      const email = e.target.value;
                      setEmailOrigen(email);
                      // Seleccionar firma automáticamente según el remitente
                      if (email === 'administracion@duettocatering.com') {
                        setFirmaSeleccionada('administracion');
                      } else {
                        setFirmaSeleccionada('alfonso');
                      }
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                  >
                    <option value="administracion@duettocatering.com">
                      administracion@duettocatering.com
                    </option>
                    <option value="eventos@duettocatering.com">
                      eventos@duettocatering.com
                    </option>
                    <option value="a.palomares@duettocatering.com">
                      a.palomares@duettocatering.com
                    </option>
                  </select>
                </div>

                {/* Contacto destino con botón añadir */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Enviar a *
                  </label>
                  <div className="flex gap-2">
                    <select
                      value={contactoDestinoId}
                      onChange={(e) => setContactoDestinoId(e.target.value)}
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                    >
                      <option value="">Selecciona un contacto...</option>
                      {cliente && (
                        <option value="principal">
                          {cliente.nombre_contacto || cliente.persona_contacto || cliente.nombre_empresa || cliente.nombre || 'Contacto principal'} (principal) - {cliente.email || 'sin email — añádelo en la ficha del cliente'}
                        </option>
                      )}
                      {[...personasContacto].sort((a, b) => a.nombre.localeCompare(b.nombre)).map((contacto) => (
                        <option key={contacto.id} value={contacto.id}>
                          {contacto.nombre} - {contacto.email}
                        </option>
                      ))}
                    </select>
                    <button
                      onClick={() => setShowNewContactoModal(true)}
                      className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors flex items-center gap-1"
                      title="Añadir nuevo contacto"
                    >
                      <Plus className="w-4 h-4" />
                      Nuevo
                    </button>
                  </div>
                  {personasContacto.length === 0 && (
                    <p className="text-xs text-orange-600 mt-1">
                      ⚠️ No hay contactos asociados. Añade un contacto primero.
                    </p>
                  )}
                </div>

                {/* CC - Emails en copia (opcional) */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    CC - Copia a (opcional)
                  </label>
                  <input
                    type="text"
                    value={ccEmails}
                    onChange={(e) => setCcEmails(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                    placeholder="email1@ejemplo.com, email2@ejemplo.com"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    Separa múltiples emails con comas
                  </p>
                  {/* Añadir rápido contactos de la misma empresa al CC */}
                  {personasContacto.filter((c) => c.email).length > 0 && (
                    <div className="mt-2">
                      <p className="text-xs text-gray-500 mb-1">Añadir contactos de la empresa al CC con un clic:</p>
                      <div className="flex flex-wrap gap-1.5">
                        {personasContacto.filter((c) => c.email).map((c) => {
                          const arr = ccEmails.split(',').map((s) => s.trim()).filter(Boolean);
                          const inCc = arr.includes(c.email);
                          return (
                            <button
                              key={c.id}
                              type="button"
                              onClick={() => {
                                if (inCc) {
                                  setCcEmails(arr.filter((e) => e !== c.email).join(', '));
                                } else {
                                  setCcEmails([...arr, c.email].join(', '));
                                }
                              }}
                              className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full border transition-colors ${
                                inCc
                                  ? 'bg-duetto-primary text-white border-duetto-primary'
                                  : 'bg-gray-50 text-gray-700 border-gray-300 hover:bg-gray-100'
                              }`}
                              title={c.email}
                            >
                              {inCc ? <X className="w-3 h-3" /> : <Plus className="w-3 h-3" />}
                              {c.nombre}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>

                {/* Asunto */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Asunto *
                  </label>
                  <input
                    type="text"
                    value={asuntoEmail}
                    onChange={(e) => setAsuntoEmail(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                    placeholder="Asunto del email"
                  />
                </div>

                {/* Mensaje */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Mensaje *
                  </label>
                  <textarea
                    value={mensajeEmail}
                    onChange={(e) => setMensajeEmail(e.target.value)}
                    rows={8}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                    placeholder="Escribe el mensaje del email..."
                  />
                </div>

                {/* Selector de Firma */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    ✍️ Firma del Email
                  </label>
                  <div className="grid grid-cols-3 gap-2">
                    {Object.entries(firmasEmail).map(([key, firma]) => (
                      <button
                        key={key}
                        onClick={() => setFirmaSeleccionada(key)}
                        className={`p-3 border-2 rounded-lg transition-all text-center ${
                          firmaSeleccionada === key
                            ? 'border-duetto-primary bg-green-50'
                            : 'border-gray-200 hover:border-gray-300'
                        }`}
                      >
                        <div className="text-sm font-medium">{firma.nombre}</div>
                      </button>
                    ))}
                  </div>
                  {firmaSeleccionada !== 'ninguna' && firmasEmail[firmaSeleccionada]?.imagen && (
                    <div className="mt-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                      <p className="text-xs text-gray-500 mb-2">Vista previa de la firma:</p>
                      <img 
                        src={firmasEmail[firmaSeleccionada].imagen} 
                        alt={`Firma ${firmasEmail[firmaSeleccionada].nombre}`}
                        className="max-h-24 object-contain"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'block';
                        }}
                      />
                      <p className="text-xs text-red-500 hidden">Imagen no disponible</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Botones de acción */}
            <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-200">
              <button
                onClick={() => setShowPresupuestoModal(false)}
                className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                disabled={enviandoEmail}
              >
                Cancelar
              </button>
              
              {accionPresupuesto === 'descargar' ? (
                <button
                  onClick={handleDescargarPresupuesto}
                  className="px-6 py-2 bg-duetto-primary text-white rounded-lg hover:bg-opacity-90 transition-colors flex items-center gap-2"
                >
                  <FileText className="w-4 h-4" />
                  Descargar PDF
                </button>
              ) : (
                <button
                  onClick={handleEnviarPresupuesto}
                  disabled={enviandoEmail || !contactoDestinoId}
                  className="px-6 py-2 bg-duetto-primary text-white rounded-lg hover:bg-opacity-90 transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {enviandoEmail ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <Send className="w-4 h-4" />
                      Enviar Email
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal: Factura */}
      {showFacturaModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 max-md:p-0">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto max-md:max-w-none max-md:h-full max-md:max-h-none max-md:rounded-none max-md:[&_input]:text-base max-md:[&_select]:text-base max-md:[&_textarea]:text-base">
            {/* Header */}
            <div className="sticky top-0 max-md:z-10 bg-white border-b border-gray-200 px-6 max-md:px-4 py-4 flex justify-between items-center">
              <h2 className="text-2xl max-md:text-xl font-bold text-gray-800">
                {jornadaFacturaSel ? `Factura · Jornada ${jornadaFacturaSel.fecha}` : 'Factura'}
              </h2>
              <button
                onClick={cerrarModalFactura}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 max-md:p-4 space-y-4">

              {/* Notas para administración y correos "para administración" sin
                  gestionar del presupuesto: recordatorio destacado al facturar
                  (sale aunque no haya notas; no bloquea la emisión) */}
              <AvisoAdministracionFactura
                presupuestoId={presupuesto?.id}
                notas={presupuesto?.notas_administracion}
              />


              {/* Selector de acción (Tabs) */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">Acción</label>
                <div className="grid grid-cols-2 gap-3">
                  <button
                    onClick={() => setAccionFactura('descargar')}
                    className={`p-4 border-2 rounded-lg transition-all ${
                      accionFactura === 'descargar'
                        ? 'border-duetto-primary bg-green-50'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <FileText className="w-6 h-6 mx-auto mb-2" />
                    <div className="text-sm font-semibold">Descargar</div>
                    <div className="text-xs text-gray-500">Guardar en tu dispositivo</div>
                  </button>
                  <button
                    onClick={() => setAccionFactura('enviar')}
                    className={`p-4 border-2 rounded-lg transition-all ${
                      accionFactura === 'enviar'
                        ? 'border-duetto-primary bg-green-50'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <Send className="w-6 h-6 mx-auto mb-2" />
                    <div className="text-sm font-semibold">Enviar por Email</div>
                    <div className="text-xs text-gray-500">Enviar directamente al cliente</div>
                  </button>
                </div>
              </div>

              {/* Documento concreto elegido en la tabla del formato nuevo */}
              {documentoEnvioSel && (
                <div className="bg-sky-50 border border-sky-300 rounded-lg p-4" data-testid="documento-envio-sel">
                  <p className="text-xs font-bold text-sky-800 uppercase tracking-wide mb-1">Documento seleccionado</p>
                  <p className="text-base font-bold text-gray-900">
                    {documentoEnvioSel.numero_factura || documentoEnvioSel.numero_proforma}
                    {documentoEnvioSel.etiquetaTipo ? <span className="ml-2 text-sm font-medium text-gray-600">{documentoEnvioSel.etiquetaTipo}</span> : null}
                  </p>
                  <p className="text-xs text-sky-800 mt-1">
                    Se descarga o se envía tal como está emitido, sin regenerarlo.
                  </p>
                </div>
              )}

              {/* Alerta: Dirección Fiscal Faltante */}
              {(!cliente?.direccion_fiscal && !cliente?.direccion && !presupuesto?.datos_facturacion?.direccion) && (
                <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <AlertCircle className="h-5 w-5 text-red-500" />
                    </div>
                    <div className="ml-3">
                      <p className="text-sm text-red-700">
                        <span className="font-bold">¡Atención!</span> El cliente no tiene dirección fiscal configurada.
                        <br />
                        La factura generada podría no ser válida legalmente sin este dato.
                      </p>
                      <button 
                        className="mt-2 text-sm font-medium text-red-600 hover:text-red-500 underline"
                        onClick={() => {
                          setShowFacturaModal(false);
                          setShowEditClienteModal(true);
                          setClienteEditData(cliente || {});
                        }}
                      >
                        Editar Cliente para añadir dirección
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Facturas existentes del presupuesto (ocultas al facturar una jornada suelta) */}
              {!jornadaFacturaSel && !documentoEnvioSel && (proformaExistente || facturaNormalExistente || rectificativasExistentes.length > 0 || anuladasExistentes.length > 0 || tercerosExistentes.length > 0 || (esFacturacionPorJornada() && (facturasJornadaExistentes || []).length > 0)) && (
                <div className="space-y-3 mb-4">
                  <h3 className="text-sm font-semibold text-gray-700">Documentos existentes</h3>
                  
                  {/* Proforma existente */}
                  {proformaExistente && (
                    <div className={`border-2 rounded-lg p-4 ${difiereDelTotal(proformaExistente.importe_total) ? 'bg-red-50 border-red-300' : 'bg-amber-50 border-amber-300'}`}>
                      <div className="flex items-center justify-between mb-2">
                        <div>
                          <span className="text-xs font-medium text-amber-700 uppercase">Proforma</span>
                          <div className="text-base font-bold text-gray-900">{proformaExistente.numero_factura}</div>
                        </div>
                        <span className="text-base font-bold text-green-600">
                          {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(proformaExistente.importe_total || 0)}
                        </span>
                      </div>
                      {difiereDelTotal(proformaExistente.importe_total) && (
                        <div className="flex items-center gap-1 mb-2 px-2 py-1 bg-red-100 rounded text-xs text-red-700 font-medium">
                          <RefreshCw className="w-3 h-3" />
                          Desactualizada: el presupuesto actual es {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(totalPresupuesto())}. Pulsa Regenerar para actualizar.
                        </div>
                      )}
                      {/* Solo si la proforma es el único documento: con factura normal
                          presente, el textarea de observaciones refleja la factura, no la proforma */}
                      {!facturaNormalExistente && (observacionesFactura || '').trim() !== (proformaExistente.observaciones || '').trim() && (
                        <div className="flex items-center gap-1 mb-2 px-2 py-1 bg-red-100 rounded text-xs text-red-700 font-medium">
                          <RefreshCw className="w-3 h-3" />
                          Observaciones distintas de las emitidas. Pulsa Regenerar para actualizarlas.
                        </div>
                      )}
                      {proformaExistente.fecha_emision && (
                        <div className="text-xs text-gray-500 mb-2">Fecha: {proformaExistente.fecha_emision.split('T')[0]}</div>
                      )}
                      <div className="flex gap-2">
                        <button
                          onClick={() => {
                            const token = getAuthToken();
                            const fId = proformaExistente.factura_id || proformaExistente.id;
                            const xhr = new XMLHttpRequest();
                            const queryPago = ocultarDatosPago ? '?ocultar_datos_pago=true' : '';
                            xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/facturas/${fId}/pdf${queryPago}`, true);
                            xhr.setRequestHeader('Authorization', `Bearer ${token}`);
                            xhr.responseType = 'blob';
                            xhr.onload = function() {
                              if (xhr.status === 200) {
                                const blob = new Blob([xhr.response], { type: 'application/pdf' });
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                a.download = `${proformaExistente.numero_factura}.pdf`;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                window.URL.revokeObjectURL(url);
                              } else { alert('Error descargando PDF de proforma'); }
                            };
                            xhr.send();
                          }}
                          data-testid="download-proforma-pdf"
                          className="flex-1 px-3 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 text-sm font-medium flex items-center justify-center gap-1"
                        >
                          <FileText className="w-4 h-4" /> Descargar PDF
                        </button>
                        <button
                          onClick={async () => {
                            if (window.confirm(`Regenerar proforma ${proformaExistente.numero_factura} con los datos actuales del presupuesto?\n\nSe mantendrá la misma numeración pero se actualizarán los menús, cantidades e importes.`)) {
                              try {
                                const token = getAuthToken();
                                const fId = proformaExistente.factura_id || proformaExistente.id;
                                const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/facturas/${fId}/regenerar`, {
                                  method: 'POST',
                                  headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                                  // Mandar lo escrito en el modal para que las observaciones,
                                  // el nº de pedido y el concepto único se guarden al regenerar
                                  body: JSON.stringify({
                                    observaciones: observacionesFactura || null,
                                    concepto_unico: conceptoUnicoFactura || null,
                                    fecha_emision: fechaEmisionFactura || null,
                                    face_numero_pedido: faceNumPedido.trim() || null
                                  })
                                });
                                if (resp.ok) {
                                  const data = await resp.json();
                                  setProformaExistente(prev => ({
                                    ...prev,
                                    importe_total: data.importe_total,
                                    observaciones: data.observaciones,
                                    concepto_unico: data.concepto_unico,
                                    fecha_emision: data.fecha_emision
                                  }));
                                  alert(`Proforma ${data.numero_factura} regenerada. Nuevo total: ${new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(data.importe_total)}`);
                                } else {
                                  const err = await resp.json();
                                  alert(err.detail || 'Error al regenerar');
                                }
                              } catch (e) { alert('Error: ' + e.message); }
                            }
                          }}
                          data-testid="regenerar-proforma"
                          className="px-3 py-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 text-sm font-medium flex items-center justify-center gap-1"
                          title="Regenerar proforma con los datos actualizados del presupuesto"
                        >
                          <RefreshCw className="w-4 h-4" /> Regenerar
                        </button>
                        <button
                          onClick={async () => {
                            if (window.confirm(`¿Eliminar proforma ${proformaExistente.numero_factura}?`)) {
                              try {
                                const token = getAuthToken();
                                const fId = proformaExistente.factura_id || proformaExistente.id;
                                const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/facturas/${fId}`, {
                                  method: 'DELETE',
                                  headers: { 'Authorization': `Bearer ${token}` }
                                });
                                if (resp.ok) {
                                  setProformaExistente(null);
                                  alert('Proforma eliminada');
                                  verificarFacturaExistente();
                                } else {
                                  const err = await resp.json();
                                  alert(err.detail || 'Error al eliminar');
                                }
                              } catch (e) { alert('Error: ' + e.message); }
                            }
                          }}
                          data-testid="delete-proforma"
                          className="px-3 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 text-sm font-medium flex items-center justify-center gap-1"
                        >
                          <Trash2 className="w-4 h-4" /> Eliminar
                        </button>
                      </div>
                      {!facturaNormalExistente && (
                        <p className="text-xs text-amber-700 mt-2">
                          Puedes generar la factura definitiva seleccionando "Factura Normal" abajo.
                        </p>
                      )}
                    </div>
                  )}
                  
                  {/* Facturación por jornada: la factura de cada jornada con su importe real */}
                  {esFacturacionPorJornada() && (() => {
                    const resumen = resumenFacturasJornadas();
                    const facturas = facturasJornadaExistentes || [];
                    const jornadasOrdenadas = [...(presupuesto.jornadas || [])].filter(j => j && j.id)
                      .sort((a, b) => String(a.fecha || '').localeCompare(String(b.fecha || '')));
                    const formatoEur = (v) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(Number(v) || 0);
                    const descargarPdf = (f) => {
                      const token = getAuthToken();
                      const xhr = new XMLHttpRequest();
                      const queryPago = ocultarDatosPago ? '?ocultar_datos_pago=true' : '';
                      xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/facturas/${f.id}/pdf${queryPago}`, true);
                      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
                      xhr.responseType = 'blob';
                      xhr.onload = function() {
                        if (xhr.status === 200) {
                          const blob = new Blob([xhr.response], { type: 'application/pdf' });
                          const url = window.URL.createObjectURL(blob);
                          const a = document.createElement('a');
                          a.href = url;
                          a.download = `${f.numero_factura || 'factura'}.pdf`;
                          document.body.appendChild(a);
                          a.click();
                          document.body.removeChild(a);
                          window.URL.revokeObjectURL(url);
                        } else { alert('Error descargando PDF de factura'); }
                      };
                      xhr.send();
                    };
                    return (
                      <div className="border-2 rounded-lg p-4 bg-blue-50 border-blue-300" data-testid="facturas-por-jornada">
                        <div className="flex items-center justify-between mb-2 gap-2">
                          <span className="text-xs font-medium text-blue-700 uppercase">Facturas por jornada</span>
                          <span className="text-xs font-semibold text-blue-900">
                            {resumen.emitidas === resumen.total
                              ? 'Todas las jornadas facturadas'
                              : (resumen.emitidas > 0
                                ? `Facturado parcialmente: ${resumen.emitidas} de ${resumen.total} jornadas`
                                : 'Ninguna jornada facturada')}
                          </span>
                        </div>
                        <div className="space-y-2">
                          {jornadasOrdenadas.map((j, i) => {
                            const f = facturas.find(x => x.jornada_id === j.id) || null;
                            const fecha = String(j.fecha || '').slice(0, 10);
                            const fechaTexto = /^\d{4}-\d{2}-\d{2}$/.test(fecha) ? `${fecha.slice(8, 10)}/${fecha.slice(5, 7)}/${fecha.slice(0, 4)}` : '';
                            return (
                              <div key={j.id} className="flex items-center justify-between gap-2 bg-white border border-blue-200 rounded px-3 py-2 text-sm">
                                <div>
                                  <div className="font-semibold text-gray-900">Jornada {i + 1}{fechaTexto ? ` · ${fechaTexto}` : ''}</div>
                                  <div className="text-xs text-gray-600">
                                    {f
                                      ? `${f.numero_factura || 'Sin número'} · ${esFacturaJornadaEmitida(f) ? 'Emitida' : 'Borrador'}`
                                      : 'Sin factura'}
                                  </div>
                                </div>
                                <div className="flex items-center gap-2">
                                  {f && <span className="font-bold text-green-600 tabular-nums">{formatoEur(f.importe_total)}</span>}
                                  {f && (
                                    <button
                                      type="button"
                                      onClick={() => descargarPdf(f)}
                                      className="px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 text-xs font-medium flex items-center gap-1"
                                      data-testid={`download-factura-jornada-${j.id}`}
                                    >
                                      <FileText className="w-3 h-3" /> PDF
                                    </button>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })()}

                  {/* Factura normal existente (en facturación por jornada, solo si no es la de una jornada) */}
                  {facturaNormalExistente && !(esFacturacionPorJornada() && facturaNormalExistente.jornada_id) && (
                    <div className={`border-2 rounded-lg p-4 ${!facturaNormalExistente.jornada_id && difiereDelTotal(facturaNormalExistente.importe_total) ? 'bg-red-50 border-red-300' : 'bg-blue-50 border-blue-300'}`}>
                      <div className="flex items-center justify-between mb-2">
                        <div>
                          <span className="text-xs font-medium text-blue-700 uppercase">Factura</span>
                          <div className="text-base font-bold text-gray-900">{facturaNormalExistente.numero_factura}</div>
                        </div>
                        <span className="text-base font-bold text-green-600">
                          {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(facturaNormalExistente.importe_total || 0)}
                        </span>
                      </div>
                      {/* Una factura de jornada no se compara con el total del evento */}
                      {!facturaNormalExistente.jornada_id && difiereDelTotal(facturaNormalExistente.importe_total) && (
                        <div className="flex items-center gap-1 mb-2 px-2 py-1 bg-red-100 rounded text-xs text-red-700 font-medium">
                          <RefreshCw className="w-3 h-3" />
                          Desactualizada: el presupuesto actual es {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(totalPresupuesto())}. Pulsa Regenerar para actualizar.
                        </div>
                      )}
                      {(observacionesFactura || '').trim() !== (facturaNormalExistente.observaciones || '').trim() && (
                        <div className="flex items-center gap-1 mb-2 px-2 py-1 bg-red-100 rounded text-xs text-red-700 font-medium">
                          <RefreshCw className="w-3 h-3" />
                          Observaciones distintas de las emitidas. Pulsa Regenerar para actualizarlas.
                        </div>
                      )}
                      {facturaNormalExistente.fecha_emision && (
                        <div className="text-xs text-gray-500 mb-2">Fecha: {facturaNormalExistente.fecha_emision.split('T')[0]}</div>
                      )}
                      {facturaNormalExistente.face_numero_registro ? (
                        <div className="mb-2 px-2 py-1 bg-blue-100 border border-blue-300 rounded text-xs text-blue-800 font-semibold inline-block" data-testid="face-enviada-badge">
                          ENVIADA A FACe · Registro {facturaNormalExistente.face_numero_registro} · Estado: {facturaNormalExistente.face_estado || 'Registrada'}
                        </div>
                      ) : facturaNormalExistente.face_xml_firmado && (
                        <div className="mb-2 px-2 py-1 bg-green-100 border border-green-300 rounded text-xs text-green-800 font-semibold inline-block" data-testid="face-firmada-badge">
                          FIRMADA con AutoFirma{facturaNormalExistente.face_fecha_firma ? ` · ${new Date(facturaNormalExistente.face_fecha_firma).toLocaleDateString('es-ES')}` : ''} · pendiente de envío a FACe
                        </div>
                      )}
                      <div className="flex gap-2">
                        <button
                          onClick={() => {
                            const token = getAuthToken();
                            const fId = facturaNormalExistente.factura_id || facturaNormalExistente.id;
                            const xhr = new XMLHttpRequest();
                            const queryPago = ocultarDatosPago ? '?ocultar_datos_pago=true' : '';
                            xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/facturas/${fId}/pdf${queryPago}`, true);
                            xhr.setRequestHeader('Authorization', `Bearer ${token}`);
                            xhr.responseType = 'blob';
                            xhr.onload = function() {
                              if (xhr.status === 200) {
                                const blob = new Blob([xhr.response], { type: 'application/pdf' });
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                a.download = `${facturaNormalExistente.numero_factura}.pdf`;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                window.URL.revokeObjectURL(url);
                              } else { alert('Error descargando PDF de factura'); }
                            };
                            xhr.send();
                          }}
                          data-testid="download-factura-normal-pdf"
                          className="flex-1 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium flex items-center justify-center gap-1"
                        >
                          <FileText className="w-4 h-4" /> Descargar PDF
                        </button>
                        <button
                          onClick={async () => {
                            const fIdAvisos = facturaNormalExistente.factura_id || facturaNormalExistente.id;
                            // U-18: avisos (enviada, a3doc, cobros, trimestre) antes de confirmar
                            const confRegen = await confirmarConAvisosFactura(
                              fIdAvisos, 'regenerar',
                              `Regenerar factura ${facturaNormalExistente.numero_factura} con los datos actuales del presupuesto?\n\nSe mantendrá la misma numeración pero se actualizarán los menús, cantidades e importes.`
                            );
                            if (confRegen) {
                              try {
                                const token = getAuthToken();
                                const fId = fIdAvisos;
                                // Mandar lo escrito en el modal (observaciones = nº de pedido,
                                // concepto único) para que se guarde al regenerar. Si es
                                // administración pública y hay un destino FACe seleccionado,
                                // se manda también para reasignarlo (si no, el backend
                                // conserva el que ya tenía).
                                const cuerpoRegenerar = {
                                  observaciones: observacionesFactura || null,
                                  concepto_unico: conceptoUnicoFactura || null,
                                  fecha_emision: fechaEmisionFactura || null,
                                  // Nº de pedido del cliente: cualquier cliente (cabecera del PDF)
                                  face_numero_pedido: faceNumPedido.trim() || null,
                                  ...(cliente?.es_administracion_publica
                                    ? {
                                        ...(faceDestinoId ? { face_destino_id: faceDestinoId } : {}),
                                        face_numero_expediente: faceNumExpediente || null,
                                        face_numero_contrato: faceNumContrato || null,
                                        face_observaciones: faceObservaciones || null
                                      }
                                    : {})
                                };
                                const enviarRegenerar = (confirmado) => fetch(`${process.env.REACT_APP_BACKEND_URL}/api/facturas/${fId}/regenerar`, {
                                  method: 'POST',
                                  headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                                  body: JSON.stringify({ ...cuerpoRegenerar, confirmado })
                                });
                                let resp = await enviarRegenerar(confRegen.confirmado);
                                if (resp.status === 409) {
                                  const err409 = await resp.clone().json().catch(() => ({}));
                                  const repetido = await reintentarSiPideConfirmacion(409, err409.detail, () => enviarRegenerar(true));
                                  if (repetido === null) return;
                                  if (repetido) resp = repetido;
                                }
                                if (resp.ok) {
                                  const data = await resp.json();
                                  setFacturaNormalExistente(prev => ({
                                    ...prev,
                                    importe_total: data.importe_total,
                                    base_imponible_total: data.base_imponible_total,
                                    cuota_total: data.cuota_total,
                                    observaciones: data.observaciones,
                                    concepto_unico: data.concepto_unico,
                                    fecha_emision: data.fecha_emision,
                                    face_numero_pedido: faceNumPedido || prev.face_numero_pedido,
                                    face_numero_expediente: faceNumExpediente || prev.face_numero_expediente,
                                    face_numero_contrato: faceNumContrato || prev.face_numero_contrato,
                                    face_observaciones: faceObservaciones || prev.face_observaciones,
                                    // Al regenerar cambian líneas/importes y el destino:
                                    // la firma previa queda invalidada en el backend.
                                    face_xml_firmado: null,
                                    face_numero_registro: null
                                  }));
                                  alert(`Factura ${data.numero_factura} regenerada. Nuevo total: ${new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(data.importe_total)}${data.aviso ? `\n\n${data.aviso}` : ''}`);
                                  verificarFacturaExistente();
                                } else {
                                  const err = await resp.json();
                                  alert(textoDetalleApi(err.detail, 'Error al regenerar'));
                                }
                              } catch (e) { alert('Error: ' + e.message); }
                            }
                          }}
                          data-testid="regenerar-factura-normal"
                          className="px-3 py-2 bg-amber-100 text-amber-700 rounded-lg hover:bg-amber-200 text-sm font-medium flex items-center justify-center gap-1"
                          title="Regenerar factura con los datos actualizados del presupuesto, manteniendo la misma numeración"
                        >
                          <RefreshCw className="w-4 h-4" /> Regenerar
                        </button>
                        <button
                          onClick={async () => {
                            const fId = facturaNormalExistente.factura_id || facturaNormalExistente.id;
                            try {
                              const data = await borrarFacturaConAvisos(fId, `¿Eliminar factura ${facturaNormalExistente.numero_factura}?`);
                              if (!data) return;
                              setFacturaNormalExistente(null);
                              alert(`Factura eliminada${data.aviso ? `\n\n${data.aviso}` : ''}`);
                              verificarFacturaExistente();
                            } catch (e) {
                              alert(textoDetalleApi(e.response?.data?.detail, `Error al eliminar: ${e.message}`));
                            }
                          }}
                          data-testid="delete-factura-normal"
                          className="px-3 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 text-sm font-medium flex items-center justify-center gap-1"
                        >
                          <Trash2 className="w-4 h-4" /> Eliminar
                        </button>
                        {cliente?.es_administracion_publica && (
                          <button
                            onClick={() => verFacePreview(facturaNormalExistente.factura_id || facturaNormalExistente.id)}
                            disabled={facePreviewLoading}
                            data-testid="face-preview-btn"
                            className="px-3 py-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 text-sm font-medium flex items-center justify-center gap-1 disabled:opacity-50"
                            title="Ver el Facturae (FACe) antes de firmar"
                          >
                            {facePreviewLoading ? 'Generando…' : 'Vista previa FACe'}
                          </button>
                        )}
                        {cliente?.es_administracion_publica && (
                          <button
                            onClick={() => {
                              if (facturaNormalExistente.face_xml_firmado && !window.confirm('Esta factura YA está firmada. ¿Volver a firmarla? (solo si has cambiado algo)')) return;
                              firmarConAutoFirma(facturaNormalExistente.factura_id || facturaNormalExistente.id);
                            }}
                            disabled={faceFirmaLoading}
                            data-testid="face-firmar-btn"
                            className={`px-3 py-2 rounded-lg text-sm font-medium flex items-center justify-center gap-1 disabled:opacity-50 ${facturaNormalExistente.face_xml_firmado ? 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-gray-300' : 'bg-duetto-primary text-white hover:opacity-90'}`}
                            title="Firmar el Facturae con AutoFirma (tu certificado)"
                          >
                            {faceFirmaLoading ? 'Firmando…' : (facturaNormalExistente.face_xml_firmado ? 'Volver a firmar' : 'Firmar con AutoFirma')}
                          </button>
                        )}
                        {cliente?.es_administracion_publica && facturaNormalExistente.face_xml_firmado && (
                          <button
                            onClick={() => descargarXsig(facturaNormalExistente.factura_id || facturaNormalExistente.id, facturaNormalExistente.numero_factura)}
                            data-testid="face-descargar-xsig-btn"
                            className="px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm font-medium flex items-center justify-center gap-1"
                            title="Descargar el Facturae firmado (.xsig) para subirlo a mano a FACe"
                          >
                            Descargar .xsig
                          </button>
                        )}
                        {cliente?.es_administracion_publica && facturaNormalExistente.face_xml_firmado && !facturaNormalExistente.face_numero_registro && (
                          <button
                            onClick={() => enviarAFace(facturaNormalExistente.factura_id || facturaNormalExistente.id)}
                            disabled={faceEnviarLoading}
                            data-testid="face-enviar-btn"
                            className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium flex items-center justify-center gap-1 disabled:opacity-50"
                            title="Enviar el Facturae firmado a FACe"
                          >
                            {faceEnviarLoading ? 'Enviando…' : 'Enviar a FACe'}
                          </button>
                        )}
                        {cliente?.es_administracion_publica && facturaNormalExistente.face_numero_registro && (
                          <button
                            onClick={() => actualizarEstadoFace(facturaNormalExistente.factura_id || facturaNormalExistente.id)}
                            disabled={faceEnviarLoading}
                            data-testid="face-estado-btn"
                            className="px-3 py-2 bg-gray-100 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-200 text-sm font-medium flex items-center justify-center gap-1 disabled:opacity-50"
                            title="Consultar el estado en FACe"
                          >
                            {faceEnviarLoading ? 'Consultando…' : 'Actualizar estado FACe'}
                          </button>
                        )}
                      </div>
                      {/* Resumen de lo que viajará en el Facturae: así se ve de un
                          vistazo si falta el nº de pedido (lo exigen casi todas). */}
                      {cliente?.es_administracion_publica && (
                        <div className="mt-2 text-xs text-gray-600 border-t border-gray-200 pt-2 space-y-0.5">
                          <div>
                            FACe: <span className="font-medium">{facturaNormalExistente.face_destino_nombre || 'sin destino DIR3'}</span>
                            {facturaNormalExistente.face_unidad_tramitadora ? ` (UT ${facturaNormalExistente.face_unidad_tramitadora})` : ''}
                          </div>
                          <div>
                            Nº pedido:{' '}
                            {facturaNormalExistente.face_numero_pedido
                              || facturaNormalExistente.face_numero_expediente
                              || facturaNormalExistente.face_numero_contrato
                              ? <span className="font-medium">{facturaNormalExistente.face_numero_pedido || facturaNormalExistente.face_numero_expediente || facturaNormalExistente.face_numero_contrato}</span>
                              : <span className="text-amber-700 font-medium">sin indicar — la administración puede rechazar la factura</span>}
                          </div>
                          {facturaNormalExistente.face_observaciones && (
                            <div>Observación: {facturaNormalExistente.face_observaciones}</div>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Facturas anuladas (histórico: la original que anuló una rectificativa) */}
                  {anuladasExistentes.map((anulada, idx) => (
                    <div key={anulada.id || `anulada-${idx}`} className="border-2 rounded-lg p-4 bg-gray-50 border-gray-300 opacity-80">
                      <div className="flex items-center justify-between mb-2">
                        <div>
                          <span className="text-xs font-medium text-gray-500 uppercase">
                            Factura anulada{anulada.anulada_por_rectificativa ? ` por ${anulada.anulada_por_rectificativa}` : ''}
                          </span>
                          <div className="text-base font-bold text-gray-600 line-through">{anulada.numero_factura}</div>
                          {anulada.cliente_nombre && (
                            <div className="text-xs text-gray-500">{anulada.cliente_nombre}</div>
                          )}
                        </div>
                        <span className="text-base font-bold text-gray-500">
                          {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(anulada.importe_total || 0)}
                        </span>
                      </div>
                      {anulada.fecha_emision && (
                        <div className="text-xs text-gray-500 mb-2">Fecha: {String(anulada.fecha_emision).split('T')[0]}</div>
                      )}
                      <button
                        onClick={() => {
                          const token = getAuthToken();
                          const fId = anulada.factura_id || anulada.id;
                          const xhr = new XMLHttpRequest();
                          xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/facturas/${fId}/pdf`, true);
                          xhr.setRequestHeader('Authorization', `Bearer ${token}`);
                          xhr.responseType = 'blob';
                          xhr.onload = function() {
                            if (xhr.status === 200) {
                              const blob = new Blob([xhr.response], { type: 'application/pdf' });
                              const url = window.URL.createObjectURL(blob);
                              const a = document.createElement('a');
                              a.href = url;
                              a.download = `${anulada.numero_factura}.pdf`;
                              document.body.appendChild(a);
                              a.click();
                              document.body.removeChild(a);
                              window.URL.revokeObjectURL(url);
                            } else { alert('Error descargando PDF'); }
                          };
                          xhr.send();
                        }}
                        data-testid={`download-anulada-pdf-${idx}`}
                        className="w-full px-3 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 text-sm font-medium flex items-center justify-center gap-1"
                      >
                        <FileText className="w-4 h-4" /> Descargar PDF
                      </button>
                    </div>
                  ))}

                  {/* Rectificativas existentes */}
                  {rectificativasExistentes.map((rect, idx) => {
                    // Solo las rectificativas antiguas (sin factura de referencia) replican
                    // el presupuesto; las nuevas replican la original o son de importe concreto.
                    // En facturación por jornada (o si rectifica una factura de jornada) no
                    // se compara con el total del evento.
                    const rectDesactualizada = !rect.rectificacion_parcial && !rect.factura_rectificada_numero
                      && !rect.jornada_id && !esFacturacionPorJornada()
                      && difiereDelTotal(-(Number(rect.importe_total) || 0));
                    return (
                    <div key={rect.id || idx} className={`border-2 rounded-lg p-4 ${rectDesactualizada ? 'bg-red-50 border-red-300' : 'bg-purple-50 border-purple-300'}`}>
                      <div className="flex items-center justify-between mb-2">
                        <div>
                          <span className="text-xs font-medium text-purple-700 uppercase">
                            Rectificativa{rect.rectificacion_parcial ? ' parcial' : ''}{rect.factura_rectificada_numero ? ` de ${rect.factura_rectificada_numero}` : ''}
                          </span>
                          <div className="text-base font-bold text-gray-900">{rect.numero_factura}</div>
                          {rect.cliente_nombre && (
                            <div className="text-xs text-gray-500">{rect.cliente_nombre}</div>
                          )}
                        </div>
                        <span className={`text-base font-bold ${(rect.importe_total || 0) < 0 ? 'text-red-600' : 'text-green-600'}`}>
                          {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(rect.importe_total || 0)}
                        </span>
                      </div>
                      {/* Una rectificativa debe ser el NEGATIVO de lo facturado: avisar si no lo es */}
                      {rectDesactualizada && (
                        <div className="flex items-center gap-1 mb-2 px-2 py-1 bg-red-100 rounded text-xs text-red-700 font-medium">
                          <RefreshCw className="w-3 h-3" />
                          Desactualizada: debería ser {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(-totalPresupuesto())} (el negativo del presupuesto). Pulsa Regenerar para actualizar.
                        </div>
                      )}
                      <div className="flex gap-2">
                        <button
                          onClick={() => {
                            const token = getAuthToken();
                            const fId = rect.factura_id || rect.id;
                            const xhr = new XMLHttpRequest();
                            const queryPago = ocultarDatosPago ? '?ocultar_datos_pago=true' : '';
                            xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/facturas/${fId}/pdf${queryPago}`, true);
                            xhr.setRequestHeader('Authorization', `Bearer ${token}`);
                            xhr.responseType = 'blob';
                            xhr.onload = function() {
                              if (xhr.status === 200) {
                                const blob = new Blob([xhr.response], { type: 'application/pdf' });
                                const url = window.URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                a.download = `${rect.numero_factura}.pdf`;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                window.URL.revokeObjectURL(url);
                              } else { alert('Error descargando PDF'); }
                            };
                            xhr.send();
                          }}
                          data-testid={`download-rectificativa-pdf-${idx}`}
                          className="flex-1 px-3 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 text-sm font-medium flex items-center justify-center gap-1"
                        >
                          <FileText className="w-4 h-4" /> Descargar PDF
                        </button>
                        <button
                          onClick={async () => {
                            const fIdRect = rect.factura_id || rect.id;
                            const confRect = await confirmarConAvisosFactura(
                              fIdRect, 'regenerar',
                              `¿Regenerar el PDF de la rectificativa ${rect.numero_factura}?\n\nSe mantiene la numeración. Si anula una factura, replica sus líneas en negativo (solo lo que quedaba vivo tras las parciales); si es de importe concreto, conserva ese importe.`
                            );
                            if (confRect) {
                              try {
                                const token = getAuthToken();
                                const enviarRegenerar = (confirmado) => fetch(`${process.env.REACT_APP_BACKEND_URL}/api/facturas/${fIdRect}/regenerar`, {
                                  method: 'POST',
                                  headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                                  body: JSON.stringify({ confirmado })
                                });
                                let resp = await enviarRegenerar(confRect.confirmado);
                                if (resp.status === 409) {
                                  const err409 = await resp.clone().json().catch(() => ({}));
                                  const repetido = await reintentarSiPideConfirmacion(409, err409.detail, () => enviarRegenerar(true));
                                  if (repetido === null) return;
                                  if (repetido) resp = repetido;
                                }
                                if (resp.ok) {
                                  const data = await resp.json();
                                  setRectificativasExistentes(prev => prev.map(r =>
                                    (r.id || r.factura_id) === (rect.id || rect.factura_id)
                                      ? { ...r, importe_total: data.importe_total }
                                      : r
                                  ));
                                  alert(`Rectificativa ${data.numero_factura} regenerada. Nuevo total: ${new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(data.importe_total)}${data.aviso ? `\n\n${data.aviso}` : ''}`);
                                } else {
                                  const err = await resp.json();
                                  alert(textoDetalleApi(err.detail, 'Error al regenerar'));
                                }
                              } catch (e) { alert('Error: ' + e.message); }
                            }
                          }}
                          data-testid={`regenerar-rectificativa-${idx}`}
                          className="px-3 py-2 bg-amber-100 text-amber-700 rounded-lg hover:bg-amber-200 text-sm font-medium flex items-center justify-center gap-1"
                          title="Regenerar el PDF de la rectificativa"
                        >
                          <RefreshCw className="w-4 h-4" /> Regenerar
                        </button>
                        <button
                          onClick={async () => {
                            const fIdBorrar = rect.factura_id || rect.id;
                            try {
                              const data = await borrarFacturaConAvisos(fIdBorrar, rect.factura_tercero_numero
                                ? `¿Eliminar la rectificativa ${rect.numero_factura}?\n\nSe eliminará también la factura ${rect.factura_tercero_numero} a la otra empresa, porque se emitieron juntas.`
                                : `¿Eliminar rectificativa ${rect.numero_factura}?`);
                              if (!data) return;
                              setRectificativasExistentes(prev => prev.filter(r => (r.id || r.factura_id) !== (rect.id || rect.factura_id)));
                              alert(`Rectificativa eliminada${data.aviso ? `\n\n${data.aviso}` : ''}`);
                              verificarFacturaExistente();
                            } catch (e) {
                              alert(textoDetalleApi(e.response?.data?.detail, `Error al eliminar: ${e.message}`));
                            }
                          }}
                          data-testid={`delete-rectificativa-${idx}`}
                          className="px-3 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 text-sm font-medium flex items-center justify-center gap-1"
                        >
                          <Trash2 className="w-4 h-4" /> Eliminar
                        </button>
                      </div>
                    </div>
                    );
                  })}

                  {/* Facturas a otras empresas (parte del servicio que asume un tercero) */}
                  {tercerosExistentes.map((ft, idx) => (
                    <div key={ft.id || `tercero-${idx}`} className="border-2 rounded-lg p-4 bg-sky-50 border-sky-300" data-testid={`factura-tercero-${idx}`}>
                      <div className="flex items-center justify-between mb-2">
                        <div>
                          <span className="text-xs font-medium text-sky-700 uppercase">
                            Factura a otra empresa{ft.factura_tercero_de_numero ? ` · parte de ${ft.factura_tercero_de_numero}` : ''}
                          </span>
                          <div className="text-base font-bold text-gray-900">{ft.numero_factura}</div>
                          <div className="text-xs text-gray-600">{ft.cliente_nombre}{ft.rectificativa_asociada_numero ? ` · rectificativa ${ft.rectificativa_asociada_numero}` : ''}</div>
                          {ft.face_oficina_contable && (
                            <div className="text-xs text-gray-600" data-testid={`tercero-face-${idx}`}>
                              FACe {ft.face_destino_nombre || ''}: {ft.face_oficina_contable} / {ft.face_organo_gestor} / {ft.face_unidad_tramitadora}
                              {' · '}{ft.face_xml_firmado ? 'firmada' : 'pendiente de firma'}
                            </div>
                          )}
                        </div>
                        <span className="text-base font-bold text-gray-900">
                          {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(ft.importe_total || 0)}
                        </span>
                      </div>
                      <div className="flex gap-2">
                      <button
                        onClick={() => {
                          const token = getAuthToken();
                          const xhr = new XMLHttpRequest();
                          const queryPago = ocultarDatosPago ? '?ocultar_datos_pago=true' : '';
                          xhr.open('GET', `${process.env.REACT_APP_BACKEND_URL}/api/facturas/${ft.id}/pdf${queryPago}`, true);
                          xhr.setRequestHeader('Authorization', `Bearer ${token}`);
                          xhr.responseType = 'blob';
                          xhr.onload = function() {
                            if (xhr.status === 200) {
                              const url = window.URL.createObjectURL(new Blob([xhr.response], { type: 'application/pdf' }));
                              const a = document.createElement('a');
                              a.href = url;
                              a.download = `${ft.numero_factura}.pdf`;
                              document.body.appendChild(a);
                              a.click();
                              document.body.removeChild(a);
                              window.URL.revokeObjectURL(url);
                            } else { alert('Error descargando PDF'); }
                          };
                          xhr.send();
                        }}
                        data-testid={`download-tercero-pdf-${idx}`}
                        className="flex-1 px-3 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700 text-sm font-medium flex items-center justify-center gap-1"
                      >
                        <FileText className="w-4 h-4" /> Descargar PDF
                      </button>
                      {ft.face_oficina_contable && (
                        <button
                          onClick={() => {
                            if (ft.face_xml_firmado && !window.confirm('Esta factura YA está firmada. ¿Volver a firmarla? (solo si has cambiado algo)')) return;
                            firmarConAutoFirma(ft.id);
                          }}
                          disabled={faceFirmaLoading}
                          data-testid={`firmar-tercero-${idx}`}
                          className={`px-3 py-2 rounded-lg text-sm font-medium flex items-center justify-center gap-1 disabled:opacity-50 ${ft.face_xml_firmado ? 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-gray-300' : 'bg-duetto-primary text-white hover:opacity-90'}`}
                        >
                          {faceFirmaLoading ? 'Firmando…' : (ft.face_xml_firmado ? 'Volver a firmar' : 'Firmar con AutoFirma')}
                        </button>
                      )}
                      {ft.face_oficina_contable && ft.face_xml_firmado && (
                        <button
                          onClick={() => descargarXsig(ft.id, ft.numero_factura)}
                          data-testid={`xsig-tercero-${idx}`}
                          className="px-3 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 text-sm font-medium"
                        >
                          Descargar .xsig
                        </button>
                      )}
                      <button
                        onClick={async () => {
                          const aviso = `¿Eliminar la factura ${ft.numero_factura} a ${ft.cliente_nombre}?` +
                            (ft.rectificativa_asociada_numero
                              ? `\n\nSe eliminará también la rectificativa ${ft.rectificativa_asociada_numero}, porque se emitieron juntas.`
                              : '') +
                            `\n\nHazlo solo si no se han enviado a nadie ni subido a a3doc.`;
                          try {
                            const data = await borrarFacturaConAvisos(ft.id, aviso);
                            if (!data) return;
                            alert(`${data?.message || 'Eliminada'}${data?.aviso ? `\n\n${data.aviso}` : ''}`);
                            verificarFacturaExistente();
                          } catch (e) {
                            alert(textoDetalleApi(e.response?.data?.detail, `Error al eliminar: ${e.message}`));
                          }
                        }}
                        data-testid={`delete-tercero-${idx}`}
                        className="px-3 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 text-sm font-medium flex items-center justify-center gap-1"
                      >
                        <Trash2 className="w-4 h-4" /> Eliminar
                      </button>
                      </div>
                    </div>
                  ))}

                  {facturaNormalExistente && !showFacturarTercero && (
                    <button
                      onClick={abrirFacturarTercero}
                      data-testid="abrir-facturar-tercero"
                      className="w-full px-3 py-2 border-2 border-dashed border-sky-300 text-sky-700 rounded-lg hover:bg-sky-50 text-sm font-medium"
                    >
                      Facturar parte a otra empresa
                    </button>
                  )}

                  {facturaNormalExistente && showFacturarTercero && (
                    <div className="border-2 rounded-lg p-4 bg-sky-50 border-sky-300 space-y-3" data-testid="form-facturar-tercero">
                      <div className="text-sm font-semibold text-sky-900">Facturar parte a otra empresa</div>
                      <p className="text-xs text-sky-800">
                        Se emite una rectificativa a {facturaNormalExistente.cliente_nombre || 'el cliente'} por el importe y una factura a la otra empresa por lo mismo. {facturaNormalExistente.numero_factura} sigue vigente por el resto.
                      </p>
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Empresa (debe existir en el CRM) *</label>
                        <input
                          type="text"
                          value={terceroBusqueda}
                          onChange={(e) => { setTerceroBusqueda(e.target.value); setTerceroClienteId(''); }}
                          placeholder="Buscar por nombre o CIF..."
                          data-testid="tercero-busqueda"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-1"
                        />
                        {!terceroClienteId && terceroBusqueda.trim().length >= 2 && (
                          <div className="max-h-40 overflow-y-auto border border-gray-200 rounded-lg bg-white">
                            {(todosClientes || [])
                              .filter(c => c.id !== facturaNormalExistente.cliente_id)
                              .filter(c => {
                                const q = terceroBusqueda.trim().toLowerCase();
                                return [c.nombre_empresa, c.nombre_fiscal, c.nombre, c.cif, c.nif]
                                  .some(v => v && String(v).toLowerCase().includes(q));
                              })
                              .slice(0, 20)
                              .map(c => (
                                <button
                                  key={c.id}
                                  type="button"
                                  onClick={() => { setTerceroClienteId(c.id); setTerceroBusqueda(c.nombre_fiscal || c.nombre_empresa || c.nombre || ''); }}
                                  className="block w-full text-left px-3 py-1.5 text-sm hover:bg-sky-50"
                                >
                                  {c.nombre_fiscal || c.nombre_empresa || c.nombre}
                                  <span className={`ml-2 text-xs ${(c.cif || c.nif) ? 'text-gray-500' : 'text-red-600'}`}>{c.cif || c.nif || 'sin CIF'}</span>
                                </button>
                              ))}
                          </div>
                        )}
                      </div>
                      <div className="grid grid-cols-2 gap-2">
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Importe que asume *</label>
                          <input type="number" min="0" step="0.01" value={terceroImporte} onChange={(e) => setTerceroImporte(e.target.value)} placeholder="1000,00" data-testid="tercero-importe" className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">El importe es</label>
                          <select value={terceroIvaIncluido ? 'incluido' : 'mas'} onChange={(e) => setTerceroIvaIncluido(e.target.value === 'incluido')} className="w-full px-3 py-2 border border-gray-300 rounded-lg">
                            <option value="incluido">IVA incluido</option>
                            <option value="mas">+ IVA (base)</option>
                          </select>
                        </div>
                        <div className="col-span-2">
                          <label className="block text-xs font-medium text-gray-700 mb-1">Tipo de IVA</label>
                          <select value={terceroIva} onChange={(e) => setTerceroIva(e.target.value)} data-testid="tercero-iva" className="w-full px-3 py-2 border border-gray-300 rounded-lg">
                            {facturaVigenteMultiIva && (
                              <option value="prop">Proporcional a la factura ({Object.keys(tiposIvaFacturaVigente).map(t => `${t} %`).join(' + ')})</option>
                            )}
                            <option value="10">10 % (catering)</option>
                            <option value="21">21 % (suplementos, alquileres...)</option>
                          </select>
                        </div>
                        <div className="col-span-2">
                          <label className="block text-xs font-medium text-gray-700 mb-1">Concepto en la factura de la otra empresa</label>
                          <input type="text" value={terceroConcepto} onChange={(e) => setTerceroConcepto(e.target.value)} placeholder="Por defecto: Servicio de catering - (evento) (parte asumida)" className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
                        </div>
                      </div>
                      {previewTercero && (
                        <div className="text-xs text-sky-900 bg-white border border-sky-200 rounded p-2">
                          Factura a la otra empresa: <strong>{new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(previewTercero.total)}</strong>
                          {' '}(base {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(previewTercero.base)}
                          {previewTercero.tramos.map(tr => ` · IVA ${tr.tipo} % ${new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(tr.cuota)}`).join('')}).
                          {' '}Rectificativa al cliente por lo mismo en negativo.
                        </div>
                      )}
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Fecha de emisión (rectificativa y factura)</label>
                        <input type="date" value={terceroFecha} onChange={(e) => setTerceroFecha(e.target.value)} data-testid="tercero-fecha" className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
                      </div>
                      <p className="text-xs text-gray-500">Las observaciones son las del formulario de arriba.</p>
                      <div className="flex gap-2">
                        <button
                          onClick={handleFacturarTercero}
                          disabled={terceroEnviando || !terceroClienteId || !previewTercero}
                          data-testid="confirmar-facturar-tercero"
                          className="flex-1 px-3 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700 text-sm font-medium disabled:opacity-50"
                        >
                          {terceroEnviando ? 'Emitiendo...' : 'Emitir rectificativa y factura'}
                        </button>
                        <button
                          onClick={() => setShowFacturarTercero(false)}
                          className="px-3 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 text-sm font-medium"
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
              
              {/* Modal para editar datos de facturación */}
              {editandoDatosFacturacion && (
                <div className="bg-amber-50 border-2 border-amber-300 rounded-lg p-5 mb-4">
                  <h3 className="text-base font-bold text-amber-900 mb-4 flex items-center gap-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    Editar Datos de Facturación
                  </h3>
                  
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Nombre/Razón Social *
                      </label>
                      <input
                        type="text"
                        value={datosFacturacionEdit.cliente_nombre}
                        onChange={(e) => setDatosFacturacionEdit(prev => ({...prev, cliente_nombre: e.target.value}))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                        placeholder="Nombre de la empresa"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        CIF/NIF *
                      </label>
                      <input
                        type="text"
                        value={datosFacturacionEdit.cliente_nif}
                        onChange={(e) => setDatosFacturacionEdit(prev => ({...prev, cliente_nif: e.target.value}))}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                        placeholder="B12345678"
                      />
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Dirección Fiscal
                      </label>
                      <textarea
                        value={datosFacturacionEdit.cliente_direccion}
                        onChange={(e) => setDatosFacturacionEdit(prev => ({...prev, cliente_direccion: e.target.value}))}
                        rows={2}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                        placeholder="Calle, número, CP, ciudad..."
                      />
                    </div>
                    
                    <div className="flex gap-3 pt-2">
                      <button
                        onClick={() => setEditandoDatosFacturacion(false)}
                        className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                      >
                        Cancelar
                      </button>
                      <button
                        onClick={handleGuardarDatosFacturacion}
                        disabled={guardandoDatosFacturacion || !datosFacturacionEdit.cliente_nombre || !datosFacturacionEdit.cliente_nif}
                        className="flex-1 px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                      >
                        {guardandoDatosFacturacion ? (
                          <>
                            <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Guardando...
                          </>
                        ) : (
                          <>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            Guardar Cambios
                          </>
                        )}
                      </button>
                    </div>
                    
                    <p className="text-xs text-amber-700 mt-2">
                      ⚠️ Al guardar, el PDF de la factura se regenerará con los nuevos datos de facturación.
                    </p>
                  </div>
                </div>
              )}

              {/* Tipo de Factura - Generar nuevo documento (no aplica al enviar un documento ya emitido) */}
              {!documentoEnvioSel && (<>
              <div className="border-t border-gray-200 pt-4">
                <h3 className="text-sm font-semibold text-gray-700 mb-3">Generar nuevo documento</h3>

                {/* Factura repartida entre varios pagadores (antes de facturar) */}
                {presupuesto?.estado === 'confirmado' && !facturaNormalExistente && tercerosExistentes.length === 0
                  && !esFacturacionPorJornada() && (
                  <FacturaRepartida
                    presupuesto={presupuesto}
                    cliente={cliente}
                    todosClientes={todosClientes}
                    cargarTodosClientes={cargarTodosClientes}
                    onEmitido={verificarFacturaExistente}
                  />
                )}

                {/* Pestañas Normal / FACe (solo administración pública) */}
                {cliente?.es_administracion_publica && (
                  <div className="flex gap-1 bg-gray-100 rounded-lg p-1 mb-4 w-fit">
                    <button
                      type="button"
                      onClick={() => setModoFactura('normal')}
                      data-testid="tab-factura-normal"
                      className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${modoFactura === 'normal' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
                    >
                      Factura normal
                    </button>
                    <button
                      type="button"
                      onClick={() => setModoFactura('face')}
                      data-testid="tab-factura-face"
                      className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${modoFactura === 'face' ? 'bg-white text-duetto-primary shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
                    >
                      Factura por FACe
                    </button>
                  </div>
                )}
                {cliente?.es_administracion_publica && modoFactura === 'normal' && (
                  <p className="text-xs text-gray-500 mb-3 -mt-1">
                    Factura normal: se emite, descarga y envía como a cualquier cliente (útil cuando la administración no exige FACe por el importe).
                  </p>
                )}

                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tipo de Documento *
                </label>
                <select
                  value={tipoFactura}
                  onChange={(e) => {
                    setTipoFactura(e.target.value);
                    // El campo trae la fecha de la factura ya emitida; una rectificativa se emite hoy
                    if (e.target.value.startsWith('R')) setFechaEmisionFactura(hoyMadrid());
                  }}
                  data-testid="tipo-factura-select"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                >
                  <optgroup label="Proforma">
                    <option value="PROFORMA">Proforma (DCP{new Date().getFullYear()}XXX) - Sin validez fiscal</option>
                  </optgroup>
                  <optgroup label="Facturas">
                    <option value="F1">Factura Normal (DC{new Date().getFullYear()}XXX)</option>
                    <option value="F2">Factura Simplificada (DCS{new Date().getFullYear()}XXX) - Sin datos del cliente</option>
                  </optgroup>
                  <optgroup label="Facturas Rectificativas">
                    <option value="R1">Rectificativa por Error (corregir datos incorrectos)</option>
                    <option value="R2">Rectificativa por Descuento/Bonificación</option>
                  </optgroup>
                </select>
                {facturaNormalExistente && tipoFactura === 'F1' && (
                  <p className="text-xs text-amber-600 mt-1">Ya existe una factura normal. Si generas otra, se actualizarán los datos.</p>
                )}
                {tipoFactura.startsWith('R') && (
                  <div className="mt-3 p-3 border border-purple-200 bg-purple-50 rounded-lg space-y-3" data-testid="rectificativa-opciones">
                    <p className="text-xs text-purple-800">
                      {facturaARectificar
                        ? <>Rectifica la factura <strong>{facturaARectificar.numero_factura}</strong> ({new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(facturaARectificar.importe_total || 0)}){facturaRectificarSel?.jornada_fecha ? <>, de la jornada del {fechaDocumento(facturaRectificarSel.jornada_fecha)}</> : null}.</>
                        : 'Este presupuesto no tiene ninguna factura vigente que rectificar.'}
                      {facturaRectificarSel && modoRectificativa === 'total' && (
                        <> La jornada queda pendiente de facturar: su factura nueva se emite desde su botón.</>
                      )}
                    </p>
                    <label className="flex items-start gap-2 text-sm cursor-pointer">
                      <input type="radio" name="modo-rectificativa" className="mt-1" checked={modoRectificativa === 'total'} onChange={() => setModoRectificativa('total')} data-testid="rect-modo-total" />
                      <span><strong>Anular la factura completa</strong><br /><span className="text-xs text-gray-600">Para cambiar cliente, datos fiscales o rehacerla. Después generas la nueva factura con los datos corregidos.</span></span>
                    </label>
                    {modoRectificativa === 'total' && rectificadoParcialPrevio > 0 && (
                      <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded p-2" data-testid="rect-total-tras-parciales">
                        Esta factura ya tiene rectificativas parciales por {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(rectificadoParcialPrevio)}: la total se emite por {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(restoPorRectificar)}.
                      </p>
                    )}
                    {modoRectificativa === 'total' && !facturaRectificarSel && (
                      <label className="flex items-start gap-2 text-xs text-gray-700 cursor-pointer ml-6">
                        <input type="checkbox" className="mt-0.5" checked={anularYReemitir} onChange={(e) => setAnularYReemitir(e.target.checked)} data-testid="rect-anular-y-reemitir" />
                        <span>Emitir justo después la factura nueva con los datos actuales del presupuesto. Si no lo marcas, el presupuesto queda pendiente de facturar.</span>
                      </label>
                    )}
                    <label className="flex items-start gap-2 text-sm cursor-pointer">
                      <input type="radio" name="modo-rectificativa" className="mt-1" checked={modoRectificativa === 'parcial'} onChange={() => { setModoRectificativa('parcial'); if (facturaVigenteMultiIva) setIvaRectificar('prop'); }} data-testid="rect-modo-parcial" />
                      <span><strong>Descontar un importe</strong><br /><span className="text-xs text-gray-600">Descuento, abono o parte que paga otra empresa. La factura original sigue vigente por el resto.</span></span>
                    </label>
                    {modoRectificativa === 'parcial' && (
                      <div className="grid grid-cols-2 gap-2">
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Importe a descontar *</label>
                          <input type="number" min="0" step="0.01" value={importeRectificar} onChange={(e) => setImporteRectificar(e.target.value)} placeholder="200,00" data-testid="rect-importe" className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">El importe es</label>
                          <select value={ivaIncluidoRectificar ? 'incluido' : 'mas'} onChange={(e) => setIvaIncluidoRectificar(e.target.value === 'incluido')} data-testid="rect-iva-incluido" className="w-full px-3 py-2 border border-gray-300 rounded-lg">
                            <option value="incluido">IVA incluido</option>
                            <option value="mas">+ IVA (base)</option>
                          </select>
                        </div>
                        <div className="col-span-2">
                          <label className="block text-xs font-medium text-gray-700 mb-1">Tipo de IVA</label>
                          <select value={ivaRectificar} onChange={(e) => setIvaRectificar(e.target.value)} data-testid="rect-iva" className="w-full px-3 py-2 border border-gray-300 rounded-lg">
                            {facturaVigenteMultiIva && (
                              <option value="prop">Proporcional a la factura ({Object.keys(tiposIvaFacturaVigente).map(t => `${t} %`).join(' + ')})</option>
                            )}
                            <option value="10">10 % (catering)</option>
                            <option value="21">21 % (suplementos, alquileres...)</option>
                          </select>
                        </div>
                        {previewRectificativa && (
                          <div className="col-span-2 text-xs text-purple-900 bg-white border border-purple-200 rounded p-2" data-testid="rect-preview">
                            Rectificativa: <strong>-{new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(previewRectificativa.total)}</strong>
                            {' '}(base -{new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(previewRectificativa.base)}
                            {previewRectificativa.tramos.map(tr => ` · IVA ${tr.tipo} % -${new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(tr.cuota)}`).join('')})
                          </div>
                        )}
                        <div className="col-span-2">
                          <label className="block text-xs font-medium text-gray-700 mb-1">Concepto</label>
                          <input type="text" value={conceptoRectificar} onChange={(e) => setConceptoRectificar(e.target.value)} placeholder="Ej: Descuento acordado / Importe asumido por otra empresa" data-testid="rect-concepto" className="w-full px-3 py-2 border border-gray-300 rounded-lg" />
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {proformaExistente && tipoFactura === 'PROFORMA' && (
                  <p className="text-xs text-amber-600 mt-1">La proforma existente se regenerará con los datos actualizados del presupuesto.</p>
                )}
              </div>

              {/* Fecha de Emisión */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Fecha de Emisión *
                </label>
                <input
                  type="date"
                  value={fechaEmisionFactura}
                  onChange={(e) => setFechaEmisionFactura(e.target.value)}
                  data-testid="fecha-emision-input"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                />
              </div>

              {/* Nº de pedido del cliente (PO). Si es administración pública en
                  modo FACe, el campo está dentro del bloque FACe (mismo dato) */}
              {!(cliente?.es_administracion_publica && modoFactura === 'face') && (
                <div data-guia="factura-numero-pedido">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Nº de pedido del cliente
                    <span className="text-xs text-gray-500 ml-2">Opcional. Sale en la cabecera de la factura, junto al presupuesto</span>
                  </label>
                  <input
                    type="text"
                    value={faceNumPedido}
                    onChange={(e) => setFaceNumPedido(e.target.value)}
                    data-testid="factura-numero-pedido"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                    placeholder="Ej: 4500045060 (el número de pedido u orden de compra que te da el cliente)"
                  />
                </div>
              )}

              {/* Observaciones / Referencia del Cliente */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Observaciones / Referencia del Cliente
                </label>
                <textarea
                  value={observacionesFactura}
                  onChange={(e) => setObservacionesFactura(e.target.value)}
                  rows={3}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                  placeholder="Ej: Referencia PO-2025-001, Pedido interno #12345..."
                />
              </div>

              {/* Concepto Único (Opcional) */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Concepto Único (Opcional)
                  <span className="text-xs text-gray-500 ml-2">⚠️ Si se rellena, reemplaza el desglose de menús por este concepto único</span>
                </label>
                <input
                  type="text"
                  value={conceptoUnicoFactura}
                  onChange={(e) => setConceptoUnicoFactura(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                  placeholder="Ej: Comida Navidad 2025, Evento Corporativo..."
                />
                <p className="text-xs text-gray-500 mt-1">
                  💡 <strong>Tip:</strong> Usa esto cuando el cliente prefiera una factura simplificada sin detallar cada menú individualmente
                </p>
              </div>

              {/* FACe: facturación a administración pública */}
              {cliente?.es_administracion_publica && modoFactura === 'face' && (
                <div className="border-2 border-duetto-primary border-opacity-30 rounded-lg p-4 bg-green-50">
                  <div className="text-sm font-semibold text-duetto-primary mb-3">
                    Facturación por FACe (administración pública)
                  </div>
                  {(cliente.face_destinos || []).length === 0 ? (
                    <p className="text-sm text-amber-600">
                      Este cliente no tiene destinos DIR3 configurados. Añádelos en su ficha
                      (Clientes → detalle → Facturación FACe) antes de facturar por FACe.
                    </p>
                  ) : (
                    <div className="space-y-3">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Destino (concejalía / unidad)</label>
                        <select
                          value={faceDestinoId}
                          onChange={(e) => setFaceDestinoId(e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary"
                          data-testid="face-destino-select"
                        >
                          {(cliente.face_destinos || []).map((d) => (
                            <option key={d.id} value={d.id}>
                              {(d.nombre_interno || d.nombre || 'Destino')} — OP {d.organo_proponente || '—'} (UT {d.unidad_tramitadora || '?'})
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">Nº pedido</label>
                          <input value={faceNumPedido} onChange={(e) => setFaceNumPedido(e.target.value)} placeholder="opcional" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">Nº expediente</label>
                          <input value={faceNumExpediente} onChange={(e) => setFaceNumExpediente(e.target.value)} placeholder="opcional" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">Nº contrato</label>
                          <input value={faceNumContrato} onChange={(e) => setFaceNumContrato(e.target.value)} placeholder="opcional" className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
                        </div>
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-600 mb-1">Observación FACe (opcional)</label>
                        <input
                          value={faceObservaciones}
                          onChange={(e) => setFaceObservaciones(e.target.value)}
                          placeholder="Texto libre, ej: CENA DE NAVIDAD 2025"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                          data-testid="face-observaciones"
                        />
                      </div>
                      <div className="flex justify-end">
                        <button
                          type="button"
                          onClick={verFacePreviewBorrador}
                          disabled={facePreviewLoading}
                          data-testid="face-preview-borrador-btn"
                          className="px-4 py-2 bg-white border border-duetto-primary text-duetto-primary rounded-lg hover:bg-green-50 text-sm font-medium disabled:opacity-50"
                          title="Ver cómo quedará el Facturae antes de generar la factura"
                        >
                          {facePreviewLoading ? 'Generando…' : 'Vista previa FACe'}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
              </>)}

              {/* Ocultar datos de pago */}
              <div className="border border-gray-200 rounded-lg p-3 bg-gray-50">
                <label className="flex items-start gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={ocultarDatosPago}
                    onChange={(e) => setOcultarDatosPago(e.target.checked)}
                    data-testid="ocultar-datos-pago-checkbox"
                    className="mt-1 w-4 h-4 text-duetto-primary rounded focus:ring-2 focus:ring-duetto-primary"
                  />
                  <div className="text-sm">
                    <div className="font-medium text-gray-800">Ocultar datos de pago en el PDF</div>
                    <div className="text-xs text-gray-500 mt-0.5">
                      Genera la factura sin la sección de cuenta bancaria. Útil cuando el cliente paga por otra vía o ya tiene los datos.
                    </div>
                  </div>
                </label>
              </div>

              {/* Opciones de envío por email (solo si se selecciona enviar) */}
              {accionFactura === 'enviar' && (
                <div className="space-y-4 border-t border-gray-200 pt-4">
                  {/* Cuenta de origen */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Enviar desde *
                    </label>
                    <select
                      value={emailOrigen}
                      onChange={(e) => {
                        const email = e.target.value;
                        setEmailOrigen(email);
                        // Seleccionar firma automáticamente según el remitente
                        if (email === 'administracion@duettocatering.com') {
                          setFirmaSeleccionada('administracion');
                        } else {
                          setFirmaSeleccionada('alfonso');
                        }
                      }}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                    >
                      <option value="administracion@duettocatering.com">
                        administracion@duettocatering.com
                      </option>
                      <option value="eventos@duettocatering.com">
                        eventos@duettocatering.com
                      </option>
                      <option value="a.palomares@duettocatering.com">
                        a.palomares@duettocatering.com
                      </option>
                    </select>
                  </div>

                  {/* Contacto destino */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Enviar a *
                    </label>
                    <div className="flex gap-2">
                      <select
                        value={contactoDestinoId}
                        onChange={(e) => setContactoDestinoId(e.target.value)}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                      >
                        <option value="">Selecciona un contacto...</option>
                        {cliente && (
                          <option value="principal">
                            {cliente.nombre_contacto || cliente.persona_contacto || cliente.nombre_empresa || cliente.nombre || 'Contacto principal'} (principal) - {cliente.email || 'sin email — añádelo en la ficha del cliente'}
                          </option>
                        )}
                        {personasContacto.map((contacto) => (
                          <option key={contacto.id} value={contacto.id}>
                            {contacto.nombre} - {contacto.email}
                          </option>
                        ))}
                      </select>
                      <button
                        onClick={() => setShowNewContactoModal(true)}
                        className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors flex items-center gap-1"
                        title="Añadir nuevo contacto"
                      >
                        <Plus className="w-4 h-4" />
                        Nuevo
                      </button>
                    </div>
                    {personasContacto.length === 0 && (
                      <p className="text-xs text-orange-600 mt-1">
                        ⚠️ No hay contactos asociados. Añade un contacto primero.
                      </p>
                    )}
                  </div>

                  {/* CC - Emails en copia */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      CC - Copia a (opcional)
                    </label>
                    <input
                      type="text"
                      value={ccEmails}
                      onChange={(e) => setCcEmails(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                      placeholder="email1@ejemplo.com, email2@ejemplo.com"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Separa múltiples emails con comas
                    </p>
                    {/* Añadir rápido contactos de la misma empresa al CC */}
                    {personasContacto.filter((c) => c.email).length > 0 && (
                      <div className="mt-2">
                        <p className="text-xs text-gray-500 mb-1">Añadir contactos de la empresa al CC con un clic:</p>
                        <div className="flex flex-wrap gap-1.5">
                          {personasContacto.filter((c) => c.email).map((c) => {
                            const arr = ccEmails.split(',').map((s) => s.trim()).filter(Boolean);
                            const inCc = arr.includes(c.email);
                            return (
                              <button
                                key={c.id}
                                type="button"
                                onClick={() => {
                                  if (inCc) {
                                    setCcEmails(arr.filter((e) => e !== c.email).join(', '));
                                  } else {
                                    setCcEmails([...arr, c.email].join(', '));
                                  }
                                }}
                                className={`inline-flex items-center gap-1 px-2 py-1 text-xs rounded-full border transition-colors ${
                                  inCc
                                    ? 'bg-duetto-primary text-white border-duetto-primary'
                                    : 'bg-gray-50 text-gray-700 border-gray-300 hover:bg-gray-100'
                                }`}
                                title={c.email}
                              >
                                {inCc ? <X className="w-3 h-3" /> : <Plus className="w-3 h-3" />}
                                {c.nombre}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* CCO - Emails en copia oculta */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      CCO - Copia oculta (opcional)
                    </label>
                    <input
                      type="text"
                      value={ccoEmails}
                      onChange={(e) => setCcoEmails(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                      placeholder="email1@ejemplo.com, email2@ejemplo.com"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      No visible para el resto de destinatarios. Separa múltiples emails con comas
                    </p>
                  </div>

                  {/* Asunto */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Asunto *
                    </label>
                    <input
                      type="text"
                      value={asuntoEmail}
                      onChange={(e) => setAsuntoEmail(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                      placeholder="Ej: Factura #{numero_factura} - {cliente}"
                    />
                  </div>

                  {/* Mensaje */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Mensaje *
                    </label>
                    <textarea
                      value={mensajeEmail}
                      onChange={(e) => setMensajeEmail(e.target.value)}
                      rows={4}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                      placeholder="Escribe el mensaje para el cliente..."
                    />
                  </div>

                  {/* Selector de Firma */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ✍️ Firma del Email
                    </label>
                    <div className="grid grid-cols-3 gap-2">
                      {Object.entries(firmasEmail).map(([key, firma]) => (
                        <button
                          key={key}
                          onClick={() => setFirmaSeleccionada(key)}
                          className={`p-3 border-2 rounded-lg transition-all text-center ${
                            firmaSeleccionada === key
                              ? 'border-duetto-primary bg-green-50'
                              : 'border-gray-200 hover:border-gray-300'
                          }`}
                        >
                          <div className="text-sm font-medium">{firma.nombre}</div>
                        </button>
                      ))}
                    </div>
                    {firmaSeleccionada !== 'ninguna' && firmasEmail[firmaSeleccionada]?.imagen && (
                      <div className="mt-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <p className="text-xs text-gray-500 mb-2">Vista previa de la firma:</p>
                        <img
                          src={firmasEmail[firmaSeleccionada].imagen}
                          alt={`Firma ${firmasEmail[firmaSeleccionada].nombre}`}
                          className="max-h-24 object-contain"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                          }}
                        />
                        <p className="text-xs text-red-500 hidden">Imagen no disponible</p>
                      </div>
                    )}
                  </div>

                  {/* Invitación a reseña Google: opt-in por evento (solo en facturas) */}
                  {accionFactura === 'enviar' && (
                    <div className="border border-amber-200 rounded-lg p-3 bg-amber-50">
                      <label className="flex items-start gap-3 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={invitarResenaGoogle}
                          onChange={(e) => setInvitarResenaGoogle(e.target.checked)}
                          className="mt-1 w-4 h-4 text-duetto-primary rounded focus:ring-2 focus:ring-duetto-primary"
                        />
                        <div className="text-sm">
                          <div className="font-medium text-gray-800">⭐ Invitar a dejar reseña en Google</div>
                          <div className="text-xs text-gray-600 mt-0.5">
                            Añade al final del email un botón que enlaza a nuestro perfil de Google para reseñas. Actívalo solo si el evento salió bien — si hubo problemas, mejor no remover el tema.
                          </div>
                        </div>
                      </label>
                    </div>
                  )}
                </div>
              )}

              {/* Info del presupuesto */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-sm font-semibold text-blue-900">Información del Cliente</h3>
                  <button
                    onClick={() => {
                      setClienteEditData({
                        nombre_empresa: cliente?.nombre_empresa || '',
                        cif: cliente?.cif || '',
                        direccion: cliente?.direccion || '',
                        ciudad: cliente?.ciudad || '',
                        codigo_postal: cliente?.codigo_postal || '',
                        telefono: cliente?.telefono || '',
                        email: cliente?.email || ''
                      });
                      setShowEditClienteModal(true);
                    }}
                    className="text-xs text-blue-600 hover:text-blue-800 underline cursor-pointer bg-transparent border-none"
                  >
                    ✏️ Editar datos
                  </button>
                </div>
                <div className="text-sm text-blue-800 space-y-1">
                  <p><strong>Cliente:</strong> {cliente?.nombre_empresa || 'N/A'}</p>
                  <p><strong>CIF/NIF:</strong> {cliente?.cif || cliente?.nif || 'Sin CIF'}</p>
                  <p><strong>Dirección:</strong> {cliente?.direccion || 'Sin dirección'}</p>
                  {jornadaFacturaSel ? (() => {
                    // Lo que saldrá la factura de la jornada (servidor), no `jornadas[].total`
                    const fj = facturacionDeJornada(jornadaFacturaSel.id);
                    return (
                      <>
                        <p><strong>Jornada:</strong> {fechaDocumento(jornadaFacturaSel.fecha)}{jornadaFacturaSel.num_personas ? ` · ${jornadaFacturaSel.num_personas} pax` : ''}</p>
                        <p data-testid="total-previsto-jornada"><strong>Total con IVA:</strong> {fj ? new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(fj.total_previsto || 0) : 'calculando...'}</p>
                        {fj?.incluye_suplementos_raiz && (
                          <p className="text-xs">Incluye los suplementos del evento y el alquiler (van en la primera factura que se emite).</p>
                        )}
                      </>
                    );
                  })() : (
                    <>
                      <p><strong>Base imponible:</strong> {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(basePresupuesto())}</p>
                      <p><strong>IVA:</strong> {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(ivaPresupuesto())}</p>
                      <p><strong>Total:</strong> {new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(totalPresupuesto())}</p>
                    </>
                  )}
                </div>
              </div>

              {/* VeriFactu desactivado */}
            </div>

            {/* Botones */}
            <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-200 max-md:sticky max-md:bottom-0 max-md:bg-white max-md:flex-wrap max-md:px-4 max-md:pb-[calc(env(safe-area-inset-bottom)+1rem)] max-md:[&_button]:min-h-[44px]">
              <button
                onClick={cerrarModalFactura}
                className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cerrar
              </button>
              
              {(presupuesto?.es_multi_evento && presupuesto?.facturacion_multi_evento === 'por_jornada' && !jornadaFacturaSel && !documentoEnvioSel
                && !(facturaRectificarSel && tipoFactura.startsWith('R'))) ? (
                <div className="text-sm text-gray-600 self-center max-w-md text-right">
                  Este presupuesto se factura <strong>por jornada</strong>. Cierra este diálogo y usa el botón <strong>Emitir factura</strong> de cada jornada en la sección "Facturación por jornada".
                </div>
              ) : accionFactura === 'descargar' ? (
                <button
                  onClick={handleDescargarFactura}
                  data-testid="generar-descargar-btn"
                  className="px-6 py-2 bg-duetto-primary text-white rounded-lg hover:bg-opacity-90 transition-colors flex items-center gap-2"
                >
                  <FileText className="w-4 h-4" />
                  {(() => {
                    if (documentoEnvioSel) return `Descargar ${documentoEnvioSel.numero_factura || documentoEnvioSel.numero_proforma || 'documento'}`;
                    if (jornadaFacturaSel) return 'Emitir y Descargar Factura';
                    if (tipoFactura === 'PROFORMA' && proformaExistente) return 'Regenerar y Descargar Proforma';
                    if (tipoFactura === 'F1' && facturaNormalExistente) return 'Descargar Factura';
                    if (tipoFactura === 'PROFORMA') return 'Generar Proforma';
                    if (tipoFactura === 'F2') return 'Generar Factura Simplificada';
                    if (tipoFactura === 'F1') return 'Generar Factura';
                    return 'Generar Rectificativa';
                  })()}
                </button>
              ) : (
                <button
                  onClick={handleEnviarFactura}
                  data-testid="generar-enviar-btn"
                  className="px-6 py-2 bg-duetto-primary text-white rounded-lg hover:bg-opacity-90 transition-colors flex items-center gap-2"
                >
                  <Send className="w-4 h-4" />
                  {(() => {
                    if (documentoEnvioSel) return `Enviar ${documentoEnvioSel.numero_factura || documentoEnvioSel.numero_proforma || 'documento'}`;
                    if (jornadaFacturaSel) return 'Emitir y Enviar Factura';
                    if (tipoFactura === 'PROFORMA') return proformaExistente ? 'Regenerar y Enviar Proforma' : 'Generar y Enviar Proforma';
                    if (tipoFactura === 'F2') return 'Generar y Enviar Factura Simplificada';
                    if (tipoFactura === 'F1') return facturaNormalExistente ? 'Enviar Factura' : 'Generar y Enviar Factura';
                    return 'Generar y Enviar Rectificativa';
                  })()}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      
      {/* Modal Editar Cliente */}
      {showEditClienteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">✏️ Editar Datos del Cliente</h2>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nombre de la Empresa *</label>
                  <input
                    type="text"
                    value={clienteEditData.nombre_empresa || ''}
                    onChange={(e) => setClienteEditData({...clienteEditData, nombre_empresa: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">CIF/NIF *</label>
                  <input
                    type="text"
                    value={clienteEditData.cif || ''}
                    onChange={(e) => setClienteEditData({...clienteEditData, cif: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary"
                    placeholder="A12345678"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Dirección</label>
                  <input
                    type="text"
                    value={clienteEditData.direccion || ''}
                    onChange={(e) => setClienteEditData({...clienteEditData, direccion: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary"
                    placeholder="Calle, número, etc."
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Ciudad</label>
                    <input
                      type="text"
                      value={clienteEditData.ciudad || ''}
                      onChange={(e) => setClienteEditData({...clienteEditData, ciudad: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Código Postal</label>
                    <input
                      type="text"
                      value={clienteEditData.codigo_postal || ''}
                      onChange={(e) => setClienteEditData({...clienteEditData, codigo_postal: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
                    <input
                      type="text"
                      value={clienteEditData.telefono || ''}
                      onChange={(e) => setClienteEditData({...clienteEditData, telefono: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input
                      type="email"
                      value={clienteEditData.email || ''}
                      onChange={(e) => setClienteEditData({...clienteEditData, email: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary"
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setShowEditClienteModal(false)}
                  className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
                >
                  Cancelar
                </button>
                <button
                  onClick={handleSaveClienteEdit}
                  className="px-4 py-2 bg-duetto-primary text-white rounded-lg hover:bg-duetto-secondary"
                >
                  💾 Guardar Cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Mini para Añadir Plato */}
      {showAddPlatoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
              <h3 className="text-xl font-bold text-gray-800">Añadir Plato al Menú</h3>
              <button
                onClick={() => setShowAddPlatoModal(false)}
                className="p-2 hover:bg-gray-100 rounded-lg"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="px-6 py-4 space-y-4">
              {/* Buscador de platos */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Buscar Plato
                </label>
                <input
                  type="text"
                  value={addPlatoSearch}
                  onChange={(e) => setAddPlatoSearch(e.target.value)}
                  placeholder="Nombre del plato..."
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                />
              </div>

              {/* Input de cantidad */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Cantidad (unidades por persona)
                </label>
                <input
                  type="number"
                  value={addPlatoCantidad}
                  onChange={(e) => setAddPlatoCantidad(parseFloat(e.target.value))}
                  min="0.5"
                  step="0.5"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                />
              </div>

              {/* Filtros colapsables */}
              <div>
                <button
                  onClick={() => setAddPlatoFilters(prev => ({ ...prev, showFilters: !prev.showFilters }))}
                  className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-800"
                >
                  {addPlatoFilters.showFilters ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
                  Filtros adicionales
                </button>

                {addPlatoFilters.showFilters && (
                  <div className="mt-3 space-y-3 pl-6 border-l-2 border-gray-200">
                    {/* Filtro de alérgenos */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Sin Alérgenos
                      </label>
                      <div className="flex flex-wrap gap-2">
                        {alergenos.map(alergeno => (
                          <button
                            key={alergeno.id}
                            onClick={() => {
                              setAddPlatoFilters(prev => ({
                                ...prev,
                                alergenosEvitar: prev.alergenosEvitar.includes(alergeno.id)
                                  ? prev.alergenosEvitar.filter(a => a !== alergeno.id)
                                  : [...prev.alergenosEvitar, alergeno.id]
                              }));
                            }}
                            className={`px-3 py-1 rounded-full text-xs ${
                              addPlatoFilters.alergenosEvitar.includes(alergeno.id)
                                ? 'bg-red-100 text-red-700 border border-red-300'
                                : 'bg-gray-100 text-gray-600 border border-gray-300'
                            }`}
                          >
                            {alergeno.nombre}
                          </button>
                        ))}
                      </div>
                      
                      {/* Checkbox para incluir trazas */}
                      <div className="mt-2 p-2 bg-orange-50 border border-orange-200 rounded-lg">
                        <label className="flex items-center text-xs cursor-pointer">
                          <input
                            type="checkbox"
                            checked={addPlatoFilters.incluirTrazas}
                            onChange={(e) => setAddPlatoFilters(prev => ({ ...prev, incluirTrazas: e.target.checked }))}
                            className="mr-2 rounded border-orange-300 text-orange-500 focus:ring-orange-400"
                          />
                          <span className="font-medium text-orange-800">Incluir trazas</span>
                          <span className="ml-1 text-orange-600">(excluir puede contener)</span>
                        </label>
                      </div>
                    </div>

                    {/* Filtro de precio */}
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Precio mín (€)</label>
                        <input
                          type="number"
                          value={addPlatoFilters.precioMin}
                          onChange={(e) => setAddPlatoFilters(prev => ({ ...prev, precioMin: e.target.value }))}
                          placeholder="0"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">Precio máx (€)</label>
                        <input
                          type="number"
                          value={addPlatoFilters.precioMax}
                          onChange={(e) => setAddPlatoFilters(prev => ({ ...prev, precioMax: e.target.value }))}
                          placeholder="100"
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Lista de platos filtrados */}
              <div className="border-t border-gray-200 pt-4">
                <p className="text-sm font-medium text-gray-700 mb-3">Selecciona un plato:</p>
                <div className="space-y-2 max-h-64 overflow-y-auto">
                  {(() => {
                    // Get platos already in the menu to filter them out
                    const menuPers = addPlatoMenuIndex !== null && presupuesto.menus_personalizados 
                      ? presupuesto.menus_personalizados[addPlatoMenuIndex]
                      : null;
                    const platosYaIncluidos = menuPers?.platos_ids || [];
                    
                    return platos
                      .filter(plato => {
                        // Filtrar platos ya incluidos
                        if (platosYaIncluidos.includes(plato.id)) {
                          return false;
                        }
                        
                        // Filtro por búsqueda (sin acentos)
                        if (addPlatoSearch && !normalizeText(plato.nombre).includes(normalizeText(addPlatoSearch))) {
                          return false;
                        }
                        
                        // Filtro por alérgenos (CONTIENE)
                        if (addPlatoFilters.alergenosEvitar.length > 0) {
                          const platoAlergenos = plato.alergenos_ids || plato.alergenos || [];
                          if (platoAlergenos.some(a => addPlatoFilters.alergenosEvitar.includes(a))) {
                            return false;
                          }
                          
                          // Si incluirTrazas está activo, también excluir por trazas
                          if (addPlatoFilters.incluirTrazas) {
                            const platoTrazas = plato.trazas_alergenos_ids || [];
                            if (platoTrazas.some(t => addPlatoFilters.alergenosEvitar.includes(t))) {
                              return false;
                            }
                          }
                        }
                        
                        // Filtro por precio
                        const precio = plato.coste_por_porcion || plato.coste_total || 0;
                        if (addPlatoFilters.precioMin && precio < parseFloat(addPlatoFilters.precioMin)) {
                          return false;
                        }
                        if (addPlatoFilters.precioMax && precio > parseFloat(addPlatoFilters.precioMax)) {
                          return false;
                        }
                        
                        return true;
                      })
                      .map(plato => (
                        <button
                          key={plato.id}
                          onClick={async () => {
                            try {
                              avisoTrasCambioPlato(await presupuestosAPI.addPlatoToMenu(id, addPlatoMenuIndex, {
                                plato_id: plato.id,
                                cantidad: addPlatoCantidad
                              }));
                              setShowAddPlatoModal(false);
                              await fetchData();
                            } catch (error) {
                              console.error('Error adding plato:', error);
                              alert('Error al añadir el plato');
                            }
                          }}
                          className="w-full text-left px-4 py-3 bg-gray-50 hover:bg-duetto-primary hover:bg-opacity-10 rounded-lg border border-gray-200 hover:border-duetto-primary transition"
                        >
                          <div className="flex justify-between items-start">
                            <div>
                              <p className="font-medium text-gray-800">{plato.nombre}</p>
                              <p className="text-xs text-gray-500 mt-1">
                                Coste: €{(plato.coste_por_porcion || plato.coste_total || 0).toFixed(2)}/porción
                              </p>
                            </div>
                            <div className="flex items-center gap-2">
                              <Plus className="w-4 h-4 text-green-600" />
                            </div>
                          </div>
                        </button>
                      ));
                  })()}
                </div>
              </div>
            </div>

            <div className="px-6 py-4 border-t border-gray-200 flex justify-end">
              <button
                onClick={() => setShowAddPlatoModal(false)}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Cambiar Cliente - INSERTADO AQUÍ */}
      {showCambiarClienteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full mx-4 max-h-[80vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
              <h3 className="text-xl font-bold text-gray-900">Cambiar Cliente del Presupuesto</h3>
              <button
                onClick={() => {
                  setShowCambiarClienteModal(false);
                  setClienteSearchQuery('');
                  setClienteSeleccionado(null);
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="p-6">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Cliente Actual
                </label>
                <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                  <p className="font-medium text-gray-900">
                    {presupuesto.cliente_nombre || cliente?.nombre_empresa || cliente?.nombre || 'Sin cliente'}
                  </p>
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Buscar Nuevo Cliente
                </label>
                <input
                  type="text"
                  placeholder="Escribe para buscar por nombre de empresa..."
                  value={clienteSearchQuery}
                  onChange={(e) => setClienteSearchQuery(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-duetto-primary focus:border-transparent"
                  autoFocus
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Seleccionar Cliente ({todosClientes.filter(c => {
                    const searchLower = clienteSearchQuery.toLowerCase();
                    const nombreEmpresa = (c.nombre_empresa || '').toLowerCase();
                    const nombre = (c.nombre || '').toLowerCase();
                    const cif = (c.cif || '').toLowerCase();
                    return nombreEmpresa.includes(searchLower) || nombre.includes(searchLower) || cif.includes(searchLower);
                  }).length})
                </label>
                <div className="border border-gray-200 rounded-lg max-h-96 overflow-y-auto">
                  {todosClientes.length === 0 ? (
                    <div className="p-4 text-center text-gray-500">
                      Cargando clientes...
                    </div>
                  ) : (
                    todosClientes
                      .filter(c => {
                        const searchLower = clienteSearchQuery.toLowerCase();
                        const nombreEmpresa = (c.nombre_empresa || '').toLowerCase();
                        const nombre = (c.nombre || '').toLowerCase();
                        const cif = (c.cif || '').toLowerCase();
                        return nombreEmpresa.includes(searchLower) || nombre.includes(searchLower) || cif.includes(searchLower);
                      })
                      .map(c => (
                        <button
                          key={c.id}
                          onClick={() => setClienteSeleccionado(c)}
                          className={`w-full text-left px-4 py-3 border-b border-gray-100 hover:bg-gray-50 transition-colors ${
                            clienteSeleccionado?.id === c.id ? 'bg-duetto-primary bg-opacity-10 border-l-4 border-l-duetto-primary' : ''
                          }`}
                        >
                          <div className="flex items-center justify-between">
                            <div>
                              <p className="font-medium text-gray-900">
                                {c.nombre_empresa || c.nombre || 'Sin nombre'}
                              </p>
                              {c.cif && (
                                <p className="text-sm text-gray-500">CIF: {c.cif}</p>
                              )}
                              {c.email && (
                                <p className="text-sm text-gray-500">{c.email}</p>
                              )}
                            </div>
                            {clienteSeleccionado?.id === c.id && (
                              <CheckCircle className="w-5 h-5 text-duetto-primary" />
                            )}
                          </div>
                        </button>
                      ))
                  )}
                </div>
              </div>

              {clienteSeleccionado && (
                <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                  <p className="text-sm text-green-800">
                    <strong>Cliente seleccionado:</strong> {clienteSeleccionado.nombre_empresa || clienteSeleccionado.nombre}
                  </p>
                </div>
              )}
            </div>

            <div className="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
              <button
                onClick={() => {
                  setShowCambiarClienteModal(false);
                  setClienteSearchQuery('');
                  setClienteSeleccionado(null);
                }}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  if (clienteSeleccionado) {
                    handleCambiarCliente(clienteSeleccionado.id);
                  }
                }}
                disabled={!clienteSeleccionado}
                className={`px-4 py-2 rounded-lg ${
                  clienteSeleccionado
                    ? 'bg-duetto-primary text-white hover:bg-opacity-90'
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
              >
                Cambiar Cliente
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Configuración de Minuta */}
      {showMinutaModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-7xl w-full max-h-[90vh] flex flex-col">
            {/* Header */}
            <div className="bg-white border-b px-6 py-4">
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold text-gray-900">Configurar Minuta</h3>
                <button
                  onClick={cerrarMinuta}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              <p className="text-sm text-gray-600 mt-1">
                Configura los menús y ve la vista previa en tiempo real
              </p>
              {jornadaMinuta && (
                <div className="mt-2 flex flex-wrap items-center gap-2 text-sm" data-testid="minuta-jornada">
                  <span className="px-2 py-0.5 rounded bg-purple-100 text-purple-800 font-medium">
                    Jornada {numeroJornadaMinuta}
                    {jornadaMinuta.fecha ? ` · ${new Date(jornadaMinuta.fecha).toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })}` : ''}
                    {jornadaMinuta.num_personas ? ` · ${jornadaMinuta.num_personas} personas` : ''}
                  </span>
                  <button
                    type="button"
                    onClick={() => { setShowMinutaModal(false); setJornadaPendingAction('minuta'); setShowJornadaSelector(true); }}
                    className="text-blue-600 hover:underline"
                    data-testid="minuta-cambiar-jornada"
                  >
                    Cambiar jornada
                  </button>
                </div>
              )}
            </div>

            {/* Contenido principal: 2 columnas */}
            <div className="flex-1 overflow-hidden flex">
              {/* Columna izquierda: Configuración */}
              <div className="w-1/2 border-r overflow-y-auto p-6">
                {/* Toggle de idioma */}
                <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="font-semibold text-gray-900 flex items-center gap-2">
                        🌍 Añadir inglés
                      </h4>
                      <p className="text-xs text-gray-500 mt-1">
                        {minutaConfig.mostrarIngles 
                          ? 'Español + inglés (bilingüe)' 
                          : 'Solo español'}
                      </p>
                    </div>
                    <button
                      onClick={() => setMinutaConfig({
                        ...minutaConfig,
                        mostrarIngles: !minutaConfig.mostrarIngles
                      })}
                      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                        minutaConfig.mostrarIngles ? 'bg-green-600' : 'bg-gray-300'
                      }`}
                    >
                      <span
                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                          minutaConfig.mostrarIngles ? 'translate-x-6' : 'translate-x-1'
                        }`}
                      />
                    </button>
                  </div>
                  {minutaConfig.mostrarIngles && (
                    <div className="mt-2 text-xs text-blue-700 bg-blue-100 px-2 py-1 rounded inline-block">
                      ✓ Español + English
                    </div>
                  )}
                </div>
              
              {/* Selección de Menús */}
              <div className="mb-6">
                <h4 className="font-semibold text-gray-900 mb-3">Seleccionar Menús</h4>
                {lineasMinuta.length > 0 ? (
                  <div className="space-y-4">
                    {lineasMinuta.map((menu, menuIdx) => {
                      const menuId = menu.menu_id || `menu-${menuIdx}`;
                      const isSelected = minutaConfig.menusSeleccionados.includes(menuId);
                      
                      // Si platos_ids está vacío, buscar los platos del menú del catálogo
                      let platosIds = menu.platos_ids || [];
                      if (platosIds.length === 0 && menu.menu_id) {
                        const menuCatalogo = menus.find(m => m.id === menu.menu_id);
                        if (menuCatalogo && menuCatalogo.platos) {
                          platosIds = menuCatalogo.platos.map(p => p.plato_id);
                        }
                      }
                      
                      const ordenActual = minutaConfig.ordenPlatos[menuId] || platosIds;
                      
                      return (
                        <div key={menuIdx} className="border rounded-lg p-4 bg-gray-50">
                          <label className="flex items-start gap-3 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setMinutaConfig({
                                    ...minutaConfig,
                                    menusSeleccionados: [...minutaConfig.menusSeleccionados, menuId],
                                    ordenPlatos: {
                                      ...minutaConfig.ordenPlatos,
                                      [menuId]: platosIds
                                    }
                                  });
                                } else {
                                  setMinutaConfig({
                                    ...minutaConfig,
                                    menusSeleccionados: minutaConfig.menusSeleccionados.filter(id => id !== menuId),
                                    platosOcultos: {
                                      ...minutaConfig.platosOcultos,
                                      [menuId]: undefined
                                    },
                                    ordenPlatos: {
                                      ...minutaConfig.ordenPlatos,
                                      [menuId]: undefined
                                    }
                                  });
                                }
                              }}
                              className="mt-1 w-4 h-4"
                            />
                            <div className="flex-1">
                              <div className="font-medium text-gray-900">
                                {menu.nombre_menu || menu.nombre || 'Menú sin nombre'}
                              </div>
                              <div className="text-sm text-gray-600">
                                {menu.num_personas || personasPorDefectoLinea(presupuesto)} personas • {platosIds.length} platos
                              </div>
                            </div>
                          </label>

                          {/* Mostrar platos del menú si está seleccionado */}
                          {isSelected && (
                            <div className="mt-4 pl-8 border-l-2 border-duetto-primary">
                              <div className="text-sm font-medium text-gray-700 mb-3 flex items-center gap-2">
                                <span>Platos del menú (reordena y oculta según necesites):</span>
                              </div>
                              <div className="space-y-2">
                                {ordenActual.map((platoId, platoIdx) => {
                                  const plato = platos.find(p => p.id === platoId);
                                  if (!plato) return null;
                                  
                                  const isHidden = minutaConfig.platosOcultos[menuId]?.includes(platoId);
                                  
                                  return (
                                    <div key={platoId} className="flex items-center gap-2 bg-white p-2 rounded border">
                                      {/* Botones de reordenar */}
                                      <div className="flex flex-col gap-1">
                                        <button
                                          onClick={() => {
                                            if (platoIdx === 0) return;
                                            const newOrden = [...ordenActual];
                                            [newOrden[platoIdx - 1], newOrden[platoIdx]] = [newOrden[platoIdx], newOrden[platoIdx - 1]];
                                            setMinutaConfig({
                                              ...minutaConfig,
                                              ordenPlatos: {
                                                ...minutaConfig.ordenPlatos,
                                                [menuId]: newOrden
                                              }
                                            });
                                          }}
                                          disabled={platoIdx === 0}
                                          className="p-1 hover:bg-gray-100 rounded disabled:opacity-30 disabled:cursor-not-allowed"
                                          title="Subir"
                                        >
                                          <ArrowUp className="w-3 h-3" />
                                        </button>
                                        <button
                                          onClick={() => {
                                            if (platoIdx === ordenActual.length - 1) return;
                                            const newOrden = [...ordenActual];
                                            [newOrden[platoIdx], newOrden[platoIdx + 1]] = [newOrden[platoIdx + 1], newOrden[platoIdx]];
                                            setMinutaConfig({
                                              ...minutaConfig,
                                              ordenPlatos: {
                                                ...minutaConfig.ordenPlatos,
                                                [menuId]: newOrden
                                              }
                                            });
                                          }}
                                          disabled={platoIdx === ordenActual.length - 1}
                                          className="p-1 hover:bg-gray-100 rounded disabled:opacity-30 disabled:cursor-not-allowed"
                                          title="Bajar"
                                        >
                                          <ArrowDown className="w-3 h-3" />
                                        </button>
                                      </div>
                                      
                                      {/* Número de orden */}
                                      <span className="text-xs font-mono text-gray-500 w-6">
                                        {platoIdx + 1}.
                                      </span>
                                      
                                      {/* Checkbox para ocultar */}
                                      <input
                                        type="checkbox"
                                        checked={isHidden}
                                        onChange={(e) => {
                                          const currentHidden = minutaConfig.platosOcultos[menuId] || [];
                                          let newHidden;
                                          
                                          if (e.target.checked) {
                                            newHidden = [...currentHidden, platoId];
                                          } else {
                                            newHidden = currentHidden.filter(id => id !== platoId);
                                          }
                                          
                                          setMinutaConfig({
                                            ...minutaConfig,
                                            platosOcultos: {
                                              ...minutaConfig.platosOcultos,
                                              [menuId]: newHidden
                                            }
                                          });
                                        }}
                                        title="Marcar para ocultar"
                                        className="w-4 h-4"
                                      />
                                      
                                      {/* Nombre del plato */}
                                      <span className={`flex-1 text-sm ${isHidden ? 'line-through text-gray-400' : 'text-gray-700'}`}>
                                        {plato.nombre}
                                      </span>
                                      
                                      {isHidden && (
                                        <span className="text-xs text-red-600 bg-red-50 px-2 py-1 rounded">
                                          Oculto
                                        </span>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p className="text-sm text-gray-500 italic">No hay menús en este presupuesto</p>
                )}
              </div>
            </div>

            {/* Columna derecha: Vista Previa */}
            <div className="w-1/2 bg-gray-100 flex flex-col p-6">
              <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <FileText className="w-4 h-4" />
                Vista Previa (A4 Horizontal - 297mm x 210mm)
                {loadingPreview && <span className="text-xs text-gray-500 ml-2">Cargando...</span>}
              </h4>
              
              {/* Contenedor A4 con altura fija */}
              <div className="bg-white rounded-lg shadow-lg border border-gray-300 overflow-hidden flex-1" style={{
                width: '100%',
                minHeight: '400px',
                maxHeight: '550px'
              }}>
                {minutaConfig.menusSeleccionados.length === 0 ? (
                  <div className="flex items-center justify-center h-full text-gray-400">
                    <div className="text-center">
                      <MenuIcon className="w-12 h-12 mx-auto mb-3 opacity-30" />
                      <p className="text-sm">Selecciona menús para ver la vista previa</p>
                    </div>
                  </div>
                ) : minutaPreviewHtml ? (
                  <iframe
                    srcDoc={minutaPreviewHtml}
                    className="w-full h-full border-0"
                    title="Vista previa minuta"
                    style={{ 
                      transform: 'scale(0.5)',
                      transformOrigin: 'top left',
                      width: '200%',
                      height: '200%'
                    }}
                  />
                ) : (
                  <div className="flex items-center justify-center h-full text-gray-400">
                    <div className="text-center">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600 mx-auto mb-3"></div>
                      <p className="text-sm">Generando vista previa...</p>
                    </div>
                  </div>
                )}
              </div>
              
              {minutaConfig.menusSeleccionados.length > 1 && (
                <p className="text-xs text-gray-500 mt-2 text-center">
                  📄 Se generarán {minutaConfig.menusSeleccionados.length} páginas (una por menú)
                </p>
              )}
            </div>
          </div>

          {/* Footer con botones */}
          <div className="bg-white border-t px-6 py-4">
            <div className="flex justify-end gap-3">
              <button
                onClick={cerrarMinuta}
                className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
              >
                Cancelar
              </button>
              
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (minutaConfig.menusSeleccionados.length === 0) {
                    alert('⚠️ Selecciona al menos un menú');
                    return;
                  }
                  handleGenerarMinuta();
                }}
                disabled={minutaConfig.menusSeleccionados.length === 0}
                className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-all font-medium ${
                  minutaConfig.menusSeleccionados.length === 0
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-duetto-terracotta text-white hover:bg-orange-600 shadow-lg'
                }`}
              >
                <FileText className="w-4 h-4" />
                Descargar PDF ({minutaConfig.menusSeleccionados.length})
              </button>
            </div>
          </div>
        </div>
      </div>
      )}
      {/* Modal de vista previa FACe (Facturae) */}
      {facePreview && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={() => setFacePreview(null)}>
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between p-4 border-b">
              <h3 className="text-lg font-bold text-gray-900">Vista previa FACe — {facePreview.resumen?.numero_factura}</h3>
              <button onClick={() => setFacePreview(null)} className="text-gray-400 hover:text-gray-700"><X className="w-5 h-5" /></button>
            </div>
            <div className="p-5 overflow-y-auto space-y-4">
              {(facePreview.resumen?.avisos || []).length > 0 && (
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-sm text-amber-700">
                  <div className="font-semibold mb-1">Revisar antes de firmar:</div>
                  <ul className="list-disc ml-5">
                    {facePreview.resumen.avisos.map((a, i) => <li key={i}>{a}</li>)}
                  </ul>
                </div>
              )}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
                <div><span className="text-gray-500">Emisor:</span> {facePreview.resumen?.emisor?.razon_social} ({facePreview.resumen?.emisor?.cif})</div>
                <div><span className="text-gray-500">Cliente:</span> {facePreview.resumen?.cliente?.nombre} ({facePreview.resumen?.cliente?.cif})</div>
                <div className="md:col-span-2"><span className="text-gray-500">Destino DIR3:</span> {facePreview.resumen?.destino?.nombre} — OC {facePreview.resumen?.destino?.oficina_contable} · OG {facePreview.resumen?.destino?.organo_gestor} · UT {facePreview.resumen?.destino?.unidad_tramitadora}{facePreview.resumen?.destino?.organo_proponente ? ` · OP ${facePreview.resumen.destino.organo_proponente}` : ''}</div>
                {(facePreview.resumen?.referencias?.pedido || facePreview.resumen?.referencias?.expediente || facePreview.resumen?.referencias?.contrato) && (
                  <div className="md:col-span-2"><span className="text-gray-500">Referencias:</span> {[facePreview.resumen.referencias.pedido && `Pedido ${facePreview.resumen.referencias.pedido}`, facePreview.resumen.referencias.expediente && `Expediente ${facePreview.resumen.referencias.expediente}`, facePreview.resumen.referencias.contrato && `Contrato ${facePreview.resumen.referencias.contrato}`].filter(Boolean).join(' · ')}</div>
                )}
                {facePreview.resumen?.observacion && <div className="md:col-span-2"><span className="text-gray-500">Observación FACe:</span> {facePreview.resumen.observacion}</div>}
              </div>
              <div>
                <div className="text-sm font-semibold text-gray-700 mb-1">Líneas</div>
                <table className="w-full text-xs border">
                  <thead><tr className="bg-gray-50 text-left"><th className="p-1">Concepto</th><th className="p-1">Uds</th><th className="p-1">Base</th><th className="p-1">IVA</th><th className="p-1">Cuota</th></tr></thead>
                  <tbody>
                    {(facePreview.resumen?.lineas || []).map((l, i) => (
                      <tr key={i} className="border-t"><td className="p-1">{l.concepto}</td><td className="p-1">{numeroEs(l.unidades, 2)}</td><td className="p-1">{l.base}</td><td className="p-1">{l.tipo_iva}%</td><td className="p-1">{l.cuota}</td></tr>
                    ))}
                  </tbody>
                </table>
                <div className="text-sm text-right mt-2">
                  Base {facePreview.resumen?.base_imponible_total} · IVA {facePreview.resumen?.cuota_total} · <strong>Total {facePreview.resumen?.importe_total} €</strong>
                </div>
              </div>
              <details>
                <summary className="text-sm font-semibold text-gray-700 cursor-pointer">Ver XML Facturae</summary>
                <pre className="mt-2 p-3 bg-gray-900 text-green-200 text-[11px] rounded-lg overflow-x-auto max-h-72 whitespace-pre">{facePreview.xml}</pre>
              </details>
            </div>
            <div className="p-3 border-t text-xs text-gray-500">
              La firma (AutoFirma) y el envío a FACe vienen en el siguiente paso. Esta vista es para revisar antes de firmar.
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Componente Modal de Adaptaciones
const AdaptacionModal = ({ menu, platos, alergenos, adaptaciones, onClose, onSave }) => {
  // Las adaptaciones ya vienen filtradas para este menú desde el componente padre
  // No es necesario volver a filtrar - usar directamente
  const menuId = menu.id || menu.menu_id;
  
  // DEBUG: Log para verificar los datos del menú
  React.useEffect(() => {
    if (menu?.menu_data?.platos) {
      menu.menu_data.platos.forEach(p => {
      });
    }
  }, []);
  
  const [localAdaptaciones, setLocalAdaptaciones] = useState(
    // Usar directamente las adaptaciones recibidas (ya vienen filtradas)
    adaptaciones || []
  );
  
  // NO sincronizar automáticamente - esto puede causar que se pierdan cambios del usuario
  // Las adaptaciones se cargan una sola vez al abrir el modal
  
  const [recomendaciones, setRecomendaciones] = useState({});
  const [loadingRecomendaciones, setLoadingRecomendaciones] = useState({});
  const [ingredientes, setIngredientes] = useState([]);  // Para cargar datos de ingredientes
  const [loadingIngredientes, setLoadingIngredientes] = useState(true);
  
  // Estado para autocompletado de ingredientes sustitutos
  const [ingredienteSearch, setIngredienteSearch] = useState({});  // {platoId_ingId: "búsqueda"}
  const [ingredienteSuggestions, setIngredienteSuggestions] = useState({});  // {platoId_ingId: [{...}]}
  const [showSuggestions, setShowSuggestions] = useState({});  // {platoId_ingId: true/false}
  
  // Estado para autocompletado de platos sustitutos (sustituir plato completo)
  const [platoSearch, setPlatoSearch] = useState({});  // {platoId: "búsqueda"}
  const [platoSuggestions, setPlatoSuggestions] = useState({});  // {platoId: [{...}]}
  const [showPlatoSuggestions, setShowPlatoSuggestions] = useState({});  // {platoId: true/false}
  
  // Estado para tipo de modificación seleccionado (por plato)
  const [tipoModificacionSeleccionado, setTipoModificacionSeleccionado] = useState({});  // {adaptIdx_platoId: 'sustituir_completo' | 'modificar_componentes' | 'modificar_unidades'}
  
  // Estado para las unidades del plato sustituto (por defecto = cantidad original)
  const [unidadesSustituto, setUnidadesSustituto] = useState({});  // {adaptIdx_platoId: cantidad}
  
  // Estado para las unidades modificadas del plato original (para quitar o ajustar cantidad)
  const [unidadesModificadas, setUnidadesModificadas] = useState({});  // {adaptIdx_platoId: nueva_cantidad}
  
  // Estado para filtros de categorías adicionales en sustitución de platos
  const [incluirPostres, setIncluirPostres] = useState(false);
  const [incluirDesayunos, setIncluirDesayunos] = useState(false);
  const [incluirTrazasAdaptaciones, setIncluirTrazasAdaptaciones] = useState(true); // Por defecto activado para máxima seguridad
  
  // Estado para preparación separada y bandejas
  const [materiales, setMateriales] = useState([]);
  const [loadingMateriales, setLoadingMateriales] = useState(true);
  const [materialSearch, setMaterialSearch] = useState({});  // {adaptIdx: "búsqueda"}
  const [materialSuggestions, setMaterialSuggestions] = useState([]);
  
  // Estado para editar sustituciones existentes
  const [editandoSustitucion, setEditandoSustitucion] = useState({});  // {adaptIdx_platoId_ingId: true/false}
  
  // Estado para forzar edición de platos ya adaptados
  const [editandoAdaptacion, setEditandoAdaptacion] = useState({});  // {adaptIdx_platoId: true/false}

  // Mapeo de nombres de alérgenos a IDs del sistema (para normalizar comparaciones)
  const alergenoNombreToId = {
    'gluten': 'alergeno-001',
    'lacteos': 'alergeno-002',
    'lácteos': 'alergeno-002',
    'frutos secos': 'alergeno-003',
    'frutos_secos': 'alergeno-003',
    'huevo': 'alergeno-004',
    'pescado': 'alergeno-005',
    'marisco': 'alergeno-006',
    'soja': 'alergeno-007',
    'sulfitos': 'alergeno-008',
    'apio': 'alergeno-009',
    'mostaza': 'alergeno-010',
    'sesamo': 'alergeno-011',
    'granos de sésamo': 'alergeno-011',
    'moluscos': 'alergeno-013',
    'altramuces': 'alergeno-014',
    'cacahuetes': 'alergeno-cacahuetes',
    'derivado_animal': 'derivado_animal'
  };

  // Función para verificar si un ingrediente tiene alérgenos problemáticos
  const ingredienteTieneAlergeno = (ingredienteAlergenosIds, alergenosEvitarIds) => {
    if (!ingredienteAlergenosIds || !alergenosEvitarIds) return false;
    
    return ingredienteAlergenosIds.some(ingAlergId => {
      // Normalizar el ID del ingrediente
      const normalizedIngId = alergenoNombreToId[ingAlergId.toLowerCase()] || ingAlergId;
      
      return alergenosEvitarIds.some(evitarId => {
        // Comparar directamente o normalizado
        return ingAlergId === evitarId || 
               normalizedIngId === evitarId ||
               ingAlergId.toLowerCase() === evitarId.toLowerCase();
      });
    });
  };

  // Función para obtener los alérgenos problemáticos de un ingrediente (deduplicados)
  const getAlergenosProblematicos = (ingredienteAlergenosIds, alergenosEvitarIds) => {
    if (!ingredienteAlergenosIds || !alergenosEvitarIds) return [];
    
    const seen = new Set();
    return ingredienteAlergenosIds.filter(ingAlergId => {
      const normalizedIngId = alergenoNombreToId[ingAlergId.toLowerCase()] || ingAlergId;
      
      const matches = alergenosEvitarIds.some(evitarId => {
        return ingAlergId === evitarId || 
               normalizedIngId === evitarId ||
               ingAlergId.toLowerCase() === evitarId.toLowerCase();
      });
      
      if (matches) {
        // Deduplicar: si ya vimos este alérgeno normalizado, no añadir de nuevo
        if (seen.has(normalizedIngId)) return false;
        seen.add(normalizedIngId);
        return true;
      }
      return false;
    });
  };

  // Cargar ingredientes al montar el componente
  React.useEffect(() => {
    const fetchIngredientes = async () => {
      try {
        const response = await ingredientesAPI.getAll();
        setIngredientes(response.data);
      } catch (error) {
        console.error('Error loading ingredientes:', error);
      } finally {
        setLoadingIngredientes(false);
      }
    };
    fetchIngredientes();
  }, []);

  // Cargar materiales al montar el componente (para selector de bandejas)
  React.useEffect(() => {
    const fetchMateriales = async () => {
      try {
        const response = await materialesAPI.getAll();
        // Filtrar solo materiales tipo bandeja o similar
        const bandejas = (response.data || []).filter(m => 
          m.nombre?.toLowerCase().includes('bandeja') ||
          m.nombre?.toLowerCase().includes('bowl') ||
          m.nombre?.toLowerCase().includes('contenedor') ||
          m.nombre?.toLowerCase().includes('envase') ||
          m.categoria?.toLowerCase().includes('bandeja') ||
          m.tipo?.toLowerCase().includes('servicio')
        );
        setMateriales(response.data || []);  // Guardar todos por si quieren otros materiales
      } catch (error) {
        console.error('Error loading materiales:', error);
      } finally {
        setLoadingMateriales(false);
      }
    };
    fetchMateriales();
  }, []);

  // Actualizar sugerencias de platos cuando cambien los filtros de categorías
  React.useEffect(() => {
    // Actualizar todas las búsquedas activas con los nuevos filtros
    Object.keys(showPlatoSuggestions).forEach(platoId => {
      if (showPlatoSuggestions[platoId]) {
        const currentSearch = platoSearch[platoId] || '';
        // Buscar la adaptación activa para obtener los alérgenos a evitar
        localAdaptaciones.forEach((adapt, idx) => {
          const alergenosEvitar = adapt.alergenos_evitar || [];
          if (alergenosEvitar.length > 0) {
            const cantidadOriginal = getCantidadPlatoEnMenu(platoId);
            const suggestions = buscarPlatosSustitutos(currentSearch, alergenosEvitar, platoId, cantidadOriginal);
            setPlatoSuggestions(prev => ({ ...prev, [platoId]: suggestions }));
          }
        });
      }
    });
  }, [incluirPostres, incluirDesayunos]);

  // Función para buscar ingredientes sustitutos (filtrar por nombre y sin alérgenos problemáticos)
  const buscarIngredientesSustitutos = (searchTerm, alergenosEvitar, ingredienteOriginalId, cantidadOriginal) => {
    if (!searchTerm || searchTerm.length < 2) return [];
    
    const ingredienteOriginal = ingredientes.find(i => i.id === ingredienteOriginalId);
    
    // precio_unitario ya es el precio por unidad base (ej: €/g para gramos, €/ud para unidades)
    // Se calcula como: precio_paquete / unidades_por_paquete
    const precioOriginal = ingredienteOriginal?.precio_unitario || 
                          (ingredienteOriginal?.precio_paquete && ingredienteOriginal?.unidades_por_paquete 
                            ? ingredienteOriginal.precio_paquete / ingredienteOriginal.unidades_por_paquete 
                            : 0);
    const unidadOriginal = ingredienteOriginal?.unidad || 'ud';
    
    const resultados = ingredientes
      .filter(ing => {
        // Excluir el ingrediente original
        if (ing.id === ingredienteOriginalId) return false;
        
        // Buscar por nombre (case insensitive)
        const matchesSearch = ing.nombre.toLowerCase().includes(searchTerm.toLowerCase());
        if (!matchesSearch) return false;
        
        // Verificar que NO tenga los alérgenos a evitar
        const tieneAlergenoProhibido = ingredienteTieneAlergeno(ing.alergenos_ids, alergenosEvitar);
        return !tieneAlergenoProhibido;
      })
      .slice(0, 10)  // Máximo 10 sugerencias
      .map(ing => {
        // precio_unitario ya es el precio por unidad base (€/g, €/ud, etc.)
        const precioSustituto = ing.precio_unitario || 
                               (ing.precio_paquete && ing.unidades_por_paquete 
                                 ? ing.precio_paquete / ing.unidades_por_paquete 
                                 : 0);
        
        // Calcular diferencia de precio por la cantidad en la receta
        // cantidadOriginal viene en la unidad base (gramos si es por peso, unidades si es por ud)
        const cantidad = cantidadOriginal || 1;
        const diferenciaPorUnidad = precioSustituto - precioOriginal;
        
        // El precio_unitario ya está normalizado, solo multiplicamos por cantidad
        const diferenciaPrecio = diferenciaPorUnidad * cantidad;
        
        // Calcular también el porcentaje de diferencia
        const diferenciaPorcentaje = precioOriginal > 0 
          ? ((precioSustituto - precioOriginal) / precioOriginal) * 100 
          : 0;
        
        return {
          ...ing,
          precio_unitario_calc: precioSustituto,
          precio_original_calc: precioOriginal,
          diferencia_precio: diferenciaPrecio,
          diferencia_porcentaje: diferenciaPorcentaje,
          diferencia_texto: diferenciaPrecio > 0 
            ? `+${diferenciaPrecio.toFixed(2)}€`
            : diferenciaPrecio < 0 
              ? `${diferenciaPrecio.toFixed(2)}€`
              : '±0€'
        };
      })
      // Ordenar por precio (más baratos primero)
      .sort((a, b) => a.diferencia_precio - b.diferencia_precio);
    
    return resultados;
  };

  // Manejar cambio en el input de búsqueda de ingredientes
  const handleIngredienteSearchChange = (key, value, alergenosEvitar, ingredienteOriginalId, cantidadOriginal) => {
    setIngredienteSearch(prev => ({ ...prev, [key]: value }));
    
    if (value.length >= 2) {
      const suggestions = buscarIngredientesSustitutos(value, alergenosEvitar, ingredienteOriginalId, cantidadOriginal);
      setIngredienteSuggestions(prev => ({ ...prev, [key]: suggestions }));
      setShowSuggestions(prev => ({ ...prev, [key]: true }));
    } else {
      setShowSuggestions(prev => ({ ...prev, [key]: false }));
    }
  };

  // Seleccionar un ingrediente sustituto
  const handleSelectIngredienteSustituto = (adaptIndex, platoId, ingredienteOriginalId, ingredienteSustituto) => {
    handleSetSustitucionIngrediente(
      adaptIndex, 
      platoId, 
      ingredienteOriginalId, 
      `${ingredienteSustituto.nombre} (${ingredienteSustituto.diferencia_texto})`
    );
    const key = `${platoId}_${ingredienteOriginalId}`;
    setIngredienteSearch(prev => ({ ...prev, [key]: '' }));
    setShowSuggestions(prev => ({ ...prev, [key]: false }));
  };

  // Función para buscar platos sustitutos (sustituir plato completo)
  // Por defecto solo "comida", con opciones para incluir postres/desayunos
  const buscarPlatosSustitutos = (searchTerm, alergenosEvitar, platoOriginalId, cantidadOriginal = 1) => {
    const platoOriginal = platos.find(p => p.id === platoOriginalId);
    
    // IMPORTANTE: Usar coste_por_porcion (coste por ración), NO coste_total (coste del lote)
    // coste_total = coste de toda la elaboración
    // coste_por_porcion = coste por ración/unidad
    const costeUnitarioOriginal = platoOriginal?.coste_por_porcion || platoOriginal?.coste || 0;
    const costeTotalOriginal = costeUnitarioOriginal * cantidadOriginal;
    const platosIdsEnMenu = getMenuPlatosIds();
    
    // Categorías base: solo "comida" + variantes principales
    const categoriasBase = ['comida', 'entrante', 'principal', 'aperitivo', 'tapa', 'cena', 'almuerzo'];
    
    // Añadir categorías opcionales según checkboxes
    const categoriasValidas = [...categoriasBase];
    if (incluirPostres) {
      categoriasValidas.push('postre', 'postres');
    }
    if (incluirDesayunos) {
      categoriasValidas.push('desayuno', 'desayunos', 'bebida', 'cafe', 'café');
    }
    
    const resultados = platos
      .filter(plato => {
        // Excluir el plato original
        if (plato.id === platoOriginalId) return false;
        
        // Excluir platos que ya están en el menú
        if (platosIdsEnMenu.includes(plato.id)) return false;
        
        // Filtrar por categorías válidas
        const categoriaPlato = (plato.categoria || '').toLowerCase();
        const esCategoriValida = categoriasValidas.includes(categoriaPlato) || 
                        // Si no tiene categoría pero tiene coste > 0, incluirlo
                        (!categoriaPlato && (plato.coste_por_porcion > 0 || plato.coste > 0));
        if (!esCategoriValida) return false;
        
        // Si hay término de búsqueda, filtrar por nombre
        if (searchTerm && searchTerm.length >= 2) {
          const matchesSearch = plato.nombre.toLowerCase().includes(searchTerm.toLowerCase());
          if (!matchesSearch) return false;
        }
        
        // Verificar que NO tenga los alérgenos a evitar (CONTIENE)
        const alergenosDelPlato = plato.alergenos_ids || [];
        const tieneAlergenoProhibido = alergenosDelPlato.some(alergenoId => {
          const normalizedAlergenoId = alergenoNombreToId[alergenoId.toLowerCase()] || alergenoId;
          return alergenosEvitar.some(evitarId => 
            alergenoId === evitarId || 
            normalizedAlergenoId === evitarId ||
            alergenoId.toLowerCase().includes(evitarId.replace('alergeno-', '').replace('-', ''))
          );
        });
        
        if (tieneAlergenoProhibido) return false;
        
        // También verificar TRAZAS si incluirTrazasAdaptaciones está activo
        if (incluirTrazasAdaptaciones) {
          const trazasDelPlato = plato.trazas_alergenos_ids || [];
          const tieneTrazaProhibida = trazasDelPlato.some(trazaId => {
            const normalizedTrazaId = alergenoNombreToId[trazaId.toLowerCase()] || trazaId;
            return alergenosEvitar.some(evitarId => 
              trazaId === evitarId || 
              normalizedTrazaId === evitarId ||
              trazaId.toLowerCase().includes(evitarId.replace('alergeno-', '').replace('-', ''))
            );
          });
          
          if (tieneTrazaProhibida) return false;
        }
        
        return true;
      })
      .map(plato => {
        // CORREGIDO: Usar coste_por_porcion (no coste_total)
        const costeUnitarioSustituto = plato.coste_por_porcion || plato.coste || 0;
        const costeTotalSustituto = costeUnitarioSustituto * cantidadOriginal;
        const diferenciaPrecio = costeTotalSustituto - costeTotalOriginal;
        const diferenciaPorcentaje = costeTotalOriginal > 0 ? (diferenciaPrecio / costeTotalOriginal) * 100 : 0;
        
        return {
          ...plato,
          coste_unitario: costeUnitarioSustituto,
          coste_total_calculado: costeTotalSustituto,
          diferencia_precio: diferenciaPrecio,
          diferencia_porcentaje: diferenciaPorcentaje,
          diferencia_texto: diferenciaPrecio > 0 
            ? `+${diferenciaPrecio.toFixed(2)}€`
            : diferenciaPrecio < 0 
              ? `${diferenciaPrecio.toFixed(2)}€`
              : '±0€',
          ahorro: -diferenciaPrecio  // Para ordenar por rentabilidad (mayor ahorro primero)
        };
      })
      // Ordenar por rentabilidad (mayor ahorro primero, es decir, diferencia más negativa)
      .sort((a, b) => a.diferencia_precio - b.diferencia_precio)
      .slice(0, 15);  // Máximo 15 sugerencias
    
    return resultados;
  };

  // Obtener la cantidad de un plato en el menú actual
  const getCantidadPlatoEnMenu = (platoId) => {
    // Esta función devuelve la cantidad ORIGINAL del plato en el menú
    // (antes de cualquier adaptación)
    // 
    // Prioridad de búsqueda:
    // 1. cantidad en menu_data.platos (del menú del catálogo)
    // 2. cantidad en menu.platos
    // 3. Default: 1
    
    // Buscar en menu_data.platos (viene del menú del catálogo)
    const platosMenuData = menu?.menu_data?.platos || [];
    const platoEnMenuData = platosMenuData.find(p => (p.plato_id || p.id) === platoId);
    if (platoEnMenuData?.cantidad !== undefined) {
      return platoEnMenuData.cantidad;
    }
    
    // Buscar en menu.platos directamente
    const platosMenu = menu?.platos || [];
    const platoEnMenu = platosMenu.find(p => (p.plato_id || p.id) === platoId);
    if (platoEnMenu?.cantidad !== undefined) {
      return platoEnMenu.cantidad;
    }
    
    // Default
    return 1;
  };

  // Manejar cambio en el input de búsqueda de platos
  const handlePlatoSearchChange = (platoOriginalId, value, alergenosEvitar) => {
    setPlatoSearch(prev => ({ ...prev, [platoOriginalId]: value }));
    const cantidadOriginal = getCantidadPlatoEnMenu(platoOriginalId);
    
    // Mostrar sugerencias incluso con búsqueda vacía (todos los compatibles)
    const suggestions = buscarPlatosSustitutos(value, alergenosEvitar, platoOriginalId, cantidadOriginal);
    setPlatoSuggestions(prev => ({ ...prev, [platoOriginalId]: suggestions }));
    setShowPlatoSuggestions(prev => ({ ...prev, [platoOriginalId]: true }));
  };

  // Mostrar todos los platos compatibles al hacer focus
  const handlePlatoInputFocus = (platoOriginalId, alergenosEvitar) => {
    const cantidadOriginal = getCantidadPlatoEnMenu(platoOriginalId);
    const currentSearch = platoSearch[platoOriginalId] || '';
    const suggestions = buscarPlatosSustitutos(currentSearch, alergenosEvitar, platoOriginalId, cantidadOriginal);
    setPlatoSuggestions(prev => ({ ...prev, [platoOriginalId]: suggestions }));
    setShowPlatoSuggestions(prev => ({ ...prev, [platoOriginalId]: true }));
  };

  // Seleccionar un plato sustituto
  const handleSelectPlatoSustituto = (adaptIndex, platoOriginalId, platoSustituto) => {
    const cantidadOriginal = getCantidadPlatoEnMenu(platoOriginalId);
    const key = `${adaptIndex}_${platoOriginalId}`;
    
    // Guardar el sustituto con la cantidad por defecto (igual al original)
    handleSetSustituto(adaptIndex, platoOriginalId, platoSustituto.id);
    setPlatoSearch(prev => ({ ...prev, [platoOriginalId]: platoSustituto.nombre }));
    setShowPlatoSuggestions(prev => ({ ...prev, [platoOriginalId]: false }));
    
    // Inicializar las unidades con la cantidad original
    setUnidadesSustituto(prev => ({ ...prev, [key]: cantidadOriginal }));
    
    // Guardar también la cantidad en la adaptación
    const updated = [...localAdaptaciones];
    if (!updated[adaptIndex].platos_sustitutos_config) {
      updated[adaptIndex].platos_sustitutos_config = {};
    }
    updated[adaptIndex].platos_sustitutos_config[platoOriginalId] = {
      plato_sustituto_id: platoSustituto.id,
      cantidad_sustituto: cantidadOriginal,
      cantidad_original: cantidadOriginal
    };
    setLocalAdaptaciones(updated);
  };

  // Cambiar las unidades del plato sustituto
  const handleCambiarUnidadesSustituto = (adaptIndex, platoOriginalId, nuevaCantidad) => {
    const key = `${adaptIndex}_${platoOriginalId}`;
    const cantidad = parseFloat(nuevaCantidad) || 0;
    
    setUnidadesSustituto(prev => ({ ...prev, [key]: cantidad }));
    
    // Actualizar en la adaptación
    const updated = [...localAdaptaciones];
    if (!updated[adaptIndex].platos_sustitutos_config) {
      updated[adaptIndex].platos_sustitutos_config = {};
    }
    if (updated[adaptIndex].platos_sustitutos_config[platoOriginalId]) {
      updated[adaptIndex].platos_sustitutos_config[platoOriginalId].cantidad_sustituto = cantidad;
    }
    setLocalAdaptaciones(updated);
  };

  // Helper function para obtener IDs de platos del menú (maneja múltiples formatos)
  // PRIORIDAD: platos del menú personalizado > platos del menú catálogo
  const getMenuPlatosIds = () => {
    // 1. Primero intentar platos_ids del menú personalizado (platos modificados)
    if (menu?.menuPersonalizado?.platos_ids?.length > 0) {
      return menu.menuPersonalizado.platos_ids;
    }
    // 2. Luego intentar platos_ids en menu_data (ya incluye los personalizados tras el fix)
    if (menu?.menu_data?.platos_ids?.length > 0) {
      return menu.menu_data.platos_ids;
    }
    if (menu?.platos_ids?.length > 0) {
      return menu.platos_ids;
    }
    // 3. Luego intentar extraer de array de objetos 'platos' [{plato_id, cantidad}]
    if (menu?.menu_data?.platos?.length > 0) {
      return menu.menu_data.platos.map(p => p.plato_id || p.id).filter(Boolean);
    }
    if (menu?.platos?.length > 0 && typeof menu.platos[0] === 'object') {
      return menu.platos.map(p => p.plato_id || p.id).filter(Boolean);
    }
    return [];
  };

  const getRecomendacionesParaPlato = async (platoId, alergenosEvitar, tipoAdaptacion, caracteristicasEvitar = []) => {
    try {
      setLoadingRecomendaciones(prev => ({ ...prev, [platoId]: true }));
      const response = await platosAPI.getRecomendaciones(
        platoId,
        alergenosEvitar.join(','),
        tipoAdaptacion,
        30, // ±30% precio
        10, // máximo 10 recomendaciones iniciales
        caracteristicasEvitar.join(',')
      );
      
      // Filtrar platos que ya están en el menú (evitar duplicados)
      const platosIdsEnMenu = getMenuPlatosIds();
      const recomendacionesFiltradas = response.data.recomendaciones.filter(
        rec => !platosIdsEnMenu.includes(rec.plato_id)
      );
      
      setRecomendaciones(prev => ({ ...prev, [platoId]: recomendacionesFiltradas }));
    } catch (error) {
      console.error('Error getting recomendaciones:', error);
      setRecomendaciones(prev => ({ ...prev, [platoId]: [] }));
    } finally {
      setLoadingRecomendaciones(prev => ({ ...prev, [platoId]: false }));
    }
  };

  const handleAddAdaptacion = () => {
    setLocalAdaptaciones([...localAdaptaciones, {
      menu_id: menu.id,
      tipo: 'personalizado',  // Tipo genérico, los alérgenos se seleccionan con checkboxes
      num_personas: 1,
      alergenos_evitar: [],
      caracteristicas_evitar: [],  // contiene_cerdo, no_apto_embarazadas, sin_lactosa, etc.
      platos_sustitutos: {},  // Para sustituciones completas
      platos_modificados: {}  // Para modificaciones de componentes
    }]);
  };

  const handleUpdateAdaptacion = (index, field, value) => {
    const updated = [...localAdaptaciones];
    updated[index][field] = value;
    setLocalAdaptaciones(updated);
    
    // Si cambia el tipo, alérgenos o características, recargar recomendaciones
    if (field === 'tipo' || field === 'alergenos_evitar' || field === 'caracteristicas_evitar') {
      const platosIds = getMenuPlatosIds();
      platosIds.forEach(platoId => {
        getRecomendacionesParaPlato(platoId, updated[index].alergenos_evitar, updated[index].tipo, updated[index].caracteristicas_evitar || []);
      });
    }
  };

  const handleSetSustituto = (adaptIndex, platoOriginalId, platoSustitutoId) => {
    const updated = [...localAdaptaciones];
    if (!updated[adaptIndex].platos_sustitutos) {
      updated[adaptIndex].platos_sustitutos = {};
    }
    if (platoSustitutoId) {
      updated[adaptIndex].platos_sustitutos[platoOriginalId] = platoSustitutoId;
    } else {
      delete updated[adaptIndex].platos_sustitutos[platoOriginalId];
    }
    setLocalAdaptaciones(updated);
  };

  // Nuevas funciones para modificación de componentes
  const handleSetTipoModificacion = (adaptIndex, platoId, tipoModif) => {
    // Actualizar el estado de selección visual
    const key = `${adaptIndex}_${platoId}`;
    setTipoModificacionSeleccionado(prev => ({ ...prev, [key]: tipoModif }));
    
    const updated = [...localAdaptaciones];
    const adapt = updated[adaptIndex];
    const alergenosEvitar = adapt.alergenos_evitar || [];
    
    if (tipoModif === 'sustituir_completo') {
      // Limpiar modificaciones de componentes si existen
      if (updated[adaptIndex].platos_modificados?.[platoId]) {
        delete updated[adaptIndex].platos_modificados[platoId];
      }
      // Limpiar modificación de unidades
      if (updated[adaptIndex].platos_unidades_modificadas?.[platoId] !== undefined) {
        delete updated[adaptIndex].platos_unidades_modificadas[platoId];
      }
    } else if (tipoModif === 'modificar_componentes') {
      // Inicializar estructura de modificación de componentes
      if (!updated[adaptIndex].platos_modificados) {
        updated[adaptIndex].platos_modificados = {};
      }
      if (!updated[adaptIndex].platos_modificados[platoId]) {
        updated[adaptIndex].platos_modificados[platoId] = {
          tipo_modificacion: 'modificar_componentes',
          ingredientes_quitar: [],
          ingredientes_sustituir: {}, // Nuevo: {ingrediente_original_id: ingrediente_sustituto_nombre}
          instrucciones_especiales: ''
        };
      }
      // Limpiar sustitución completa si existe
      if (updated[adaptIndex].platos_sustitutos?.[platoId]) {
        delete updated[adaptIndex].platos_sustitutos[platoId];
      }
      // Limpiar modificación de unidades
      if (updated[adaptIndex].platos_unidades_modificadas?.[platoId] !== undefined) {
        delete updated[adaptIndex].platos_unidades_modificadas[platoId];
      }
    } else if (tipoModif === 'modificar_unidades') {
      // Limpiar otras modificaciones
      if (updated[adaptIndex].platos_modificados?.[platoId]) {
        delete updated[adaptIndex].platos_modificados[platoId];
      }
      if (updated[adaptIndex].platos_sustitutos?.[platoId]) {
        delete updated[adaptIndex].platos_sustitutos[platoId];
      }
      // Inicializar unidades modificadas con la cantidad actual
      if (!updated[adaptIndex].platos_unidades_modificadas) {
        updated[adaptIndex].platos_unidades_modificadas = {};
      }
      const cantidadActual = getCantidadPlatoEnMenu(platoId);
      updated[adaptIndex].platos_unidades_modificadas[platoId] = cantidadActual;
      setUnidadesModificadas(prev => ({ ...prev, [key]: cantidadActual }));
    }
    
    setLocalAdaptaciones(updated);
  };

  // Función para cambiar las unidades modificadas de un plato
  const handleCambiarUnidadesModificadas = (adaptIndex, platoId, nuevasUnidades) => {
    const key = `${adaptIndex}_${platoId}`;
    const cantidad = parseFloat(nuevasUnidades) || 0;
    
    
    setUnidadesModificadas(prev => ({ ...prev, [key]: cantidad }));
    
    const updated = [...localAdaptaciones];
    if (!updated[adaptIndex].platos_unidades_modificadas) {
      updated[adaptIndex].platos_unidades_modificadas = {};
    }
    updated[adaptIndex].platos_unidades_modificadas[platoId] = cantidad;
    setLocalAdaptaciones(updated);
  };

  const handleToggleIngredienteQuitar = (adaptIndex, platoId, ingredienteId) => {
    const updated = [...localAdaptaciones];
    
    if (!updated[adaptIndex].platos_modificados) {
      updated[adaptIndex].platos_modificados = {};
    }
    if (!updated[adaptIndex].platos_modificados[platoId]) {
      updated[adaptIndex].platos_modificados[platoId] = {
        tipo_modificacion: 'modificar_componentes',
        ingredientes_quitar: [],
        instrucciones_especiales: ''
      };
    }
    
    const ingredientesQuitar = updated[adaptIndex].platos_modificados[platoId].ingredientes_quitar || [];
    const index = ingredientesQuitar.indexOf(ingredienteId);
    
    if (index > -1) {
      ingredientesQuitar.splice(index, 1);
    } else {
      ingredientesQuitar.push(ingredienteId);
    }
    
    updated[adaptIndex].platos_modificados[platoId].ingredientes_quitar = ingredientesQuitar;
    setLocalAdaptaciones(updated);
  };

  // Nueva función para sustituir un ingrediente por otro
  const handleSetSustitucionIngrediente = (adaptIndex, platoId, ingredienteId, sustitucion) => {
    const updated = [...localAdaptaciones];
    
    if (!updated[adaptIndex].platos_modificados) {
      updated[adaptIndex].platos_modificados = {};
    }
    if (!updated[adaptIndex].platos_modificados[platoId]) {
      updated[adaptIndex].platos_modificados[platoId] = {
        tipo_modificacion: 'modificar_componentes',
        ingredientes_quitar: [],
        ingredientes_sustituir: {},
        instrucciones_especiales: ''
      };
    }
    if (!updated[adaptIndex].platos_modificados[platoId].ingredientes_sustituir) {
      updated[adaptIndex].platos_modificados[platoId].ingredientes_sustituir = {};
    }
    
    if (sustitucion) {
      updated[adaptIndex].platos_modificados[platoId].ingredientes_sustituir[ingredienteId] = sustitucion;
      // Remover de ingredientes_quitar si estaba ahí
      const quitarIdx = updated[adaptIndex].platos_modificados[platoId].ingredientes_quitar?.indexOf(ingredienteId);
      if (quitarIdx > -1) {
        updated[adaptIndex].platos_modificados[platoId].ingredientes_quitar.splice(quitarIdx, 1);
      }
    } else {
      delete updated[adaptIndex].platos_modificados[platoId].ingredientes_sustituir[ingredienteId];
    }
    
    setLocalAdaptaciones(updated);
  };

  const handleSetInstruccionesEspeciales = (adaptIndex, platoId, instrucciones) => {
    const updated = [...localAdaptaciones];
    
    if (!updated[adaptIndex].platos_modificados?.[platoId]) {
      return;
    }
    
    updated[adaptIndex].platos_modificados[platoId].instrucciones_especiales = instrucciones;
    setLocalAdaptaciones(updated);
  };

  const platosDelMenu = getMenuPlatosIds()
    .map(platoId => platos.find(p => p.id === platoId))
    .filter(p => p && !p.oculto_en_presupuestos);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 max-md:p-0">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col max-md:max-w-none max-md:h-full max-md:max-h-none max-md:rounded-none max-md:[&_input]:text-base max-md:[&_select]:text-base max-md:[&_textarea]:text-base">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <div>
            <h3 className="text-lg font-bold text-gray-900">Gestionar Adaptaciones Dietéticas</h3>
            <p className="text-sm text-gray-600">{menu.concepto}</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6 max-md:p-4 space-y-6">
          {/* Resumen de platos del menú */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-semibold text-blue-900 mb-2 flex items-center gap-2">
              <span>🍽️</span> Platos del Menú ({platosDelMenu.length})
            </h4>
            {platosDelMenu.length === 0 ? (
              <p className="text-sm text-blue-700">No hay platos configurados en este menú.</p>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                {platosDelMenu.map(plato => {
                  // Buscar alérgenos del plato
                  const alergenosDelPlato = (plato.alergenos_ids || [])
                    .map(alergId => alergenos.find(a => a.id === alergId))
                    .filter(Boolean);
                  
                  return (
                    <div key={plato.id} className="bg-white p-2 rounded border border-blue-100 text-xs">
                      <p className="font-medium text-gray-800 truncate">{plato.nombre}</p>
                      {alergenosDelPlato.length > 0 && (
                        <div className="flex flex-wrap gap-1 mt-1">
                          {alergenosDelPlato.map(alerg => (
                            <AlergenoIcon key={alerg.id} nombre={alerg.nombre} size="sm" />
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {localAdaptaciones.length === 0 ? (
            <div className="text-center py-8 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
              <AlertCircle className="w-12 h-12 text-gray-400 mx-auto mb-2" />
              <p className="text-gray-600 text-sm mb-3">Sin adaptaciones configuradas para este menú</p>
              <button
                onClick={handleAddAdaptacion}
                className="px-4 py-2 bg-duetto-primary text-white text-sm rounded-lg hover:bg-opacity-90"
              >
                + Nueva Adaptación
              </button>
            </div>
          ) : (
            <>
              {localAdaptaciones.map((adapt, idx) => (
                <div key={idx} className="bg-gray-50 rounded-lg p-4 border border-gray-200 space-y-4">
                  <div className="flex justify-between items-start">
                    <h4 className="font-semibold text-gray-900">Adaptación {idx + 1}</h4>
                    <button
                      onClick={() => setLocalAdaptaciones(localAdaptaciones.filter((_, i) => i !== idx))}
                      className="text-red-600 hover:text-red-700"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>

                  <div className="flex items-start gap-4">
                    <div>
                      <label className="block text-xs font-medium text-gray-700 mb-1">N° Personas</label>
                      <input
                        type="number"
                        min="1"
                        value={adapt.num_personas || ''}
                        onChange={(e) => {
                          const val = e.target.value === '' ? '' : (parseInt(e.target.value) || 1);
                          handleUpdateAdaptacion(idx, 'num_personas', val);
                          // Ajustar array de nombres al nuevo número de personas
                          if (val && val > 0) {
                            const nombres = [...(adapt.nombres_personas || [])];
                            while (nombres.length < val) nombres.push('');
                            handleUpdateAdaptacion(idx, 'nombres_personas', nombres.slice(0, val));
                          }
                        }}
                        onBlur={(e) => { if (e.target.value === '') handleUpdateAdaptacion(idx, 'num_personas', 1); }}
                        className="w-24 px-3 py-2 text-sm border rounded-lg"
                      />
                    </div>
                    <div className="flex-1">
                      <label className="block text-xs font-medium text-gray-700 mb-1">Observaciones</label>
                      <input
                        type="text"
                        value={adapt.observaciones || ''}
                        onChange={(e) => handleUpdateAdaptacion(idx, 'observaciones', e.target.value)}
                        placeholder="Notas sobre esta adaptación..."
                        className="w-full px-3 py-2 text-sm border rounded-lg"
                      />
                    </div>
                  </div>

                  {/* Nombres de las personas */}
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Nombres de las personas</label>
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                      {Array.from({ length: adapt.num_personas || 1 }, (_, i) => (
                        <input
                          key={i}
                          type="text"
                          value={(adapt.nombres_personas || [])[i] || ''}
                          onChange={(e) => {
                            const nombres = [...(adapt.nombres_personas || [])];
                            while (nombres.length <= i) nombres.push('');
                            nombres[i] = e.target.value;
                            handleUpdateAdaptacion(idx, 'nombres_personas', nombres);
                          }}
                          placeholder={`Persona ${i + 1}`}
                          className="px-3 py-1.5 text-sm border rounded-lg"
                        />
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-2">Alérgenos a Evitar</label>
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                      {alergenos.map(alergeno => (
                        <label 
                          key={alergeno.id} 
                          className={`flex items-center text-xs p-2 rounded-lg border cursor-pointer transition-colors ${
                            adapt.alergenos_evitar?.includes(alergeno.id)
                              ? 'bg-red-50 border-red-300 text-red-800'
                              : 'bg-white border-gray-200 hover:bg-gray-50'
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={adapt.alergenos_evitar?.includes(alergeno.id) || false}
                            onChange={(e) => {
                              const current = adapt.alergenos_evitar || [];
                              const updated = e.target.checked
                                ? [...current, alergeno.id]
                                : current.filter(id => id !== alergeno.id);
                              handleUpdateAdaptacion(idx, 'alergenos_evitar', updated);
                            }}
                            className="mr-2 accent-red-600"
                          />
                          <AlergenoIcon nombre={alergeno.nombre} size="sm" />
                          <span className="truncate ml-1">{alergeno.nombre}</span>
                        </label>
                      ))}
                    </div>
                    <p className="text-xs text-gray-500 mt-2">
                      {adapt.alergenos_evitar?.length > 0 
                        ? `${adapt.alergenos_evitar.length} alérgeno(s) seleccionado(s)`
                        : 'Selecciona los alérgenos que debe evitar esta persona'}
                    </p>
                  </div>

                  {/* Dietas: se apuntan en la pestaña Alérgenos (sin garantía). Una
                      adaptación antigua con características a evitar las enseña
                      aquí solo como texto */}
                  <div data-testid="adaptacion-dietas-info">
                    <label className="block text-xs font-medium text-gray-700 mb-1">Dietas</label>
                    {(adapt.caracteristicas_evitar || []).length > 0 ? (
                      <p className="text-xs text-gray-700">
                        {(adapt.caracteristicas_evitar || []).map(c => ({
                          contiene_carne: 'Sin carne', origen_animal: 'Sin origen animal', contiene_cerdo: 'Sin cerdo',
                          no_apto_embarazadas: 'Embarazada', sin_lactosa: 'Sin lactosa', vegetariano: 'Vegetariano',
                          vegano: 'Vegano', sin_cerdo: 'Sin cerdo', embarazada: 'Embarazada',
                        }[c] || c)).join(', ')}
                        <span className="text-gray-500"> (solo lectura)</span>
                      </p>
                    ) : null}
                    <p className="text-xs text-gray-500 mt-1">
                      Vegetariano, vegano, sin cerdo, embarazada y sin lactosa se apuntan en la pestaña Alérgenos: allí se cambia el menú y se cobra el suplemento.
                    </p>
                  </div>

                  {/* Preparación Separada */}
                  <div className="border-t border-gray-200 pt-4">
                    <label className="flex items-center gap-3 cursor-pointer group">
                      <input
                        type="checkbox"
                        checked={adapt.requiere_preparacion_separada || false}
                        onChange={(e) => handleUpdateAdaptacion(idx, 'requiere_preparacion_separada', e.target.checked)}
                        className="w-5 h-5 accent-orange-600 rounded"
                      />
                      <div>
                        <span className="text-sm font-medium text-gray-900 group-hover:text-orange-700">
                          ⚠️ Requiere preparación separada
                        </span>
                        <p className="text-xs text-gray-500">
                          Generar hoja especial con instrucciones para cocina y montaje
                        </p>
                      </div>
                    </label>
                    
                    {/* Opciones de bandeja cuando requiere preparación separada */}
                    {adapt.requiere_preparacion_separada && (
                      <div className="mt-3 ml-8 p-3 bg-orange-50 rounded-lg border border-orange-200 space-y-3">
                        <div>
                          <label className="block text-xs font-medium text-orange-800 mb-2">
                            Tipo de distribución de bandejas
                          </label>
                          <div className="flex flex-col gap-2">
                            <label className="flex items-center text-sm cursor-pointer">
                              <input
                                type="radio"
                                name={`bandeja-tipo-${idx}`}
                                checked={adapt.tipo_bandeja === 'por_plato' || !adapt.tipo_bandeja}
                                onChange={() => handleUpdateAdaptacion(idx, 'tipo_bandeja', 'por_plato')}
                                className="mr-2 accent-orange-600"
                              />
                              <span className="text-gray-700">1 bandeja por plato</span>
                              <span className="text-xs text-gray-500 ml-2">(más organizado)</span>
                            </label>
                            <label className="flex items-center text-sm cursor-pointer">
                              <input
                                type="radio"
                                name={`bandeja-tipo-${idx}`}
                                checked={adapt.tipo_bandeja === 'por_persona'}
                                onChange={() => handleUpdateAdaptacion(idx, 'tipo_bandeja', 'por_persona')}
                                className="mr-2 accent-orange-600"
                              />
                              <span className="text-gray-700">1 bandeja por persona</span>
                              <span className="text-xs text-gray-500 ml-2">(menú completo individual)</span>
                            </label>
                          </div>
                        </div>
                        
                        {/* Selector de material/bandeja */}
                        <div>
                          <label className="block text-xs font-medium text-orange-800 mb-2">
                            Material para bandejas (opcional)
                          </label>
                          <div className="relative">
                            <input
                              type="text"
                              placeholder="Buscar bandeja, bowl, contenedor..."
                              value={materialSearch[idx] || adapt.material_bandeja_nombre || ''}
                              onChange={(e) => {
                                setMaterialSearch(prev => ({ ...prev, [idx]: e.target.value }));
                                // Filtrar materiales
                                const search = e.target.value.toLowerCase();
                                const filtered = materiales.filter(m => 
                                  m.nombre?.toLowerCase().includes(search)
                                ).slice(0, 8);
                                setMaterialSuggestions(filtered);
                              }}
                              onFocus={() => {
                                const search = (materialSearch[idx] || '').toLowerCase();
                                const filtered = materiales.filter(m => 
                                  m.nombre?.toLowerCase().includes(search) ||
                                  m.nombre?.toLowerCase().includes('bandeja') ||
                                  m.nombre?.toLowerCase().includes('bowl')
                                ).slice(0, 8);
                                setMaterialSuggestions(filtered);
                              }}
                              className="w-full px-3 py-2 text-sm border border-orange-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />
                            {materialSuggestions.length > 0 && materialSearch[idx] !== undefined && (
                              <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                                {materialSuggestions.map(mat => (
                                  <button
                                    key={mat.id}
                                    onClick={() => {
                                      handleUpdateAdaptacion(idx, 'material_bandeja_id', mat.id);
                                      handleUpdateAdaptacion(idx, 'material_bandeja_nombre', mat.nombre);
                                      setMaterialSearch(prev => ({ ...prev, [idx]: mat.nombre }));
                                      setMaterialSuggestions([]);
                                    }}
                                    className="w-full text-left px-3 py-2 text-sm hover:bg-orange-50 border-b border-gray-100 last:border-0"
                                  >
                                    <span className="font-medium">{mat.nombre}</span>
                                    {mat.unidad && <span className="text-gray-500 ml-2">({mat.unidad})</span>}
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                          {adapt.material_bandeja_nombre && (
                            <p className="text-xs text-green-700 mt-1">
                              ✓ Seleccionado: {adapt.material_bandeja_nombre}
                            </p>
                          )}
                        </div>
                        
                        {/* Resumen de bandejas necesarias */}
                        {adapt.alergenos_evitar?.length > 0 && (
                          <div className="bg-white rounded p-2 border border-orange-200">
                            <p className="text-xs font-medium text-orange-800">
                              📦 Bandejas estimadas:
                            </p>
                            <p className="text-sm text-gray-700">
                              {adapt.tipo_bandeja === 'por_persona' 
                                ? `${adapt.num_personas} bandeja(s) - 1 por persona`
                                : `${(() => {
                                    // Contar platos que comen (compatibles + modificados)
                                    const platosMenu = menu.platos_ids || [];
                                    return platosMenu.length;
                                  })()} bandeja(s) máx. - 1 por plato`
                              }
                            </p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Estadísticas de platos */}
                  {(adapt.alergenos_evitar?.length > 0 || adapt.tipo) && (() => {
                    const alergenosEvitar = adapt.alergenos_evitar || [];
                    let platosCompatibles = 0;
                    let platosIncompatibles = 0;
                    let platosAdaptados = 0;
                    
                    const platosIds = getMenuPlatosIds();
                    platosIds.forEach(platoId => {
                      const plato = platos.find(p => p.id === platoId);
                      if (!plato) return;
                      
                      const contieneAlergeno = plato.alergenos_ids?.some(
                        alergId => alergenosEvitar.includes(alergId)
                      );
                      
                      if (!contieneAlergeno) {
                        platosCompatibles++;
                      } else {
                        // Verificar si el plato ha sido adaptado
                        const modificacionesPlato = adapt.platos_modificados?.[platoId];
                        const ingredientesQuitados = modificacionesPlato?.ingredientes_quitar || [];
                        const ingredientesSustituidos = Object.keys(modificacionesPlato?.ingredientes_sustituir || {});
                        const ingredientesModificados = [...ingredientesQuitados, ...ingredientesSustituidos];
                        
                        // Identificar ingredientes problemáticos
                        let ingredientesConProblema = [];
                        if (plato.ingredientes) {
                          Object.keys(plato.ingredientes).forEach(ingId => {
                            const ing = ingredientes.find(i => i.id === ingId);
                            if (ing?.alergenos_ids) {
                              const tieneAlergenoProblema = ing.alergenos_ids.some(alergenoId => {
                                const normalizedId = alergenoNombreToId[alergenoId.toLowerCase()] || alergenoId;
                                return alergenosEvitar.some(evitarId => 
                                  alergenoId === evitarId || 
                                  normalizedId === evitarId ||
                                  alergenoId.toLowerCase().includes(evitarId.replace('alergeno-', '').replace('-', ''))
                                );
                              });
                              if (tieneAlergenoProblema) {
                                ingredientesConProblema.push(ingId);
                              }
                            }
                          });
                        }
                        
                        const todosResueltos = ingredientesConProblema.length > 0 && 
                          ingredientesConProblema.every(ingId => ingredientesModificados.includes(ingId));
                        const tieneSustituto = adapt.platos_sustitutos?.[platoId];
                        
                        if (tieneSustituto || todosResueltos) {
                          platosAdaptados++;
                        } else {
                          platosIncompatibles++;
                        }
                      }
                    });

                    return (
                      <div className="grid grid-cols-3 gap-3">
                        <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                          <div className="text-xl font-bold text-green-700">{platosCompatibles}</div>
                          <div className="text-xs text-green-600">Compatibles</div>
                        </div>
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                          <div className="text-xl font-bold text-blue-700">{platosAdaptados}</div>
                          <div className="text-xs text-blue-600">Adaptados</div>
                        </div>
                        <div className="bg-orange-50 border border-orange-200 rounded-lg p-3">
                          <div className="text-xl font-bold text-orange-700">{platosIncompatibles}</div>
                          <div className="text-xs text-orange-600">Pendientes</div>
                        </div>
                      </div>
                    );
                  })()}

                  {/* Sustitutos de platos */}
                  <div>
                    <h5 className="text-sm font-semibold text-gray-800 mb-2">Análisis de Platos del Menú</h5>
                    <div className="space-y-3">
                      {getMenuPlatosIds().map(platoId => {
                        const platoOriginal = platos.find(p => p.id === platoId);
                        if (!platoOriginal) return null;

                        // Verificar si el plato contiene algún alérgeno a evitar
                        const alergenosEvitar = adapt.alergenos_evitar || [];
                        const contieneAlergeno = platoOriginal.alergenos_ids?.some(
                          alergId => alergenosEvitar.includes(alergId)
                        );

                        // Verificar características a evitar
                        const caracteristicasEvitar = adapt.caracteristicas_evitar || [];
                        const platoCaracts = platoOriginal.caracteristicas || {};
                        let contieneCaracteristicaEvitada = false;
                        let caracteristicaProblema = '';
                        
                        for (const caract of caracteristicasEvitar) {
                          if (caract === 'contiene_carne' && platoCaracts.contiene_carne) {
                            contieneCaracteristicaEvitada = true;
                            caracteristicaProblema = 'Contiene carne';
                            break;
                          }
                          if (caract === 'origen_animal' && platoCaracts.origen_animal) {
                            contieneCaracteristicaEvitada = true;
                            caracteristicaProblema = 'Origen animal';
                            break;
                          }
                          if (caract === 'contiene_cerdo' && platoCaracts.contiene_cerdo) {
                            contieneCaracteristicaEvitada = true;
                            caracteristicaProblema = 'Contiene cerdo';
                            break;
                          }
                          if (caract === 'no_apto_embarazadas' && platoCaracts.no_apto_embarazadas) {
                            contieneCaracteristicaEvitada = true;
                            caracteristicaProblema = 'No apto para embarazadas';
                            break;
                          }
                          if (caract === 'sin_lactosa' && platoCaracts.sin_lactosa === false) {
                            contieneCaracteristicaEvitada = true;
                            caracteristicaProblema = 'Contiene lactosa';
                            break;
                          }
                        }

                        // Verificar compatibilidad con tipo de adaptación
                        let esCompatibleConTipo = true;
                        let razonIncompatibilidad = caracteristicaProblema || '';
                        
                        if (adapt.tipo === 'vegano') {
                          // Verificar si algún ingrediente es de origen animal
                          const tieneOrigenAnimal = platoCaracts.origen_animal;
                          if (tieneOrigenAnimal) {
                            esCompatibleConTipo = false;
                            razonIncompatibilidad = 'Contiene ingredientes de origen animal';
                          }
                        } else if (adapt.tipo === 'vegetariano') {
                          // Verificar si contiene carne
                          const tieneCarne = platoCaracts.contiene_carne;
                          if (tieneCarne) {
                            esCompatibleConTipo = false;
                            razonIncompatibilidad = 'Contiene carne';
                          }
                        }

                        // NUEVO: Verificar si TODOS los ingredientes problemáticos han sido modificados
                        const modificacionesPlato = adapt.platos_modificados?.[platoId];
                        const ingredientesQuitados = modificacionesPlato?.ingredientes_quitar || [];
                        const ingredientesSustituidos = Object.keys(modificacionesPlato?.ingredientes_sustituir || {});
                        const ingredientesModificados = [...ingredientesQuitados, ...ingredientesSustituidos];
                        
                        // Identificar ingredientes con alérgenos problemáticos
                        let ingredientesConProblema = [];
                        if (platoOriginal.ingredientes) {
                          Object.keys(platoOriginal.ingredientes).forEach(ingId => {
                            const ing = ingredientes.find(i => i.id === ingId);
                            if (ing?.alergenos_ids) {
                              const tieneAlergenoProblema = ing.alergenos_ids.some(alergenoId => {
                                const normalizedId = alergenoNombreToId[alergenoId.toLowerCase()] || alergenoId;
                                return alergenosEvitar.some(evitarId => 
                                  alergenoId === evitarId || 
                                  normalizedId === evitarId ||
                                  alergenoId.toLowerCase().includes(evitarId.replace('alergeno-', '').replace('-', ''))
                                );
                              });
                              if (tieneAlergenoProblema) {
                                ingredientesConProblema.push(ingId);
                              }
                            }
                          });
                        }
                        
                        // Verificar si todos los ingredientes problemáticos han sido modificados
                        const todosIngredientesResueltos = ingredientesConProblema.length > 0 && 
                          ingredientesConProblema.every(ingId => ingredientesModificados.includes(ingId));
                        
                        // El plato está "adaptado" si:
                        // 1. Tiene un plato sustituto seleccionado, O
                        // 2. Todos sus ingredientes problemáticos han sido quitados/sustituidos
                        const platoSustitutoId = adapt.platos_sustitutos?.[platoId];
                        const estaAdaptado = platoSustitutoId || todosIngredientesResueltos;
                        
                        // Estado para forzar modo edición de platos adaptados
                        const seleccionKey = `${idx}_${platoId}`;
                        const forzarEdicion = editandoAdaptacion?.[seleccionKey] === true;
                        
                        const necesitaSustitucion = (contieneAlergeno || contieneCaracteristicaEvitada || !esCompatibleConTipo) && (!estaAdaptado || forzarEdicion);
                        const recsParaPlato = recomendaciones[platoId] || [];

                        // Plato compatible O ya adaptado - mostrar en verde
                        if (!necesitaSustitucion) {
                          const cantidadActual = getCantidadPlatoEnMenu(platoId);
                          const unidadesKey = `${idx}_${platoId}`;
                          const nuevaCantidad = unidadesModificadas[unidadesKey] !== undefined 
                            ? unidadesModificadas[unidadesKey] 
                            : (adapt.platos_unidades_modificadas?.[platoId] !== undefined 
                              ? adapt.platos_unidades_modificadas[platoId] 
                              : cantidadActual);
                          const tieneModificacion = nuevaCantidad !== cantidadActual;
                          const fueAdaptado = estaAdaptado && (contieneAlergeno || contieneCaracteristicaEvitada || !esCompatibleConTipo);
                          
                          // Obtener información sobre el tipo de adaptación realizada
                          const tieneplatoSustituto = adapt.platos_sustitutos?.[platoId];
                          const tieneModificacionComponentes = adapt.platos_modificados?.[platoId];
                          const platoSustitutoNombre = tieneplatoSustituto ? 
                            platos.find(p => p.id === tieneplatoSustituto)?.nombre : null;
                          
                          return (
                            <div key={platoId} className={`p-3 rounded border ${tieneModificacion ? 'bg-blue-50 border-blue-200' : 'bg-green-50 border-green-200'}`}>
                              <div className="flex items-center gap-2">
                                <span className={`font-bold ${tieneModificacion ? 'text-blue-600' : 'text-green-600'}`}>
                                  {tieneModificacion ? '📦' : '✓'}
                                </span>
                                <div className="flex-1">
                                  <span className="text-sm font-medium text-gray-900">{platoOriginal.nombre}</span>
                                  {fueAdaptado && (
                                    <span className="ml-2 px-1.5 py-0.5 bg-green-200 text-green-800 rounded text-xs font-medium">
                                      ✓ Adaptado
                                    </span>
                                  )}
                                </div>
                                {/* Botón para editar adaptación si fue adaptado */}
                                {fueAdaptado && (
                                  <button
                                    onClick={() => setEditandoAdaptacion(prev => ({ ...prev, [unidadesKey]: true }))}
                                    className="px-2 py-1 text-xs text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded border border-blue-200"
                                  >
                                    ✏️ Cambiar
                                  </button>
                                )}
                                {/* Input de unidades directamente en la fila */}
                                <div className="flex items-center gap-1.5">
                                  <input
                                    type="number"
                                    min="0"
                                    step="0.5"
                                    value={nuevaCantidad}
                                    onChange={(e) => handleCambiarUnidadesModificadas(idx, platoId, e.target.value)}
                                    className={`w-14 px-1.5 py-1 text-sm border-2 rounded text-center font-medium focus:outline-none ${
                                      tieneModificacion 
                                        ? 'border-blue-400 bg-white focus:border-blue-500' 
                                        : 'border-gray-300 bg-white focus:border-blue-400'
                                    }`}
                                  />
                                  <span className="text-xs text-gray-500">ud</span>
                                </div>
                              </div>
                              
                              {/* Mostrar detalle de la adaptación realizada */}
                              {fueAdaptado && (
                                <div className="mt-2 ml-6 p-2 bg-green-100 rounded text-xs">
                                  {tieneplatoSustituto && platoSustitutoNombre && (
                                    <p className="text-green-800">
                                      🔄 Sustituido por: <strong>{platoSustitutoNombre}</strong>
                                    </p>
                                  )}
                                  {tieneModificacionComponentes && (
                                    <>
                                      {tieneModificacionComponentes.ingredientes_quitar?.length > 0 && (
                                        <p className="text-green-800">
                                          ❌ Sin: {tieneModificacionComponentes.ingredientes_quitar.map(ingId => {
                                            const ing = ingredientes.find(i => i.id === ingId);
                                            return ing?.nombre || ingId;
                                          }).join(', ')}
                                        </p>
                                      )}
                                      {Object.keys(tieneModificacionComponentes.ingredientes_sustituir || {}).length > 0 && (
                                        <p className="text-green-800">
                                          🔄 Sustituciones: {Object.entries(tieneModificacionComponentes.ingredientes_sustituir).map(([ingId, sust]) => {
                                            const ingOriginal = ingredientes.find(i => i.id === ingId);
                                            return `${ingOriginal?.nombre || ingId} → ${sust}`;
                                          }).join(', ')}
                                        </p>
                                      )}
                                    </>
                                  )}
                                </div>
                              )}
                              
                              {tieneModificacion && !fueAdaptado && (
                                <p className="text-xs text-blue-700 mt-1 ml-6">
                                  {nuevaCantidad === 0 
                                    ? '❌ Se eliminará de esta adaptación' 
                                    : `Modificado: ${cantidadActual} → ${nuevaCantidad} ud(s)`}
                                </p>
                              )}
                              {!tieneModificacion && !fueAdaptado && (
                                <p className="text-xs text-green-700 mt-1 ml-6">
                                  Compatible - No requiere sustitución
                                </p>
                              )}
                            </div>
                          );
                        }

                        // Plato que necesita sustitución o modificación
                        // Prioridad: 1) estado de selección UI, 2) tiene modificaciones de componentes, 3) tiene sustituto
                        // seleccionKey ya está definido arriba
                        const tipoModifActual = tipoModificacionSeleccionado[seleccionKey] ||
                                               (adapt.platos_modificados?.[platoId] ? 'modificar_componentes' : 
                                               (platoSustitutoId ? 'sustituir_completo' : null));
                        
                        // Obtener cantidad actual y modificada
                        const cantidadActual = getCantidadPlatoEnMenu(platoId);
                        const nuevaCantidad = unidadesModificadas[seleccionKey] !== undefined 
                          ? unidadesModificadas[seleccionKey] 
                          : (adapt.platos_unidades_modificadas?.[platoId] !== undefined 
                            ? adapt.platos_unidades_modificadas[platoId] 
                            : cantidadActual);
                        const tieneModificacionUnidades = nuevaCantidad !== cantidadActual;
                        const platoEliminado = nuevaCantidad === 0;
                        
                        return (
                          <div key={platoId} className={`p-3 rounded border ${
                            platoEliminado 
                              ? 'bg-gray-100 border-gray-300 opacity-75' 
                              : 'bg-orange-50 border-orange-200'
                          }`}>
                            <div className="flex justify-between items-start mb-2">
                              <div className="flex-1">
                                <div className="flex items-center gap-2 max-md:flex-wrap">
                                  <span className={`font-bold ${platoEliminado ? 'text-gray-500' : 'text-orange-600'}`}>
                                    {platoEliminado ? '🚫' : '⚠'}
                                  </span>
                                  <span className={`text-sm font-medium ${platoEliminado ? 'text-gray-500 line-through' : 'text-gray-900'}`}>
                                    {platoOriginal.nombre}
                                  </span>
                                  {/* Input de unidades directamente en la fila */}
                                  <div className="flex items-center gap-1.5 ml-auto">
                                    <input
                                      type="number"
                                      min="0"
                                      step="0.5"
                                      value={nuevaCantidad}
                                      onChange={(e) => handleCambiarUnidadesModificadas(idx, platoId, e.target.value)}
                                      className={`w-14 px-1.5 py-1 text-sm border-2 rounded text-center font-medium focus:outline-none ${
                                        platoEliminado
                                          ? 'border-gray-400 bg-gray-50 text-gray-600 focus:border-gray-500'
                                          : tieneModificacionUnidades 
                                            ? 'border-blue-400 bg-white focus:border-blue-500' 
                                            : 'border-gray-300 bg-white focus:border-blue-400'
                                      }`}
                                    />
                                    <span className="text-xs text-gray-500">ud</span>
                                  </div>
                                </div>
                                <p className={`text-xs mt-1 ml-5 ${platoEliminado ? 'text-gray-500' : 'text-orange-700'}`}>
                                  {contieneAlergeno && 'Contiene alérgenos a evitar'}
                                  {contieneCaracteristicaEvitada && !contieneAlergeno && caracteristicaProblema}
                                  {!esCompatibleConTipo && !contieneAlergeno && !contieneCaracteristicaEvitada && razonIncompatibilidad}
                                </p>
                                {tieneModificacionUnidades && (
                                  <p className={`text-xs mt-1 ml-5 ${platoEliminado ? 'text-gray-600 font-medium' : 'text-blue-700'}`}>
                                    {nuevaCantidad === 0 
                                      ? '🚫 ELIMINADO - Este plato no se servirá a esta adaptación' 
                                      : `📦 Cantidad modificada: ${cantidadActual} → ${nuevaCantidad} ud(s)`}
                                  </p>
                                )}
                                {contieneAlergeno && !platoEliminado && (
                                  <div className="flex flex-wrap gap-1 mt-2 ml-5">
                                    {platoOriginal.alergenos_ids
                                      ?.filter(alergId => alergenosEvitar.includes(alergId))
                                      .map(alergId => {
                                        const alerg = alergenos.find(a => a.id === alergId);
                                        return alerg ? (
                                          <span key={alergId} className="px-2 py-0.5 bg-red-100 text-red-700 text-xs rounded-full">
                                            {alerg.icono} {alerg.nombre}
                                          </span>
                                        ) : null;
                                      })}
                                  </div>
                                )}
                              </div>
                            </div>
                            
                            {/* Solo mostrar opciones si no se ha eliminado el plato (cantidad > 0) */}
                            {nuevaCantidad > 0 && (
                            <>
                            {/* SECCIÓN: Selector de tipo de modificación (solo 2 opciones) */}
                            <div className="ml-5 mt-3 mb-3 bg-white rounded-lg p-3 border border-orange-200">
                              <p className="text-xs font-semibold text-gray-700 mb-2">¿Cómo quieres adaptar este plato?</p>
                              <div className="space-y-2">
                                <label className="flex items-start cursor-pointer group">
                                  <input
                                    type="radio"
                                    name={`tipo-modif-${idx}-${platoId}`}
                                    checked={tipoModifActual === 'sustituir_completo'}
                                    onChange={() => handleSetTipoModificacion(idx, platoId, 'sustituir_completo')}
                                    className="mt-0.5 mr-2 accent-duetto-primary"
                                  />
                                  <div className="flex-1">
                                    <span className="text-xs font-medium text-gray-900">Sustituir plato completo</span>
                                    <p className="text-xs text-gray-500">Reemplazar por otro plato del catálogo</p>
                                  </div>
                                </label>
                                
                                <label className="flex items-start cursor-pointer group">
                                  <input
                                    type="radio"
                                    name={`tipo-modif-${idx}-${platoId}`}
                                    checked={tipoModifActual === 'modificar_componentes'}
                                    onChange={() => handleSetTipoModificacion(idx, platoId, 'modificar_componentes')}
                                    className="mt-0.5 mr-2 accent-duetto-primary"
                                  />
                                  <div className="flex-1">
                                    <span className="text-xs font-medium text-gray-900">Modificar componentes del plato</span>
                                    <p className="text-xs text-gray-500">Quitar o sustituir ingredientes específicos</p>
                                  </div>
                                </label>
                              </div>
                            </div>
                            
                            {/* Opción A: Sustituir plato completo - AUTOCOMPLETADO */}
                            {tipoModifActual === 'sustituir_completo' && (
                              <div className="ml-5 mt-3">
                                {/* Mostrar cantidad actual del plato */}
                                {(() => {
                                  const cantidadActual = getCantidadPlatoEnMenu(platoId);
                                  const platoOrig = platos.find(p => p.id === platoId);
                                  // CORREGIDO: Usar coste_por_porcion (no coste_total)
                                  const costeActual = (platoOrig?.coste_por_porcion || 0) * cantidadActual;
                                  return (
                                    <div className="mb-3 p-2 bg-gray-50 rounded-lg border border-gray-200">
                                      <div className="flex justify-between items-center text-xs">
                                        <span className="text-gray-600">
                                          Cantidad actual en menú: <strong>{cantidadActual} ud(s)</strong>
                                        </span>
                                        <span className="text-gray-600">
                                          Coste total: <strong>{costeActual.toFixed(2)}€</strong>
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })()}
                                
                                {/* Checkboxes para incluir categorías adicionales */}
                                <div className="mb-3 p-2 bg-blue-50 rounded-lg border border-blue-200">
                                  <p className="text-xs font-medium text-blue-800 mb-2">Filtrar por categorías:</p>
                                  <div className="flex flex-wrap gap-3">
                                    <label className="flex items-center text-xs cursor-pointer">
                                      <input
                                        type="checkbox"
                                        checked={incluirPostres}
                                        onChange={(e) => setIncluirPostres(e.target.checked)}
                                        className="mr-1.5 accent-blue-600"
                                      />
                                      <span className="text-gray-700">Incluir postres</span>
                                    </label>
                                    <label className="flex items-center text-xs cursor-pointer">
                                      <input
                                        type="checkbox"
                                        checked={incluirDesayunos}
                                        onChange={(e) => setIncluirDesayunos(e.target.checked)}
                                        className="mr-1.5 accent-blue-600"
                                      />
                                      <span className="text-gray-700">Incluir desayunos/bebidas</span>
                                    </label>
                                  </div>
                                </div>
                                
                                {/* Checkbox para filtrar también por trazas - IMPORTANTE PARA SEGURIDAD */}
                                <div className="mb-3 p-2 bg-orange-50 rounded-lg border border-orange-200">
                                  <label className="flex items-center text-xs cursor-pointer">
                                    <input
                                      type="checkbox"
                                      checked={incluirTrazasAdaptaciones}
                                      onChange={(e) => setIncluirTrazasAdaptaciones(e.target.checked)}
                                      className="mr-1.5 rounded border-orange-300 text-orange-500 focus:ring-orange-400"
                                    />
                                    <span className="font-medium text-orange-800">Excluir platos con trazas del alérgeno</span>
                                  </label>
                                  <p className="text-xs text-orange-600 mt-1">
                                    ⚠️ Recomendado para alérgicos graves: también excluye platos que pueden contener trazas
                                  </p>
                                </div>
                                
                                <p className="text-xs font-medium text-gray-700 mb-2">
                                  🔄 Platos compatibles (ordenados por ahorro):
                                </p>
                                
                                {/* Input de búsqueda opcional */}
                                <div className="relative">
                                  <input
                                    type="text"
                                    placeholder="🔍 Filtrar por nombre... (o haz clic para ver todos)"
                                    value={platoSearch[platoId] || ''}
                                    onChange={(e) => handlePlatoSearchChange(platoId, e.target.value, alergenosEvitar)}
                                    onFocus={() => handlePlatoInputFocus(platoId, alergenosEvitar)}
                                    className="w-full px-3 py-2 text-xs border-2 border-orange-300 rounded-lg bg-white focus:border-orange-500 focus:outline-none"
                                  />
                                  
                                  {/* Dropdown de sugerencias de platos */}
                                  {showPlatoSuggestions[platoId] && platoSuggestions[platoId]?.length > 0 && (
                                    <div className="absolute left-0 right-0 z-[9999] mt-1 bg-white border-2 border-orange-400 rounded-lg shadow-2xl max-h-72 overflow-y-auto">
                                      <div className="sticky top-0 bg-orange-50 px-3 py-1.5 border-b border-orange-200 text-xs text-orange-800 font-medium">
                                        {platoSuggestions[platoId].length} platos compatibles (con {getCantidadPlatoEnMenu(platoId)} uds)
                                      </div>
                                      {platoSuggestions[platoId].map((sug, sugIdx) => (
                                        <button
                                          key={sug.id}
                                          onClick={() => handleSelectPlatoSustituto(idx, platoId, sug)}
                                          className={`w-full px-3 py-2.5 text-left text-xs hover:bg-orange-50 border-b border-gray-100 last:border-b-0 ${
                                            sugIdx === 0 ? 'bg-green-50' : ''
                                          }`}
                                        >
                                          <div className="flex justify-between items-start">
                                            <div className="flex-1">
                                              <div className="flex items-center gap-2">
                                                {sugIdx === 0 && (
                                                  <span className="px-1.5 py-0.5 bg-green-500 text-white rounded text-xs font-bold">
                                                    💰 Más rentable
                                                  </span>
                                                )}
                                                <span className="font-medium text-gray-800">{sug.nombre}</span>
                                              </div>
                                              <div className="flex items-center gap-2 mt-1 text-gray-500">
                                                {sug.categoria && (
                                                  <span className="px-1.5 py-0.5 bg-gray-100 rounded">
                                                    {sug.categoria}
                                                  </span>
                                                )}
                                                <span>
                                                  Coste: {sug.coste_total_calculado?.toFixed(2)}€
                                                </span>
                                              </div>
                                            </div>
                                            <div className="text-right ml-2">
                                              <span className={`font-bold text-sm ${
                                                sug.diferencia_precio > 0 ? 'text-red-600' : 
                                                sug.diferencia_precio < 0 ? 'text-green-600' : 'text-gray-500'
                                              }`}>
                                                {sug.diferencia_texto}
                                              </span>
                                              {sug.diferencia_porcentaje !== 0 && (
                                                <div className={`text-xs ${
                                                  sug.diferencia_precio > 0 ? 'text-red-500' : 'text-green-500'
                                                }`}>
                                                  ({sug.diferencia_porcentaje > 0 ? '+' : ''}{sug.diferencia_porcentaje.toFixed(0)}%)
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                          {/* Mostrar alérgenos del plato sustituto si tiene */}
                                          {sug.alergenos_ids?.length > 0 && (
                                            <div className="flex items-center gap-1 mt-1">
                                              {sug.alergenos_ids.slice(0, 4).map(alergId => {
                                                const alerg = alergenos.find(a => a.id === alergId);
                                                return alerg ? (
                                                  <AlergenoIcon key={alergId} nombre={alerg.nombre} size="sm" />
                                                ) : null;
                                              })}
                                            </div>
                                          )}
                                        </button>
                                      ))}
                                    </div>
                                  )}
                                  
                                  {/* No hay resultados */}
                                  {showPlatoSuggestions[platoId] && 
                                   (!platoSuggestions[platoId] || platoSuggestions[platoId].length === 0) && (
                                    <div className="absolute left-0 right-0 z-[9999] mt-1 bg-white border-2 border-orange-400 rounded-lg shadow-2xl p-3">
                                      <p className="text-xs text-gray-500">No se encontraron platos sin los alérgenos seleccionados</p>
                                    </div>
                                  )}
                                </div>
                                
                                <p className="text-xs text-gray-400 mt-1">
                                  Solo muestra platos que no contengan: {alergenosEvitar.map(a => {
                                    const alerg = alergenos.find(al => al.id === a);
                                    return alerg?.nombre || a;
                                  }).join(', ')}
                                </p>
                                
                                {/* Mostrar plato seleccionado con ajuste de unidades */}
                                {platoSustitutoId && (() => {
                                  const platoSeleccionado = platos.find(p => p.id === platoSustitutoId);
                                  if (!platoSeleccionado) return null;
                                  
                                  const platoOriginal = platos.find(p => p.id === platoId);
                                  const cantidadOriginal = getCantidadPlatoEnMenu(platoId);
                                  const key = `${idx}_${platoId}`;
                                  const cantidadSustituto = unidadesSustituto[key] !== undefined 
                                    ? unidadesSustituto[key] 
                                    : cantidadOriginal;
                                  
                                  // Costes unitarios - CORREGIDO: Usar coste_por_porcion (no coste_total)
                                  const costeUnitarioOriginal = platoOriginal?.coste_por_porcion || platoOriginal?.coste || 0;
                                  const costeUnitarioSustituto = platoSeleccionado.coste_por_porcion || platoSeleccionado.coste || 0;
                                  
                                  // Costes totales
                                  const costeTotalOriginal = costeUnitarioOriginal * cantidadOriginal;
                                  const costeTotalSustituto = costeUnitarioSustituto * cantidadSustituto;
                                  const diferenciaPrecio = costeTotalSustituto - costeTotalOriginal;
                                  const diferenciaTexto = diferenciaPrecio > 0 
                                    ? `+${diferenciaPrecio.toFixed(2)}€`
                                    : diferenciaPrecio < 0 
                                      ? `${diferenciaPrecio.toFixed(2)}€`
                                      : '±0€';
                                  
                                  return (
                                    <div className="mt-3 p-3 bg-green-50 border border-green-300 rounded-lg">
                                      <div className="flex justify-between items-start mb-3">
                                        <div>
                                          <p className="text-xs font-medium text-green-800">✓ Plato sustituto seleccionado:</p>
                                          <p className="text-sm font-semibold text-gray-800 mt-1">{platoSeleccionado.nombre}</p>
                                        </div>
                                        <button
                                          onClick={() => {
                                            handleSetSustituto(idx, platoId, null);
                                            setPlatoSearch(prev => ({ ...prev, [platoId]: '' }));
                                          }}
                                          className="text-xs text-red-600 hover:text-red-700"
                                        >
                                          ✕ Cancelar
                                        </button>
                                      </div>
                                      
                                      {/* Ajuste de unidades */}
                                      <div className="grid grid-cols-2 gap-3 mb-3">
                                        <div className="p-2 bg-white rounded border border-gray-200">
                                          <p className="text-xs text-gray-500 mb-1">Original (se quita)</p>
                                          <div className="flex items-center justify-between">
                                            <span className="text-sm font-medium text-gray-400 line-through">
                                              {cantidadOriginal} ud(s)
                                            </span>
                                            <span className="text-xs text-gray-400">
                                              {costeTotalOriginal.toFixed(2)}€
                                            </span>
                                          </div>
                                        </div>
                                        <div className="p-2 bg-white rounded border-2 border-green-400">
                                          <p className="text-xs text-green-700 mb-1">Sustituto (nuevo)</p>
                                          <div className="flex items-center gap-2">
                                            <input
                                              type="number"
                                              min="0"
                                              step="0.5"
                                              value={cantidadSustituto}
                                              onChange={(e) => handleCambiarUnidadesSustituto(idx, platoId, e.target.value)}
                                              className="w-16 px-2 py-1 text-sm border border-green-300 rounded text-center font-medium"
                                            />
                                            <span className="text-xs text-gray-500">ud(s)</span>
                                            <span className="text-xs font-medium text-gray-700 ml-auto">
                                              {costeTotalSustituto.toFixed(2)}€
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      
                                      {/* Resumen de diferencia */}
                                      <div className={`p-2 rounded text-center ${
                                        diferenciaPrecio > 0 ? 'bg-red-100' : 
                                        diferenciaPrecio < 0 ? 'bg-green-100' : 'bg-gray-100'
                                      }`}>
                                        <span className={`text-sm font-bold ${
                                          diferenciaPrecio > 0 ? 'text-red-600' : 
                                          diferenciaPrecio < 0 ? 'text-green-600' : 'text-gray-500'
                                        }`}>
                                          Diferencia total: {diferenciaTexto}
                                        </span>
                                        {cantidadSustituto !== cantidadOriginal && (
                                          <p className="text-xs text-gray-500 mt-1">
                                            (cantidad ajustada de {cantidadOriginal} a {cantidadSustituto} uds)
                                          </p>
                                        )}
                                      </div>
                                      
                                      {/* Alérgenos del plato sustituto */}
                                      {platoSeleccionado.alergenos_ids?.length > 0 && (
                                        <div className="flex items-center gap-1 mt-2 flex-wrap">
                                          <span className="text-xs text-gray-600">Alérgenos:</span>
                                          {platoSeleccionado.alergenos_ids.slice(0, 5).map(alergId => {
                                            const alerg = alergenos.find(a => a.id === alergId);
                                            return alerg ? (
                                              <AlergenoIcon key={alergId} nombre={alerg.nombre} size="sm" />
                                            ) : null;
                                          })}
                                        </div>
                                      )}
                                    </div>
                                  );
                                })()}
                              </div>
                            )}
                            
                            {/* Opción B: Modificar componentes del plato */}
                            {tipoModifActual === 'modificar_componentes' && (
                              <div className="ml-5 bg-blue-50 rounded-lg p-3 border border-blue-200">
                                <h6 className="text-xs font-semibold text-blue-900 mb-2">Componentes del plato:</h6>
                                
                                {loadingIngredientes ? (
                                  <p className="text-xs text-gray-500 italic">Cargando ingredientes...</p>
                                ) : (
                                  <>
                                    {Object.keys(platoOriginal.ingredientes || {}).length === 0 ? (
                                      <p className="text-xs text-gray-500 italic">Este plato no tiene ingredientes definidos en el sistema</p>
                                    ) : (
                                      <div className="space-y-2 mb-3">
                                        {Object.entries(platoOriginal.ingredientes || {}).map(([ingId, cantidad]) => {
                                          const ingrediente = ingredientes.find(i => i.id === ingId);
                                          if (!ingrediente) return null;
                                          
                                          const estaQuitado = adapt.platos_modificados?.[platoId]?.ingredientes_quitar?.includes(ingId);
                                          const sustitucion = adapt.platos_modificados?.[platoId]?.ingredientes_sustituir?.[ingId];
                                          
                                          // Usar la función mejorada para verificar alérgenos
                                          const tieneAlergenosProblema = ingredienteTieneAlergeno(
                                            ingrediente.alergenos_ids, 
                                            alergenosEvitar
                                          );
                                          const alergenosProblematicos = getAlergenosProblematicos(
                                            ingrediente.alergenos_ids,
                                            alergenosEvitar
                                          );
                                          
                                          return (
                                            <div 
                                              key={ingId} 
                                              className={`p-2 rounded border transition-colors ${
                                                estaQuitado || sustitucion
                                                  ? 'bg-green-50 border-green-300'
                                                  : tieneAlergenosProblema
                                                    ? 'bg-red-50 border-red-400 ring-1 ring-red-300'
                                                    : 'bg-white border-gray-200'
                                              }`}
                                            >
                                              <div className="flex items-center justify-between">
                                                <div className="flex items-center flex-1">
                                                  <span className={`text-xs ${estaQuitado ? 'text-gray-500 line-through' : 'text-gray-900'}`}>
                                                    {ingrediente.nombre} <span className="text-gray-400">({cantidad}g)</span>
                                                  </span>
                                                  {tieneAlergenosProblema && !estaQuitado && !sustitucion && (
                                                    <div className="ml-2 flex items-center gap-1 px-1.5 py-0.5 bg-red-100 rounded">
                                                      {alergenosProblematicos.slice(0, 2).map(alergenoNombre => {
                                                        const alerg = alergenos.find(a => 
                                                          a.nombre.toLowerCase() === alergenoNombre.toLowerCase() ||
                                                          a.id.toLowerCase().includes(alergenoNombre.toLowerCase())
                                                        );
                                                        return alerg ? (
                                                          <AlergenoIcon key={alergenoNombre} nombre={alerg.nombre} size="sm" />
                                                        ) : null;
                                                      })}
                                                      <span className="text-red-700 text-xs font-medium animate-pulse">⚠️</span>
                                                    </div>
                                                  )}
                                                </div>
                                                {(estaQuitado || sustitucion) && (
                                                  <span className="ml-2 px-1.5 py-0.5 bg-green-200 text-green-800 rounded text-xs font-medium">
                                                    ✓ {sustitucion ? 'Sustituido' : 'Se quitará'}
                                                  </span>
                                                )}
                                              </div>
                                              
                                              {/* Opciones de modificación para ingredientes con alérgenos */}
                                              {tieneAlergenosProblema && !estaQuitado && !sustitucion && (
                                                <div className="mt-2 pt-2 border-t border-red-200">
                                                  <p className="text-xs text-gray-600 mb-2">¿Qué deseas hacer?</p>
                                                  <div className="flex flex-col gap-2">
                                                    <button
                                                      onClick={() => handleToggleIngredienteQuitar(idx, platoId, ingId)}
                                                      className="px-3 py-1.5 text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 rounded border border-gray-300 text-left"
                                                    >
                                                      🗑️ Quitar ingrediente
                                                    </button>
                                                    
                                                    {/* Autocompletado de ingredientes sustitutos */}
                                                    <div className="relative">
                                                      <input
                                                        type="text"
                                                        placeholder="🔄 Buscar ingrediente sustituto..."
                                                        value={ingredienteSearch[`${platoId}_${ingId}`] || ''}
                                                        onChange={(e) => handleIngredienteSearchChange(
                                                          `${platoId}_${ingId}`,
                                                          e.target.value,
                                                          alergenosEvitar,
                                                          ingId,
                                                          cantidad
                                                        )}
                                                        onFocus={() => {
                                                          const key = `${platoId}_${ingId}`;
                                                          if ((ingredienteSearch[key] || '').length >= 2) {
                                                            setShowSuggestions(prev => ({ ...prev, [key]: true }));
                                                          }
                                                        }}
                                                        className="w-full px-3 py-1.5 text-xs border border-orange-300 rounded bg-white"
                                                      />
                                                      
                                                      {/* Dropdown de sugerencias */}
                                                      {showSuggestions[`${platoId}_${ingId}`] && ingredienteSuggestions[`${platoId}_${ingId}`]?.length > 0 && (
                                                        <div className="absolute left-0 right-0 z-[9999] mt-1 bg-white border-2 border-orange-400 rounded-lg shadow-2xl max-h-56 overflow-y-auto">
                                                          <div className="sticky top-0 bg-orange-50 px-3 py-1.5 text-xs text-orange-700 font-medium border-b border-orange-200">
                                                            💡 Ordenados por ahorro (mejor primero)
                                                          </div>
                                                          {ingredienteSuggestions[`${platoId}_${ingId}`].map((sug, sugIdx) => (
                                                            <button
                                                              key={sug.id}
                                                              onClick={() => handleSelectIngredienteSustituto(idx, platoId, ingId, sug)}
                                                              className={`w-full px-3 py-2 text-left text-xs hover:bg-orange-50 border-b border-gray-100 last:border-b-0 ${
                                                                sugIdx === 0 && sug.diferencia_precio < 0 ? 'bg-green-50' : ''
                                                              }`}
                                                            >
                                                              <div className="flex justify-between items-start">
                                                                <div className="flex-1">
                                                                  <span className="font-medium text-gray-800">{sug.nombre}</span>
                                                                  {sug.categoria && (
                                                                    <span className="ml-2 text-gray-400 text-[10px]">({sug.categoria})</span>
                                                                  )}
                                                                </div>
                                                                <div className="text-right ml-2">
                                                                  <span className={`font-bold ${
                                                                    sug.diferencia_precio > 0 ? 'text-red-600' : 
                                                                    sug.diferencia_precio < 0 ? 'text-green-600' : 'text-gray-500'
                                                                  }`}>
                                                                    {sug.diferencia_texto}
                                                                  </span>
                                                                  {sug.diferencia_porcentaje !== 0 && (
                                                                    <div className={`text-[10px] ${
                                                                      sug.diferencia_precio > 0 ? 'text-red-500' : 'text-green-500'
                                                                    }`}>
                                                                      ({sug.diferencia_porcentaje > 0 ? '+' : ''}{sug.diferencia_porcentaje.toFixed(0)}%)
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              </div>
                                                              {sugIdx === 0 && sug.diferencia_precio < 0 && (
                                                                <div className="mt-1 text-[10px] text-green-600 font-medium">
                                                                  💰 Más rentable
                                                                </div>
                                                              )}
                                                            </button>
                                                          ))}
                                                        </div>
                                                      )}
                                                      
                                                      {showSuggestions[`${platoId}_${ingId}`] && 
                                                       (ingredienteSearch[`${platoId}_${ingId}`] || '').length >= 2 &&
                                                       (!ingredienteSuggestions[`${platoId}_${ingId}`] || ingredienteSuggestions[`${platoId}_${ingId}`].length === 0) && (
                                                        <div className="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg p-3">
                                                          <p className="text-xs text-gray-500">No se encontraron ingredientes sin estos alérgenos</p>
                                                        </div>
                                                      )}
                                                    </div>
                                                    <p className="text-xs text-gray-400">Escribe para buscar (ej: "sin gluten", "picos")</p>
                                                  </div>
                                                </div>
                                              )}
                                              
                                              {/* Mostrar sustitución actual o permitir edición */}
                                              {sustitucion && (
                                                <div className="mt-2 pt-2 border-t border-green-200">
                                                  {editandoSustitucion[`${idx}_${platoId}_${ingId}`] ? (
                                                    // Modo edición: mostrar autocompletado
                                                    <div className="space-y-2">
                                                      <div className="flex items-center justify-between mb-1">
                                                        <span className="text-xs text-gray-600">Cambiar sustituto:</span>
                                                        <button
                                                          onClick={() => setEditandoSustitucion(prev => ({ ...prev, [`${idx}_${platoId}_${ingId}`]: false }))}
                                                          className="text-xs text-gray-500 hover:text-gray-700"
                                                        >
                                                          ✕ Cancelar
                                                        </button>
                                                      </div>
                                                      <div className="relative">
                                                        <input
                                                          type="text"
                                                          placeholder="🔄 Buscar nuevo sustituto..."
                                                          value={ingredienteSearch[`${platoId}_${ingId}`] || ''}
                                                          onChange={(e) => handleIngredienteSearchChange(
                                                            `${platoId}_${ingId}`,
                                                            e.target.value,
                                                            alergenosEvitar,
                                                            ingId,
                                                            cantidad
                                                          )}
                                                          onFocus={() => {
                                                            const key = `${platoId}_${ingId}`;
                                                            if ((ingredienteSearch[key] || '').length >= 2) {
                                                              setShowSuggestions(prev => ({ ...prev, [key]: true }));
                                                            }
                                                          }}
                                                          className="w-full px-3 py-1.5 text-xs border border-blue-300 rounded bg-white"
                                                          autoFocus
                                                        />
                                                        
                                                        {/* Dropdown de sugerencias para edición */}
                                                        {showSuggestions[`${platoId}_${ingId}`] && ingredienteSuggestions[`${platoId}_${ingId}`]?.length > 0 && (
                                                          <div className="absolute left-0 right-0 z-[9999] mt-1 bg-white border-2 border-blue-400 rounded-lg shadow-2xl max-h-56 overflow-y-auto">
                                                            <div className="sticky top-0 bg-blue-50 px-3 py-1.5 text-xs text-blue-700 font-medium border-b border-blue-200">
                                                              💡 Ordenados por ahorro (mejor primero)
                                                            </div>
                                                            {ingredienteSuggestions[`${platoId}_${ingId}`].map((sug, sugIdx) => (
                                                              <button
                                                                key={sug.id}
                                                                onClick={() => {
                                                                  handleSelectIngredienteSustituto(idx, platoId, ingId, sug);
                                                                  setEditandoSustitucion(prev => ({ ...prev, [`${idx}_${platoId}_${ingId}`]: false }));
                                                                }}
                                                                className={`w-full px-3 py-2 text-left text-xs hover:bg-blue-50 border-b border-gray-100 last:border-b-0 ${
                                                                  sugIdx === 0 && sug.diferencia_precio < 0 ? 'bg-green-50' : ''
                                                                }`}
                                                              >
                                                                <div className="flex justify-between items-start">
                                                                  <div className="flex-1">
                                                                    <span className="font-medium text-gray-800">{sug.nombre}</span>
                                                                    {sug.categoria && (
                                                                      <span className="ml-2 text-gray-400 text-[10px]">({sug.categoria})</span>
                                                                    )}
                                                                  </div>
                                                                  <div className="text-right ml-2">
                                                                    <span className={`font-bold ${
                                                                      sug.diferencia_precio > 0 ? 'text-red-600' : 
                                                                      sug.diferencia_precio < 0 ? 'text-green-600' : 'text-gray-500'
                                                                    }`}>
                                                                      {sug.diferencia_texto}
                                                                    </span>
                                                                    {sug.diferencia_porcentaje !== 0 && (
                                                                      <div className={`text-[10px] ${
                                                                        sug.diferencia_precio > 0 ? 'text-red-500' : 'text-green-500'
                                                                      }`}>
                                                                        ({sug.diferencia_porcentaje > 0 ? '+' : ''}{sug.diferencia_porcentaje.toFixed(0)}%)
                                                                      </div>
                                                                    )}
                                                                  </div>
                                                                </div>
                                                                {sugIdx === 0 && sug.diferencia_precio < 0 && (
                                                                  <div className="mt-1 text-[10px] text-green-600 font-medium">
                                                                    💰 Más rentable
                                                                  </div>
                                                                )}
                                                              </button>
                                                            ))}
                                                          </div>
                                                        )}
                                                      </div>
                                                      <p className="text-xs text-gray-400">Actual: {sustitucion}</p>
                                                    </div>
                                                  ) : (
                                                    // Modo visualización: mostrar sustitución con opciones
                                                    <div className="flex items-center justify-between">
                                                      <span className="text-xs text-green-700">
                                                        🔄 Sustituido por: <strong>{sustitucion}</strong>
                                                      </span>
                                                      <div className="flex gap-2">
                                                        <button
                                                          onClick={() => {
                                                            setIngredienteSearch(prev => ({ ...prev, [`${platoId}_${ingId}`]: '' }));
                                                            setEditandoSustitucion(prev => ({ ...prev, [`${idx}_${platoId}_${ingId}`]: true }));
                                                          }}
                                                          className="text-xs text-blue-600 hover:text-blue-700"
                                                        >
                                                          ✏️ Cambiar
                                                        </button>
                                                        <button
                                                          onClick={() => handleSetSustitucionIngrediente(idx, platoId, ingId, null)}
                                                          className="text-xs text-red-600 hover:text-red-700"
                                                        >
                                                          ✕ Quitar
                                                        </button>
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              )}
                                              
                                              {/* Botón para deshacer quitar */}
                                              {estaQuitado && (
                                                <div className="mt-2 pt-2 border-t border-green-200">
                                                  <button
                                                    onClick={() => handleToggleIngredienteQuitar(idx, platoId, ingId)}
                                                    className="text-xs text-blue-600 hover:text-blue-700"
                                                  >
                                                    ↩️ Deshacer
                                                  </button>
                                                </div>
                                              )}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    )}
                                    
                                    {/* Campo de instrucciones especiales */}
                                    <div className="mt-3">
                                      <label className="block text-xs font-medium text-gray-700 mb-1">
                                        Instrucciones especiales (opcional):
                                      </label>
                                      <textarea
                                        value={adapt.platos_modificados?.[platoId]?.instrucciones_especiales || ''}
                                        onChange={(e) => handleSetInstruccionesEspeciales(idx, platoId, e.target.value)}
                                        placeholder="Ej: Usar pan sin gluten, servir en plato separado para evitar contaminación cruzada..."
                                        className="w-full px-2 py-1.5 text-xs border border-blue-300 rounded bg-white resize-none"
                                        rows={2}
                                      />
                                      <p className="text-xs text-gray-500 mt-1">
                                        💡 Estas instrucciones aparecerán en la orden de cocina
                                      </p>
                                    </div>
                                    
                                    {/* Resumen de modificaciones */}
                                    {(adapt.platos_modificados?.[platoId]?.ingredientes_quitar?.length > 0 || 
                                      Object.keys(adapt.platos_modificados?.[platoId]?.ingredientes_sustituir || {}).length > 0) && (
                                      <div className="mt-3 p-2 bg-green-50 border border-green-200 rounded">
                                        <p className="text-xs font-medium text-green-800">
                                          ✓ Modificaciones: 
                                          {adapt.platos_modificados[platoId].ingredientes_quitar?.length > 0 && 
                                            ` ${adapt.platos_modificados[platoId].ingredientes_quitar.length} quitado(s)`}
                                          {adapt.platos_modificados[platoId].ingredientes_quitar?.length > 0 && 
                                           Object.keys(adapt.platos_modificados[platoId].ingredientes_sustituir || {}).length > 0 && ', '}
                                          {Object.keys(adapt.platos_modificados[platoId].ingredientes_sustituir || {}).length > 0 && 
                                            ` ${Object.keys(adapt.platos_modificados[platoId].ingredientes_sustituir).length} sustituido(s)`}
                                        </p>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            )}
                            </>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ))}

              <button
                onClick={handleAddAdaptacion}
                className="w-full px-4 py-2 border-2 border-dashed border-gray-300 text-gray-600 text-sm rounded-lg hover:border-duetto-primary hover:text-duetto-primary transition"
              >
                + Añadir Otra Adaptación
              </button>
            </>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3 max-md:flex-wrap max-md:px-4 max-md:pb-[calc(env(safe-area-inset-bottom)+1rem)] max-md:[&_button]:min-h-[44px]">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Cancelar
          </button>
          <button
            onClick={() => onSave(localAdaptaciones)}
            className="px-4 py-2 bg-duetto-primary text-white rounded-lg hover:bg-opacity-90"
          >
            Guardar Adaptaciones
          </button>
        </div>
      </div>
    </div>
  );
};

export default PresupuestoDetalle;
